"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9720],{

/***/ 33714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ runningTradeAction; },
/* harmony export */   "x": function() { return /* binding */ runningTradeConfig; }
/* harmony export */ });
var runningTradeConfig = {
    widget: {
        limit: 100,
        speed: 100
    },
    fastOrder: {
        limit: 100,
        speed: 100
    },
    company: {
        limit: 10,
        speed: 100
    }
};
var runningTradeAction = {
    0: "",
    1: "Buy",
    2: "Sell"
};


/***/ }),

/***/ 80056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var features_chat_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33037);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var _tests_constant__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(376);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19546);






var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function AttachmentPreview(param) {
    var type = param.type;
    if (type === "ATTACHMENT_TYPE_GIF") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/icon/preview-gif.svg",
            alt: "Gif icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_PHOTO") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/icon/preview-photo.svg",
            alt: "Photo icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_POST") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/icon/preview-post.svg",
            alt: "Post icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_PDF") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/icon/preview-pdf.svg",
            alt: "Post icon"
        });
    }
    if (type === "ATTACHMENT_TYPE_STICKER") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/icon/preview-sticker.svg",
            alt: "Post icon"
        });
    }
    return null;
}
function LastMessagePreview(param) {
    var message = param.message, showSenderUsername = param.showSenderUsername;
    var attachmentType = message.type, tmp = message.sender_username, senderUsername = tmp === void 0 ? "" : tmp, isDeleted = message.is_deleted;
    var parseLastMessage = function() {
        var isMessageEmpty = (message === null || message === void 0 ? void 0 : message.text) === "";
        if (attachmentType === "ATTACHMENT_TYPE_STICKER") {
            return "Sticker";
        }
        if (attachmentType === "ATTACHMENT_TYPE_GIF") {
            return "GIF";
        }
        if (attachmentType === "ATTACHMENT_TYPE_PHOTO" && isMessageEmpty) {
            return "Photo";
        }
        if (attachmentType === "ATTACHMENT_TYPE_POST" && isMessageEmpty) {
            return "Post";
        }
        return message === null || message === void 0 ? void 0 : message.text;
    };
    var showedMessage = parseLastMessage();
    var asteriskRemover = (0,features_chat_utils__WEBPACK_IMPORTED_MODULE_2__/* .removeFormat */ .Ir)(showedMessage);
    if (isDeleted) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .DeletedLastMessage */ ._c, {
            ellipsis: true,
            "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_5__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED */ .Jf,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: "/icon/chat-bubble-removed-gray.svg"
                }),
                asteriskRemover
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
        width: "90%",
        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray,
        ellipsis: true,
        "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_5__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW */ .c2,
        children: [
            showSenderUsername && senderUsername ? "".concat(senderUsername, ": ") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AttachmentPreview, {
                type: attachmentType
            }),
            asteriskRemover
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (LastMessagePreview);


/***/ }),

/***/ 82906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BubbleChat_ShareTradeAttachment; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/Icons/CornerUpRightSvg.tsx

var CornerUpRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.5 7L10 4.5L7.5 2",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2 10V6.5C2 5.96957 2.21071 5.46086 2.58579 5.08579C2.96086 4.71071 3.46957 4.5 4 4.5H10",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_CornerUpRightSvg = (CornerUpRightSvg);

// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
;// CONCATENATED MODULE: ./src/global/Icons/VerifiedSvg.tsx

var VerifiedSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.01819 9.48603C2.08412 9.26126 2.19301 8.82172 2.34286 8.39716C2.44051 8.14764 2.44051 7.87048 2.34286 7.62097C2.20159 7.2781 2.09743 6.92109 2.03218 6.55606C1.95451 6.15825 2.01847 5.74582 2.21296 5.39022C2.40745 5.03462 2.72023 4.75828 3.09708 4.60908C3.43255 4.47361 3.73747 4.27226 3.99381 4.01695C4.25015 3.76163 4.45272 3.45753 4.58954 3.12261C4.67451 2.90141 4.8035 2.69976 4.96872 2.5299C5.13393 2.36003 5.33192 2.22549 5.55068 2.13441C5.76944 2.04334 6.00441 1.99765 6.24136 2.00009C6.4783 2.00253 6.71228 2.05305 6.92912 2.14861C7.61406 2.42938 8.38197 2.42938 9.06691 2.14861C9.27736 2.05639 9.50408 2.00707 9.73382 2.00352C9.96355 1.99997 10.1917 2.04227 10.4049 2.12794C10.6181 2.2136 10.8121 2.34093 10.9755 2.50246C11.1389 2.66398 11.2684 2.85647 11.3565 3.06866C11.6565 3.77484 12.2177 4.33783 12.9229 4.64004C13.1345 4.72468 13.327 4.8507 13.4892 5.0107C13.6514 5.1707 13.7801 5.36147 13.8676 5.57183C13.9552 5.78218 13.9998 6.00789 13.999 6.23574C13.9982 6.46358 13.952 6.68897 13.863 6.8987C13.5762 7.61951 13.5802 8.42342 13.8739 9.14138C14.0254 9.53303 14.0297 9.96631 13.8861 10.3609C13.7424 10.7555 13.4606 11.0846 13.0928 11.2872C13.0345 11.3332 12.9708 11.3718 12.903 11.402C12.5501 11.5253 12.2294 11.7261 11.9646 11.9898C11.6997 12.2535 11.4974 12.5732 11.3725 12.9255C11.1896 13.3492 10.8491 13.6854 10.423 13.8628C9.99693 14.0403 9.51854 14.0452 9.08889 13.8765C8.75014 13.7194 8.3815 13.6372 8.0081 13.6355C7.6347 13.6337 7.26531 13.7125 6.92513 13.8665C6.48897 14.0453 5.99985 14.0445 5.56428 13.8643C5.12871 13.6841 4.78195 13.3391 4.59953 12.9045C4.46772 12.5663 4.26787 12.2588 4.01234 12.0011C3.75682 11.7433 3.45107 11.5408 3.11406 11.406C2.74589 11.2508 2.43907 10.9786 2.241 10.6316C2.04294 10.2846 1.96463 9.88199 2.01819 9.48603ZM7.41262 8.95159C7.32571 8.87067 7.25678 8.81073 7.19185 8.7468C6.93312 8.49306 6.68637 8.22634 6.41565 7.98658C6.30159 7.87942 6.14964 7.82194 5.9932 7.82681C5.83677 7.83168 5.68868 7.8985 5.58151 8.01256C5.47434 8.12662 5.41687 8.27857 5.42174 8.435C5.42661 8.59144 5.49343 8.73952 5.60749 8.84669C6.04803 9.29922 6.49357 9.74577 6.9491 10.1853C7.00239 10.2543 7.07095 10.3099 7.14939 10.3479C7.22782 10.3858 7.31399 10.4051 7.40112 10.4041C7.48825 10.4031 7.57398 10.382 7.65155 10.3423C7.72912 10.3026 7.79642 10.2454 7.84817 10.1753C8.8851 9.14971 9.91737 8.11945 10.945 7.08452C11.0118 7.03244 11.0664 6.96626 11.1047 6.89069C11.1431 6.81512 11.1643 6.73202 11.1669 6.64732C11.1695 6.56261 11.1533 6.47837 11.1196 6.40061C11.0859 6.32285 11.0355 6.25348 10.9719 6.19743C10.848 6.09001 10.6868 6.03556 10.5232 6.04584C10.3595 6.05612 10.2064 6.13029 10.0968 6.25237C9.93002 6.4142 9.76619 6.57904 9.60236 6.74387L7.41262 8.95159Z",
                fill: "#00AB6B"
            })
        ]
    });
};
/* harmony default export */ var Icons_VerifiedSvg = (VerifiedSvg);

;// CONCATENATED MODULE: ./src/typings/api/shareTradeChat.ts
var UpdatedShareOrderStatus;
(function(UpdatedShareOrderStatus) {
    UpdatedShareOrderStatus["Unspecified"] = "UPDATED_STATUS_UNSPECIFIED";
    UpdatedShareOrderStatus["Amended"] = "UPDATED_STATUS_AMENDED";
    UpdatedShareOrderStatus["Cancelled"] = "UPDATED_STATUS_CANCELLED";
})(UpdatedShareOrderStatus || (UpdatedShareOrderStatus = {}));
var ShareTradeLabel;
(function(ShareTradeLabel) {
    ShareTradeLabel["UNSPECIFIED"] = "LABEL_UNSPECIFIED";
    ShareTradeLabel["DAY_TRADE"] = "LABEL_DAY_TRADE";
    ShareTradeLabel["SPLIT_ORDER"] = "LABEL_SPLIT_ORDER";
})(ShareTradeLabel || (ShareTradeLabel = {}));

// EXTERNAL MODULE: ./src/typings/api/shareTradeShare.ts
var shareTradeShare = __webpack_require__(10529);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeGroupChat.ts
var shareTradeGroupChat = __webpack_require__(30196);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.styled.ts


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  height: 100%;\n\n  img {\n    margin-top: -1px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: unset;\n  text-align: left;\n  padding: 6px 12px;\n  width: 100%;\n  border: 0;\n\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n\n  & > .anticon + span {\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 14px 14px 0 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  margin-left: ",
        ";\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #b5b5b5 !important;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  line-height: 22px;\n  margin: 0;\n  text-wrap: nowrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 267px;\n  cursor: pointer;\n  border-radius: 14px;\n  background: ",
        ";\n\n  & ",
        " ",
        ", ",
        " ",
        " {\n    color: ",
        ";\n  }\n\n  & ",
        " {\n    color: ",
        ";\n  }\n\n  & ",
        " {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: auto;\n\n  display: flex;\n  text-align: left;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  & > .ant-row {\n    width: 100%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  color: #b5b5b5;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  color: #b5b5b5;\n  margin: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  margin: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var _obj;
var shareTradeBubbleConfig = (_obj = {}, (0,_define_property/* default */.Z)(_obj, shareTradeShare/* ShareOrderType.Unspecified */.y.Unspecified, {
    background: "transparent",
    header: "transparent",
    text: "#333333"
}), (0,_define_property/* default */.Z)(_obj, shareTradeShare/* ShareOrderType.Buy */.y.Buy, {
    background: "#E5F7F0",
    header: "#CCF1EA",
    text: "#00B897"
}), (0,_define_property/* default */.Z)(_obj, shareTradeShare/* ShareOrderType.Sell */.y.Sell, {
    background: "#FDEDED",
    header: "#FBDFDF",
    text: "#EE4A49"
}), _obj);
var TradeRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-0"
})(_templateObject());
var TitleRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-1"
})(_templateObject1());
var BadgeWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-723005ab-2"
})(_templateObject2());
var PreviousOrderButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).attrs({
    type: "link"
}).withConfig({
    componentId: "sc-723005ab-3"
})(_templateObject3());
var PreviousOrderCol = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-723005ab-4"
})(_templateObject4());
var PriceText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-723005ab-5"
})(_templateObject5(), function(param) {
    var _marginLeft = param.marginLeft, marginLeft = _marginLeft === void 0 ? "0" : _marginLeft;
    return marginLeft;
}, function(param) {
    var lineThrough = param.lineThrough;
    return lineThrough ? "line-through" : "none";
});
var TotalInvestmentText = (0,styled_components_browser_esm["default"])(PriceText).withConfig({
    componentId: "sc-723005ab-6"
})(_templateObject6());
var Title = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-723005ab-7"
})(_templateObject7());
var ContainerRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-8"
})(_templateObject8(), function(param) {
    var orderType = param.orderType;
    var ref;
    return (ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.background;
}, TradeRow, PriceText, TradeRow, Title, function(param) {
    var orderType = param.orderType;
    var ref;
    return ((ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.text) || "#333333";
}, PreviousOrderButton, function(param) {
    var orderType = param.orderType;
    var ref;
    return ((ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.text) || "#333333";
}, PreviousOrderCol, function(param) {
    var orderType = param.orderType;
    var ref;
    return ((ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.header) || "transparent";
});
var ContentButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-723005ab-9"
})(_templateObject9());
var ContentRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-723005ab-10"
})(_templateObject10());
var StatusText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-723005ab-11"
})(_templateObject11());
var TimeText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-723005ab-12"
})(_templateObject12());
var Username = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-723005ab-13"
})(_templateObject13(), function(param) {
    var _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return color;
});

;// CONCATENATED MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.tsx














var ShareTradeAttachment = function(param) {
    var roomId = param.roomId, messageId = param.messageId, chatRoomType = param.chatRoomType, _info = param.info, info = _info === void 0 ? {} : _info, _username = param.username, username = _username === void 0 ? "" : _username, usernameColor = param.usernameColor, _previousButtonText = param.previousButtonText, previousButtonText = _previousButtonText === void 0 ? "See Previous Order" : _previousButtonText, _isVerified = param.isVerified, isVerified = _isVerified === void 0 ? false : _isVerified, _hideUsername = param.hideUsername, hideUsername = _hideUsername === void 0 ? false : _hideUsername, _hidePreviousOrder = param.hidePreviousOrder, hidePreviousOrder = _hidePreviousOrder === void 0 ? false : _hidePreviousOrder, _onPreviousOrderClick = param.onPreviousOrderClick, onPreviousOrderClick = _onPreviousOrderClick === void 0 ? function() {} : _onPreviousOrderClick, _isPreview = param.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview;
    var ref;
    var router = (0,next_router.useRouter)();
    var symbol = info.symbol, text = info.text, price = info.price, status = info.status, updatedPrice = info.updated_price, orderType = info.order_type, orderTime = info.order_time, totalInvestment = info.total_investment, label = info.label;
    var isDayTrade = label === ShareTradeLabel.DAY_TRADE;
    var isSplitOrder = label === ShareTradeLabel.SPLIT_ORDER;
    var isLineThrough = (0,react.useMemo)(function() {
        return [
            shareTradeShare/* ShareOrderStatus.Amend */.F.Amend,
            shareTradeShare/* ShareOrderStatus.Cancel */.F.Cancel
        ].includes(status);
    }, [
        status
    ]);
    var getOrderTitleBadge = function() {
        if (!label || label === ShareTradeLabel.UNSPECIFIED) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BadgeWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isSplitOrder,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/share-trade/split-order.svg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isDayTrade,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/share-trade/day-trade.svg"
                    })
                })
            ]
        });
    };
    var handlePreviousOrderClick = function() {
        if (isPreview) return;
        (0,shareTradeGroupChat/* trackChatPreviousOrder */.Jw)(roomId === null || roomId === void 0 ? void 0 : roomId.toString(), messageId === null || messageId === void 0 ? void 0 : messageId.toString(), symbol, status, chatRoomType);
        onPreviousOrderClick();
    };
    var handleContentClick = function() {
        if (isPreview) return;
        (0,shareTradeGroupChat/* trackChatCompanySymbol */.As)(roomId === null || roomId === void 0 ? void 0 : roomId.toString(), messageId === null || messageId === void 0 ? void 0 : messageId.toString(), symbol, status, chatRoomType);
        router.push("/symbol/".concat(symbol));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerRow, {
        align: "middle",
        justify: "space-between",
        orderType: orderType,
        className: "share-preview",
        children: [
            hidePreviousOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousOrderCol, {
                className: "st-col-header",
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviousOrderButton, {
                    type: "link",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        component: Icons_CornerUpRightSvg
                    }),
                    onClick: handlePreviousOrderClick,
                    children: previousButtonText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentButton, {
                    onClick: handleContentClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentRow, {
                        align: "middle",
                        gutter: [
                            0,
                            6
                        ],
                        children: [
                            !hideUsername && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    align: "middle",
                                    gutter: [
                                        4,
                                        0
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Username, {
                                                color: usernameColor,
                                                children: username
                                            })
                                        }),
                                        isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: Icons_VerifiedSvg
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    align: "middle",
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                            span: 22,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                                            span: 24,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleRow, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                                                        children: text.split(symbol).map(function(item) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                                                children: item || /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                                                    children: symbol
                                                                                })
                                                                            }, item);
                                                                        })
                                                                    }),
                                                                    getOrderTitleBadge()
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                                            lineThrough: isLineThrough,
                                                            children: price
                                                        }),
                                                        updatedPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceText, {
                                                            marginLeft: "8px",
                                                            children: updatedPrice
                                                        }),
                                                        !!totalInvestment && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalInvestmentText, {
                                                            marginLeft: "4px",
                                                            children: [
                                                                "• ",
                                                                totalInvestment
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, {
                                                    children: new Date(orderTime).toLocaleTimeString(undefined, {
                                                        hour12: false
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                component: ChevronDownSvg/* default */.Z,
                                                style: {
                                                    fontSize: 16,
                                                    color: (ref = shareTradeBubbleConfig[orderType]) === null || ref === void 0 ? void 0 : ref.text,
                                                    transform: "rotate(-90deg)"
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BubbleChat_ShareTradeAttachment = (ShareTradeAttachment);


/***/ }),

/***/ 4881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52288);

function useScrollChat() {
    var highlightChat = function(id) {
        var bubbleElement = document.getElementById("".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id));
        bubbleElement.classList.add("chat-highlight");
        setTimeout(function() {
            bubbleElement.classList.remove("chat-highlight");
        }, 3000);
    };
    var scrollToBottom = function() {
        setTimeout(function() {
            var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
            if (contentElement) {
                contentElement.scrollTo({
                    top: contentElement.scrollHeight,
                    behavior: "smooth"
                });
            }
        }, 50);
    };
    var scrollToChatBubble = function(id) {
        var bubbleId = "".concat(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_BUBBLE_ID */ .H2, "-").concat(id);
        var contentElement = document.getElementById(_constant__WEBPACK_IMPORTED_MODULE_0__/* .CHAT_CONTENT_CONTAINER_ID */ .mR);
        var bubbleElement = document.getElementById(bubbleId);
        if (bubbleElement) {
            contentElement.scrollTo({
                top: bubbleElement.offsetTop - contentElement.offsetTop - bubbleElement.offsetHeight * 0.1,
                behavior: "smooth"
            });
            highlightChat(id);
        } else {
            contentElement.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setTimeout(function() {
                scrollToChatBubble(id);
            }, 500);
        }
    };
    return {
        scrollToBottom: scrollToBottom,
        scrollToChatBubble: scrollToChatBubble,
        highlightChat: highlightChat
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useScrollChat);


/***/ }),

/***/ 77284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* reexport */ store_chatGroupPolicyStore; },
  "Z9": function() { return /* reexport */ store_chatUtilsStore; },
  "vW": function() { return /* reexport */ store_contactDiscoveryStore; },
  "Zn": function() { return /* reexport */ store_contactSyncStore; },
  "VY": function() { return /* reexport */ store_groupMemberStore; },
  "tZ": function() { return /* reexport */ store_roomActionStore; },
  "e": function() { return /* reexport */ store_roomDetailStore; }
});

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/features/chat/store/chatUtilsStore.ts

var chatUtilsStore = (0,esm/* default */.ZP)(function(set) {
    return {
        showRightSidebar: false,
        showSearchMember: false,
        showInviteLink: false,
        showAddMember: false,
        showNewMessage: false,
        showUserSelection: false,
        showCreateGroup: false,
        showModalLeaveGroup: false,
        showEditRoomChat: false,
        isComposeChatFocused: false,
        setComposeChatFocuses: function(focused) {
            set({
                isComposeChatFocused: focused
            });
        },
        toggleRightSidebar: function(visible) {
            set({
                showRightSidebar: visible
            });
        },
        toggleSearchMember: function(visible) {
            set({
                showSearchMember: visible
            });
        },
        toggleInviteLink: function(visible) {
            set({
                showInviteLink: visible
            });
        },
        toggleAddMember: function(visible) {
            set({
                showAddMember: visible
            });
        },
        toggleNewMessage: function(visible) {
            set({
                showNewMessage: visible
            });
        },
        toggleUserSelection: function(visible) {
            set({
                showUserSelection: visible
            });
        },
        toggleCreateGroup: function(visible) {
            set({
                showCreateGroup: visible
            });
        },
        toggleModalLeaveGroup: function(visible) {
            set({
                showModalLeaveGroup: visible
            });
        },
        toggleEditRoomChat: function(visible) {
            set({
                showEditRoomChat: visible
            });
        },
        resetLeftSidebarView: function() {
            set({
                showCreateGroup: false,
                showNewMessage: false,
                showUserSelection: false
            });
        },
        resetRightSidebarView: function() {
            set({
                showRightSidebar: false,
                showSearchMember: false,
                showInviteLink: false,
                showAddMember: false
            });
        }
    };
});
/* harmony default export */ var store_chatUtilsStore = (chatUtilsStore);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/lib/api/chat.ts
var chat = __webpack_require__(69101);
;// CONCATENATED MODULE: ./src/features/chat/store/groupMemberStore.ts
/* eslint-disable import/no-named-as-default-member */ 





var groupMemberStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        data: {
            members: [],
            is_more: false
        },
        isLoading: false,
        offset: 0,
        userUpdated: {
            userId: 0,
            isAdmin: true
        },
        fetchGroupMember: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(groupId, offset) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (offset === 0) {
                                set({
                                    isLoading: true
                                });
                            }
                            _ctx.next = 3;
                            return chat/* default.getMemberList */.ZP.getMemberList(groupId, null, 10, offset).then(function(res) {
                                var data = res.data.data;
                                if (offset === 0) {
                                    set({
                                        data: data,
                                        isLoading: false,
                                        offset: 10
                                    });
                                } else {
                                    set({
                                        data: {
                                            members: (0,_to_consumable_array/* default */.Z)(get().data.members).concat((0,_to_consumable_array/* default */.Z)(data.members)),
                                            is_more: data.is_more
                                        },
                                        isLoading: false
                                    });
                                }
                            }).catch(function() {
                                set({
                                    isLoading: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(groupId, offset) {
                return _ref.apply(this, arguments);
            };
        }(),
        setAdminStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(groupId, userId, status) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 3;
                            return chat/* default.setAdminStatus */.ZP.setAdminStatus(groupId, {
                                user_id: userId,
                                status: status
                            }).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                                    var ref;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                ;
                                                set({
                                                    offset: 0,
                                                    isLoading: false,
                                                    userUpdated: {
                                                        userId: userId,
                                                        isAdmin: status
                                                    }
                                                });
                                                (0,AlertMessage/* default */.Z)({
                                                    content: (ref = res.data) === null || ref === void 0 ? void 0 : ref.message,
                                                    alertType: "snackbar",
                                                    messageType: "success",
                                                    hasCloseIcon: false
                                                });
                                                get().fetchGroupMember(groupId, 0);
                                            case 4:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function() {
                                set({
                                    isLoading: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(groupId, userId, status) {
                return _ref.apply(this, arguments);
            };
        }(),
        removeMember: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(groupId, userId, username) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 3;
                            return chat/* default.removeGroupMember */.ZP.removeGroupMember(groupId, {
                                user_id: userId
                            }).then(function() {
                                set({
                                    isLoading: false
                                });
                                (0,AlertMessage/* default */.Z)({
                                    content: "".concat(username, " removed from the group"),
                                    alertType: "snackbar",
                                    messageType: "success",
                                    hasCloseIcon: true
                                });
                                get().fetchGroupMember(groupId, 0);
                            }).catch(function() {
                                set({
                                    isLoading: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(groupId, userId, username) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store_groupMemberStore = (groupMemberStore);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/features/chat/store/roomDetailStore.ts









var roomDetailStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        personal: {},
        group: {},
        isLoading: false,
        isLoadingUpdateGroup: false,
        isLoadingResetLink: false,
        fetchPersonalRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                chat/* default.getRoom */.ZP.getRoom(chatId).then(function(res) {
                                    var data = res.data.data;
                                    set({
                                        personal: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().personal), (0,_define_property/* default */.Z)({}, chatId, data))
                                    });
                                    resolve({
                                        data: data,
                                        error: false
                                    });
                                }).catch(function() {
                                    resolve({
                                        error: true
                                    });
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(chatId) {
                return _ref.apply(this, arguments);
            };
        }(),
        fetchGroupRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                chat/* default.getGroupRoom */.ZP.getGroupRoom(chatId).then(function(res) {
                                    var data = res.data.data;
                                    set({
                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, data))
                                    });
                                    resolve({
                                        data: data,
                                        error: false
                                    });
                                }).catch(function() {
                                    resolve({
                                        error: true
                                    });
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(chatId) {
                return _ref.apply(this, arguments);
            };
        }(),
        updateGroupRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var chatId = params.chatId, groupId = params.groupId, restParams = (0,_object_without_properties/* default */.Z)(params, [
                                    "chatId",
                                    "groupId"
                                ]);
                                chat/* default.updateChatGroup */.ZP.updateChatGroup(groupId, restParams).then((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                _ctx.next = 2;
                                                return chat/* default.getGroupRoom */.ZP.getGroupRoom(chatId).then(function(resGroupDetail) {
                                                    var data = resGroupDetail.data.data;
                                                    set({
                                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, data))
                                                    });
                                                    resolve(true);
                                                }).catch(function() {
                                                    set({
                                                        isLoadingUpdateGroup: false
                                                    });
                                                });
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }))).catch(function() {
                                    set({
                                        isLoadingUpdateGroup: false
                                    });
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetGroupLink: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
                var groupId, chatId;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            groupId = params.groupId, chatId = params.chatId;
                            _ctx.next = 3;
                            return chat/* default.resetLink */.ZP.resetLink(groupId).then(function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(res) {
                                    var data;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                data = res.data.data;
                                                set({
                                                    group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group[chatId]), {
                                                        invitation_link: data === null || data === void 0 ? void 0 : data.new_link
                                                    }))),
                                                    isLoadingResetLink: false
                                                });
                                            case 2:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(res) {
                                    return _ref.apply(this, arguments);
                                };
                            }()).catch(function(err) {
                                var ref;
                                if ((err === null || err === void 0 ? void 0 : (ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 403) {
                                    var ref1, ref2;
                                    (0,AlertMessage/* default */.Z)({
                                        content: err === null || err === void 0 ? void 0 : (ref1 = err.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message,
                                        alertType: "plain-default",
                                        messageType: "error"
                                    });
                                }
                                set({
                                    isLoadingResetLink: false
                                });
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        refreshGroupRoomDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                chat/* default.getGroupRoomSilent */.ZP.getGroupRoomSilent(chatId).then(function(res) {
                                    var data = res.data.data;
                                    set({
                                        group: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().group), (0,_define_property/* default */.Z)({}, chatId, data))
                                    });
                                    resolve(true);
                                }).catch(function() {
                                    resolve(false);
                                });
                            }));
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(chatId) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store_roomDetailStore = (roomDetailStore);

// EXTERNAL MODULE: ./src/lib/api/friends.ts
var friends = __webpack_require__(63699);
;// CONCATENATED MODULE: ./src/features/chat/store/contactSyncStore.ts
/* eslint-disable import/no-named-as-default-member */ 

var contactSyncStore = (0,esm/* default */.ZP)(function(set) {
    return {
        status: "CONTACT_STATUS_TYPE_NOT_SYNCED",
        total: 0,
        fetchStatus: function() {
            friends/* default.getContactSyncStatus */.Z.getContactSyncStatus().then(function(res) {
                var _data = res.data, _data1 = _data.data, status = _data1.status, total = _data1.total;
                set({
                    status: status,
                    total: total
                });
            }).catch(function() {});
        }
    };
});
/* harmony default export */ var store_contactSyncStore = (contactSyncStore);

;// CONCATENATED MODULE: ./src/features/chat/store/contactDiscoveryStore.ts
/* eslint-disable camelcase */ 







var contactDiscoveryStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        data: {},
        showSuggestionContacts: false,
        showSuggestionMembers: false,
        showSuggestionNewMembers: false,
        searchUser: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword, storeKey) {
                var cursor, groupId, ref, ref1, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            cursor = _args.length > 2 && _args[2] !== void 0 ? _args[2] : null, groupId = _args.length > 3 && _args[3] !== void 0 ? _args[3] : 0;
                            ;
                            set({
                                data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().data), (0,_define_property/* default */.Z)({}, storeKey, {
                                    isLoading: true,
                                    members: ((ref = get().data[storeKey]) === null || ref === void 0 ? void 0 : ref.members) || [],
                                    nextCursor: ((ref1 = get().data[storeKey]) === null || ref1 === void 0 ? void 0 : ref1.nextCursor) || ""
                                }))
                            });
                            _ctx.next = 5;
                            return chat/* default.getSearchContactDiscovery */.ZP.getSearchContactDiscovery(keyword, cursor, 10, groupId).then(function(res) {
                                var _data = res.data.data, members = _data.members, next_cursor = _data.next_cursor;
                                var memberList = cursor ? (0,_to_consumable_array/* default */.Z)(get().data[storeKey].members).concat((0,_to_consumable_array/* default */.Z)(members)) : members;
                                set({
                                    data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get().data), (0,_define_property/* default */.Z)({}, storeKey, {
                                        members: memberList,
                                        nextCursor: next_cursor,
                                        isLoading: false
                                    }))
                                });
                            }).catch(function() {});
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(keyword, storeKey) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var store_contactDiscoveryStore = (contactDiscoveryStore);

// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
;// CONCATENATED MODULE: ./src/features/chat/store/chatGroupPolicyStore.ts





var chatGroupPolicyStore = (0,esm/* default */.ZP)(function(set) {
    return {
        maxMembers: constant/* MAX_GROUP_MEMBER_DEFAULT */.cK,
        fetchMaxMembers: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return chat/* default.getMaxMemberInGroup */.ZP.getMaxMemberInGroup().then(function(res) {
                            var _data = res.data.data, maxMembers = _data.max_member;
                            // -1 for admin
                            set({
                                maxMembers: maxMembers - 1
                            });
                        }).catch(function() {});
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    };
});
/* harmony default export */ var store_chatGroupPolicyStore = (chatGroupPolicyStore);

// EXTERNAL MODULE: ./src/lib/api/user.ts
var user = __webpack_require__(1955);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var stores_chat = __webpack_require__(50490);
;// CONCATENATED MODULE: ./src/features/chat/store/roomActionStore.ts
/* eslint-disable import/no-named-as-default-member */ /* eslint-disable eqeqeq */ 





var roomActionStore = (0,esm/* default */.ZP)(function(set) {
    return {
        isLoadingAcceptRequest: false,
        isLoadingRejectRequest: false,
        isLoadingAcceptInvitation: false,
        isLoadingDeleteInvitation: false,
        isLoadingBlockUnblock: false,
        respondRequestedRoom: function(param) {
            var roomId = param.roomId, respond = param.respond;
            return new Promise(function(resolve) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (respond === "accept") {
                        state.isLoadingAcceptRequest = true;
                    } else {
                        state.isLoadingRejectRequest = true;
                    }
                }));
                var request = respond === "accept" ? chat/* default.acceptRequest */.ZP.acceptRequest : chat/* default.rejectRequest */.ZP.rejectRequest;
                request(roomId).then(function(res) {
                    var rooms = stores_chat/* default.getState */.Z.getState().rooms;
                    stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        var roomIdx = rooms.invited.list.findIndex(function(room) {
                            return room.id == roomId;
                        });
                        if (roomIdx > -1) {
                            state.rooms.invited.list.splice(roomIdx, 1);
                        }
                    }));
                    set({
                        isLoadingAcceptRequest: false,
                        isLoadingRejectRequest: false
                    });
                    resolve(res.data);
                }).catch(function() {
                    set({
                        isLoadingAcceptRequest: false,
                        isLoadingRejectRequest: false
                    });
                });
            });
        },
        respondGroupInvitation: function(param) {
            var chatId = param.chatId, action = param.action;
            return new Promise(function(resolve) {
                set((0,immer_esm/* default */.ZP)(function(state) {
                    if (action === "ACTION_ACCEPT") {
                        state.isLoadingAcceptInvitation = true;
                    } else {
                        state.isLoadingDeleteInvitation = true;
                    }
                }));
                chat/* default.respondInvitation */.ZP.respondInvitation(chatId, action).then(function(res) {
                    if (action === "ACTION_REJECT") {
                        var rooms = stores_chat/* default.getState */.Z.getState().rooms;
                        var roomIdx = rooms.invited.list.findIndex(function(room) {
                            return room.id == chatId;
                        });
                        if (roomIdx > -1) {
                            stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                                state.rooms.invited.list.splice(roomIdx, 1);
                            }));
                        }
                    }
                    set({
                        isLoadingAcceptInvitation: false,
                        isLoadingDeleteInvitation: false
                    });
                    resolve(res.data);
                }).catch(function() {
                    set({
                        isLoadingAcceptInvitation: false,
                        isLoadingDeleteInvitation: false
                    });
                });
            });
        },
        blockUnblockUser: function(param) {
            var userId = param.userId, block = param.block, username = param.username;
            return new Promise(function(resolve) {
                var request = block ? user/* default.blockUser */.Z.blockUser : user/* default.unblockUser */.Z.unblockUser;
                request(userId).then(function(res) {
                    var roomIdx = stores_chat/* default.getState */.Z.getState().rooms.default.list.findIndex(function(room) {
                        var ref, ref1;
                        return ((ref = room.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.personal) === null || ref1 === void 0 ? void 0 : ref1.user_id) === userId;
                    });
                    if (roomIdx > -1) {
                        stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                            state.rooms.default.list[roomIdx].attributes.personal.is_blocked = block;
                        }));
                    }
                    if (block) {
                        (0,AlertMessage/* default */.Z)({
                            content: "".concat(username, " berhasil diblock "),
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                    } else {
                        (0,AlertMessage/* default */.Z)({
                            content: "unblock ".concat(username, " berhasil"),
                            alertType: "snackbar",
                            messageType: "success",
                            hasCloseIcon: true
                        });
                    }
                    resolve(res.data);
                }).catch(function() {
                    (0,AlertMessage/* default */.Z)({
                        content: "Blocking user gagal",
                        messageType: "error",
                        alertType: "snackbar",
                        hasCloseIcon: true
                    });
                });
            });
        },
        muteUnmuteRoom: function(param) {
            var chatId = param.chatId, muted = param.muted;
            return new Promise(function(resolve) {
                chat/* default.muteNotification */.ZP.muteNotification(chatId, muted).then(function(res) {
                    var data = res.data.data;
                    if (data) {
                        var roomIdx = stores_chat/* default.getState */.Z.getState().rooms.default.list.findIndex(function(room) {
                            return (room.type === "ROOM_TYPE_GROUP" || room.type === "ROOM_TYPE_BROADCAST") && room.id === parseInt(String(chatId), 10);
                        });
                        stores_chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                            state.rooms.default.list[roomIdx].status.is_muted = muted;
                        }));
                        if (muted) {
                            (0,AlertMessage/* default */.Z)({
                                content: "Notification Muted",
                                messageType: "success",
                                alertType: "snackbar",
                                hasCloseIcon: true
                            });
                        } else {
                            (0,AlertMessage/* default */.Z)({
                                content: "Notification Unmuted",
                                messageType: "success",
                                alertType: "snackbar",
                                hasCloseIcon: true
                            });
                        }
                    }
                    resolve(data);
                }).catch(function() {
                    (0,AlertMessage/* default */.Z)({
                        content: "Gagal menyimpan aturan notifikasi",
                        messageType: "error",
                        alertType: "snackbar",
                        hasCloseIcon: true
                    });
                });
            });
        }
    };
});
/* harmony default export */ var store_roomActionStore = (roomActionStore);

;// CONCATENATED MODULE: ./src/features/chat/store/index.ts









/***/ }),

/***/ 20826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ affiliateNavigationEvents; },
/* harmony export */   "d": function() { return /* binding */ affiliateActions; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

// Affiliate Partner - Navigate
var affiliateNavigationEvents = {
    /**
     Navigate - 1
     When user landed at external community page
  */ externalCommunityViewed: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("External Community Viewed");
    },
    /**
     Navigate - 2
     when user landed on detail Confirmed Code Community pop-up
  */ confirmedCodeCommunityViewed: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Confirmed Code Community Viewed", {
            affiliate_code: code
        });
    },
    /**
     Navigate - 3
     when user landed on Success Activated Code Community page
  */ activatedSuccessCodeCommunityViewed: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Success Activated Code Community Viewed", {
            affiliate_code: code
        });
    },
    /**
     Navigate - 4 & 5
     when user (member of community) landed on External Community Page
  */ membersExternalCommunityViewed: function(isExitEnabled) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Members External Community Viewed", {
            is_exit: isExitEnabled ? "True" : "False"
        });
    },
    /**
     Navigate - 6
     when user landed on Exit External Community pop-up
  */ exitExternalCommunityViewed: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Exit External Community Viewed");
    }
};
// Affiliate Partner - Action
var affiliateActions = {
    /**
     Action - 1
     user click External Community on Settings Menu
  */ externalCommunitySelected: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "External Community Selected"
        });
    },
    /**
     Action - 3
     user click Lanjut after input the code community to activate
  */ activatedCodeSelected: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Selected",
            affiliate_code: code
        });
    },
    /**
     Action - 4
     user click Batal on pop-up Confirmation Code Community
  */ activatedCodeCanceled: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Canceled",
            affiliate_code: code
        });
    },
    /**
     Action - 5
     user click Konfirmasi on pop-up Confirmation Code Community
  */ activatedCodeConfirmed: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Confirmed",
            affiliate_code: code
        });
    },
    /**
     Action - 6
     user click Selesai on Success Activated Code Community page
  */ activatedCodeSuccessSelected: function(code) {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Activated Code Success Selected",
            affiliate_code: code
        });
    },
    /**
     Action - 7
     user click Keluar Komunitas on External Community Page
  */ exitCommunitySelected: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Exit Community Selected"
        });
    },
    /**
     Action - 8
     user click Batal on External Community Page
  */ exitCommunityCanceled: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Exit Community Canceled"
        });
    },
    /**
     Action - 9
     user click Keluar on External Community Page
  */ exitCommunityConfirmed: function() {
        return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Affiliate Partner Action", {
            Action: "Exit Community Confirmed"
        });
    }
};


/***/ }),

/***/ 37220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useGetReferralInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lib_api_community__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89561);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);





var useGetReferralInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return {
        isLoading: false,
        fetchCommunityInfo: function fetchCommunityInfo() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var remisierUI, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            remisierUI = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("remisier");
                            if (!remisierUI) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            // If remisier UI is not exists, then we fetch from API
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,lib_api_community__WEBPACK_IMPORTED_MODULE_1__/* .getReferralInfo */ .Qu)();
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("failed to get community info");
                        case 10:
                            data = response.data.data;
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue("remisier", {
                                isLeader: data.is_leader,
                                isCommunityAccessGranted: data.enabled || data.is_leader
                            });
                            set({
                                isLoading: false
                            });
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            console.error(_ctx.t0);
                            set({
                                isLoading: false
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 74438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4680);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59748);




var TableBestBidOffer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var visible = props.visible, data = props.data, previous = props.previous;
    var getColor = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(columnData, dataToCompare) {
        if (columnData === 0) return undefined;
        return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getTypeByComparison */ .Ih)(columnData, dataToCompare);
    }, []);
    var reformatColumnData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(columnData) {
        if (columnData === 0) return "-";
        return (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(columnData);
    }, []);
    if (!visible || !data) return null;
    var cellClass = "orderbook-text-cell";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .TableBestBidOfferWrapper */ .M5, {
        children: [
            (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .generateColumnGroup */ .km)(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: "-"
                        }, "best-bid-frequency"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: reformatColumnData((ref = data.bid) === null || ref === void 0 ? void 0 : (ref1 = ref.quantity) === null || ref1 === void 0 ? void 0 : ref1.raw)
                        }, "best-bid-lot"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: "".concat(cellClass, " ").concat(getColor((ref2 = data.bid) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.raw, previous)),
                            children: reformatColumnData((ref4 = data.bid) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.price) === null || ref5 === void 0 ? void 0 : ref5.raw)
                        }, "best-bid-price"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: "".concat(cellClass, " ").concat(getColor((ref6 = data.offer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.raw, previous)),
                            children: reformatColumnData((ref8 = data.offer) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.price) === null || ref9 === void 0 ? void 0 : ref9.raw)
                        }, "best-offer-price"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: reformatColumnData((ref10 = data.offer) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.quantity) === null || ref11 === void 0 ? void 0 : ref11.raw)
                        }, "best-offer-lot"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: "-"
                        }, "best-offer-frequency")
                    ]
                }, "best-bid-offer")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableBestBidOffer);


/***/ }),

/***/ 44127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4680);


var TableEmptyOrderbook = function() {
    var cellClass = "orderbook-text-summary";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
        className: "empty-table",
        children: [
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateColumnGroup */ .km)(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                children: Array.from({
                    length: 10
                }).map(function(_, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tr", {
                        children: Array.from({
                            length: 6
                        }).map(function(_, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: cellClass,
                                children: "-"
                            }, "empty-".concat(index.toString()));
                        })
                    }, "empty-row-".concat(index.toString()));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tfoot", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: "-"
                        }, "bid-frequency-total"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: "-"
                        }, "bid-total"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: "".concat(cellClass, " center"),
                            colSpan: 2,
                            children: "TOTAL"
                        }, "total"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: "-"
                        }, "offer-total"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                            className: cellClass,
                            children: "-"
                        }, "offer-frequency-total")
                    ]
                }, "empty-summary")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableEmptyOrderbook);


/***/ }),

/***/ 25504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4680);




var TableOHLNonStock = function(param) {
    var data = param.data, isTwoColumn = param.isTwoColumn;
    var average = data.average, change = data.change, high = data.high, lot = data.lot, low = data.low, open = data.open, percentage = data.percentage, previous = data.previous, value = data.value;
    var classNameTwoColumn = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isTwoColumn ? " two-column" : "";
    }, [
        isTwoColumn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
        className: "table-live-price",
        children: [
            isTwoColumn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "118.5px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "54px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "94.5px"
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "66.5px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "42px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "62px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "42px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "54.5px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "Prev"
                            }, "previous-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: "notchange".concat(classNameTwoColumn),
                                children: numeral__WEBPACK_IMPORTED_MODULE_2___default()(previous).format("0,0")
                            }, "previous"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: "Open"
                            }, "open-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(open, previous),
                                children: open
                            }, "open"),
                            !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "Lot"
                                    }, "lot-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getType */ .oL)(change),
                                        children: lot
                                    }, "lot")
                                ]
                            })
                        ]
                    }, "previous-open-lot"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "Chg"
                            }, "change-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: "".concat((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getType */ .oL)(change)).concat(classNameTwoColumn),
                                children: change
                            }, "change"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: "High"
                            }, "high-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(high, previous),
                                children: high
                            }, "high"),
                            !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "Val"
                                    }, "value-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getType */ .oL)(change),
                                        children: value
                                    }, "value")
                                ]
                            })
                        ]
                    }, "change-high-val"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "%"
                            }, "percentage-change-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: "".concat((0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getType */ .oL)(percentage)).concat(classNameTwoColumn),
                                children: percentage
                            }, "percentage-change"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: "Low"
                            }, "low-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(low, previous),
                                children: low
                            }, "low"),
                            !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "Avg"
                                    }, "average-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(average, previous, true),
                                        children: average
                                    }, "average")
                                ]
                            })
                        ]
                    }, "percentage-change-low-average")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableOHLNonStock);


/***/ }),

/***/ 57644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4680);




var TableOHLStock = function(param) {
    var data = param.data, isTwoColumn = param.isTwoColumn, showForthRow = param.showForthRow, showIepIev = param.showIepIev;
    var average = data.average, change = data.change, high = data.high, lot = data.lot, low = data.low, open = data.open, previous = data.previous, value = data.value, frequency = data.frequency, Iep = data.Iep, Iev = data.Iev, fbuy = data.fbuy, fsell = data.fsell, ara = data.ara, arb = data.arb;
    var classNameTwoColumn = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isTwoColumn ? " two-column" : "";
    }, [
        isTwoColumn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
        className: "table-live-price",
        children: [
            isTwoColumn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "118.5px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "54px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "94.5px"
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("colgroup", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "30px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "66.5px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "42px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "62px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "42px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("col", {
                        style: {
                            width: "54.5px"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: "Open"
                            }, "open-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(open, previous),
                                children: open
                            }, "open"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "Prev"
                            }, "previous-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: "notchange".concat(classNameTwoColumn),
                                children: numeral__WEBPACK_IMPORTED_MODULE_2___default()(previous).format("0,0")
                            }, "previous"),
                            !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "Lot"
                                    }, "lot-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getType */ .oL)(change),
                                        children: lot
                                    }, "lot")
                                ]
                            })
                        ]
                    }, "previous-open-lot"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: "High"
                            }, "high-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(high, previous),
                                children: high
                            }, "high"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "ARA"
                            }, "ara-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: ara
                            }, "ara-value"),
                            !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "Val"
                                    }, "value-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getType */ .oL)(change),
                                        children: value
                                    }, "value")
                                ]
                            })
                        ]
                    }, "change-high-val"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: "Low"
                            }, "low-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(low, previous),
                                children: low
                            }, "low"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "ARB"
                            }, "arb-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                className: classNameTwoColumn,
                                children: arb
                            }, "arb-value"),
                            !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "Avg"
                                    }, "average-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(average, previous, true),
                                        children: average
                                    }, "average")
                                ]
                            })
                        ]
                    }, "percentage-change-low-average"),
                    showForthRow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                        children: [
                            showIepIev ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "IEP"
                                    }, "iep-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTypeByComparison */ .Ih)(Iep, previous),
                                        children: Iep
                                    }, "iep"),
                                    !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "IEV"
                                            }, "iev-title"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: Iev
                                            }, "iev")
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        children: "F Buy"
                                    }, "f-buy-title"),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "up",
                                        children: fbuy
                                    }, "f-buy"),
                                    !isTwoColumn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                children: "F Sell"
                                            }, "f-sell-title"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                className: "down",
                                                children: fsell
                                            }, "f-sell")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: "Freq"
                            }, "frequency-title"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                children: frequency
                            }, "frequency")
                        ]
                    }, "frequency-f-buy-f-sell")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableOHLStock);


/***/ }),

/***/ 98822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4680);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59748);



var THead = function(param) {
    var key = param.key, value = param.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
        className: "orderbook-text-cell title",
        children: value
    }, key);
};
var TableSeparator = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TableSeparatorWrapper */ .s_, {
        children: [
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateColumnGroup */ .km)(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(THead, {
                            value: "Freq"
                        }, "bid-frequency-title"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(THead, {
                            value: "Lot"
                        }, "bid-lot-title"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(THead, {
                            value: "Bid"
                        }, "bid-price-title"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(THead, {
                            value: "Offer"
                        }, "offer-price-title"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(THead, {
                            value: "Lot"
                        }, "offer-lot-title"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(THead, {
                            value: "Freq"
                        }, "offer-frequency-title")
                    ]
                }, "header")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TableSeparator);


/***/ }),

/***/ 88259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var stores_company_useGetCompanyInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25610);




var useBestBidOfferData = function(data, symbol) {
    var defaultMarketStatus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showBestBid = ref[0], setShowBestBid = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(data), bestBidData = ref1[0], setBestBidData = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isBlured = ref2[0], setIsBlured = ref2[1];
    var getCompanyInfo = (0,stores_company_useGetCompanyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.getCompanyInfo;
    });
    var companyData = (0,stores_company_useGetCompanyInfo__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.data;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (symbol && !defaultMarketStatus) {
            getCompanyInfo(symbol);
        }
    }, [
        symbol,
        defaultMarketStatus
    ]);
    // update data from websocket
    var setBestBidOffer = function(newData) {
        var bestBid = newData.bestBid, bestOffer = newData.bestOffer;
        if (bestBid) {
            setBestBidData(function(prevData) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData), {
                    bid: bestBid
                });
            });
        }
        if (bestOffer) {
            setBestBidData(function(prevData) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, prevData), {
                    offer: bestOffer
                });
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (data) {
            setBestBidData(data);
            setShowBestBid(true);
        }
        return function() {
            setShowBestBid(false);
        };
    }, [
        data
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref, ref1;
        var marketStatus = defaultMarketStatus || ((ref = companyData[symbol]) === null || ref === void 0 ? void 0 : (ref1 = ref.market_hour) === null || ref1 === void 0 ? void 0 : ref1.status);
        var hasBestBidOffer = data && showBestBid;
        if (marketStatus) {
            setIsBlured(marketStatus === "open" && hasBestBidOffer);
        } else {
            setIsBlured(false);
        }
        return function() {
            setIsBlured(false);
        };
    }, [
        companyData,
        symbol,
        data,
        defaultMarketStatus,
        showBestBid
    ]);
    return {
        showBestBid: showBestBid,
        bestBidData: bestBidData,
        isBlured: isBlured,
        setBestBidOffer: setBestBidOffer
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useBestBidOfferData);


/***/ }),

/***/ 59748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M5": function() { return /* binding */ TableBestBidOfferWrapper; },
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; },
/* harmony export */   "fC": function() { return /* binding */ LastPriceTextWrapper; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "s_": function() { return /* binding */ TableSeparatorWrapper; },
/* harmony export */   "v0": function() { return /* binding */ OrderbookTableWrapper; }
/* harmony export */ });
/* unused harmony exports OrderbookText, OrderbookTextHover, OptionText, IconMoreOptions, RightIconMoreOptions, NotAvailableText, SecureTable, BalanceInfoWrapper, StyledIconWrapper, ValueWrapper, PendingMark */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  border-bottom: 1px solid ",
        ";\n  padding: 20px 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 10px;\n  display: inline-block;\n  font-size: 13px;\n  text-overflow: ellipsis;\n  max-width: calc(100% - 10px);\n  overflow: hidden;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  right: 10px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n  position: relative;\n  table-layout: fixed;\n  width: 100%;\n  z-index: 1;\n  background: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n\n  thead {\n    th {\n      height: 32px;\n      line-height: 16px;\n      font-weight: normal;\n      text-align: center;\n      padding: 8px 0px;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: unset;\n  height: 32px;\n  border: none;\n\n  tbody {\n    td {\n      height: 20px;\n      line-height: 16px;\n      font-weight: normal;\n      text-align: center;\n      padding: 4px 0px;\n    }\n\n    tr {\n      border: 5px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-top: 25px;\n\n    ::before {\n      border-bottom: none;\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ::after,\n    ::before {\n      display: none;\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  user-select: none;\n  \n  .empty-table > tbody {\n    display: table;\n  }\n\n  table {\n    margin: auto;\n    position: relative;\n    table-layout: fixed;\n    width: 100%;\n    z-index: 1;\n  }\n\n  tbody {\n    display: block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 320px;\n  }\n\n  thead, tbody tr, tfoot {\n    display: table;\n    width: 321px;\n    table-layout: fixed;\n  }\n\n  thead {\n    th {\n      height: 32px;\n      line-height: 16px;\n      font-weight: normal;\n      text-align: center;\n      padding: 8px 0px;\n    }\n  } \n\n  tbody {\n    > tr:hover {\n      > td {\n        background: unset;\n      }\n    }\n    \n    td {\n      text-align: center;\n      padding: 8px 0px;\n      white-space: nowrap;\n    }\n\n    td:first-child, td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2), td:nth-child(5) {\n      width: 66.5px;\n    }\n\n    td:nth-child(3), td:nth-child(4) {\n      width: 50px;\n    }\n  } \n\n  tfoot {\n    background: ",
        ";\n    border-top: 1px solid ",
        ";\n\n    > tr {\n      > td {\n        border-bottom: none;\n        height: 32px;\n        line-height: 16px;\n        font-weight: normal;\n        text-align: center;\n        padding: 8px 0px;\n      }\n    }\n\n    td:nth-child(3) {\n      width: 100px;\n    }\n\n    td:first-child, td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2), td:nth-child(4) {\n      width: 66.5px;\n    }\n  }\n\n  tr.blurred {\n    opacity: 0.4;\n  }\n\n  .highlited-bid::before,\n  .highlited-off::before {\n    position: absolute;\n    content: '';\n    width: 200%;\n    height: 100%;\n  }\n\n  .highlited-bid::before {\n    background: ",
        ";\n  }\n\n  td:nth-child(2):before {\n    left: -50px;\n  }\n\n  .highlited-off::before {\n    background: ",
        ";\n  }\n\n  td:nth-child(4):before {\n    right: -5px;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  user-select: none;\n\n  .ant-table-tbody {\n    > tr:hover {\n      > td {\n        background: unset;\n      }\n    }\n\n    td {\n      white-space: nowrap;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid ",
        ";\n  border-width: 0 1px;\n  min-width: 50px;\n  margin: 0 7px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  display: ",
        ";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  cursor: pointer;\n  position: absolute;\n  top: 40%;\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  margin-bottom: 20px;\n  position: relative;\n\n  table.table-live-price {\n    td:first-child {\n      padding-left: 0px;\n      text-align: left;\n      width: 30px;\n    }\n\n    td:nth-child(even) {\n      padding-right: 12px;\n\n      &.two-column {\n        padding-right: 16px;\n      }\n    }\n\n    td:nth-child(2) {\n      width: 66.5px;\n\n      &.two-column {\n        padding-left: 8px;\n        width: 118.5px;\n      }\n    }\n\n    td:nth-child(3) {\n      padding-left: 12px;\n      text-align: left;\n      width: 42px;\n\n      &.two-column {\n        padding-left: 16px;\n        padding-right: 8px;\n        width: 54px;\n      }\n    }\n\n    td:nth-child(4) {\n      width: 62px;\n    }\n\n    td:nth-child(5) {\n      padding-left: 12px;\n      text-align: left;\n      width: 42px;\n    }\n\n    td:last-child {\n      padding-right: 0px;\n      width: 54.5px;\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 20px;\n  line-height: 21px;\n  padding: 0 10px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}


var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, IconMoreOptions = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconMoreOptions */ .Gn.IconMoreOptions, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper;
var Table = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Orderbook.Table */ .TG.Table;
var hexOpacity = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .utils.hexOpacity */ .P6.hexOpacity;
var colorTextByType = {
    up: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary,
    down: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange,
    notchange: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highball */ .$_.highball
};
var OrderbookText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function(props) {
    return {
        size: "12.5px",
        align: "right",
        padding: props.padding || "5px 3px",
        height: "1.15",
        type: props.type
    };
}).withConfig({
    componentId: "sc-3d0d3d9e-0"
})(_templateObject(), function(param) {
    var type = param.type;
    return colorTextByType[type];
});
var OrderbookTextHover = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(OrderbookText).attrs(function(props) {
    return {
        bid: props.bid
    };
}).withConfig({
    componentId: "sc-3d0d3d9e-1"
})(_templateObject1(), function(param) {
    var bid = param.bid;
    return bid ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary + hexOpacity(30) : _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange + hexOpacity(30);
});
var CardHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    padding: "9px 12px",
    align: "center"
}).withConfig({
    componentId: "sc-3d0d3d9e-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var Tag = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    height: "20px",
    size: "12.5px",
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light,
    padding: "0 5px",
    width: "auto",
    family: "bold"
}).withConfig({
    componentId: "sc-3d0d3d9e-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis);
var OptionText = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-3d0d3d9e-4"
})(_templateObject4());
var NotAvailableText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange,
    padding: "2px 5px"
}).withConfig({
    componentId: "sc-3d0d3d9e-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange);
var RightIconMoreOptions = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(IconMoreOptions).attrs({
    vertical: true
}).withConfig({
    componentId: "sc-3d0d3d9e-6"
})(_templateObject6());
var TableSeparatorWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].table.withConfig({
    componentId: "sc-3d0d3d9e-7"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var TableBestBidOfferWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(TableSeparatorWrapper).withConfig({
    componentId: "sc-3d0d3d9e-8"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray);
var OrderbookTableWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-3d0d3d9e-9"
})(_templateObject11(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary + hexOpacity(30), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange + hexOpacity(30), function(props) {
    return props.$isHidden && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject9());
}, function(props) {
    return props.$isIHSG && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject10());
});
var SecureTable = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Table).attrs({
    padding: "0",
    showHeader: false
}).withConfig({
    componentId: "sc-3d0d3d9e-10"
})(_templateObject12());
var BalanceInfoWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    height: "25px"
}).withConfig({
    componentId: "sc-3d0d3d9e-11"
})(_templateObject13(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var StyledIconWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(IconWrapper).attrs({
    size: "24px"
}).withConfig({
    componentId: "sc-3d0d3d9e-12"
})(_templateObject14(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ValueWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(OrderbookText).attrs({
    align: "center",
    py: "4px"
}).withConfig({
    componentId: "sc-3d0d3d9e-13"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
// eslint-disable-next-line space-infix-ops
var PendingMark = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-3d0d3d9e-14"
})(_templateObject16(), function(param) {
    var isBuy = param.isBuy;
    return isBuy ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary : _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange;
}, function(param) {
    var show = param.show;
    return show ? "block" : "none";
}, function(param) {
    var isBuy = param.isBuy;
    return isBuy ? "left: -20px" : "right: -20px";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-3d0d3d9e-15"
})(_templateObject17(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var LastPriceTextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-3d0d3d9e-16"
})(_templateObject18());



/***/ }),

/***/ 4680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sM": function() { return /* binding */ calculateSummary; },
  "o$": function() { return /* binding */ checkShouldTableHide; },
  "Te": function() { return /* binding */ formatAverage; },
  "Px": function() { return /* binding */ formatChangePrevious; },
  "P3": function() { return /* binding */ formatLastPrice; },
  "uf": function() { return /* binding */ formatNumber; },
  "_7": function() { return /* binding */ formatNumberWithNA; },
  "Dl": function() { return /* binding */ formatPercentageChange; },
  "km": function() { return /* binding */ generateColumnGroup; },
  "ow": function() { return /* binding */ getPriceDataFromOrderbookData; },
  "ru": function() { return /* binding */ getShowIepIev; },
  "oL": function() { return /* binding */ getType; },
  "Ih": function() { return /* binding */ getTypeByComparison; },
  "nr": function() { return /* binding */ handleReceiveMessageNATSIepIev; },
  "K1": function() { return /* binding */ isTensOfMillions; }
});

// UNUSED EXPORTS: formatLot, generateOHLCData, generateOrderbookData, handleReceiveMessageNATSLivePrice, handleReceiveMessageNATSOrderbook

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/number.js
var utils_number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral_numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral_numeral);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/store.ts
var store = __webpack_require__(85440);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/utils/websocketHandler.ts




var simulateLivePrice = null;
var startSimulateLivePrice = function() {
    var i = 0;
    var intr = 10;
    var mock = '{"S":"","N":"","M":"","C":{"sym":"IHSG","ohlc":{"Adj_Close":5627.123,"Close":5627.123,"High":5660.385,"Low":5624.928,"Open":5658.199,"volume":5594419200,"date_unix":1492016400,"date_formated":"2017-04-13 00:00:00+07:00","dividend":"","foreign_buy":2145632540293,"foreign_flow":164572124019141,"foreign_sell":1544625382053,"frequency":251951,"marketcap":0,"value":3463678783600,"shareoutstanding":0,"ann_eps":0,"ann_pe":null,"avg_price":null,"previous":5644.15478515625},"widget":{"IHSG":{"lastprice":"5627.123","price_change":"-17.0320","percentage_change":"-0.302"}}},"__t":1492071194520}';
    var mock1 = '{"S":"","N":"","M":"","C":{"sym":"INPC","ohlc":{"Adj_Close":102,"Close":102,"High":105,"Low":99,"Open":100,"volume":30281300,"date_unix":1490029200,"date_formated":"2017-03-21 00:00:00+07:00","dividend":"","foreign_buy":0,"foreign_flow":40891563428,"foreign_sell":0,"frequency":4117,"marketcap":1595099574138,"value":3103994400,"shareoutstanding":15796238181,"ann_eps":7.54,"ann_pe":null,"avg_price":102.505,"previous":100},"widget":{"INPC":{"lastprice":"102","price_change":"2","percentage_change":"2"}},"OFFER-RG":{"price9":"111","que_num5":"16","que_num4":"24","que_num7":"8","que_num6":"7","que_num1":"8","que_num3":"27","que_num2":"24","price10":"112","que_num9":"6","que_num8":"15","price7":"109","price8":"110","price5":"107","price6":"108","price3":"105","price4":"106","price1":"103","price2":"104","volume1":"260900","volume3":"1488300","volume2":"1836600","volume5":"2347500","volume4":"1398000","volume7":"359300","volume6":"897900","volume9":"168700","volume8":"320500","que_num10":"6","volume10":"445600"},"BID-RG":{"price9":"94","que_num5":"18","que_num4":"20","que_num7":"6","que_num6":"7","que_num1":"1","que_num3":"18","que_num2":"13","price10":"93","que_num9":"2","que_num8":"4","price7":"96","price8":"95","price5":"98","price6":"97","price3":"100","price4":"99","price1":"102","price2":"101","volume1":"12000","volume3":"1413400","volume2":"1347400","volume5":"1368600","volume4":"628400","volume7":"1025900","volume6":"1013700","volume9":"1300","volume8":"2570300","que_num10":"3","volume10":"16000"}},"__t":1490091253800}';
    var mock_ELSA_C = '{"S":"","N":"","M":"","C":{"sym":"ELSA","ohlc":{"Adj_Close":298,"Close":298,"High":308,"Low":298,"Open":300,"volume":74749700,"date_unix":1507136400,"date_formated":"2017-10-05 00:00:00+07:00","dividend":"","foreign_buy":527721600,"foreign_flow":370672302064,"foreign_sell":436602600,"frequency":2761,"marketcap":2174953000000,"value":22664262800,"shareoutstanding":7298500000,"ann_eps":3.96,"ann_pe":null,"avg_price":303.202,"previous":300,"freq_analyzer":3551.4870391264053},"date_unix":1507136400,"widget":{"ELSA":{"lastprice":"308","price_change":"-2","percentage_change":"-0.667"}},"OFFER-RG":{},"BID-RG":{}},"O":"","__t":1507193041035}';
    var mock_ELSA_O = '{"S":"","N":"","M":"","C":"","O":{"sym":"ELSA","OFFER-RG":{"price9":"316","que_num5":"107","que_num4":"89","que_num7":"92","que_num6":"140","que_num1":"23","que_num3":"64","que_num2":"28","price10":"318","que_num9":"60","que_num8":"82","price7":"312","price8":"314","price5":"308","price6":"310","price3":"304","price4":"306","price1":"300","price2":"302","volume1":"1785900","volume3":"3128600","volume2":"1936000","volume5":"6448500","volume4":"7207500","volume7":"13696700","volume6":"7946800","volume9":"4039600","volume8":"4784200","que_num10":"45","volume10":"2000700"},"BID-RG":{"price9":"282","que_num5":"67","que_num4":"44","que_num7":"23","que_num6":"25","que_num1":"91","que_num3":"77","que_num2":"86","price10":"280","que_num9":"16","que_num8":"20","price7":"286","price8":"284","price5":"290","price6":"288","price3":"294","price4":"292","price1":"298","price2":"296","volume1":"2541100","volume3":"4919800","volume2":"3998700","volume5":"2428600","volume4":"1747800","volume7":"2508700","volume6":"1376500","volume9":"5917300","volume8":"1047900","que_num10":"33","volume10":"1614000"}},"__t":1507192983176}';
    simulateLivePrice = setInterval(function() {
        i = i + 1;
        var json_mock_C = JSON.parse(mock_ELSA_C);
        var json_mock_O = JSON.parse(mock_ELSA_O);
        var C = json_mock_C.C;
        var O = json_mock_O.O;
        C.__t = json_mock_C.__t;
        O.__t = json_mock_O.__t;
        C.ohlc.High = C.ohlc.High + i;
        C.ohlc.frequency = C.ohlc.frequency + i;
        C.ohlc.Close = C.ohlc.Close + i;
        C.widget["ELSA"].lastprice = Number(C.widget["ELSA"].lastprice) + i;
        O["OFFER-RG"].volume2 = parseInt(O["OFFER-RG"].volume2) + i * 100;
        O["OFFER-RG"].volume3 = parseInt(O["OFFER-RG"].volume3) + i * 100;
        O["OFFER-RG"].volume4 = parseInt(O["OFFER-RG"].volume4) + i * 100;
        O["OFFER-RG"].volume5 = parseInt(O["OFFER-RG"].volume5) + i * 100;
        O["OFFER-RG"].volume6 = parseInt(O["OFFER-RG"].volume6) + i * 100;
        O["OFFER-RG"].volume7 = parseInt(O["OFFER-RG"].volume7) + i * 100;
        O["OFFER-RG"].volume8 = parseInt(O["OFFER-RG"].volume8) + i * 100;
        O["OFFER-RG"].volume9 = parseInt(O["OFFER-RG"].volume9) + i * 100;
        // dispatch(handleC(C))
        websocketHandler_handleCSingle(C);
        websocketHandler_handleOsingle(O);
    }, intr);
};
var stopSimulateLivePrice = function() {
    clearInterval(simulateLivePrice);
};
var websocketHandler_handleCSingle = function(data) {
    var isNATS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var batch = [];
    var state = useOrderbookStore.getState();
    var symbol = isNATS ? data.stockCode : data.sym;
    var general_pricedata = state.liveprice[symbol];
    var checkObj = emptyObject(general_pricedata);
    var page_company_lastupdate = "";
    if (isNATS) {
        page_company_lastupdate = moment(data.date).format("ddd HH:mm");
    } else {
        var temp_timestamp = data.__t.toString();
        temp_timestamp = parseInt(temp_timestamp);
        page_company_lastupdate = moment.unix(temp_timestamp).format("ddd HH:mm");
    }
    if (!checkObj) {
        // if there is symbol
        convertUpdatePriceSocket(data, isNATS, function(err, result) {
            var newResult = _object_spread({}, result);
            newResult.time = page_company_lastupdate;
            batch.push({
                name: "update_general_pricedata_liveprice",
                payload: {
                    index: symbol,
                    data: newResult,
                    lastupdate: page_company_lastupdate
                }
            });
        });
    }
    setValueBatch(batch);
    return batch;
};
var websocketHandler_handleOsingle = function(data) {
    var plate = {
        bid: data["BID-RG"],
        offer: data["OFFER-RG"]
    };
    var batch = [];
    var state = useOrderbookStore.getState();
    var symbol = data.sym;
    var general_pricedata = state.liveprice[symbol];
    var checkObj = emptyObject(general_pricedata);
    if (!checkObj) {
        // if there is symbol
        batch.push({
            name: "update_orderbook_pricedata_liveprice",
            payload: {
                index: symbol,
                data: plate
            }
        });
    }
    setValueBatch(batch);
};
var convertUpdatePriceSocket = function(pricesocket, isNATS, cb) {
    var convert_spec = {};
    if (isNATS) {
        convert_spec = {
            "BID-RG": "bid",
            "OFFER-RG": "offer",
            close: "close",
            open: "open",
            high: "high",
            low: "low",
            average: "average",
            prev: "previous",
            value: "value",
            volume: "volume",
            frequency: "frequency",
            frg_buy: "fbuy",
            frg_sell: "fsell",
            stockCode: "symbol",
            lastprice: "lastprice",
            change: {
                percentage: "percentage_change",
                value: "change"
            }
        };
    } else {
        convert_spec = {
            "BID-RG": "bid",
            "OFFER-RG": "offer",
            ohlc: {
                Close: "close",
                Open: "open",
                High: "high",
                Low: "low",
                avg_price: "average",
                previous: "previous",
                value: "value",
                volume: "volume",
                frequency: "frequency",
                foreign_buy: "fbuy",
                foreign_sell: "fsell"
            },
            sym: "symbol",
            widget: {
                sym$: {
                    price_change: "change",
                    percentage_change: "percentage_change",
                    lastprice: "lastprice"
                }
            }
        };
    }
    var result = {};
    result = generalConvertBySpec(convert_spec, pricesocket);
    // @ts-ignore
    // result.id = pricecurrent.id
    // @ts-ignore
    // if (pricecurrent.desc) result.desc = pricecurrent.desc
    cb(null, result);
    return result;
};
var generalConvertBySpec = function(convert_spec, pricesocket) {
    var result = {};
    Object.keys(convert_spec).map(function(name) {
        if (typeof convert_spec[name] === "string") {
            result[convert_spec[name]] = pricesocket[name];
        } else {
            var _convert_spec = convert_spec[name];
            var _pricesocket = pricesocket[name];
            Object.keys(_convert_spec).map(function(_name) {
                if (_pricesocket[_name] || _pricesocket[_name] === 0) {
                    // if price socket exists
                    result[_convert_spec[_name]] = _pricesocket[_name];
                } else if (_name.indexOf("$") !== -1) {
                    // if price socket dollar sign
                    var ori_name = _name;
                    _name = _name.replace("$", "");
                    Object.keys(convert_spec).map(function(name) {
                        if (name === _name) {
                            var value = pricesocket[name];
                            var obj_temp = _pricesocket[value];
                            Object.keys(_convert_spec[ori_name]).map(function(_child_name) {
                                result[_convert_spec[ori_name][_child_name]] = obj_temp[_child_name];
                            });
                        }
                    });
                }
            });
        }
    });
    return result;
};

// EXTERNAL MODULE: ./src/utils/webSocket.js
var webSocket = __webpack_require__(92953);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/styled.ts
var styled = __webpack_require__(59748);
;// CONCATENATED MODULE: ./src/features/company/Stream/TableOrderbook/utils.tsx
/* eslint-disable indent */ 








var getType = function(data) {
    var formattedData = numeral_default()(data).value();
    if (formattedData > 0) {
        return "up";
    }
    if (formattedData < 0) {
        return "down";
    }
    return "notchange";
};
var getTypeByComparison = function(data, dataToCompare) {
    var yellowZero = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var formattedData = numeral_default()(data).value();
    var formattedDataToCompare = numeral_default()(dataToCompare).value();
    if (yellowZero && !formattedData) return "notchange";
    if (formattedData > formattedDataToCompare) {
        return "up";
    }
    if (formattedData < formattedDataToCompare) {
        return "down";
    }
    if (formattedData === formattedDataToCompare) {
        return "notchange";
    }
    return "";
};
var formatPercentageChange = function(value) {
    var percentData = value || "NA";
    return percentData || percentData !== "NA" ? "".concat(numeral_default()(percentData).format("0.00"), "%") : "NA";
};
var formatAverage = function(value) {
    return Number.isNaN(value) || Number(value) === 0 || !value ? "NA" : (0,utils_number/* parseCountThousand */.ym)(value);
};
var formatNumber = function(value) {
    return numeral_default()(value).format("0,0[.]00");
};
var formatNumberWithNA = function(value) {
    var NA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "NA";
    return value ? (0,utils_number/* parseCountThousand */.ym)(value) : NA;
};
var formatLastPrice = function(value) {
    return value ? (0,utils_number/* parseCountThousand */.ym)(value) : "NA";
};
var formatChangePrevious = function(value) {
    if (utils_number/* default.isDecimal */.ZP.isDecimal(value)) {
        return numeral_default()(value).format("0.00");
    }
    return value !== "NA" ? numeral_default()(value).format("0") : "NA";
};
var generateOHLCData = function(data) {
    var fourthRowExist = !!data.iepiev || data.is_foreignbs_exist;
    return [
        // First row
        {
            col1Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "0px 5px 4px 12px",
                children: "Prev"
            }),
            col1Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "0px 5px 4px",
                type: "notchange",
                children: formatNumber(data.previous)
            }),
            col2Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "0px 5px 4px",
                children: "Open"
            }),
            col2Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "0px 5px 4px",
                type: getTypeByComparison(data.open, data.previous),
                children: formatNumber(data.open)
            }),
            col3Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "0px 5px 4px",
                children: "Lot"
            }),
            col3Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "0px 12px 4px 5px",
                type: getType(data.change),
                children: data.volume ? number.parseCountAbbrv3(number.parseLot(data.volume), 1, 4) : "NA"
            })
        },
        // Second row
        {
            col1Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 4px 12px",
                children: "Chg"
            }),
            col1Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 4px",
                type: getType(data.change),
                children: number.addPlusOrMinus2(data.change)
            }),
            col2Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 4px",
                children: "High"
            }),
            col2Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 4px",
                type: getTypeByComparison(data.high, data.previous),
                children: formatNumber(data.high)
            }),
            col3Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 4px",
                children: "Val"
            }),
            col3Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 12px 4px 5px",
                type: getType(data.change),
                children: data.value ? parseCountAbbrv2(data.value, 1) : "NA"
            })
        },
        // Third row
        {
            col1Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px ".concat(fourthRowExist ? "4px" : "0px", " 12px"),
                children: "%"
            }),
            col1Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px ".concat(fourthRowExist ? "4px" : "0px"),
                type: getType(data.percentage_change),
                children: formatPercentageChange(data.percentage_change)
            }),
            col2Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px ".concat(fourthRowExist ? "4px" : "0px"),
                children: "Low"
            }),
            col2Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px ".concat(fourthRowExist ? "4px" : "0px"),
                type: getTypeByComparison(data.low, data.previous),
                children: formatNumber(data.low)
            }),
            col3Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px ".concat(fourthRowExist ? "4px" : "0px"),
                children: "Avg"
            }),
            col3Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 12px ".concat(fourthRowExist ? "4px" : "0px", " 5px"),
                type: getType(data.change),
                children: formatAverage(data.average)
            })
        },
        // Fourth row
        data.iepiev ? {
            col1Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px 12px",
                children: "Freq"
            }),
            col1Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: data.frequency ? numeral(data.frequency).format("0,0") : ""
            }),
            col2Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: "IEP"
            }),
            col2Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                type: data.iepiev.iep.raw ? getTypeByComparison(data.iepiev.iep.raw, data.previous) : undefined,
                children: data.iepiev.iep.raw ? formatNumber(data.iepiev.iep.raw) : "-"
            }),
            col3Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: "IEV"
            }),
            col3Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 12px 0px 5px",
                children: data.iepiev.iev.raw ? parseCountAbbrv2(data.iepiev.iev.raw, 1, ",", true) : "-"
            })
        } : data.is_foreignbs_exist ? {
            col1Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px 12px",
                children: "Freq"
            }),
            col1Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: data.frequency ? numeral(data.frequency).format("0,0") : ""
            }),
            col2Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: "F Buy"
            }),
            col2Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: data.fbuy ? numeral(data.fbuy).format("0.0 a") : ""
            }),
            col3Label: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 5px 0px",
                children: "F Sell"
            }),
            col3Value: /*#__PURE__*/ _jsx(OrderbookText, {
                padding: "4px 12px 0px 5px",
                children: data.fsell ? numeral(data.fsell).format("0.0 a") : ""
            })
        } : {}, 
    ];
};
var generateOrderbookData = function(data) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var _bid = data.bid, bid = _bid === void 0 ? {} : _bid, _offer = data.offer, offer = _offer === void 0 ? {} : _offer;
    return (0,_to_consumable_array/* default */.Z)(Array(length)).map(function(_, i) {
        return {
            bidLot: parseInt(bid === null || bid === void 0 ? void 0 : bid["volume".concat(i + 1)], 10) / 100 || 0,
            bidPrice: parseInt(bid === null || bid === void 0 ? void 0 : bid["price".concat(i + 1)], 10) || 0,
            bidFrequency: parseInt(bid === null || bid === void 0 ? void 0 : bid["que_num".concat(i + 1)], 10) || 0,
            offerPrice: parseInt(offer === null || offer === void 0 ? void 0 : offer["price".concat(i + 1)], 10) || 0,
            offerLot: parseInt(offer === null || offer === void 0 ? void 0 : offer["volume".concat(i + 1)], 10) / 100 || 0,
            offerFrequency: parseInt(offer === null || offer === void 0 ? void 0 : offer["que_num".concat(i + 1)], 10) || 0
        };
    });
};
var handleReceiveMessageNATSLivePrice = function(message) {
    handleCSingle(message, true);
};
var handleReceiveMessageNATSOrderbook = function(message) {
    var parsedData = wsUtils.parseSocketString(message.body);
    if (parsedData.O) {
        handleOsingle(parsedData.O);
    }
};
var handleReceiveMessageNATSIepIev = function(symbol, value) {
    (0,store/* setValue */.sO)({
        key: "liveprice",
        type: "update_iepiev",
        symbol: symbol,
        value: value
    });
};
var getBidOfferPrice = function() {
    var orderbookData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var bid = orderbookData.bid, offer = orderbookData.offer;
    var newBid = bid || {};
    var newOffer = offer || {};
    var bidPrice = Object.keys(newBid).filter(function(key) {
        return key.includes("price");
    });
    var offerPrice = Object.keys(newOffer).filter(function(key) {
        return key.includes("price");
    });
    return {
        bidPrice: bidPrice,
        offerPrice: offerPrice
    };
};
var getPriceDataFromOrderbookData = function() {
    var orderbookData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = getBidOfferPrice(orderbookData), bidPrice = ref.bidPrice, offerPrice = ref.offerPrice;
    var dataLength = Math.max(bidPrice.length, offerPrice.length);
    var dataShowedLength = dataLength <= 10 ? 10 : dataLength;
    return generateOrderbookData(orderbookData, dataShowedLength);
};
var calculateSummary = function() {
    var priceData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var totalLots = priceData.reduce(function(obj, curr) {
        return {
            bid: obj.bid + Number(curr.bidLot),
            offer: obj.offer + Number(curr.offerLot),
            bidFrequency: obj.bidFrequency + Number(curr.bidFrequency),
            offerFrequency: obj.offerFrequency + Number(curr.offerFrequency)
        };
    }, {
        bid: 0,
        offer: 0,
        bidFrequency: 0,
        offerFrequency: 0
    });
    return {
        bid: numeral_default()(totalLots.bid).format("0,0"),
        offer: numeral_default()(totalLots.offer).format("0,0"),
        bidFrequency: numeral_default()(totalLots.bidFrequency).format("0,0"),
        offerFrequency: numeral_default()(totalLots.offerFrequency).format("0,0")
    };
};
var checkShouldTableHide = function() {
    var orderbookData = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var symbol = orderbookData.symbol;
    var ref = getBidOfferPrice(orderbookData), bidPrice = ref.bidPrice, offerPrice = ref.offerPrice;
    var isIHSG = symbol === "IHSG";
    var isBidOfferNotExist = bidPrice.length === 0 && offerPrice.length === 0;
    var isHideTable = isIHSG || isBidOfferNotExist;
    return {
        isHideTable: isHideTable,
        isIHSG: isIHSG
    };
};
var formatLot = function(value) {
    var result = parseCountAbbrv2(value, 1);
    if (typeof result === "number") {
        return result.toString();
    }
    return result;
};
var isTensOfMillions = function(value) {
    return value.length > 9;
};
var generateColumnGroup = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                style: {
                    width: "40px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                style: {
                    width: "66.5px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                style: {
                    width: "50px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                style: {
                    width: "50px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                style: {
                    width: "66.5px"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                style: {
                    width: "40px"
                }
            })
        ]
    });
};
var getShowIepIev = function(showIepIev, timeLeft) {
    return showIepIev && (timeLeft !== undefined ? timeLeft > 0 : true);
};



/***/ }),

/***/ 40892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dj": function() { return /* reexport */ Icons_ChevronRightSvg; },
  "V3": function() { return /* reexport */ Icons_DropDownSvg; },
  "iD": function() { return /* reexport */ Icons_LightningBoxSvg; },
  "SY": function() { return /* reexport */ Icons_LightningFilledSvg; },
  "Sf": function() { return /* reexport */ Icons_LightningSvg; },
  "bC": function() { return /* reexport */ Icons_TimerClockSvg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningSvg.tsx

var LightningSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_1561_100863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5 1.25L6.75 5L9.75 6.125L4.5 11.75L5.25 8L2.25 6.875L7.5 1.25Z",
                    stroke: fill,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1561_100863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningSvg = (LightningSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningFilledSvg.tsx

var LightningFilledSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_118194)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.5 1L5 3.5L7 4.25L3.5 8L4 5.5L2 4.75L5.5 1Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_118194",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningFilledSvg = (LightningFilledSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/LightningBoxSvg.tsx

var LightningBoxSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#8277F8" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "1",
                y: "0.5",
                width: "17",
                height: "15",
                rx: "1.5",
                stroke: fill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4016_142863)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.75 3.625L10.125 6.75L12.625 7.6875L8.25 12.375L8.875 9.25L6.375 8.3125L10.75 3.625Z",
                    fill: fill
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4016_142863",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white",
                        transform: "translate(4.5 3)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_LightningBoxSvg = (LightningBoxSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/ChevronRightSvg.tsx

var ChevronRightSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_4007_110905)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M3.51562 8.70331L7.21933 4.9996L3.51562 1.2959",
                    stroke: "#969696",
                    strokeOpacity: "0.6",
                    strokeWidth: "1.25",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_4007_110905",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "10",
                        height: "10",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ChevronRightSvg = (ChevronRightSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/DropDownSvg.tsx

var DropDownSvg = function(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#00AB6B" : _fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4.5 6L8.5 10L12.5 6",
            stroke: fill,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var Icons_DropDownSvg = (DropDownSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/TimerClockSvg.tsx

var TimerClockSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "6.00156",
                cy: "6.7252",
                r: "3.775",
                stroke: "#8277F8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 4.5874V6.9624L7.1875 7.9124",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "1.60934",
                y1: "2.90025",
                x2: "3.457",
                y2: "1.42212",
                stroke: "#8277F8",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "0.5",
                y1: "-0.5",
                x2: "2.86616",
                y2: "-0.5",
                transform: "matrix(-0.780869 -0.624695 -0.624695 0.780869 10.4688 3.60303)",
                stroke: "#8277F8",
                strokeLinecap: "round"
            })
        ]
    });
};
/* harmony default export */ var Icons_TimerClockSvg = (TimerClockSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/components/Icons/index.ts









/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S$": function() { return /* reexport */ confirmation; },
  "J7": function() { return /* reexport */ debt_ratio; },
  "g0": function() { return /* reexport */ PaymentLeverage_leverage; },
  "B7": function() { return /* reexport */ onboarding; },
  "md": function() { return /* reexport */ terms_conditions; },
  "TI": function() { return /* reexport */ DayTradeUnavailable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 2 modules
var BaseSecuritiesModal = __webpack_require__(93400);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/Onboarding/onboarding.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px 40px 40px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 32px;\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  margin: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #00ab6b;\n  color: #00ab6b;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-13f62da7-0"
})(_templateObject());
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-13f62da7-1"
})(_templateObject1());
var Title = styled_components_browser_esm["default"].h1.withConfig({
    componentId: "sc-13f62da7-2"
})(_templateObject2());
var Description = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-13f62da7-3"
})(_templateObject3());
var ActionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-13f62da7-4"
})(_templateObject4());
var NextButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-13f62da7-5"
})(_templateObject5());
var CancelButton = (0,styled_components_browser_esm["default"])(NextButton).withConfig({
    componentId: "sc-13f62da7-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/Onboarding/onboarding.tsx









var DayTradeOnboarding = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var handleSubmit = function() {
        onSubmit();
        (0,securities/* clevertapDayTradeActivationSelected */.lH)();
    };
    var handleCancel = function(e) {
        onCancel(e);
        (0,securities/* clevertapDayTradeActivationDismissed */.HR)();
    };
    (0,react.useEffect)(function() {
        (0,securities/* clevertapDayTradeActivationViewed */.V8)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/day-trade/onboarding.svg",
                    alt: "Day Trade Onboarding"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Day Trade"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            children: "Tingkatkan daya beli hingga 5 kali lipat trading balance kamu dengan fitur Day Trade."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            children: "Aktifkan Sekarang"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                            onClick: handleCancel,
                            children: "Nanti Aja"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var onboarding = (DayTradeOnboarding);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts + 1 modules
var useTermsAndConditionStore = __webpack_require__(49365);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingAcceptTnC/terms-condition.styled.ts

function terms_condition_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  min-height: 408px;\n"
    ]);
    terms_condition_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  gap: 8px;\n"
    ]);
    terms_condition_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    terms_condition_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    terms_condition_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 408px;\n"
    ]);
    terms_condition_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n\n  & span {\n    color: #00ab6b;\n    font-weight: 700;\n    cursor: pointer;\n  }\n"
    ]);
    terms_condition_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function terms_condition_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0 0;\n"
    ]);
    terms_condition_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n\n  &:disabled {\n    background-color: #cceee1 !important;\n    color: #ffffff !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var terms_condition_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4a5778e9-0"
})(terms_condition_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4a5778e9-1"
})(terms_condition_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-4a5778e9-2"
})(terms_condition_styled_templateObject2());
var TnCFrameWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4a5778e9-3"
})(terms_condition_styled_templateObject3());
var TnCFrame = styled_components_browser_esm["default"].iframe.withConfig({
    componentId: "sc-4a5778e9-4"
})(terms_condition_styled_templateObject4());
var AgreementTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4a5778e9-5"
})(terms_condition_styled_templateObject5());
var terms_condition_styled_ActionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4a5778e9-6"
})(terms_condition_styled_templateObject6());
var terms_condition_styled_NextButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-4a5778e9-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingAcceptTnC/terms-conditions.tsx















var TITLE = "Syarat & Ketentuan Day Trade dan Trading Limit";
var DayTradeTncModal = function(_param) {
    var _title = _param.title, title = _title === void 0 ? TITLE : _title, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "onSubmit",
        "onCancel"
    ]);
    var ref = (0,react.useState)(false), tncAgreed = ref[0], setTncAgreed = ref[1];
    var ref1 = (0,react.useState)(""), tncUrl = ref1[0], setTncUrl = ref1[1];
    var isSubmitting = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.isSubmitting;
    });
    var termsData = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.termsData;
    });
    var postAcceptances = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.postAcceptances;
    });
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var FEATURE_ID = termsAndCondition/* TnCFeaturesIDEnum.DAY_TRADE */.el.DAY_TRADE;
    var terms = termsData === null || termsData === void 0 ? void 0 : termsData[FEATURE_ID];
    var isButtonDisabled = !tncAgreed || isSubmitting;
    var handleCheckboxChange = function(event) {
        setTncAgreed(event.target.checked);
    };
    var handleTncSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var acceptanceLetters;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (tncAgreed) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        acceptanceLetters = Object.keys(termsData).map(function(key) {
                            return {
                                feature_id: key,
                                is_accepted: true,
                                version: termsData[key].version
                            };
                        });
                        _ctx.next = 5;
                        return postAcceptances(acceptanceLetters).then(function(data) {
                            if (data) {
                                setUIValue("dayTradeTnc", true);
                                setUIValue("dayTradeSubAccountActive", true);
                                onSubmit();
                            }
                        });
                    case 5:
                        (0,securities/* clevertapDayTradeActivationSubmitted */.pl)();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTncSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleScrollTo = function(target) {
        var cleanUrl = tncUrl.split("#")[0];
        setTncUrl("".concat(cleanUrl, "#"));
        setTimeout(function() {
            setTncUrl("".concat(cleanUrl, "#").concat(target));
        });
    };
    var handleClickDayTrade = function() {
        handleScrollTo("tnc-day-trade");
    };
    var handleClickTradingLimit = function() {
        handleScrollTo("tnc-trading-limit");
    };
    var renderClickableText = function(text, onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            onClick: onClick,
            "aria-hidden": true,
            children: text
        });
    };
    (0,react.useEffect)(function() {
        if (terms === null || terms === void 0 ? void 0 : terms.url) {
            setTncUrl(terms.url);
        }
    }, [
        terms,
        setTncUrl
    ]);
    (0,react.useEffect)(function() {
        (0,securities/* clevertapDayTradeTNCViewed */.C5)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        onCancel: onCancel
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(terms_condition_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrameWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: tncUrl,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                            title: "day-trade-tnc",
                            src: tncUrl,
                            id: "tnc-frame"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            onChange: handleCheckboxChange
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementTextWrapper, {
                            children: [
                                "Saya menyetujui Syarat & Ketentuan Penggunaan",
                                " ",
                                renderClickableText("Day Trade", handleClickDayTrade),
                                " dan",
                                " ",
                                renderClickableText("Trading Limit", handleClickTradingLimit),
                                " di atas."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_condition_styled_ActionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_condition_styled_NextButton, {
                        onClick: handleTncSubmit,
                        type: "primary",
                        disabled: isButtonDisabled,
                        loading: isSubmitting,
                        children: "Lanjut"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var terms_conditions = (DayTradeTncModal);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingConfirmation/confirmation.styled.ts

function confirmation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    confirmation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n  padding: 0 16px 16px;\n"
    ]);
    confirmation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    confirmation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  margin: 0;\n  width: 70%;\n\n  span svg {\n    margin-top: -2px;\n    color: #8277f8;\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    confirmation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n"
    ]);
    confirmation_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function confirmation_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n"
    ]);
    confirmation_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var confirmation_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-be749860-0"
})(confirmation_styled_templateObject());
var confirmation_styled_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-be749860-1"
})(confirmation_styled_templateObject1());
var confirmation_styled_Title = styled_components_browser_esm["default"].h1.withConfig({
    componentId: "sc-be749860-2"
})(confirmation_styled_templateObject2());
var confirmation_styled_Description = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-be749860-3"
})(confirmation_styled_templateObject3());
var confirmation_styled_ActionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-be749860-4"
})(confirmation_styled_templateObject4());
var FinishButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-be749860-5"
})(confirmation_styled_templateObject5());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OnboardingConfirmation/confirmation.tsx











var DayTradeConfirmation = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var handleSubmit = function() {
        onSubmit();
        (0,securities/* clevertapDayTradeActivationSuccessSelected */.p)();
    };
    (0,react.useEffect)(function() {
        (0,securities/* clevertapDayTradeActivationSuccessViewed */.xs)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        closable: false,
        modalWidth: 415,
        onCancel: onCancel,
        hideSubmit: true
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(confirmation_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(confirmation_styled_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/day-trade/confirmation-success.svg",
                            alt: "Day Trade Success",
                            height: "120",
                            width: "160"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_styled_Title, {
                            children: "Day Trade Berhasil Diaktifkan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(confirmation_styled_Description, {
                            children: [
                                "Kamu sudah bisa melakukan Day Trade di semua saham yang memiliki simbol",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: Icons/* LightningBoxSvg */.iD
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(confirmation_styled_ActionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishButton, {
                        onClick: handleSubmit,
                        type: "primary",
                        children: "Selesai"
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var confirmation = (DayTradeConfirmation);

// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts + 1 modules
var useTradingInfoStore = __webpack_require__(21734);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/features/day-trade/utils/formater.ts
var formater = __webpack_require__(22733);
// EXTERNAL MODULE: ./src/features/day-trade/utils/common.ts
var common = __webpack_require__(99533);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OrderUnavailable/unavailable.styled.ts

function unavailable_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  gap: 20px;\n"
    ]);
    unavailable_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function unavailable_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  width: 90%;\n  margin: 0;\n"
    ]);
    unavailable_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function unavailable_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    unavailable_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function unavailable_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n"
    ]);
    unavailable_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var unavailable_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4acb3710-0"
})(unavailable_styled_templateObject());
var unavailable_styled_Description = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-4acb3710-1"
})(unavailable_styled_templateObject1());
var unavailable_styled_ActionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4acb3710-2"
})(unavailable_styled_templateObject2());
var ConfirmButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-4acb3710-3"
})(unavailable_styled_templateObject3());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/OrderUnavailable/unavailable.tsx















function DayTradeUnavailable(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.dayTrade;
    }), eventType = ref.event_type, tradingOpen = ref.trading_open, tradingClose = ref.trading_close;
    var orderType = (0,store/* default */.Z)().orderType;
    var SELL = trading/* ORDER_TYPE.SELL */.Jm.SELL, AMEND_SELL = trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isTimeLimit = eventType === types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.b.OUTSIDE_MARKET_HOURS;
    var isSellOrder = orderType === SELL || orderType === AMEND_SELL;
    var isSellAmend = orderType === AMEND_SELL;
    var formattedTime = (0,formater/* formatHourMinutes */.d7)(tradingOpen, tradingClose).openClose;
    var imageUrl = isTimeLimit ? "time-limit" : "force-selling";
    var unavailableReason = (0,common/* getUnavailableReason */.bs)(isTimeLimit, isSellOrder, isSellAmend, formattedTime);
    var handleSubmit = function() {
        onSubmit();
        if (!isTimeLimit || isSellAmend) {
            (0,securities/* clevertapDayTradeDebtRatioSubmitted */.SW)();
        }
    };
    (0,react.useEffect)(function() {
        if (isTimeLimit && !isSellAmend) {
            (0,securities/* clevertapDayTradeAfterMarketViewed */.jS)();
        } else {
            (0,securities/* clevertapDayTradeDebtRatioViewed */.L)();
        }
    }, [
        isTimeLimit,
        isSellAmend
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onCancel: onCancel,
        hideSubmit: true,
        closable: false,
        modalWidth: 415
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(unavailable_styled_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/day-trade/unavailable-".concat(imageUrl, ".svg"),
                    alt: "Day Trade Unavailable",
                    height: 120
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(unavailable_styled_Description, {
                    children: unavailableReason
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(unavailable_styled_ActionWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                        onClick: handleSubmit,
                        type: "primary",
                        children: "Oke"
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/global/Securities/components/Radio/index.ts

function Radio_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-radio-inner::after {\n    top: 50%;\n    left: 50%;\n    width: 11px;\n    height: 11px;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    Radio_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Radio = (0,styled_components_browser_esm["default"])(es_radio/* default */.ZP).withConfig({
    componentId: "sc-2997eda8-0"
})(Radio_templateObject());
/* harmony default export */ var components_Radio = (Radio);

// EXTERNAL MODULE: ./src/global/Securities/components/Chips/index.tsx
var Chips = __webpack_require__(17348);
// EXTERNAL MODULE: ./src/global/Securities/components/SkeletonWrapper/index.tsx
var SkeletonWrapper = __webpack_require__(27607);
;// CONCATENATED MODULE: ./src/global/Securities/components/Icons/ReloadSvg.tsx

var ReloadSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 12 13",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M9.967 7.02a4 4 0 11-4.963-4.393c1.95-.5 3.968.503 4.713 2.373"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                stroke: "#00AB6B",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                d: "M10 2.5V5H7.5"
            })
        ]
    });
};
/* harmony default export */ var Icons_ReloadSvg = (ReloadSvg);

;// CONCATENATED MODULE: ./src/features/day-trade/constants/leverage.ts
var TRADING_LIMIT = {
    description: "Kamu bisa menyimpan posisi leverage maksimal hingga T+3 setelah tanggal transaksi. Biaya harian sebesar 0,20% akan berlaku mulai dari T+3. Aturan Forced Sell akan diberlakukan pada T+4."
};
var DAY_TRADE = {
    description: "Kamu harus menjual semua posisi day trade pada pukul %CLOSE_TIME% WIB di hari trading yang sama. Tidak ada biaya tambahan berlaku."
};
var DAY_TRADE_UNAVAILBALE_REASON = {
    OUTSIDE_MARKET_HOURS: "Pembelian saham-saham Day Trade dapat dilakukan di hari bursa sampai pukul %CLOSE_TIME% WIB. Day Trade akan tersedia kembali pada hari bursa mulai pukul %OPEN_TIME% WIB.",
    EXCEED_DEBT_RATIO: "Debt Ratio kamu sudah mencapai limit. Silakan melakukan penjualan aset atau menunggu hingga proses forced sell selesai.",
    MAX_DEBT_LIMIT: "Kamu sudah menggunakan seluruh kuota Day Trade kamu. Jual sebagian saham kamu untuk menggunakan Day Trade kembali",
    ZERO_BALANCE: "Saldo kamu tidak mencukupi untuk melakukan pembelian dengan menggunakan Day Trade."
};
/* harmony default export */ var leverage = ({
    TRADING_LIMIT: TRADING_LIMIT,
    DAY_TRADE: DAY_TRADE,
    DAY_TRADE_UNAVAILBALE_REASON: DAY_TRADE_UNAVAILBALE_REASON
});

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Securities/stores/useCashInfoStore.ts
var useCashInfoStore = __webpack_require__(11806);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./src/features/search/styled.ts
var styled = __webpack_require__(14348);
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/PaymentLeverage/leverage.styled.ts

function leverage_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: #333333;\n  margin: 0 0 20px;\n"
    ]);
    leverage_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 16px 20px;\n  gap: 16px;\n\n  & > button {\n    padding: 16px;\n    border: 1px solid #f1f1f1;\n    border-radius: 6px;\n    gap: 16px;\n  }\n"
    ]);
    leverage_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  text-align: left;\n  cursor: pointer;\n\n  & > .ant-radio-wrapper {\n    display: block;\n    margin: 0;\n  }\n\n  .activate-daytrade {\n    color: #00ab6b;\n  }\n\n  .disabled-daytrade {\n    color: #b5b5b5;\n  }\n\n  :disabled {\n    cursor: not-allowed;\n  }\n"
    ]);
    leverage_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n"
    ]);
    leverage_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    leverage_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-skeleton-button {\n    width: 100px;\n    height: 22px;\n  }\n"
    ]);
    leverage_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin: 0 0 4px;\n\n  & > div,\n  button {\n    margin-left: 8px;\n  }\n\n  .multiplier-chip {\n    font-size: 14px;\n    line-height: 19px;\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 8px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    leverage_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n  color: #333333;\n\n  margin: 0;\n\n  ",
        "\n"
    ]);
    leverage_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  color: #969696;\n\n  margin: 0;\n  width: 88%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  max-width: 460px;\n  font-size: 14px;\n  color: #333333;\n  cursor: default;\n  gap: 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  span {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 10px 0;\n  width: 50%;\n  min-width: unset;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  padding: 0 6px;\n  border-radius: 8px;\n  border: 1px solid #f2f1fe;\n  height: 18px;\n  background-color: #f2f1fe;\n  color: #8277f8;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  .multiplier-chip {\n    font-size: 14px;\n    line-height: 19px;\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 8px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-skeleton-button {\n    width: 60px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span.ant-skeleton-button {\n    width: 100px;\n    height: 22px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var leverage_styled_Title = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-41b6b08-0"
})(leverage_styled_templateObject());
var MethodGroup = (0,styled_components_browser_esm["default"])(styled/* RadioGroup */.Ee).withConfig({
    componentId: "sc-41b6b08-1"
})(leverage_styled_templateObject1());
var MethodItem = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-41b6b08-2"
})(leverage_styled_templateObject2());
var MethodItemButton = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-3"
})(leverage_styled_templateObject3());
var MethodTextContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-4"
})(leverage_styled_templateObject4());
var MethodTitleSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-41b6b08-5"
})(leverage_styled_templateObject5());
var MethodTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-6"
})(leverage_styled_templateObject6());
var MethodTitle = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-41b6b08-7"
})(leverage_styled_templateObject7(), function(param) {
    var disabled = param.disabled;
    return disabled && "\n    color: #B5B5B5;\n  ";
});
var MethodDescription = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-41b6b08-8"
})(_templateObject8());
var ChipsButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-41b6b08-9"
})(_templateObject9());
var LeverageInfoWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-10"
})(_templateObject10());
var InfoRow = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-11"
})(_templateObject11(), function(param) {
    var isBold = param.isBold;
    return isBold ? "700" : "400";
});
var DividerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-12"
})(_templateObject12());
var RowDivider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-41b6b08-13"
})(_templateObject13());
var SymbolChip = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-14"
})(_templateObject14());
var BuyingPowerWording = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-41b6b08-15"
})(_templateObject15());
var ChipSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-41b6b08-16"
})(_templateObject16());
var PriceSkeleton = (0,styled_components_browser_esm["default"])(ChipSkeleton).withConfig({
    componentId: "sc-41b6b08-17"
})(_templateObject17());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/PaymentLeverage/leverage-info.tsx











var LeverageInfo = function(param) {
    var multiplier = param.multiplier;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCashInfoStore/* default */.Z)(function(s) {
        return [
            s.error,
            s.isLoading,
            s.dayTrade,
            s.dayTradeLeverage,
            s.dayTradeTradingBalance, 
        ];
    }, shallow/* default */.Z), 5), cashInfoError = ref[0], isCashInfoLoading = ref[1], dayTradeBuyingPower = ref[2], dayTradeLeverage = ref[3], dayTradeTradingBalance = ref[4];
    var getBalance = function(balance) {
        return "Rp".concat(numeral_default()(Math.floor(balance)).format("0,00"));
    };
    if (cashInfoError) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageInfoWrapper, {
        onClick: function(e) {
            return e.stopPropagation();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Trading Balance"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                            active: true
                        }),
                        loading: isCashInfoLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getBalance(dayTradeTradingBalance)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolChip, {
                        children: "+"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Leverage"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                            active: true
                        }),
                        loading: isCashInfoLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getBalance(dayTradeLeverage)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DividerWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolChip, {
                        children: "="
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RowDivider, {
                        dashed: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoRow, {
                isBold: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyingPowerWording, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Buying Power"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                                skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipSkeleton, {
                                    active: true
                                }),
                                loading: isCashInfoLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                    className: "multiplier-chip",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: Icons/* LightningSvg */.Sf
                                        }),
                                        "".concat(multiplier, "x")
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceSkeleton, {
                            active: true
                        }),
                        loading: isCashInfoLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getBalance(dayTradeBuyingPower)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var leverage_info = (/*#__PURE__*/(0,react.memo)(LeverageInfo));

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/PaymentLeverage/leverage.tsx
























var defaultMethodList = {
    TradingLimit: {
        title: "Trading Limit",
        description: leverage.TRADING_LIMIT.description
    },
    DayTrade: {
        title: "Day Trade",
        description: leverage.DAY_TRADE.description
    }
};
var _obj;
var defaultBalance = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, 0), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, 0), _obj);
var PaymentMethodModal = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Leverage" : _title, _balance = _param.balance, balance = _balance === void 0 ? defaultBalance : _balance, _methodList = _param.methodList, methodList = _methodList === void 0 ? defaultMethodList : _methodList, methodValue = _param.methodValue, defaultMethodValue = _param.defaultMethodValue, _tradingBalance = _param.tradingBalance, tradingBalance = _tradingBalance === void 0 ? 0 : _tradingBalance, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, _symbol = _param.symbol, symbol = _symbol === void 0 ? "" : _symbol, _error = _param.error, error = _error === void 0 ? {} : _error, _splitOrderActive = _param.splitOrderActive, splitOrderActive = _splitOrderActive === void 0 ? false : _splitOrderActive, _dayTradeAvailable = _param.dayTradeAvailable, dayTradeAvailable = _dayTradeAvailable === void 0 ? false : _dayTradeAvailable, _dayTradeMultiplier = _param.dayTradeMultiplier, dayTradeMultiplier = _dayTradeMultiplier === void 0 ? 0 : _dayTradeMultiplier, _onMethodChange = _param.onMethodChange, onMethodChange = _onMethodChange === void 0 ? function() {} : _onMethodChange, _onReloadClick = _param.onReloadClick, onReloadClick = _onReloadClick === void 0 ? function() {} : _onReloadClick, _onShowDayTradeOnboarding = _param.onShowDayTradeOnboarding, onShowDayTradeOnboarding = _onShowDayTradeOnboarding === void 0 ? function() {} : _onShowDayTradeOnboarding, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "balance",
        "methodList",
        "methodValue",
        "defaultMethodValue",
        "tradingBalance",
        "loading",
        "symbol",
        "error",
        "splitOrderActive",
        "dayTradeAvailable",
        "dayTradeMultiplier",
        "onMethodChange",
        "onReloadClick",
        "onShowDayTradeOnboarding"
    ]);
    var ref = (0,react.useState)(defaultMethodValue), selectedMethod = ref[0], setSelectedMethod = ref[1];
    var ref1 = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return {
            dayTrade: s.dayTrade,
            loadTradingInfo: s.loadTradingInfo
        };
    }), dayTrade = ref1.dayTrade, loadTradingInfo = ref1.loadTradingInfo;
    var ref2 = dayTrade || {}, eventType = ref2.event_type;
    var handleMethodClick = function(method) {
        if (loading || error[method]) return;
        setSelectedMethod(method);
        onMethodChange(method);
        (0,securities/* clevertapSetVisibleBalance */.ng)();
    };
    var handleReloadClick = function(event) {
        event.stopPropagation();
        onReloadClick();
    };
    var handleOpenDayTradeActivation = function() {
        onShowDayTradeOnboarding();
        (0,securities/* clevertapDayTradeLeverageActivationSelected */.oZ)();
    };
    var isDayTradeNotTradable = [
        types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.b.OUTSIDE_MARKET_HOURS,
        types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.b.EXCEED_DEBT_RATIO, 
    ].includes(eventType);
    var getChipButton = function(methodType) {
        var isDayTrade = methodType === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
        if (isDayTrade && (isDayTradeNotTradable || tradingBalance <= 0)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips/* default */.Z, {
                className: "disabled-daytrade",
                children: "Tidak Tersedia"
            });
        }
        var disabledChipsClassName = isDayTrade && balance[methodType] <= 0 ? "disabled-daytrade" : "";
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips/* default */.Z, {
            "data-cy": "".concat(methodType, "-balance"),
            className: disabledChipsClassName,
            children: "Rp".concat(numeral_default()(Math.floor(balance[methodType])).format("0,00"))
        });
    };
    var getDefaultDescription = function(description) {
        var isDayTrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (!isDayTrade) return description;
        var hourMinute = (0,formater/* formatHourMinutes */.d7)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_open, dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_close);
        return (0,formater/* replaceWords */.Wn)(description, [
            "%CLOSE_TIME%"
        ], [
            hourMinute.close
        ]);
    };
    var getDayTradeDescription = function(daytradeBalance) {
        if (tradingBalance <= 0) {
            return leverage.DAY_TRADE_UNAVAILBALE_REASON.ZERO_BALANCE;
        }
        if (eventType === types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.b.OUTSIDE_MARKET_HOURS) {
            var hourMinute = (0,formater/* formatHourMinutes */.d7)(dayTrade.trading_open, dayTrade.trading_close);
            return (0,formater/* replaceWords */.Wn)(leverage.DAY_TRADE_UNAVAILBALE_REASON.OUTSIDE_MARKET_HOURS, [
                "%CLOSE_TIME%",
                "%OPEN_TIME%"
            ], [
                hourMinute.close,
                hourMinute.open
            ]);
        }
        if (eventType === types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.b.EXCEED_DEBT_RATIO) {
            return leverage.DAY_TRADE_UNAVAILBALE_REASON.EXCEED_DEBT_RATIO;
        }
        if (daytradeBalance <= 0) {
            return leverage.DAY_TRADE_UNAVAILBALE_REASON.MAX_DEBT_LIMIT;
        }
        return getDefaultDescription(defaultMethodList.DayTrade.description);
    };
    // Only get trading info if day trade is available
    (0,react.useEffect)(function() {
        if (dayTradeAvailable && props.visible) {
            loadTradingInfo([
                types_trading/* TradingFeatureEnum.DAY_TRADE */.n.DAY_TRADE
            ]);
        }
    }, [
        dayTradeAvailable,
        props.visible,
        loadTradingInfo
    ]);
    (0,react.useEffect)(function() {
        if (props.visible) (0,securities/* clevertapDayTradeLeverageOptionViewed */.Nf)();
    }, [
        props.visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        hideSubmit: true
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodGroup, {
            value: methodValue || selectedMethod,
            children: Object.entries(methodList).map(function(param) {
                var _$_param = (0,_sliced_to_array/* default */.Z)(param, 2), methodType = _$_param[0], methodConfig = _$_param[1];
                if (balance[methodType] === undefined) return null;
                var isErrorOrLoading = loading || error[methodType];
                var isDayTrade = methodType === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
                var isDayTradeAvailable = isDayTrade && dayTradeAvailable;
                var isDayTradeNotAvailable = isDayTrade && !dayTradeAvailable;
                var isDayTradeSplitOrderActive = isDayTrade && splitOrderActive;
                var isDayTradeExceedLimit = isDayTrade && balance[methodType] <= 0;
                var isDayTradeExceedLimitAndNotAvailable = isDayTrade && eventType === types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.b.EXCEED_DEBT_RATIO;
                var isDayTradeOutsideMarketHours = isDayTrade && eventType === types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.b.OUTSIDE_MARKET_HOURS;
                var isDisabledSelect = isErrorOrLoading || isDayTradeNotAvailable || isDayTradeSplitOrderActive || isDayTradeExceedLimit || isDayTradeExceedLimitAndNotAvailable || isDayTradeOutsideMarketHours;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodItem, {
                    "data-cy": "".concat(methodType, "-button"),
                    onClick: function() {
                        if (isDayTradeNotAvailable || isErrorOrLoading) {
                            return;
                        }
                        handleMethodClick(methodType);
                    },
                    disabled: isDisabledSelect && dayTradeAvailable,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodItemButton, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodTextContent, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MethodTitleWrapper, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodTitle, {
                                                    disabled: isDisabledSelect && dayTradeAvailable,
                                                    children: methodConfig.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                                    condition: isDayTrade && dayTradeMultiplier > 0 && (!isDisabledSelect || !isDayTradeAvailable),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                                        "data-cy": "day-trade-multiplier",
                                                        className: "multiplier-chip",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                component: Icons/* LightningSvg */.Sf
                                                            }),
                                                            "".concat(dayTradeMultiplier, "x")
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
                                                    skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodTitleSkeleton, {
                                                        active: true
                                                    }),
                                                    loading: loading,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                                        condition: !isDayTrade || isDayTradeAvailable,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                                            condition: error[methodType] && !isDayTrade,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChipsButton, {
                                                                    onClick: handleReloadClick,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                                                        style: {
                                                                            color: "#00AB6B"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                                component: Icons_ReloadSvg,
                                                                                style: {
                                                                                    marginRight: 4
                                                                                }
                                                                            }),
                                                                            "Muat Ulang"
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                                    children: getChipButton(methodType)
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodDescription, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                                condition: isDayTradeNotAvailable,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            "Gunakan Day Trade dan dapatkan tambahan",
                                                            " ",
                                                            dayTradeMultiplier,
                                                            "x Buying Power saham ",
                                                            symbol,
                                                            "."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                                            condition: !isDisabledSelect,
                                                            children: [
                                                                getDefaultDescription(methodConfig.description, isDayTrade),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                                                    children: getDayTradeDescription(balance[methodType])
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Common_If/* default */.Z, {
                                    condition: isDayTradeNotAvailable && !dayTradeAvailable,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Chips/* default */.Z, {
                                            className: "activate-daytrade",
                                            onClick: handleOpenDayTradeActivation,
                                            children: "Aktifkan"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default.Else */.Z.Else, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Radio, {
                                                value: methodType,
                                                disabled: isDisabledSelect
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                            condition: isDayTrade && isDayTradeAvailable && !isDayTradeNotTradable && balance[methodType] > 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(leverage_info, {
                                multiplier: dayTradeMultiplier
                            })
                        })
                    ]
                }, methodType);
            })
        })
    }));
};
/* harmony default export */ var PaymentLeverage_leverage = (PaymentMethodModal);

// EXTERNAL MODULE: ./node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(11248);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
;// CONCATENATED MODULE: ./public/animation/speedo-portfolio.json
var speedo_portfolio_namespaceObject = JSON.parse('{"v":"5.9.6","fr":50,"ip":0,"op":150,"w":1230,"h":615,"nm":"Speedo","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Ellipse 1350 (Stroke)","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[615,313,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-0.157,0],[-0.157,-0.001],[0,0],[0.168,0],[0.168,-0.001]],"o":[[0.157,-0.001],[0.157,0],[0,0],[-0.168,-0.001],[-0.168,0],[0,0]],"v":[[-0.472,-52.999],[0,-53],[0.472,-52.999],[0.505,-60.999],[0,-61],[-0.505,-60.999]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[-0.314,0.012],[0,0],[0.336,-0.015]],"o":[[0.314,-0.014],[0,0],[-0.336,0.012],[0,0]],"v":[[-5.182,-52.882],[-4.241,-52.921],[-4.538,-60.916],[-5.546,-60.874]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[-0.314,-0.014],[0,0],[0.336,0.012]],"o":[[0.314,0.012],[0,0],[-0.336,-0.015],[0,0]],"v":[[4.241,-52.921],[5.182,-52.882],[5.546,-60.874],[4.538,-60.916]],"c":true},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":0,"k":{"i":[[0,0],[-0.313,0.025],[0,0],[0.335,-0.029]],"o":[[0.313,-0.027],[0,0],[-0.335,0.026],[0,0]],"v":[[-9.884,-52.571],[-8.945,-52.649],[-9.572,-60.624],[-10.578,-60.541]],"c":true},"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ind":4,"ty":"sh","ix":5,"ks":{"a":0,"k":{"i":[[0,0],[-0.313,-0.027],[0,0],[0.335,0.026]],"o":[[0.313,0.025],[0,0],[-0.335,-0.029],[0,0]],"v":[[8.945,-52.649],[9.884,-52.571],[10.578,-60.541],[9.572,-60.624]],"c":true},"ix":2},"nm":"Path 5","mn":"ADBE Vector Shape - Group","hd":false},{"ind":5,"ty":"sh","ix":6,"ks":{"a":0,"k":{"i":[[0,0],[-0.312,0.038],[0,0],[0.333,-0.043]],"o":[[0.312,-0.04],[0,0],[-0.334,0.04],[0,0]],"v":[[-14.569,-52.066],[-13.634,-52.182],[-14.59,-60.125],[-15.591,-60]],"c":true},"ix":2},"nm":"Path 6","mn":"ADBE Vector Shape - Group","hd":false},{"ind":6,"ty":"sh","ix":7,"ks":{"a":0,"k":{"i":[[0,0],[-0.311,-0.04],[0,0],[0.334,0.04]],"o":[[0.312,0.038],[0,0],[-0.333,-0.043],[0,0]],"v":[[13.634,-52.182],[14.569,-52.066],[15.591,-60],[14.59,-60.125]],"c":true},"ix":2},"nm":"Path 7","mn":"ADBE Vector Shape - Group","hd":false},{"ind":7,"ty":"sh","ix":8,"ks":{"a":0,"k":{"i":[[0,0],[-0.31,0.05],[0,0],[0.331,-0.057]],"o":[[0.31,-0.053],[0,0],[-0.332,0.054],[0,0]],"v":[[-19.229,-51.367],[-18.299,-51.522],[-19.584,-59.418],[-20.578,-59.253]],"c":true},"ix":2},"nm":"Path 8","mn":"ADBE Vector Shape - Group","hd":false},{"ind":8,"ty":"sh","ix":9,"ks":{"a":0,"k":{"i":[[0,0],[-0.309,-0.053],[0,0],[0.332,0.054]],"o":[[0.31,0.05],[0,0],[-0.331,-0.057],[0,0]],"v":[[18.299,-51.522],[19.229,-51.367],[20.578,-59.253],[19.584,-59.418]],"c":true},"ix":2},"nm":"Path 9","mn":"ADBE Vector Shape - Group","hd":false},{"ind":9,"ty":"sh","ix":10,"ks":{"a":0,"k":{"i":[[0,0],[-0.308,0.063],[0,0],[0.329,-0.07]],"o":[[0.307,-0.066],[0,0],[-0.329,0.068],[0,0]],"v":[[-23.856,-50.476],[-22.933,-50.67],[-24.543,-58.506],[-25.53,-58.299]],"c":true},"ix":2},"nm":"Path 10","mn":"ADBE Vector Shape - Group","hd":false},{"ind":10,"ty":"sh","ix":11,"ks":{"a":0,"k":{"i":[[0,0],[-0.307,-0.066],[0,0],[0.329,0.068]],"o":[[0.308,0.063],[0,0],[-0.329,-0.07],[0,0]],"v":[[22.933,-50.67],[23.856,-50.476],[25.53,-58.299],[24.543,-58.506]],"c":true},"ix":2},"nm":"Path 11","mn":"ADBE Vector Shape - Group","hd":false},{"ind":11,"ty":"sh","ix":12,"ks":{"a":0,"k":{"i":[[0,0],[-0.305,0.076],[0,0],[0.326,-0.084]],"o":[[0.304,-0.078],[0,0],[-0.326,0.081],[0,0]],"v":[[-28.442,-49.395],[-27.528,-49.627],[-29.46,-57.39],[-30.438,-57.142]],"c":true},"ix":2},"nm":"Path 12","mn":"ADBE Vector Shape - Group","hd":false},{"ind":12,"ty":"sh","ix":13,"ks":{"a":0,"k":{"i":[[0,0],[-0.304,-0.078],[0,0],[0.326,0.081]],"o":[[0.305,0.076],[0,0],[-0.326,-0.084],[0,0]],"v":[[27.528,-49.627],[28.442,-49.395],[30.438,-57.142],[29.46,-57.39]],"c":true},"ix":2},"nm":"Path 13","mn":"ADBE Vector Shape - Group","hd":false},{"ind":13,"ty":"sh","ix":14,"ks":{"a":0,"k":{"i":[[0,0],[-0.301,0.088],[0,0],[0.322,-0.097]],"o":[[0.301,-0.091],[0,0],[-0.323,0.095],[0,0]],"v":[[-32.98,-48.126],[-32.077,-48.394],[-34.328,-56.071],[-35.294,-55.783]],"c":true},"ix":2},"nm":"Path 14","mn":"ADBE Vector Shape - Group","hd":false},{"ind":14,"ty":"sh","ix":15,"ks":{"a":0,"k":{"i":[[0,0],[-0.301,-0.091],[0,0],[0.323,0.095]],"o":[[0.301,0.088],[0,0],[-0.322,-0.097],[0,0]],"v":[[32.077,-48.394],[32.98,-48.126],[35.294,-55.783],[34.328,-56.071]],"c":true},"ix":2},"nm":"Path 15","mn":"ADBE Vector Shape - Group","hd":false},{"ind":15,"ty":"sh","ix":16,"ks":{"a":0,"k":{"i":[[0,0],[-0.298,0.101],[0,0],[0.318,-0.11]],"o":[[0.297,-0.103],[0,0],[-0.318,0.108],[0,0]],"v":[[-37.461,-46.669],[-36.57,-46.975],[-39.136,-54.552],[-40.09,-54.225]],"c":true},"ix":2},"nm":"Path 16","mn":"ADBE Vector Shape - Group","hd":false},{"ind":16,"ty":"sh","ix":17,"ks":{"a":0,"k":{"i":[[0,0],[-0.297,-0.103],[0,0],[0.318,0.108]],"o":[[0.298,0.101],[0,0],[-0.318,-0.11],[0,0]],"v":[[36.57,-46.975],[37.461,-46.669],[40.09,-54.225],[39.136,-54.552]],"c":true},"ix":2},"nm":"Path 17","mn":"ADBE Vector Shape - Group","hd":false},{"ind":17,"ty":"sh","ix":18,"ks":{"a":0,"k":{"i":[[0,0],[-0.293,0.113],[0,0],[0.313,-0.124]],"o":[[0.292,-0.115],[0,0],[-0.314,0.121],[0,0]],"v":[[-41.879,-45.029],[-41.001,-45.372],[-43.878,-52.836],[-44.817,-52.47]],"c":true},"ix":2},"nm":"Path 18","mn":"ADBE Vector Shape - Group","hd":false},{"ind":18,"ty":"sh","ix":19,"ks":{"a":0,"k":{"i":[[0,0],[-0.292,-0.115],[0,0],[0.314,0.121]],"o":[[0.293,0.113],[0,0],[-0.313,-0.124],[0,0]],"v":[[41.001,-45.372],[41.879,-45.029],[44.817,-52.47],[43.878,-52.836]],"c":true},"ix":2},"nm":"Path 19","mn":"ADBE Vector Shape - Group","hd":false},{"ind":19,"ty":"sh","ix":20,"ks":{"a":0,"k":{"i":[[0,0],[-0.288,0.125],[0,0],[0.307,-0.136]],"o":[[0.287,-0.127],[0,0],[-0.308,0.134],[0,0]],"v":[[-46.224,-43.208],[-45.361,-43.587],[-48.545,-50.926],[-49.468,-50.521]],"c":true},"ix":2},"nm":"Path 20","mn":"ADBE Vector Shape - Group","hd":false},{"ind":20,"ty":"sh","ix":21,"ks":{"a":0,"k":{"i":[[0,0],[-0.287,-0.127],[0,0],[0.308,0.134]],"o":[[0.288,0.125],[0,0],[-0.307,-0.136],[0,0]],"v":[[45.361,-43.587],[46.224,-43.208],[49.468,-50.521],[48.545,-50.926]],"c":true},"ix":2},"nm":"Path 21","mn":"ADBE Vector Shape - Group","hd":false},{"ind":21,"ty":"sh","ix":22,"ks":{"a":0,"k":{"i":[[0,0],[-0.283,0.137],[0,0],[0.301,-0.149]],"o":[[0.282,-0.139],[0,0],[-0.303,0.146],[0,0]],"v":[[-50.491,-41.209],[-49.645,-41.623],[-53.128,-48.824],[-54.034,-48.381]],"c":true},"ix":2},"nm":"Path 22","mn":"ADBE Vector Shape - Group","hd":false},{"ind":22,"ty":"sh","ix":23,"ks":{"a":0,"k":{"i":[[0,0],[-0.282,-0.139],[0,0],[0.303,0.146]],"o":[[0.283,0.137],[0,0],[-0.301,-0.149],[0,0]],"v":[[49.645,-41.623],[50.491,-41.209],[54.034,-48.381],[53.128,-48.824]],"c":true},"ix":2},"nm":"Path 23","mn":"ADBE Vector Shape - Group","hd":false},{"ind":23,"ty":"sh","ix":24,"ks":{"a":0,"k":{"i":[[0,0],[-0.277,0.148],[0,0],[0.295,-0.161]],"o":[[0.276,-0.151],[0,0],[-0.296,0.159],[0,0]],"v":[[-54.672,-39.035],[-53.843,-39.484],[-57.622,-46.535],[-58.508,-46.055]],"c":true},"ix":2},"nm":"Path 24","mn":"ADBE Vector Shape - Group","hd":false},{"ind":24,"ty":"sh","ix":25,"ks":{"a":0,"k":{"i":[[0,0],[-0.276,-0.151],[0,0],[0.296,0.159]],"o":[[0.277,0.148],[0,0],[-0.295,-0.161],[0,0]],"v":[[53.843,-39.484],[54.672,-39.035],[58.508,-46.055],[57.622,-46.535]],"c":true},"ix":2},"nm":"Path 25","mn":"ADBE Vector Shape - Group","hd":false},{"ind":25,"ty":"sh","ix":26,"ks":{"a":0,"k":{"i":[[0,0],[-0.271,0.16],[0,0],[0.288,-0.173]],"o":[[0.269,-0.162],[0,0],[-0.29,0.171],[0,0]],"v":[[-58.759,-36.69],[-57.95,-37.173],[-62.016,-44.062],[-62.883,-43.546]],"c":true},"ix":2},"nm":"Path 26","mn":"ADBE Vector Shape - Group","hd":false},{"ind":26,"ty":"sh","ix":27,"ks":{"a":0,"k":{"i":[[0,0],[-0.269,-0.162],[0,0],[0.29,0.171]],"o":[[0.271,0.16],[0,0],[-0.288,-0.173],[0,0]],"v":[[57.95,-37.173],[58.759,-36.69],[62.883,-43.546],[62.016,-44.062]],"c":true},"ix":2},"nm":"Path 27","mn":"ADBE Vector Shape - Group","hd":false},{"ind":27,"ty":"sh","ix":28,"ks":{"a":0,"k":{"i":[[0,0],[-0.264,0.171],[0,0],[0.281,-0.185]],"o":[[0.262,-0.173],[0,0],[-0.282,0.183],[0,0]],"v":[[-62.746,-34.179],[-61.957,-34.694],[-66.305,-41.41],[-67.149,-40.858]],"c":true},"ix":2},"nm":"Path 28","mn":"ADBE Vector Shape - Group","hd":false},{"ind":28,"ty":"sh","ix":29,"ks":{"a":0,"k":{"i":[[0,0],[-0.262,-0.173],[0,0],[0.282,0.183]],"o":[[0.264,0.171],[0,0],[-0.281,-0.185],[0,0]],"v":[[61.957,-34.694],[62.746,-34.179],[67.149,-40.858],[66.305,-41.41]],"c":true},"ix":2},"nm":"Path 29","mn":"ADBE Vector Shape - Group","hd":false},{"ind":29,"ty":"sh","ix":30,"ks":{"a":0,"k":{"i":[[0,0],[-0.256,0.181],[0,0],[0.273,-0.196]],"o":[[0.255,-0.184],[0,0],[-0.274,0.194],[0,0]],"v":[[-66.626,-31.505],[-65.859,-32.052],[-70.48,-38.582],[-71.301,-37.996]],"c":true},"ix":2},"nm":"Path 30","mn":"ADBE Vector Shape - Group","hd":false},{"ind":30,"ty":"sh","ix":31,"ks":{"a":0,"k":{"i":[[0,0],[-0.255,-0.184],[0,0],[0.274,0.194]],"o":[[0.256,0.181],[0,0],[-0.273,-0.196],[0,0]],"v":[[65.859,-32.052],[66.626,-31.505],[71.301,-37.996],[70.48,-38.582]],"c":true},"ix":2},"nm":"Path 31","mn":"ADBE Vector Shape - Group","hd":false},{"ind":31,"ty":"sh","ix":32,"ks":{"a":0,"k":{"i":[[0,0],[-0.249,0.192],[0,0],[0.265,-0.208]],"o":[[0.247,-0.194],[0,0],[-0.266,0.205],[0,0]],"v":[[-70.391,-28.672],[-69.648,-29.251],[-74.535,-35.585],[-75.331,-34.965]],"c":true},"ix":2},"nm":"Path 32","mn":"ADBE Vector Shape - Group","hd":false},{"ind":32,"ty":"sh","ix":33,"ks":{"a":0,"k":{"i":[[0,0],[-0.247,-0.194],[0,0],[0.266,0.205]],"o":[[0.249,0.192],[0,0],[-0.265,-0.208],[0,0]],"v":[[69.648,-29.251],[70.391,-28.672],[75.331,-34.965],[74.535,-35.585]],"c":true},"ix":2},"nm":"Path 33","mn":"ADBE Vector Shape - Group","hd":false},{"ind":33,"ty":"sh","ix":34,"ks":{"a":0,"k":{"i":[[0,0],[-0.241,0.202],[0,0],[0.256,-0.218]],"o":[[0.239,-0.204],[0,0],[-0.257,0.216],[0,0]],"v":[[-74.037,-25.687],[-73.317,-26.296],[-78.463,-32.422],[-79.233,-31.77]],"c":true},"ix":2},"nm":"Path 34","mn":"ADBE Vector Shape - Group","hd":false},{"ind":34,"ty":"sh","ix":35,"ks":{"a":0,"k":{"i":[[0,0],[-0.239,-0.204],[0,0],[0.257,0.216]],"o":[[0.241,0.202],[0,0],[-0.256,-0.218],[0,0]],"v":[[73.317,-26.296],[74.037,-25.687],[79.233,-31.77],[78.463,-32.422]],"c":true},"ix":2},"nm":"Path 35","mn":"ADBE Vector Shape - Group","hd":false},{"ind":35,"ty":"sh","ix":36,"ks":{"a":0,"k":{"i":[[0,0],[-0.232,0.212],[0,0],[0.246,-0.229]],"o":[[0.23,-0.214],[0,0],[-0.248,0.227],[0,0]],"v":[[-77.555,-22.553],[-76.862,-23.191],[-82.256,-29.099],[-82.998,-28.417]],"c":true},"ix":2},"nm":"Path 36","mn":"ADBE Vector Shape - Group","hd":false},{"ind":36,"ty":"sh","ix":37,"ks":{"a":0,"k":{"i":[[0,0],[-0.23,-0.214],[0,0],[0.248,0.227]],"o":[[0.232,0.212],[0,0],[-0.246,-0.229],[0,0]],"v":[[76.862,-23.191],[77.556,-22.553],[82.998,-28.417],[82.256,-29.099]],"c":true},"ix":2},"nm":"Path 37","mn":"ADBE Vector Shape - Group","hd":false},{"ind":37,"ty":"sh","ix":38,"ks":{"a":0,"k":{"i":[[-0.111,0.111],[-0.112,0.111],[0,0],[0.119,-0.119],[0.118,-0.119],[0,0]],"o":[[0.111,-0.111],[0,0],[-0.119,0.118],[-0.119,0.119],[0,0],[0.111,-0.112]],"v":[[-80.61,-19.61],[-80.276,-19.943],[-85.909,-25.623],[-86.267,-25.267],[-86.623,-24.909],[-80.943,-19.276]],"c":true},"ix":2},"nm":"Path 38","mn":"ADBE Vector Shape - Group","hd":false},{"ind":38,"ty":"sh","ix":39,"ks":{"a":0,"k":{"i":[[0,0],[-0.111,-0.111],[-0.111,-0.112],[0,0],[0.119,0.119],[0.051,0.05],[0.069,0.068]],"o":[[0.112,0.111],[0.111,0.111],[0,0],[-0.118,-0.119],[-0.05,-0.05],[-0.069,-0.068],[0,0]],"v":[[80.276,-19.943],[80.61,-19.61],[80.943,-19.276],[86.623,-24.909],[86.267,-25.267],[86.116,-25.418],[85.909,-25.623]],"c":true},"ix":2},"nm":"Path 39","mn":"ADBE Vector Shape - Group","hd":false},{"ind":39,"ty":"sh","ix":40,"ks":{"a":0,"k":{"i":[[0,0],[-0.214,0.23],[0,0],[0.227,-0.248]],"o":[[0.212,-0.232],[0,0],[-0.229,0.246],[0,0]],"v":[[-84.191,-15.862],[-83.553,-16.556],[-89.417,-21.998],[-90.099,-21.256]],"c":true},"ix":2},"nm":"Path 40","mn":"ADBE Vector Shape - Group","hd":false},{"ind":40,"ty":"sh","ix":41,"ks":{"a":0,"k":{"i":[[0,0],[-0.212,-0.232],[0,0],[0.229,0.246]],"o":[[0.214,0.23],[0,0],[-0.227,-0.248],[0,0]],"v":[[83.553,-16.556],[84.191,-15.862],[90.099,-21.256],[89.417,-21.998]],"c":true},"ix":2},"nm":"Path 41","mn":"ADBE Vector Shape - Group","hd":false},{"ind":41,"ty":"sh","ix":42,"ks":{"a":0,"k":{"i":[[0,0],[-0.204,0.239],[0,0],[0.216,-0.257]],"o":[[0.202,-0.241],[0,0],[-0.218,0.256],[0,0]],"v":[[-87.296,-12.317],[-86.687,-13.037],[-92.77,-18.233],[-93.422,-17.463]],"c":true},"ix":2},"nm":"Path 42","mn":"ADBE Vector Shape - Group","hd":false},{"ind":42,"ty":"sh","ix":43,"ks":{"a":0,"k":{"i":[[0,0],[-0.202,-0.241],[0,0],[0.219,0.256]],"o":[[0.204,0.239],[0,0],[-0.216,-0.257],[0,0]],"v":[[86.687,-13.037],[87.296,-12.317],[93.422,-17.463],[92.77,-18.233]],"c":true},"ix":2},"nm":"Path 43","mn":"ADBE Vector Shape - Group","hd":false},{"ind":43,"ty":"sh","ix":44,"ks":{"a":0,"k":{"i":[[0,0],[-0.194,0.247],[0,0],[0.205,-0.266]],"o":[[0.192,-0.249],[0,0],[-0.208,0.265],[0,0]],"v":[[-90.251,-8.648],[-89.672,-9.391],[-95.965,-14.331],[-96.585,-13.535]],"c":true},"ix":2},"nm":"Path 44","mn":"ADBE Vector Shape - Group","hd":false},{"ind":44,"ty":"sh","ix":45,"ks":{"a":0,"k":{"i":[[0,0],[-0.192,-0.249],[0,0],[0.208,0.265]],"o":[[0.194,0.247],[0,0],[-0.205,-0.266],[0,0]],"v":[[89.672,-9.391],[90.251,-8.648],[96.585,-13.535],[95.965,-14.331]],"c":true},"ix":2},"nm":"Path 45","mn":"ADBE Vector Shape - Group","hd":false},{"ind":45,"ty":"sh","ix":46,"ks":{"a":0,"k":{"i":[[0,0],[-0.184,0.255],[0,0],[0.194,-0.274]],"o":[[0.181,-0.256],[0,0],[-0.196,0.273],[0,0]],"v":[[-93.052,-4.859],[-92.505,-5.626],[-98.996,-10.301],[-99.582,-9.48]],"c":true},"ix":2},"nm":"Path 46","mn":"ADBE Vector Shape - Group","hd":false},{"ind":46,"ty":"sh","ix":47,"ks":{"a":0,"k":{"i":[[0,0],[-0.181,-0.256],[0,0],[0.196,0.273]],"o":[[0.184,0.255],[0,0],[-0.194,-0.274],[0,0]],"v":[[92.505,-5.626],[93.052,-4.859],[99.582,-9.48],[98.996,-10.301]],"c":true},"ix":2},"nm":"Path 47","mn":"ADBE Vector Shape - Group","hd":false},{"ind":47,"ty":"sh","ix":48,"ks":{"a":0,"k":{"i":[[0,0],[-0.173,0.262],[0,0],[0.183,-0.282]],"o":[[0.171,-0.264],[0,0],[-0.185,0.281],[0,0]],"v":[[-95.694,-0.957],[-95.179,-1.746],[-101.858,-6.149],[-102.41,-5.305]],"c":true},"ix":2},"nm":"Path 48","mn":"ADBE Vector Shape - Group","hd":false},{"ind":48,"ty":"sh","ix":49,"ks":{"a":0,"k":{"i":[[0,0],[-0.171,-0.264],[0,0],[0.185,0.281]],"o":[[0.173,0.262],[0,0],[-0.183,-0.282],[0,0]],"v":[[95.179,-1.746],[95.694,-0.957],[102.41,-5.305],[101.858,-6.149]],"c":true},"ix":2},"nm":"Path 49","mn":"ADBE Vector Shape - Group","hd":false},{"ind":49,"ty":"sh","ix":50,"ks":{"a":0,"k":{"i":[[0,0],[-0.162,0.269],[0,0],[0.171,-0.29]],"o":[[0.16,-0.271],[0,0],[-0.173,0.288],[0,0]],"v":[[-98.173,3.05],[-97.69,2.241],[-104.546,-1.883],[-105.062,-1.016]],"c":true},"ix":2},"nm":"Path 50","mn":"ADBE Vector Shape - Group","hd":false},{"ind":50,"ty":"sh","ix":51,"ks":{"a":0,"k":{"i":[[0,0],[-0.16,-0.271],[0,0],[0.173,0.288]],"o":[[0.162,0.269],[0,0],[-0.171,-0.29],[0,0]],"v":[[97.69,2.241],[98.173,3.05],[105.062,-1.016],[104.546,-1.883]],"c":true},"ix":2},"nm":"Path 51","mn":"ADBE Vector Shape - Group","hd":false},{"ind":51,"ty":"sh","ix":52,"ks":{"a":0,"k":{"i":[[0,0],[-0.151,0.276],[0,0],[0.159,-0.296]],"o":[[0.148,-0.277],[0,0],[-0.161,0.295],[0,0]],"v":[[-100.484,7.157],[-100.035,6.328],[-107.055,2.492],[-107.535,3.378]],"c":true},"ix":2},"nm":"Path 52","mn":"ADBE Vector Shape - Group","hd":false},{"ind":52,"ty":"sh","ix":53,"ks":{"a":0,"k":{"i":[[0,0],[-0.148,-0.277],[0,0],[0.161,0.295]],"o":[[0.151,0.276],[0,0],[-0.159,-0.296],[0,0]],"v":[[100.035,6.328],[100.484,7.157],[107.535,3.378],[107.055,2.492]],"c":true},"ix":2},"nm":"Path 53","mn":"ADBE Vector Shape - Group","hd":false},{"ind":53,"ty":"sh","ix":54,"ks":{"a":0,"k":{"i":[[0,0],[-0.139,0.282],[0,0],[0.146,-0.303]],"o":[[0.137,-0.283],[0,0],[-0.149,0.301],[0,0]],"v":[[-102.623,11.355],[-102.209,10.509],[-109.381,6.966],[-109.824,7.872]],"c":true},"ix":2},"nm":"Path 54","mn":"ADBE Vector Shape - Group","hd":false},{"ind":54,"ty":"sh","ix":55,"ks":{"a":0,"k":{"i":[[0,0],[-0.137,-0.283],[0,0],[0.149,0.301]],"o":[[0.139,0.282],[0,0],[-0.146,-0.303],[0,0]],"v":[[102.209,10.509],[102.623,11.355],[109.824,7.872],[109.381,6.966]],"c":true},"ix":2},"nm":"Path 55","mn":"ADBE Vector Shape - Group","hd":false},{"ind":55,"ty":"sh","ix":56,"ks":{"a":0,"k":{"i":[[0,0],[-0.127,0.287],[0,0],[0.134,-0.308]],"o":[[0.125,-0.288],[0,0],[-0.136,0.307],[0,0]],"v":[[-104.587,15.639],[-104.208,14.776],[-111.521,11.532],[-111.926,12.455]],"c":true},"ix":2},"nm":"Path 56","mn":"ADBE Vector Shape - Group","hd":false},{"ind":56,"ty":"sh","ix":57,"ks":{"a":0,"k":{"i":[[0,0],[-0.125,-0.288],[0,0],[0.136,0.307]],"o":[[0.127,0.287],[0,0],[-0.134,-0.308],[0,0]],"v":[[104.208,14.776],[104.587,15.639],[111.926,12.455],[111.521,11.532]],"c":true},"ix":2},"nm":"Path 57","mn":"ADBE Vector Shape - Group","hd":false},{"ind":57,"ty":"sh","ix":58,"ks":{"a":0,"k":{"i":[[0,0],[-0.115,0.292],[0,0],[0.121,-0.314]],"o":[[0.113,-0.293],[0,0],[-0.124,0.313],[0,0]],"v":[[-106.372,19.999],[-106.029,19.121],[-113.47,16.183],[-113.836,17.122]],"c":true},"ix":2},"nm":"Path 58","mn":"ADBE Vector Shape - Group","hd":false},{"ind":58,"ty":"sh","ix":59,"ks":{"a":0,"k":{"i":[[0,0],[-0.113,-0.293],[0,0],[0.124,0.313]],"o":[[0.115,0.292],[0,0],[-0.121,-0.314],[0,0]],"v":[[106.029,19.121],[106.372,19.999],[113.836,17.122],[113.47,16.183]],"c":true},"ix":2},"nm":"Path 59","mn":"ADBE Vector Shape - Group","hd":false},{"ind":59,"ty":"sh","ix":60,"ks":{"a":0,"k":{"i":[[0,0],[-0.103,0.297],[0,0],[0.108,-0.318]],"o":[[0.101,-0.298],[0,0],[-0.11,0.318],[0,0]],"v":[[-107.975,24.43],[-107.669,23.539],[-115.225,20.91],[-115.552,21.864]],"c":true},"ix":2},"nm":"Path 60","mn":"ADBE Vector Shape - Group","hd":false},{"ind":60,"ty":"sh","ix":61,"ks":{"a":0,"k":{"i":[[0,0],[-0.101,-0.298],[0,0],[0.11,0.318]],"o":[[0.103,0.297],[0,0],[-0.108,-0.318],[0,0]],"v":[[107.669,23.539],[107.975,24.43],[115.552,21.864],[115.225,20.91]],"c":true},"ix":2},"nm":"Path 61","mn":"ADBE Vector Shape - Group","hd":false},{"ind":61,"ty":"sh","ix":62,"ks":{"a":0,"k":{"i":[[0,0],[-0.091,0.301],[0,0],[0.095,-0.323]],"o":[[0.088,-0.301],[0,0],[-0.097,0.322],[0,0]],"v":[[-109.394,28.923],[-109.126,28.02],[-116.783,25.706],[-117.071,26.672]],"c":true},"ix":2},"nm":"Path 62","mn":"ADBE Vector Shape - Group","hd":false},{"ind":62,"ty":"sh","ix":63,"ks":{"a":0,"k":{"i":[[0,0],[-0.088,-0.301],[0,0],[0.097,0.322]],"o":[[0.091,0.301],[0,0],[-0.095,-0.323],[0,0]],"v":[[109.126,28.02],[109.394,28.923],[117.071,26.672],[116.783,25.706]],"c":true},"ix":2},"nm":"Path 63","mn":"ADBE Vector Shape - Group","hd":false},{"ind":63,"ty":"sh","ix":64,"ks":{"a":0,"k":{"i":[[0,0],[-0.078,0.304],[0,0],[0.081,-0.326]],"o":[[0.076,-0.305],[0,0],[-0.084,0.326],[0,0]],"v":[[-110.627,33.472],[-110.395,32.558],[-118.142,30.562],[-118.39,31.54]],"c":true},"ix":2},"nm":"Path 64","mn":"ADBE Vector Shape - Group","hd":false},{"ind":64,"ty":"sh","ix":65,"ks":{"a":0,"k":{"i":[[0,0],[-0.076,-0.305],[0,0],[0.084,0.326]],"o":[[0.078,0.304],[0,0],[-0.081,-0.326],[0,0]],"v":[[110.395,32.558],[110.627,33.472],[118.39,31.54],[118.142,30.562]],"c":true},"ix":2},"nm":"Path 65","mn":"ADBE Vector Shape - Group","hd":false},{"ind":65,"ty":"sh","ix":66,"ks":{"a":0,"k":{"i":[[0,0],[-0.066,0.307],[0,0],[0.068,-0.329]],"o":[[0.063,-0.308],[0,0],[-0.07,0.329],[0,0]],"v":[[-111.67,38.067],[-111.476,37.144],[-119.299,35.47],[-119.506,36.457]],"c":true},"ix":2},"nm":"Path 66","mn":"ADBE Vector Shape - Group","hd":false},{"ind":66,"ty":"sh","ix":67,"ks":{"a":0,"k":{"i":[[0,0],[-0.063,-0.308],[0,0],[0.07,0.329]],"o":[[0.066,0.307],[0,0],[-0.068,-0.329],[0,0]],"v":[[111.476,37.144],[111.67,38.067],[119.506,36.457],[119.299,35.47]],"c":true},"ix":2},"nm":"Path 67","mn":"ADBE Vector Shape - Group","hd":false},{"ind":67,"ty":"sh","ix":68,"ks":{"a":0,"k":{"i":[[0,0],[-0.053,0.309],[0,0],[0.054,-0.332]],"o":[[0.05,-0.31],[0,0],[-0.057,0.331],[0,0]],"v":[[-112.522,42.701],[-112.367,41.771],[-120.252,40.422],[-120.418,41.416]],"c":true},"ix":2},"nm":"Path 68","mn":"ADBE Vector Shape - Group","hd":false},{"ind":68,"ty":"sh","ix":69,"ks":{"a":0,"k":{"i":[[0,0],[-0.05,-0.31],[0,0],[0.057,0.331]],"o":[[0.053,0.309],[0,0],[-0.054,-0.332],[0,0]],"v":[[112.367,41.771],[112.522,42.701],[120.418,41.416],[120.253,40.422]],"c":true},"ix":2},"nm":"Path 69","mn":"ADBE Vector Shape - Group","hd":false},{"ind":69,"ty":"sh","ix":70,"ks":{"a":0,"k":{"i":[[0,0],[-0.04,0.312],[0,0],[0.04,-0.334]],"o":[[0.038,-0.312],[0,0],[-0.043,0.333],[0,0]],"v":[[-113.182,47.366],[-113.066,46.431],[-121,45.409],[-121.125,46.41]],"c":true},"ix":2},"nm":"Path 70","mn":"ADBE Vector Shape - Group","hd":false},{"ind":70,"ty":"sh","ix":71,"ks":{"a":0,"k":{"i":[[0,0],[-0.038,-0.312],[0,0],[0.043,0.333]],"o":[[0.04,0.312],[0,0],[-0.04,-0.334],[0,0]],"v":[[113.066,46.431],[113.182,47.366],[121.125,46.41],[121,45.409]],"c":true},"ix":2},"nm":"Path 71","mn":"ADBE Vector Shape - Group","hd":false},{"ind":71,"ty":"sh","ix":72,"ks":{"a":0,"k":{"i":[[0,0],[-0.027,0.313],[0,0],[0.026,-0.335]],"o":[[0.025,-0.313],[0,0],[-0.029,0.335],[0,0]],"v":[[-113.649,52.055],[-113.571,51.116],[-121.541,50.422],[-121.624,51.428]],"c":true},"ix":2},"nm":"Path 72","mn":"ADBE Vector Shape - Group","hd":false},{"ind":72,"ty":"sh","ix":73,"ks":{"a":0,"k":{"i":[[0,0],[-0.025,-0.313],[0,0],[0.029,0.335]],"o":[[0.027,0.313],[0,0],[-0.026,-0.335],[0,0]],"v":[[113.571,51.116],[113.649,52.055],[121.624,51.428],[121.541,50.422]],"c":true},"ix":2},"nm":"Path 73","mn":"ADBE Vector Shape - Group","hd":false},{"ind":73,"ty":"sh","ix":74,"ks":{"a":0,"k":{"i":[[0,0],[-0.014,0.314],[0,0],[0.012,-0.336]],"o":[[0.012,-0.314],[0,0],[-0.015,0.336],[0,0]],"v":[[-113.921,56.759],[-113.882,55.818],[-121.874,55.454],[-121.916,56.462]],"c":true},"ix":2},"nm":"Path 74","mn":"ADBE Vector Shape - Group","hd":false},{"ind":74,"ty":"sh","ix":75,"ks":{"a":0,"k":{"i":[[0,0],[-0.012,-0.314],[0,0],[0.015,0.336]],"o":[[0.014,0.314],[0,0],[-0.012,-0.336],[0,0]],"v":[[113.882,55.818],[113.921,56.759],[121.916,56.462],[121.874,55.454]],"c":true},"ix":2},"nm":"Path 75","mn":"ADBE Vector Shape - Group","hd":false},{"ind":75,"ty":"sh","ix":76,"ks":{"a":0,"k":{"i":[[0,0],[-0.001,0.157],[0,0],[0,-0.168]],"o":[[0,-0.157],[0,0],[-0.001,0.168],[0,0]],"v":[[-114,61],[-113.999,60.528],[-121.999,60.495],[-122,61]],"c":true},"ix":2},"nm":"Path 76","mn":"ADBE Vector Shape - Group","hd":false},{"ind":76,"ty":"sh","ix":77,"ks":{"a":0,"k":{"i":[[0,0],[0,-0.157],[0,0],[0.001,0.168]],"o":[[0.001,0.157],[0,0],[0,-0.168],[0,0]],"v":[[113.999,60.528],[114,61],[122,61],[121.999,60.495]],"c":true},"ix":2},"nm":"Path 77","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.929411764706,0.929411764706,0.929411764706,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[500,500],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1350 (Stroke)","np":79,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":150,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Path 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[615,617.5,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[208,208],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"gs","o":{"a":0,"k":100,"ix":9},"w":{"a":0,"k":12,"ix":10},"g":{"p":5,"k":{"a":0,"k":[0,0.933,0.29,0.286,0.064,0.947,0.433,0.196,0.127,0.961,0.576,0.106,0.454,0.48,0.624,0.263,0.782,0,0.671,0.42],"ix":8}},"s":{"a":0,"k":[93,42],"ix":4},"e":{"a":0,"k":[-100,-32.5],"ix":5},"t":1,"lc":2,"lj":2,"bm":0,"nm":"Gradient Stroke 1","mn":"ADBE Vector Graphic - G-Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[500,500],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1349","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":149.166015625,"s":[50]}],"ix":2},"o":{"a":0,"k":270,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":150,"st":0,"ct":1,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Path","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[615,617.5,0],"ix":2,"l":2},"a":{"a":0,"k":[0,0,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[208,208],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.96862745098,0.96862745098,0.96862745098,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[500,500],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1349","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":0,"k":50,"ix":2},"o":{"a":0,"k":270,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":150,"st":0,"ct":1,"bm":0}],"markers":[]}');
;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/DebtRatio/debt-ratio.styled.ts

function debt_ratio_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-close-x {\n    font-size: 11px;\n  }\n\n  max-width: 400px;\n"
    ]);
    debt_ratio_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 20px 0;\n"
    ]);
    debt_ratio_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n\n  & > * {\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    debt_ratio_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 240px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"
    ]);
    debt_ratio_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n"
    ]);
    debt_ratio_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: center;\n  border-radius: 4px;\n  border: 1px solid #ededed;\n  width: 100%;\n  padding: 17px 16px;\n"
    ]);
    debt_ratio_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n\n  p {\n    margin: 0;\n    max-width: 50%;\n  }\n"
    ]);
    debt_ratio_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 0 16px;\n"
    ]);
    debt_ratio_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  padding: 0 6px;\n  border-radius: 8px;\n  border: 1px solid #ededed;\n  height: 18px;\n"
    ]);
    debt_ratio_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  width: 100%;\n"
    ]);
    debt_ratio_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function debt_ratio_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background-color: #f2f1fe;\n"
    ]);
    debt_ratio_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var SbModal = ui/* Common.Modal */.Gn.Modal;
var Modal = (0,styled_components_browser_esm["default"])(SbModal).withConfig({
    componentId: "sc-27588294-0"
})(debt_ratio_styled_templateObject());
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-1"
})(debt_ratio_styled_templateObject1());
var debt_ratio_styled_ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-2"
})(debt_ratio_styled_templateObject2());
var LottieWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-3"
})(debt_ratio_styled_templateObject3());
var InfoTextWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-4"
})(debt_ratio_styled_templateObject4());
var DebtRatioInfoWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-5"
})(debt_ratio_styled_templateObject5());
var RowWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-6"
})(debt_ratio_styled_templateObject6());
var debt_ratio_styled_DividerWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-7"
})(debt_ratio_styled_templateObject7());
var debt_ratio_styled_SymbolChip = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-8"
})(debt_ratio_styled_templateObject8());
var debt_ratio_styled_RowDivider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-27588294-9"
})(debt_ratio_styled_templateObject9());
var DebtRatioBanner = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-27588294-10"
})(debt_ratio_styled_templateObject10());

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/DebtRatio/debt-ratio.tsx











var Text = ui/* Common.Text */.Gn.Text;
function ModalDebtRatio(param) {
    var visible = param.visible, _percentage = param.percentage, percentage = _percentage === void 0 ? 100 : _percentage, totalDebt = param.totalDebt, marketValue = param.marketValue, onCancel = param.onCancel;
    var dayTrade = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.dayTrade;
    });
    var ref = dayTrade || {
        debt_ratio_rules: {
            caution: 0,
            force_sell: 0
        }
    }, debtRatioRules = ref.debt_ratio_rules;
    var uiConfig = (0,common/* getDayTradeUIValue */.qD)(percentage, debtRatioRules.force_sell, debtRatioRules.caution);
    (0,react.useEffect)(function() {
        lottie_default().destroy();
        lottie_default().setQuality("high");
        var speedoAnim = lottie_default().loadAnimation({
            container: document.getElementById("debt-speedo"),
            renderer: "svg",
            loop: false,
            autoplay: true,
            animationData: speedo_portfolio_namespaceObject
        });
        var speed = percentage > 50 ? 7 : 5;
        speedoAnim.setSpeed(speed);
        var maxFrame = speedoAnim.getDuration(true);
        var minPercentage = 0;
        var maxPercentage = 100;
        var percentProgress = Math.min(Math.max(percentage, minPercentage), maxPercentage);
        if (percentProgress === minPercentage || !visible) {
            speedoAnim.goToAndStop(0, true);
            return;
        }
        if (percentProgress > debtRatioRules.force_sell) {
            speedoAnim.playSegments([
                0,
                maxFrame
            ], true);
            return;
        }
        var endFrame = percentProgress / maxPercentage * maxFrame;
        speedoAnim.playSegments([
            0,
            endFrame
        ], true);
    }, [
        visible
    ]);
    (0,react.useEffect)(function() {
        if (visible) {
            (0,securities/* clevertapDayTradeDebtRatioModalViewed */.t3)();
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        visible: visible,
        onCancel: onCancel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    align: "center",
                    family: "bold",
                    size: "18px",
                    "data-cy": "debt-ratio-modal-title",
                    children: "Debt Ratio"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LottieWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                id: "debt-speedo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoTextWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "24px",
                                        family: "bold",
                                        color: uiConfig.percentColor,
                                        children: (0,formater/* formatPercentageDayTrade */.m9)(percentage)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                        size: "12px",
                                        color: "#858585",
                                        children: [
                                            "Maksimal ",
                                            (0,formater/* formatPercentageDayTrade */.m9)(debtRatioRules.force_sell)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "14px",
                        children: "Debt Ratio adalah perbandingan antara Day Trade yang sudah kamu pakai dengan market value aset Day Trade kamu saat ini."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DebtRatioInfoWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        children: "Total Hutang"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        children: (0,number/* formatNumber */.uf)(totalDebt)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_DividerWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_RowDivider, {
                                        dashed: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_SymbolChip, {
                                        children: "\xf7"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        children: "Total Aset Day Trade (Market Value)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        children: (0,number/* formatNumber */.uf)(marketValue)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(debt_ratio_styled_DividerWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_RowDivider, {
                                        dashed: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(debt_ratio_styled_SymbolChip, {
                                        children: "="
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        family: "bold",
                                        children: "Debt Ratio"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "14px",
                                        family: "bold",
                                        color: uiConfig.percentColor,
                                        children: (0,formater/* formatPercentageDayTrade */.m9)(percentage)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DebtRatioBanner, {
                        children: [
                            "Aset Day Trade kamu akan terjual secara otomatis apabila Debt Ratio kamu mencapai ",
                            (0,formater/* formatPercentageDayTrade */.m9)(debtRatioRules.force_sell),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var debt_ratio = (/*#__PURE__*/(0,react.memo)(ModalDebtRatio));

;// CONCATENATED MODULE: ./src/features/day-trade/components/Modals/index.ts









/***/ }),

/***/ 99533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ getPortfolioType; },
/* harmony export */   "JH": function() { return /* binding */ getCombinedPortfolioList; },
/* harmony export */   "bs": function() { return /* binding */ getUnavailableReason; },
/* harmony export */   "qD": function() { return /* binding */ getDayTradeUIValue; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);



var getCombinedPortfolioList = function() {
    var dataRegular = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], dataDaytrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isRealTrading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, dataBonds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    if (!isRealTrading) {
        return dataRegular;
    }
    var regular = (dataRegular === null || dataRegular === void 0 ? void 0 : dataRegular.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            type_label: "RG"
        });
    })) || [];
    var daytrade = (dataDaytrade === null || dataDaytrade === void 0 ? void 0 : dataDaytrade.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            type_label: "DT"
        });
    })) || [];
    var bonds = dataBonds === null || dataBonds === void 0 ? void 0 : dataBonds.map(function(item) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, item), {
            type_label: "FR"
        });
    });
    return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(daytrade).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(regular), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(bonds));
};
var getPortfolioType = function(portfolios) {
    var isRegular = portfolios === null || portfolios === void 0 ? void 0 : portfolios.some(function(item) {
        return item.type_label === "RG";
    });
    var isDayTrade = portfolios === null || portfolios === void 0 ? void 0 : portfolios.some(function(item) {
        return item.type_label === "DT";
    });
    var isBonds = portfolios === null || portfolios === void 0 ? void 0 : portfolios.some(function(item) {
        return item.type_label === "FR";
    });
    if (isRegular && isDayTrade) {
        return "Both";
    }
    if (isRegular) {
        return "Regular";
    }
    if (isDayTrade) {
        return "Day Trade";
    }
    if (isBonds) {
        return "Bonds";
    }
    return "None";
};
var getUnavailableReason = function(isTimeLimit, isSellOrder, isSellAmend, time) {
    if (!isTimeLimit || isTimeLimit && isSellAmend) {
        return "Aset Day Trade sedang dalam proses penjualan otomatis";
    }
    var orderType = isSellOrder ? "Penjualan" : "Pembelian";
    return "".concat(orderType, " saham-saham Day Trade hanya dapat dilakukan pukul ").concat(time, " WIB.");
};
var getDayTradeUIValue = function(percentRatio, forceSellLimit, cautionLimit) {
    if (percentRatio > forceSellLimit) {
        return {
            color: "#EE4A49",
            percentColor: "#EE4A49",
            background: "#FBDFDF",
            label: "FORCE SELLING"
        };
    }
    if (percentRatio > cautionLimit) {
        return {
            color: "#F5931B",
            percentColor: "#F5931B",
            background: "#FDE7CD",
            label: "CAUTION"
        };
    }
    return {
        color: "#333333",
        percentColor: "#00AB6B",
        background: "#CCEEE1",
        label: ""
    };
};


/***/ }),

/***/ 22733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wn": function() { return /* binding */ replaceWords; },
/* harmony export */   "d7": function() { return /* binding */ formatHourMinutes; },
/* harmony export */   "m9": function() { return /* binding */ formatPercentageDayTrade; }
/* harmony export */ });
/* unused harmony export replaceWord */
var formatPercentageDayTrade = function(percentage) {
    var withSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (percentage === undefined || percentage === null || Number.isNaN(percentage)) {
        return "";
    }
    return "".concat(percentage.toFixed(2)).concat(withSymbol ? "%" : "");
};
var formatHourMinutes = function() {
    var timeOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "00:00", timeClose = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "15:30";
    var formattedOpen = timeOpen.split(":").slice(0, 2).join(":");
    var formattedClose = timeClose.split(":").slice(0, 2).join(":");
    return {
        open: formattedOpen,
        close: formattedClose,
        openClose: "".concat(formattedOpen, " - ").concat(formattedClose)
    };
};
var replaceWord = function(words, replace, selected) {
    if (!words) {
        return "";
    }
    return words.replace(replace, selected);
};
var replaceWords = function(words, replace, selected) {
    if (!words) {
        return "";
    }
    var newWords = words;
    replace.forEach(function(item, index) {
        newWords = replaceWord(newWords, item, selected[index]);
    });
    return newWords;
};


/***/ }),

/***/ 53400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ DesktopAppDownloadAnalytics; }
/* harmony export */ });
/* unused harmony export EVENT */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var EVENT = {
    openDesktopAppLandingPage: "Open Desktop App Landing Page",
    onDownloadDesktopApp: "Download Desktop App"
};
var DesktopAppDownloadAnalytics = {
    onDesktopAppLandingPage: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENT.openDesktopAppLandingPage);
    },
    onDownloadDesktopApp: function(param) {
        var os = param.os, source = param.source;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(EVENT.onDownloadDesktopApp, {
            Source: source,
            OS: os
        });
    }
};


/***/ }),

/***/ 54949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareTrade_ErrorState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Icons/RefreshSvg.tsx
var RefreshSvg = __webpack_require__(83952);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/styled.ts
var styled = __webpack_require__(35614);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/ErrorState/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  100% {\n    transform: rotate(-360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .anticon {\n    animation: ",
        " 1s linear 0s infinite forwards;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 4px;\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #00ab6b;\n  font-weight: bold;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: #00ab6b;\n  }\n\n  & > .anticon {\n    width: 13px;\n    height: 13px;\n    vertical-align: middle;\n    transform: rotate(0deg);\n    transition: transform 0.3s linear;\n  }\n\n  ",
        "\n\n  margin: 0 !important;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var counterSpinAnimation = (0,styled_components_browser_esm.keyframes)(_templateObject());
var counterSpinCss = (0,styled_components_browser_esm.css)(_templateObject1(), counterSpinAnimation);
var ErrorIcon = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-3612f55f-0"
})(_templateObject2(), function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width;
    return "".concat(width);
}, function(param) {
    var _height = param.height, height = _height === void 0 ? "auto" : _height;
    return "".concat(height);
});
var RetryButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-3612f55f-1"
})(_templateObject3(), function(param) {
    var spin = param.spin;
    return spin ? counterSpinCss : "";
});

;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/ErrorState/index.tsx






var ErrorState = function(param) {
    var className = param.className, description = param.description, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Try Again" : _buttonText, iconSrc = param.iconSrc, iconWidth = param.iconWidth, iconHeight = param.iconHeight, _hideRetry = param.hideRetry, hideRetry = _hideRetry === void 0 ? false : _hideRetry, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _onRetry = param.onRetry, onRetry = _onRetry === void 0 ? function() {} : _onRetry;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
        className: className,
        align: "middle",
        justify: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    align: "middle",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon, {
                                src: iconSrc,
                                width: iconWidth,
                                height: iconHeight
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 24,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Text */.xv, {
                                align: "center",
                                color: "#858585",
                                marginBottom: "12px",
                                children: description
                            })
                        })
                    ]
                }),
                !hideRetry && /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    align: "middle",
                    justify: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RetryButton, {
                            type: "text",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: RefreshSvg/* default */.Z
                            }),
                            onClick: onRetry,
                            spin: loading,
                            disabled: loading,
                            children: buttonText
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ShareTrade_ErrorState = (ErrorState);


/***/ }),

/***/ 70963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareTrade_PopOverInvestment; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 1 modules
var popover = __webpack_require__(10808);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.tsx + 4 modules
var ShareTradeAttachment = __webpack_require__(82906);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var entities_profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/constant.ts
var POPOVER_TITLE = {
    CHECKED: "Share Investment Amount",
    UNCHECKED: "Share without Investment Amount"
};
var TOOLTIP_TITLE = "Investment amount will be displayed along with price if you turn the toggle on.";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  background: #f7f7f7;\n  padding: 2px 6px;\n  border-radius: 4px;\n  width: fit-content;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n\n  span {\n    color: ",
        ";\n    font-size: 12px;\n    padding: 0;\n    margin: 0;\n    line-height: normal;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #ffffff;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  min-width: 250px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n  padding: 12px;\n  border-bottom: 1px solid #ededed;\n\n  span {\n    font-size: 13px;\n    font-weight: bold;\n  }\n  \n  img {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 6px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var PopOverButton = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c1c4cca3-0"
})(_templateObject(), function(param) {
    var isActive = param.isActive;
    return isActive ? "#00ab6b" : "#858585";
}, function(param) {
    var isMaxWidth = param.isMaxWidth;
    return isMaxWidth && "\n    width: 100%;\n  ";
});
var PopOverContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c1c4cca3-1"
})(_templateObject1());
var ContentHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c1c4cca3-2"
})(_templateObject2());
var HeaderTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c1c4cca3-3"
})(_templateObject3());
var ContentCard = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c1c4cca3-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/index.tsx










var PopOverInvestment = function(param) {
    var isSelected = param.isSelected, defaultSwitchValue = param.defaultSwitchValue, previewShareTrade = param.previewShareTrade, _isScrolling = param.isScrolling, isScrolling = _isScrolling === void 0 ? false : _isScrolling, _placement = param.placement, placement = _placement === void 0 ? "bottomLeft" : _placement, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? false : _maxWidth, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(defaultSwitchValue), isSwitchChecked = ref1[0], setIsSwitchChecked = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(entities_profile/* selectors */.wl), profile = ref2.data;
    var handleChangeSwitch = function(checked) {
        setIsSwitchChecked(checked);
        onSwitchChange(checked);
        setVisible(false);
    };
    (0,react.useEffect)(function() {
        setIsSwitchChecked(defaultSwitchValue);
    }, [
        isSelected,
        defaultSwitchValue
    ]);
    (0,react.useEffect)(function() {
        if (isScrolling) setVisible(false);
    }, [
        isScrolling
    ]);
    var popOverText = isSwitchChecked ? POPOVER_TITLE.CHECKED : POPOVER_TITLE.UNCHECKED;
    var iconSuffix = isSwitchChecked ? "_active" : "";
    var PopOverIcon = {
        height: 14,
        width: 14
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
        trigger: [
            "click",
            "contextMenu"
        ],
        placement: placement,
        destroyTooltipOnHide: true,
        visible: visible,
        onVisibleChange: function() {
            return setVisible(!visible);
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopOverContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTitleWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: POPOVER_TITLE.CHECKED
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                        title: TOOLTIP_TITLE,
                                        trigger: [
                                            "click",
                                            "contextMenu"
                                        ],
                                        placement: "bottom",
                                        overlayClassName: "tooltip-overlay-green",
                                        destroyTooltipOnHide: true,
                                        overlayStyle: {
                                            minWidth: 320
                                        },
                                        overlayInnerStyle: {
                                            background: "#00ab6b"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, (0,_object_spread/* default */.Z)({
                                            src: "/icon/info.svg",
                                            alt: "close"
                                        }, PopOverIcon))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                                checked: isSwitchChecked,
                                onChange: handleChangeSwitch,
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentCard, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTradeAttachment/* default */.Z, {
                            info: previewShareTrade,
                            username: profile.username,
                            isVerified: false,
                            usernameColor: "#94B041",
                            hidePreviousOrder: false,
                            hideUsername: false,
                            onPreviousOrderClick: function() {},
                            isPreview: true
                        })
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopOverButton, {
            isActive: isSwitchChecked,
            isMaxWidth: maxWidth,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/sharetrade/currency".concat(iconSuffix, ".svg"),
                    alt: "icon"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: popOverText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/sharetrade/arrow".concat(iconSuffix, ".svg"),
                    alt: "icon",
                    className: "icon-arrow"
                })
            ]
        })
    });
};
/* harmony default export */ var ShareTrade_PopOverInvestment = (PopOverInvestment);


/***/ }),

/***/ 45205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HG": function() { return /* binding */ IconVerified; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "f9": function() { return /* binding */ UserInfoRow; },
/* harmony export */   "yB": function() { return /* binding */ NameWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var global_Securities_components_Checkbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19254);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35614);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-col.avatar-col > img,\n  & > .ant-col.avatar-col > div {\n    margin-right: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 2px;\n\n  & > p:first-child {\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 12px;\n  height: 12px;\n  margin: 2px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-checkbox > .ant-checkbox-inner,\n  & .ant-checkbox-checked::after {\n    border-radius: 9px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var UserInfoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-0"
})(_templateObject());
var NameWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-1"
})(_templateObject1());
var IconVerified = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-2"
})(_templateObject2());
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(global_Securities_components_Checkbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a520c28e-3"
})(_templateObject3());
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(_styled__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv).withConfig({
    componentId: "sc-a520c28e-4"
})(_templateObject4());


/***/ }),

/***/ 21504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ShareTrade_UserList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(72317);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/typings/api/shareTradeTarget.ts
var shareTradeTarget = __webpack_require__(32070);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/styled.ts
var styled = __webpack_require__(35614);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/UserItem/styled.ts
var UserItem_styled = __webpack_require__(45205);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/PopOverInvestment/index.tsx + 2 modules
var PopOverInvestment = __webpack_require__(70963);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/UserItem/index.tsx










var UserItem = function(param) {
    var avatarUrl = param.avatarUrl, name = param.name, alias = param.alias, description = param.description, targetType = param.targetType, _isVerified = param.isVerified, isVerified = _isVerified === void 0 ? false : _isVerified, _defaultChecked = param.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _defaultSwitchValue = param.defaultSwitchValue, defaultSwitchValue = _defaultSwitchValue === void 0 ? false : _defaultSwitchValue, previewShareTrade = param.previewShareTrade, _isScrolling = param.isScrolling, isScrolling = _isScrolling === void 0 ? false : _isScrolling, _onCheckChange = param.onCheckChange, onCheckChange = _onCheckChange === void 0 ? function() {} : _onCheckChange, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange;
    var ref = (0,react.useState)(defaultChecked), isSelected = ref[0], setIsSelected = ref[1];
    var handleChangeCheckbox = function(e) {
        setIsSelected(e.target.checked);
        onCheckChange(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
            align: "middle",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    span: 22,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* UserInfoRow */.f9, {
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                className: "avatar-col",
                                children: [
                                    targetType === shareTradeTarget/* TargetType.User */.L.User && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: avatarUrl,
                                        alt: name
                                    }),
                                    targetType === shareTradeTarget/* TargetType.ChatRoom */.L.ChatRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                        src: avatarUrl,
                                        children: avatarUrl ? undefined : alias
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                span: 20,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* NameWrapper */.yB, {
                                        align: "middle",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Text */.xv, {
                                                weight: "bold",
                                                children: name
                                            }),
                                            isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* IconVerified */.HG, {
                                                src: "/icon/widget-trending/icon-verfied.svg",
                                                alt: "icon-verified"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !isSelected || disabled,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* Description */.dk, {
                                            size: "12px",
                                            lineHeight: "19px",
                                            color: "#969696",
                                            children: description
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isSelected && !disabled,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopOverInvestment/* default */.Z, {
                                            defaultSwitchValue: defaultSwitchValue,
                                            isSelected: isSelected,
                                            previewShareTrade: previewShareTrade,
                                            isScrolling: isScrolling,
                                            onSwitchChange: onSwitchChange
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* Checkbox */.XZ, (0,_object_spread/* default */.Z)({
                        defaultChecked: defaultChecked,
                        onChange: handleChangeCheckbox,
                        disabled: disabled
                    }, disabled ? {
                        checked: false
                    } : {}))
                })
            ]
        })
    });
};
/* harmony default export */ var ShareTrade_UserItem = (UserItem);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/UserList/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  max-height: 392px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  & > .ant-row {\n    margin-bottom: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var UserListWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f4644d58-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/features/edit-profile/ShareTrade/UserList/index.tsx







var UserList = function(param) {
    var className = param.className, _defaultCheckedKey = param.defaultCheckedKey, defaultCheckedKey = _defaultCheckedKey === void 0 ? "" : _defaultCheckedKey, _defaultSwitchKey = param.defaultSwitchKey, defaultSwitchKey = _defaultSwitchKey === void 0 ? "" : _defaultSwitchKey, _sharedDescription = param.sharedDescription, sharedDescription = _sharedDescription === void 0 ? "Already shared to this friend" : _sharedDescription, _data = param.data, data = _data === void 0 ? [] : _data, _disableSharedKey = param.disableSharedKey, disableSharedKey = _disableSharedKey === void 0 ? [] : _disableSharedKey, _disableSharedUsers = param.disableSharedUsers, disableSharedUsers = _disableSharedUsers === void 0 ? false : _disableSharedUsers, _previewShareTrade = param.previewShareTrade, previewShareTrade = _previewShareTrade === void 0 ? {} : _previewShareTrade, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _onSelectedUserChange = param.onSelectedUserChange, onSelectedUserChange = _onSelectedUserChange === void 0 ? function() {} : _onSelectedUserChange, _onScrollToBottom = param.onScrollToBottom, onScrollToBottom = _onScrollToBottom === void 0 ? function() {} : _onScrollToBottom;
    var ref = (0,react.useState)(false), isScrolling = ref[0], setIsScrolling = ref[1];
    var scrollTimeout = (0,react.useRef)(null);
    var getIsDisabled = function(target) {
        if (!disableSharedUsers) return false;
        for(var i = 0; i < disableSharedKey.length; i += 1){
            if (target[disableSharedKey[i]]) return true;
        }
        return false;
    };
    var handleUserChange = function(e, userTarget) {
        var checked = e.target.checked;
        onSelectedUserChange(checked, userTarget);
    };
    var handleSwitchChange = function(checked, userTarget) {
        onSelectedUserChange(true, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, userTarget), {
            is_share_value: checked
        }));
    };
    var handleScroll = function() {
        setIsScrolling(true);
        // Clear any previous timeout to avoid multiple triggers
        if (scrollTimeout.current) {
            clearTimeout(scrollTimeout.current);
        }
        // Set a new timeout to reset the scrolling state
        scrollTimeout.current = setTimeout(function() {
            setIsScrolling(false);
        }, 100);
    };
    var handleScrollToBottom = function(isVisible) {
        if (isVisible) {
            onScrollToBottom();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserListWrapper, {
        className: className,
        onScroll: handleScroll,
        children: data.map(function(item, idx) {
            var isDisabled = getIsDisabled(item);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                onChange: handleScrollToBottom,
                intervalCheck: true,
                scrollCheck: true,
                active: !isLoading && data.length - 1 === idx,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTrade_UserItem, {
                    avatarUrl: item.avatar_url,
                    name: item.name,
                    alias: item.shortened_name,
                    targetType: item.type,
                    description: isDisabled ? sharedDescription : item.description,
                    isVerified: item.is_verified,
                    defaultChecked: item[defaultCheckedKey] || false,
                    onCheckChange: function(e) {
                        return handleUserChange(e, data[idx]);
                    },
                    disabled: isDisabled,
                    defaultSwitchValue: item[defaultSwitchKey] || false,
                    previewShareTrade: previewShareTrade,
                    onSwitchChange: function(checked) {
                        return handleSwitchChange(checked, data[idx]);
                    },
                    isScrolling: isScrolling
                }, item.id)
            });
        })
    });
};
/* harmony default export */ var ShareTrade_UserList = (UserList);


/***/ }),

/***/ 35614:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GZ": function() { return /* binding */ EmptyUserListWrapper; },
/* harmony export */   "K8": function() { return /* binding */ UserListErrorWrapper; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "Ot": function() { return /* binding */ RowHeaderContainer; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "Vx": function() { return /* binding */ ErrorWrapper; },
/* harmony export */   "Zb": function() { return /* binding */ Card; },
/* harmony export */   "bS": function() { return /* binding */ UserListWrapper; },
/* harmony export */   "gq": function() { return /* binding */ SaveWrapper; },
/* harmony export */   "iz": function() { return /* binding */ Divider; },
/* harmony export */   "k$": function() { return /* binding */ SaveButton; },
/* harmony export */   "m0": function() { return /* binding */ RowContentWrapper; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71577);
/* harmony import */ var global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47756);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(686);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  line-height: ",
        ";\n  margin-bottom: ",
        ";\n  color: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-card-body {\n    padding: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 8px;\n  width: 100%;\n  background-color: #f7f7f7;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px 0 0;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: unset;\n  border-radius: 4px;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  margin: 0 !important;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #ffffff;\n  border: 1px solid #dadada;\n  border-radius: 2px;\n  width: 100%;\n  height: 515px;\n\n  & > .ant-col > .ant-row {\n    min-height: 451px;\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 392px;\n\n  .user-list {\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 364px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}




var Text = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].p.withConfig({
    componentId: "sc-a2e9fc09-0"
})(_templateObject(), function(param) {
    var _size = param.size, size = _size === void 0 ? "14px" : _size;
    return "".concat(size);
}, function(param) {
    var _weight = param.weight, weight = _weight === void 0 ? "normal" : _weight;
    return weight;
}, function(param) {
    var _lineHeight = param.lineHeight, lineHeight = _lineHeight === void 0 ? "19px" : _lineHeight;
    return "".concat(lineHeight);
}, function(param) {
    var _marginBottom = param.marginBottom, marginBottom = _marginBottom === void 0 ? "0px" : _marginBottom;
    return "".concat(marginBottom);
}, function(param) {
    var _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return color;
}, function(param) {
    var align = param.align;
    return align;
});
var Card = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(_styled__WEBPACK_IMPORTED_MODULE_2__/* .EditProfileCard */ .pr).withConfig({
    componentId: "sc-a2e9fc09-1"
})(_templateObject1());
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-a2e9fc09-2"
})(_templateObject2());
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-3"
})(_templateObject3());
var RowHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-a2e9fc09-4"
})(_templateObject4());
var RowContentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-5"
})(_templateObject5());
var SearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-6"
})(_templateObject6());
var SaveWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-7"
})(_templateObject7());
var SaveButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-8"
})(_templateObject8());
var ErrorWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-9"
})(_templateObject9());
var UserListWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-10"
})(_templateObject10());
var UserListErrorWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-11"
})(_templateObject11());
var EmptyUserListWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a2e9fc09-12"
})(_templateObject12());


/***/ }),

/***/ 60779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CJ": function() { return /* binding */ PROGRESS_STATUS_ENUM; },
/* harmony export */   "Mz": function() { return /* binding */ WORDING_FORMAT_EMAIL_WRONG; },
/* harmony export */   "N7": function() { return /* binding */ NAVIGATION_ITEMS; },
/* harmony export */   "Qz": function() { return /* binding */ INDONESIA_CITY_LIST; },
/* harmony export */   "_T": function() { return /* binding */ SHARE_TRADE_PREVIEW; },
/* harmony export */   "ep": function() { return /* binding */ INDONESIA_PREFERRED_CITY_LIST; },
/* harmony export */   "kd": function() { return /* binding */ MAX_IMG_SIZE; },
/* harmony export */   "oE": function() { return /* binding */ SUCCESS_CONTENT; },
/* harmony export */   "tp": function() { return /* binding */ ACCEPTED_IMG_EXTENSIONS; }
/* harmony export */ });
/* unused harmony exports DEFAULT_AVATAR, MONTHS */
var MAX_IMG_SIZE = 2097152; // +-2MB
var ACCEPTED_IMG_EXTENSIONS = [
    ".jpg",
    ".jpeg",
    ".png"
];
var DEFAULT_AVATAR = "https://avatar.stockbit.com/placeholders/S.png";
var NAVIGATION_ITEMS = [
    {
        label: "Public Profile",
        value: "public-profile",
        icon: "icon-securities_account_publicprofile",
        url: "/account"
    },
    {
        label: "Preferences",
        value: "preferences",
        icon: "icon-profile_location",
        url: "/preferences"
    },
    {
        label: "Password",
        value: "password",
        icon: "icon-securities-lock",
        url: "/password"
    },
    {
        label: "Notification",
        value: "notification",
        icon: "icon-toolbar_bell",
        url: "/notification"
    },
    {
        label: "Link Account",
        value: "link-account",
        icon: "icon-link-chain",
        url: "/integration"
    },
    {
        label: "Privacy",
        value: "privacy",
        icon: "icon-user-privacy",
        url: "/privacy"
    },
    {
        label: "Share Trade",
        value: "sharetrade",
        icon: "icon-sync-contact",
        url: "/sharetrade"
    },
    {
        label: "Blocked List",
        value: "blocked-list",
        icon: "icon-user-block",
        url: "/blocked"
    },
    {
        label: "Delete Account",
        value: "delete-account",
        icon: "icon-cancel_circle",
        url: "/delete"
    }, 
];
var INDONESIA_CITY_LIST = [
    "Aceh",
    "Ambon",
    "Banjarmasin",
    "Bali",
    "Bandar Lampung",
    "Banten",
    "Bengkulu",
    "Gorontalo",
    "Jambi",
    "Jayapura",
    "Kendari",
    "Kupang",
    "Makassar",
    "Mamuju",
    "Manado",
    "Manokwari",
    "Mataram",
    "Padang",
    "Palangkaraya",
    "Palembang",
    "Palu",
    "Pangkal Pinang",
    "Pekanbaru",
    "Pontianak",
    "Samarinda",
    "Semarang",
    "Sofifi",
    "Tanjung Pinang",
    "Tanjung Selor", 
];
var INDONESIA_PREFERRED_CITY_LIST = [
    "DKI Jakarta",
    "Surabaya",
    "Bandung",
    "Yogyakarta", 
];
var MONTHS = (/* unused pure expression or super */ null && ([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
]));
var SUCCESS_CONTENT = {
    PASSWORD: "Password Sudah Diubah",
    EMAIL: "Email Kamu Sudah Diubah",
    PHONE: "Nomor Hp Kamu Sudah Diubah"
};
var PROGRESS_STATUS_ENUM = {
    no_amend: 1,
    verification: 2,
    in_progress: 3,
    rejected: 4
};
var WORDING_FORMAT_EMAIL_WRONG = "Email yang kamu masukkan tidak valid";
var SHARE_TRADE_PREVIEW = {
    text: "Order Buy TLKM",
    symbol: "TLKM",
    order_type: "ORDER_TYPE_BUY",
    status: "ORDER_STATUS_OPEN",
    updated_status: "UPDATED_STATUS_UNSPECIFIED",
    price: "Rp3,930",
    updated_price: "",
    parent_order_id: "XL1205922VspdLUJrOr7",
    order_time: "2024-06-13T02:30:00Z",
    label: "LABEL_UNSPECIFIED",
    is_show_value: false,
    qty: 0,
    updated_qty: 0,
    total_investment: "Rp3,930,000",
    is_amend_lot: false
};



/***/ }),

/***/ 686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B5": function() { return /* binding */ NavigationHeader; },
/* harmony export */   "BP": function() { return /* binding */ LeftNavigation; },
/* harmony export */   "EU": function() { return /* binding */ RadioButton; },
/* harmony export */   "G_": function() { return /* binding */ PasswordSubmitButton; },
/* harmony export */   "IH": function() { return /* binding */ ProfileSwitch; },
/* harmony export */   "Ky": function() { return /* binding */ ProfileLabel; },
/* harmony export */   "Ol": function() { return /* binding */ CardHeader; },
/* harmony export */   "Tc": function() { return /* binding */ CustomConfigNavigation; },
/* harmony export */   "U1": function() { return /* binding */ ProfileInputGroup; },
/* harmony export */   "WG": function() { return /* binding */ RegionFlag; },
/* harmony export */   "WX": function() { return /* binding */ CardHeaderTextContainer; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "aO": function() { return /* binding */ CardHeaderExtra; },
/* harmony export */   "aj": function() { return /* binding */ NotificationWrapper; },
/* harmony export */   "eX": function() { return /* binding */ SectionLabel; },
/* harmony export */   "hS": function() { return /* binding */ EditProfileContainer; },
/* harmony export */   "ke": function() { return /* binding */ CheckboxLabel; },
/* harmony export */   "kr": function() { return /* binding */ CustomNavigationItem; },
/* harmony export */   "m$": function() { return /* binding */ PasswordCancelButton; },
/* harmony export */   "pr": function() { return /* binding */ EditProfileCard; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "wP": function() { return /* binding */ CardHeaderTitle; },
/* harmony export */   "wy": function() { return /* binding */ PrivacySectionTitle; }
/* harmony export */ });
/* unused harmony exports IconMoreWrapper, Frame, Avatar, NavigationItem, TogglePassword, InputPassword */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 30%;\n  margin-right: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  border: solid 1px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 180px;\n  height: 180px;\n  background: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  background: ",
        ";\n  padding: 15px 29px;\n  border: 1px solid ",
        ";\n  border-bottom: none;\n  border-radius: 2px;\n  width: 100%;\n\n  img {\n    display: block;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-left: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: 'center';\n  align-items: 'flex-end';\n  width: 30px;\n  height: 40px;\n  display: flex;\n  transform: rotate(90deg);\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  transition: background 0.3s;\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n  height: ",
        ";\n\n  &:last-of-type {\n    border-radius: 0 0 3px 3px;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  min-width: 150px;\n  color: ",
        ";\n  text-align: start;\n\n  @media ",
        " {\n    text-align: end;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  margin-bottom: 24px;\n  ",
        "\n\n  .ant-input-group-wrapper {\n    border: none !important;\n  }\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  :checked + label {\n    border-radius: 4px;\n    border: 2px solid ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40px;\n  display: block;\n  position: relative;\n  cursor: pointer;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 8px 2px;\n  font-size: 12px;\n  font-weight: 400;\n  color: ",
        ";\n  padding: 16px 0px 12px !important;\n  width: calc(100% - 16px) !important;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: 100%;\n  padding: 10px 8px;\n  border: none !important;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-right: 3px solid ",
        " !important;\n      background: ",
        ";\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  width: 100%;\n  padding: 24px 20px;\n  border-right: 1px solid ",
        ";\n  align-items: center;\n\n  :hover {\n    border-right: 1px solid ",
        ";\n  }\n\n  &:last-of-type {\n    border-radius: 0 0 3px 3px !important;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-bottom: 0 solid;\n  background: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0;\n  width: 100%;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-card-head-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    margin: 0 -5px;\n  }\n\n  .ant-card-head {\n    border: ",
        ";\n  }\n\n  .ant-card-head-title {\n    font-size: 16px;\n    color: ",
        ";\n    padding: 0;\n  }\n\n  .ant-card-extra {\n    font-size: 14px;\n    margin-left: 0px;\n    padding: 0px;\n  }\n\n  .ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n  }\n\n  @media ",
        " {\n    .ant-card-head-wrapper {\n      display: flex;\n      flex-direction: row;\n      padding: 16px 5px;\n    }\n\n    .ant-card-head-title {\n      margin: 0;\n      padding: 0;\n    }\n\n    .ant-card-extra {\n      font-size: 16px;\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  @media ",
        " {\n    .ant-card-extra {\n      margin: 0;\n      padding: 0;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: -25px;\n  margin-top: 8px;\n  z-index: 99;\n  width: 15px;\n  cursor: pointer;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 95px;\n  height: 35px;\n  border-radius: 2px;\n  border: none;\n  font-family: var(--bold-font);\n  background: ",
        ";\n  color: ",
        ";\n  margin-left: 10px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none !important;\n  min-width: 95px;\n  height: 35px;\n  font-family: var(--bold-font);\n  background: ",
        " !important;\n  color: ",
        " !important;\n  box-shadow: none;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid\n    ",
        " !important;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  width: calc(100% - 210px);\n\n  .ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n\n    &:hover > p {\n      color: #ffffff;\n    }\n  }\n\n  button.ant-btn {\n    box-shadow: none;\n    margin-right: 10px;\n  }\n\n  & > div {\n    border-radius: 3px;\n  }\n\n  @media ",
        " {\n    width: 530px;\n  }\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        border: none;\n      "
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 40px;\n    border-bottom: solid 1px ",
        ";\n\n    ",
        "\n  }\n  .ant-modal-body {\n    padding: 20px;\n  }\n  .ant-modal-footer {\n    padding: 0 !important;\n    text-align: left;\n    display: flex;\n\n    button {\n      border-radius: 3px;\n    }\n  }\n  .ant-modal-close-x {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}



var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Card = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Card */ .Gn.Card, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Input = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Input */ .Gn.Input, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, BaseCheckbox = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Checkbox */ .Gn.Checkbox, ModalAntd = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
var Switch = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Profile.ProfileSwitch */ .NZ.ProfileSwitch, ConfigNavigation = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Profile.ConfigNavigation */ .NZ.ConfigNavigation, ConfigNavigationItem = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Profile.ConfigNavigationItem */ .NZ.ConfigNavigationItem;
var LeftNavigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-0"
})(_templateObject());
var Frame = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    direction: "column",
    align: "center"
}).withConfig({
    componentId: "sc-bca7adff-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var Avatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bca7adff-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.mischka */ .$_.mischka);
var CardHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var CardHeaderTextContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-4"
})(_templateObject4());
var CardHeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).attrs({
    size: "18px"
}).withConfig({
    componentId: "sc-bca7adff-5"
})(_templateObject5());
var CardHeaderExtra = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).attrs({
    size: "14px",
    align: "right",
    color: "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary)
}).withConfig({
    componentId: "sc-bca7adff-6"
})(_templateObject6());
var IconMoreWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-7"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var NavigationItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs(function(props) {
    return {
        isActive: props.isActive || false,
        height: props.height || "40px"
    };
}).withConfig({
    componentId: "sc-bca7adff-8"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, function(param) {
    var height = param.height;
    return height;
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.attrs({
    className: "control-label"
}).withConfig({
    componentId: "sc-bca7adff-9"
})(_templateObject9(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs(function(props) {
    return {
        isFluid: props.isFluid || false,
        align: props.align || "center",
        className: "control-group"
    };
}).withConfig({
    componentId: "sc-bca7adff-10"
})(_templateObject11(), function(param) {
    var isFluid = param.isFluid;
    return isFluid && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject10());
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var RadioButton = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].input.withConfig({
    componentId: "sc-bca7adff-11"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var RegionFlag = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bca7adff-12"
})(_templateObject13());
var CheckboxLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.withConfig({
    componentId: "sc-bca7adff-13"
})(_templateObject14(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis);
var SectionLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].span.withConfig({
    componentId: "sc-bca7adff-14"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var NotificationWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-15"
})(_templateObject16());
var ProfileSwitch = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Switch).withConfig({
    componentId: "sc-bca7adff-16"
})(_templateObject18(), function(param) {
    var checked = param.checked;
    return checked && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject17(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
});
var CustomNavigationItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(ConfigNavigationItem).withConfig({
    componentId: "sc-bca7adff-17"
})(_templateObject20(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject19(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue);
});
var NavigationHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-18"
})(_templateObject21(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var CustomConfigNavigation = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(ConfigNavigation).withConfig({
    componentId: "sc-bca7adff-19"
})(_templateObject22());
var EditProfileCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Card).withConfig({
    componentId: "sc-bca7adff-20"
})(_templateObject23(), function(props) {
    return props.isHideTitle ? "none" : "1px solid #f0f0f0";
}, function(props) {
    return props.isHideTitle ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light) : "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var PrivacySectionTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    width: "100%",
    py: "20px"
}).withConfig({
    componentId: "sc-bca7adff-21"
})(_templateObject24(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseCheckbox).withConfig({
    componentId: "sc-bca7adff-22"
})(_templateObject25(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var TogglePassword = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bca7adff-23"
})(_templateObject26());
var PasswordSubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-bca7adff-24"
})(_templateObject27(), function(props) {
    return props.disabled ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, " !important") : "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
}, function(props) {
    return props.disabled ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, " !important") : "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
});
var PasswordCancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-bca7adff-25"
})(_templateObject28(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray);
var InputPassword = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Input).attrs({
    autoComplete: "new-password"
}).withConfig({
    componentId: "sc-bca7adff-26"
})(_templateObject29(), function(props) {
    return props.error ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange) : "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
});
var EditProfileContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-bca7adff-27"
})(_templateObject30(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.laptop */ .Uh.laptop);
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(ModalAntd).withConfig({
    componentId: "sc-bca7adff-28"
})(_templateObject32(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var noBorder = param.noBorder;
    return noBorder && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject31());
});



/***/ }),

/***/ 5562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);



var initialState = {
    symbol: ""
};
var useFastOrderForm = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setSymbol: function(symbol) {
            set({
                symbol: symbol
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useFastOrderForm);


/***/ }),

/***/ 43774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Ig": function() { return /* binding */ Relative; },
/* harmony export */   "P1": function() { return /* binding */ ButtonNext; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "lk": function() { return /* binding */ ListWrapper; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid #dadada;\n  display: table;\n  font-size: 16px;\n  height: 100%;\n  left: 0;\n  margin: auto;\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 1000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  overflow: auto;\n\n  animation: fade-in-pulse 0.3s forwards cubic-bezier(0.8, 0.02, 0.45, 0.91);\n  transform-origin: bottom center;\n\n  &.ob-discover {\n    @media only screen and (max-height: 600px) {\n      justify-content: flex-start;\n      padding: 48px 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 600px;\n\n  position: relative;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n\n  @media only screen and (max-width: 500px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  span {\n    color: ",
        ";\n    display: block;\n    font-family: ProximaNovaRg;\n    font-size: 13px;\n    font-weight: normal;\n    padding-top: 5px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 480px;\n  margin-bottom: 18px;\n  overflow-y: auto;\n  margin-right: -15px;\n  padding-right: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-color: transparent;\n  cursor: pointer;\n\n  :hover,\n  :focus {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button;
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-4ac4cef-0"
})(_templateObject());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-4ac4cef-1"
})(_templateObject1());
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-4ac4cef-2"
})(_templateObject2());
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    family: "bold",
    size: "18px",
    mx: "auto",
    align: "center"
}).withConfig({
    componentId: "sc-4ac4cef-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray);
var Relative = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-4ac4cef-4"
})(_templateObject4());
var ListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-4ac4cef-5"
})(_templateObject5());
var ButtonNext = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Button).attrs({
    type: "primary"
}).withConfig({
    componentId: "sc-4ac4cef-6"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);



/***/ }),

/***/ 65794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_OfferingSubscription; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/paywall/analytics.ts
var analytics = __webpack_require__(67857);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
;// CONCATENATED MODULE: ./src/features/paywall/Modal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n\n    .ant-modal-close {\n      top: 20px;\n      right: 20px;\n    }\n\n    .ant-modal-close-x {\n      width: 30px;\n      height: 30px;\n      line-height: 30px;\n\n      @media ",
        " {\n        width: 40px;\n        height: 40px;\n        line-height: 40px;\n      }\n    }\n  }\n\n  .ant-modal-header {\n    border-radius: 6px 6px 0 0;\n\n    #header-illustration {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      border-radius: 6px 6px 0 0;\n\n      @media ",
        " {\n        height: 200px;\n      }\n\n      @media ",
        " {\n        height: 300px;\n      }\n    }\n  }\n\n  .ant-modal-body {\n    padding: 0;\n    margin-top: -24px;\n\n    @media ",
        " {\n      margin-top: -36px;\n      margin-bottom: 2px;\n    }\n\n    img#offering-illustration {\n      width: 100%;\n    }\n  }\n\n  .ant-modal-footer {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    padding: 20px;\n    flex-direction: column;\n    gap: 10px;\n\n    @media ",
        " {\n      padding: 40px;\n      flex-direction: row;\n      gap: 20px;\n    }\n\n    button {\n      width: 200px !important;\n      padding: 7px 15px 8px 15px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 140%;\n  color: ",
        ";\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 28px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 2px solid ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-color: #ffffff;\n      background: #ebf8f3;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  padding: 20px 8px 20px 8px;\n\n  border: 1px solid ",
        ";\n  border-radius: 8px;\n  position: relative;\n\n  img.star-left {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  img.star-right {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n  }\n\n  @media ",
        " {\n    padding: 30px 12px 30px 16px;\n    min-height: 124px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  gap: 4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 135%;\n  margin: 0;\n  padding: 0;\n\n  @media ",
        " {\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 18px;\n  margin: 0;\n  padding: 0;\n\n  @media ",
        " {\n    font-size: 13px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components_browser_esm["default"])(ui/* Common.Modal */.Gn.Modal).withConfig({
    componentId: "sc-d4bc1d6b-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet, ui/* device.mobile */.Uh.mobile, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet);
var OfferingContainer = (0,styled_components_browser_esm["default"])(ui/* Common.Flex */.Gn.Flex).attrs({
    direction: "column",
    justify: "center",
    align: "center"
}).withConfig({
    componentId: "sc-d4bc1d6b-1"
})(_templateObject1());
var TextContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4bc1d6b-2"
})(_templateObject2());
var TitleText = styled_components_browser_esm["default"].h5.withConfig({
    componentId: "sc-d4bc1d6b-3"
})(_templateObject3(), ui/* color.highempahis */.$_.highempahis, ui/* device.tablet */.Uh.tablet);
var UnderlinedText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-d4bc1d6b-4"
})(_templateObject4(), ui/* color.primary */.$_.primary);
var ButtonOffer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4bc1d6b-5"
})(_templateObject6(), ui/* color.downgray */.$_.downgray, ui/* device.tablet */.Uh.tablet, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm.css)(_templateObject5());
});
var ButtonTextContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4bc1d6b-6"
})(_templateObject7(), ui/* color.highempahis */.$_.highempahis);
var ButtonTitle = styled_components_browser_esm["default"].h6.withConfig({
    componentId: "sc-d4bc1d6b-7"
})(_templateObject8(), ui/* device.tablet */.Uh.tablet);
var ButtonDescription = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-d4bc1d6b-8"
})(_templateObject9(), ui/* device.tablet */.Uh.tablet);


;// CONCATENATED MODULE: ./src/features/paywall/Modal/OfferingSubscription/Button.tsx





var ButtonOffering = function(param) {
    var title = param.title, description = param.description, iconUrl = param.iconUrl, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, onClick = param.onClick;
    var suffixName = isActive ? "active" : "right";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOffer, {
        onClick: onClick,
        isActive: isActive,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: iconUrl,
                className: "icon"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonDescription, {
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-chevron-").concat(suffixName, ".svg")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: isActive,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-star-left.svg"),
                        className: "star-left"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-star-right.svg"),
                        className: "star-right"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Button = (ButtonOffering);

;// CONCATENATED MODULE: ./src/features/paywall/Modal/OfferingSubscription/index.tsx









function OfferingSubscription(param) {
    var _defaultVisible = param.defaultVisible, defaultVisible = _defaultVisible === void 0 ? false : _defaultVisible, _watchParams = param.watchParams, watchParams = _watchParams === void 0 ? false : _watchParams, onVisibleChange = param.onVisibleChange;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var handleRemoveQuery = function() {
        // Remove offeringProVisible from query
        var restQuery = (0,_object_spread/* default */.Z)({}, query);
        delete restQuery.offeringProVisible;
        router.replace({
            query: restQuery
        }, undefined, {
            shallow: true
        });
    };
    var handleVisibleChange = function(payload) {
        setVisible(payload);
        if (onVisibleChange) {
            onVisibleChange(payload);
        }
    };
    var handleNavigate = function(toUrl) {
        handleVisibleChange(false);
        router.push(toUrl);
    };
    (0,react.useEffect)(function() {
        setVisible(defaultVisible);
    }, [
        defaultVisible
    ]);
    (0,react.useEffect)(function() {
        var ref;
        // Check if query has offeringProVisible
        var hasQueryVisible = (query === null || query === void 0 ? void 0 : query.offeringProVisible) === "true";
        var fromDeepLink = (window === null || window === void 0 ? void 0 : (ref = window.history) === null || ref === void 0 ? void 0 : ref.length) <= 2;
        if (hasQueryVisible && fromDeepLink && watchParams) {
            setVisible(true);
            handleRemoveQuery();
        }
    }, [
        query === null || query === void 0 ? void 0 : query.offeringProVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        centered: true,
        visible: visible,
        onCancel: function() {
            return handleVisibleChange(false);
        },
        maskClosable: false,
        width: 802,
        transitionName: "",
        maskTransitionName: "",
        destroyOnClose: true,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                title: constants/* OfferingPro.open.title */.oz.open.title,
                description: constants/* OfferingPro.open.description */.oz.open.description,
                iconUrl: constants/* OfferingPro.open.iconUrl */.oz.open.iconUrl,
                onClick: function() {
                    analytics/* default.onClickOpenSecurities */.ZP.onClickOpenSecurities();
                    handleNavigate("/securities/auth");
                },
                isActive: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                title: constants/* OfferingPro.subscribe.title */.oz.subscribe.title,
                description: constants/* OfferingPro.subscribe.description */.oz.subscribe.description,
                iconUrl: constants/* OfferingPro.subscribe.iconUrl */.oz.subscribe.iconUrl,
                onClick: function() {
                    analytics/* default.onClickOpenSubscribe */.ZP.onClickOpenSubscribe();
                    handleNavigate("/shop");
                }
            }), 
        ],
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "".concat(constants/* PAYWALL_IMAGE_URL */.HY, "/offering-illustration.svg"),
            id: "header-illustration"
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferingContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleText, {
                        children: constants/* OfferingProText.headline */.pj.headline
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UnderlinedText, {
                                children: constants/* OfferingProText.underlined */.pj.underlined
                            }),
                            " ",
                            constants/* OfferingProText.unlimited */.pj.unlimited
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var Modal_OfferingSubscription = (OfferingSubscription);


/***/ }),

/***/ 74673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29658);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(579);
/* harmony import */ var features_stream_containers_RegistrationStatus_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75823);
/* harmony import */ var features_shop_revamp_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31366);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(333);
/* harmony import */ var lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11733);
/* harmony import */ var _Modal_OfferingSubscription__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(65794);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11298);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35921);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(92182);
/* harmony import */ var _analytics__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67857);















var LockedIcon = "/icon/paywall/locked.svg";
function Paywall(param) {
    var source = param.source, height = param.height, className = param.className, isRenewal = param.isRenewal, _isWidget = param.isWidget, isWidget = _isWidget === void 0 ? false : _isWidget, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,features_stream_containers_RegistrationStatus_store__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), data = ref.data, getRegistrationStatus = ref.getRegistrationStatus;
    var ref1 = (0,_store__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(), page = ref1.page, company = ref1.company, widget = ref1.widget;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), modalVisible = ref2[0], setModalVisible = ref2[1];
    var ref3 = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__/* .selectors */ .wl), list = ref3.products.list, isLoading = ref3.cart.isLoading;
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_7__/* .selectors */ .wl), _data = ref4.data, isPro = _data.ispro;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        dispatch(lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__/* .thunks.fetchProducts */ .CJ.fetchProducts());
        getRegistrationStatus();
    }, []);
    var getLatestSubscription = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var ref = page || {}, pageData = ref.data;
        var ref1 = company || {}, companyData = ref1.data;
        var ref2 = widget || {}, widgetData = ref2.data;
        var lastSubscriptionData = (pageData === null || pageData === void 0 ? void 0 : pageData.last_subscription) || (companyData === null || companyData === void 0 ? void 0 : companyData.last_subscription) || (widgetData === null || widgetData === void 0 ? void 0 : widgetData.last_subscription);
        var selectedList = list === null || list === void 0 ? void 0 : list.find(function(item) {
            return Number(item.id) === (lastSubscriptionData === null || lastSubscriptionData === void 0 ? void 0 : lastSubscriptionData.id);
        });
        dispatch(lib_entities_shop__WEBPACK_IMPORTED_MODULE_8__/* .thunks.continueSubscribe */ .CJ.continueSubscribe({
            selected: selectedList
        }));
    }, [
        list
    ]);
    var analyticsPayload = {
        oldStatus: Boolean(isPro),
        source: source,
        companyID: symbol
    };
    var handleSetModal = function(visible) {
        setModalVisible(visible);
    };
    var handleOpenAccess = function() {
        handleSetModal(true);
        _analytics__WEBPACK_IMPORTED_MODULE_13__/* ["default"].onClickOpenAccess */ .ZP.onClickOpenAccess(analyticsPayload);
    };
    var handleExtendAccess = function() {
        _analytics__WEBPACK_IMPORTED_MODULE_13__/* ["default"].onClickExtendSubscribe */ .ZP.onClickExtendSubscribe(analyticsPayload);
        if ((0,features_shop_revamp_utils__WEBPACK_IMPORTED_MODULE_6__/* .checkIsWaitingAccount */ .fX)(data === null || data === void 0 ? void 0 : data.status)) {
            router.push("/shop");
            return;
        }
        getLatestSubscription();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .PaywallWrapper */ .Qo, {
                className: className,
                style: {
                    height: height || "auto"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        src: LockedIcon,
                        alt: "Paywall"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .TextWrapper */ .OP, {
                        isWidget: isWidget,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .Header */ .h4, {
                                children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .HeaderText */ .z
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .Description */ .dk, {
                                children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .DescriptionText */ .RQ
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .ButtonWrapper */ .W4, {
                        isWidget: isWidget,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .ButtonNew */ .M1, {
                                onClick: handleOpenAccess,
                                children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .ButtonNewText */ .Up
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                condition: isRenewal,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_11__/* .ButtonContinue */ .fr, {
                                    disabled: isLoading,
                                    onClick: handleExtendAccess,
                                    children: _constants__WEBPACK_IMPORTED_MODULE_10__/* .ButtonContinueText */ .cY
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal_OfferingSubscription__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                defaultVisible: modalVisible,
                onVisibleChange: handleSetModal
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Paywall);


/***/ }),

/***/ 55872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60374);
/* harmony import */ var _Paywall__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74673);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92182);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35921);





function PaywallWidget(param) {
    var height = param.height, source = param.source;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var widget = param.widget;
        return {
            isLoading: widget.isLoading,
            isRenewal: widget.isRenewal
        };
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z), isLoading = ref.isLoading, isRenewal = ref.isRenewal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .WidgetWrapper */ .wv, {
        height: height,
        children: !isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paywall__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            source: source,
            isRenewal: isRenewal,
            height: "100%",
            isWidget: true
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PaywallWidget);


/***/ }),

/***/ 67857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lb": function() { return /* binding */ SideWidgetAnalytics; },
/* harmony export */   "Os": function() { return /* binding */ CompanyAnalytics; },
/* harmony export */   "oF": function() { return /* binding */ PageAnalytics; },
/* harmony export */   "wB": function() { return /* binding */ CompanyWidgetAnalytics; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);
/* eslint-disable no-shadow */ 

var PAYWALL = "Paywall Action";
var ACTION = {
    openAccess: "Paywall Open Access Selected",
    extendSubscribe: "Paywall Extend Subscribe Selected",
    openSecurities: "Paywall Open Securities Selected",
    openSubscribe: "Paywall Subscribe Selected",
    paymentSelected: "Paywall Payment Method Selected",
    inputVoucher: "Paywall Input Voucher Selected",
    confirmPayment: "Paywall Payment Confirmation  Selected",
    selectPlan: "Paywall Subscribe Plan Selected",
    confirmSubscribe: "Paywall Subscribe Confirmation Selected",
    submitVoucher: "Paywall Submit Voucher Selected",
    successSubscribe: "Paywall Subscribe Success Selected"
};
var SideWidgetAnalytics;
(function(SideWidgetAnalytics) {
    SideWidgetAnalytics["PRICE_ALERT"] = "Price Alert (Side Bar)";
    SideWidgetAnalytics["RUNNING_TRADE"] = "Running Trade (Side Bar)";
    SideWidgetAnalytics["VALUATION"] = "Valuation (Side Bar)";
    SideWidgetAnalytics["SCREENER"] = "Screener (Side Bar)";
    SideWidgetAnalytics["BANDAR_DETECTOR"] = "Bandar Detector (Side Bar)";
})(SideWidgetAnalytics || (SideWidgetAnalytics = {}));
var PageAnalytics;
(function(PageAnalytics) {
    PageAnalytics["ORDERBOOK"] = "Orderbook (Top Bar)";
    PageAnalytics["SCREENER"] = "Screener (Top Bar)";
    PageAnalytics["VALUATION"] = "Valuation (Top Bar)";
    PageAnalytics["CALENDAR"] = "Calendar (Top Bar)";
    PageAnalytics["EARNINGS"] = "Earnings (Top Bar)";
    PageAnalytics["CHARTBIT"] = "Chartbit (Top Bar)";
})(PageAnalytics || (PageAnalytics = {}));
var CompanyAnalytics;
(function(CompanyAnalytics) {
    CompanyAnalytics["ORDERBOOK"] = "Orderbook (Company)";
    CompanyAnalytics["RUNNING_TRADE"] = "Running Trade (Company)";
    CompanyAnalytics["KEYSTATS"] = "Keystats (Company)";
    CompanyAnalytics["ANALYST"] = "Analysis (Company)";
    CompanyAnalytics["FINANCIALS"] = "Financials (Company)";
    CompanyAnalytics["FUNDACHART"] = "Fundachart (Company)";
    CompanyAnalytics["SEASONALITY"] = "Seasonality (Company)";
    CompanyAnalytics["CHARTBIT"] = "Chartbit (Company)";
    CompanyAnalytics["COMPARISON"] = "Comparison (Company)";
    CompanyAnalytics["INSIDER"] = "Insider (Company)";
    CompanyAnalytics["PROFILE"] = "Company Profile (Company)";
    CompanyAnalytics["CORPACTION"] = "Corporate Action (Company)";
})(CompanyAnalytics || (CompanyAnalytics = {}));
var CompanyWidgetAnalytics = {
    Orderbook: "Orderbook (Company)",
    "Running Trade": "Running Trade (Company)",
    "Trade Book": "Trade Book (Company)",
    "Broker Summary": "Broker Summary (Company)"
};
var PaymentMethod;
(function(PaymentMethod) {
    PaymentMethod["bca_va"] = "BCA";
    PaymentMethod["veritrans"] = "Credit Card";
    PaymentMethod["gopay"] = "Gopay";
})(PaymentMethod || (PaymentMethod = {}));
function formatDuration(durationString) {
    var duration = parseInt(durationString, 10);
    if (Number.isNaN(duration)) {
        return durationString;
    }
    if (durationString.includes("MONTH")) {
        return "".concat(duration, " Bulan");
    }
    if (durationString.includes("YEAR")) {
        return "".concat(duration, " Tahun");
    }
    if (durationString.includes("DAY")) {
        return "".concat(duration, " Hari");
    }
    return durationString;
}
var createPaywallEvent = function(action, params) {
    var oldStatus = params.oldStatus, source = params.source, companyID = params.companyID;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
        Action: action,
        "Old Subscriber Pro": oldStatus,
        Source: source,
        "Company ID": companyID
    });
};
var PaywallAnalytics = {
    onClickOpenAccess: function(params) {
        createPaywallEvent(ACTION.openAccess, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params));
    },
    onClickExtendSubscribe: function(params) {
        createPaywallEvent(ACTION.extendSubscribe, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, params));
    },
    onClickOpenSecurities: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.openSecurities
        });
    },
    onClickOpenSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.openSubscribe
        });
    },
    onClickPaymentSelected: function(paymentMethod) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.paymentSelected,
            "Metode Pembayaran": PaymentMethod[paymentMethod]
        });
    },
    onClickInputVoucher: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.inputVoucher
        });
    },
    onClickConfirmPayment: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.confirmPayment
        });
    },
    onClickSelectPlan: function(plan) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.selectPlan,
            "Subscription Period": formatDuration(plan)
        });
    },
    onClickConfirmSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.confirmSubscribe
        });
    },
    onClickSubmitVoucher: function(voucher) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.submitVoucher,
            Voucher: voucher
        });
    },
    onClickSuccessSubscribe: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(PAYWALL, {
            Action: ACTION.successSubscribe
        });
    }
};
/* harmony default export */ __webpack_exports__["ZP"] = (PaywallAnalytics);


/***/ }),

/***/ 11298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HY": function() { return /* binding */ PAYWALL_IMAGE_URL; },
/* harmony export */   "LB": function() { return /* binding */ CompanyStreamWidget; },
/* harmony export */   "RQ": function() { return /* binding */ DescriptionText; },
/* harmony export */   "Up": function() { return /* binding */ ButtonNewText; },
/* harmony export */   "Uw": function() { return /* binding */ CompanyWidgetEnum; },
/* harmony export */   "cY": function() { return /* binding */ ButtonContinueText; },
/* harmony export */   "gQ": function() { return /* binding */ CompanyWidgetTitle; },
/* harmony export */   "oz": function() { return /* binding */ OfferingPro; },
/* harmony export */   "pj": function() { return /* binding */ OfferingProText; },
/* harmony export */   "qU": function() { return /* binding */ PaywallFeatureEnum; },
/* harmony export */   "t9": function() { return /* binding */ AddOnWidget; },
/* harmony export */   "z": function() { return /* binding */ HeaderText; }
/* harmony export */ });
/* unused harmony exports IncludedNavbar, ExcludeOldPro, ExcludeOldProPage */
/* eslint-disable no-shadow */ var HeaderText = "Kuota Akses Bulanan Sudah Mencapai Limit";
var DescriptionText = "Nikmati akses seluruh fitur tanpa batas dengan membuka rekening saham di Stockbit Sekuritas.";
var ButtonNewText = "Buka Akses";
var ButtonContinueText = "Lanjut Berlangganan";
var PAYWALL_IMAGE_URL = "/img/paywall";
var OfferingPro = {
    open: {
        title: "Buka Rekening Saham",
        description: "Trading saham di Stockbit Sekuritas dan nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-open-icon.svg")
    },
    subscribe: {
        title: "Berlangganan",
        description: "Berlangganan mulai dari Rp10 ribu/hari untuk nikmati semua fitur tanpa batas.",
        iconUrl: "".concat(PAYWALL_IMAGE_URL, "/offering-subscribe-icon.svg")
    }
};
var OfferingProText = {
    headline: "Nikmati Seluruh Fitur",
    underlined: "Profesional Stockbit",
    unlimited: "Tanpa Batas"
};
var PaywallFeatureEnum;
(function(PaywallFeatureEnum) {
    PaywallFeatureEnum["DEFAULT"] = "PAYWALL_FEATURE_UNSPECIFIED";
    PaywallFeatureEnum["KEYSTATS"] = "PAYWALL_FEATURE_KEYSTATS";
    PaywallFeatureEnum["ANALYST"] = "PAYWALL_FEATURE_ANALYSIS";
    PaywallFeatureEnum["FINANCIALS"] = "PAYWALL_FEATURE_FINANCIALS";
    PaywallFeatureEnum["FUNDACHART"] = "PAYWALL_FEATURE_FUNDACHART";
    PaywallFeatureEnum["SEASONALITY"] = "PAYWALL_FEATURE_SEASONALITY";
    PaywallFeatureEnum["CHARTBIT"] = "PAYWALL_FEATURE_CHARTBIT";
    PaywallFeatureEnum["COMPARISON"] = "PAYWALL_FEATURE_COMPARISON";
    PaywallFeatureEnum["INSIDER"] = "PAYWALL_FEATURE_INSIDER";
    PaywallFeatureEnum["PROFILE"] = "PAYWALL_FEATURE_COMPANY_PROFILE";
    PaywallFeatureEnum["CORPACTION"] = "PAYWALL_FEATURE_CORP_ACTION";
    PaywallFeatureEnum["PRICE_ALERT"] = "PAYWALL_FEATURE_PRICE_ALERT";
    PaywallFeatureEnum["RUNNING_TRADE"] = "PAYWALL_FEATURE_RUNNING_TRADE";
    PaywallFeatureEnum["VALUATION"] = "PAYWALL_FEATURE_VALUATION";
    PaywallFeatureEnum["BANDAR_DETECTOR"] = "PAYWALL_FEATURE_BANDAR_DETECTOR";
    PaywallFeatureEnum["ORDERBOOK"] = "PAYWALL_FEATURE_ORDERBOOK";
    PaywallFeatureEnum["SCREENER"] = "PAYWALL_FEATURE_SCREENER";
    PaywallFeatureEnum["CALENDAR"] = "PAYWALL_FEATURE_CALENDAR";
    PaywallFeatureEnum["EARNINGS"] = "PAYWALL_FEATURE_EARNINGS";
})(PaywallFeatureEnum || (PaywallFeatureEnum = {}));
var CompanyWidgetEnum;
(function(CompanyWidgetEnum) {
    CompanyWidgetEnum["FUNDACHART"] = "FUNDACHART";
    CompanyWidgetEnum["SEASONALITY"] = "SEASONALITY";
    CompanyWidgetEnum["COMPARISON"] = "COMPARISON";
    CompanyWidgetEnum["FINANCIALS"] = "FINANCIALS";
})(CompanyWidgetEnum || (CompanyWidgetEnum = {}));
var IncludedNavbar = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "SCREENER",
    "VALUATION",
    "CALENDAR",
    "EARNINGS", 
]));
var CompanyStreamWidget = [
    "ORDERBOOK",
    "RUNNING_TRADE"
];
var CompanyWidgetTitle = {
    ORDERBOOK: "Orderbook",
    RUNNING_TRADE: "Running Trade",
    TRADE_BOOK: "Trade Book",
    BROKER_SUMMARY: "Broker Summary"
};
var AddOnWidget = "VALUATION";
var ExcludeOldPro = (/* unused pure expression or super */ null && ([
    "analyst",
    "insider",
    "profile",
    "corpaction"
]));
var ExcludeOldProPage = (/* unused pure expression or super */ null && ([
    "ORDERBOOK",
    "CALENDAR",
    "EARNINGS"
]));



/***/ }),

/***/ 92182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/config/requestExodus.ts + 1 modules
var requestExodus = __webpack_require__(68425);
;// CONCATENATED MODULE: ./src/lib/api/paywall.ts

var request = (0,requestExodus/* default */.Z)(false);
var GET_ELIGIBILITY_STATUS = "/paywall/eligibility/check";
var POST_PAYWALL_COUNTER = "/paywall/counter/increment";
var getPaywallStatus = function(param) {
    var company = param.company, feature = param.feature;
    var params = {
        features: feature
    };
    if (company) {
        params.company = company;
    }
    return request.get(GET_ELIGIBILITY_STATUS, {
        params: params
    });
};
var getMultipleStatus = function(payload) {
    var company = payload.company, feature = payload.feature;
    var companyQs = company ? "company=".concat(company, "&") : "";
    var featuresQs = feature.map(function(f) {
        return "features=".concat(f);
    }).join("&");
    return request.get("".concat(GET_ELIGIBILITY_STATUS, "?").concat(companyQs).concat(featuresQs));
};
var addPaywallCounter = function(param) {
    var company = param.company, feature = param.feature;
    var body = {
        feature: feature
    };
    if (company) {
        body.company = company;
    }
    return request.post(POST_PAYWALL_COUNTER, body);
};
/* harmony default export */ var paywall = ({
    getPaywallStatus: getPaywallStatus,
    getMultipleStatus: getMultipleStatus,
    addPaywallCounter: addPaywallCounter
});

;// CONCATENATED MODULE: ./src/features/paywall/store/index.ts








var sectionState = {
    isLoading: false,
    isRenewal: false,
    isPro: false,
    data: {
        features: [],
        last_subscription: null,
        company: null
    }
};
var initialState = {
    page: sectionState,
    company: sectionState,
    widget: sectionState
};
var useStorePaywall = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        getStatus: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var ref, key, feature, company, isMultiple, payloadFeature, response, data, ref1, newData, ref2, ref3, selectedData, _is_eligible, defaultError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            key = payload.key, feature = payload.feature, company = payload.company;
                            isMultiple = Array.isArray(feature) && feature.length > 1;
                            payloadFeature = isMultiple ? feature[0] : feature;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[key].isLoading = true;
                            }));
                            if (!isMultiple) {
                                _ctx.next = 12;
                                break;
                            }
                            _ctx.next = 9;
                            return paywall.getMultipleStatus(payload);
                        case 9:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.next = 14;
                            return paywall.getPaywallStatus(payload);
                        case 14:
                            _ctx.t0 = _ctx.sent;
                        case 15:
                            response = _ctx.t0;
                            if (!(!response || !response.data || !response.data.data)) {
                                _ctx.next = 18;
                                break;
                            }
                            throw new Error("Error while fetching paywall status");
                        case 18:
                            data = response.data.data;
                            ;
                            newData = {
                                isPro: false,
                                isRenewal: (ref1 = (data === null || data === void 0 ? void 0 : data.last_subscription) !== null) !== null && ref1 !== void 0 ? ref1 : false,
                                isLoading: false,
                                data: data
                            };
                            if (!(company && data.company)) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            ;
                            newData.isPro = (ref3 = (ref2 = data.company) === null || ref2 === void 0 ? void 0 : ref2.is_eligible) !== null && ref3 !== void 0 ? ref3 : false;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 27:
                            selectedData = (ref = data.features) === null || ref === void 0 ? void 0 : ref.find(function(item) {
                                return item.feature === payloadFeature;
                            });
                            if (selectedData) {
                                ;
                                newData.isPro = (_is_eligible = selectedData.is_eligible) !== null && _is_eligible !== void 0 ? _is_eligible : false;
                            }
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                Object.assign(state[key], newData);
                            }));
                            return _ctx.abrupt("return", data);
                        case 33:
                            _ctx.prev = 33;
                            _ctx.t1 = _ctx["catch"](0);
                            defaultError = "Unknown error while fetching paywall status";
                            if (!(0,_instanceof/* default */.Z)(_ctx.t1, Error)) {
                                _ctx.next = 39;
                                break;
                            }
                            console.error("Error while fetching paywall status: ".concat(_ctx.t1.message));
                            return _ctx.abrupt("return", _ctx.t1.message);
                        case 39:
                            console.error(defaultError);
                            return _ctx.abrupt("return", defaultError);
                        case 41:
                            _ctx.prev = 41;
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state[payload.key].isLoading = false;
                            }));
                            return _ctx.finish(41);
                        case 44:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        33,
                        41,
                        44
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addCounter: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return paywall.addPaywallCounter(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while post paywall counter");
                        case 6:
                            _data = response.data, error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return");
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            if (!(0,_instanceof/* default */.Z)(_ctx.t0, Error)) {
                                _ctx.next = 17;
                                break;
                            }
                            console.error("Error while post paywall counter: ".concat(_ctx.t0.message));
                            return _ctx.abrupt("return");
                        case 17:
                            console.error("Unknown error while post paywall counter");
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetProStatus: function(key) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state[key].isPro = false;
            }));
        }
    });
});
/* harmony default export */ var store = (useStorePaywall);


/***/ }),

/***/ 35921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E3": function() { return /* binding */ CompanyWidgetHeaderTitle; },
/* harmony export */   "M1": function() { return /* binding */ ButtonNew; },
/* harmony export */   "OP": function() { return /* binding */ TextWrapper; },
/* harmony export */   "Qo": function() { return /* binding */ PaywallWrapper; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "XE": function() { return /* binding */ WidgetOrderbookHeader; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "fr": function() { return /* binding */ ButtonContinue; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "iV": function() { return /* binding */ LastPrice; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "j2": function() { return /* binding */ CompanyWidgetWrapper; },
/* harmony export */   "kF": function() { return /* binding */ CompanyWidgetHeader; },
/* harmony export */   "qh": function() { return /* binding */ PaywallPageWrapper; },
/* harmony export */   "wv": function() { return /* binding */ WidgetWrapper; }
/* harmony export */ });
/* unused harmony exports PaywallPage, CustomNotProWrapper, OldNotProContainer, NotProWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var global_NotPro_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92768);
/* harmony import */ var global_NotPro__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89698);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 20px auto auto auto;\n  padding: 80px 0;\n  border-radius: 2px;\n  min-height: 316px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 330px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  background-color: ",
        ";\n\n  & > img {\n    width: 42px;\n    height: 42px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin: 20px auto auto -10px;\n      width: calc(100% + 20px);\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px 20px auto 20px;\n  max-width: none;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  height: auto;\n  max-width: 843px;\n\n  @media ",
        " {\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0px;\n  padding: 50px 0;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 80%;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 700;\n  text-align: center;\n  width: 80%;\n\n  @media ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 400;\n  color: #858585;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      flex-direction: column !important;\n      gap: 8px !important;\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n\n  @media ",
        " {\n    flex-direction: row;\n    gap: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 154px;\n  height: 28px;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: initial;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  border-color: ",
        ";\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  margin-bottom: 20px;\n  position: relative;\n\n  ",
        " {\n    font-size: 13px;\n    line-height: 18px;\n    width: 80%;\n  }\n\n  ",
        " {\n    font-size: 12px;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n  border-bottom: solid 1px ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  line-height: 135%;\n  font-weight: 700;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #121212;\n  border-radius: 3px;\n  padding: 0px 6px;\n\n  & > p {\n    color: ",
        ";\n    font-size: 12px;\n    margin: 0;\n    padding: 2px 0;\n    line-height: initial;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  font-size: 12px;\n  line-height: initial;\n\n  & > p {\n    color: ",
        ";\n    font-size: 12px;\n    margin: 0;\n  }\n\n  & > span {\n    margin-left: 4px;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      border-radius: 2px;\n      height: auto;\n      max-width: 1000px;\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  max-width: none;\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0px;\n  padding: 50px 0;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button;
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var NotProWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-1"
})(_templateObject1());
var PaywallWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var PaywallPageWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(NotProWrapper).withConfig({
    componentId: "sc-b64effa6-3"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileL */ .Uh.mobileL, function(param) {
    var isFlexible = param.isFlexible;
    return isFlexible && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject3());
});
var PaywallPage = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(PaywallWrapper).withConfig({
    componentId: "sc-b64effa6-4"
})(_templateObject5());
var TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-5"
})(_templateObject7(), function(param) {
    var isWidget = param.isWidget;
    return isWidget && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject6());
});
var Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(Text).withConfig({
    componentId: "sc-b64effa6-6"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileL */ .Uh.mobileL);
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(Text).withConfig({
    componentId: "sc-b64effa6-7"
})(_templateObject9());
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-8"
})(_templateObject11(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileL */ .Uh.mobileL, function(param) {
    var isWidget = param.isWidget;
    return isWidget && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject10());
});
var ButtonNew = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(Button).attrs({
    type: "primary"
}).withConfig({
    componentId: "sc-b64effa6-9"
})(_templateObject12());
var ButtonContinue = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(ButtonNew).attrs({
    type: "default"
}).withConfig({
    componentId: "sc-b64effa6-10"
})(_templateObject13(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-11"
})(_templateObject14(), function(param) {
    var height = param.height;
    return height;
});
var CompanyWidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-12"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, Header, Description);
var CompanyWidgetHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-13"
})(_templateObject16(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var CompanyWidgetHeaderTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(Text).attrs({
    type: "h5"
}).withConfig({
    componentId: "sc-b64effa6-14"
})(_templateObject17());
var WidgetOrderbookHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-15"
})(_templateObject18());
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-16"
})(_templateObject19(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var LastPrice = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-b64effa6-17"
})(_templateObject20(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray);
var CustomNotProWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(global_NotPro_styled__WEBPACK_IMPORTED_MODULE_2__/* .NotProWrapper */ .CW).withConfig({
    componentId: "sc-b64effa6-18"
})(_templateObject22(), function(param) {
    var isPro = param.isPro;
    return !isPro && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject21(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
});
var OldNotProContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__["default"])(global_NotPro__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b64effa6-19"
})(_templateObject23());



/***/ }),

/***/ 5072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionEnum; }
/* harmony export */ });
var SectionEnum;
(function(SectionEnum) {
    SectionEnum["page"] = "page";
    SectionEnum["company"] = "company";
    SectionEnum["widget"] = "widget";
})(SectionEnum || (SectionEnum = {}));


/***/ }),

/***/ 14348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EU": function() { return /* binding */ RadioButton; },
/* harmony export */   "Ee": function() { return /* binding */ RadioGroup; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "dC": function() { return /* binding */ BoxResult; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29924);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 658px;\n  margin: auto;\n  padding-bottom: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border: solid 1px ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: solid 1px ",
        ";\n  color: ",
        ";\n  font-family: var(--bold-font);\n  font-size: 16px;\n  padding: 10px 20px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  width: 80px;\n  text-align: center;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n\n  &.ant-radio-button-wrapper-checked:not([class*=' ant-radio-button-wrapper-disabled']).ant-radio-button-wrapper:first-child {\n    border-right-color: ",
        ";\n  }\n\n  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    color: ",
        ";\n    background: ",
        ";\n    border-color: ",
        ";\n\n    &::before {\n      background-color: ",
        ";\n    }\n\n    &:first-child {\n      border-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex;
var AntGroup = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Group */ .ZP.Group, AntButton = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Button */ .ZP.Button;
var Container = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-99879ea1-0"
})(_templateObject());
var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-99879ea1-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var BoxResult = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-99879ea1-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray);
var RadioGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(AntGroup).withConfig({
    componentId: "sc-99879ea1-3"
})(_templateObject3());
var RadioButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(AntButton).withConfig({
    componentId: "sc-99879ea1-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);


/***/ }),

/***/ 26941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LoginInputPin; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/LoginInputPin/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 48px !important;\n  height: 56px;\n  font-size: 24px;\n  border-radius: 8px;\n  text-align: center;\n  margin-right: 10px;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &:focus {\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Input = ui/* Common.Input */.Gn.Input;
var LoginInputNumber = (0,styled_components_browser_esm["default"])(Input).withConfig({
    componentId: "sc-b2d8f557-0"
})(_templateObject(), ui/* color.primary */.$_.primary);

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/LoginInputPin/LoginInputPin.tsx







var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var KEY_CODE_BACKSPACE = 8;
var KEY_CODE_DELETE = 46;
function LoginInputPin(param) {
    var onLogin = param.onLogin, errorMsg = param.errorMsg;
    var inputRef = (0,react.useRef)((0,_to_consumable_array/* default */.Z)(Array(6)).map(function() {
        return /*#__PURE__*/ (0,react.createRef)();
    }));
    var ref = (0,react.useState)((0,_to_consumable_array/* default */.Z)(Array(6))), inputValue = ref[0], setInputValue = ref[1];
    (0,react.useEffect)(function() {
        inputRef.current[0].current.focus();
        return function() {
            return setInputValue((0,_to_consumable_array/* default */.Z)(Array(6)));
        };
    }, []);
    var onChangeInput = function(e) {
        return function(index) {
            var value = e.target.value;
            var newInputValue = (0,_to_consumable_array/* default */.Z)(inputValue);
            if (newInputValue.join("").length === 6) return;
            if (e.keyCode !== KEY_CODE_BACKSPACE && e.keyCode !== KEY_CODE_DELETE) {
                // eslint-disable-next-line prefer-destructuring
                newInputValue[index] = value[0];
                setInputValue(newInputValue);
                window.requestAnimationFrame(function() {
                    if (index < 5 && inputRef.current[index].current.value !== "") {
                        inputRef.current[index + 1].current.focus();
                    }
                    if (index === 5 && newInputValue[5] !== undefined && newInputValue.join("").length === 6) {
                        onLogin(newInputValue.join(""));
                        (0,securities/* clevertapSecuritiesTradingPinSubmitted */.FH)();
                    }
                });
            }
            if (e.keyCode === KEY_CODE_BACKSPACE) {
                newInputValue[index] = "";
                setInputValue(newInputValue);
                window.requestAnimationFrame(function() {
                    if (index > 0 && index <= 5) {
                        inputRef.current[index - 1].current.focus();
                    }
                });
            }
        };
    };
    var onKeyDown = function(e) {
        return function(index) {
            var numKeyValue = Number(e.key);
            var newInputValue = (0,_to_consumable_array/* default */.Z)(inputValue);
            if (Number.isNaN(numKeyValue) && e.keyCode !== KEY_CODE_BACKSPACE) {
                e.preventDefault();
                return;
            }
            if (e.keyCode === KEY_CODE_BACKSPACE) {
                newInputValue[index] = "";
                setInputValue(newInputValue);
                window.requestAnimationFrame(function() {
                    if (index > 0 && index <= 5) {
                        inputRef.current[index - 1].current.focus();
                    }
                });
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                justify: "center",
                width: "100%",
                children: (0,_to_consumable_array/* default */.Z)(Array(6)).map(function(_, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginInputNumber, {
                        "data-cy": "input-pin-".concat(i),
                        type: "password",
                        name: "auth-modal-input-pin",
                        autoComplete: "new-password",
                        autoFocus: true,
                        ref: inputRef.current[i],
                        value: inputValue[i],
                        onChange: function(e) {
                            return onChangeInput(e)(i);
                        },
                        onKeyDown: function(e) {
                            return onKeyDown(e)(i);
                        },
                        onFocus: function(e) {
                            return e.target.select();
                        }
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: errorMsg !== "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    align: "center",
                    color: ui/* color.sunsetOrange */.$_.sunsetOrange,
                    mt: "24px",
                    "data-cy": "input-pin-error",
                    children: errorMsg
                })
            })
        ]
    });
};
LoginInputPin.defaultProps = {
    errorMsg: ""
};


/***/ }),

/***/ 62450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AuthModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOpeningAccountStore.ts
var useOpeningAccountStore = __webpack_require__(8948);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-body {\n    padding: 40px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 360px;\n  min-height: 492px;\n  background-color: #5dcbad26;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 391px;\n  padding: 40px 32px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1px;\n  height: 144px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 185px;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var Flex = ui/* Common.Flex */.Gn.Flex, Modal = ui/* Common.Modal */.Gn.Modal;
var AuthModalContainer = (0,styled_components_browser_esm["default"])(Modal).withConfig({
    componentId: "sc-22dc24f-0"
})(_templateObject());
var ProgressRejectedAuthModalContainer = (0,styled_components_browser_esm["default"])(AuthModalContainer).withConfig({
    componentId: "sc-22dc24f-1"
})(_templateObject1());
var LoginTradingModalContainer = (0,styled_components_browser_esm["default"])(AuthModalContainer).withConfig({
    componentId: "sc-22dc24f-2"
})(_templateObject2());
var CarouselContainer = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-22dc24f-3"
})(_templateObject3());
var RegisterInfoContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-22dc24f-4"
})(_templateObject4());
var RegisterInfoDivider = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-22dc24f-5"
})(_templateObject5(), ui/* color.downgray */.$_.downgray);
var LoginInfoDivider = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-22dc24f-6"
})(_templateObject6(), ui/* color.downgray */.$_.downgray);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/VirtualTradingButton/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid ",
        ";\n  justify-content: ",
        ";\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Button = ui/* Common.Button */.Gn.Button;
var VirtualTradingButtonContainer = (0,styled_components_browser_esm["default"])(Button).attrs(function(props) {
    return {
        justify: props.justify || "center"
    };
}).withConfig({
    componentId: "sc-7e181066-0"
})(styled_templateObject(), ui/* color.downgray */.$_.downgray, function(param) {
    var justify = param.justify;
    return justify;
});

// EXTERNAL MODULE: ./src/features/securities/AuthModal/types.ts
var types = __webpack_require__(41110);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/global/VirtualTrading/stores/useFormulaStore.ts
var useFormulaStore = __webpack_require__(62544);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var AuthModal_store = __webpack_require__(70175);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/hooks/useVirtualLogin.ts













var useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
function useVirtualLogin(setLoading) {
    var resetErrorCode = useTradingStore().resetErrorCode;
    var showTradingModal = (0,store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var ref = (0,AuthModal_store/* default */.Z)(), closeModal = ref.closeModal, tradingModalConfig = ref.tradingModalConfig;
    var loadFormula = (0,useFormulaStore/* default */.Z)(function(s) {
        return s.loadFormula;
    });
    var loadLoginVirtual = (0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return s.loadLoginVirtual;
    });
    var switchToVirtual = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return loadLoginVirtual();
                    case 4:
                        _ctx.next = 6;
                        return loadFormula();
                    case 6:
                        resetErrorCode();
                        (0,AlertErrorMessage/* default */.Z)("Kamu berhasil masuk ke Akun Virtual Trading", "plain-green");
                        if (tradingModalConfig !== null && !tradingModalConfig.onVirtualLoginSuccess) {
                            showTradingModal((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tradingModalConfig), {
                                orderType: constants/* AUTH_MODAL_CONFIG.virtual */.n.virtual[tradingModalConfig.orderType]
                            }));
                        }
                        if (tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.onVirtualLoginSuccess) {
                            tradingModalConfig.onVirtualLoginSuccess();
                        }
                        closeModal();
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,logger/* default */.ZP)(Error("Failed to Switch to Virtual"), {
                            event: "useVirtualLogin@switchToVirtual"
                        });
                    case 16:
                        setLoading(false);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function switchToVirtual() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        switchToVirtual: switchToVirtual
    };
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/VirtualTradingButton/VirtualTradingButton.tsx







var VirtualTradingButton_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
function VirtualTradingButton(param) {
    var title = param.title, type = param.type, setLoading = param.setLoading;
    var switchToVirtual = useVirtualLogin(setLoading).switchToVirtual;
    var _obj;
    var imgWidth = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types/* AuthModalType.LOGIN */.O.LOGIN, "40px"), (0,_define_property/* default */.Z)(_obj, types/* AuthModalType.REGISTER */.O.REGISTER, "40px"), (0,_define_property/* default */.Z)(_obj, types/* AuthModalType.PROGRESS */.O.PROGRESS, "32px"), _obj);
    var getTitle = function() {
        if (type === types/* AuthModalType.REGISTER */.O.REGISTER) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                family: "bold",
                ml: "8px",
                children: [
                    "Virtual ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " Trading"
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
            family: "bold",
            ml: "8px",
            children: title
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingButtonContainer, {
        "data-cy": "virtual-trading-button-auth",
        width: type === types/* AuthModalType.REGISTER */.O.REGISTER ? "50%" : "",
        justify: type === types/* AuthModalType.REGISTER */.O.REGISTER ? "left" : "center",
        onClick: switchToVirtual,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTradingButton_Flex, {
            justify: "center",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "virtual-trading",
                    src: "/img/virtual.svg",
                    width: imgWidth[type]
                }),
                getTitle()
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/Carousel/constants.ts
var CAROUSEL_DATA = [
    {
        url: "/img/illustration_1.svg",
        title: "Biaya Broker yang Rendah",
        description: "Fee beli 0,15%. Fee jual 0,25%"
    },
    {
        url: "/img/illustration_2.svg",
        title: "Gratis Stockbit Pro",
        description: "Setiap nasabah dapat akses Stockbit Pro tanpa biaya."
    },
    {
        url: "/img/illustration_4.svg",
        title: "Tanpa Minimal Deposit",
        description: "Mulai investasi tanpa modal besar."
    },
    {
        url: "/img/illustration_5.svg",
        title: "Buka Rekening 1 Hari Kerja",
        description: "Tanpa perlu kirim dokumen fisik."
    }, 
];

// EXTERNAL MODULE: ./node_modules/antd/es/carousel/index.js + 9 modules
var carousel = __webpack_require__(61980);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/Carousel/styled.ts

function Carousel_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  top: -24px;\n\n  .slick-prev,\n  .slick-next {\n    z-index: 1;\n    display: none !important;\n  }\n\n  &:hover .slick-prev,\n  &:hover .slick-next {\n    display: block !important;\n  }\n\n  .slick-next {\n    right: 16px;\n  }\n\n  .slick-prev {\n    left: 16px;\n  }\n\n  .slick-dots {\n    width: auto;\n\n    li {\n      width: 2px;\n      bottom: -24px;\n    }\n\n    li button {\n      background: gray;\n      width: 5px;\n      height: 5px;\n      border-radius: 10px;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    li.slick-active {\n      width: 13px;\n      margin-right: 0;\n    }\n\n    li.slick-active button {\n      width: 13px;\n      height: 5px;\n      background: ",
        ";\n      border: unset;\n    }\n  }\n"
    ]);
    Carousel_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 300px !important;\n  margin: auto;\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto 24px;\n  width: 200px;\n  height: 200px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var styled_Flex = ui/* Common.Flex */.Gn.Flex;
var AuthModalCarousel = (0,styled_components_browser_esm["default"])(carousel/* default */.Z).withConfig({
    componentId: "sc-d288d4eb-0"
})(Carousel_styled_templateObject(), ui/* color.primary */.$_.primary);
var CarouselItemContainer = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-d288d4eb-1"
})(styled_templateObject1());
var CarouselImage = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-d288d4eb-2"
})(styled_templateObject2());

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/Carousel/Carousel.tsx





var Carousel_Text = ui/* Common.Text */.Gn.Text;
function Carousel() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            maxWidth: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalCarousel, {
            autoplay: true,
            arrows: true,
            nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/next-arrow.svg",
                alt: "next arrow"
            }),
            prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/prev-arrow.svg",
                alt: "previous arrow"
            }),
            children: CAROUSEL_DATA.map(function(param) {
                var url = param.url, title = param.title, description = param.description;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CarouselItemContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselImage, {
                            alt: title,
                            src: url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_Text, {
                            family: "bold",
                            align: "center",
                            size: "20px",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel_Text, {
                            align: "center",
                            mt: "12px",
                            size: "16px",
                            children: description
                        })
                    ]
                });
            })
        })
    });
};

// EXTERNAL MODULE: ./src/features/securities/AuthModal/components/LoginInputPin/LoginInputPin.tsx + 1 modules
var LoginInputPin = __webpack_require__(26941);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js
var spin = __webpack_require__(11382);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/AuthModalLoading/AuthModalLoading.tsx




var AuthModalLoading_Flex = ui/* Common.Flex */.Gn.Flex, AuthModalLoading_Text = ui/* Common.Text */.Gn.Text;
var loadingIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
    style: {
        fontSize: 24,
        color: ui/* color.highgray */.$_.highgray
    },
    spin: true
});
function AuthModalLoading() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModalLoading_Flex, {
        "data-cy": "auth-modal-loading",
        direction: "column",
        justify: "center",
        align: "center",
        width: "100%",
        height: "374px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                indicator: loadingIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalLoading_Text, {
                color: "#858585",
                mt: "16px",
                children: "Authenticating..."
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/components/index.tsx






// EXTERNAL MODULE: ./src/constants/trading.ts
var constants_trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/typings/auth.ts
var auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/hooks/useLogin.ts





















var useLogin_useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
function useLogin() {
    var resetErrorCode = useLogin_useTradingStore().resetErrorCode;
    var getConfigFormula = (0,tradingData/* default */.Z)().getConfigFormula;
    var showTradingModal = (0,store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var ref = (0,AuthModal_store/* default */.Z)(), closeModal = ref.closeModal, tradingModalConfig = ref.tradingModalConfig;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useSecuritiesCredentialStore/* default */.Z)(function(s) {
        return [
            s.loadLoginReal,
            s.loadLogout
        ];
    }, shallow/* default */.Z), 2), loadLoginReal = ref1[0], loadLogout = ref1[1];
    var loadBooleanEvaluation = (0,useFliptStore/* default */.Z)(function(s) {
        return s.loadBooleanEvaluation;
    });
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var getUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue;
    });
    var resetUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.resetUIValue;
    });
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(""), errorMsg = ref3[0], setErrorMsg = ref3[1];
    var handleErrorNewCore = function(error) {
        var ref;
        var ref1, ref2;
        var ref3 = (ref2 = (ref1 = error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data) !== null && ref1 !== void 0 ? ref1 : error === null || error === void 0 ? void 0 : error.cause) !== null && ref2 !== void 0 ? ref2 : {}, errorType = ref3.error_type, message = ref3.message;
        if (errorType === "INVALID_CREDS") {
            setErrorMsg(message);
        }
        if (errorType !== "INVALID_CREDS") {
            closeModal();
        }
    };
    var handleErrorLegacy = function(message) {
        if (message) {
            setErrorMsg(message);
        }
        if (!message) {
            closeModal();
        }
    };
    var checkDailyMaintenance = function() {
        return trading/* default.getState */.Z.getState().errorType === "DAILY_MAINTENANCE_MODE";
    };
    var onLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(pin) {
            var isDailyMaintenance, SPLIT_ORDER, isOnboardingShown, ref, message, isUserNewCore;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return resetUIValue(auth/* LoginType.Securities */.B.Securities);
                    case 4:
                        _ctx.next = 6;
                        return loadLoginReal(pin);
                    case 6:
                        isDailyMaintenance = checkDailyMaintenance();
                        if (!isDailyMaintenance) {
                            _ctx.next = 11;
                            break;
                        }
                        {
                            loadLogout();
                        }
                        _ctx.next = 24;
                        break;
                    case 11:
                        SPLIT_ORDER = flagKeys/* FeatureFlagKeys.SPLIT_ORDER */.O.SPLIT_ORDER;
                        _ctx.next = 14;
                        return getConfigFormula();
                    case 14:
                        _ctx.next = 16;
                        return loadBooleanEvaluation(SPLIT_ORDER);
                    case 16:
                        setErrorMsg("");
                        resetErrorCode();
                        (0,AlertErrorMessage/* default */.Z)("Kamu berhasil masuk ke Akun Trading", "plain-green");
                        // Show day trade onboarding
                        setUIValue("dayTradeSubAccountActive", false);
                        isOnboardingShown = getUIValue("dayTradeTncShown");
                        if (!isOnboardingShown) {
                            showTradingModal({
                                modalData: {
                                    showDayTradeOnboarding: true
                                }
                            });
                        }
                        if (tradingModalConfig !== null && !tradingModalConfig.onRealLoginSuccess) {
                            showTradingModal((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tradingModalConfig), {
                                orderType: constants/* AUTH_MODAL_CONFIG.real */.n.real[tradingModalConfig.orderType]
                            }));
                        }
                        if (tradingModalConfig === null || tradingModalConfig === void 0 ? void 0 : tradingModalConfig.onRealLoginSuccess) {
                            tradingModalConfig.onRealLoginSuccess();
                        }
                    case 24:
                        closeModal();
                        _ctx.next = 33;
                        break;
                    case 27:
                        _ctx.prev = 27;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        message = ((ref = _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause) !== null && ref !== void 0 ? ref : {}).message;
                        isUserNewCore = (0,utils/* getTargetAPI */.Ai)() === constants_trading/* UserTargetAPI.NEW_CORE */.FA.NEW_CORE;
                        if (!isUserNewCore) {
                            handleErrorLegacy(message);
                        } else {
                            handleErrorNewCore(_ctx.t0);
                        }
                    case 33:
                        setLoading(false);
                    case 34:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    27
                ]
            ]);
        }));
        return function onLogin(pin) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        loading: loading,
        setLoading: setLoading,
        errorMsg: errorMsg,
        setErrorMsg: setErrorMsg,
        onLogin: onLogin
    };
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/LoginTradingModal.tsx














var LoginTradingModal_Flex = ui/* Common.Flex */.Gn.Flex, LoginTradingModal_Text = ui/* Common.Text */.Gn.Text;
var LoginTradingModal_useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
function LoginTradingModal(param) {
    var visible = param.visible;
    var resetErrorCode = LoginTradingModal_useTradingStore().resetErrorCode;
    var closeModal = (0,AuthModal_store/* default */.Z)().closeModal;
    var ref = useLogin(), errorMsg = ref.errorMsg, setErrorMsg = ref.setErrorMsg, loading = ref.loading, setLoading = ref.setLoading, onLogin = ref.onLogin;
    var closeLoginModal = function() {
        resetErrorCode();
        setErrorMsg("");
        closeModal();
    };
    (0,react.useEffect)(function() {
        setErrorMsg("");
        if (visible) {
            (0,securities/* clevertapSecuritiesTradingPinViewed */.fn)();
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModalContainer, {
        "data-cy": "login-trading-modal",
        visible: visible,
        centered: true,
        width: 500,
        onCancel: closeLoginModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginTradingModal_Flex, {
            direction: "column",
            justify: "center",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    className: "illustration",
                    alt: "securities-lock",
                    src: "icon/securities-lock.svg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: loading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalLoading, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                    condition: !loading,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModal_Text, {
                            size: "24px",
                            family: "bold",
                            mt: "48px",
                            mb: "24px",
                            children: "Masukkan PIN Trading"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginInputPin/* default */.Z, {
                            onLogin: onLogin,
                            errorMsg: errorMsg
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/securities/forgotpin",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModal_Flex, {
                                onClick: closeLoginModal,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModal_Text, {
                                    size: "14px",
                                    family: "bold",
                                    color: ui/* color.primary */.$_.primary,
                                    mt: "24px",
                                    mb: "48px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "data-cy": "auth-modal-forgot-pin",
                                        children: "Lupa Pin?"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginTradingModal_Flex, {
                            width: "100%",
                            justify: "space-between",
                            align: "center",
                            mb: "48px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginInfoDivider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModal_Text, {
                                    family: "bold",
                                    color: ui/* color.midgray */.$_.midgray,
                                    children: "Or"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginInfoDivider, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingButton, {
                            title: "Virtual Trading",
                            type: types/* AuthModalType.LOGIN */.O.LOGIN,
                            setLoading: setLoading
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/ProgressAuthModal.tsx









var ProgressAuthModal_Text = ui/* Common.Text */.Gn.Text;
function ProgressAuthModal(param) {
    var visible = param.visible;
    var closeModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.closeModal;
    });
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProgressRejectedAuthModalContainer, {
        "data-cy": "progress-auth-modal",
        visible: visible,
        centered: true,
        width: 500,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: loading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalLoading, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: !loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/img/auth-progress.svg",
                        alt: "Registrasi Kamu Dalam Proses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressAuthModal_Text, {
                        align: "center",
                        family: "bold",
                        size: "16px",
                        mt: "30px",
                        mb: "13px",
                        children: "Registrasi Kamu Dalam Proses"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressAuthModal_Text, {
                        align: "center",
                        mb: "30px",
                        color: ui/* color.highgray */.$_.highgray,
                        width: "284px",
                        children: "Mohon ditunggu sebentar lagi. Registrasi kamu masih dalam tahap verifikasi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingButton, {
                        title: "Coba Virtual Trading",
                        type: types/* AuthModalType.PROGRESS */.O.PROGRESS,
                        setLoading: setLoading
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/features/securities/AuthModal/RegisterTradingModal.tsx










var RegisterTradingModal_Flex = ui/* Common.Flex */.Gn.Flex, RegisterTradingModal_Text = ui/* Common.Text */.Gn.Text;
function RegisterTradingModal(param) {
    var visible = param.visible;
    var closeModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.closeModal;
    });
    var ref = (0,react.useState)(false), loading = ref[0], setloading = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalContainer, {
        "data-cy": "register-trading-modal",
        visible: visible,
        centered: true,
        width: 751,
        onCancel: closeModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterTradingModal_Flex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselContainer, {
                    justify: "center",
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterInfoContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: loading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModalLoading, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: !loading,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal_Text, {
                                    family: "bold",
                                    size: "24px",
                                    mb: "8px",
                                    children: "Mulai Investasi di Saham bersama Stockbit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal_Text, {
                                    mb: "40px",
                                    children: "Download aplikasi Stockbit untuk membuka akun trading dan mulai perjalanan investasimu dengan lebih mudah. Scan QR Code di bawah ini."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterTradingModal_Flex, {
                                    justify: "space-between",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterTradingModal_Flex, {
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    href: api/* GOOGLE_PLAY_URL */.VE,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "android",
                                                        src: "/images/google-play.png",
                                                        style: {
                                                            height: "40px",
                                                            marginBottom: "24px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    href: api/* APP_STORE_URL */.l5,
                                                    rel: "noopener noreferrer",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: "iOS",
                                                        src: "/images/app-store.png",
                                                        style: {
                                                            height: "40px"
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterInfoDivider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/img/stockbit-qr.svg",
                                            alt: "stockbit app qr code"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RegisterTradingModal_Flex, {
                                    justify: "space-between",
                                    align: "center",
                                    mt: "40px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal_Text, {
                                            size: "16px",
                                            color: "#858585",
                                            children: "Or Switch Platform"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingButton, {
                                            title: "Virtual Trading",
                                            type: types/* AuthModalType.REGISTER */.O.REGISTER,
                                            setLoading: setloading
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/RejectedAuthModal.tsx





var RejectedAuthModal_Flex = ui/* Common.Flex */.Gn.Flex, RejectedAuthModal_Text = ui/* Common.Text */.Gn.Text, RejectedAuthModal_Button = ui/* Common.Button */.Gn.Button;
function RejectedAuthModal(param) {
    var visible = param.visible;
    var closeModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.closeModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressRejectedAuthModalContainer, {
        "data-cy": "rejected-auth-modal",
        visible: visible,
        centered: true,
        width: 364,
        onCancel: closeModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RejectedAuthModal_Flex, {
            direction: "column",
            justify: "center",
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/img/stockbit-qr.svg",
                    alt: "stockbit app qr code"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal_Text, {
                    align: "center",
                    mt: "2px",
                    mb: "30px",
                    children: "Scan QR Code"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal_Text, {
                    family: "bold",
                    size: "16px",
                    align: "center",
                    mb: "13px",
                    children: "Verifikasi Data Belum Berhasil"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal_Text, {
                    align: "center",
                    mb: "30px",
                    color: ui/* color.highgray */.$_.highgray,
                    children: "Silakan scan QR Code di atas atau buka aplikasi Stockbit kamu dan perbaiki data sesuai dengan instruksi."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal_Button, {
                    type: "primary",
                    width: "100%",
                    radius: "4px",
                    onClick: closeModal,
                    "data-cy": "rejected-auth-modal-btn",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal_Text, {
                        family: "bold",
                        color: ui/* color.light */.$_.light,
                        padding: "12px",
                        children: "Oke"
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/features/securities/AuthModal/index.tsx












function AuthModal() {
    var authModalVisible = (0,AuthModal_store/* default */.Z)(function(s) {
        return s.visible;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOpeningAccountStore/* default */.Z)(function(s) {
        return [
            s.status,
            s.loadAccountStatus
        ];
    }, shallow/* default */.Z), 2), oaStatus = ref[0], loadAccountStatus = ref[1];
    (0,react.useEffect)(function() {
        loadAccountStatus();
    }, [
        loadAccountStatus
    ]);
    var accountNotRegistered = [
        types/* AuthModalStatus.UNREGISTERED */.X.UNREGISTERED,
        types/* AuthModalStatus.INCOMPLETE */.X.INCOMPLETE, 
    ].includes(oaStatus);
    var accountOnProgress = [
        types/* AuthModalStatus.CS */.X.CS,
        types/* AuthModalStatus.KSEI */.X.KSEI,
        types/* AuthModalStatus.RDN */.X.RDN, 
    ].includes(oaStatus);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
        condition: authModalVisible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: accountNotRegistered,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterTradingModal, {
                    visible: accountNotRegistered
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: accountOnProgress,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressAuthModal, {
                    visible: accountOnProgress
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: oaStatus === types/* AuthModalStatus.REJECTED */.X.REJECTED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RejectedAuthModal, {
                    visible: oaStatus === types/* AuthModalStatus.REJECTED */.X.REJECTED
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: oaStatus === types/* AuthModalStatus.COMPLETED */.X.COMPLETED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginTradingModal, {
                    visible: oaStatus === types/* AuthModalStatus.COMPLETED */.X.COMPLETED
                })
            })
        ]
    });
};


/***/ }),

/***/ 41110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ AuthModalType; },
/* harmony export */   "X": function() { return /* binding */ AuthModalStatus; }
/* harmony export */ });
var AuthModalType;
(function(AuthModalType) {
    AuthModalType["LOGIN"] = "login";
    AuthModalType["REGISTER"] = "register";
    AuthModalType["PROGRESS"] = "progress";
})(AuthModalType || (AuthModalType = {}));
var AuthModalStatus;
(function(AuthModalStatus) {
    AuthModalStatus[AuthModalStatus["UNREGISTERED"] = 0] = "UNREGISTERED";
    AuthModalStatus[AuthModalStatus["INCOMPLETE"] = 1] = "INCOMPLETE";
    AuthModalStatus[AuthModalStatus["CS"] = 2] = "CS";
    AuthModalStatus[AuthModalStatus["KSEI"] = 3] = "KSEI";
    AuthModalStatus[AuthModalStatus["RDN"] = 4] = "RDN";
    AuthModalStatus[AuthModalStatus["REJECTED"] = 99] = "REJECTED";
    AuthModalStatus[AuthModalStatus["COMPLETED"] = 100] = "COMPLETED";
})(AuthModalStatus || (AuthModalStatus = {}));


/***/ }),

/***/ 13799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ specialMonitoring; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
;// CONCATENATED MODULE: ./src/constants/contents/special-monitoring.ts
var SESSION_A = [
    {
        session: 1,
        orderCollection: "09:00 - 09:55",
        randomClosing: "09:53 - 09:55",
        orderMatching: "09:55 - 10:00"
    },
    {
        session: 2,
        orderCollection: "10:00 - 10:55",
        randomClosing: "10:53 - 10:55",
        orderMatching: "10:55 - 11:00"
    },
    {
        session: 3,
        orderCollection: "11:00 - 11:55",
        randomClosing: "11:53 - 11:55",
        orderMatching: "11:55 - 12:00"
    },
    {
        session: 4,
        orderCollection: "14:00 - 14:55",
        randomClosing: "14:53 - 14:55",
        orderMatching: "14:55 - 15:00"
    },
    {
        session: 5,
        orderCollection: "15:00 - 15:55",
        randomClosing: "15:53 - 15:55",
        orderMatching: "15:55 - 16:00"
    }, 
];
var SESSION_B = [
    {
        session: 1,
        orderCollection: "09:00 - 09:55",
        randomClosing: "09:53 - 09:55",
        orderMatching: "09:55 - 10:00"
    },
    {
        session: 2,
        orderCollection: "10:00 - 11:25",
        randomClosing: "11:23 - 11:25",
        orderMatching: "11:25 - 11:30"
    },
    {
        session: 3,
        orderCollection: "14:00 - 14:55",
        randomClosing: "14:53 - 14:55",
        orderMatching: "14:55 - 15:00"
    },
    {
        session: 4,
        orderCollection: "15:00 - 15:55",
        randomClosing: "15:53 - 15:55",
        orderMatching: "15:55 - 16:00"
    }, 
];
var CRITERIA = [
    {
        id: 1,
        content: "Harga rata-rata saham selama enam bulan terakhir di pasar reguler kurang dari Rp51. Kriteria ini tidak berlaku untuk perusahaan tercatat yang ada di papan akselerasi."
    },
    {
        id: 2,
        content: "Laporan keuangan auditan terakhir perusahaan terdapat disclaimer. Dengan aturan ini, bursa tidak perlu menunggu perusahaan tercatat mendapat opini disclaimer dua kali, tetapi bursa bisa langsung memasukkan perusahaan ke dalam pemantauan khusus."
    },
    {
        id: 3,
        content: "Memiliki ekuitas negatif pada laporan keuangan terakhir. Pada saat ini, bursa tidak menunggu laporan keuangan tahunan, tapi berdasarkan laporan keuangan interim per Maret, Juni, atau September."
    },
    {
        id: 4,
        content: "Memiliki anak perusahaan yang kontribusi pendapatannya material bagi perusahaan tercatat, dan juga anak perusahaan tersebut dalam kondisi dimohonkan PKPU atau pailit."
    }, 
];
var SPECIAL_INFO = {
    date: "25 Maret 2024",
    auction: "Full Call Auction"
};
var SESSION_A_EXISTING = [
    {
        session: "I",
        orderCollection: "09.00 - 11.55 WIB",
        processingOrder: "11.55 - 12.00 WIB"
    },
    {
        session: "II",
        orderCollection: "13.25 - 15.55 WIB",
        processingOrder: "15.55 - 16.00 WIB"
    }, 
];
var SESSION_B_EXISTING = [
    {
        session: "I",
        orderCollection: "09.00 - 11.25 WIB",
        processingOrder: "11.25 - 11.30 WIB"
    },
    {
        session: "II",
        orderCollection: "13.55 - 15.55 WIB",
        processingOrder: "15.55 - 16.00 WIB"
    }, 
];
var SPECIAL_INFO_EXISTING = {
    date: "12 Juni 2023",
    auction: "Hybrid Call Auction"
};
var FULL_CALL_AUCTION = [
    {
        label: "Input Order",
        inclusion: [
            true,
            false,
            false
        ]
    },
    {
        label: "Amend",
        inclusion: [
            true,
            false,
            false
        ]
    },
    {
        label: "Withdraw",
        inclusion: [
            true,
            false,
            true
        ]
    }, 
];
var EXISTING_CONTENT = {
    SESSION_A: SESSION_A_EXISTING,
    SESSION_B: SESSION_B_EXISTING,
    CRITERIA: CRITERIA,
    SPECIAL_INFO: SPECIAL_INFO_EXISTING,
    FULL_CALL_AUCTION: FULL_CALL_AUCTION
};
/* harmony default export */ var special_monitoring = ({
    SESSION_A: SESSION_A,
    SESSION_B: SESSION_B,
    CRITERIA: CRITERIA,
    SPECIAL_INFO: SPECIAL_INFO,
    FULL_CALL_AUCTION: FULL_CALL_AUCTION
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/securities/static/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    width: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StaticPageContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3f001eb0-0"
})(_templateObject(), function(props) {
    return props.mode === "dark" ? "#121212" : ui/* color.light */.$_.light;
});

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: 1px dashed;\n  border-color: ",
        ";\n  border-width: 1px 0 0;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  padding-bottom: 20px;\n  margin: 0 auto;\n  max-width: 500px;\n\n  @media screen and (max-width: 500px) {\n    margin: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid\n    ",
        ";\n  border-radius: 4px;\n  margin-top: 20px;\n\n  &:first-child {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n  border-bottom: 1px solid\n    ",
        ";\n\n  h1 {\n    font-size: 14px;\n    font-family: var(--bold-font);\n    line-height: 19px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px 20px;\n\n  .special-monitoring-session-container {\n    margin-top: 20px;\n\n    p {\n      margin-bottom: 8px;\n    }\n\n    .special-monitoring-session-item {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n  }\n\n  ul {\n    padding-inline-start: 24px;\n\n    li {\n      margin-bottom: 20px;\n\n      &::marker {\n        color: ",
        ";\n      }\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var Divider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-c7645d67-0"
})(styled_templateObject(), function(props) {
    return props.mode === "dark" ? "rgb(238 238 238 / 25%)" : "rgb(238 238 238 / 95%)";
});
var SpecialMonitoringContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c7645d67-1"
})(_templateObject1());
var SpecialMonitoringCard = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c7645d67-2"
})(_templateObject2(), function(props) {
    return props.mode === "dark" ? "#2e2e2e" : ui/* color.downgray */.$_.downgray;
});
var SpecialMonitoringHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c7645d67-3"
})(_templateObject3(), function(props) {
    return props.mode === "dark" ? "#2e2e2e" : ui/* color.downgray */.$_.downgray;
});
var SpecialMonitoringBody = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c7645d67-4"
})(_templateObject4(), function(props) {
    return props.mode === "dark" ? ui/* color.lowgray */.$_.lowgray : ui/* color.highempahis */.$_.highempahis;
});

// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/components/SessionItem.tsx



var Text = ui/* Common.Text */.Gn.Text, Flex = ui/* Common.Flex */.Gn.Flex;
function SessionItem(param) {
    var session = param.session, idx = param.idx, color = param.color, _isExisting = param.isExisting, isExisting = _isExisting === void 0 ? false : _isExisting;
    var sessionContent = session;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        justify: "space-between",
        width: "100%",
        mt: "14px",
        direction: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                size: "12px",
                color: color,
                width: "40px",
                children: [
                    "Sesi ",
                    sessionContent.session
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        direction: "column",
                        width: "98px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                size: "12px",
                                color: "#858585",
                                mb: "4px",
                                children: "Order Collection"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                size: "12px",
                                family: "bold",
                                color: color,
                                children: sessionContent.orderCollection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isExisting,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                direction: "column",
                                width: "98px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "12px",
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Random Closing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "12px",
                                        family: "bold",
                                        color: color,
                                        children: sessionContent.randomClosing
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                direction: "column",
                                width: "98px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "12px",
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Order Matching"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        size: "12px",
                                        family: "bold",
                                        color: color,
                                        children: sessionContent.orderMatching
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }, "".concat(sessionContent.session, "-").concat(idx + 1, "-session-a"));
};

;// CONCATENATED MODULE: ./src/features/securities/static/information/specialMonitoring/index.tsx








var specialMonitoring_Text = ui/* Common.Text */.Gn.Text, specialMonitoring_Flex = ui/* Common.Flex */.Gn.Flex;
var SpecialMonitoringInformation = function(param) {
    var _mode = param.mode, mode = _mode === void 0 ? "light" : _mode;
    var CONTENT = special_monitoring;
    var textColor = (0,react.useMemo)(function() {
        return mode === "dark" ? ui/* color.lowgray */.$_.lowgray : ui/* color.highempahis */.$_.highempahis;
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticPageContainer, {
        mode: mode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                family: "bold",
                                color: textColor,
                                children: "Kapan transaksi saya akan diproses?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBody, {
                            mode: mode,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                    color: textColor,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Order saat Full Call Auction"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(specialMonitoring_Flex, {
                                    justify: "space-between",
                                    width: "100%",
                                    mt: "12px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            size: "12px",
                                            color: textColor,
                                            width: "70px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Order Collection"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Random Closing"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            size: "12px",
                                            color: "#858585",
                                            width: "70px",
                                            align: "center",
                                            children: "Order Matching"
                                        })
                                    ]
                                }),
                                CONTENT.FULL_CALL_AUCTION.map(function(content, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(specialMonitoring_Flex, {
                                        justify: "space-between",
                                        width: "100%",
                                        mt: "12px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                                size: "12px",
                                                color: textColor,
                                                width: "70px",
                                                family: "bold",
                                                children: content.label
                                            }),
                                            content.inclusion.map(function(inclusion) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Flex, {
                                                    align: "center",
                                                    justify: "center",
                                                    width: "70px",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: inclusion ? "/icon/ic-check-green.svg" : "/icon/ic-close-red.svg"
                                                    })
                                                });
                                            })
                                        ]
                                    }, "".concat(content.label, "-").concat(idx + 1, "-fca"));
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                                    mode: mode,
                                    dashed: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(specialMonitoring_Text, {
                                    color: textColor,
                                    children: [
                                        "Transaksi kamu akan diproses pada masa",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Order Matching"
                                        }),
                                        "."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(specialMonitoring_Flex, {
                                    direction: "column",
                                    my: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            family: "bold",
                                            color: textColor,
                                            children: "Senin-Kamis"
                                        }),
                                        CONTENT.SESSION_A.map(function(session, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                                session: session,
                                                idx: idx,
                                                color: textColor
                                            }, "".concat(session.session, "-").concat(idx + 1, "-session-a"));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {
                                    mode: mode,
                                    dashed: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(specialMonitoring_Flex, {
                                    direction: "column",
                                    my: "20px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            family: "bold",
                                            color: textColor,
                                            children: "Jumat"
                                        }),
                                        CONTENT.SESSION_B.map(function(session, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionItem, {
                                                session: session,
                                                idx: idx,
                                                color: textColor
                                            }, "".concat(session.session, "-").concat(idx + 1, "-session-b"));
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                family: "bold",
                                color: textColor,
                                children: "Kenapa saya tidak bisa langsung beli saham ini?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringBody, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(specialMonitoring_Text, {
                                color: textColor,
                                children: [
                                    "Per tanggal ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: CONTENT.SPECIAL_INFO.date
                                    }),
                                    ", Bursa Efek Indonesia menerapkan mekanisme",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: CONTENT.SPECIAL_INFO.auction
                                    }),
                                    " untuk saham di papan pemantauan khusus."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringCard, {
                    mode: mode,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringHeader, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                family: "bold",
                                color: textColor,
                                children: "Apa kriteria saham dalam pemantauan khusus?"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringBody, {
                            mode: mode,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: special_monitoring.CRITERIA.map(function(criteria, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring_Text, {
                                            color: textColor,
                                            children: criteria.content
                                        })
                                    }, "".concat(criteria.id, "-").concat(idx + 1, "-criteria"));
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var specialMonitoring = (SpecialMonitoringInformation);


/***/ }),

/***/ 38639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ ContainerTemplateWrapper; },
/* harmony export */   "JK": function() { return /* binding */ InputPINContainer; },
/* harmony export */   "Ky": function() { return /* binding */ ProfileLabel; },
/* harmony export */   "N5": function() { return /* binding */ InputTokenContainer; },
/* harmony export */   "U1": function() { return /* binding */ ProfileInputGroup; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l2": function() { return /* binding */ UserRdnInfoContainer; }
/* harmony export */ });
/* unused harmony exports Button, BaseIconmoon, BaseInput, PageContainer, CarouselContainer, RightSection, VirtualButtonContainer, Carousel, CarouselItemContainer, CarouselImage, VirtualButton, LoginButton, RegisterButton, Input, InputPINForm, RegisterContainer, BannerRegisterContainer, BackButton, InfoRegisterContainer, Iconmoon, GrayBackButton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61980);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: hidden;\n  position: relative;\n  margin-top: 60px;\n  height: calc(100vh - 60px);\n\n  @media ",
        " {\n    margin-top: 103px;\n    height: calc(100vh - 103px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background: #5dcbad26;\n    padding: 30px;\n    height: calc(100vh - 60px);\n    max-height: 100%;\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  background: ",
        ";\n  padding: 30px;\n  overflow-y: auto;\n\n  @media ",
        " {\n    /* height: 95vh;\n    max-height: 100%; */\n    height: calc(100vh - 101px);\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 300px;\n  margin-bottom: 50px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 50px;\n  height: 100%;\n  max-height: 550px;\n  margin-top: 23%;\n\n  .slick-dots {\n    width: auto;\n    bottom: -60px;\n\n    li {\n      width: unset;\n    }\n\n    li button {\n      background: gray;\n      width: 5px;\n      height: 5px;\n      border-radius: 10px;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    li.slick-active button {\n      width: 25px;\n      height: 5px;\n      background: ",
        ";\n      border: unset;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 240px;\n  margin: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto 25px;\n  width: 180px;\n  height: 180px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px auto;\n  padding: 10px 15px;\n  border-radius: 10px;\n  background: transparent;\n\n  img {\n    margin-right: 10px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n  padding: 6px;\n  border: 1px solid ",
        ";\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &\n    .ant-form-item-has-error\n    .ant-input-affix-wrapper-focused.securities-input-pin,\n  & .ant-form-item-has-error .ant-input-affix-wrapper,\n  & .ant-form-item-has-error .securities-input-pin:hover {\n    border-color: ",
        " !important;\n    box-shadow: none;\n  }\n\n  & .ant-form-item-explain.ant-form-item-explain-error {\n    margin-top: 4px;\n    min-height: 19px;\n\n    div {\n      display: flex;\n      align-items: center;\n      font-size: 12px;\n      line-height: 1.5;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .eye {\n    position: absolute;\n    right: 10px;\n    width: 16px;\n    cursor: pointer;\n  }\n\n  .withdrawal-input-pin {\n    padding: 0;\n\n    &.ant-input-affix-wrapper {\n      padding: 0;\n      margin-bottom: 4px;\n    }\n\n    .ant-input-prefix {\n      background: ",
        ";\n      margin-right: 12px;\n      padding: 11px;\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-input-group-addon {\n    background: ",
        ";\n  }\n\n  .securities-input-pin {\n    margin: 15px 0 5px;\n    height: 35px;\n    padding-left: 45px;\n\n    &::placeholder {\n      font-family: var(--bold-font);\n      color: #e4e4e4;\n    }\n\n    &.ant-input-affix-wrapper-focused {\n      border-color: ",
        ";\n      box-shadow: none;\n    }\n  }\n\n  .ant-input-group .ant-input {\n    width: 85%;\n  }\n\n  .icon-password.input-prefix {\n    position: absolute;\n    top: 15px;\n    left: 0;\n    width: 35px;\n    height: 35px;\n    text-align: center;\n    line-height: 35px;\n    border-right: 1px solid ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  height: 585px;\n  max-width: 798px;\n  margin: 20px auto;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  position: relative;\n  width: 40%;\n  padding: 20px;\n\n  img {\n    position: absolute;\n    right: 0;\n    top: 170px;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  height: 35px;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 40px;\n  border-left: 1px solid ",
        ";\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:before {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  position: absolute;\n  top: 25px;\n  left: 20px;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin: 0 auto;\n  height: fit-content;\n  border-radius: 4px;\n  width: ",
        ";\n\n  &.deposit-section-instruction {\n    border: none;\n    border-radius: 0;\n    min-height: 100%;\n\n    i.icon-up-arrow {\n      transform: rotate(-90deg);\n      font-size: 14px;\n      color: ",
        ";\n    }\n  }\n\n  .header {\n    height: 56px;\n    padding: 0 20px;\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      margin-bottom: 0;\n    }\n\n    .back-btn {\n      background: none;\n      border: none;\n      min-width: 30px;\n      width: fit-content;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding: 0;\n    }\n\n    .title {\n      font-family: var(--bold-font);\n      font-size: 18px;\n      line-height: 24px;\n      text-align: center;\n      color: ",
        ";\n    }\n\n    .right-header {\n      text-align: right;\n\n      .history-link {\n        font-size: 18px;\n        line-height: 24px;\n        text-align: right;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: nowrap;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: ",
        ";\n  text-align: left;\n\n  img {\n    display: block;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n  }\n\n  .text-content {\n    flex-grow: 1;\n    font-size: 14px;\n    line-height: 19px;\n    padding: 0 16px;\n    overflow: hidden;\n\n    p {\n      margin-bottom: 0;\n      line-height: 21px;\n    }\n\n    .rdn-name {\n      color: ",
        ";\n      word-break: break-word;\n      margin-bottom: 4px;\n    }\n\n    .rdn-account {\n      font-family: var(--bold-font);\n      color: ",
        ";\n      font-size: 13.5px;\n    }\n  }\n\n  .btn-copy {\n    background-color: #ebf6ef;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    color: ",
        ";\n    padding: 8px 10px;\n    border-radius: 4px;\n    border: none;\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  width: 30%;\n  color: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  margin: 25px 0;\n  width: 100%;\n\n  &.small-margin {\n    margin: 5px 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .input-token {\n    border: 1px solid ",
        ";\n    height: 36px;\n    input {\n      border: none;\n      font-size: 16px;\n      padding: 5px;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}




var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, BaseIconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon, BaseInput = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Input */ .Gn.Input;
var PageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var RightSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var VirtualButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f7e724-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Carousel = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f7e724-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var CarouselItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-5"
})(_templateObject5());
var CarouselImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f7e724-6"
})(_templateObject6());
var VirtualButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-f7e724-7"
})(_templateObject7());
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-f7e724-8"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var RegisterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-f7e724-9"
})(_templateObject9(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseInput).withConfig({
    componentId: "sc-f7e724-10"
})(_templateObject10());
var InputPINForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f7e724-11"
})(_templateObject11(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange);
var InputPINContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f7e724-12"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var RegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-13"
})(_templateObject13(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray);
var BannerRegisterContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-f7e724-14"
})(_templateObject14(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var BackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-f7e724-15"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var InfoRegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-16"
})(_templateObject16(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var Iconmoon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseIconmoon).withConfig({
    componentId: "sc-f7e724-17"
})(_templateObject17(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var GrayBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseIconmoon).withConfig({
    componentId: "sc-f7e724-18"
})(_templateObject18(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var ContainerTemplateWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f7e724-19"
})(_templateObject19(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var width = param.width;
    if (typeof width === "number") return "".concat(width, "px");
    return width;
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.midgray */ .$_.midgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var UserRdnInfoContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f7e724-20"
})(_templateObject20(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray, function(param) {
    var padding = param.padding;
    if (padding) {
        if (typeof padding === "number") return "".concat(padding, "px");
        return padding;
    }
    return "16px 24px";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].label.withConfig({
    componentId: "sc-f7e724-21"
})(_templateObject21(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-22"
})(_templateObject22());
var InputTokenContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-f7e724-23"
})(_templateObject23(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);


/***/ }),

/***/ 17921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ formatShiftedCurrency; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "VZ": function() { return /* binding */ getMostMinMaxAmountRules; },
/* harmony export */   "i$": function() { return /* binding */ isOverDailyLimit; },
/* harmony export */   "iM": function() { return /* binding */ formatPricePercentage; },
/* harmony export */   "kI": function() { return /* binding */ isUnderDailyLimit; },
/* harmony export */   "qF": function() { return /* binding */ formatBondDate; },
/* harmony export */   "uJ": function() { return /* binding */ formatBondCurrency; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);


// eslint-disable-next-line import/prefer-default-export
var formatBondDate = function(date) {
    if (!date) {
        return "-";
    }
    var formatFullMonthId = Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });
    return formatFullMonthId.format(new Date(date));
};
var formatBondCurrency = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "IDR";
    return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(value).replace(/\s+/g, "");
};
var formatPricePercentage = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never";
    if (typeof value !== "number") {
        return "-";
    }
    var rawValue = value / 100;
    return Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(rawValue);
};
var formatCurrency = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rp";
    return "".concat(currency).concat(Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    }));
};
var formatShiftedCurrency = function(value) {
    var fixZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, fractionDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Rp";
    var isNegative = value <= 0;
    var absoluteValue = Math.abs(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
    var formattedValue = "".concat(currency).concat(absoluteValue);
    if (fixZero && value === 0) return "".concat(formattedValue);
    return "".concat(isNegative ? "- " : "").concat(formattedValue);
};
var formatPrice = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
};
var formatNumber = function(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
};
var isOverDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && remaining < amount.min && (inputValue > remaining || inputValue > dailyMax);
};
var isUnderDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && inputValue <= dailyMax && remaining >= amount.min && inputValue > remaining;
};
var getMostMinMaxAmountRules = function(methods) {
    if (methods === null || methods === void 0 ? void 0 : methods.length) {
        var _Math, _Math1;
        var amounts = methods.map(function(method) {
            return method.amount;
        });
        var min = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.min;
        })));
        var max = (_Math1 = Math).max.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.max;
        })));
        return {
            min: min,
            max: max
        };
    }
    return {
        min: 0,
        max: 0
    };
};


/***/ }),

/***/ 30196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "As": function() { return /* binding */ trackChatCompanySymbol; },
/* harmony export */   "Jw": function() { return /* binding */ trackChatPreviousOrder; },
/* harmony export */   "RA": function() { return /* binding */ trackAllowMemberShareTrade; },
/* harmony export */   "eD": function() { return /* binding */ trackMemberActivateNow; },
/* harmony export */   "mA": function() { return /* binding */ trackConfirmedMemberAutoShare; },
/* harmony export */   "tM": function() { return /* binding */ trackGroupAutoShare; }
/* harmony export */ });
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var roomTypeValue = {
    ROOM_TYPE_PERSONAL: "Personal",
    ROOM_TYPE_GROUP: "Group",
    ROOM_TYPE_BROADCAST: "Broadcast"
};
// Action
var trackGroupAutoShare = function(roomId, isAdmin, isAutoShareOn) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Group Chat Action", {
        Action: "Group Chat Auto-Share Trade Selected",
        "Room ID": roomId,
        "Member Type": isAdmin ? "Admin" : "Non Admin",
        "Auto Share": isAutoShareOn ? "On" : "Off"
    });
};
var trackAllowMemberShareTrade = function(roomId, isAutoShareOn) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Group Chat Action", {
        Action: "Group Chat Allow Member Share Trade Selected",
        "Room ID": roomId,
        "Enable Member Share": isAutoShareOn ? "On" : "Off"
    });
};
var trackMemberActivateNow = function(roomId) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Member Activate Now Selected",
        "Room ID": roomId
    });
};
var trackConfirmedMemberAutoShare = function(roomId) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Confirmed Member Auto-Share",
        "Room ID": roomId
    });
};
var trackChatCompanySymbol = function(roomId, messageId, symbol, orderStatus, roomType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Chat Company Symbol Selected",
        "Room ID": roomId,
        "Message ID": messageId,
        Symbol: symbol,
        "Order Status": orderStatus,
        "Chat Room Type": roomTypeValue[roomType]
    });
};
var trackChatPreviousOrder = function(roomId, messageId, symbol, orderStatus, roomType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Chat See Previous Order Company Symbol Selected",
        "Room ID": roomId,
        "Message ID": messageId,
        Symbol: symbol,
        "Order Status": orderStatus,
        "Chat Room Type": roomTypeValue[roomType]
    });
};


/***/ }),

/***/ 56371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ trackOrderDetailShareSelected; },
/* harmony export */   "J4": function() { return /* binding */ trackShareSelected; },
/* harmony export */   "M1": function() { return /* binding */ trackOrderShareSelected; },
/* harmony export */   "cP": function() { return /* binding */ trackTradeSharedViewed; },
/* harmony export */   "g3": function() { return /* binding */ trackOrderViewed; },
/* harmony export */   "tE": function() { return /* binding */ trackDoneSelected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56644);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2078);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);




var _obj;
var orderActionValue = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .iX.Buy, "Buy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .iX.Sell, "Sell"), _obj);
var _obj1;
var symbolTypeValue = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Right */ .Z.Right, "Right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Waran */ .Z.Waran, "Warrant"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Saham */ .Z.Saham, "Normal"), _obj1);
var _obj2;
var expiryValue = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodForDay */ .ZM.GoodForDay, "Good for day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, "Good till canceled"), _obj2);
var _obj3;
var statusValue = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Open */ .iF.Open, "Open"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Partial */ .iF.Partial, "Partial"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Match */ .iF.Match, "Match"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Withdrawn */ .iF.Withdrawn, "Withdrawn"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Amended */ .iF.Amended, "Amended"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Rejected */ .iF.Rejected, "Rejected"), _obj3);
// Views
var trackOrderViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Order Viewed");
};
var trackTradeSharedViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Trade Shared Viewed");
};
var trackOrderShareSelected = function(type, symbol) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Share Selected"), {
        Action: "".concat(action, " Order Share Selected"),
        Symbol: symbol
    });
};
// Actions
var trackOrderDetailShareSelected = function(type, orderId, symbol, symbolType, expiry, rejectReason, status) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Detail Share Selected"), {
        Action: "".concat(action, " Order Detail Share Selected"),
        "Order ID": orderId,
        Symbol: symbol,
        "Symbol Type": symbolTypeValue[symbolType] || "Normal",
        Expiry: expiryValue[expiry],
        "Reject Reason": rejectReason,
        Status: statusValue[status]
    });
};
var trackShareSelected = function(symbol, isAddAutoShare) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Share Selected",
        Symbol: symbol,
        "Add Auto Share": isAddAutoShare
    });
};
var trackDoneSelected = function(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Done Selected",
        Symbol: symbol
    });
};


/***/ }),

/***/ 20242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalShareConfirm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/features/chat/MainContent/BubbleChat/ShareTradeAttachment.tsx + 4 modules
var ShareTradeAttachment = __webpack_require__(82906);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var entities_profile = __webpack_require__(333);
// EXTERNAL MODULE: ./src/features/sharetrade/components/ModalShareTrade/styled.ts
var styled = __webpack_require__(15350);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
// EXTERNAL MODULE: ./src/global/Avatar/index.tsx + 1 modules
var Avatar = __webpack_require__(72317);
// EXTERNAL MODULE: ./src/typings/api/shareTradeTarget.ts
var shareTradeTarget = __webpack_require__(32070);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/UserItem/styled.ts
var UserItem_styled = __webpack_require__(45205);
// EXTERNAL MODULE: ./src/features/edit-profile/ShareTrade/styled.ts
var ShareTrade_styled = __webpack_require__(35614);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareConfirm/UserItem.tsx







function UserItem(param) {
    var avatarUrl = param.avatarUrl, name = param.name, alias = param.alias, description = param.description, targetType = param.targetType, _isVerified = param.isVerified, isVerified = _isVerified === void 0 ? false : _isVerified, _defaultSwitchValue = param.defaultSwitchValue, defaultSwitchValue = _defaultSwitchValue === void 0 ? false : _defaultSwitchValue, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange;
    var ref = (0,react.useState)(defaultSwitchValue), isSwitchChecked = ref[0], setIsSwitchChecked = ref[1];
    var handleChangeSwitch = function(checked) {
        setIsSwitchChecked(checked);
        onSwitchChange(checked);
    };
    (0,react.useEffect)(function() {
        setIsSwitchChecked(defaultSwitchValue);
    }, [
        defaultSwitchValue
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        align: "middle",
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 22,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* UserInfoRow */.f9, {
                    align: "middle",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 4,
                            className: "avatar-col",
                            children: [
                                targetType === shareTradeTarget/* TargetType.User */.L.User && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: avatarUrl,
                                    alt: name
                                }),
                                targetType === shareTradeTarget/* TargetType.ChatRoom */.L.ChatRoom && /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    src: avatarUrl,
                                    children: avatarUrl ? undefined : alias
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 20,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItem_styled/* NameWrapper */.yB, {
                                    align: "middle",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTrade_styled/* Text */.xv, {
                                            weight: "bold",
                                            children: name
                                        }),
                                        isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* IconVerified */.HG, {
                                            src: "/icon/verified.svg",
                                            alt: "icon-verified"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem_styled/* Description */.dk, {
                                    size: "12px",
                                    lineHeight: "16px",
                                    color: "#969696",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_switch/* default */.Z, {
                    checked: isSwitchChecked,
                    onChange: handleChangeSwitch,
                    size: "small"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/styled.ts
var BaseModal_styled = __webpack_require__(89997);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareConfirm/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 20px;\n  }\n\n  & ",
        " {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  & ",
        " {\n    margin-bottom: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 20px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n  span {\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n    width: 70%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #ededed;\n\n  .share-preview {\n    width: 100% !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 16px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 8px 16px;\n  border-top: 1px solid #ededed;\n\n  max-height: 250px;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  & > .ant-row {\n    margin: 8px 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid #ededed;\n  padding: 12px 20px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm["default"])(BaseModal/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-0"
})(_templateObject(), BaseModal_styled/* Title */.Dx, BaseModal_styled/* HeaderRow */.VJ);
var HeaderRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-1"
})(_templateObject1());
var ContentRow = (0,styled_components_browser_esm["default"])(row/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-2"
})(_templateObject2());
var ContentCard = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-3"
})(_templateObject3());
var CardHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-78c5c9ad-4"
})(_templateObject4());
var CardLists = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-78c5c9ad-5"
})(_templateObject5());
var FooterCol = (0,styled_components_browser_esm["default"])(col/* default */.Z).withConfig({
    componentId: "sc-78c5c9ad-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareConfirm/index.tsx











function ModalShareConfirm(_param) {
    var _title = _param.title, title = _title === void 0 ? "Review Share Trade" : _title, _width = _param.width, width = _width === void 0 ? 430 : _width, selectedUsers = _param.selectedUsers, previewShareTrade = _param.previewShareTrade, isLoading = _param.isLoading, _filterSelected = _param.filterSelected, filterSelected = _filterSelected === void 0 ? false : _filterSelected, _onConfirm = _param.onConfirm, onConfirm = _onConfirm === void 0 ? function() {} : _onConfirm, _onSwitchChange = _param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "width",
        "selectedUsers",
        "previewShareTrade",
        "isLoading",
        "filterSelected",
        "onConfirm",
        "onSwitchChange",
        "onCancel"
    ]);
    var ref;
    var ref1 = (0,es/* useSelector */.v9)(entities_profile/* selectors */.wl), profile = ref1.data;
    var isEmptyUsers = filterSelected && ((ref = selectedUsers === null || selectedUsers === void 0 ? void 0 : selectedUsers.filter(function(param) {
        var is_selected = param.is_selected;
        return is_selected;
    })) === null || ref === void 0 ? void 0 : ref.length) === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        width: width,
        onCancel: onCancel
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Your Investment amount will be shared to these contact(s)"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentRow, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentCard, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareTradeAttachment/* default */.Z, {
                                info: previewShareTrade,
                                username: profile.username,
                                isVerified: false,
                                usernameColor: "#94B041",
                                hidePreviousOrder: false,
                                hideUsername: false,
                                onPreviousOrderClick: function() {},
                                isPreview: true
                            })
                        }),
                        !isEmptyUsers && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLists, {
                            children: selectedUsers === null || selectedUsers === void 0 ? void 0 : selectedUsers.map(function(user) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserItem, {
                                    avatarUrl: user.avatar_url,
                                    name: user.name,
                                    alias: user.shortened_name,
                                    targetType: user.type,
                                    description: user.description,
                                    isVerified: user.is_verified,
                                    defaultSwitchValue: user.is_share_value || false,
                                    onSwitchChange: function(checked) {
                                        return onSwitchChange(checked, user);
                                    }
                                }, user.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCol, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                    align: "middle",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SubmitButton */.Mm, {
                            type: "primary",
                            onClick: onConfirm,
                            loading: isLoading,
                            disabled: isLoading,
                            block: true,
                            children: "Confirm"
                        })
                    })
                })
            })
        ]
    }));
};


/***/ }),

/***/ 15350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ ListTitle; },
/* harmony export */   "GY": function() { return /* binding */ AgreementRow; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "Mm": function() { return /* binding */ SubmitButton; },
/* harmony export */   "NL": function() { return /* binding */ AgreementText; },
/* harmony export */   "Te": function() { return /* binding */ ErrorState; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "Z7": function() { return /* binding */ UserList; },
/* harmony export */   "bZ": function() { return /* binding */ Alert; },
/* harmony export */   "mE": function() { return /* binding */ AgreementDescription; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "zg": function() { return /* binding */ FooterCol; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19521);
/* harmony import */ var features_edit_profile_ShareTrade_UserList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21504);
/* harmony import */ var global_Alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26142);
/* harmony import */ var global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47756);
/* harmony import */ var global_Modal_BaseModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16981);
/* harmony import */ var global_Modal_BaseModal_styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89997);
/* harmony import */ var features_edit_profile_ShareTrade_ErrorState__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54949);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 20px;\n  }\n\n  & ",
        " {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  & ",
        " {\n    margin-bottom: 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 16px;\n  text-align: left;\n\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n\n  margin-bottom: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 19px;\n  height: 35px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n\n  color: #969696;\n\n  padding: 16px 0 0;\n  margin: 0 0 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-row {\n    padding: 0 20px;\n  }\n  height: 356px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid #ededed;\n  padding: 12px 20px 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n  height: min-content;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  color: #333333;\n\n  margin: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  color: #969696;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  border-radius: 4px;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  &.ant-btn-primary[disabled] {\n    background: #8cd9bc !important;\n    color: #ffffff !important;\n\n    &:hover > p {\n      color: #ffffff;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 226px;\n\n  & p {\n    margin-bottom: 4px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}








var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_Modal_BaseModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-0"
})(_templateObject(), global_Modal_BaseModal_styled__WEBPACK_IMPORTED_MODULE_5__/* .Title */ .Dx, global_Modal_BaseModal_styled__WEBPACK_IMPORTED_MODULE_5__/* .HeaderRow */ .VJ);
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-1"
})(_templateObject1());
var Alert = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_Alert__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-2"
})(_templateObject2());
var SearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(global_Input_SearchInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-3"
})(_templateObject3());
var ListTitle = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].p.withConfig({
    componentId: "sc-b4f58be-4"
})(_templateObject4());
var UserList = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(features_edit_profile_ShareTrade_UserList__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-5"
})(_templateObject5());
var FooterCol = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-6"
})(_templateObject6());
var AgreementRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-7"
})(_templateObject7());
var AgreementText = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].p.withConfig({
    componentId: "sc-b4f58be-8"
})(_templateObject8());
var AgreementDescription = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(AgreementText).withConfig({
    componentId: "sc-b4f58be-9"
})(_templateObject9());
var SubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-10"
})(_templateObject10());
var ErrorState = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__["default"])(features_edit_profile_ShareTrade_ErrorState__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b4f58be-11"
})(_templateObject11());


/***/ }),

/***/ 77064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);



var initialState = {
    isVisible: false,
    selectedUsers: {},
    sharedUsers: {},
    orderType: undefined,
    expiry: undefined,
    isDayTrade: false
};
var useShareTradeModal = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setIsVisible: function(isVisible) {
            set({
                isVisible: isVisible
            });
        },
        setSelectedUsers: function(selectedUsers) {
            set({
                selectedUsers: selectedUsers
            });
        },
        setSharedUsers: function(sharedUsers) {
            set({
                sharedUsers: sharedUsers
            });
        },
        setOrderType: function(orderType) {
            set({
                orderType: orderType
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setIsDayTrade: function(isDayTrade) {
            set({
                isDayTrade: isDayTrade
            });
        },
        resetShareTradeModal: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeModal);


/***/ }),

/***/ 1473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oD": function() { return /* binding */ getPreviewData; },
  "h3": function() { return /* binding */ getRemapOrderAction; },
  "o8": function() { return /* binding */ getRemapOrderStatus; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/typings/api/shareTradeShare.ts
var shareTradeShare = __webpack_require__(10529);
// EXTERNAL MODULE: ./src/features/edit-profile/constants.ts
var constants = __webpack_require__(60779);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
;// CONCATENATED MODULE: ./src/features/sharetrade/constants/shareTradeOrder.ts



var _obj;
var orderStatusRemap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Open */.iF.Open, shareTradeShare/* ShareOrderStatus.Open */.F.Open), (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Amended */.iF.Amended, shareTradeShare/* ShareOrderStatus.Amend */.F.Amend), (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Match */.iF.Match, shareTradeShare/* ShareOrderStatus.Match */.F.Match), (0,_define_property/* default */.Z)(_obj, transaction/* OrderStatus.Withdrawn */.iF.Withdrawn, shareTradeShare/* ShareOrderStatus.Cancel */.F.Cancel), _obj);
var _obj1;
var orderActionRemap = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, transaction/* OrderAction.Buy */.iX.Buy, shareTradeShare/* ShareOrderType.Buy */.y.Buy), (0,_define_property/* default */.Z)(_obj1, transaction/* OrderAction.Sell */.iX.Sell, shareTradeShare/* ShareOrderType.Sell */.y.Sell), _obj1);

;// CONCATENATED MODULE: ./src/features/sharetrade/utils/shareTradeOrder.ts






var getRemapOrderStatus = function(status) {
    return orderStatusRemap[status] || shareTradeShare/* ShareOrderStatus.Unspecified */.F.Unspecified;
};
var getRemapOrderAction = function(action) {
    return orderActionRemap[action] || shareTradeShare/* ShareOrderType.Unspecified */.y.Unspecified;
};
var getPreviewData = function(transactionData) {
    var ref = transactionData || {}, symbol = ref.symbol, status = ref.status, type = ref.type, price = ref.price, total_investment = ref.total_investment, order_time = ref.order_time;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* SHARE_TRADE_PREVIEW */._T), {
        symbol: symbol,
        status: status,
        order_time: order_time,
        order_type: type,
        text: "Order ".concat(type === "ORDER_TYPE_BUY" ? "Buy" : "Sell", " ").concat(symbol),
        price: "Rp ".concat((0,number/* formatNumber */.uf)(price)),
        total_investment: "Rp ".concat((0,number/* formatNumber */.uf)(total_investment))
    });
};


/***/ }),

/***/ 75823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82670);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65906);





var registrationStatusStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return {
        data: {
            status: 0
        },
        isLoading: false,
        error: null,
        getRegistrationStatus: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response, _data, data, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        set({
                            isLoading: true,
                            error: null
                        });
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_securities__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getOAStatus */ .Z.getOAStatus();
                    case 4:
                        response = _ctx.sent;
                        if (response === null || response === void 0 ? void 0 : response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        set({
                            isLoading: false
                        });
                        throw new Error("Attempt to fetch oa status failed");
                    case 8:
                        _data = response.data, data = _data.data, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        set({
                            isLoading: false,
                            error: _$error
                        });
                        return _ctx.abrupt("return");
                    case 12:
                        set({
                            data: data,
                            isLoading: false,
                            error: null
                        });
                        _ctx.next = 22;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ctx.t0, Error)) {
                            _ctx.next = 21;
                            break;
                        }
                        console.error("Error fetching OA status:", _ctx.t0.message);
                        set({
                            isLoading: false,
                            error: _ctx.t0.message
                        });
                        return _ctx.abrupt("return");
                    case 21:
                        console.error("Unknown error while fetching OA status");
                    case 22:
                        _ctx.prev = 22;
                        set({
                            isLoading: false
                        });
                        return _ctx.finish(22);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15,
                    22,
                    25
                ]
            ]);
        }))
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (registrationStatusStore);


/***/ }),

/***/ 51981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ InfoTable; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4303);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75818);







var InfoTable = function(_param) {
    var dataSource = _param.dataSource, _title = _param.title, title = _title === void 0 ? "" : _title, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "dataSource",
        "title"
    ]);
    if (!(dataSource === null || dataSource === void 0 ? void 0 : dataSource.length)) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TableContainer */ .xJ, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, rest), {
        "data-cy": "trade-detail-modal-info-table-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                condition: title,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("legend", {
                    "data-cy": "trade-detail-modal-info-table-title",
                    children: title
                })
            }),
            dataSource.map(function(d, i) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: d.label,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .DataField */ .lg, {
                        "data-cy": "trade-detail-modal-info-table-item",
                        children: [
                            d.label,
                            " ",
                            d.value
                        ]
                    })
                }, (d === null || d === void 0 ? void 0 : d.key) || "dt-".concat(i));
            })
        ]
    }));
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (DetailModal)));


/***/ }),

/***/ 4303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DetailModal; }
});

// UNUSED EXPORTS: DetailModal

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts + 1 modules
var useEmittenInfoStore = __webpack_require__(97454);
// EXTERNAL MODULE: ./src/global/Securities/hooks/useLivePriceUpdater.ts
var useLivePriceUpdater = __webpack_require__(76870);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/styled.ts
var styled = __webpack_require__(75818);
;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/CompanyLabel.tsx





var Text = ui/* Common.Text */.Gn.Text, Flex = ui/* Common.Flex */.Gn.Flex;
var CompanyLabel = function(param) {
    var notation = param.notation, corpAction = param.corpAction, indexes = param.indexes, tradeType = param.tradeType, dayTradeInfo = param.dayTradeInfo;
    var syariah = indexes.indexOf("JII") > -1 || indexes.indexOf("ISSI") > -1;
    var isAccel = tradeType === "ACCEL";
    var isDbx = indexes.indexOf("DBX") > -1;
    var isDayTrade = dayTradeInfo === null || dayTradeInfo === void 0 ? void 0 : dayTradeInfo.is_show_multiplier;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* CompanyLabelContainer */.gL, {
        align: "center",
        justify: "center",
        "data-cy": "trade-detail-modal-company-label=container",
        children: [
            notation.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/ic_indicator.svg",
                    alt: "warning",
                    width: "12px"
                })
            }),
            corpAction.active && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/corp_action_event_icon.svg",
                    alt: "corp_action"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDayTrade,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* LabelDayTrade */.$y, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/day-trade/lightning-filled-company.svg",
                            alt: "",
                            height: "14",
                            width: "14"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                            size: "12px",
                            color: "#8277f8",
                            family: "bold",
                            children: [
                                dayTradeInfo.multiplier,
                                "x"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isAccel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "12px",
                        color: ui/* color.primary */.$_.primary,
                        children: "Akselerasi"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDbx,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "12px",
                        color: ui/* color.primary */.$_.primary,
                        children: "DBX"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: syariah,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LabelWrapper */.ub, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        size: "12px",
                        color: ui/* color.primary */.$_.primary,
                        children: "Syariah"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var DetailModal_CompanyLabel = (CompanyLabel);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore.ts
var useBondPortfolioStore = __webpack_require__(29176);
;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/BondsCompany.tsx











var BondsCompany_Text = ui/* Common.Text */.Gn.Text, BondsCompany_Flex = ui/* Common.Flex */.Gn.Flex;
var BondsCompany = function(param) {
    var showPrice = param.showPrice, symbol = param.symbol, iconUrl = param.iconUrl, bondsName = param.bondsName, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return [
            s.product
        ];
    }), 1), product = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyCard */.SQ, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/symbol/".concat(symbol),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondsCompany_Flex, {
                as: "a",
                justify: "space-between",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondsCompany_Flex, {
                        align: "center",
                        width: showPrice ? "320px" : "100%",
                        "data-cy": "trade-detail-modal-bond-company-show-price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: iconUrl || constants/* FALLBACK_AVATAR_SRC */.sW,
                                style: {
                                    width: "40px",
                                    height: "40px",
                                    background: "white"
                                },
                                "data-cy": "trade-detail-modal-company-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondsCompany_Flex, {
                                direction: "column",
                                pl: "15px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BondsCompany_Flex, {
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BondsCompany_Text, {
                                            family: "bold",
                                            children: symbol
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BondsCompany_Text, {
                                        size: "12px",
                                        color: ui/* color.midgray */.$_.midgray,
                                        mr: "5px",
                                        mt: "3px",
                                        ellipsis: true,
                                        children: bondsName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showBondPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondsCompany_Flex, {
                            direction: "column",
                            pr: "8px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BondsCompany_Text, {
                                    family: "bold",
                                    align: "right",
                                    width: "80px",
                                    children: (0,number/* formatPercentage */.rl)(product === null || product === void 0 ? void 0 : (ref = product.meta) === null || ref === void 0 ? void 0 : ref.sell_price_rate, false, "0,0.00", true)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BondsCompany_Text, {
                                    color: "#969696",
                                    size: "14px",
                                    align: "right",
                                    width: "80px",
                                    children: "Harga Jual"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightSvg */.dj, {})
                ]
            })
        })
    });
};
/* harmony default export */ var DetailModal_BondsCompany = (BondsCompany);

;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/Company.tsx














var Company_Text = ui/* Common.Text */.Gn.Text, Company_Flex = ui/* Common.Flex */.Gn.Flex, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var CompanyContainer = function(param) {
    var children = param.children, href = param.href, onClick = param.onClick;
    return onClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyButton */.R, {
        onClick: onClick,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: children
    });
};
var Company = function(param) {
    var symbol = param.symbol, showPrice = param.showPrice, isBonds = param.isBonds, _isRedemption = param.isRedemption, isRedemption = _isRedemption === void 0 ? false : _isRedemption, bondsName = param.bondsName, onClick = param.onClick, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var ref = (0,useEmittenInfoStore/* default */.Z)(function(s) {
        return {
            data: s.data,
            isLoading: s.isLoading,
            loadEmittenInfo: s.loadEmittenInfo,
            resetEmittenInfo: s.resetEmittenInfo,
            updateEmittenInfo: s.updateEmittenInfo
        };
    }, shallow/* default */.Z), emittenInfo = ref.data, isLoading = ref.isLoading, loadEmittenInfo = ref.loadEmittenInfo, resetEmittenInfo = ref.resetEmittenInfo, updateEmittenInfo = ref.updateEmittenInfo;
    var name = emittenInfo.name, icon_url = emittenInfo.icon_url, formatted_price = emittenInfo.formatted_price, change = emittenInfo.change, percentage = emittenInfo.percentage, notation = emittenInfo.notation, corpAction = emittenInfo.corp_action, indexes = emittenInfo.indexes, tradeType = emittenInfo.trade_type, dayTradeInfo = emittenInfo.day_trade_info;
    var isEmittenEmpty = (0,react.useMemo)(function() {
        return Object.keys(emittenInfo).length === 0;
    }, [
        JSON.stringify(emittenInfo)
    ]);
    (0,useLivePriceUpdater/* default */.Z)({
        symbol: symbol,
        page: "orderlist_detail"
    }, function(param) {
        var lastprice = param.lastprice, liveChange = param.change, percentage_change = param.percentage_change;
        updateEmittenInfo({
            formatted_price: lastprice.toString(),
            change: liveChange.toString(),
            percentage: percentage_change
        });
    });
    (0,react.useEffect)(function() {
        if (symbol && !isRedemption) loadEmittenInfo(symbol);
        return function() {
            resetEmittenInfo();
        };
    }, [
        symbol,
        isRedemption
    ]);
    if (isBonds || isRedemption) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_BondsCompany, {
            symbol: symbol,
            iconUrl: icon_url,
            showPrice: showPrice,
            bondsName: bondsName,
            showBondPrice: showBondPrice
        });
    }
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanySkeletonBlock */.eT, {});
    if (isEmittenEmpty) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyContainer, {
        href: "/symbol/".concat(symbol),
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* CompanyCard */.SQ, {
            as: "a",
            "data-cy": "trade-detail-modal-company-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Company_Flex, {
                justify: "space-between",
                align: "center",
                width: "100%",
                "data-cy": "trade-detail-modal-company-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Company_Flex, {
                        align: "center",
                        width: showPrice ? "320px" : "100%",
                        children: [
                            !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SymbolAvatar */.Mu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Company_Text, {
                                    color: "white",
                                    family: "bold",
                                    size: "16px",
                                    children: symbol[0]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: icon_url,
                                style: {
                                    width: "40px",
                                    height: "40px",
                                    background: "white"
                                },
                                "data-cy": "trade-detail-modal-company-image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Company_Flex, {
                                direction: "column",
                                pl: "15px",
                                "data-cy": "trade-detail-modal-company-info",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Company_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Company_Text, {
                                                family: "bold",
                                                children: symbol
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_CompanyLabel, {
                                                notation: notation,
                                                corpAction: corpAction,
                                                indexes: indexes,
                                                tradeType: tradeType,
                                                dayTradeInfo: dayTradeInfo
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Company_Text, {
                                        size: "12px",
                                        color: ui/* color.midgray */.$_.midgray,
                                        mr: "5px",
                                        mt: "3px",
                                        ellipsis: true,
                                        children: name
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Company_Flex, {
                            direction: "column",
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Company_Text, {
                                    as: "div",
                                    family: "bold",
                                    align: "right",
                                    children: formatted_price
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Company_Text, {
                                    align: "right",
                                    mt: "3px",
                                    color: (0,general/* getColorBasedOnNumber */.pV)(change),
                                    children: [
                                        Number(change) > 0 ? "+" : "",
                                        (0,number/* formatNumber */.uf)(change, false),
                                        " (",
                                        (0,number/* formatPercentage */.rl)(percentage, false),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !showPrice,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                            className: "icon-trading_back reverse"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var DetailModal_Company = (Company);

;// CONCATENATED MODULE: ./src/features/trade/components/DetailModal/index.tsx





var DetailModal_Text = ui/* Common.Text */.Gn.Text;
var DetailModal = function(param) {
    var visible = param.visible, onCancel = param.onCancel, title = param.title, symbol = param.symbol, children = param.children, prefix = param.prefix, suffix = param.suffix, _showPrice = param.showPrice, showPrice = _showPrice === void 0 ? true : _showPrice, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds, _isRedemption = param.isRedemption, isRedemption = _isRedemption === void 0 ? false : _isRedemption, _bondsName = param.bondsName, bondsName = _bondsName === void 0 ? "" : _bondsName, onCompanyClick = param.onCompanyClick, _showBondPrice = param.showBondPrice, showBondPrice = _showBondPrice === void 0 ? false : _showBondPrice;
    var onClose = function() {
        onCancel();
    };
    var isCompanyInfoVisible = function() {
        if (title === "WITHDRAW") return false;
        return !!symbol;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, {
        visible: visible,
        onCancel: onClose,
        centered: true,
        width: 520,
        "data-cy": "trade-detail-modal-container",
        zIndex: 110,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* HeaderWrapper */.Pz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_Text, {
                    align: "center",
                    family: "bold",
                    size: "18px",
                    "data-cy": "trade-detail-modal-title",
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ContentWrapper */.vs, {
                children: [
                    prefix,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isCompanyInfoVisible(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailModal_Company, {
                            symbol: symbol,
                            showPrice: showPrice,
                            isBonds: isBonds,
                            isRedemption: isRedemption,
                            bondsName: bondsName,
                            onClick: onCompanyClick,
                            showBondPrice: showBondPrice
                        })
                    }),
                    children
                ]
            }),
            suffix
        ]
    });
};
/* harmony default export */ var components_DetailModal = (DetailModal);


/***/ }),

/***/ 75818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$y": function() { return /* binding */ LabelDayTrade; },
/* harmony export */   "Mu": function() { return /* binding */ SymbolAvatar; },
/* harmony export */   "PU": function() { return /* binding */ BaseContainer; },
/* harmony export */   "Pz": function() { return /* binding */ HeaderWrapper; },
/* harmony export */   "R": function() { return /* binding */ CompanyButton; },
/* harmony export */   "SQ": function() { return /* binding */ CompanyCard; },
/* harmony export */   "eT": function() { return /* binding */ CompanySkeletonBlock; },
/* harmony export */   "gL": function() { return /* binding */ CompanyLabelContainer; },
/* harmony export */   "lg": function() { return /* binding */ DataField; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "ub": function() { return /* binding */ LabelWrapper; },
/* harmony export */   "vs": function() { return /* binding */ ContentWrapper; },
/* harmony export */   "xJ": function() { return /* binding */ TableContainer; }
/* harmony export */ });
/* unused harmony export CompanyTextSkeleton */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41080);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: normal;\n\n  &.border-bottom {\n    border-bottom: 1px solid #ededed;\n  }\n\n  .ant-progress-inner:not(.ant-progress-circle-gradient)\n    .ant-progress-circle-path {\n    stroke: ",
        ";\n  }\n\n  .free-transfer {\n    font-size: 0.875rem;\n    font-weight: 700;\n    line-height: 19px;\n    color: #00ab6b;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  row-gap: 14px;\n  display: flex;\n  flex-direction: column;\n\n  ",
        ";\n\n  legend {\n    font-size: 14px;\n    font-family: var(--bold-font);\n    line-height: normal;\n    padding: 0 10px;\n    width: auto;\n    margin-bottom: 0px;\n    margin-left: -10px;\n    text-transform: capitalize;\n  }\n\n  & > div {\n    margin-bottom: 8px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #3a645c;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 2px 4.5px 2px 2px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  display: flex;\n  background-color: #f5f0ff;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-close-x {\n    font-size: 11px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px 20px 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n\n  & > * {\n    margin-bottom: 16px;\n\n    &:last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-skeleton-content .ant-skeleton-title + .ant-skeleton-paragraph {\n    margin: 0;\n  }\n\n  .ant-skeleton-title {\n    margin: 0 0 8px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  outline: none;\n  width: 100%;\n  padding: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n\n  & > .ant-skeleton-button {\n    border-radius: 4px;\n    height: 74px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, SbModal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
var CompanyLabelContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-df7fd51e-0"
})(_templateObject());
var DataField = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-df7fd51e-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var BaseContainerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray);
var BaseContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-df7fd51e-2"
})(_templateObject3(), BaseContainerStyle);
var TableContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].fieldset.withConfig({
    componentId: "sc-df7fd51e-3"
})(_templateObject4(), BaseContainerStyle);
var CompanyCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-df7fd51e-4"
})(_templateObject5(), BaseContainerStyle);
var SymbolAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-df7fd51e-5"
})(_templateObject6());
var LabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-df7fd51e-6"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var LabelDayTrade = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(LabelWrapper).withConfig({
    componentId: "sc-df7fd51e-7"
})(_templateObject8());
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(SbModal).withConfig({
    componentId: "sc-df7fd51e-8"
})(_templateObject9());
var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-df7fd51e-9"
})(_templateObject10());
var ContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-df7fd51e-10"
})(_templateObject11());
// Company
var CompanyTextSkeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-df7fd51e-11"
})(_templateObject12());
var CompanyButton = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].button.withConfig({
    componentId: "sc-df7fd51e-12"
})(_templateObject13());
var CompanySkeletonBlock = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Button */ .Z.Button).attrs({
    active: true
}).withConfig({
    componentId: "sc-df7fd51e-13"
})(_templateObject14());


/***/ }),

/***/ 32978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PnLCurrency; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62974);



var Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function PnLCurrency(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 0 : _amount, _dataCy = param.dataCy, dataCy = _dataCy === void 0 ? "" : _dataCy, _percentage = param.percentage, percentage = _percentage === void 0 ? null : _percentage, _family = param.family, family = _family === void 0 ? "normal" : _family, _isFillEmptyWithDash = param.isFillEmptyWithDash, isFillEmptyWithDash = _isFillEmptyWithDash === void 0 ? false : _isFillEmptyWithDash, _isColorless = param.isColorless, isColorless = _isColorless === void 0 ? false : _isColorless, _isSignless = param.isSignless, isSignless = _isSignless === void 0 ? false : _isSignless, _isOnlyPercentage = param.isOnlyPercentage, isOnlyPercentage = _isOnlyPercentage === void 0 ? false : _isOnlyPercentage, _isHidePositiveSign = param.isHidePositiveSign, isHidePositiveSign = _isHidePositiveSign === void 0 ? false : _isHidePositiveSign, _isMultiline = param.isMultiline, isMultiline = _isMultiline === void 0 ? false : _isMultiline;
    var isPositive = amount > 0;
    var sign = isPositive ? "+" : "-";
    if (isSignless || isPositive && isHidePositiveSign) {
        sign = "";
    }
    var textColor = isPositive ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary : _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange;
    if (isColorless) {
        textColor = "";
    }
    if (amount === 0) {
        sign = "";
        textColor = "";
    }
    if (amount === 0 && isFillEmptyWithDash) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
            "data-cy": dataCy,
            family: family,
            children: "-"
        });
    }
    if (isOnlyPercentage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
            "data-cy": dataCy,
            color: textColor,
            family: family,
            children: [
                sign,
                (0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatPercentage */ .rl)(Math.abs(amount), false, "0,0.00", true)
            ]
        });
    }
    var amountDisplayed = "".concat(sign, "Rp").concat((0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(Math.abs(amount)));
    var percentageDisplayed = "";
    if (percentage !== null) {
        var percentageSign = percentage !== 0 ? sign : "";
        percentageDisplayed = "(".concat(percentageSign).concat((0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatPercentage */ .rl)(Math.abs(percentage), false, "0,0.00", true), ")");
    }
    var displayed = "".concat(amountDisplayed, " ").concat(percentageDisplayed);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isMultiline && displayed.length > 22 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    "data-cy": dataCy,
                    color: textColor,
                    family: family,
                    children: amountDisplayed
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    "data-cy": dataCy,
                    color: textColor,
                    family: family,
                    align: "end",
                    children: percentageDisplayed
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
            "data-cy": dataCy,
            color: textColor,
            family: family,
            children: displayed
        })
    });
};


/***/ }),

/***/ 26142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Alert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Icons/CloseSvg.tsx
var CloseSvg = __webpack_require__(79928);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/alert/index.js + 2 modules
var es_alert = __webpack_require__(90567);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Alert/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 20px;\n\n  &.ant-alert-info {\n    border: none;\n    background-color: #f2f1fe;\n\n    .ant-alert-message,\n    .anticon-info-circle {\n      color: #8277f8;\n    }\n  }\n\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BaseAlert = (0,styled_components_browser_esm["default"])(es_alert/* default */.Z).withConfig({
    componentId: "sc-f50812bc-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/global/Alert/index.tsx





var Alert = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseAlert, (0,_object_spread/* default */.Z)({
        closeText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            component: CloseSvg/* default */.Z,
            style: {
                color: "#969696",
                fontSize: 10
            }
        })
    }, props));
};
/* harmony default export */ var global_Alert = (Alert);


/***/ }),

/***/ 72317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/Avatar/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n\n  border-radius: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "px;\n  height: ",
        "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var ImageContainer = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-1bdfb0d2-0"
})(_templateObject(), function(param) {
    var _width = param.width, width = _width === void 0 ? 40 : _width;
    return width;
}, function(param) {
    var _height = param.height, height = _height === void 0 ? 40 : _height;
    return height;
});
var GroupAvatar = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1bdfb0d2-1"
})(_templateObject1(), function(param) {
    var _width = param.width, width = _width === void 0 ? 40 : _width;
    return width;
}, function(param) {
    var _height = param.height, height = _height === void 0 ? 40 : _height;
    return height;
});

;// CONCATENATED MODULE: ./src/global/Avatar/index.tsx



var Avatar = function(param) {
    var name = param.name, _src = param.src, src = _src === void 0 ? "/images/avatar.png" : _src, alt = param.alt, _size = param.size, size = _size === void 0 ? 40 : _size, children = param.children;
    return children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupAvatar, {
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
        src: src,
        alt: src ? alt : "User Not Found Avatar",
        width: size,
        height: size,
        onError: function(e) {
            return (0,general/* handleErrorAvatar */.Tk)(e, name);
        }
    });
};
/* harmony default export */ var global_Avatar = (Avatar);


/***/ }),

/***/ 80557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Collapsible; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Collapsible/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        "; /* This will make the content expand upwards */\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  cursor: pointer;\n  text-align: center;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-right: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  transition: max-height 0.5s ease-out;\n  max-height: ",
        ";\n  width: 100%;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n\n  transition: all 0.25s ease-in-out;\n\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ba367647-0"
})(_templateObject(), function(props) {
    return props.direction === "top" ? "column" : "column-reverse";
});
var HeaderContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ba367647-1"
})(_templateObject1());
var HeaderContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ba367647-2"
})(_templateObject2());
var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ba367647-3"
})(_templateObject3(), function(props) {
    return props.isOpen ? props.maxHeight : "0";
});
var Chevron = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ba367647-4"
})(_templateObject4(), function(p) {
    return p.direction === "top" && "rotate(180deg)";
}, function(p) {
    return p.direction === "right" && "-rotate(90deg)";
}, function(p) {
    return p.direction === "bottom" && "rotate(0deg)";
}, function(p) {
    return p.direction === "left" && "rotate(90deg)";
});

;// CONCATENATED MODULE: ./src/global/Collapsible/index.tsx




function Collapsible(param) {
    var children = param.children, _defaultOpenState = param.defaultOpenState, defaultOpenState = _defaultOpenState === void 0 ? false : _defaultOpenState, _header = param.header, header = _header === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : _header, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "300px" : _maxHeight, _expandDirection = param.expandDirection, expandDirection = _expandDirection === void 0 ? "top" : _expandDirection;
    var ref = (0,react.useState)(defaultOpenState), isOpen = ref[0], setIsOpen = ref[1];
    var toggleCollapsible = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        direction: expandDirection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                isOpen: isOpen,
                maxHeight: maxHeight,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                onClick: toggleCollapsible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContent, {
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        direction: isOpen ? "top" : "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownSvg/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var global_Collapsible = (Collapsible);


/***/ }),

/***/ 66988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27691);
/* eslint-disable no-undef */ 


var CORP_ACTION_IMG = "/icon/corp_action_event_icon.svg";
function CorpActionTag(param) {
    var corpAction = param.corpAction, _className = param.className, className = _className === void 0 ? "" : _className, _isCorpActionBadges = param.isCorpActionBadges, isCorpActionBadges = _isCorpActionBadges === void 0 ? false : _isCorpActionBadges;
    var icon = (corpAction === null || corpAction === void 0 ? void 0 : corpAction.icon) || CORP_ACTION_IMG;
    var text = (corpAction === null || corpAction === void 0 ? void 0 : corpAction.text) || "Corporate Action";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .TagWrapper */ .nf, {
        className: className,
        isCorpActionBadges: isCorpActionBadges,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            alt: text,
            src: icon
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CorpActionTag);


/***/ }),

/***/ 27691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CC": function() { return /* binding */ IconArrow; },
/* harmony export */   "iG": function() { return /* binding */ BarWrapper; },
/* harmony export */   "nf": function() { return /* binding */ TagWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* eslint-disable no-unused-vars */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(147,67,200,.08);\n  cursor: pointer;\n  padding: 0px 18px;\n\n  @media ",
        " {\n    padding: 0 18px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 16px;\n      width: 16px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: 20px;\n      width: 20px;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-right: 0;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 12px;\n  margin: 0 4px;\n  width: 12px;\n\n  & > img {\n    width: 100%;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ';\n  font-size: 12px;\n\n  &:before {\n    content: "\\e968";\n  }\n\n  &:hover {\n    color: ',
        ";\n  }\n"
    ], [
        "\n  color: ",
        ';\n  font-size: 12px;\n\n  &:before {\n    content: "\\\\e968";\n  }\n\n  &:hover {\n    color: ',
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon;
var BarWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    height: "38px",
    justify: "space-between",
    width: "100%"
}).withConfig({
    componentId: "sc-12e04539-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet);
var TagWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs(function(props) {
    return {
        align: "center",
        justify: "center"
    };
}).withConfig({
    componentId: "sc-12e04539-1"
})(_templateObject4(), function(param) {
    var size = param.size;
    return size === "medium" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1());
}, function(param) {
    var size = param.size;
    return size === "large" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2());
}, function(param) {
    var isCorpActionBadges = param.isCorpActionBadges;
    return isCorpActionBadges && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject3());
});
var ICON_ARROW_COLOR = "#9343c8";
var IconArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Iconmoon).withConfig({
    componentId: "sc-12e04539-2"
})(_templateObject5(), ICON_ARROW_COLOR, ICON_ARROW_COLOR);



/***/ }),

/***/ 27934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ LivePriceSymbolsKeyEnum; }
/* harmony export */ });
var LivePriceSymbolsKeyEnum;
(function(LivePriceSymbolsKeyEnum) {
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_WATCHLIST"] = "sideWidgetWatchlist";
    LivePriceSymbolsKeyEnum["SIDE_WIDGET_ORDERBOOK_SUMMARY"] = "sideWidgetOrderbookSummary";
    LivePriceSymbolsKeyEnum["COMPANY_HERO"] = "companyHero";
    LivePriceSymbolsKeyEnum["COMPANY_STREAM_ORDERBOOK"] = "companyStreamOrderbook";
    LivePriceSymbolsKeyEnum["TRENDING_STOCK"] = "trendingStock";
    LivePriceSymbolsKeyEnum["CATALOG"] = "catalog";
    LivePriceSymbolsKeyEnum["SECTOR"] = "sector";
    LivePriceSymbolsKeyEnum["WATCHLIST"] = "watchlist";
    LivePriceSymbolsKeyEnum["ORDERBOOK"] = "orderbook";
    LivePriceSymbolsKeyEnum["IHSG_WIDGET"] = "ihsgWidget";
    LivePriceSymbolsKeyEnum["SECURITIES_TRANSACTION"] = "securitiesTransaction";
    LivePriceSymbolsKeyEnum["TRADE_PAGE"] = "tradePage";
    LivePriceSymbolsKeyEnum["PORTFOLIO_DETAIL"] = "portfolioDetail";
    LivePriceSymbolsKeyEnum["ORDERLIST_DETAIL"] = "orderlistDetail";
    LivePriceSymbolsKeyEnum["FAST_ORDER"] = "fastOrder";
})(LivePriceSymbolsKeyEnum || (LivePriceSymbolsKeyEnum = {}));


/***/ }),

/***/ 39767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useLivePrice; }
/* harmony export */ });
/* harmony import */ var _useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65131);
/* harmony import */ var _useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);


var useLivePrice = function(symbols, stateKey, actionKey, onMessage) {
    (0,_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(stateKey, symbols);
    (0,_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_0__/* .useLivePriceReceiver */ .V)(symbols, actionKey, onMessage);
};


/***/ }),

/***/ 7538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XA": function() { return /* binding */ natsLivePriceFormatter; }
/* harmony export */ });
/* unused harmony exports oldLivePriceFormatter, isNatsLivePriceResponse */
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

var natsLivePriceFormatter = function(liveprice) {
    return {
        // orderbook col 1
        previous: liveprice.prev,
        change: liveprice.change.value,
        percentage_change: liveprice.change.percentage,
        frequency: liveprice.frequency,
        // orderbook col 2
        open: liveprice.open,
        high: liveprice.high,
        low: liveprice.low,
        // fbuy: 0, // Not Exist in LivePrice Nats
        // orderbook col 3
        volume: liveprice.volume,
        value: liveprice.value,
        average: liveprice.average,
        // fsell: 0, // Not Exist in LivePrice Nats
        // misc
        close: liveprice.close,
        lastprice: liveprice.lastprice,
        date: liveprice.date,
        stockCode: liveprice.stockCode
    };
};
var oldLivePriceFormatter = function(param) {
    var ohlc = param.ohlc, widget = param.widget, sym = param.sym;
    return {
        // orderbook col 1
        previous: ohlc.previous,
        change: widget[sym].price_change,
        percentage_change: widget[sym].percentage_change,
        frequency: ohlc.frequency,
        // orderbook col 2
        open: ohlc.Open,
        high: ohlc.High,
        low: ohlc.Low,
        fbuy: ohlc.foreign_buy,
        // orderbook col 3
        volume: ohlc.volume,
        value: ohlc.value,
        average: ohlc.avg_price,
        fsell: ohlc.foreign_sell,
        // misc
        close: ohlc.Close,
        lastprice: widget[sym].lastprice,
        date: ohlc.date_formated ? moment(ohlc.date_formated, "YYYY-MM-DD HH:mm:ss").format() : "",
        stockCode: sym
    };
};
/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */ var isNatsLivePriceResponse = function(rawLivePrice) {
    return rawLivePrice.stockCode !== undefined;
}; // Formatted Nats
 // {
 //     "previous": 4710,
 //     "change": -10,
 //     "percentage_change": -0.21231422505307856,
 //     "frequency": 13409,
 //     "open": 4760,
 //     "high": 4770,
 //     "low": 4700,
 //     "volume": 89721000,
 //     "value": 424632501000,
 //     "average": 4733,
 //     "close": 4700,
 //     "lastprice": 4700,
 //     "date": "2023-03-15T15:09:29.728289+07:00",
 //     "stockCode": "BBRI"
 // }
 // Raw Nats
 // {
 //   "stockCode": "GOTO",
 //   "lastprice": 120,
 //   "volume": 2619794600,
 //   "high": 125,
 //   "low": 119,
 //   "open": 124,
 //   "frequency": 20846,
 //   "average": 122,
 //   "date": "2023-03-15T14:48:21.762801+07:00",
 //   "close": 120,
 //   "prev": 121,
 //   "value": 318585803700,
 //   "change": {
 //     "value": -1,
 //     "percentage": -0.8264462809917356
 //   },
 //   "orderVerb": "B",
 //   "quantity": "85200",
 //   "sequenceNumber": "3963134",
 //   "orderBookId": "4311",
 //   "orderNumber": "202303150001779420",
 //   "matchNumber": "202303150001127170",
 //   "board": "BOARD_TYPE_RG"
 // }
 // Raw Old
 // {
 //   "sym": "BBCA",
 //   "date_unix": 1678865974,
 //   "ohlc": {
 //     "Adj_Close": 8350,
 //     "Close": 8350,
 //     "High": 8475,
 //     "Low": 8325,
 //     "Open": 8450,
 //     "volume": 46148300,
 //     "date_unix": 1678865974,
 //     "date_formated": "2023-03-15 14:39:34",
 //     "dividend": 0,
 //     "foreign_buy": 0,
 //     "foreign_flow": 0,
 //     "foreign_sell": 0,
 //     "frequency": 14038,
 //     "marketcap": 0,
 //     "value": 387196490000,
 //     "shareoutstanding": 0,
 //     "ann_eps": 0,
 //     "ann_pe": 0,
 //     "avg_price": 8390,
 //     "previous": 8325,
 //     "freq_analyzer": 0
 //   },
 //   "widget": {
 //     "BBCA": {
 //       "lastprice": 8350,
 //       "price_change": 25,
 //       "percentage_change": 0.3003
 //     }
 //   },
 //   "OFFER-RG": {},
 //   "BID-RG": {},
 //   "__t": "1678865974"
 // }


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useLivePriceReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7538);





var useLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var liveprice, formattedLivePrice;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            formattedLivePrice = (0,_useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsLivePriceFormatter */ .XA)(liveprice);
                            onMessage(formattedLivePrice, liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 35320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useLivePriceSender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _liveprice_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66620);


var useLivePriceSender = function(key, symbols) {
    var setLivePriceSymbols = (0,_liveprice_store__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceStore */ .H)().setLivePriceSymbols;
    var stringSymbols = symbols.join();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var listSymbol = stringSymbols ? stringSymbols.split(",") : [];
        setLivePriceSymbols(key, listSymbol);
        return function() {
            return setLivePriceSymbols(key, []);
        };
    }, [
        key,
        stringSymbols,
        setLivePriceSymbols
    ]);
};


/***/ }),

/***/ 75979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useLivePriceSingleReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7538);





var useLivePriceSingleReceiver = function(symbol, key, onMessage) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), livePrice = ref[0], setLivePrice = ref[1];
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var liveprice, formattedLivePrice;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && symbol === liveprice.stockCode) {
                            formattedLivePrice = (0,_useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsLivePriceFormatter */ .XA)(liveprice);
                            if (onMessage) onMessage(formattedLivePrice, liveprice);
                            setLivePrice(formattedLivePrice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        symbol,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("liveprice", "".concat(key, ":").concat(symbol), handleReceiveMessage);
    return {
        livePrice: livePrice
    };
};


/***/ }),

/***/ 52781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ OrderbookSymbolsKeyEnum; }
/* harmony export */ });
var OrderbookSymbolsKeyEnum;
(function(OrderbookSymbolsKeyEnum) {
    OrderbookSymbolsKeyEnum["SIDE_WIDGET_ORDERBOOK_SUMMARY"] = "sideWidgetOrderbookSummary";
    OrderbookSymbolsKeyEnum["COMPANY_STREAM_ORDERBOOK"] = "companyStreamOrderbook";
    OrderbookSymbolsKeyEnum["ORDERBOOK"] = "orderbook";
    OrderbookSymbolsKeyEnum["SECURITIES_TRANSACTION"] = "securitiesTransaction";
    OrderbookSymbolsKeyEnum["FAST_ORDER"] = "fastOrder";
})(OrderbookSymbolsKeyEnum || (OrderbookSymbolsKeyEnum = {}));


/***/ }),

/***/ 10272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jN": function() { return /* binding */ natsOrderbookFormatter; }
/* harmony export */ });
/* unused harmony exports oldOrderbookFormatter, isNatsOrderbookResponse */
/* harmony import */ var utils_webSocket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92953);

var parseSocketString = utils_webSocket__WEBPACK_IMPORTED_MODULE_0__/* ["default"].parseSocketString */ .Z.parseSocketString;
var natsOrderbookFormatter = function(rawOrderbook) {
    return {
        stockCode: rawOrderbook.stockCode,
        bid: parseSocketString(rawOrderbook.body).O["BID-RG"],
        offer: parseSocketString(rawOrderbook.body).O["OFFER-RG"]
    };
};
var oldOrderbookFormatter = function(rawOldOrderbook) {
    return {
        stockCode: rawOldOrderbook.sym,
        bid: rawOldOrderbook["BID-RG"],
        offer: rawOldOrderbook["OFFER-RG"]
    };
};
/**
 * Defined Type Guards.
 * @link https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */ var isNatsOrderbookResponse = function(rawOrderbook) {
    return rawOrderbook.datetime !== undefined;
}; // Raw Nats
 // {
 //   "stockCode": "GOTO",
 //   "body": "#O|GOTO|BID|118;0;223613500|117;0;99554900|116;0;77776600|115;0;141316000|114;0;53095000|113;0;116110800|1678949070",
 //   "sequenceNumber": "3418843",
 //   "orderBookId": "4311",
 //   "datetime": "2023-03-16T13:44:30.7964+07:00"
 // }
 // Raw Old
 // {
 //     "sym": "AALI",
 //     "BID-RG": {
 //         "price1": 7875,
 //         "que_num1": 0,
 //         "volume1": 2600,
 //         "price2": 7850,
 //         "que_num2": 0,
 //         "volume2": 101800,
 //         "price3": 7825,
 //         "que_num3": 0,
 //         "volume3": 57200,
 //         "price4": 7800,
 //         "que_num4": 0,
 //         "volume4": 236800,
 //         "price5": 7775,
 //         "que_num5": 0,
 //         "volume5": 12700,
 //         "price6": 7750,
 //         "que_num6": 0,
 //         "volume6": 20900,
 //         "price7": 7725,
 //         "que_num7": 0,
 //         "volume7": 10100,
 //         "price8": 7700,
 //         "que_num8": 0,
 //         "volume8": 50700,
 //         "price9": 7675,
 //         "que_num9": 0,
 //         "volume9": 21900,
 //         "price10": 7650,
 //         "que_num10": 0,
 //         "volume10": 148900
 //     },
 //     "OFFER-RG": {
 //       "price1": 8325,
 //       "que_num1": 0,
 //       "volume1": 2198200,
 //       "price2": 8350,
 //       "que_num2": 0,
 //       "volume2": 949900,
 //       "price3": 8375,
 //       "que_num3": 0,
 //       "volume3": 848400,
 //       "price4": 8400,
 //       "que_num4": 0,
 //       "volume4": 1026900,
 //       "price5": 8425,
 //       "que_num5": 0,
 //       "volume5": 864500,
 //       "price6": 8450,
 //       "que_num6": 0,
 //       "volume6": 840200,
 //       "price7": 8475,
 //       "que_num7": 0,
 //       "volume7": 1601900,
 //       "price8": 8500,
 //       "que_num8": 0,
 //       "volume8": 1519500,
 //       "price9": 8525,
 //       "que_num9": 0,
 //       "volume9": 310400,
 //       "price10": 8550,
 //       "que_num10": 0,
 //       "volume10": 1057200
 //     }
 // }


/***/ }),

/***/ 49816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useRawOrderbookReceiver; },
/* harmony export */   "q": function() { return /* binding */ useOrderbookReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useOrderbook_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10272);





var useOrderbookReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var orderbook, formattedOrderbook;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        orderbook = (message || {}).orderbook;
                        if (orderbook && stringSymbols.split(",").includes(orderbook.stockCode)) {
                            formattedOrderbook = (0,_useOrderbook_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsOrderbookFormatter */ .jN)(orderbook);
                            onMessage(formattedOrderbook, orderbook);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("orderbook", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};
var useRawOrderbookReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var orderbook;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        orderbook = (message || {}).orderbook;
                        if (orderbook && stringSymbols.split(",").includes(orderbook.stockCode)) {
                            onMessage(orderbook);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("orderbook", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 64579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useOrderbookSender; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _orderbook_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23782);


var useOrderbookSender = function(key, symbols) {
    var setOrderbookSymbols = (0,_orderbook_store__WEBPACK_IMPORTED_MODULE_1__/* .useOrderbookStore */ .a)().setOrderbookSymbols;
    var stringSymbols = symbols.join();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var symbolList = stringSymbols ? stringSymbols.split(",") : [];
        setOrderbookSymbols(key, symbolList);
        return function() {
            return setOrderbookSymbols(key, []);
        };
    }, [
        stringSymbols,
        key,
        setOrderbookSymbols
    ]);
};


/***/ }),

/***/ 11113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useOrderbookSingleReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useOrderbook_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10272);





var useOrderbookSingleReceiver = function(symbol, key, onMessage) {
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var orderbook, formattedOrderbook;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        orderbook = (message || {}).orderbook;
                        if (orderbook && symbol === orderbook.stockCode) {
                            formattedOrderbook = (0,_useOrderbook_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsOrderbookFormatter */ .jN)(orderbook);
                            onMessage(formattedOrderbook, orderbook);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        symbol,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("orderbook", "".concat(key, ":").concat(symbol), handleReceiveMessage);
};


/***/ }),

/***/ 11453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ useRunningTradeStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/constants/datafeed.ts
var datafeed = __webpack_require__(33714);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/runningTrade/actions.ts




var actions = function(set) {
    return {
        setClearData: function() {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    Object.keys(draft.runningTrade).forEach(function(rtKey) {
                        if (draft.runningTrade[rtKey].isActive) {
                            draft.runningTrade[rtKey].data = [];
                            draft.runningTrade[rtKey].batch = [];
                        }
                    });
                });
            });
        },
        addBatch: function(key, batch) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    var _key = draft.runningTrade[key], filter = _key.filter, isPaused = _key.isPaused;
                    if (!isPaused) {
                        var newBatch = filter && filter !== "*" ? batch.filter(function(value) {
                            return value.stock === filter;
                        }) : batch;
                        draft.runningTrade[key].batch = (0,_to_consumable_array/* default */.Z)(state.runningTrade[key].batch).concat((0,_to_consumable_array/* default */.Z)(newBatch)).slice(-datafeed/* runningTradeConfig */.x[key].limit);
                    }
                });
            });
        },
        /** setIsQueue will set isQueue value to true
   * if batch is not empty and runningtrade active, vice versa */ setIsQueue: function(key) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    var rtInstance = draft.runningTrade[key];
                    rtInstance.isQueue = !!rtInstance.batch[0] && rtInstance.isActive;
                });
            });
        },
        shiftBatch: function(key) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    var rtInstance = draft.runningTrade[key];
                    var data = rtInstance.data, batch = rtInstance.batch;
                    var _batch = (0,_sliced_to_array/* default */.Z)(batch, 1), dataToInsert = _batch[0];
                    if (!dataToInsert) return;
                    if (rtInstance.filter === "*" || rtInstance.filter === dataToInsert.stock) {
                        var newLength = data.unshift(dataToInsert);
                        if (newLength > datafeed/* runningTradeConfig */.x[key].limit) data.pop();
                    }
                    batch.splice(0, 1);
                });
            });
        },
        setActive: function(key, value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.runningTrade[key].isActive = value;
                });
            });
        },
        setFilter: function(key, value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.runningTrade[key].filter = value;
                });
            });
        },
        clearData: function(key) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.runningTrade[key].data = [];
                    draft.runningTrade[key].batch = [];
                });
            });
        },
        play: function(key) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.runningTrade[key].isPaused = false;
                });
            });
        },
        pause: function(key) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.runningTrade[key].isPaused = true;
                    draft.runningTrade[key].batch = [];
                });
            });
        }
    };
};

;// CONCATENATED MODULE: ./src/global/Datafeed/store/runningTrade/state.ts
var state = {
    runningTrade: {
        company: {
            data: [],
            batch: [],
            filter: "",
            isActive: false,
            isQueue: false,
            isPaused: false
        },
        widget: {
            data: [],
            batch: [],
            filter: "",
            isActive: false,
            isQueue: false,
            isPaused: false
        },
        fastOrder: {
            data: [],
            batch: [],
            filter: "",
            isActive: false,
            isQueue: false,
            isPaused: false
        }
    }
};

;// CONCATENATED MODULE: ./src/global/Datafeed/store/runningTrade/index.ts




var useRunningTradeStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, actions(set, get, store, storeMutation), state);
});


/***/ }),

/***/ 11562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J6": function() { return /* binding */ useBestBidOfferSender; },
/* harmony export */   "tC": function() { return /* binding */ useBestBidReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39834);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49696);
/* harmony import */ var _useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92924);






var CHANNEL = "bestBidOffer";
var useBestBidOfferSender = function(symbols) {
    var setChannel = (0,_useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().setChannel;
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    (0,_useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var bestBidOffer = stringSymbols ? stringSymbols.split(",") : [];
        setChannel({
            bestBidOffer: bestBidOffer
        });
    }, [
        stringSymbols
    ]);
};
var useBestBidReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    var KEY = "".concat(key, ":").concat(stringSymbols);
    var onReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var bestBidOffer;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        bestBidOffer = (message || {}).bestBidOffer;
                        if (bestBidOffer && stringSymbols.split(",").includes(bestBidOffer.stockCode)) {
                            onMessage(bestBidOffer);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CHANNEL, KEY, onReceiveMessage);
};
var useBestBidOffer = function(symbols, key, onMessage) {
    useBestBidOfferSender(symbols);
    useBestBidReceiver(symbols, key, onMessage);
};
/* harmony default export */ __webpack_exports__["ZP"] = (useBestBidOffer);


/***/ }),

/***/ 39834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedAuthEffect = function(callback, deps) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y), socket = ref.socket, isAuthorized = ref.isAuthorized;
    var handleCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(callback, deps);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isAuthorized) handleCallback(socket);
    }, [
        isAuthorized,
        handleCallback
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedAuthEffect);


/***/ }),

/***/ 49696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedMessageEffect = function(channel, key, action) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (action) {
            setAction(channel, key, action);
            return function() {
                return removeAction(channel, key);
            };
        }
    }, [
        channel,
        key,
        action
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedMessageEffect);


/***/ }),

/***/ 92924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);


var useDatafeedSocket = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(___WEBPACK_IMPORTED_MODULE_1__/* .DatafeedContext */ .y);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDatafeedSocket);


/***/ }),

/***/ 28398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jj": function() { return /* binding */ useOrderbookIEPIEV; },
/* harmony export */   "Yc": function() { return /* binding */ useOrderbookIEPIEVReceiver; },
/* harmony export */   "_1": function() { return /* binding */ useOrderbookIEPIEVSender; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39834);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49696);
/* harmony import */ var _useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92924);






var useOrderbookIEPIEVSender = function(symbols) {
    var setChannel = (0,_useDatafeedSocket__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().setChannel;
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    (0,_useDatafeedAuthEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        setChannel({
            iepiev: stringSymbols ? stringSymbols.split(",") : []
        });
    }, [
        stringSymbols
    ]);
};
var useOrderbookIEPIEVReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.filter(function(v, i, a) {
        return a.indexOf(v) === i;
    }).join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var iepiev;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        iepiev = (message || {}).iepiev;
                        if (iepiev && stringSymbols.split(",").includes(iepiev.stockCode)) {
                            onMessage(iepiev);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("iepiev", "".concat(key, ":").concat(stringSymbols), handleReceiveMessage);
};
var useOrderbookIEPIEV = function(symbols, key, onMessage) {
    useOrderbookIEPIEVSender(symbols);
    useOrderbookIEPIEVReceiver(symbols, key, onMessage);
};


/***/ }),

/***/ 54037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_GlobalModalManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTransactionFormStore.ts
var useTransactionFormStore = __webpack_require__(52870);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./src/global/Securities/websocket/usePortfolio/index.ts + 4 modules
var usePortfolio = __webpack_require__(77596);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.tsx
var securities_store = __webpack_require__(28840);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/store.ts
var RunningTrade_store = __webpack_require__(78970);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/types.ts
var types = __webpack_require__(7365);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/Datafeed/store/runningTrade/index.ts + 2 modules
var runningTrade = __webpack_require__(11453);
// EXTERNAL MODULE: ./src/lib/flipt/hooks/index.ts + 1 modules
var hooks = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/index.tsx + 26 modules
var RunningTrade = __webpack_require__(4618);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    height: 90vh;\n    border-radius: 4px;\n  }\n\n  & .ant-modal-body {\n    padding: 0;\n    border-radius: 4px;\n    overflow: hidden;\n\n    height: 100vh;\n    max-height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100% !important;\n  width: 100%;\n  overflow: hidden;\n\n  & > div {\n    height: 100% !important;\n\n    & > div:last-of-type {\n      height: 100% !important;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Modal = (0,styled_components_browser_esm["default"])(BaseModal/* default */.Z).withConfig({
    componentId: "sc-d92a8940-0"
})(_templateObject());
var FastRunningTrade = (0,styled_components_browser_esm["default"])(RunningTrade/* default */.Z).withConfig({
    componentId: "sc-d92a8940-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/utils.ts
var convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/colors.ts
var lightColors = {
    text: {
        primary: "#333333",
        secondary: "#858585",
        tertiary: "#B5B5B5",
        specialSecondary: "#6B6B6B",
        white: "#FFFFFF",
        green: "#00AB6B",
        red: "#EE4A49",
        orange: "#F5931B",
        periwinkle: "#8277F8",
        purple: "#8250A3",
        violet: "#9343C8",
        liberty: "#6159B8"
    },
    artboard: {
        surfaceDefault: "#FFFFFF",
        surfaceVariant: "#F7F7F7",
        surfaceEmphasis: "#F7F7F7",
        surfaceHighlight: "#F2F2F2",
        dividerThin: "#F1F1F1",
        dividerThick: "#F7F7F7",
        border: "#EDEDED",
        borderGreen: "#0BA16B",
        borderRed: "#EE4A49",
        borderOrange: "#F5931B",
        borderPeriwinkle: "#8277F8"
    },
    modals: {
        surfaceDefault: "#FFFFFF",
        surfaceEmphasis: "#F7F7F7",
        surfaceHighlight: "#F2F2F2",
        dividerThin: "#F1F1F1",
        dividerThick: "#F7F7F7",
        border: "#EDEDED",
        borderGreen: "#0BA16B",
        borderRed: "#D74342",
        borderOrange: "#E4830C",
        borderPeriwinkle: "#796FEC"
    },
    icon: {
        default: "#969696",
        lowerEmphasis: "rgba(150, 150, 150, 0.6)",
        white: "#FFFFFF",
        green: "#0BA16B",
        red: "#D74342",
        orange: "#E4830C",
        periwinkle: "#796FEC"
    },
    semantic: {
        inactive: "#CBCBCB",
        active: "#00AB6B",
        error: "#EE4A49",
        warning: "#F5931B",
        informative: "#8277F8"
    },
    peach: {
        low: "#FBF0F0",
        medium: "#F7E1E0",
        default: "#D96A65"
    },
    red: {
        low: "#FDEDED",
        medium: "#FBDFDF",
        default: "#EE4A49"
    },
    orange: {
        low: "#322311",
        medium: "#422C11",
        default: "#E4830C"
    },
    yellow: {
        low: "#352B14",
        medium: "#4C3C15",
        default: "#FCBC1D"
    },
    brown: {
        low: "#2C241B",
        medium: "#3A2D20",
        default: "#966B40"
    },
    olive: {
        low: "#222617",
        medium: "#30361D",
        default: "#89A23F"
    },
    green: {
        low: "#EBF8F3",
        medium: "#CCEEE1",
        default: "#0BA16B"
    },
    turqoise: {
        low: "#093029",
        medium: "#10564A",
        default: "#35CBB1"
    },
    teal: {
        low: "#112925",
        medium: "#0F4138",
        default: "#09AE91"
    },
    navy: {
        low: "#1A212D",
        medium: "#1C2537",
        default: "#34518D"
    },
    cobalt: {
        low: "#14222B",
        medium: "#162D3D",
        default: "#2073AC"
    },
    blue: {
        low: "#19262E",
        medium: "#203846",
        default: "#439ACB"
    },
    periwinkle: {
        low: "#1E1D2C",
        medium: "#2D2A4B",
        default: "#796FEC"
    },
    violet: {
        low: "#1F1527",
        medium: "#281634",
        default: "#8228BD"
    },
    purple: {
        low: "#221B27",
        medium: "#32233C",
        default: "#7E4B9F"
    },
    pink: {
        low: "#281A25",
        medium: "#43253A",
        default: "#E65BBF"
    },
    magenta: {
        low: "#231421",
        medium: "#30152C",
        default: "#861D75"
    }
};

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/styled.ts


function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: transparent;\n    border: 1px solid #f7f7f7;\n  "
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  height: ",
        ";\n  width: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  margin-bottom: 8px;\n\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  grid-column-gap: 8px;\n  max-width: 100%;\n  position: relative;\n\n  @media only screen and (min-width: 728px) {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  @media only screen and (min-width: 1048px) {\n    grid-template-columns: 680px 1fr;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  background-color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  display: none;\n  background-color: ",
        ";\n\n  @media only screen and (min-width: 728px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  row-gap: 10px;\n\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  padding: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 1px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 8px;\n  background-color: #f6f6f6;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  display: flex;\n  align-items: stretch;\n  gap: 1px;\n  width: 100%;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20%;\n  padding: 5px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 1px;\n  width: 100%;\n  text-align: center;\n  background-color: ",
        ";\n\n  border-radius: 4px;\n\n  & > ",
        ":first-of-type {\n    > ",
        ":first-of-type {\n      border-top-left-radius: 4px;\n    }\n\n    > ",
        ":last-of-type {\n      border-top-right-radius: 4px;\n    }\n  }\n\n  & > ",
        ":last-of-type {\n    > ",
        ":first-of-type {\n      border-bottom-left-radius: 4px;\n    }\n\n    > ",
        ":last-of-type {\n      border-bottom-right-radius: 4px;\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80px;\n  height: 28px;\n  border: 1px solid #f7f7f7;\n  border-radius: 14px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}



var variantStyles = function(param) {
    var background = param.background;
    return {
        default: (0,styled_components_browser_esm.css)(styled_templateObject(), background || "#f7f7f7"),
        outline: (0,styled_components_browser_esm.css)(styled_templateObject1())
    };
};
var Skeleton = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-0"
})(_templateObject2(), function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant"
    ]);
    return variantStyles(props)[variant];
}, function(param) {
    var height = param.height;
    return convertToPixel(height);
}, function(param) {
    var _width = param.width, width = _width === void 0 ? 24 : _width;
    return convertToPixel(width);
}, function(param) {
    var rounded = param.rounded, width = param.width, height = param.height;
    if (typeof width === "number") {
        return rounded ? convertToPixel(width / 2) : "6px";
    }
    if (typeof height === "number") {
        return rounded ? convertToPixel(height / 2) : "6px";
    }
    return rounded ? "50%" : "6px";
});
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-1"
})(_templateObject3(), lightColors.modals.border);
var HeaderWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-2"
})(_templateObject4(), lightColors.modals.surfaceDefault);
var ContentGrid = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-3"
})(_templateObject5());
var LeftSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-4"
})(_templateObject6(), lightColors.modals.surfaceDefault);
var RightSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-5"
})(_templateObject7(), lightColors.modals.surfaceDefault);
var PortfolioContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-6"
})(_templateObject8(), lightColors.modals.surfaceEmphasis);
var Divider = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-7"
})(_templateObject9(), lightColors.modals.surfaceEmphasis);
var ThickDivider = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-8"
})(_templateObject10());
var TableRow = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-9"
})(_templateObject11());
var TableCell = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-10"
})(_templateObject12(), lightColors.modals.surfaceDefault);
var Table = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-11"
})(_templateObject13(), lightColors.modals.surfaceEmphasis, TableRow, TableCell, TableCell, TableRow, TableCell, TableCell);
var BorderedButton = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5de9bc8-12"
})(_templateObject14());

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/Layout.tsx



var Layout = function(param) {
    var id = param.id, header = param.header, leftSection = param.leftSection, rightSection = param.rightSection;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderWrapper, {
                children: header
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentGrid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSection, {
                        children: leftSection
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightSection, {
                        children: rightSection
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FastOrderSkeleton_Layout = (/*#__PURE__*/(0,react.memo)(Layout));

;// CONCATENATED MODULE: ./src/features/fast-order/Flex/utils.ts
var utils_convertToPixel = function(value) {
    if (value === undefined) return value;
    return typeof value === "number" ? "".concat(value, "px") : value;
};
var generateSpaceProps = function(props) {
    var m = props.m, mt = props.mt, mr = props.mr, mb = props.mb, ml = props.ml, mx = props.mx, my = props.my, p = props.p, pt = props.pt, pr = props.pr, pb = props.pb, pl = props.pl, px = props.px, py = props.py;
    var margin = m;
    var marginTop = mt || my;
    var marginRight = mr || mx;
    var marginBottom = mb || my;
    var marginLeft = ml || mx;
    var padding = p;
    var paddingTop = pt || py;
    var paddingRight = pr || px;
    var paddingBottom = pb || py;
    var paddingLeft = pl || px;
    return {
        margin: margin && utils_convertToPixel(margin),
        marginTop: marginTop && utils_convertToPixel(marginTop),
        marginRight: marginRight && utils_convertToPixel(marginRight),
        marginBottom: marginBottom && utils_convertToPixel(marginBottom),
        marginLeft: marginLeft && utils_convertToPixel(marginLeft),
        padding: padding && utils_convertToPixel(padding),
        paddingTop: paddingTop && utils_convertToPixel(paddingTop),
        paddingRight: paddingRight && utils_convertToPixel(paddingRight),
        paddingBottom: paddingBottom && utils_convertToPixel(paddingBottom),
        paddingLeft: paddingLeft && utils_convertToPixel(paddingLeft)
    };
};
var generateLayoutProps = function(props) {
    var width = props.width, w = props.w, height = props.height, h = props.h, minWidth = props.minWidth, maxWidth = props.maxWidth, minHeight = props.minHeight, maxHeight = props.maxHeight, position = props.position, cursor = props.cursor;
    return {
        width: width || w,
        height: height || h,
        minWidth: minWidth,
        maxWidth: maxWidth,
        minHeight: minHeight,
        maxHeight: maxHeight,
        position: position,
        cursor: cursor
    };
};
var generateBorderProps = function(props) {
    var border = props.border, borderTop = props.borderTop, bt = props.bt, borderRight = props.borderRight, br = props.br, borderBottom = props.borderBottom, bb = props.bb, borderLeft = props.borderLeft, bl = props.bl, borderColor = props.borderColor, borderRadius = props.borderRadius, radius = props.radius;
    return {
        border: border,
        borderTop: borderTop || bt,
        borderRight: borderRight || br,
        borderBottom: borderBottom || bb,
        borderLeft: borderLeft || bl,
        borderColor: borderColor,
        borderRadius: borderRadius || radius
    };
};

;// CONCATENATED MODULE: ./src/features/fast-order/Flex/index.ts



var Flex = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f781b0f2-0"
})(function(props) {
    return (0,_object_spread/* default */.Z)({
        display: "flex",
        flex: props.flex,
        alignItems: props.align,
        justifyContent: props.justify,
        flexDirection: props.direction,
        flexWrap: props.wrap,
        gap: props.gap && utils_convertToPixel(props.gap)
    }, generateSpaceProps(props), generateLayoutProps(props), generateBorderProps(props));
});

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderSkeleton/index.tsx




var SkeletonHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
        px: 16,
        py: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
            width: 120,
            height: 30
        })
    });
};
var FastOrderSkeleton_LeftSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        direction: "column",
        height: "100%",
        px: 16,
        py: 12,
        gap: 14,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                width: 106,
                height: 30
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                direction: "column",
                gap: 14,
                position: "relative",
                height: "100%",
                style: {
                    overflow: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                    direction: "column",
                    gap: 14,
                    position: "absolute",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PortfolioContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                    children: new Array(3).fill("").map(function(_, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                            direction: "column",
                                            gap: 6,
                                            width: "100%",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                                    width: 120,
                                                    height: 12
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                                    width: 80,
                                                    height: 12
                                                })
                                            ]
                                        }, i.toString());
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                    align: "center",
                                    gap: 12,
                                    height: 28,
                                    mb: 40,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                            width: 80,
                                            height: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                            variant: "outline",
                                            width: 148,
                                            height: "100%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                            gap: 8,
                                            children: new Array(3).fill("").map(function(_, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                                    variant: "outline",
                                                    width: 80,
                                                    height: 28,
                                                    rounded: true
                                                }, i.toString());
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                            children: new Array(21).fill("").map(function(_, rowIdx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow, {
                                    children: new Array(5).fill("").map(function(_, colIdx) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                                height: 16
                                            })
                                        }, "".concat(rowIdx.toString(), "-").concat(colIdx.toString()));
                                    })
                                }, rowIdx.toString());
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                gap: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                        variant: "outline",
                        width: "100%",
                        height: 32
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                        variant: "outline",
                        width: "100%",
                        height: 32
                    })
                ]
            })
        ]
    });
};
var FastOrderSkeleton_RightSection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        direction: "column",
        width: "100%",
        height: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                direction: "column",
                px: 16,
                py: 12,
                mb: 22,
                gap: 12,
                children: Array.from({
                    length: 3
                }).map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        width: "100%",
                        justify: "space-between",
                        gap: 30,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                width: "100%",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                        width: 40,
                                        height: 12
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                        width: 60,
                                        height: 12
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                width: "100%",
                                justify: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                        width: 40,
                                        height: 12
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                        width: 60,
                                        height: 12
                                    })
                                ]
                            })
                        ]
                    }, "ohlc-".concat(idx.toString()));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThickDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                direction: "column",
                width: "100%",
                py: 12,
                gap: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        width: "100%",
                        justify: "flex-end",
                        gap: 8,
                        px: 16,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedButton, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BorderedButton, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                        direction: "column",
                        px: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                width: "100%",
                                justify: "space-between",
                                children: Array.from({
                                    length: 5
                                }).map(function(_, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                        px: 8,
                                        py: 10,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                            width: 40,
                                            height: 12
                                        })
                                    }, "th-".concat(idx.toString()));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                                direction: "column",
                                gap: 10,
                                py: 10,
                                children: Array.from({
                                    length: 4
                                }).map(function() {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton, {
                                        width: "100%",
                                        height: 12
                                    });
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FastOrderSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderSkeleton_Layout, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonHeader, {}),
        leftSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderSkeleton_LeftSection, {}),
        rightSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderSkeleton_RightSection, {})
    });
};
/* harmony default export */ var fast_order_FastOrderSkeleton = (FastOrderSkeleton);

// EXTERNAL MODULE: ./src/features/fast-order/stores/useFastOrderStore.ts
var useFastOrderStore = __webpack_require__(5562);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.types.ts
var orderbook_store_types = __webpack_require__(52781);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookReceiver.ts
var useOrderbookReceiver = __webpack_require__(49816);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookSender.ts
var useOrderbookSender = __webpack_require__(64579);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseOrderbook/useRawOrderbook.ts


var useRawOrderbook = function(symbols, stateKey, actionKey, onMessage) {
    (0,useOrderbookSender/* useOrderbookSender */.J)(stateKey, symbols);
    (0,useOrderbookReceiver/* useRawOrderbookReceiver */.H)(symbols, actionKey, onMessage);
};

// EXTERNAL MODULE: ./src/global/Datafeed/useBestBidOffer.ts
var useBestBidOffer = __webpack_require__(11562);
// EXTERNAL MODULE: ./src/global/Datafeed/useOrderbookIEPIEV.ts
var useOrderbookIEPIEV = __webpack_require__(28398);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePriceSender.ts
var useLivePriceSender = __webpack_require__(35320);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedMessageEffect.ts
var useDatafeedMessageEffect = __webpack_require__(49696);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseLivePrice/useRawLivePriceReceiver.ts




var useRawLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var liveprice;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            onMessage(liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,useDatafeedMessageEffect/* default */.Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};

;// CONCATENATED MODULE: ./src/global/Datafeed/UseLivePrice/useRawLivePrice.ts


var useRawLivePrice = function(symbols, stateKey, actionKey, onMessage) {
    (0,useLivePriceSender/* useLivePriceSender */.O)(stateKey, symbols);
    useRawLivePriceReceiver(symbols, actionKey, onMessage);
};

;// CONCATENATED MODULE: ./src/features/fast-order/hooks/useFastOrderDatafeed.ts







var useFastOrderDatafeed = function(symbol) {
    var ref = (0,react.useState)(), orderbook = ref[0], setOrderbook = ref[1];
    var ref1 = (0,react.useState)(), livePrice = ref1[0], setLivePrice = ref1[1];
    var ref2 = (0,react.useState)(), iepiev = ref2[0], setIepIev = ref2[1];
    var ref3 = (0,react.useState)(), bestBidOffer = ref3[0], setBestBidOffer = ref3[1];
    useRawOrderbook([
        symbol
    ], orderbook_store_types/* OrderbookSymbolsKeyEnum.FAST_ORDER */.E.FAST_ORDER, "fast_order", setOrderbook);
    useRawLivePrice([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.FAST_ORDER */.j.FAST_ORDER, "fast_order", setLivePrice);
    (0,useOrderbookIEPIEV/* useOrderbookIEPIEV */.Jj)([
        symbol
    ], "fast_order", setIepIev);
    (0,useBestBidOffer/* default */.ZP)([
        symbol
    ], "fast_order", setBestBidOffer);
    return {
        orderbook: orderbook,
        livePrice: livePrice,
        iepiev: iepiev,
        bestBidOffer: bestBidOffer
    };
};
/* harmony default export */ var hooks_useFastOrderDatafeed = (useFastOrderDatafeed);

;// CONCATENATED MODULE: ./src/features/fast-order/FastOrderModal/index.tsx























var FastOrderFederation = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2311).then(__webpack_require__.t.bind(__webpack_require__, 72311, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72311)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fast_order_FastOrderSkeleton, {});
    }
});
var FastOrderRunningTrade = function(param) {
    var hideCode = param.hideCode;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FastRunningTrade, {
        runningTradeKey: "widget",
        minDataLength: 50,
        allowInitialData: true,
        hideCode: hideCode,
        hideStockFilter: true,
        hideHeader: true,
        playAlignRight: true,
        fullWidth: true,
        isPro: true,
        isVolumeColor: true
    });
};
var FastOrderModal = function(_param) {
    var switchFormConfig = _param.switchFormConfig, props = (0,_object_without_properties/* default */.Z)(_param, [
        "switchFormConfig"
    ]);
    var onCancel = props.onCancel;
    var isDuplicateBidofferEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.FAST_ORDER_DUPLICATE_BIDOFFER */.O.FAST_ORDER_DUPLICATE_BIDOFFER);
    var showClassicModal = (0,store/* default */.Z)(function(s) {
        return s.showModal;
    });
    var isSecuritiesSocketOnline = (0,securities_store/* useSecuritiesStore */.$A)(function(s) {
        return s.isSocketOnline;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useFastOrderStore/* default */.Z)(function(s) {
        return [
            s.symbol,
            s.setSymbol
        ];
    }), 2), symbol = ref[0], setSymbol = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTransactionFormStore/* default */.Z)(function(s) {
        return [
            s.formType,
            s.setFormType, 
        ];
    }), 2), formType = ref1[0], setFormType = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,tradingData/* default */.Z)(function(s) {
        var ref, ref1;
        return [
            (ref = s.portfolio) === null || ref === void 0 ? void 0 : ref.data,
            (ref1 = s.orderHistory) === null || ref1 === void 0 ? void 0 : ref1.data,
            s.getOrderHistory, 
        ];
    }), 3), portfolio = ref2[0], orderList = ref2[1], getOrderHistory = ref2[2];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return [
            s.data,
            s.setCurrentSymbol, 
        ];
    }), 2), portfolioDetail = ref3[0], setCurrentSymbol = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,RunningTrade_store/* useFilterStore */.r)(function(s) {
        return [
            s.onApplyStockFilter
        ];
    }), 1), onApplyStockFilter = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,runningTrade/* useRunningTradeStore */.C)(function(s) {
        return [
            s.clearData
        ];
    }), 1), clearData = ref5[0];
    var ref6 = hooks_useFastOrderDatafeed(props.visible ? symbol : ""), wsOrderbook = ref6.orderbook, bestBidOffer = ref6.bestBidOffer, iepiev = ref6.iepiev, livePrice = ref6.livePrice;
    (0,usePortfolio/* default */.Z)();
    var handleFormTypeChange = function(value) {
        setFormType(value);
        showClassicModal((0,_object_spread/* default */.Z)({
            symbol: symbol,
            orderType: trading/* ORDER_TYPE.BUY */.Jm.BUY
        }, switchFormConfig));
        props.onCancel();
    };
    var handleEmittenChange = (0,react.useCallback)(function(newSymbol) {
        setSymbol(newSymbol);
        setCurrentSymbol(newSymbol);
        onApplyStockFilter({
            type: newSymbol ? types/* StockFilterTypeEnum.Custom */.d.Custom : types/* StockFilterTypeEnum.AllStock */.d.AllStock,
            selected: newSymbol ? [
                newSymbol
            ] : []
        });
        clearData("widget");
    }, [
        setSymbol
    ]);
    var handleModalCancel = function() {
        onApplyStockFilter({
            type: types/* StockFilterTypeEnum.AllStock */.d.AllStock,
            selected: []
        });
        clearData("widget");
        props.onCancel();
    };
    (0,react.useEffect)(function() {
        if (props.visible) getOrderHistory(true);
    }, [
        props.visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 1096,
        hideHeader: true
    }, props), {
        onCancel: handleModalCancel,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderFederation, {
            formType: formType,
            defaultSymbol: symbol,
            onFormTypeChange: handleFormTypeChange,
            onEmittenChange: handleEmittenChange,
            onClose: onCancel,
            rightSection: /*#__PURE__*/ (0,jsx_runtime.jsx)(FastOrderRunningTrade, {
                hideCode: !!symbol
            }),
            orderList: orderList,
            portfolio: portfolio,
            portfolioDetail: portfolioDetail,
            wsOrderbook: wsOrderbook,
            bestBidOffer: bestBidOffer,
            iepiev: iepiev,
            livePrice: livePrice,
            securitiesSocketOnline: isSecuritiesSocketOnline,
            disableDuplicateHandler: !isDuplicateBidofferEnabled
        })
    }));
};
/* harmony default export */ var fast_order_FastOrderModal = (/*#__PURE__*/(0,react.memo)(FastOrderModal));

// EXTERNAL MODULE: ./src/global/GlobalModalManager/types/index.ts
var GlobalModalManager_types = __webpack_require__(30682);
;// CONCATENATED MODULE: ./src/global/GlobalModalManager/modalComponentList.ts



var modalComponentList = (0,_define_property/* default */.Z)({}, GlobalModalManager_types/* GlobalModalType.FastOrder */.C.FastOrder, fast_order_FastOrderModal);

// EXTERNAL MODULE: ./src/global/GlobalModalManager/stores/useGlobalModalStore.ts
var useGlobalModalStore = __webpack_require__(14467);
;// CONCATENATED MODULE: ./src/global/GlobalModalManager/index.tsx






var GlobalModalManager = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useGlobalModalStore/* default */.Z)(function(s) {
        return [
            s.activeModal,
            s.modalProps,
            s.setActiveModal, 
        ];
    }), 3), activeModal = ref[0], modalProps = ref[1], setActiveModal = ref[2];
    var getActiveModal = (0,react.useCallback)(function(modalType) {
        return modalType === activeModal;
    }, [
        activeModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Object.entries(modalComponentList).map(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], ModalComponent = _param[1];
            var isActive = getActiveModal(key);
            return isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalComponent, (0,_object_spread/* default */.Z)({
                visible: isActive,
                onCancel: function() {
                    setActiveModal();
                }
            }, modalProps[key]), key);
        })
    });
};
/* harmony default export */ var global_GlobalModalManager = (GlobalModalManager);


/***/ }),

/***/ 14467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);




var initialState = {
    activeModal: undefined,
    modalProps: {}
};
var useGlobalModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setActiveModal: function(activeModal, props) {
            set({
                activeModal: activeModal
            });
            if (activeModal) {
                get().setModalProps(activeModal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                    onCancel: function() {
                        if (!(props === null || props === void 0 ? void 0 : props.preventClose)) get().setActiveModal();
                        if (props === null || props === void 0 ? void 0 : props.onCancel) props.onCancel();
                    }
                }));
            }
        },
        setModalProps: function(type, props) {
            set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* .produce */ .Uy)(function(state) {
                state.modalProps[type] = props;
            }));
        },
        resetActiveModal: function() {
            return set({
                activeModal: undefined
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGlobalModalStore);


/***/ }),

/***/ 30682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ GlobalModalType; }
/* harmony export */ });
var GlobalModalType;
(function(GlobalModalType) {
    GlobalModalType["FastOrder"] = "fastOrder";
})(GlobalModalType || (GlobalModalType = {}));


/***/ }),

/***/ 33591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F2": function() { return /* binding */ Autocomplete; },
/* harmony export */   "Ig": function() { return /* binding */ Relative; },
/* harmony export */   "OL": function() { return /* binding */ NavLink; },
/* harmony export */   "bM": function() { return /* binding */ IconClose; },
/* harmony export */   "cI": function() { return /* binding */ SearchBarWrapper; },
/* harmony export */   "me": function() { return /* binding */ CatalogItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 999px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: fit-content;\n  display: inline-flex;\n  font-size: 12.5px;\n\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 16px;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  border-left: none;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* .rc-virtual-list-holder-inner {\n    flex-direction: row;\n    flex-wrap: wrap;\n  } */\n\n  .ant-select-item-option-grouped {\n    padding-left: 12px;\n  }\n\n  .ant-select-item-group {\n    &:not(:first-child) {\n      border-top: dashed 1px ",
        ";\n    }\n\n    border-bottom: solid 1px #f0f0f0;\n    font-size: 14px;\n    color: ",
        ";\n    width: 100%;\n  }\n\n  .ant-select-item-option {\n    width: 100%;\n  }\n\n  .catalog-res {\n    background: #fff;\n    padding: 12px;\n\n    &:hover,\n    &:focus {\n      background: #fff;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper, BaseAutocomplete = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Autocomplete */ .Gn.Autocomplete;
var Relative = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-526b5aad-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var CatalogItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    size: "13px",
    p: "2px 8px"
}).withConfig({
    componentId: "sc-526b5aad-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var SearchBarWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-526b5aad-2"
})(_templateObject2(), function(param) {
    var _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible;
    return isVisible ? "flex" : "none";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var IconClose = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(IconWrapper).withConfig({
    componentId: "sc-526b5aad-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lowgray */ .$_.lowgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var Autocomplete = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(BaseAutocomplete).withConfig({
    componentId: "sc-526b5aad-4"
})(_templateObject4(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray);
var NavLink = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-526b5aad-5"
})(_templateObject5());



/***/ }),

/***/ 79928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseSvg = function(param) {
    var _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? "1.5" : _strokeWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "1em",
        height: "1em ",
        viewBox: "0 0 12 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M11 1.5L1 11.5",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1 1.5L11 11.5",
                stroke: "currentColor",
                strokeWidth: strokeWidth,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseSvg);


/***/ }),

/***/ 83952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var RefreshSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "13",
        height: "13",
        viewBox: "0 0 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_6884_74970)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1 2.5V5.5H4",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M12 10.5V7.5H9",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.745 4.99979C10.4914 4.28319 10.0604 3.6425 9.49227 3.1375C8.9241 2.63251 8.23727 2.27968 7.49586 2.11192C6.75445 1.94417 5.98262 1.96696 5.2524 2.17818C4.52219 2.3894 3.85737 2.78215 3.32 3.31979L1 5.49979M12 7.49979L9.68 9.67979C9.14263 10.2174 8.47781 10.6102 7.7476 10.8214C7.01738 11.0326 6.24555 11.0554 5.50414 10.8877C4.76273 10.7199 4.0759 10.3671 3.50773 9.86208C2.93957 9.35709 2.50858 8.7164 2.255 7.99979",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_6884_74970",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "12",
                        height: "12",
                        fill: "white",
                        transform: "translate(0.5 0.5)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RefreshSvg);


/***/ }),

/***/ 7162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LabelBroadcast; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: #796fec;\n  border-radius: 3px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px;\n  width: 12px;\n  height: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var IconFrame = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-3ac81157-0"
})(_templateObject());
function LabelBroadcast() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IconFrame, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: "/icon/broadcast.svg",
            width: "8px",
            height: "8px",
            alt: "icon-broadcast"
        })
    });
};


/***/ }),

/***/ 32253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29658);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100px;\n  min-height: 100px;\n  position: relative;\n\n  @keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  &::before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n    content: '';\n    border-radius: 50%;\n    border-top: 4px solid #00ab6b;\n    border-right: 4px solid transparent;\n    animation: 0.7s linear infinite spinner;\n    -webkit-animation: 0.7s linear infinite spinner;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PrimarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-717be61e-0"
})(_templateObject(), function(param) {
    var overlay = param.overlay, isDarkOverlay = param.isDarkOverlay;
    return overlay && "\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 100;\n    background: ".concat(isDarkOverlay ? "rgba(0,0,0,.5)" : "rgba(255,255,255,.85)", ";\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ");
});
var PrimarySpinner = function(_param) {
    var overlay = _param.overlay, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "overlay",
        "isLoading"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PrimarySpinnerDiv, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            "data-cy": "primary-spinner",
            overlay: overlay
        }, props))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PrimarySpinner);


/***/ }),

/***/ 51906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ModalErrorManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/MainLayout/store.ts
var MainLayout_store = __webpack_require__(73580);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/MainLayout/ModalErrorMessage/constants.ts
var constants = __webpack_require__(5728);
;// CONCATENATED MODULE: ./src/global/MainLayout/ModalErrorMessage/index.tsx










var Button = ui/* Common.Button */.Gn.Button, Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text, Modal = ui/* Common.Modal */.Gn.Modal;
var ModalError = function(param) {
    var _dataCy = param.dataCy, dataCy = _dataCy === void 0 ? "" : _dataCy, _zIndex = param.zIndex, zIndex = _zIndex === void 0 ? 1000 : _zIndex, _errorCode = param.errorCode, errorCode = _errorCode === void 0 ? 0 : _errorCode, _errorType = param.errorType, errorType = _errorType === void 0 ? "" : _errorType, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? "" : _errorMessage, _isErrorSecurities = param.isErrorSecurities, isErrorSecurities = _isErrorSecurities === void 0 ? true : _isErrorSecurities, _onLogout = param.onLogout, onLogout = _onLogout === void 0 ? function() {} : _onLogout, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisible = ref[1];
    // access trading modal store
    var closeTradingModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.resetModal;
    });
    var isTradingModalVisible = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.visible;
    });
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useMemo)(function() {
        var ref;
        if (!isErrorSecurities) {
            return constants/* errorInfoList.find */.qO.find(function(param) {
                var error = param.error;
                return error === errorCode;
            }) || {};
        }
        var modalConfigKey = (ref = constants/* tradingErrorModalList */.Ar[errorCode]) === null || ref === void 0 ? void 0 : ref[errorType || "NO_SERVER_RESPONSE"];
        return constants/* tradingErrorModalConfig */.c0[modalConfigKey] || {};
    }, [
        errorCode,
        errorType
    ]), modalErrorTitle = ref1.title, imageUrl = ref1.imageUrl, description = ref1.description, isShowButton = ref1.isShowButton, isLogoutUser = ref1.isLogoutUser, buttonText = ref1.buttonText, redirectTo = ref1.redirectTo, needToCloseTradingModal = ref1.needToCloseTradingModal, isFullWidthButton = ref1.isFullWidthButton;
    var handleModalCancel = function() {
        if (isLogoutUser) onLogout();
        setVisible(false);
    };
    var handleConfirmClick = function() {
        setVisible(false);
        if (isLogoutUser) {
            onLogout();
        }
        if (redirectTo) {
            onClose();
            router.push((0,general/* sanitizeURL */.lz)(redirectTo));
        }
    };
    var handleShowModal = (0,react.useCallback)(function() {
        if (!errorCode) return;
        // Show error modal if there is any modal error constant
        if (modalErrorTitle) {
            setVisible(true);
            return;
        }
        // Show error toast if there is no modal error constant
        if (!modalErrorTitle && errorMessage && isErrorSecurities) {
            (0,AlertMessage/* default */.Z)({
                content: errorMessage,
                alertType: "plain-default",
                messageType: "error",
                hasCloseIcon: false,
                onCloseHandler: onClose
            });
        }
    }, [
        errorCode,
        errorType,
        errorMessage,
        modalErrorTitle
    ]);
    (0,react.useEffect)(function() {
        handleShowModal();
        if (needToCloseTradingModal && isTradingModalVisible) {
            closeTradingModal();
        }
    }, [
        handleShowModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
        centered: true,
        className: dataCy,
        visible: isVisible,
        onCancel: handleModalCancel,
        afterClose: onClose,
        width: "400px",
        zIndex: zIndex,
        style: {
            borderRadius: "4px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
            direction: "column",
            align: "center",
            justify: "center",
            padding: "50px 40px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "".concat(imageUrl),
                    alt: "info",
                    width: 140
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    "data-cy": "error-trading-modal-title",
                    size: "1.2rem",
                    mt: "16px",
                    family: "bold",
                    muted: true,
                    children: modalErrorTitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    size: "1rem",
                    align: "center",
                    mt: "10px",
                    color: ui/* color.dimgray */.$_.dimgray,
                    children: description || errorMessage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isShowButton,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        height: "46px",
                        type: "primary",
                        mt: "20px",
                        onClick: handleConfirmClick,
                        style: {
                            borderRadius: 4
                        },
                        width: isFullWidthButton ? "100%" : "auto",
                        children: buttonText
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ModalErrorMessage = (ModalError);

;// CONCATENATED MODULE: ./src/global/MainLayout/ModalErrorMessage/ModalErrorManager.tsx













var useTradingStore = (0,esm/* default */.ZP)(trading/* default */.Z);
var useMainLayoutStore = (0,esm/* default */.ZP)(MainLayout_store/* default */.Z);
function ModalErrorManager() {
    var router = (0,next_router.useRouter)();
    var resetTradingModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.resetModal;
    });
    var resetOrderTable = (0,store/* default */.Z)(function(s) {
        return s.resetOrderTableStore;
    });
    var ref = useTradingStore(function(s) {
        return {
            errorCodeSecurities: s.errorCode,
            errorTypeSecurities: s.errorType,
            errorMessageSecurities: s.errorMessage,
            resetErrorCodeSecurities: s.resetErrorCode
        };
    }, shallow/* default */.Z), errorCodeSecurities = ref.errorCodeSecurities, errorTypeSecurities = ref.errorTypeSecurities, errorMessageSecurities = ref.errorMessageSecurities, resetErrorCodeSecurities = ref.resetErrorCodeSecurities;
    var ref1 = useMainLayoutStore(function(s) {
        return {
            errorCodeSocial: s.errorCode,
            errorTypeSocial: s.errorType,
            errorMessageSocial: s.errorMessage,
            resetErrorCodeSocial: s.resetErrorCode
        };
    }, shallow/* default */.Z), errorCodeSocial = ref1.errorCodeSocial, errorTypeSocial = ref1.errorTypeSocial, errorMessageSocial = ref1.errorMessageSocial, resetErrorCodeSocial = ref1.resetErrorCodeSocial;
    var currentPath = router === null || router === void 0 ? void 0 : router.asPath;
    var securitiesPathPattern = /securities\/.+/;
    var securitiesPath = securitiesPathPattern.test(currentPath);
    var handleLogoutSecurities = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        resetOrderTable();
                        resetTradingModal();
                        useUIConfigStore/* default.getState */.Z.getState().setUIValue("featureFlags", {});
                        if (securitiesPath) router.push("/stream");
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogoutSecurities() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLogoutSocial = function() {
        router.push("/logout");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorMessage, {
                dataCy: "modal-error-trading",
                zIndex: 1002,
                errorCode: errorCodeSecurities,
                errorType: errorTypeSecurities,
                errorMessage: errorMessageSecurities,
                onLogout: handleLogoutSecurities,
                onClose: resetErrorCodeSecurities,
                isErrorSecurities: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorMessage, {
                dataCy: "modal-error-social",
                zIndex: 1001,
                errorCode: errorCodeSocial,
                errorType: errorTypeSocial,
                errorMessage: errorMessageSocial,
                onLogout: handleLogoutSocial,
                onClose: resetErrorCodeSocial,
                isErrorSecurities: false
            })
        ]
    });
};


/***/ }),

/***/ 6396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6775);




var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
function FailedLoad(param) {
    var onReloadClick = param.onReloadClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
        direction: "column",
        align: "center",
        justify: "center",
        px: "50px",
        height: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                src: "/img/load-failed-signal.svg",
                alt: "loading-failed",
                width: "125px"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                family: "bold",
                align: "center",
                size: "16px",
                mt: "20px",
                children: "Failed to Load Running Trade"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                align: "center",
                mt: "10px",
                color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray,
                children: "Please check your internet connection and try again"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .ReloadButton */ .hN, {
                onClick: onReloadClick,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        src: "/img/reload-white.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        children: "Click to Reload"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FailedLoad);


/***/ }),

/***/ 79736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6775);


var RunningTradeEmpty = function() {
    var icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "160",
        height: "121",
        viewBox: "0 0 160 121",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M41.9492 29.2016H118.049C119.149 29.2016 120.049 30.1016 120.049 31.2016V50.1416H39.9492V31.2016C39.9492 30.1016 40.8492 29.2016 41.9492 29.2016Z",
                fill: "#E6FCEF"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M118.049 29.2016H41.9492C40.8446 29.2016 39.9492 30.097 39.9492 31.2016V90.0916C39.9492 91.1962 40.8446 92.0916 41.9492 92.0916H118.049C119.154 92.0916 120.049 91.1962 120.049 90.0916V31.2016C120.049 30.097 119.154 29.2016 118.049 29.2016Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M63.9102 29.2016V92.0816",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M39.9492 50.1416H120.049",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M39.9492 71.0816H120.049",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M40.5195 71.0816H119.48",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.7791 38.5716C18.9891 38.5716 20.7691 36.7916 20.7691 34.5816C20.7691 32.3716 18.9891 30.5916 16.7791 30.5916C14.5691 30.5916 12.7891 32.3716 12.7891 34.5816C12.7891 36.7916 14.5691 38.5716 16.7791 38.5716Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M32.7094 16.7516C34.2794 16.7516 35.5594 15.4816 35.5594 13.9016C35.5594 12.3216 34.2894 11.0516 32.7094 11.0516C31.1294 11.0516 29.8594 12.3216 29.8594 13.9016C29.8594 15.4816 31.1294 16.7516 32.7094 16.7516Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M135.18 107.162C137.72 107.162 139.77 105.112 139.77 102.572C139.77 100.032 137.72 97.9816 135.18 97.9816C132.64 97.9816 130.59 100.032 130.59 102.572C130.59 105.112 132.64 107.162 135.18 107.162Z",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M127.471 39.8516C130.221 41.3516 133.891 40.9116 136.211 38.8216C138.531 36.7316 139.341 33.1216 138.131 30.2316C137.721 29.2516 137.051 28.3216 136.091 27.8716C135.131 27.4216 133.821 27.6216 133.221 28.5016C132.761 29.1816 132.811 30.1216 133.191 30.8416C133.571 31.5616 134.241 32.1016 134.961 32.5016C137.661 33.9916 141.141 33.6216 143.751 32.0016C146.361 30.3816 148.161 27.6516 149.131 24.7216",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M149.861 21.0416C150.311 19.3116 149.901 17.6616 149.901 17.6616",
                stroke: "#00AB6B",
                strokeWidth: "1.25",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .RunningTradeEmptyWrapper */ .eQ, {
        children: [
            icon,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .RunningTradeEmptyText */ .b9, {
                children: "Data belum tersedia"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RunningTradeEmpty);


/***/ }),

/***/ 61185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RunningTrade_RunningTradeInitTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/datafeed.ts
var datafeed = __webpack_require__(33714);
// EXTERNAL MODULE: ./src/global/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(71078);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/styled.ts
var styled = __webpack_require__(6775);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/RunningTradeEmpty.tsx
var RunningTradeEmpty = __webpack_require__(79736);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ThSort.tsx





var ThSort = function(_param) {
    var children = _param.children, sortKey = _param.sortKey, sortState = _param.sortState, onSort = _param.onSort, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "sortKey",
        "sortState",
        "onSort"
    ]);
    var ref = sortState !== null && sortState !== void 0 ? sortState : {}, key = ref.key, direction = ref.direction;
    var nextDirection = key === sortKey && direction === "asc" ? "desc" : "asc";
    if (!onSort) return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: children
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("th", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props === null || props === void 0 ? void 0 : props.style), {
            cursor: "pointer"
        }),
        onClick: function() {
            return onSort(sortKey, nextDirection);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ThSortWrapper */.yQ, {
            children: [
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ThSortIconWrapper */.AG, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ThSortIconContent */.jy, {
                            active: key === sortKey && direction === "asc",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AscIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ThSortIconContent */.jy, {
                            active: key === sortKey && direction === "desc",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DescIcon, {})
                        })
                    ]
                })
            ]
        })
    }));
};
var AscIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 1024 1024",
        focusable: "false",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
        })
    });
};
var DescIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 1024 1024",
        focusable: "false",
        width: "1em",
        height: "1em",
        fill: "currentColor",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
        })
    });
};
/* harmony default export */ var RunningTrade_ThSort = (ThSort);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/RunningTradeInitTable.tsx








var actionEnum = {
    buy: 1,
    sell: 2
};
function RunningTradeInitTable(param) {
    var id = param.id, data = param.data, _showAction = param.showAction, showAction = _showAction === void 0 ? false : _showAction, _showCode = param.showCode, showCode = _showCode === void 0 ? false : _showCode, hasMore = param.hasMore, loadMore = param.loadMore, isLoadingMore = param.isLoadingMore, height = param.height, handleTableSort = param.handleTableSort, defaultSort = param.defaultSort;
    var headerColumns = [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade_ThSort, {
            style: {
                width: data.length ? "68.72px" : undefined
            },
            sortKey: "ORDER_BY_TIME",
            sortState: defaultSort,
            onSort: handleTableSort,
            children: "Time"
        }), 
    ].concat((0,_to_consumable_array/* default */.Z)(showCode ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
            style: {
                width: "50px"
            },
            children: "Code"
        })
    ] : []), [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
            style: {
                width: data.length ? "85.67px" : undefined
            },
            children: "Price"
        }), 
    ], (0,_to_consumable_array/* default */.Z)(showAction ? [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
            children: "Action"
        })
    ] : []), [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade_ThSort, {
            sortKey: "ORDER_BY_LOT",
            sortState: defaultSort,
            onSort: handleTableSort,
            children: "Lot"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
            children: "Buyer"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
            children: "Seller"
        }), 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TableInitWrapper */.eL, {
        className: id,
        style: {
            height: data.length > 0 ? height : undefined
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            style: {
                minWidth: data.length > 0 ? 382 : undefined
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: headerColumns
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: data.length > 0 ? data.map(function(x, index, a) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: x.time
                                }),
                                showCode && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    className: "company-code",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/symbol/".concat(x.code),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            children: x.code
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TdPrice */.YY, {
                                        type: x.action,
                                        change: parseFloat(x.change),
                                        isColored: true,
                                        children: [
                                            x.price,
                                            "(",
                                            x.change,
                                            ")",
                                            index === a.length - 10 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                                                style: {
                                                    display: "inline"
                                                },
                                                hasMore: hasMore,
                                                refineNext: loadMore,
                                                loader: null,
                                                isLoading: isLoadingMore
                                            })
                                        ]
                                    })
                                }),
                                showAction && /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TdAction */.VM, {
                                        type: actionEnum[x.action],
                                        isColored: true,
                                        children: datafeed/* runningTradeAction */.I[actionEnum[x.action]]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: x.lot
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TdBroker */.U5, {
                                    type: x.buyer_type,
                                    children: x.buyer
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TdBroker */.U5, {
                                    type: x.seller_type,
                                    children: x.seller
                                })
                            ]
                        }, x.trade_number);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                            colSpan: headerColumns.length,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTradeEmpty/* default */.Z, {})
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var RunningTrade_RunningTradeInitTable = (RunningTradeInitTable);


/***/ }),

/***/ 51725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36305);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var utils_date__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46870);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29097);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var constants_datafeed__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var date_fns_parse__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83366);
/* harmony import */ var date_fns_compareAsc__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49474);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _RunningTradeEmpty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79736);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6775);












function RunningTradeTable(param) {
    var initialData = param.initialData, data = param.data, loading = param.loading, _showAction = param.showAction, showAction = _showAction === void 0 ? false : _showAction, _skeletonRows = param.skeletonRows, skeletonRows = _skeletonRows === void 0 ? 20 : _skeletonRows, _minDataLength = param.minDataLength, minDataLength = _minDataLength === void 0 ? 10 : _minDataLength, height = param.height, _hideCode = param.hideCode, hideCode = _hideCode === void 0 ? false : _hideCode, _isPaused = param.isPaused, isPaused = _isPaused === void 0 ? false : _isPaused, _isCodeBold = param.isCodeBold, isCodeBold = _isCodeBold === void 0 ? false : _isCodeBold, _isVolumeColor = param.isVolumeColor, isVolumeColor = _isVolumeColor === void 0 ? false : _isVolumeColor;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)({}), sortedInfo = ref[0], setSortedInfo = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (isPaused) {
            setSortedInfo({});
        }
    }, [
        isPaused
    ]);
    var handleChange = function(___pagination, ___filters, sorter) {
        setSortedInfo(sorter);
    };
    var formatInitialData = function(initialDataSource) {
        if (!initialDataSource) return [];
        var initialDataSliced = initialDataSource.length > minDataLength ? initialDataSource.slice(0, minDataLength) : initialDataSource;
        return initialDataSliced.map(function(param, i) {
            var action = param.action, change = param.change, code = param.code, price = param.price, time = param.time, lot = param.lot;
            return {
                key: "".concat(i),
                action: Object.keys(constants_datafeed__WEBPACK_IMPORTED_MODULE_3__/* .runningTradeAction */ .I).find(function(key) {
                    return constants_datafeed__WEBPACK_IMPORTED_MODULE_3__/* .runningTradeAction */ .I[key] === action.charAt(0).toUpperCase() + action.slice(1);
                }),
                change: {
                    value: change || 0,
                    percentage: change ? parseFloat(change).toFixed(2) : 0
                },
                time: time,
                code: code,
                price: "".concat(price.toLocaleString(), " (").concat(change, ")"),
                volume: lot
            };
        });
    };
    var dataSource = data.map(function(param, i) {
        var time = param.time, change = param.change, stock = param.stock, price = param.price, action = param.action, volume = param.volume;
        return {
            key: "".concat(i),
            action: action,
            change: {
                value: (change === null || change === void 0 ? void 0 : change.value) || 0,
                percentage: (change === null || change === void 0 ? void 0 : change.percentage) || 0
            },
            time: (0,utils_date__WEBPACK_IMPORTED_MODULE_8__/* .getTimeFromDate */ .D)(new Date(Number(time.seconds) * 1000)),
            code: stock,
            price: "".concat(price.toLocaleString(), " (").concat(change && change.percentage > 0 ? "+" : "").concat(change ? "".concat(numeral__WEBPACK_IMPORTED_MODULE_2___default()(change.percentage).format("0.00"), "%") : "0.00", ")"),
            volume: (volume / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_1__/* .lotSize */ .CQ).toLocaleString()
        };
    });
    var columnsWidth = (0,react__WEBPACK_IMPORTED_MODULE_4__.useMemo)(function() {
        if (hideCode) {
            return [
                "20%",
                "0%",
                showAction ? "auto" : "20%",
                "20%",
                "20%"
            ];
        }
        return [
            "20%",
            "20%",
            showAction ? "auto" : "20%",
            "13%",
            "18%"
        ];
    }, [
        hideCode
    ]);
    var columns = [
        {
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Th, {
                children: "Time"
            }),
            width: columnsWidth[0],
            dataIndex: "time",
            key: "time",
            render: function(time, record) {
                var action = record.action, change = record.change;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Td, {
                    type: action,
                    change: change.percentage,
                    isColored: false,
                    children: time
                });
            },
            showSorterTooltip: false,
            sorter: function(a, b) {
                if (isPaused) {
                    var timeA = (0,date_fns_parse__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(a.time, "HH:mm:ss", new Date());
                    var timeB = (0,date_fns_parse__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(b.time, "HH:mm:ss", new Date());
                    return (0,date_fns_compareAsc__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(timeA, timeB);
                }
                return false;
            },
            sortOrder: sortedInfo.columnKey === "time" && (sortedInfo === null || sortedInfo === void 0 ? void 0 : sortedInfo.order),
            sortDirections: isPaused ? [
                "ascend",
                "descend"
            ] : []
        }, 
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(!hideCode ? [
        {
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Th, {
                children: "Code"
            }),
            width: columnsWidth[1],
            dataIndex: "code",
            key: "code",
            render: function(code) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .TdSymbol */ .G4, {
                    children: isPaused ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/symbol/".concat(code),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            target: "_blank",
                            children: code
                        })
                    }) : code
                });
            }
        }, 
    ] : []), [
        {
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Th, {
                children: "Price"
            }),
            width: columnsWidth[2],
            dataIndex: "price",
            key: "price",
            render: function(price, record) {
                var change = record.change, action = record.action;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .TdPrice */ .YY, {
                    type: action,
                    change: change.percentage,
                    isColored: true,
                    children: price
                });
            }
        }, 
    ], (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(showAction ? [
        {
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Th, {
                children: "Action"
            }),
            width: columnsWidth[3],
            dataIndex: "action",
            key: "action",
            render: function(action, record) {
                var change = record.change;
                if (!action) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Td, {});
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .TdAction */ .VM, {
                    type: action,
                    change: change.percentage,
                    isColored: true,
                    children: constants_datafeed__WEBPACK_IMPORTED_MODULE_3__/* .runningTradeAction */ .I[action]
                });
            }
        }, 
    ] : []), [
        {
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Th, {
                children: "Lot"
            }),
            width: columnsWidth[4],
            dataIndex: "volume",
            key: "volume",
            render: function(volume, record) {
                var action = record.action;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__.Td, {
                    type: action,
                    isColored: isVolumeColor,
                    children: volume
                });
            }
        }, 
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .Skeleton */ .Od, {
            paragraph: {
                width: "100%",
                rows: skeletonRows
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_7__/* .Table */ .iA, {
        tableLayout: "fixed",
        style: {
            overflow: "hidden"
        },
        locale: {
            emptyText: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_RunningTradeEmpty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        },
        dataSource: dataSource.length < minDataLength && initialData ? dataSource.concat(formatInitialData(initialData).slice(dataSource.length, minDataLength)) : dataSource,
        columns: columns,
        pagination: false,
        borderless: true,
        scroll: {
            y: data.length > 0 ? height : undefined
        },
        onChange: handleChange
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (RunningTradeTable);


/***/ }),

/***/ 4618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SideWidget_RunningTrade; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Widget.tsx
var Widget = __webpack_require__(55872);
// EXTERNAL MODULE: ./src/features/paywall/analytics.ts
var analytics = __webpack_require__(67857);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/constants/datafeed.ts
var datafeed = __webpack_require__(33714);
// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedAuthEffect.ts
var useDatafeedAuthEffect = __webpack_require__(39834);
// EXTERNAL MODULE: ./src/global/Datafeed/store/runningTrade/index.ts + 2 modules
var store_runningTrade = __webpack_require__(11453);
// EXTERNAL MODULE: ./src/global/Datafeed/index.tsx + 1 modules
var Datafeed = __webpack_require__(87637);
;// CONCATENATED MODULE: ./src/global/Datafeed/useDatafeedMessage.ts


var useDatafeedMessage = function(channel, key, callbackFn) {
    var setAction = (0,react.useContext)(Datafeed/* DatafeedContext */.y).setAction;
    var actionSet = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (actionSet.current) return;
        actionSet.current = true;
        setAction(channel, key, callbackFn);
    }, []);
};
/* harmony default export */ var Datafeed_useDatafeedMessage = (useDatafeedMessage);

// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedSocket.ts
var useDatafeedSocket = __webpack_require__(92924);
;// CONCATENATED MODULE: ./src/global/Datafeed/useRunningTrade.ts













var useRunningTrade = function(key, customFilter) {
    var ref = (0,useDatafeedSocket/* default */.Z)(), setChannel = ref.setChannel, isAuthorized = ref.isAuthorized;
    var addBatch = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.addBatch;
    });
    var shiftBatch = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.shiftBatch;
    });
    var setIsQueue = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.setIsQueue;
    });
    var setActive = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.setActive;
    });
    var setFilter = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.setFilter;
    });
    var clearData = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.clearData;
    });
    var play = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.play;
    });
    var runningTradeInstance = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.runningTrade[key];
    });
    var runningTradeAllFilter = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        var dataReduced = Object.entries(state.runningTrade).reduce(function(prev, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), itemKey = _param[0], itemValue = _param[1];
            return (0,_object_spread/* default */.Z)({}, prev, itemValue.filter !== "" ? (0,_define_property/* default */.Z)({}, itemKey, itemValue.filter) : {});
        }, {
            company: "",
            widget: ""
        });
        if (dataReduced && dataReduced.company && dataReduced.widget && dataReduced.widget === "*") {
            delete dataReduced.company;
        }
        return dataReduced;
    }, shallow/* default */.Z);
    var ref1 = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return {
            isQueue: state.runningTrade[key].isQueue,
            isActive: state.runningTrade[key].isActive,
            isPaused: state.runningTrade[key].isPaused
        };
    }, shallow/* default */.Z), isQueue = ref1.isQueue, isActive = ref1.isActive, isPaused = ref1.isPaused;
    // getting non-reactive running trade instance
    var getRunningTradeInstance = function() {
        return store_runningTrade/* useRunningTradeStore.getState */.C.getState().runningTrade[key];
    };
    var getStockByFilter = function(newFilter) {
        if (runningTradeAllFilter && runningTradeAllFilter.company && runningTradeAllFilter.widget && runningTradeAllFilter.widget === "*") {
            delete runningTradeAllFilter.company;
            return Object.values((0,_object_spread/* default */.Z)({}, runningTradeAllFilter));
        }
        return Object.values((0,_object_spread/* default */.Z)({}, runningTradeAllFilter, newFilter !== undefined && (0,_define_property/* default */.Z)({}, key, newFilter)));
    };
    var setQueueInstanceBatch = function() {
        /** Recursive function not getting updated values,
     * with that we need to directly get value from store using getState() */ var instance = getRunningTradeInstance();
        if (!instance.isQueue || !instance.isActive || instance.isPaused) return;
        setIsQueue(key);
        shiftBatch(key);
        setTimeout(function() {
            return setQueueInstanceBatch();
        }, 1000 / datafeed/* runningTradeConfig.widget.speed */.x.widget.speed);
    };
    /** Send empty string to stop running trade */ var setInstanceFilter = function(value) {
        clearData(key);
        setFilter(key, value);
        setChannel({
            runningTradeBatch: getStockByFilter(value)
        });
    };
    var setDebounceInstanceFilter = lodash_debounce_default()(setInstanceFilter, 200);
    var setInstanceQueue = function() {
        setIsQueue(key);
    };
    var setInstanceActive = function(value) {
        setActive(key, value);
        setInstanceQueue();
        play(key);
    };
    var handleReceiveMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var instance, runningTradeBatch, error, ref, _batch, batch, filteredBatch;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        instance = getRunningTradeInstance();
                        if (instance.isActive) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        runningTradeBatch = message.runningTradeBatch, error = message.error;
                        ref = runningTradeBatch || {}, _batch = ref.batch, batch = _batch === void 0 ? [] : _batch;
                        if (!error) {
                            _ctx.next = 7;
                            break;
                        }
                        throw error;
                    case 7:
                        filteredBatch = batch;
                        if (customFilter) {
                            filteredBatch = customFilter(batch);
                        }
                        if (filteredBatch.length > 0) {
                            addBatch(key, filteredBatch);
                            if (instance.isActive && !instance.isQueue) setInstanceQueue();
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReceiveMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useDatafeedAuthEffect/* default */.Z)(function() {
        if (isActive) {
            setChannel({
                runningTradeBatch: Object.values(runningTradeAllFilter)
            });
        }
    }, [
        runningTradeAllFilter
    ]);
    Datafeed_useDatafeedMessage("runningTradeBatch", key, handleReceiveMessage);
    (0,react.useEffect)(function() {
        if (isQueue || isPaused) setQueueInstanceBatch();
    }, [
        isQueue,
        isPaused
    ]);
    return {
        runningTrade: runningTradeInstance,
        setInstanceActive: setInstanceActive,
        setInstanceFilter: setInstanceFilter,
        setDebounceInstanceFilter: setDebounceInstanceFilter,
        isLoading: !isAuthorized,
        runningTradeAllFilter: runningTradeAllFilter
    };
};
/* harmony default export */ var Datafeed_useRunningTrade = (useRunningTrade);

// EXTERNAL MODULE: ./src/global/Loading/PrimarySpinner.tsx
var PrimarySpinner = __webpack_require__(32253);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/Failed.tsx
var Failed = __webpack_require__(6396);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/styled.ts
var styled = __webpack_require__(6775);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/Header.tsx





var Text = ui/* Common.Text */.Gn.Text;
var Header = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* HeaderContainer */.gM, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
            size: "16px",
            family: "bold",
            children: children
        })
    });
};
Header.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var RunningTrade_Header = (Header);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/RunningTradeTable.tsx
var RunningTradeTable = __webpack_require__(51725);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/useRunningTradeInit.ts
var useRunningTradeInit = __webpack_require__(64577);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/RunningTradeInitTable.tsx + 1 modules
var RunningTradeInitTable = __webpack_require__(61185);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/PausePlay.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 6px 10px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2px;\n  border-radius: 14px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  width: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var PausePlay_Text = ui/* Common.Text */.Gn.Text, Button = ui/* Common.Button */.Gn.Button;
var ButtonContainer = (0,styled_components_browser_esm["default"])(Button).withConfig({
    componentId: "sc-74b7d866-0"
})(_templateObject(), ui/* color.downgray */.$_.downgray, ui/* color.light */.$_.light);
var PlayIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/rt-play.svg",
        alt: "Play"
    });
};
var PauseIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "/icon/rt-pause.svg",
        alt: "Pause"
    });
};
var PausePlay = function() {
    var isPaused = (0,store_runningTrade/* useRunningTradeStore */.C)(function(s) {
        return s.runningTrade.widget.isPaused;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,store_runningTrade/* useRunningTradeStore */.C)(function(s) {
        return [
            s.pause,
            s.play, 
        ];
    }), 2), pause = ref[0], play = ref[1];
    var onClickButton = function() {
        if (isPaused) {
            play("widget");
        } else {
            pause("widget");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
        onClick: onClickButton,
        children: [
            isPaused ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PauseIcon, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PausePlay_Text, {
                weight: "700",
                width: "34px",
                size: "12px",
                color: ui/* color.highgray */.$_.highgray,
                children: isPaused ? "Play" : "Pause"
            })
        ]
    });
};
/* harmony default export */ var ActionControl_PausePlay = (PausePlay);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 16px 10px 16px;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: #f6f6f6;\n\n      #rt-filter-chevron-down {\n        transform: rotate(180deg);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 6px 4px;\n  align-items: center;\n  gap: 4px;\n  border-radius: 14px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: pointer;\n  position: relative;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 3px;\n  min-width: 318px;\n  position: absolute;\n  top: 90px;\n  right: 40px;\n  background: ",
        ";\n  width: 318px;\n  z-index: 999;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: ",
        ";\n  }\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n    width: 18px;\n    height: 18px;\n    position: relative;\n\n    :after {\n      left: 3.5px !important;\n      top: 7px !important;\n    }\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n  .ant-checkbox-disabled .ant-checkbox-inner {\n    border-color: ",
        "!important;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var BaseCheckbox = ui/* Common.Checkbox */.Gn.Checkbox;
var ActionControlWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d74d07a-0"
})(styled_templateObject());
var ButtonDropdownTrigger = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-d74d07a-1"
})(_templateObject2(), ui/* color.downgray */.$_.downgray, ui/* color.light */.$_.light, function(param) {
    var isOpened = param.isOpened;
    return isOpened && (0,styled_components_browser_esm.css)(_templateObject1());
});
var DropdownWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d74d07a-2"
})(_templateObject3(), ui/* color.light */.$_.light);
var Checkbox = (0,styled_components_browser_esm["default"])(BaseCheckbox).withConfig({
    componentId: "sc-d74d07a-3"
})(_templateObject4(), ui/* color.lowgray */.$_.lowgray, ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary, ui/* color.lowgray */.$_.lowgray, ui/* color.lowgray */.$_.lowgray);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/antd/es/time-picker/index.js
var time_picker = __webpack_require__(68351);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/types.ts
var types = __webpack_require__(7365);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/constants.ts

var actionTypeMenus = [
    {
        label: "All",
        key: types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL
    },
    {
        label: "Buy",
        key: types/* RunningTradeCustomFilterActionEnum.BUY */.Q.BUY
    },
    {
        label: "Sell",
        key: types/* RunningTradeCustomFilterActionEnum.SELL */.Q.SELL
    }, 
];
var predefinedLot = [
    {
        label: "100",
        value: 100
    },
    {
        label: "200",
        value: 200
    },
    {
        label: "500",
        value: 500
    },
    {
        label: "1000",
        value: 1000
    }, 
];

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/store.ts
var store = __webpack_require__(78970);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/styled.ts

function AdvancedFilter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 14px 8px;\n  height: 451px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n"
    ]);
    AdvancedFilter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    > p {\n      color: ",
        ";\n      font-weight: 700;\n    }\n  "
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 28px;\n  padding: 6px 16px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 15px;\n  border: 1px solid ",
        ";\n  box-shadow: unset;\n  transition: unset;\n  background: ",
        ";\n  cursor: pointer;\n\n  > p {\n    color: #858585;\n  }\n\n  ",
        "\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  > .ant-input-number-input-wrap {\n    height: 19px;\n    line-height: 19px;\n  }\n  \n  input {\n    padding: 0;\n    height: 19px;\n    line-height: 19px;\n    font-size: 14px;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 15px;\n  color: ",
        ";\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 8px;\n  gap: 8px;\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    :disabled {\n      color: ",
        ";\n      background: ",
        " !important;\n    }\n\n    :hover:disabled {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 0;\n  align-self: stretch;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 6px 0;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 4px;\n  left: 19px;\n  width: 4px;\n  height: 4px;\n  background: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-picker-time-panel {\n    width: auto;\n  }\n  .ant-picker-time-panel-column {\n    width: 56px;\n    padding-left: 6px;\n    padding-right: 4px;\n    overflow-y: scroll;\n\n    .ant-picker-time-panel-cell-inner {\n      width: 43px;\n      text-align: center;\n      padding-left: 0!important;\n      font-size: 13px;\n      font-family: 'ProximaNovaRg';\n    }\n\n    .ant-picker-time-panel-cell-selected > .ant-picker-time-panel-cell-inner {\n      border-radius: 4px;\n    }\n\n    .ant-picker-time-panel-cell-disabled {\n      display: none;\n    }\n  }\n\n  .ant-picker-ranges {\n    padding: 8px 6px;\n  }\n\n  .ant-picker-now-btn {\n    font-size: 12px !important;\n    font-family: 'ProximaNovaBd';\n    padding-left: 12px;\n    padding-right: 12px;\n    height: 28px;\n  }\n  \n  .ant-picker-ok {\n    float: none;\n    margin-left: 4px;\n    height: 28px;\n\n    .ant-btn {\n      width: 42px;\n      height: 28px;\n      span {\n        font-family: 'ProximaNovaBd';\n        font-weight: bold;\n        text-transform: uppercase;\n      }\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 16px;\n\n  .ant-picker {\n    width: 142px;\n    height: 42px;\n    border-radius: 4px;\n    border: 1px solid #EDEDED;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var ButtonAntd = ui/* Common.Button */.Gn.Button, BaseInputNumber = ui/* Common.InputNumber */.Gn.InputNumber, Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text;
var FormWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bdf567f8-0"
})(AdvancedFilter_styled_templateObject());
var ButtonChip = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-bdf567f8-1"
})(styled_templateObject2(), function(param) {
    var isActive = param.isActive;
    return isActive ? ui/* color.primary */.$_.primary : ui/* color.downgray */.$_.downgray;
}, ui/* color.light */.$_.light, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm.css)(styled_templateObject1(), ui/* color.primary */.$_.primary);
});
var NumberInput = (0,styled_components_browser_esm["default"])(BaseInputNumber).attrs({
    controls: false
}).withConfig({
    componentId: "sc-bdf567f8-2"
})(styled_templateObject3(), ui/* color.downgray */.$_.downgray);
var TextErrorMessage = (0,styled_components_browser_esm["default"])(styled_Text).withConfig({
    componentId: "sc-bdf567f8-3"
})(styled_templateObject4(), ui/* color.sunsetOrange */.$_.sunsetOrange);
var FormFooterWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-bdf567f8-4"
})(_templateObject5(), ui/* color.downgray */.$_.downgray);
var styled_Button = (0,styled_components_browser_esm["default"])(ButtonAntd).withConfig({
    componentId: "sc-bdf567f8-5"
})(_templateObject7(), function(param) {
    var type = param.type;
    return type === "primary" && (0,styled_components_browser_esm.css)(_templateObject6(), ui/* color.light */.$_.light, ui/* color.hummingBird */.$_.hummingBird, ui/* color.light */.$_.light);
});
var Dot = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bdf567f8-6"
})(_templateObject8(), ui/* color.primary */.$_.primary);
var TimePickerPopoverContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bdf567f8-7"
})(_templateObject9());
var TimePickerInputContainer = (0,styled_components_browser_esm["default"])(Flex).attrs({
    mb: "6px"
}).withConfig({
    componentId: "sc-bdf567f8-8"
})(_templateObject10());

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/utils.ts
var allowedNavigationKeys = [
    "ArrowLeft",
    "ArrowRight",
    "Backspace",
    "Delete"
];
var validateNumbersOnly = function(e) {
    if (/[^0-9]/.test(e.key) && allowedNavigationKeys.indexOf(e.key) === -1) {
        e.preventDefault();
    }
};
var formatterThousand = function(value) {
    return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var parserThousand = function(value) {
    return value.replace(/\$\s?|(,*)/g, "");
};
var onPasteNumbersOnly = function(e) {
    var clipboardData = e.clipboardData || window.Clipboard;
    var pastedData = clipboardData.getData("Text").toUpperCase();
    if (/[^0-9\-+.]/.test(pastedData)) {
        e.stopPropagation();
        e.preventDefault();
    }
};
var validateDecimalNumber = function(e) {
    var isNonNumericChar = /[^0-9\-+.]/.test(e.key);
    var isInvalidNavigationKey = allowedNavigationKeys.indexOf(e.key) === -1;
    if (isNonNumericChar && isInvalidNavigationKey) {
        e.preventDefault();
        return;
    }
    var dotCount = (e.target.value.match(/\./g) || []).length;
    if (dotCount === 1 && isInvalidNavigationKey) {
        var ref;
        if (e.key === "." || ((ref = e.target.value.split(".")[1]) === null || ref === void 0 ? void 0 : ref.length) > 1) {
            e.preventDefault();
        }
    }
};

// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/utils.ts



var actionTypeMap = {
    0: "ACTION_TYPE_ALL",
    1: "ACTION_TYPE_BUY",
    2: "ACTION_TYPE_SELL"
};
var isNumber = function(value) {
    if (value === null || typeof value === "undefined") return false;
    var newN = Number(value);
    return !Number.isNaN(newN);
};
var mapCustomFilter = function(filter, isOpenMarket) {
    var mappedFilter = {};
    if ((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom && !isOpenMarket && filter.selected.length === 1) {
        mappedFilter.symbols = filter === null || filter === void 0 ? void 0 : filter.selected[0].split("#")[0];
    }
    if (mappedFilter.symbols && actionTypeMap[filter === null || filter === void 0 ? void 0 : filter.actionType]) {
        mappedFilter.action_type = actionTypeMap[filter === null || filter === void 0 ? void 0 : filter.actionType];
    }
    if (mappedFilter.symbols && isNumber(filter === null || filter === void 0 ? void 0 : filter.minPrice)) {
        mappedFilter.price_range_from = filter.minPrice;
    }
    if (mappedFilter.symbols && isNumber(filter === null || filter === void 0 ? void 0 : filter.maxPrice)) {
        mappedFilter.price_range_to = filter.maxPrice;
    }
    // Uncomment if watchlist_id has been implemented on BE
    // if (isNumber(filter?.minPercentage)) {
    //   mappedFilter.price_change_from = filter.minPercentage;
    // }
    // Uncomment if watchlist_id has been implemented on BE
    // if (isNumber(filter?.maxPercentage)) {
    //   mappedFilter.price_change_to = filter.maxPercentage;
    // }
    if (mappedFilter.symbols && isNumber(filter === null || filter === void 0 ? void 0 : filter.minLot)) {
        mappedFilter.minimum_lot = filter.minLot;
    }
    if (mappedFilter.symbols && filter.timeRangeStart) {
        mappedFilter["time_range.start"] = filter.timeRangeStart;
    }
    if (mappedFilter.symbols && filter.timeRangeEnd) {
        mappedFilter["time_range.end"] = filter.timeRangeEnd;
    }
    // Uncomment if watchlist_id has been implemented on BE
    // if (filter?.type === StockFilterTypeEnum.Watchlist && !isOpenMarket) {
    //   mappedFilter.watchlist_id = parseInt(`${filter?.watchlistId}`, 10);
    // }
    return mappedFilter;
};
var parseNumberFilter = function(type, value) {
    if (isNumber(value)) {
        return value;
    }
    if (type === "min") {
        return Number.MIN_SAFE_INTEGER;
    }
    return Number.MAX_SAFE_INTEGER;
};
var filterRunningTrade = function(items, filter, stockFilter) {
    return items.filter(function(item) {
        var ref;
        var isCustomOrWatchlist = (stockFilter === null || stockFilter === void 0 ? void 0 : stockFilter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom || (stockFilter === null || stockFilter === void 0 ? void 0 : stockFilter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist;
        if (isCustomOrWatchlist && (stockFilter === null || stockFilter === void 0 ? void 0 : (ref = stockFilter.selected) === null || ref === void 0 ? void 0 : ref.length) > 0 && !stockFilter.selected.map(function(symbol) {
            return symbol.split("#")[0];
        }).includes(item.stock) // check if stock is not on selected symbol
        ) {
            return false;
        }
        var ref1 = (0,_sliced_to_array/* default */.Z)(Array(6).fill(false), 6), isMatchingAction = ref1[0], isWithinMinPrice = ref1[1], isWithinMaxPrice = ref1[2], meetsMinPercentage = ref1[3], meetsMaxPercentage = ref1[4], meetsMinLot = ref1[5];
        if (!filter) {
            isMatchingAction = true;
        } else if ((filter === null || filter === void 0 ? void 0 : filter.actionType) === types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL) {
            isMatchingAction = true;
        } else if (item.action === (filter === null || filter === void 0 ? void 0 : filter.actionType)) {
            isMatchingAction = true;
        }
        if (item.price >= parseNumberFilter("min", filter === null || filter === void 0 ? void 0 : filter.minPrice)) {
            isWithinMinPrice = true;
        }
        if (item.price <= parseNumberFilter("max", filter === null || filter === void 0 ? void 0 : filter.maxPrice)) {
            isWithinMaxPrice = true;
        }
        if (Math.floor(item.change.percentage * 100) / 100 >= parseNumberFilter("min", filter === null || filter === void 0 ? void 0 : filter.minPercentage)) {
            meetsMinPercentage = true;
        }
        if (Math.floor(item.change.percentage * 100) / 100 <= parseNumberFilter("max", filter === null || filter === void 0 ? void 0 : filter.maxPercentage)) {
            meetsMaxPercentage = true;
        }
        if (item.volume / constant/* lotSize */.CQ >= parseNumberFilter("min", filter === null || filter === void 0 ? void 0 : filter.minLot)) {
            meetsMinLot = true;
        }
        return isMatchingAction && isWithinMinPrice && isWithinMaxPrice && meetsMinPercentage && meetsMaxPercentage && meetsMinLot;
    });
};

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/AdvancedFilter/index.tsx















var AdvancedFilter_Text = ui/* Common.Text */.Gn.Text, AdvancedFilter_Flex = ui/* Common.Flex */.Gn.Flex;
var AdvancedFilter = function(param) {
    var isMarketOpen = param.isMarketOpen, _timeFormat = param.timeFormat, timeFormat = _timeFormat === void 0 ? "HH:mm" : _timeFormat;
    var popoverRef = (0,react.useRef)(null);
    var popoverButtonRef = (0,react.useRef)(null);
    var filter = (0,store/* useFilterStore */.r)(function(s) {
        return s.filter;
    });
    var onApplyFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onApplyFilter;
    });
    var onResetFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onResetFilter;
    });
    var clearData = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.clearData;
    });
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL), actionType = ref1[0], setActionType = ref1[1];
    var ref2 = (0,react.useState)(null), minPrice = ref2[0], setMinPrice = ref2[1];
    var ref3 = (0,react.useState)(null), maxPrice = ref3[0], setMaxPrice = ref3[1];
    var ref4 = (0,react.useState)(null), minPercentage = ref4[0], setMinPercentage = ref4[1];
    var ref5 = (0,react.useState)(null), maxPercentage = ref5[0], setMaxPercentage = ref5[1];
    var ref6 = (0,react.useState)(null), minLot = ref6[0], setMinLot = ref6[1];
    var ref7 = (0,react.useState)(null), timeRangeStart = ref7[0], setTimeRangeStart = ref7[1];
    var ref8 = (0,react.useState)(null), timeRangeEnd = ref8[0], setTimeRangeEnd = ref8[1];
    var handleClickOutside = function(event) {
        var ref;
        event.preventDefault();
        if ((ref = popoverButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) return;
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setVisible(false);
        }
    };
    (0,react.useEffect)(function() {
        if (visible) {
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("click", handleClickOutside);
        }
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        visible
    ]);
    var handleResetForm = function() {
        setActionType(types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL);
        setMinPrice(null);
        setMaxPrice(null);
        setMinPercentage(null);
        setMaxPercentage(null);
        setMinLot(null);
        setTimeRangeStart(null);
        setTimeRangeEnd(null);
        clearData("widget");
        onResetFilter();
    };
    var handleApplyFilter = function() {
        setVisible(false);
        clearData("widget");
        onApplyFilter({
            minPrice: minPrice,
            maxPrice: maxPrice,
            minPercentage: minPercentage,
            maxPercentage: maxPercentage,
            minLot: minLot,
            actionType: actionType,
            timeRangeStart: timeRangeStart ? timeRangeStart.format(timeFormat).toString() : null,
            timeRangeEnd: timeRangeEnd ? timeRangeEnd.format(timeFormat).toString() : null
        });
    };
    var handleClickButton = function() {
        var isVisible = !visible;
        setVisible(isVisible);
        if (isVisible) {
            setActionType((filter === null || filter === void 0 ? void 0 : filter.actionType) || types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL);
            setMinPrice(isNumber(filter === null || filter === void 0 ? void 0 : filter.minPrice) ? filter === null || filter === void 0 ? void 0 : filter.minPrice : null);
            setMaxPrice(isNumber(filter === null || filter === void 0 ? void 0 : filter.maxPrice) ? filter === null || filter === void 0 ? void 0 : filter.maxPrice : null);
            setMinPercentage(isNumber(filter === null || filter === void 0 ? void 0 : filter.minPercentage) ? filter === null || filter === void 0 ? void 0 : filter.minPercentage : null);
            setMaxPercentage(isNumber(filter === null || filter === void 0 ? void 0 : filter.maxPercentage) ? filter === null || filter === void 0 ? void 0 : filter.maxPercentage : null);
            setMinLot(isNumber(filter === null || filter === void 0 ? void 0 : filter.minLot) ? filter === null || filter === void 0 ? void 0 : filter.minLot : null);
        }
    };
    var onPasteNumberValidate = function(e) {
        var clipboardData = e.clipboardData || window.Clipboard;
        var pastedData = clipboardData.getData("Text").toUpperCase();
        if (pastedData.indexOf("E") > -1) {
            e.stopPropagation();
            e.preventDefault();
        }
    };
    var priceRangeValidation = (0,react.useMemo)(function() {
        if (!isNumber(maxPrice) || !isNumber(minPrice)) return null;
        if (maxPrice < minPrice) {
            return {
                message: "Maximum price must be greater than the minimum price",
                status: "error"
            };
        }
        return null;
    }, [
        minPrice,
        maxPrice
    ]);
    var percentageValidation = (0,react.useMemo)(function() {
        if (!isNumber(maxPercentage) || !isNumber(minPercentage)) return null;
        if (maxPercentage < minPercentage) {
            return {
                message: "Maximum price change must be greater than the minimum price change",
                status: "error"
            };
        }
        return null;
    }, [
        minPercentage,
        maxPercentage
    ]);
    var timeRangeValidation = (0,react.useMemo)(function() {
        if (isMarketOpen) return null;
        if (timeRangeStart && timeRangeEnd) {
            var isNotValid = moment_default()(timeRangeEnd, "HH:mm").isBefore(moment_default()(timeRangeStart, "HH:mm"));
            if (isNotValid) {
                return {
                    message: "The end time must be later than the start time.",
                    status: "error"
                };
            }
        }
        return null;
    }, [
        isMarketOpen,
        timeRangeStart,
        timeRangeEnd
    ]);
    var isButtonApplyDisabled = (0,react.useMemo)(function() {
        if (priceRangeValidation || percentageValidation || timeRangeValidation) {
            return true;
        }
        return false;
    }, [
        priceRangeValidation,
        percentageValidation,
        timeRangeValidation
    ]);
    var isFilterApplied = (0,react.useMemo)(function() {
        var arrayFilterType = [
            (0,_type_of/* default */.Z)(filter === null || filter === void 0 ? void 0 : filter.minPrice),
            (0,_type_of/* default */.Z)(filter === null || filter === void 0 ? void 0 : filter.maxPrice),
            (0,_type_of/* default */.Z)(filter === null || filter === void 0 ? void 0 : filter.minPercentage),
            (0,_type_of/* default */.Z)(filter === null || filter === void 0 ? void 0 : filter.maxPercentage),
            (0,_type_of/* default */.Z)(filter === null || filter === void 0 ? void 0 : filter.minLot), 
        ];
        if (!filter) return false;
        if (arrayFilterType.includes("number") || (filter === null || filter === void 0 ? void 0 : filter.actionType) !== types/* RunningTradeCustomFilterActionEnum.ALL */.Q.ALL) {
            return true;
        }
        if ((filter === null || filter === void 0 ? void 0 : filter.timeRangeStart) || filter.timeRangeEnd) {
            return true;
        }
        return false;
    }, [
        filter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonDropdownTrigger, {
                ref: popoverButtonRef,
                onClick: handleClickButton,
                isOpened: visible,
                style: {
                    padding: "6px 10px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/rt-filter.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                        size: "12px",
                        children: "Filter"
                    }),
                    isFilterApplied && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {})
                ]
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                ref: popoverRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Action Type"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Flex, {
                                        style: {
                                            gap: 12
                                        },
                                        children: actionTypeMenus.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChip, {
                                                isActive: actionType === item.key,
                                                onClick: function() {
                                                    return setActionType(item.key);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                                    size: "12px",
                                                    children: item.label
                                                })
                                            }, item.key);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Price Range (Rp)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedFilter_Flex, {
                                        style: {
                                            gap: 16
                                        },
                                        mb: "6px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMinPrice(value);
                                                },
                                                value: minPrice,
                                                placeholder: "From",
                                                status: priceRangeValidation === null || priceRangeValidation === void 0 ? void 0 : priceRangeValidation.status,
                                                min: 0,
                                                max: 999999,
                                                maxlength: 7,
                                                onKeyDown: validateNumbersOnly,
                                                onPaste: onPasteNumbersOnly,
                                                formatter: formatterThousand,
                                                parser: parserThousand
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMaxPrice(value);
                                                },
                                                value: maxPrice,
                                                placeholder: "To",
                                                min: 0,
                                                max: 999999,
                                                maxlength: 7,
                                                onKeyDown: validateNumbersOnly,
                                                onPaste: onPasteNumbersOnly,
                                                formatter: formatterThousand,
                                                parser: parserThousand
                                            })
                                        ]
                                    }),
                                    priceRangeValidation && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextErrorMessage, {
                                        children: priceRangeValidation.message
                                    })
                                ]
                            }),
                            isMarketOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Price Change (%)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AdvancedFilter_Flex, {
                                        style: {
                                            gap: 16
                                        },
                                        mb: "6px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMinPercentage(value);
                                                },
                                                value: minPercentage,
                                                placeholder: "From",
                                                status: percentageValidation === null || percentageValidation === void 0 ? void 0 : percentageValidation.status,
                                                min: -35,
                                                max: 35,
                                                maxlength: 6,
                                                onKeyDown: validateDecimalNumber,
                                                onPaste: onPasteNumbersOnly
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                                onChange: function(value) {
                                                    return setMaxPercentage(value);
                                                },
                                                value: maxPercentage,
                                                placeholder: "To",
                                                min: -35,
                                                max: 35,
                                                maxlength: 6,
                                                onKeyDown: validateDecimalNumber,
                                                onPaste: onPasteNumbersOnly
                                            })
                                        ]
                                    }),
                                    percentageValidation && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextErrorMessage, {
                                        children: percentageValidation.message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Minimum Lot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Flex, {
                                        mb: "6px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput, {
                                            onChange: function(value) {
                                                return setMinLot(value);
                                            },
                                            value: minLot,
                                            placeholder: "e.g 1000",
                                            onKeyDown: validateNumbersOnly,
                                            onPaste: onPasteNumberValidate,
                                            formatter: formatterThousand,
                                            parser: parserThousand,
                                            max: 50000
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Flex, {
                                        style: {
                                            gap: 8
                                        },
                                        children: predefinedLot.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonChip, {
                                                isActive: item.value === minLot,
                                                onClick: function() {
                                                    return setMinLot(item.value);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                                    size: "12px",
                                                    children: item.label
                                                })
                                            }, item.value);
                                        })
                                    })
                                ]
                            }),
                            !isMarketOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedFilter_Text, {
                                        weight: 700,
                                        mb: "6px",
                                        children: "Time Range"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimePickerPopoverContainer, {
                                        id: "rt-advanced-time-picker"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimePickerInputContainer, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker/* default */.Z, {
                                                defaultValue: timeRangeStart,
                                                format: timeFormat,
                                                getPopupContainer: function() {
                                                    return document.getElementById("rt-advanced-time-picker");
                                                },
                                                suffixIcon: null,
                                                placeholder: "from",
                                                onChange: function(value) {
                                                    return setTimeRangeStart(value);
                                                },
                                                value: timeRangeStart
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker/* default */.Z, {
                                                defaultValue: timeRangeEnd,
                                                format: timeFormat,
                                                getPopupContainer: function() {
                                                    return document.getElementById("rt-advanced-time-picker");
                                                },
                                                suffixIcon: null,
                                                placeholder: "to",
                                                onChange: function(value) {
                                                    return setTimeRangeEnd(value);
                                                },
                                                value: timeRangeEnd
                                            })
                                        ]
                                    }),
                                    timeRangeValidation && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextErrorMessage, {
                                        children: timeRangeValidation.message
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormFooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                                onClick: handleResetForm,
                                style: {
                                    color: "#858585"
                                },
                                children: "Reset"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Button, {
                                onClick: handleApplyFilter,
                                type: "primary",
                                disabled: isButtonApplyDisabled,
                                children: "Apply"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ActionControl_AdvancedFilter = (AdvancedFilter);

// EXTERNAL MODULE: ./src/lib/api/watchlist.ts
var watchlist = __webpack_require__(15056);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/AllStock/styled.ts

function AllStock_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 8px 10px 8px;\n"
    ]);
    AllStock_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AllStock_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: 1px solid ",
        ";\n  cursor: pointer;\n  width: 100%;\n  border-radius: 4px;\n"
    ]);
    AllStock_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styled_Flex = ui/* Common.Flex */.Gn.Flex;
var Wrapper = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-4faebc85-0"
})(AllStock_styled_templateObject());
var AllStockButton = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-4faebc85-1"
})(AllStock_styled_templateObject1(), ui/* color.downgray */.$_.downgray);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/AllStock/index.tsx





var AllStock_Text = ui/* Common.Text */.Gn.Text;
var AllStock = function(param) {
    var isChecked = param.isChecked, setFilter = param.setFilter;
    var onCheck = function() {
        setFilter({
            type: types/* StockFilterTypeEnum.AllStock */.d.AllStock
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        onClick: onCheck,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AllStockButton, {
            px: "16px",
            py: "8.5px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AllStock_Text, {
                    weight: "700",
                    children: "All Stocks"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                    checked: isChecked
                })
            ]
        })
    });
};
/* harmony default export */ var StocksFilter_AllStock = (AllStock);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/MyWatchlist/styled.ts

function MyWatchlist_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 8px 10px 8px;\n"
    ]);
    MyWatchlist_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyWatchlist_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  padding: 12px 16px 6px 16px;\n\n  .item:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    MyWatchlist_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MyWatchlist_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 20px;\n  border-radius: 4px;\n  background-color: #F6F6F6;\n"
    ]);
    MyWatchlist_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MyWatchlist_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n\n  .checkbox {\n    width: 15.417px;\n    height: 15.417px;\n    border: 1px solid ",
        ";\n    border-radius: 50%;\n  }\n"
    ]);
    MyWatchlist_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var MyWatchlist_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var MyWatchlistWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c8a14954-0"
})(MyWatchlist_styled_templateObject());
var MyWatchlistResult = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c8a14954-1"
})(MyWatchlist_styled_templateObject1(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
var SkeletonItemText = (0,styled_components_browser_esm["default"])(MyWatchlist_styled_Flex).withConfig({
    componentId: "sc-c8a14954-2"
})(MyWatchlist_styled_templateObject2());
var SkeletonItemCheckbox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c8a14954-3"
})(MyWatchlist_styled_templateObject3(), ui/* color.downgray */.$_.downgray);

// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/MyWatchlist/store.ts






var watchlistListStore = (0,esm/* default */.ZP)(function(set) {
    return {
        isLoading: false,
        data: [],
        hasNext: true,
        fetch: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(page) {
                var res, _data, data, message, error_type, error;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                if (page === 1) {
                                    state.data = [];
                                    state.hasNext = true;
                                }
                                state.isLoading = true;
                            }));
                            _ctx.next = 3;
                            return watchlist/* default.getAllWatchlist */.Z.getAllWatchlist(null, true, page, 10);
                        case 3:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while search company data");
                        case 6:
                            _data = res.data, data = _data.data, message = _data.message, error_type = _data.error_type, error = _data.error;
                            if (!(error || error_type)) {
                                _ctx.next = 10;
                                break;
                            }
                            set({
                                isLoading: false
                            });
                            throw new Error(message);
                        case 10:
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                if (page === 1) {
                                    state.data = data;
                                } else if (page > 1) {
                                    var _data;
                                    (_data = state.data).push.apply(_data, (0,_to_consumable_array/* default */.Z)(data));
                                }
                                if (data.length < 10) {
                                    state.hasNext = false;
                                }
                                state.isLoading = false;
                            }));
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(page) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});


;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/MyWatchlist/index.tsx
/* eslint-disable react/no-array-index-key */ 











var MyWatchlist_Text = ui/* Common.Text */.Gn.Text, MyWatchlist_Flex = ui/* Common.Flex */.Gn.Flex;
var WatchlistItem = function(props) {
    var name = props.name, totalItems = props.total_items, onClick = props.onClick, isChecked = props.isChecked;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlist_Flex, {
        py: "10px",
        justify: "space-between",
        align: "center",
        className: "item",
        onClick: function() {
            return onClick(props);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyWatchlist_Text, {
                size: "13px",
                ellipsis: true,
                width: "140px",
                children: name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlist_Flex, {
                align: "center",
                style: {
                    gap: 32
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlist_Text, {
                        size: "13px",
                        color: "#858585",
                        children: [
                            totalItems,
                            " Stocks"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox, {
                        checked: isChecked
                    })
                ]
            })
        ]
    });
};
var MyWatchlist = function(param) {
    var filter = param.filter, setFilter = param.setFilter;
    var ref = (0,react.useState)(1), page = ref[0], setPage = ref[1];
    var isLoading = watchlistListStore(function(s) {
        return s.isLoading;
    });
    var data = watchlistListStore(function(s) {
        return s.data;
    });
    var hasNext = watchlistListStore(function(s) {
        return s.hasNext;
    });
    var fetchWatchlist = watchlistListStore(function(s) {
        return s.fetch;
    });
    (0,react.useEffect)(function() {
        fetchWatchlist(page);
    }, [
        page
    ]);
    var handleLoadMore = function(isVisible) {
        if (isVisible && !isLoading && hasNext) {
            setPage(function(prev) {
                return prev + 1;
            });
        }
    };
    var handleSelectWatchlist = function(watchlist) {
        setFilter({
            type: types/* StockFilterTypeEnum.Watchlist */.d.Watchlist,
            watchlistId: watchlist.watchlist_id,
            watchlistName: watchlist.name,
            watchlistItemCounts: watchlist.total_items
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MyWatchlistWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlistResult, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MyWatchlist_Text, {
                    weight: "700",
                    mb: "8px",
                    children: "From My Watchlist"
                }),
                data.map(function(item) {
                    /*#__PURE__*/ return (0,react.createElement)(WatchlistItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        key: item.watchlist_id,
                        onClick: handleSelectWatchlist,
                        isChecked: (filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist && (filter === null || filter === void 0 ? void 0 : filter.watchlistId) === item.watchlist_id
                    }));
                }),
                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(___, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlist_Flex, {
                            align: "center",
                            justify: "space-between",
                            py: "10px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItemText, {
                                    width: "70px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyWatchlist_Flex, {
                                    align: "center",
                                    style: {
                                        gap: 8
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItemText, {
                                            width: "70px"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonItemCheckbox, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "checkbox"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    })
                }),
                !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                    onChange: handleLoadMore,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "\xa0"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var StocksFilter_MyWatchlist = (MyWatchlist);

// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/hooks/useClickOutside.ts
var useClickOutside = __webpack_require__(1014);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/styled.ts

function SearchStock_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 0;\n  align-self: stretch;\n  border: none;\n  padding: 0 16px 0 0;\n\n  .ant-input-affix-wrapper {\n    border-radius: 4px;\n  }\n\n  .ant-input {\n    height: 20px;\n    line-height: 20px;\n    font-size: 13px;\n  }\n\n  .ant-input-prefix {\n    margin-right: 8px;\n    height: 20px;\n    line-height: 20px;\n  }\n"
    ]);
    SearchStock_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 14px 8px;\n"
    ]);
    SearchStock_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: 8px 0px 8px 16px;\n"
    ]);
    SearchStock_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  border-bottom: 1px solid ",
        ";\n  width: calc(100% - 16px);\n"
    ]);
    SearchStock_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SearchStock_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  border-radius: 20px;\n  padding: 4px 3px 4px 5px;\n  border: 1px solid ",
        ";\n  flex: 0 0 auto;\n  order: 0;\n  margin-bottom: 10px;\n  margin-right: 4px;\n  align-items: center;\n\n  .remove-icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 16px;\n    height: 16px;\n    margin-left: 6px;\n    cursor: pointer;\n\n    img {\n      width: 6.6px;\n      height: 6.6px;\n    }\n  }\n"
    ]);
    SearchStock_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 50px;\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 318px;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 246px;\n  height: 20px;\n  border-radius: 4px;\n  background-color: #F6F6F6;\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n\n  .checkbox {\n    width: 15.417px;\n    height: 15.417px;\n    border-radius: 50%;\n    background-color: #F6F6F6;\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3A645C;\n  border-radius: 50%;\n  color: ",
        ";\n  display: flex;\n  min-height: 20px;\n  min-width: 20px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .add {\n      cursor: not-allowed;\n      pointer-events: all !important;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .selected {\n    width: 15px;\n    height: 15px;\n  }\n\n  .add {\n    width: 15.417px;\n    height: 15.417px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 8px;\n  gap: 8px;\n  border-top: 1px solid ",
        ";\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    :disabled {\n      color: ",
        ";\n      background: ",
        " !important;\n    }\n\n    :hover:disabled {\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 0 0;\n  align-self: stretch;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  padding: 6px 0;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 12px;\n  cursor: ",
        ";\n  :hover {\n    background: #F7F7F7;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var Input = ui/* Common.Input */.Gn.Input, SearchStock_styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_ButtonAntd = ui/* Common.Button */.Gn.Button;
var SearchInput = (0,styled_components_browser_esm["default"])(Input).withConfig({
    componentId: "sc-684da453-0"
})(SearchStock_styled_templateObject());
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-1"
})(SearchStock_styled_templateObject1());
var SearchContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-2"
})(SearchStock_styled_templateObject2(), ui/* color.downgray */.$_.downgray);
var SearchInputDivider = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-3"
})(SearchStock_styled_templateObject3(), ui/* color.downgray */.$_.downgray);
var StockChipWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-4"
})(SearchStock_styled_templateObject4(), ui/* color.downgray */.$_.downgray);
var CompanySearchResultWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-5"
})(styled_templateObject5());
var SkeletonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-6"
})(styled_templateObject6());
var SkeletonItemWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-7"
})(styled_templateObject7());
var styled_SkeletonItemText = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-8"
})(styled_templateObject8());
var styled_SkeletonItemCheckbox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-9"
})(styled_templateObject9());
var ImagePlaceholder = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-684da453-10"
})(styled_templateObject10(), ui/* color.light */.$_.light);
var styled_Checkbox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-684da453-11"
})(_templateObject12(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm.css)(_templateObject11());
});
var styled_FormFooterWrapper = (0,styled_components_browser_esm["default"])(SearchStock_styled_Flex).withConfig({
    componentId: "sc-684da453-12"
})(_templateObject13(), ui/* color.downgray */.$_.downgray, ui/* color.light */.$_.light);
var SearchStock_styled_Button = (0,styled_components_browser_esm["default"])(styled_ButtonAntd).withConfig({
    componentId: "sc-684da453-13"
})(_templateObject15(), function(param) {
    var type = param.type;
    return type === "primary" && (0,styled_components_browser_esm.css)(_templateObject14(), ui/* color.light */.$_.light, ui/* color.hummingBird */.$_.hummingBird, ui/* color.light */.$_.light);
});
var SearchItemContainer = (0,styled_components_browser_esm["default"])(SearchStock_styled_Flex).attrs({
    px: "20px",
    py: "10px",
    align: "center"
}).withConfig({
    componentId: "sc-684da453-14"
})(_templateObject16(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled ? "not-allowed" : "pointer";
});

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/styled.ts

function StocksFilter_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  padding: 10px 8px;\n  width: 100%;\n  background: ",
        ";\n"
    ]);
    StocksFilter_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    :disabled {\n      color: ",
        ";\n      background: ",
        " !important;\n    }\n\n    :hover:disabled {\n      color: ",
        ";\n    }\n  "
    ]);
    StocksFilter_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  font-weight: 700;\n  padding: 6px;\n  font-size: 12px;\n  line-height: 16px;\n\n  ",
        "\n"
    ]);
    StocksFilter_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 0.6;\n  "
    ]);
    StocksFilter_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: 8px;\n  flex-flow: wrap;\n  justify-content: left;\n  align-items: flex-start;\n  overflow: auto;\n\n  ",
        "\n"
    ]);
    StocksFilter_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 451px;\n  overflow: auto;\n"
    ]);
    StocksFilter_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function StocksFilter_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    StocksFilter_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var StocksFilter_styled_Button = ui/* Common.Button */.Gn.Button;
var FooterWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96a3236d-0"
})(StocksFilter_styled_templateObject(), ui/* color.downgray */.$_.downgray, ui/* color.light */.$_.light);
var ButtonApply = (0,styled_components_browser_esm["default"])(StocksFilter_styled_Button).attrs({
    block: true,
    type: "primary"
}).withConfig({
    componentId: "sc-96a3236d-1"
})(StocksFilter_styled_templateObject2(), function(param) {
    var type = param.type;
    return type === "primary" && (0,styled_components_browser_esm.css)(StocksFilter_styled_templateObject1(), ui/* color.light */.$_.light, ui/* color.hummingBird */.$_.hummingBird, ui/* color.light */.$_.light);
});
var SelectedSymbolWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96a3236d-2"
})(StocksFilter_styled_templateObject4(), function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && (0,styled_components_browser_esm.css)(StocksFilter_styled_templateObject3());
});
var DropdownContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96a3236d-3"
})(StocksFilter_styled_templateObject5());
var StockCount = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96a3236d-4"
})(StocksFilter_styled_templateObject6(), ui/* color.hummingBird */.$_.hummingBird);

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/components/CompanyIcon.tsx

function CompanyIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3A645C;\n  border-radius: 50%;\n  color: ",
        ";\n  display: flex;\n  min-height: 20px;\n  min-width: 20px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    CompanyIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var CompanyIcon_ImagePlaceholder = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-3c882946-0"
})(CompanyIcon_templateObject(), ui/* color.light */.$_.light);
var CompanyIcon = function(param) {
    var symbol = param.symbol;
    var ref = (0,react.useState)(true), isIconAvailable = ref[0], setIsIconAvailable = ref[1];
    if (isIconAvailable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "".concat(app/* assetsStatic */.mM, "/logos/companies/").concat(symbol, ".png"),
            alt: symbol,
            width: 20,
            height: 20,
            onError: function() {
                return setIsIconAvailable(false);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIcon_ImagePlaceholder, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
            children: !!symbol && symbol.toUpperCase().slice(0, 1)
        })
    });
};
/* harmony default export */ var components_CompanyIcon = (CompanyIcon);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/StockChip.tsx





var StockChip_Flex = ui/* Common.Flex */.Gn.Flex, StockChip_Text = ui/* Common.Text */.Gn.Text;
var StockChip = function(param) {
    var symbol = param.symbol, onRemove = param.onRemove;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockChipWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockChip_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyIcon, {
                        symbol: symbol
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StockChip_Text, {
                        ml: "4px",
                        size: "13px",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "remove-icon",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/close.svg",
                    onClick: function(e) {
                        e.stopPropagation();
                        onRemove(symbol);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var SearchStock_StockChip = (StockChip);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/SearchItem.tsx
/* eslint-disable react/destructuring-assignment */ 




var SearchItem_Text = ui/* Common.Text */.Gn.Text, Tooltip = ui/* Common.Tooltip */.Gn.Tooltip;
var TooltipContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem_Text, {
            size: "12px",
            height: "18px",
            children: "Maximum 25 stocks"
        })
    });
};
var AddCheckbox = function(param) {
    var isSelected = param.isSelected, isDisabled = param.isDisabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
        title: isDisabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContent, {}) : false,
        overlayInnerStyle: {
            background: ui/* color.light */.$_.light,
            padding: "8px 16px",
            border: "1px solid ".concat(ui/* color.downgray */.$_.downgray)
        },
        overlayClassName: "tooltip-overlay-transparent",
        placement: "bottom",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Checkbox, {
            isDisabled: isDisabled,
            children: isSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/rt-company-checkmark.svg",
                class: "selected"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/rt-company-add.svg",
                class: "add"
            })
        })
    });
};
var SearchItem = function(props) {
    var symbolName = props.name, symbol = props.symbol_2, desc = props.desc, onSelect = props.onSelect, onRemove = props.onRemove, isSelected = props.isSelected, isDisabled = props.isDisabled, hasCheckbox = props.hasCheckbox;
    var handleClickCheckbox = function() {
        if (isSelected) {
            onRemove("".concat(symbol, "#").concat(symbolName));
        } else {
            onSelect("".concat(symbol, "#").concat(symbolName));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchItemContainer, {
        onClick: isDisabled && !isSelected ? null : handleClickCheckbox,
        isDisabled: isDisabled && !isSelected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyIcon, {
                symbol: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem_Text, {
                weight: "700",
                width: "52px",
                ellipsis: true,
                children: symbol
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchItem_Text, {
                width: hasCheckbox ? "150px" : "180px",
                ellipsis: true,
                children: desc
            }),
            hasCheckbox && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddCheckbox, {
                isSelected: isSelected,
                isDisabled: isDisabled && !isSelected
            })
        ]
    });
};
/* harmony default export */ var SearchStock_SearchItem = (SearchItem);

// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/store.ts







var initialState = {
    isLoading: false,
    data: [],
    hasMoreCompany: false
};
var searchCompanyStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        fetch: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(query, page) {
                var res, _data, data, message, error_type, error;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(query.length > 1)) {
                                _ctx.next = 13;
                                break;
                            }
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return search/* default.getSearchCompany */.Z.getSearchCompany(query, page);
                        case 4:
                            res = _ctx.sent;
                            if (res.data) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error("Error while search company data");
                        case 7:
                            _data = res.data, data = _data.data, message = _data.message, error_type = _data.error_type, error = _data.error;
                            if (!(error || error_type)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(message);
                        case 10:
                            set((0,immer_esm/* default */.ZP)(function(state) {
                                state.data = data.company;
                                state.hasMoreCompany = data.pagination.has_more_companies;
                                state.isLoading = false;
                            }));
                            _ctx.next = 14;
                            break;
                        case 13:
                            {
                                set((0,_object_spread/* default */.Z)({}, initialState));
                            }
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(query, page) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
var selectedSymbolStore = (0,esm/* default */.ZP)(function(set) {
    return {
        symbols: [],
        updateSymbols: function(symbols) {
            set({
                symbols: symbols
            });
        }
    };
});


;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/SearchStock/index.tsx
/* eslint-disable react/no-array-index-key */ 

















var SearchStock_Flex = ui/* Common.Flex */.Gn.Flex, SearchStock_Text = ui/* Common.Text */.Gn.Text;
var SearchStock = function(param) {
    var isAllowMultipleSelect = param.isAllowMultipleSelect, filter = param.filter, setFilter = param.setFilter, showResult = param.showResult, onShowSearchResult = param.onShowSearchResult, onApplyStockFilter = param.onApplyStockFilter;
    var searchCompany = searchCompanyStore(function(s) {
        return s.fetch;
    });
    var searchResult = searchCompanyStore(function(s) {
        return s.data;
    });
    var isLoading = searchCompanyStore(function(s) {
        return s.isLoading;
    });
    var selectedSymbol = selectedSymbolStore(function(store) {
        return store.symbols;
    });
    var updateSymbols = selectedSymbolStore(function(s) {
        return s.updateSymbols;
    });
    var isDisabled = (filter === null || filter === void 0 ? void 0 : filter.type) !== types/* StockFilterTypeEnum.Custom */.d.Custom;
    var ref = (0,react.useState)([]), tempSelectedSymbol = ref[0], setTempSelectedSymbol = ref[1];
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,useClickOutside/* default */.Z)(function() {
        if (showResult && isAllowMultipleSelect) {
            var appliedSymbol = (0,_to_consumable_array/* default */.Z)(selectedSymbol).concat((0,_to_consumable_array/* default */.Z)(tempSelectedSymbol));
            updateSymbols(appliedSymbol);
            setTempSelectedSymbol([]);
            setKeyword("");
            onApplyStockFilter({
                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                selected: appliedSymbol
            });
        }
    }), searchStockRef = ref2.ref;
    var keywordDebounce = (0,useDebounce/* default */.Z)(keyword, 500);
    (0,react.useEffect)(function() {
        setKeyword("");
    }, []);
    (0,react.useEffect)(function() {
        searchCompany(keywordDebounce, 1);
    }, [
        keywordDebounce
    ]);
    var onSelectCompany = function(symbol) {
        if (isAllowMultipleSelect) {
            setTempSelectedSymbol(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    symbol
                ]);
            });
        } else {
            setTempSelectedSymbol(function() {
                return [
                    symbol
                ];
            });
            onApplyStockFilter({
                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                selected: [
                    symbol
                ]
            });
        }
    };
    var onRemoveCompany = function(symbol) {
        if (tempSelectedSymbol.includes(symbol)) {
            var updatedSymbols = tempSelectedSymbol.filter(function(item) {
                return item !== symbol;
            });
            setTempSelectedSymbol(updatedSymbols);
        }
        if (selectedSymbol.includes(symbol)) {
            var updatedSymbols1 = selectedSymbol.filter(function(item) {
                return item !== symbol;
            });
            updateSymbols(updatedSymbols1);
        }
    };
    var handlePressEnter = function(e) {
        var findSymbol = searchResult.find(function(item) {
            var ref, ref1;
            return ((ref = item.symbol_2) === null || ref === void 0 ? void 0 : ref.toUpperCase()) === ((ref1 = e.target.value) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase());
        });
        if (findSymbol && isAllowMultipleSelect) {
            var symbolCombined = "".concat(findSymbol.symbol_2, "#").concat(findSymbol.name);
            var isAlreadyAdded = selectedSymbol.includes(symbolCombined);
            if (!isAlreadyAdded) {
                var appliedSymbol = (0,_to_consumable_array/* default */.Z)(selectedSymbol).concat([
                    symbolCombined
                ]);
                onApplyStockFilter({
                    type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                    selected: appliedSymbol
                });
                updateSymbols(appliedSymbol);
                setTempSelectedSymbol([]);
            }
        } else if (findSymbol && !isAllowMultipleSelect) {
            var symbolCombined1 = "".concat(findSymbol.symbol_2, "#").concat(findSymbol.name);
            onApplyStockFilter({
                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                selected: [
                    symbolCombined1
                ]
            });
            updateSymbols([
                symbolCombined1
            ]);
            setTempSelectedSymbol([]);
        }
    };
    var onClickAdd = function() {
        var appliedSymbol = (0,_to_consumable_array/* default */.Z)(selectedSymbol).concat((0,_to_consumable_array/* default */.Z)(tempSelectedSymbol));
        updateSymbols(appliedSymbol);
        setTempSelectedSymbol([]);
        setKeyword("");
        onShowSearchResult(false);
        onApplyStockFilter({
            type: types/* StockFilterTypeEnum.Custom */.d.Custom,
            selected: appliedSymbol
        });
    };
    var onClickCancel = function() {
        onShowSearchResult(false);
        setTempSelectedSymbol([]);
    };
    var isEmpty = (0,react.useMemo)(function() {
        if (searchResult.length === 0 && keyword.length > 1) {
            return true;
        }
        return false;
    }, [
        isLoading,
        searchResult,
        keyword
    ]);
    (0,react.useEffect)(function() {
        setFilter({
            type: types/* StockFilterTypeEnum.Custom */.d.Custom,
            selected: selectedSymbol
        });
    }, [
        selectedSymbol
    ]);
    (0,react.useEffect)(function() {
        // reset selected symbol if user remove symbol but not apply the filter
        if (filter.type === types/* StockFilterTypeEnum.Custom */.d.Custom && filter.selected !== selectedSymbol) {
            updateSymbols(filter.selected);
        }
    }, [
        filter
    ]);
    var showSelectedSymbolChip = isAllowMultipleSelect && !showResult && selectedSymbol.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: searchStockRef,
        style: {
            height: showResult ? "100%" : "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchContainer, {
                        onClick: function() {
                            setFilter({
                                type: types/* StockFilterTypeEnum.Custom */.d.Custom,
                                selected: selectedSymbol
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_Flex, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput, {
                                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/search-rounded.svg",
                                        alt: "icon",
                                        width: "14px",
                                        height: "13px"
                                    }),
                                    placeholder: "Search Stocks",
                                    value: keyword,
                                    onChange: function(e) {
                                        onShowSearchResult(true);
                                        setKeyword(e.target.value);
                                    },
                                    onPressEnter: handlePressEnter,
                                    "data-cy": data_cy/* default.RUNNING_TRADE.SEARCH_INPUT */.Z.RUNNING_TRADE.SEARCH_INPUT
                                })
                            }),
                            showSelectedSymbolChip && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInputDivider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedSymbolWrapper, {
                                        isDisabled: isDisabled,
                                        children: selectedSymbol.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_StockChip, {
                                                symbol: item.split("#")[0],
                                                onRemove: function() {
                                                    return onRemoveCompany(item);
                                                }
                                            }, item);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    selectedSymbol.length >= 25 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_Text, {
                        size: "12px",
                        color: "#858585",
                        children: "*Maximum 25 Stocks"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: showResult ? "block" : "none"
                },
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, {
                        children: (0,_to_consumable_array/* default */.Z)(Array(4)).map(function(___, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkeletonItemWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_SkeletonItemText, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_SkeletonItemCheckbox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "checkbox"
                                        })
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                        condition: !isLoading,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isEmpty,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchStock_Flex, {
                                    align: "center",
                                    justify: "center",
                                    direction: "column",
                                    height: "410px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/illustration/empty-search-running-trade.svg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_Text, {
                                            mt: "16px",
                                            size: "13px",
                                            color: "#858585",
                                            children: "No result found"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isEmpty,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanySearchResultWrapper, {
                                    children: searchResult.map(function(item) {
                                        return /*#__PURE__*/ (0,react.createElement)(SearchStock_SearchItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                            key: item.id,
                                            onSelect: onSelectCompany,
                                            onRemove: onRemoveCompany,
                                            isSelected: selectedSymbol.includes("".concat(item.symbol_2, "#").concat(item.name)) || tempSelectedSymbol.includes("".concat(item.symbol_2, "#").concat(item.name)),
                                            isDisabled: selectedSymbol.length + tempSelectedSymbol.length >= 25,
                                            hasCheckbox: isAllowMultipleSelect
                                        }));
                                    })
                                })
                            })
                        ]
                    }),
                    isAllowMultipleSelect && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_FormFooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_styled_Button, {
                                onClick: onClickCancel,
                                style: {
                                    color: "#858585"
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStock_styled_Button, {
                                type: "primary",
                                onClick: onClickAdd,
                                disabled: tempSelectedSymbol.length === 0,
                                children: "Add"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var StocksFilter_SearchStock = (SearchStock);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/DropdownContent.tsx












var DropdownContent = function(param) {
    var isMarketOpen = param.isMarketOpen, onClosePopover = param.onClosePopover;
    var ref = (0,react.useState)(false), showResult = ref[0], setShowResult = ref[1];
    var defaultFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var onApplyFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onApplyStockFilter;
    });
    var onResetActionFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onResetFilter;
    });
    var ref1 = (0,react.useState)(defaultFilter), filter = ref1[0], setFilter = ref1[1];
    var clearData = (0,store_runningTrade/* useRunningTradeStore */.C)(function(state) {
        return state.clearData;
    });
    var onClickApply = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var appliedFilter, res, _data, data, message, error_type, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        appliedFilter = filter;
                        if (!((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 4;
                        return watchlist/* default.getSymbolWatchlist */.Z.getSymbolWatchlist(filter === null || filter === void 0 ? void 0 : filter.watchlistId);
                    case 4:
                        res = _ctx.sent;
                        if (res.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error while search company data");
                    case 7:
                        _data = res.data, data = _data.data, message = _data.message, error_type = _data.error_type, error = _data.error;
                        if (!(error || error_type)) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(message);
                    case 10:
                        appliedFilter.selected = data === null || data === void 0 ? void 0 : data.symbols;
                        setFilter(appliedFilter);
                    case 12:
                        if (!isMarketOpen && (filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.AllStock */.d.AllStock) {
                            onResetActionFilter();
                        }
                        onApplyFilter(appliedFilter);
                        clearData("widget");
                        onClosePopover();
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickApply() {
            return _ref.apply(this, arguments);
        };
    }();
    var isButtonDisabled = (0,react.useMemo)(function() {
        if ((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom) {
            if (isMarketOpen) {
                return filter.selected.length === 0;
            }
            return true;
        }
        if ((filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist) {
            return filter.watchlistItemCounts === 0;
        }
        return filter === null;
    }, [
        filter
    ]);
    (0,react.useEffect)(function() {
        // reset default active filter
        setFilter(defaultFilter);
    }, []);
    var onApplyStockFilter = function(value) {
        setFilter(value);
        onApplyFilter(value);
        clearData("widget");
        onClosePopover();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_SearchStock, {
                        filter: filter,
                        setFilter: setFilter,
                        showResult: showResult,
                        onShowSearchResult: function(show) {
                            return setShowResult(show);
                        },
                        onApplyStockFilter: onApplyStockFilter,
                        isAllowMultipleSelect: isMarketOpen
                    }),
                    !showResult && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_AllStock, {
                                isChecked: (filter === null || filter === void 0 ? void 0 : filter.type) === types/* StockFilterTypeEnum.AllStock */.d.AllStock,
                                setFilter: setFilter
                            }),
                            isMarketOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_MyWatchlist, {
                                filter: filter,
                                setFilter: setFilter
                            })
                        ]
                    })
                ]
            }),
            !showResult && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonApply, {
                    disabled: isButtonDisabled,
                    onClick: onClickApply,
                    children: "Apply"
                })
            })
        ]
    });
};
/* harmony default export */ var StocksFilter_DropdownContent = (DropdownContent);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/StocksFilter/index.tsx










var StocksFilter_Text = ui/* Common.Text */.Gn.Text, StocksFilter_Flex = ui/* Common.Flex */.Gn.Flex;
var StocksFilter = function(param) {
    var isMarketOpen = param.isMarketOpen;
    var ref, ref1, ref2;
    var popoverRef = (0,react.useRef)(null);
    var popoverButtonRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var selectedStockFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var handleClickOutside = function(event) {
        var ref;
        if ((ref = popoverButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target)) return;
        if (popoverRef.current && !popoverRef.current.contains(event.target)) {
            setVisible(false);
        }
    };
    (0,react.useEffect)(function() {
        if (visible) {
            document.addEventListener("click", handleClickOutside);
        } else {
            document.removeEventListener("click", handleClickOutside);
        }
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonDropdownTrigger, {
                onClick: function() {
                    return setVisible(!visible);
                },
                isOpened: visible,
                ref: popoverButtonRef,
                children: [
                    (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.type) === types/* StockFilterTypeEnum.Custom */.d.Custom && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : (ref = selectedStockFilter.selected) === null || ref === void 0 ? void 0 : ref.length) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StocksFilter_Flex, {
                                    align: "center",
                                    style: {
                                        gap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyIcon, {
                                            symbol: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.selected[0].split("#")[0]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_Text, {
                                            size: "12px",
                                            children: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.selected[0].split("#")[0]
                                        })
                                    ]
                                })
                            }),
                            (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : (ref1 = selectedStockFilter.selected) === null || ref1 === void 0 ? void 0 : ref1.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StocksFilter_Flex, {
                                    align: "center",
                                    style: {
                                        gap: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StockCount, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_Text, {
                                                size: "13px",
                                                color: ui/* color.primary */.$_.primary,
                                                children: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : (ref2 = selectedStockFilter.selected) === null || ref2 === void 0 ? void 0 : ref2.length
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_Text, {
                                            size: "12px",
                                            children: "Stocks"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.type) === types/* StockFilterTypeEnum.AllStock */.d.AllStock && /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_Text, {
                        size: "12px",
                        ml: "12px",
                        children: "All Stocks"
                    }),
                    (selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.type) === types/* StockFilterTypeEnum.Watchlist */.d.Watchlist && /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_Text, {
                        size: "12px",
                        ml: "12px",
                        style: {
                            maxWidth: 87
                        },
                        ellipsis: true,
                        children: selectedStockFilter === null || selectedStockFilter === void 0 ? void 0 : selectedStockFilter.watchlistName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/chevron-down.svg",
                        id: "rt-filter-chevron-down"
                    })
                ]
            }),
            visible && /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
                ref: popoverRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StocksFilter_DropdownContent, {
                    isMarketOpen: isMarketOpen,
                    onClosePopover: function() {
                        return setVisible(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var ActionControl_StocksFilter = (StocksFilter);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/ActionControl/index.tsx

 // Implemented on next phase

 // Implemented on next phase





var ActionControl_Flex = ui/* Common.Flex */.Gn.Flex;
var ActionControl = function(param) {
    var isMarketOpen = param.isMarketOpen, _hideStockFilter = param.hideStockFilter, hideStockFilter = _hideStockFilter === void 0 ? false : _hideStockFilter, _playAlignRight = param.playAlignRight, playAlignRight = _playAlignRight === void 0 ? false : _playAlignRight;
    var stockFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var isLeftPlayVisible = (0,react.useMemo)(function() {
        return isMarketOpen && !playAlignRight;
    }, [
        isMarketOpen,
        playAlignRight
    ]);
    var isRightPlayVisible = (0,react.useMemo)(function() {
        return isMarketOpen && playAlignRight;
    }, [
        isMarketOpen,
        playAlignRight
    ]);
    var showAdvancedFilter = (0,react.useMemo)(function() {
        if (isMarketOpen) return true;
        if (!isMarketOpen && stockFilter.type === types/* StockFilterTypeEnum.Custom */.d.Custom && stockFilter.selected.length === 1) {
            return true;
        }
        return false;
    }, [
        stockFilter,
        isMarketOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionControlWrapper, {
        children: [
            isLeftPlayVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_PausePlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionControl_Flex, {
                style: {
                    gap: 8
                },
                justify: "end",
                children: [
                    isRightPlayVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_PausePlay, {}),
                    !hideStockFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_StocksFilter, {
                        isMarketOpen: isMarketOpen
                    }),
                    showAdvancedFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionControl_AdvancedFilter, {
                        isMarketOpen: isMarketOpen
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RunningTrade_ActionControl = (ActionControl);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/useRunningTradeCustomFilter.ts


var useRunningTradeCustomFilter = function(isUseCustomFilter) {
    var getFilter = function() {
        return store/* useFilterStore.getState */.r.getState().filter;
    };
    var getStockFilter = function() {
        return store/* useFilterStore.getState */.r.getState().stocksFilter;
    };
    var runningTradeFilter = function(items) {
        if (!isUseCustomFilter) return items;
        var filter = getFilter();
        var stockFilter = getStockFilter();
        return filterRunningTrade(items, filter, stockFilter);
    };
    return {
        runningTradeFilter: runningTradeFilter
    };
};
/* harmony default export */ var RunningTrade_useRunningTradeCustomFilter = (useRunningTradeCustomFilter);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/index.tsx





















var tableIdentifierClassName = "table-scroller";
function RunningTrade(param) {
    var _runningTradeKey = param.runningTradeKey, runningTradeKey = _runningTradeKey === void 0 ? "widget" : _runningTradeKey, className = param.className, _minDataLength = param.minDataLength, minDataLength = _minDataLength === void 0 ? 10 : _minDataLength, isPro = param.isPro, hideHeader = param.hideHeader, _hideCode = param.hideCode, hideCode = _hideCode === void 0 ? false : _hideCode, _hideStockFilter = param.hideStockFilter, hideStockFilter = _hideStockFilter === void 0 ? false : _hideStockFilter, _playAlignRight = param.playAlignRight, playAlignRight = _playAlignRight === void 0 ? false : _playAlignRight, fullWidth = param.fullWidth, _isVolumeColor = param.isVolumeColor, isVolumeColor = _isVolumeColor === void 0 ? false : _isVolumeColor, _allowInitialData = param.allowInitialData, allowInitialData = _allowInitialData === void 0 ? false : _allowInitialData;
    var ref = (0,react.useState)(false), isOpenMarket = ref[0], setIsOpenMarket = ref[1];
    // performance issue in BE, so we need to use V1
    // will be updated if BE fixing the V2 version
    var runningTradeVersion = "V2";
    var filter = (0,store/* useFilterStore */.r)(function(s) {
        return s.filter;
    });
    var stocksFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.stocksFilter;
    });
    var isPaused = (0,store_runningTrade/* useRunningTradeStore */.C)(function(s) {
        return s.runningTrade.widget.isPaused;
    });
    var onApplyStockFilter = (0,store/* useFilterStore */.r)(function(s) {
        return s.onApplyStockFilter;
    });
    var combinedCustomFilter = (0,react.useMemo)(function() {
        return mapCustomFilter((0,_object_spread/* default */.Z)({}, filter, stocksFilter), allowInitialData ? false : isOpenMarket);
    }, [
        filter,
        stocksFilter,
        isOpenMarket
    ]);
    var wrapperRef = (0,react.useRef)(null);
    var runningTradeFilter = RunningTrade_useRunningTradeCustomFilter(true).runningTradeFilter;
    var ref1 = Datafeed_useRunningTrade(runningTradeKey, runningTradeFilter), isLoading = ref1.isLoading, runningTrade = ref1.runningTrade, setInstanceActive = ref1.setInstanceActive, setInstanceFilter = ref1.setInstanceFilter, setDebounceInstanceFilter = ref1.setDebounceInstanceFilter;
    var ref2 = (0,useDatafeedSocket/* default */.Z)(), datafeedError = ref2.error;
    var ref3 = (0,useRunningTradeInit/* default */.Z)({
        version: runningTradeVersion,
        defaultParams: (0,_object_spread/* default */.Z)({
            sort: "desc",
            order_by: "ORDER_BY_TIME",
            limit: 50
        }, combinedCustomFilter),
        onSuccess: function(data) {
            var ref;
            setInstanceActive(data.is_open_market);
            setIsOpenMarket(data.is_open_market);
            if (!data.is_open_market && stocksFilter.type === types/* StockFilterTypeEnum.Custom */.d.Custom && (stocksFilter === null || stocksFilter === void 0 ? void 0 : (ref = stocksFilter.selected) === null || ref === void 0 ? void 0 : ref.length) > 1) {
                onApplyStockFilter({
                    type: types/* StockFilterTypeEnum.AllStock */.d.AllStock,
                    selected: []
                });
            }
        }
    }), runningTradeRes = ref3.runningTradeRes, runningTrades = ref3.runningTrades, isInitiating = ref3.isInitiating, isLoadingMore = ref3.isLoadingMore, hasMore = ref3.hasMore, loadMore = ref3.loadMore, params = ref3.params, setParams = ref3.setParams;
    (0,react.useEffect)(function() {
        if (allowInitialData || !isInitiating && !isOpenMarket) {
            setParams(function(s) {
                return (0,_object_spread/* default */.Z)({
                    sort: s.sort,
                    limit: s.limit,
                    order_by: s.order_by,
                    trade_number: undefined
                }, mapCustomFilter((0,_object_spread/* default */.Z)({}, filter, stocksFilter), allowInitialData ? false : isOpenMarket));
            });
        }
    }, [
        filter,
        stocksFilter,
        allowInitialData
    ]);
    var handleReloadClick = function() {
        window.location.reload();
    };
    var scrollToTop = (0,react.useCallback)(function() {
        // Reset ant table body scroll position back to top
        if (wrapperRef) {
            var scrollableEl = wrapperRef.current.querySelector(".".concat(tableIdentifierClassName));
            if (!scrollableEl) return;
            scrollableEl.scrollTo({
                top: 0
            });
        }
    }, []);
    var handleSetSocketFilter = (0,react.useCallback)(function(symbol) {
        setDebounceInstanceFilter(symbol || "*");
    }, []);
    var handleSetAPIFilter = (0,react.useCallback)(function(symbol) {
        setParams(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                symbol: symbol,
                trade_number: undefined
            });
        });
        scrollToTop();
        setInstanceFilter(symbol);
    }, [
        scrollToTop
    ]);
    var handleTableSort = (0,react.useCallback)(function(field, order) {
        setParams(function(s) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, s), {
                sort: order,
                order_by: field,
                trade_number: undefined
            });
        });
        scrollToTop();
    }, []);
    (0,react.useEffect)(function() {
        setInstanceFilter(runningTrade.filter || "*");
        if (runningTrade.filter !== "" && runningTrade.filter !== "*") {
            handleSetSocketFilter(runningTrade.filter);
            handleSetAPIFilter(runningTrade.filter);
        }
    }, [
        runningTrade.filter
    ]);
    if (!isInitiating && runningTradeRes && runningTradeRes.is_open_market && datafeedError) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Failed/* default */.Z, {
            onReloadClick: handleReloadClick
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Box */.xu, {
        id: "running-trade",
        className: className,
        ref: wrapperRef,
        children: [
            !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade_Header, {
                children: "Running Trade"
            }),
            isPro ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    overflow: "hidden",
                    height: "calc(100vh - 42px)"
                },
                children: isInitiating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimarySpinner/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade_ActionControl, {
                            isMarketOpen: runningTradeRes === null || runningTradeRes === void 0 ? void 0 : runningTradeRes.is_open_market,
                            hideStockFilter: hideStockFilter,
                            playAlignRight: playAlignRight
                        }),
                        runningTradeRes && runningTradeRes.is_open_market ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTradeTable/* default */.Z, {
                            initialData: allowInitialData ? runningTradeRes.running_trade : [],
                            minDataLength: minDataLength,
                            data: runningTrade.data,
                            loading: isLoading,
                            showAction: true,
                            height: "calc(100vh - 133px)",
                            hideCode: hideCode,
                            isPaused: isPaused,
                            isCodeBold: true,
                            isVolumeColor: isVolumeColor
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTradeInitTable/* default */.Z, {
                            id: tableIdentifierClassName,
                            data: runningTrades,
                            showCode: !hideCode,
                            showAction: true,
                            hasMore: hasMore,
                            loadMore: loadMore,
                            isLoadingMore: isLoadingMore,
                            height: "calc(100vh - 102px)",
                            handleTableSort: handleTableSort,
                            defaultSort: {
                                direction: params.sort,
                                key: params.order_by
                            }
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                height: "90vh",
                source: analytics/* SideWidgetAnalytics.RUNNING_TRADE */.Lb.RUNNING_TRADE
            })
        ]
    });
}
/* harmony default export */ var SideWidget_RunningTrade = (RunningTrade);


/***/ }),

/***/ 78970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useFilterStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var global_Datafeed_store_runningTrade__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11453);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7365);



var useFilterStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return {
        filter: null,
        stocksFilter: {
            type: _types__WEBPACK_IMPORTED_MODULE_1__/* .StockFilterTypeEnum.AllStock */ .d.AllStock,
            selected: []
        },
        onApplyFilter: function(filter) {
            set({
                filter: filter
            });
            global_Datafeed_store_runningTrade__WEBPACK_IMPORTED_MODULE_0__/* .useRunningTradeStore.getState */ .C.getState().play("widget");
        },
        onResetFilter: function() {
            set({
                filter: null
            });
            global_Datafeed_store_runningTrade__WEBPACK_IMPORTED_MODULE_0__/* .useRunningTradeStore.getState */ .C.getState().play("widget");
        },
        onApplyStockFilter: function(activeFilter) {
            set({
                stocksFilter: activeFilter
            });
            global_Datafeed_store_runningTrade__WEBPACK_IMPORTED_MODULE_0__/* .useRunningTradeStore.getState */ .C.getState().play("widget");
        }
    };
});


/***/ }),

/***/ 6775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AG": function() { return /* binding */ ThSortIconWrapper; },
/* harmony export */   "G4": function() { return /* binding */ TdSymbol; },
/* harmony export */   "Od": function() { return /* binding */ Skeleton; },
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "U5": function() { return /* binding */ TdBroker; },
/* harmony export */   "VM": function() { return /* binding */ TdAction; },
/* harmony export */   "YY": function() { return /* binding */ TdPrice; },
/* harmony export */   "b9": function() { return /* binding */ RunningTradeEmptyText; },
/* harmony export */   "eL": function() { return /* binding */ TableInitWrapper; },
/* harmony export */   "eQ": function() { return /* binding */ RunningTradeEmptyWrapper; },
/* harmony export */   "gM": function() { return /* binding */ HeaderContainer; },
/* harmony export */   "hN": function() { return /* binding */ ReloadButton; },
/* harmony export */   "iA": function() { return /* binding */ Table; },
/* harmony export */   "jy": function() { return /* binding */ ThSortIconContent; },
/* harmony export */   "xu": function() { return /* binding */ Box; },
/* harmony export */   "yQ": function() { return /* binding */ ThSortWrapper; }
/* harmony export */ });
/* unused harmony exports DatePicker, SearchWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41080);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow: auto;\n\n  & table {\n    border-collapse: separate;\n    border-spacing: 0;\n    width: 100%;\n    table-layout: fixed;\n\n    th,\n    td {\n      text-align: center;\n      font-size: 12px;\n      line-height: 30px;\n      padding: 0;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n    }\n\n    th {\n      font-family: var(--bold-font);\n      position: sticky;\n      top: 0;\n      background-color: #fff;\n      border-bottom: 1px solid ",
        ";\n    }\n\n    td {\n      transition: background-color 0.3s;\n    }\n\n    td.company-code {\n      font-family: var(--bold-font);\n    }\n\n    tr:hover {\n      td {\n        background-color: #f5f6f7;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  text-overflow: ellipsis !important;\n\n  & table th p {\n    font-size: 12px;\n    font-family: var(--bold-font);\n    text-align: center;\n  }\n\n  & table td {\n    background: transparent;\n  }\n\n  & table td p {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .ant-spin-nested-loading > div > .ant-spin {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    .ant-spin-dot {\n      position: static;\n      margin: 0;\n    }\n  }\n\n  thead.ant-table-thead {\n    th.ant-table-cell {\n      background-color: #fff;\n      padding-bottom: 10px;\n      border-bottom: 1px solid ",
        ";\n      text-align: center;\n\n      .ant-table-column-sorters {\n        padding: unset;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 40px;\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  color: #00ab6b;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  border-top: none !important;\n  height: 32px;\n  :nth-child(1) {\n    border-right: none !important;\n  }\n  :hover,\n  :focus {\n    border-top: none !important;\n    :nth-child(1) {\n      border-right: none !important;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  height: 44px;\n  border-radius: 22px;\n  cursor: pointer;\n\n  p {\n    color: ",
        ";\n    margin-left: 5px;\n    font-weight: 700;\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n  .ant-skeleton-content > ul {\n    margin: 0 !important;\n  }\n  .ant-skeleton-content .ant-skeleton-title,\n  .ant-skeleton-content .ant-skeleton-paragraph > li {\n    height: 16px !important;\n    margin: 0 0 14px !important;\n    border-radius: 4px !important;\n  }\n\n  .ant-skeleton-content .ant-skeleton-paragraph > li:last-child {\n    margin: 0 !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 300px;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 8px;\n  color: #858585;\n  font-size: 12px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  align-items: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 11px;\n  margin-left: 8px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  color: ",
        ";\n\n  & + & {\n    margin-top: -0.3em;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, DatePickerDefault = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.DatePicker */ .Gn.DatePicker;
var TableDefault = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Widget.Table */ .$L.Table;
var cellType = {
    up: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary,
    down: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange,
    neutral: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.suvaGrey */ .$_.suvaGrey,
    default: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis,
    local: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.purpleHeart */ .$_.purpleHeart,
    bumn: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.green */ .$_.green,
    foreign: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.venetianRed */ .$_.venetianRed
};
var actionColor = {
    0: "#333333",
    1: "#00ab6b",
    2: "#ee4a49"
};
var TableInitWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-a3c352bf-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var Table = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(TableDefault).withConfig({
    componentId: "sc-a3c352bf-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var HeaderContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    justify: "space-between",
    px: "10px"
}).withConfig({
    componentId: "sc-a3c352bf-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var Td = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function(props) {
    return {
        height: "30px",
        size: "12px",
        type: props.type,
        isColored: props.isColored
    };
}).withConfig({
    componentId: "sc-a3c352bf-3"
})(_templateObject3(), function(param) {
    var isColored = param.isColored, type = param.type;
    if (!isColored) return actionColor[0];
    return actionColor[type] || actionColor[0];
});
var TdSymbol = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function() {
    return {
        height: "30px",
        size: "12px",
        weight: "bold"
    };
}).withConfig({
    componentId: "sc-a3c352bf-4"
})(_templateObject4());
var TdAction = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function(props) {
    return {
        height: "30px",
        size: "12px",
        type: props.type,
        isColored: props.isColored
    };
}).withConfig({
    componentId: "sc-a3c352bf-5"
})(_templateObject5(), function(param) {
    var isColored = param.isColored, type = param.type;
    return !isColored ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.nightRider */ .$_.nightRider) : type == 1 ? "#00ab6b" : "#ee4a49";
});
var TdPrice = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function(props) {
    return {
        height: "30px",
        size: "12px",
        type: props.type,
        isColored: props.isColored
    };
}).withConfig({
    componentId: "sc-a3c352bf-6"
})(_templateObject6(), function(param) {
    var isColored = param.isColored, change = param.change;
    return !isColored ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.nightRider */ .$_.nightRider) : change == 0 ? "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.suvaGrey */ .$_.suvaGrey) : change > 0 ? "#00ab6b" : "#ee4a49";
});
var Th = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Td).attrs({
    size: "8px"
}).withConfig({
    componentId: "sc-a3c352bf-7"
})(_templateObject7());
var DatePicker = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(DatePickerDefault).withConfig({
    componentId: "sc-a3c352bf-8"
})(_templateObject8());
var ReloadButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    px: "20px",
    mt: "20px"
}).withConfig({
    componentId: "sc-a3c352bf-9"
})(_templateObject9(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var Box = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-a3c352bf-10"
})(_templateObject10());
var SearchWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-a3c352bf-11"
})(_templateObject11());
var Skeleton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    active: true,
    avatar: false,
    loading: true,
    title: false,
    round: true
}).withConfig({
    componentId: "sc-a3c352bf-12"
})(_templateObject12());
var RunningTradeEmptyWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-a3c352bf-13"
})(_templateObject13());
var RunningTradeEmptyText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-a3c352bf-14"
})(_templateObject14());
var ThSortWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-a3c352bf-15"
})(_templateObject15());
var ThSortIconWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-a3c352bf-16"
})(_templateObject16());
var ThSortIconContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({
    componentId: "sc-a3c352bf-17"
})(_templateObject17(), function(param) {
    var active = param.active;
    return active ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary : "#bfbfbf";
});
var brokerCodeColor = {
    BROKER_TYPE_FOREIGN: "red",
    BROKER_TYPE_GOVERNMENT: "green",
    BROKER_TYPE_LOCAL: "purple",
    BROKER_TYPE_UNSPECIFIED: "#000"
};
var TdBroker = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].td.withConfig({
    componentId: "sc-a3c352bf-18"
})(_templateObject18(), function(param) {
    var type = param.type;
    return brokerCodeColor[type];
});



/***/ }),

/***/ 7365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ RunningTradeCustomFilterActionEnum; },
/* harmony export */   "d": function() { return /* binding */ StockFilterTypeEnum; }
/* harmony export */ });
var RunningTradeCustomFilterActionEnum;
(function(RunningTradeCustomFilterActionEnum) {
    RunningTradeCustomFilterActionEnum[RunningTradeCustomFilterActionEnum["ALL"] = 0] = "ALL";
    RunningTradeCustomFilterActionEnum[RunningTradeCustomFilterActionEnum["BUY"] = 1] = "BUY";
    RunningTradeCustomFilterActionEnum[RunningTradeCustomFilterActionEnum["SELL"] = 2] = "SELL";
})(RunningTradeCustomFilterActionEnum || (RunningTradeCustomFilterActionEnum = {}));
var StockFilterTypeEnum;
(function(StockFilterTypeEnum) {
    StockFilterTypeEnum["Custom"] = "custom";
    StockFilterTypeEnum["AllStock"] = "allstock";
    StockFilterTypeEnum["Watchlist"] = "watchlist";
})(StockFilterTypeEnum || (StockFilterTypeEnum = {}));


/***/ }),

/***/ 64577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1349);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25516);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61608);
/* harmony import */ var hooks_useAsync__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64030);










var fetchRunningTrade = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var res, _data, message, error, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_company__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitRunningTrade */ .Z.getInitRunningTrade(params);
                case 2:
                    res = _ctx.sent;
                    if (res.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to get init of Running Trades Failed");
                case 5:
                    _data = res.data, message = _data.message, error = _data.error, data = _data.data;
                    if (!error) {
                        _ctx.next = 9;
                        break;
                    }
                    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                    throw new Error(message);
                case 9:
                    return _ctx.abrupt("return", data);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchRunningTrade(params) {
        return _ref.apply(this, arguments);
    };
}();
var fetchRunningTradeV2 = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        var res, _data, message, error, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_company__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitRunningTradeV2 */ .Z.getInitRunningTradeV2(params);
                case 2:
                    res = _ctx.sent;
                    if (res.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to get init of Running Trades Failed");
                case 5:
                    _data = res.data, message = _data.message, error = _data.error, data = _data.data;
                    if (!error) {
                        _ctx.next = 9;
                        break;
                    }
                    (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(message, constants_errorMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                    throw new Error(message);
                case 9:
                    return _ctx.abrupt("return", data);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchRunningTradeV2(params) {
        return _ref.apply(this, arguments);
    };
}();
var useRunningTradeInit = function(param) {
    var version = param.version, defaultParams = param.defaultParams, onSuccess = param.onSuccess;
    var isV2 = version === "V2";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(defaultParams), params = ref[0], setParams = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), runningTrades = ref1[0], setRunningTrades = ref1[1];
    var ref2 = (0,hooks_useAsync__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!isV2) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 3;
                    return fetchRunningTradeV2(params);
                case 3:
                    _ctx.t0 = _ctx.sent;
                    _ctx.next = 9;
                    break;
                case 6:
                    _ctx.next = 8;
                    return fetchRunningTrade(params);
                case 8:
                    _ctx.t0 = _ctx.sent;
                case 9:
                    data = _ctx.t0;
                    setRunningTrades(function(s) {
                        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(params.trade_number ? s : []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data.running_trade));
                    });
                    if (onSuccess) onSuccess(data);
                    return _ctx.abrupt("return", data);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        params
    ]), runningTradeRes = ref2.value, error = ref2.error, isLoading = ref2.loading;
    var loadMore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setTimeout(function() {
            var cursor = runningTrades[runningTrades.length - 1].trade_number;
            setParams(function(s) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, s), {
                    trade_number: cursor
                });
            });
        }, error ? 1000 : 0);
    }, [
        runningTrades,
        error
    ]);
    var reload = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        setTimeout(function() {
            setParams(function(s) {
                return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, s);
            });
        }, error ? 1000 : 0);
    }, [
        runningTrades,
        error
    ]);
    return {
        runningTradeRes: runningTradeRes,
        runningTrades: runningTrades,
        isInitiating: isLoading && !error && !runningTradeRes,
        isLoadingMore: isLoading && runningTrades.length > 0,
        hasMore: runningTradeRes && runningTradeRes.running_trade.length > 0 || !!error,
        loadMore: loadMore,
        params: params,
        setParams: setParams,
        reload: reload
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useRunningTradeInit);


/***/ }),

/***/ 32457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OP": function() { return /* binding */ indonesiaMenu; },
/* harmony export */   "V3": function() { return /* binding */ baseMenu; },
/* harmony export */   "t2": function() { return /* binding */ SIDE_MENU_KEY; }
/* harmony export */ });
var SIDE_MENU_KEY = {
    ALL_WATCHLIST: "ALL_WATCHLIST",
    PRICE_ALERT: "PRICE_ALERT",
    RUNNING_TRADE: "RUNNING_TRADE",
    MOVERS: "MOVERS",
    VALUATION: "VALUATION",
    BANDAR_DETECTOR: "BANDAR_DETECTOR"
};
var baseMenu = [
    {
        key: SIDE_MENU_KEY.ALL_WATCHLIST,
        icon: "icon-widget_watchlist",
        text: "Watchlist",
        eventName: "watchlist"
    }, 
];
var indonesiaMenu = [
    {
        key: SIDE_MENU_KEY.PRICE_ALERT,
        icon: "icon-widget_alert",
        text: "Price Alert",
        eventName: "price_alert"
    },
    {
        key: SIDE_MENU_KEY.RUNNING_TRADE,
        icon: "icon-widget_runningtrade",
        text: "Running Trade",
        eventName: "running_trade"
    },
    {
        key: SIDE_MENU_KEY.MOVERS,
        icon: "icon-widget_hotlist",
        text: "Movers",
        eventName: "movers"
    },
    {
        key: SIDE_MENU_KEY.VALUATION,
        icon: "icon-widget_valuation",
        text: "Valuation",
        eventName: "valuation"
    },
    {
        key: SIDE_MENU_KEY.BANDAR_DETECTOR,
        icon: "icon-widget_bandar",
        text: "Bandar Detector",
        eventName: "bandar_detector"
    }, 
];


/***/ }),

/***/ 40995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainLayout_SideWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/features/paywall/store/index.ts + 1 modules
var store = __webpack_require__(92182);
// EXTERNAL MODULE: ./src/features/paywall/types.ts
var types = __webpack_require__(5072);
// EXTERNAL MODULE: ./src/features/paywall/constants.ts
var constants = __webpack_require__(11298);
;// CONCATENATED MODULE: ./src/features/paywall/store/useWidget.ts





function useWidget(activeTab) {
    var ref = (0,react.useState)(false), isAddonPro = ref[0], setIsAddonPro = ref[1];
    var ref1 = (0,store/* default */.Z)(function(state) {
        return {
            isPro: state.widget.isPro,
            data: state.widget.data,
            getStatus: state.getStatus,
            addCounter: state.addCounter
        };
    }, shallow/* default */.Z), isPro = ref1.isPro, data = ref1.data, getStatus = ref1.getStatus, addCounter = ref1.addCounter;
    (0,react.useEffect)(function() {
        if (!(data === null || data === void 0 ? void 0 : data.features) || !activeTab) return;
        if (activeTab.toUpperCase() === constants/* AddOnWidget */.t9) {
            var addOnData = data.features.find(function(item) {
                return item.feature === constants/* PaywallFeatureEnum.SCREENER */.qU.SCREENER;
            });
            setIsAddonPro((addOnData === null || addOnData === void 0 ? void 0 : addOnData.is_eligible) || false);
        }
    }, [
        data === null || data === void 0 ? void 0 : data.features
    ]);
    var widgetGetStatus = function(key) {
        var KEY = key.toUpperCase();
        var feature = constants/* PaywallFeatureEnum */.qU[KEY];
        if (!feature) return;
        if (KEY === constants/* AddOnWidget */.t9) {
            var features = [
                constants/* PaywallFeatureEnum.VALUATION */.qU.VALUATION,
                constants/* PaywallFeatureEnum.SCREENER */.qU.SCREENER
            ];
            getStatus({
                key: types/* SectionEnum.widget */.P.widget,
                feature: features
            });
            return;
        }
        getStatus({
            key: types/* SectionEnum.widget */.P.widget,
            feature: feature
        });
    };
    // post paywall counter
    var widgetAddCounter = function(key) {
        var KEY = key.toUpperCase();
        var feature = constants/* PaywallFeatureEnum */.qU[KEY];
        if (!feature) return;
        addCounter({
            feature: feature
        });
        if (KEY === constants/* AddOnWidget */.t9) {
            addCounter({
                feature: constants/* PaywallFeatureEnum.SCREENER */.qU.SCREENER
            });
        }
    };
    (0,react.useEffect)(function() {
        if (!activeTab) return;
        widgetGetStatus(activeTab);
    }, [
        activeTab
    ]);
    return {
        isPro: isPro,
        isAddonPro: isAddonPro,
        addCounter: function(key) {
            return widgetAddCounter(key);
        }
    };
};

// EXTERNAL MODULE: ./src/global/WebSocket/slice.ts
var slice = __webpack_require__(23985);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSearchCompanyModalStore.ts
var useSearchCompanyModalStore = __webpack_require__(5612);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
// EXTERNAL MODULE: ./src/features/paywall/Wrapper/Widget.tsx
var Widget = __webpack_require__(55872);
// EXTERNAL MODULE: ./src/features/paywall/analytics.ts
var analytics = __webpack_require__(67857);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/styled.ts
var styled = __webpack_require__(63914);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/Header.tsx





var Text = ui/* Common.Text */.Gn.Text;
var Header = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* HeaderContainer */.gM, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
            size: "16px",
            family: "bold",
            children: children
        })
    });
};
Header.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var BandarDetector_Header = (Header);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/slice.ts
var BandarDetector_slice = __webpack_require__(46881);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/constants.tsx
var BandarDetector_constants = __webpack_require__(13180);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/constants.ts
var SideWidget_constants = __webpack_require__(32457);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/BandarDetector/index.tsx












var BrokerSummary = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5880), __webpack_require__.e(7253)]).then(__webpack_require__.bind(__webpack_require__, 37253));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37253)
            ];
        }
    }
});
var TopBroker = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1796).then(__webpack_require__.bind(__webpack_require__, 71796));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71796)
            ];
        }
    }
});
var BrokerActivity = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8133).then(__webpack_require__.bind(__webpack_require__, 78133));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78133)
            ];
        }
    }
});
function BandarDetector(param) {
    var isPro = param.isPro, _activeKey = param.activeKey, activeKey = _activeKey === void 0 ? BandarDetector_constants/* BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY */.lA.BROKER_SUMMARY : _activeKey;
    var dispatch = (0,es/* useDispatch */.I0)();
    var summary = (0,es/* useSelector */.v9)(BandarDetector_slice/* selectors */.wl).summary;
    var isBrokerSummary = activeKey === BandarDetector_constants/* BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY */.lA.BROKER_SUMMARY;
    var handleTabChange = function(val) {
        dispatch(// @ts-ignore
        MainLayout_slice/* default.actions.setActiveWidget */.ZP.actions.setActiveWidget({
            key: SideWidget_constants/* SIDE_MENU_KEY.BANDAR_DETECTOR */.t2.BANDAR_DETECTOR,
            bandarDetectorActiveKey: val,
            isFromBandarDetector: true
        }));
    };
    (0,react.useEffect)(function() {
        dispatch(BandarDetector_slice/* effects.getBrokerList */.Sz.getBrokerList({
            page: 1,
            limit: 150,
            group: "GROUP_UNSPECIFIED"
        }));
        return function() {
            dispatch(BandarDetector_slice/* default.actions.resetPagination */.ZP.actions.resetPagination());
        };
    }, []);
    var tabItems = [
        {
            label: "Broker Summary",
            key: BandarDetector_constants/* BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY */.lA.BROKER_SUMMARY,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokerSummary, {})
        },
        {
            label: "Top Broker",
            key: BandarDetector_constants/* BANDAR_DETECTOR_MENU_KEY.TOP_BROKER */.lA.TOP_BROKER,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBroker, {})
        },
        {
            label: "Broker Activity",
            key: BandarDetector_constants/* BANDAR_DETECTOR_MENU_KEY.BROKER_ACTIVITY */.lA.BROKER_ACTIVITY,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrokerActivity, {})
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                overflow: isBrokerSummary ? "auto" : "hidden",
                height: "100vh",
                paddingBottom: "5px"
            },
            className: "bandar-detector-wrapper",
            children: isPro ? /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* StyledTabs */.Yt, {
                activeKey: activeKey,
                onChange: handleTabChange,
                children: tabItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* StyledTabs.TabPane */.Yt.TabPane, {
                        tab: item.label,
                        children: item.children
                    }, item.key);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BandarDetector_Header, {
                        children: [
                            "Bandar Detector ",
                            (summary === null || summary === void 0 ? void 0 : summary.symbol) && "( ".concat(summary.symbol, " )")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                        height: "90vh",
                        source: analytics/* SideWidgetAnalytics.BANDAR_DETECTOR */.Lb.BANDAR_DETECTOR
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var SideWidget_BandarDetector = (BandarDetector);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 57 modules
var table = __webpack_require__(79931);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: ",
        "px;\n  cursor: pointer;\n  /* border-bottom: 1px solid ",
        "; */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  font-variant: normal;\n  -webkit-font-feature-settings: normal;\n  font-feature-settings: normal;\n  word-break: keep-all;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ffffff;\n  text-align: center;\n  height: calc(100% - ",
        "px);\n  ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: auto;\n\n  > .add-alert {\n    color: #00ab6b;\n    margin: 10px 0;\n    width: 80%;\n    border: solid 1px #dadada;\n    padding: 5px 15px;\n    display: inline-block;\n    border-radius: 2px;\n  }\n\n  > .add-alert .icon-toolbar_plus {\n    position: relative;\n    top: 5px;\n    right: 6px;\n    font-size: 12px;\n    margin-left: 5px;\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  span.active {\n    background: #00ab6b;\n    height: 5px;\n    width: 5px;\n    display: inline-block;\n    overflow: hidden;\n    border-radius: 50%;\n    color: transparent;\n    margin-right: 8px;\n    vertical-align: middle;\n  }\n  span.pending {\n    background: #979134;\n    height: 5px;\n    width: 5px;\n    display: inline-block;\n    overflow: hidden;\n    border-radius: 50%;\n    color: transparent;\n    margin-right: 8px;\n    vertical-align: middle;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 400px;\n  border-radius: 20px;\n\n  .ant-modal-content {\n    border-radius: 3px;\n    padding: 15px;\n  }\n\n  .ant-modal-title {\n    font-size: 18px;\n    height: 40px;\n    text-align: center;\n  }\n\n  .ant-modal-footer,\n  .ant-modal-header {\n    border-radius: 10px;\n  }\n\n  .ant-modal-header {\n    font-family: var(--bold-font);\n    border-bottom-width: 0;\n  }\n\n  .ant-modal-footer {\n    margin-top: 20px;\n    border-top-width: 0;\n  }\n\n  .pa-condition {\n    width: calc(100% - 10px);\n    float: left;\n  }\n\n  .pa-condition select {\n    width: 100%;\n    height: 30px;\n    border: solid 1px #dadada;\n    padding: 0 5px;\n  }\n\n  .pa-value {\n    width: calc(96% - 10px);\n    margin-left: 20px;\n    float: left;\n  }\n\n  .pa-value input {\n    height: 30px;\n    border: solid 1px #dadada;\n    min-width: 100%;\n    padding: 0 5px;\n  }\n\n  .pa-value:after {\n    clear: both;\n    display: block;\n    content: '';\n  }\n\n  .pa-description {\n    margin-top: 10px;\n  }\n\n  .pa-description:before {\n    clear: both;\n    display: block;\n    content: '';\n  }\n\n  .pa-description textarea {\n    width: 100%;\n    border: solid 1px #dadada;\n    padding: 5px;\n  }\n\n  label {\n    font-family: var(--regular-font);\n  }\n\n  & .ant-modal-close-x {\n    color: rgba(0, 0, 0, 0.43);\n    font-size: 14px;\n\n    > span {\n      vertical-align: baseline;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 12px;\n\n  .ant-table-column-sorters-with-tooltip,\n  .ant-table-column-sorters {\n    display: flex;\n    justify-content: ",
        ";\n    padding: 0;\n\n    .ant-table-column-sorter {\n      display: flex;\n      margin-top: 0;\n    }\n  }\n\n  & .ant-table {\n    thead {\n      th {\n        background-color: transparent;\n        padding: 6px 5px;\n      }\n\n      th:first-of-type {\n        padding-left: 0;\n      }\n\n      th:last-of-type {\n        padding-right: 0;\n      }\n    }\n\n    tbody {\n      td {\n        overflow-wrap: normal;\n        padding: 6px 5px;\n      }\n\n      td:first-of-type {\n        padding-left: 0;\n      }\n\n      td:last-of-type {\n        padding-right: 0;\n      }\n    }\n\n    .ant-table-thead > tr > th,\n    .ant-table-tbody > tr > td {\n      border-bottom: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: #f7f7f7;\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 1.5;\n  padding: 7px 15px 8px;\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text, Modal = ui/* Common.Modal */.Gn.Modal, Button = ui/* Common.Button */.Gn.Button;
var cellType = {
    up: ui/* color.primary */.$_.primary,
    down: ui/* color.sunsetOrange */.$_.sunsetOrange,
    neutral: ui/* color.suvaGrey */.$_.suvaGrey,
    default: ui/* color.highempahis */.$_.highempahis
};
var headerHeight = 40;
var HeaderContainer = (0,styled_components_browser_esm["default"])(Flex).attrs({
    align: "center",
    justify: "space-between",
    px: "12px"
}).withConfig({
    componentId: "sc-4de97cf2-0"
})(_templateObject(), ui/* color.aliceBlue */.$_.aliceBlue, headerHeight, ui/* color.gainsboro */.$_.gainsboro);
var Td = (0,styled_components_browser_esm["default"])(styled_Text).attrs(function(props) {
    return {
        height: "1.15",
        padding: "0",
        size: "13px",
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-4de97cf2-1"
})(_templateObject2(), function(param) {
    var type = param.type;
    return (0,styled_components_browser_esm.css)(_templateObject1(), cellType[type]);
});
var Th = (0,styled_components_browser_esm["default"])(Td).attrs({
    family: "bold",
    size: "13px"
}).withConfig({
    componentId: "sc-4de97cf2-2"
})(_templateObject3());
var EmptyPriceAlert = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4de97cf2-3"
})(_templateObject4(), headerHeight, function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight && "max-height: ".concat(maxHeight);
});
var PriceAlertTd = (0,styled_components_browser_esm["default"])(Td).withConfig({
    componentId: "sc-4de97cf2-4"
})(_templateObject5());
var ModalPriceAlert = (0,styled_components_browser_esm["default"])(Modal).attrs({
    width: "400px"
}).withConfig({
    componentId: "sc-4de97cf2-5"
})(_templateObject6());
var TableLog = (0,styled_components_browser_esm["default"])(table/* default */.Z).withConfig({
    componentId: "sc-4de97cf2-6"
})(_templateObject7(), function(param) {
    var alignSorter = param.alignSorter;
    return alignSorter === "start" ? "flex-start" : "flex-end";
}, ui/* color.aliceBlue */.$_.aliceBlue);
var LabelForm = styled_components_browser_esm["default"].label.withConfig({
    componentId: "sc-4de97cf2-7"
})(_templateObject8());
var CustomButton = (0,styled_components_browser_esm["default"])(Button).withConfig({
    componentId: "sc-4de97cf2-8"
})(_templateObject10(), function(props) {
    return props.$cancel && (0,styled_components_browser_esm.css)(_templateObject9());
});


;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/Header.tsx








var Header_Text = ui/* Common.Text */.Gn.Text;
var Header_Header = function(_param) /*#__PURE__*/ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(HeaderContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
            size: "1rem",
            height: "40px",
            family: "bold",
            children: children
        })
    }));
};
Header_Header.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var PriceAlert_Header = (Header_Header);

// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/slice.ts
var PriceAlert_slice = __webpack_require__(16835);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/styled.ts
var SideWidget_styled = __webpack_require__(73164);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/PriceAlertContent.tsx
/* eslint-disable react/prop-types */ 












var PriceAlertContent_Button = ui/* Common.Button */.Gn.Button, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, PriceAlertContent_Text = ui/* Common.Text */.Gn.Text;
var mth = {
    gt: ">",
    lt: "<",
    gte: ">=",
    lte: "<=",
    eq: "="
};
var map = {
    active: [
        2
    ],
    pending: [
        0,
        1,
        3
    ]
};
function PriceAlertContent(param) {
    var _handleAddPriceAlert = param.handleAddPriceAlert, handleAddPriceAlert = _handleAddPriceAlert === void 0 ? function() {} : _handleAddPriceAlert, _handleShowModalCancel = param.handleShowModalCancel, handleShowModalCancel = _handleShowModalCancel === void 0 ? function() {} : _handleShowModalCancel, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? 100 : _maxHeight;
    var dispatch = (0,es/* useDispatch */.I0)();
    var state = (0,es/* useSelector */.v9)(PriceAlert_slice/* priceAlertSelector */.TB);
    var visibilityRef = (0,react.useRef)(null);
    var data = state.data, page = state.page, reachEnd = state.reachEnd;
    var handleLoadMore = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isVisible) {
            var options;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!isVisible || reachEnd)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        options = {
                            page: page + 1,
                            limit: 30
                        };
                        dispatch(PriceAlert_slice/* effects.getPriceAlert */.Sz.getPriceAlert(options));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(isVisible) {
            return _ref.apply(this, arguments);
        };
    }(), [
        page,
        reachEnd
    ]);
    (0,react.useEffect)(function() {
        // @ts-ignore
        dispatch(PriceAlert_slice/* effects.getPriceAlert */.Sz.getPriceAlert());
    }, [
        dispatch
    ]);
    var getCommandValue = function(operator, value) {
        var cmd = mth[operator] || operator;
        var parsedValue = (0,general/* parseCountAbbrv2 */.St)(value, 0);
        // @ts-ignore
        var val = parsedValue.length > 7 ? parsedValue.slice(0, 7) : parsedValue;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(tooltip/* default */.Z, {
            title: parsedValue,
            children: [
                cmd,
                " ",
                val
            ]
        });
    };
    // price alert data is empty
    if (data.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyPriceAlert, {
            maxHeight: "".concat(maxHeight, "px"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "No alert has been set"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlertContent_Button, {
                    className: "add-alert",
                    onClick: handleAddPriceAlert,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                                    className: "icon-toolbar_plus"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: "Create a new alert"
                            })
                        ]
                    })
                })
            ]
        });
    }
    var dataSource = data.map(function(dataPriceAlert) {
        var newData = (0,_object_spread/* default */.Z)({}, dataPriceAlert);
        var symbolShow = newData.command.symbol_2 ? newData.command.symbol_2.toUpperCase() : newData.command.stock.toUpperCase();
        newData.symbol = /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
            children: symbolShow
        });
        newData.key = dataPriceAlert.alert_id;
        return newData;
    });
    var columns = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                children: "Symbol"
            }),
            key: "symbol",
            sorter: function(a, b) {
                return a.command.stock.localeCompare(b.command.stock);
            },
            render: function(param, record, i) {
                var status = param.status, symbol = param.symbol;
                var className = "";
                Object.keys(map).map(function(index) {
                    if (map[index].indexOf(parseInt(status, 10)) > -1) {
                        className = index;
                    }
                    return index;
                });
                var isLast = i + 1 === dataSource.length;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlertTd, {
                    onClick: function(e) {
                        return handleAddPriceAlert(e, record);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: className,
                                    style: {
                                        wordBreak: "keep-all"
                                    },
                                    children: className
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                style: {
                                    wordBreak: "keep-all"
                                },
                                children: symbol
                            }),
                            isLast && /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                                containment: visibilityRef.current,
                                onChange: handleLoadMore,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "\xa0"
                                })
                            })
                        ]
                    })
                });
            }
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                children: "Condition"
            }),
            dataIndex: "command",
            key: "command",
            render: function(param, record) {
                var operator = param.operator, value = param.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    style: {
                        wordBreak: "keep-all"
                    },
                    onClick: function(e) {
                        return handleAddPriceAlert(e, record);
                    },
                    children: getCommandValue(operator, value)
                });
            }
        },
        {
            title: "",
            key: "action1",
            width: "40px",
            render: function(record) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                title: function() {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(PriceAlertContent_Text, {
                                        color: ui/* color.light */.$_.light,
                                        className: "price-alert-note-text-".concat(record === null || record === void 0 ? void 0 : (ref = record.command) === null || ref === void 0 ? void 0 : ref.stock),
                                        children: record.name
                                    });
                                },
                                className: "price-alert-note",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                                    className: "icon-toolbar_note",
                                    size: "12px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* ButtonTransparent */.hb, {
                                onClick: function(event) {
                                    return handleShowModalCancel(event, record.alert_id);
                                },
                                style: {
                                    marginLeft: "5px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                                    className: "icon-toolbar_delete",
                                    size: "12px"
                                })
                            })
                        ]
                    })
                });
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "calc(100% - 41px)",
            paddingBottom: "10px"
        },
        ref: visibilityRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableLog, {
            alignSorter: "start",
            style: {
                height: "100%",
                overflowY: "auto"
            },
            dataSource: dataSource,
            columns: columns,
            pagination: false,
            sortDirections: [
                "ascend",
                "descend",
                "ascend"
            ]
        })
    });
}
/* harmony default export */ var PriceAlert_PriceAlertContent = (PriceAlertContent);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./src/utils/date.ts
var utils_date = __webpack_require__(46870);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/AlertLogContent.tsx
/* eslint-disable react/destructuring-assignment */ 









var Table = ui/* Widget.Table */.$L.Table;
var desc = {
    0: "init",
    1: "queue",
    2: "loaded",
    3: "reload",
    4: "complete",
    5: "cancel",
    6: "error"
};
var AlertLogContent_mth = {
    gt: ">",
    lt: "<",
    gte: ">=",
    lte: "<=",
    eq: "="
};
function AlertLogContent(param) {
    var handleAddPriceAlert = param.handleAddPriceAlert, maxHeight = param.maxHeight;
    var dispatch = (0,es/* useDispatch */.I0)();
    var state = (0,es/* useSelector */.v9)(PriceAlert_slice/* alertLogSelector */._b);
    var data = state.data;
    (0,react.useEffect)(function() {
        dispatch(PriceAlert_slice/* effects.getAlertLog */.Sz.getAlertLog());
    }, [
        dispatch
    ]);
    var columns = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                children: "Symbol"
            }),
            dataIndex: "symbol",
            key: "symbol"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                children: "Condition"
            }),
            dataIndex: "command",
            key: "command",
            render: function(v) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                    align: "right",
                    children: "".concat(AlertLogContent_mth[v.operator] || v.operator, " ").concat((0,general/* parseCountAbbrv2 */.St)(v.value, 0))
                });
            }
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Th, {
                align: "right",
                style: {
                    paddingRight: 0
                },
                children: "Triggered On"
            }),
            dataIndex: "updated",
            key: "updated",
            sorter: function(a, b) {
                var dateA = new Date(a.updated_at).getTime();
                var dateB = new Date(b.updated_at).getTime();
                return dateA - dateB;
            }
        }, 
    ];
    // price alert data is empty
    if (data.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyPriceAlert, {
            maxHeight: maxHeight,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "empty-price-alert",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "No log alert found"
                })
            })
        });
    }
    var dataSource = data.map(function(dataAlertLog) {
        if (dataAlertLog.command.stock) {
            var newData = (0,_object_spread/* default */.Z)({}, dataAlertLog);
            var symbolShow = newData.command.symbol_2 ? newData.command.symbol_2.toUpperCase() : newData.command.stock.toUpperCase();
            newData.key = newData.alert_id;
            newData.symbol = /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                children: symbolShow
            });
            newData.status = /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                align: "right",
                children: desc[parseInt(dataAlertLog.status, 10)]
            });
            newData.updated_at = newData.updated;
            var date = (0,format/* default */.Z)((0,utils_date/* convertToDate */.k)(newData.updated), "d MMM yyyy HH:mm");
            newData.updated = /*#__PURE__*/ (0,jsx_runtime.jsx)(Td, {
                align: "right",
                children: date
            });
            return newData;
        }
        return dataAlertLog;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: "100%",
            paddingBottom: "30px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableLog, {
            style: {
                height: "calc(100% - 30px)",
                overflowY: "auto"
            },
            dataSource: dataSource,
            columns: columns,
            pagination: false,
            onRow: function(record) {
                return {
                    onClick: function(e) {
                        return handleAddPriceAlert(e, record, true);
                    }
                };
            },
            sortDirections: [
                "ascend",
                "descend",
                "ascend"
            ]
        })
    });
}
AlertLogContent.defaultProps = {
    handleAddPriceAlert: function() {}
};
/* harmony default export */ var PriceAlert_AlertLogContent = (AlertLogContent);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/ModalCancelPriceAlert.tsx
/* eslint-disable react/no-unescaped-entities */ 




var ModalCancelPriceAlert_Button = ui/* Common.Button */.Gn.Button, ModalCancelPriceAlert_Text = ui/* Common.Text */.Gn.Text;
function ModalCancelPriceAlert(param) {
    var visible = param.visible, loading = param.loading, onSubmit = param.onSubmit, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalPriceAlert, {
        title: "Cancel Price Alert",
        centered: true,
        visible: visible,
        onCancel: onCancel,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: 10,
                        offset: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* ButtonTransparent */.hb, {
                            onClick: onCancel,
                            style: {
                                float: "right",
                                marginTop: "5px",
                                fontWeight: 500
                            },
                            children: "NO, DON'T CANCEL IT"
                        }, "back")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: 10,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancelPriceAlert_Button, {
                            type: "primary",
                            loading: loading,
                            onClick: onSubmit,
                            style: {
                                float: "right"
                            },
                            children: "YES, CANCEL IT"
                        }, "submit")
                    })
                ]
            }, Date.now()), 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCancelPriceAlert_Text, {
            size: "12px",
            height: "1.5",
            children: "Are you sure want to cancel this alert ?"
        })
    });
}
ModalCancelPriceAlert.defaultProps = {
    visible: false,
    loading: false,
    onSubmit: function() {},
    onCancel: function() {}
};
/* harmony default export */ var PriceAlert_ModalCancelPriceAlert = (ModalCancelPriceAlert);

// EXTERNAL MODULE: ./src/features/onboarding/OnBoardingLayout/styled.js
var OnBoardingLayout_styled = __webpack_require__(43774);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var entities_company = __webpack_require__(74645);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/Search/options.tsx


var options_Flex = ui/* Common.Flex */.Gn.Flex, Tag = ui/* Common.Tag.Tag */.Gn.Tag.Tag, options_Text = ui/* Common.Text */.Gn.Text;
var renderStockSuggestions = function() {
    var stocks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return stocks.map(function(stock) {
        return {
            value: stock.name,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(options_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                        size: "xs",
                        type: "grey",
                        children: stock.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(options_Text, {
                        pl: "10px",
                        size: "13px",
                        children: stock.desc
                    })
                ]
            })
        };
    });
};
/* harmony default export */ var options = ({});

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/Search/index.tsx





// Store company


var Input = ui/* Common.Input */.Gn.Input, Search_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Autocomplete = ui/* Common.Autocomplete */.Gn.Autocomplete;
function Search(param) {
    var searchValue = param.searchValue, handleSelectedValueStock = param.handleSelectedValueStock, isClickAlertLog = param.isClickAlertLog, isEdit = param.isEdit;
    var ref = (0,react.useState)(0), timeInterval = ref[0], setTimeInterval = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(entities_company/* selectors */.wl), _search = ref2.search, dataSearch = _search.data;
    (0,react.useEffect)(function() {
        if (searchValue) {
            setValue(searchValue);
        }
        return function() {
            setValue("");
        };
    }, [
        searchValue
    ]);
    // handle actions
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleSearchCompany = function(val) {
        if (val.length > 1) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(setTimeout(function() {
                // @ts-ignore
                dispatch(entities_company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
            }, 1500));
        }
    };
    var handleSelectCompany = function(val) {
        handleSelectedValueStock(val);
        // dispatch search company with stock name
        dispatch(entities_company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
    };
    var handleChange = function(val) {
        setValue(val);
    };
    var options = renderStockSuggestions(dataSearch);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* Relative */.Ig, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete, {
            options: options,
            width: "100%",
            onSelect: handleSelectCompany,
            onSearch: handleSearchCompany,
            onChange: handleChange,
            mb: "8px",
            getPopupContainer: function(trigger) {
                return trigger.parentElement;
            },
            value: value,
            disabled: isClickAlertLog || isEdit,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                placeholder: "Type stocks here ..",
                height: "36px",
                width: "100%"
            })
        })
    });
}
Search.defaultProps = {
    searchValue: "",
    handleSelectedValueStock: function() {},
    isClickAlertLog: false
};
/* harmony default export */ var PriceAlert_Search = (Search);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/ModalAddPriceAlert.tsx






var ModalAddPriceAlert_Input = ui/* Common.Input */.Gn.Input, Select = ui/* Common.Select */.Gn.Select, ModalAddPriceAlert_Flex = ui/* Common.Flex */.Gn.Flex, ModalAddPriceAlert_Text = ui/* Common.Text */.Gn.Text;
var Option = Select.Option;
var ITEM_CLOSE = "close";
function ModalAddPriceAlert(param) {
    var visible = param.visible, loading = param.loading, onSubmit = param.onSubmit, onCancel = param.onCancel, formData = param.formData, isEdit = param.isEdit, modalKey = param.modalKey, isClickAlertLog = param.isClickAlertLog;
    var ref = (0,react.useState)(""), stock = ref[0], setStock = ref[1];
    var ref1 = (0,react.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(""), operator = ref2[0], setOperator = ref2[1];
    var ref3 = (0,react.useState)(ITEM_CLOSE), item = ref3[0]; // dr web legacy emang ini di hardcode
    var ref4 = (0,react.useState)(""), name = ref4[0], setName = ref4[1];
    var handleSelectedValueStock = function(selectedStock) {
        setStock(selectedStock);
    };
    var handleSelectedOperator = function(selectedOperator) {
        setOperator(selectedOperator);
    };
    var handleInputedValue = function(inputedValue) {
        setValue(inputedValue.target.value);
    };
    var handleInputedName = function(inputedName) {
        setName(inputedName.target.value);
    };
    var valueCharacterCheck = function(e) {
        var isNumber = /^\d|\.$/.test(e.key);
        var notIndoButIHSG = stock.toUpperCase() === "IHSG";
        var preventCondition = notIndoButIHSG ? !(isNumber || e.which === 46) : !isNumber;
        if (preventCondition) e.preventDefault();
    };
    var handleOnSubmit = function(e) {
        e.preventDefault();
        var command = JSON.stringify({
            stock: stock,
            value: value.trim(),
            operator: operator,
            item: item
        });
        onSubmit(name.trim(), command, isEdit);
    };
    (0,react.useEffect)(function() {
        setStock(formData.stock);
        setOperator(formData.operator);
        setValue(formData.value);
        setName(formData.name);
    }, [
        formData
    ]);
    var handleOnCancel = function() {
        setStock("");
        setOperator("");
        setValue("");
        setName("");
        onCancel();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalPriceAlert, {
        title: "".concat(isEdit || isClickAlertLog ? "Edit" : "Create", " Price Alert"),
        centered: true,
        visible: visible,
        onCancel: handleOnCancel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelForm, {
                        htmlFor: "search",
                        children: "Stockname"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_Search, {
                        // @ts-ignore
                        id: "search",
                        name: "search",
                        searchValue: stock,
                        handleSelectedValueStock: handleSelectedValueStock,
                        isEdit: isEdit,
                        isClickAlertLog: isClickAlertLog
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pa-condition",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelForm, {
                                            htmlFor: "operator",
                                            children: "Condition"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                                        id: "operator",
                                        onChange: handleSelectedOperator,
                                        value: operator,
                                        disabled: !!isClickAlertLog,
                                        defaultValue: "lte",
                                        style: {
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                                value: "lte",
                                                children: "Lesser than equal"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                                value: "gte",
                                                children: "Greater than equal"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                                value: "lt",
                                                children: "Lesser than"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                                value: "gt",
                                                children: "Greater than"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                                                value: "eq",
                                                children: "Equal"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            span: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pa-value",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelForm, {
                                            htmlFor: "value",
                                            children: "Value"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddPriceAlert_Input, {
                                        value: value,
                                        step: "0.01",
                                        onKeyPress: valueCharacterCheck,
                                        onChange: handleInputedValue,
                                        disabled: isClickAlertLog
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "pa-description",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelForm, {
                                htmlFor: "description",
                                children: "Description"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddPriceAlert_Input.TextArea, {
                            id: "description",
                            style: {
                                width: "100%"
                            },
                            rows: "3",
                            placeholder: "Add your notes...",
                            onChange: handleInputedName,
                            value: name,
                            disabled: isClickAlertLog
                        })
                    ]
                })
            }),
            !isClickAlertLog && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalAddPriceAlert_Flex, {
                justify: "flex-end",
                mt: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                        margin: "0 10px",
                        $cancel: true,
                        round: true,
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddPriceAlert_Text, {
                            size: "12px",
                            height: "1.5",
                            color: "rgba(0, 0, 0, 0.65)",
                            children: "CANCEL"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                        type: "primary",
                        padding: "7px 15px 8px",
                        round: true,
                        loading: loading,
                        onClick: function(e) {
                            return handleOnSubmit(e);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalAddPriceAlert_Text, {
                            size: "12px",
                            height: "1.5",
                            color: ui/* color.light */.$_.light,
                            align: "center",
                            children: isEdit ? "SAVE" : "CREATE"
                        })
                    })
                ]
            })
        ]
    }, modalKey);
}
ModalAddPriceAlert.defaultProps = {
    visible: false,
    loading: false,
    onSubmit: function() {},
    onCancel: function() {},
    formData: {
        stock: "",
        value: "",
        operator: "",
        name: ""
    },
    isEdit: false,
    modalKey: 0,
    isClickAlertLog: false
};
/* harmony default export */ var PriceAlert_ModalAddPriceAlert = (ModalAddPriceAlert);

// EXTERNAL MODULE: ./node_modules/re-resizable/lib/index.js + 1 modules
var lib = __webpack_require__(46312);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Resizeable/styled.js

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 10px;\n  background-image: url(",
        ");\n  background-color: ",
        ";\n  background-repeat: no-repeat;\n  background-position: 50%;\n  border-bottom: 1px solid ",
        ";\n  margin-top: -5px; /* Put indicator inside the box */\n  cursor: s-resize;\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 0px;\n  z-index: 99;\n\n  > div {\n    > div {\n      z-index: 99;\n    }\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var bgBottom = app/* assetPrefix */.Vc + "/icon/horizontal.png";
var ResizeIndicator = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c90da531-0"
})(styled_templateObject(), bgBottom, ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro);
var Box = (0,styled_components_browser_esm["default"])(lib/* Resizable */.e).attrs(function(props) {
    return {
        handleComponent: props.handleComponent || {
            bottom: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResizeIndicator, {})
        },
        enable: {
            top: false,
            right: false,
            bottom: true,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false
        }
    };
}).withConfig({
    componentId: "sc-c90da531-1"
})(styled_templateObject1());


;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/PriceAlert/index.tsx
/* eslint-disable no-undef */ /* eslint-disable react-hooks/exhaustive-deps */ 



















var PriceAlert_Flex = ui/* Common.Flex */.Gn.Flex, PriceAlert_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function PriceAlert(param) {
    var isPro = param.isPro;
    var ref = (0,react.useState)(false), isModalCancelPriceAlert = ref[0], setModalCancelPriceAlert = ref[1];
    var ref1 = (0,react.useState)(false), isModalAddPriceAlert = ref1[0], setModalAddPriceAlert = ref1[1];
    var ref2 = (0,react.useState)(false), isClickAlertLog = ref2[0], setClickAlertLog = ref2[1];
    var ref3 = (0,react.useState)({
        stock: "",
        value: "",
        operator: "",
        name: ""
    }), formData = ref3[0], setFormData = ref3[1];
    var ref4 = (0,react.useState)(0), alertId = ref4[0], setAlertId = ref4[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var addPriceAlert = (0,es/* useSelector */.v9)(PriceAlert_slice/* addPriceAlertSelector */.az);
    var editPriceAlert = (0,es/* useSelector */.v9)(PriceAlert_slice/* editPriceAlertSelector */.J$);
    var cancelPriceAlert = (0,es/* useSelector */.v9)(PriceAlert_slice/* cancelPriceAlertSelector */.NS);
    var isLoadingAddPriceAlert = addPriceAlert.isLoading;
    var isLoadingEditPriceAlert = editPriceAlert.isLoading;
    var isLoadingCancelPriceAlert = cancelPriceAlert.isLoading;
    var ref5 = (0,react.useState)(0), resizeableHeight = ref5[0], setResizeableHeight = ref5[1];
    var ref6 = (0,react.useState)(0), windowHeight = ref6[0], setWindowHeight = ref6[1];
    var handleShowModalCancel = function(e, id) {
        e.preventDefault();
        setAlertId(id);
        setModalCancelPriceAlert(!isModalCancelPriceAlert);
    };
    var handleSubmitCancelPriceAlert = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var del, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(PriceAlert_slice/* effects.cancelPriceAlert */.Sz.cancelPriceAlert(alertId));
                    case 2:
                        del = _ctx.sent;
                        data = del.payload.data;
                        if (data) {
                            (0,AlertErrorMessage/* default */.Z)("Item alert canceled", successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitCancelPriceAlert() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnCancelModalCancel = function() {
        setModalCancelPriceAlert(false);
        // setAlertId default
        setAlertId(0);
        setFormData({
            stock: "",
            value: "",
            operator: "",
            name: ""
        });
    };
    var handleOnCancelModalAdd = function() {
        setModalAddPriceAlert(false);
        // setAlertId default
        setAlertId(0);
        // set isClickAlertLog to false
        setClickAlertLog(false);
        setFormData({
            stock: "",
            value: "",
            operator: "",
            name: ""
        });
    };
    var handleShowModalAdd = function(e, record, isAlertLog) {
        e.preventDefault();
        if (isAlertLog) {
            var command = record.command, name = record.name;
            setClickAlertLog(true);
            setFormData({
                stock: command.stock,
                value: command.value,
                operator: command.operator,
                name: name
            });
        } else if (record) {
            var alertid = record.alert_id, command1 = record.command, name1 = record.name;
            setAlertId(alertid);
            setFormData({
                stock: command1.stock,
                value: command1.value,
                operator: command1.operator,
                name: name1
            });
        } else {
            setFormData({
                stock: "",
                value: "",
                operator: "",
                name: ""
            });
        }
        setModalAddPriceAlert(!isModalAddPriceAlert);
    };
    var handleSubmitAddPriceAlert = function(name, command, isEdit) {
        var data = {
            name: name,
            command: command
        };
        var action = isEdit ? PriceAlert_slice/* effects.editPriceAlert */.Sz.editPriceAlert : PriceAlert_slice/* effects.addPriceAlert */.Sz.addPriceAlert;
        if (isEdit) {
            data.alertId = alertId;
        }
        // @ts-ignore
        dispatch(action(data));
    };
    (0,react.useEffect)(function() {
        var isCancel = cancelPriceAlert.isCancel;
        if (isCancel) {
            // close modal cancel
            setModalCancelPriceAlert(false);
            // dispatch get all price alert
            // @ts-ignore
            // dispatch(effects.getPriceAlert());
            // dispatch get all alert log
            dispatch(PriceAlert_slice/* effects.getAlertLog */.Sz.getAlertLog());
            // setAlertId default
            setAlertId(0);
        }
    }, [
        cancelPriceAlert.isCancel
    ]);
    (0,react.useEffect)(function() {
        var isSubmit = addPriceAlert.isSubmit;
        if (isSubmit) {
            // close modal add
            setModalAddPriceAlert(false);
            // dispatch get all price alert
            // @ts-ignore
            dispatch(PriceAlert_slice/* effects.getPriceAlert */.Sz.getPriceAlert());
            // dispatch get all alert log
            dispatch(PriceAlert_slice/* effects.getAlertLog */.Sz.getAlertLog());
            // setAlertId default
            setAlertId(0);
            // clear form
            setFormData({
                stock: "",
                value: "",
                operator: "",
                name: ""
            });
        }
    }, [
        addPriceAlert.isSubmit
    ]);
    (0,react.useEffect)(function() {
        var isSubmit = editPriceAlert.isSubmit;
        if (isSubmit) {
            // close modal edit
            setModalAddPriceAlert(false);
            // dispatch get all price alert
            // @ts-ignore
            dispatch(PriceAlert_slice/* effects.getPriceAlert */.Sz.getPriceAlert());
            // dispatch get all alert log
            dispatch(PriceAlert_slice/* effects.getAlertLog */.Sz.getAlertLog());
            // setAlertId default
            setAlertId(0);
            // clear form
            setFormData({
                stock: "",
                value: "",
                operator: "",
                name: ""
            });
        }
    }, [
        editPriceAlert.isSubmit
    ]);
    (0,react.useEffect)(function() {
        var resizeable = document.getElementsByClassName("sw-price-alert");
        if (resizeable.length) {
            setResizeableHeight(resizeable[0].clientHeight);
        }
        setWindowHeight(window.innerHeight);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                className: "sw-price-alert",
                defaultSize: {
                    height: "50%",
                    width: "100%"
                },
                maxHeight: windowHeight - 40,
                minHeight: 50,
                onResizeStop: function(e, direction, ref, d) {
                    var h = resizeableHeight + d.height;
                    setResizeableHeight(h);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        justify: "end",
                        style: {
                            backgroundColor: ui/* color.aliceBlue */.$_.aliceBlue,
                            borderBottom: "solid 1px ".concat(ui/* color.gainsboro */.$_.gainsboro)
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 10,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_Header, {
                                    children: "Price Alert"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 2,
                                offset: 12,
                                children: isPro && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* ButtonTransparent */.hb, {
                                    height: "40px",
                                    onClick: handleShowModalAdd,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_Iconmoon, {
                                        className: "icon-compose_plus",
                                        style: {
                                            color: "#333"
                                        }
                                    })
                                })
                            })
                        ]
                    }),
                    isPro ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_PriceAlertContent, {
                        handleAddPriceAlert: handleShowModalAdd,
                        handleShowModalCancel: handleShowModalCancel,
                        maxHeight: resizeableHeight - 50
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                        height: "45vh",
                        source: analytics/* SideWidgetAnalytics.PRICE_ALERT */.Lb.PRICE_ALERT
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    height: "calc(100vh - ".concat(resizeableHeight, "px)"),
                    position: "relative",
                    zIndex: 99
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_Header, {
                        style: {
                            borderBottom: "solid 1px ".concat(ui/* color.gainsboro */.$_.gainsboro)
                        },
                        children: "Alert Log"
                    }),
                    isPro ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_AlertLogContent, {
                        handleAddPriceAlert: handleShowModalAdd,
                        maxHeight: "calc(100vh - ".concat(resizeableHeight, "px - ").concat(headerHeight, "px)")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                        height: "45vh",
                        source: analytics/* SideWidgetAnalytics.PRICE_ALERT */.Lb.PRICE_ALERT
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_ModalCancelPriceAlert, {
                loading: isLoadingCancelPriceAlert,
                visible: isModalCancelPriceAlert,
                onSubmit: handleSubmitCancelPriceAlert,
                onCancel: handleOnCancelModalCancel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceAlert_ModalAddPriceAlert, {
                loading: alertId === 0 ? isLoadingAddPriceAlert : isLoadingEditPriceAlert,
                visible: isModalAddPriceAlert,
                onSubmit: handleSubmitAddPriceAlert,
                onCancel: handleOnCancelModalAdd,
                formData: formData,
                isEdit: alertId !== 0,
                modalKey: alertId || "add",
                isClickAlertLog: isClickAlertLog
            })
        ]
    });
}
/* harmony default export */ var SideWidget_PriceAlert = (PriceAlert);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/RunningTrade/index.tsx + 26 modules
var RunningTrade = __webpack_require__(4618);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/styled.ts

function Valuation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 40px;\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n  padding-left: 10px;\n"
    ]);
    Valuation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Valuation_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    Valuation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 80%;\n  .ant-select-selector {\n    border-bottom: none !important;\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: none;\n  border-left: none;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 2px;\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    0% {\n      padding-left : 30%;\n    }\n    100% {\n      padding-left : 20px;\n    }\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: 0.5s ",
        " linear forwards;\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .stock-search-dropdown {\n    top: 30px !important;\n  }\n"
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: var(--regular-font);\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-header {\n    border-bottom-color: transparent;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    height: auto;\n    padding: 10px 24px 0 !important;\n  }\n\n  .ant-modal-close-x {\n    margin: 10px;\n\n    svg {\n      width: 14px;\n      height: 14px;\n    }\n  }\n\n  .ant-modal-content {\n    border-radius: 3px !important;\n  }\n\n  .ant-modal-body {\n    padding: 16px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &::placeholder {\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var styled_Flex = ui/* Common.Flex */.Gn.Flex, Valuation_styled_Text = ui/* Common.Text */.Gn.Text, styled_Input = ui/* Common.Input */.Gn.Input, styled_Autocomplete = ui/* Common.Autocomplete */.Gn.Autocomplete;
var styled_Select = ui/* Widget.Select */.$L.Select, WidgetTable = ui/* Widget.Table */.$L.Table, ModalWidget = ui/* Widget.Modal */.$L.Modal;
var styled_cellType = {
    up: ui/* color.primary */.$_.primary,
    down: ui/* color.sunsetOrange */.$_.sunsetOrange,
    neutral: ui/* color.suvaGrey */.$_.suvaGrey,
    default: ui/* color.highempahis */.$_.highempahis
};
var styled_HeaderContainer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    align: "center",
    justify: "space-between"
}).withConfig({
    componentId: "sc-e2915f7b-0"
})(Valuation_styled_templateObject(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro);
var styled_Td = (0,styled_components_browser_esm["default"])(Valuation_styled_Text).attrs(function(props) {
    return {
        height: "30px",
        padding: "0 10px",
        size: "12.5px",
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-e2915f7b-1"
})(styled_templateObject2(), function(param) {
    var type = param.type;
    return (0,styled_components_browser_esm.css)(Valuation_styled_templateObject1(), styled_cellType[type]);
});
var styled_Th = (0,styled_components_browser_esm["default"])(styled_Td).attrs({
    weight: "bold",
    size: "11px"
}).withConfig({
    componentId: "sc-e2915f7b-2"
})(styled_templateObject3());
var ListContainer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-e2915f7b-3"
})(styled_templateObject4(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.aliceBlue */.$_.aliceBlue);
var SelectGroup = (0,styled_components_browser_esm["default"])(styled_Select).withConfig({
    componentId: "sc-e2915f7b-4"
})(styled_templateObject5());
var InputGroup = (0,styled_components_browser_esm["default"])(styled_Input).withConfig({
    componentId: "sc-e2915f7b-5"
})(styled_templateObject6());
var styled_Tag = (0,styled_components_browser_esm["default"])(Valuation_styled_Text).attrs({
    color: ui/* color.light */.$_.light,
    weight: "bold",
    px: "3px"
}).withConfig({
    componentId: "sc-e2915f7b-6"
})(styled_templateObject7(), ui/* color.dimgray */.$_.dimgray);
var containerAnimation = (0,styled_components_browser_esm.keyframes)(styled_templateObject8());
var List = (0,styled_components_browser_esm["default"])(Valuation_styled_Text).attrs({
    height: "30px"
}).withConfig({
    componentId: "sc-e2915f7b-7"
})(styled_templateObject9(), containerAnimation, ui/* color.aliceBlue */.$_.aliceBlue);
var AutoCompleteStock = (0,styled_components_browser_esm["default"])(styled_Autocomplete).withConfig({
    componentId: "sc-e2915f7b-8"
})(styled_templateObject10());
var styled_Table = (0,styled_components_browser_esm["default"])(WidgetTable).withConfig({
    componentId: "sc-e2915f7b-9"
})(_templateObject11());
var styled_Modal = (0,styled_components_browser_esm["default"])(ModalWidget).withConfig({
    componentId: "sc-e2915f7b-10"
})(_templateObject12());
var InputModal = (0,styled_components_browser_esm["default"])(styled_Input).attrs({
    height: "32px",
    width: "100%"
}).withConfig({
    componentId: "sc-e2915f7b-11"
})(_templateObject13());


// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/Header.tsx





var Valuation_Header_Text = ui/* Common.Text */.Gn.Text;
var Valuation_Header_Header = function(param) {
    var title = param.title, children = param.children, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_HeaderContainer, {
        children: [
            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Button */.Z.Button, {
                active: true,
                size: "small",
                style: {
                    width: "125px"
                }
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Valuation_Header_Text, {
                size: "16px",
                family: "bold",
                ellipsis: true,
                children: title
            }),
            children
        ]
    });
};
/* harmony default export */ var Valuation_Header = (Valuation_Header_Header);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/Common/ListCloseIcon.tsx


var IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, ListCloseIcon_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var ListCloseIcon = function(param) {
    var handleOnClickDelete = param.handleOnClickDelete;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
        padding: "0 5px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCloseIcon_Iconmoon, {
            className: "icon-widget_close",
            color: ui/* color.sunsetOrange */.$_.sunsetOrange,
            hoverColor: ui/* color.sunsetOrange */.$_.sunsetOrange,
            size: "14px",
            weight: "bold",
            onClick: handleOnClickDelete
        })
    });
};
/* harmony default export */ var Common_ListCloseIcon = (ListCloseIcon);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ModalDelete.tsx
/* eslint-disable react/jsx-wrap-multilines */ 


var ModalDelete_Text = ui/* Common.Text */.Gn.Text, ModalDelete_Flex = ui/* Common.Flex */.Gn.Flex;
var ModalDelete_Button = ui/* Widget.Button */.$L.Button;
var ValuationModalDelete = function(param) {
    var valuationId = param.valuationId, valuationName = param.valuationName, isVisible = param.isVisible, onCancel = param.onCancel, onSubmit = param.onSubmit, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Modal, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_Text, {
            size: "18px",
            align: "center",
            height: "40px",
            family: "bold",
            children: "Delete Valuation"
        }),
        visible: isVisible,
        onCancel: onCancel,
        centered: true,
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDelete_Text, {
                children: [
                    'Are you sure you want to delete "',
                    valuationName,
                    '" valuation?'
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDelete_Flex, {
                justify: "flex-end",
                mt: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_Button, {
                        height: "40px",
                        borderLess: true,
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_Text, {
                            children: "CANCEL"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_Button, {
                        loading: isLoading,
                        type: "primary",
                        height: "40px",
                        width: "80px",
                        round: true,
                        onClick: function() {
                            return onSubmit(valuationId);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_Text, {
                            color: ui/* color.light */.$_.light,
                            align: "center",
                            children: !isLoading && "DELETE"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ModalDelete = (ValuationModalDelete);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/slice.ts
var Valuation_slice = __webpack_require__(9139);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ValuationList.tsx
/* eslint-disable react/jsx-curly-newline */ 











var ValuationList_Text = ui/* Common.Text */.Gn.Text;
var ValuationList_Button = ui/* Widget.Button */.$L.Button;
var ValuationList = function(param) {
    var handleSwitchHamberger = param.handleSwitchHamberger, dataTemplate = param.dataTemplate, onClick = param.onClick, setUpdateMode = param.setUpdateMode, setShowResultSection = param.setShowResultSection;
    var dispatch = (0,es/* useDispatch */.I0)();
    var state = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl);
    var postDeleteValuationTemplate = state.postDeleteValuationTemplate, getValuationTemplateLoad = state.getValuationTemplateLoad;
    var isLoadingDeleteValuation = postDeleteValuationTemplate.isLoading;
    var ref = (0,react.useState)(""), hoveredRow = ref[0], setHoveredRow = ref[1];
    var ref1 = (0,react.useState)(0), valuationIdDelete = ref1[0], setValuationIdDelete = ref1[1];
    var ref2 = (0,react.useState)(""), valuationNameDelete = ref2[0], setValuationNameDelete = ref2[1];
    var ref3 = (0,react.useState)(false), isValuationModalDelete = ref3[0], setValuationModalDelete = ref3[1];
    var handleOnClickDeleteValuation = function(valuationId, valuationName) {
        // set valuationIdDelete
        setValuationIdDelete(valuationId);
        // set valuationNameDelete
        setValuationNameDelete(valuationName);
        // show modal delete
        setValuationModalDelete(true);
    };
    var handleCancelValuationModalDelete = function() {
        // clear valuationNameDelete
        setValuationNameDelete("");
        // hide modal delete
        setValuationModalDelete(false);
    };
    var handleSubmitValuationModalDelete = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(valuationId) {
            var del, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(Valuation_slice/* effects.postDeleteValuationTemplate */.Sz.postDeleteValuationTemplate(valuationId));
                    case 2:
                        del = _ctx.sent;
                        error = del.payload.error;
                        if (!error) {
                            (0,AlertErrorMessage/* default */.Z)("Template ".concat(valuationNameDelete, " has been deleted"), successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitValuationModalDelete(valuationId) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var isLoading = getValuationTemplateLoad.isLoading;
        // getValuationTemplateLoad success
        if (!isLoading) {
            // dispatch all valuation list
            dispatch(Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate());
        }
    }, [
        getValuationTemplateLoad,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        var isSubmitted = postDeleteValuationTemplate.isSubmitted;
        // delete valuation success
        if (isSubmitted) {
            // hide modal delete
            setValuationModalDelete(false);
            // dispatch all valuation list
            dispatch(Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate());
        }
    }, [
        postDeleteValuationTemplate,
        dispatch
    ]);
    var handleOnClickButton = function() {
        setUpdateMode(false);
        setShowResultSection(false);
        handleSwitchHamberger();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: "calc(100% - 40px)",
            overflowY: "auto",
            padding: "19px 12px 0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationList_Button, {
                block: true,
                round: true,
                height: "35px",
                margin: "0 0 12px",
                type: "defaultHoverable",
                onClick: handleOnClickButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationList_Text, {
                    color: "inherit",
                    align: "center",
                    children: "Create New Valuation"
                })
            }),
            dataTemplate.map(function(template) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListContainer, {
                    onMouseEnter: function() {
                        return setHoveredRow(template.id);
                    },
                    onMouseLeave: function() {
                        return setHoveredRow("");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationList_Text, {
                            size: "14px",
                            height: "30px",
                            as: "a",
                            style: {
                                flex: 1
                            },
                            color: "#6b6b6b",
                            onClick: function() {
                                return onClick(template.id);
                            },
                            children: template.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_ListCloseIcon, {
                            handleOnClickDelete: function() {
                                return handleOnClickDeleteValuation(template.id, template.name);
                            }
                        })
                    ]
                }, template.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete, {
                valuationId: valuationIdDelete,
                valuationName: valuationNameDelete,
                isVisible: isValuationModalDelete,
                onCancel: handleCancelValuationModalDelete,
                onSubmit: handleSubmitValuationModalDelete,
                isLoading: isLoadingDeleteValuation
            })
        ]
    });
};
/* harmony default export */ var ValuationWidget_ValuationList = (ValuationList);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/lib/api/valuation.ts
var valuation = __webpack_require__(17065);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/Common/Search/options.tsx


var Search_options_Flex = ui/* Common.Flex */.Gn.Flex, options_Tag = ui/* Common.Tag.Tag */.Gn.Tag.Tag, Search_options_Text = ui/* Common.Text */.Gn.Text;
var options_renderStockSuggestions = function() {
    var stocks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return stocks.map(function(stock) {
        return {
            value: stock.name,
            objStock: stock,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_options_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(options_Tag, {
                        size: "xs",
                        type: "grey",
                        children: stock.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_options_Text, {
                        pl: "10px",
                        size: "13px",
                        children: stock.desc
                    })
                ]
            })
        };
    });
};
/* harmony default export */ var Search_options = ({});

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/Common/Search/index.tsx









// Store company


var Search_Input = ui/* Common.Input */.Gn.Input, Common_Search_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function Search_Search(param) {
    var searchValue = param.searchValue, handleSelectedValueStock = param.handleSelectedValueStock, isEdit = param.isEdit, isClickAlertLog = param.isClickAlertLog, onReset = param.onReset;
    var ref = (0,react.useState)(""), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(0), timeInterval = ref1[0], setTimeInterval = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(entities_company/* selectors */.wl), _search = ref2.search, dataSearch = _search.data;
    // handle actions
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (searchValue) {
            setValue(searchValue);
        }
    }, [
        searchValue
    ]);
    var handleSearchCompany = function(val) {
        if (val.length > 1) {
            onReset();
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(window.setTimeout(function() {
                dispatch(entities_company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
            }, 500));
        }
    };
    var handleSelectCompany = function(val, options) {
        var objStock = options.objStock;
        // Reset on select
        onReset();
        setValue(objStock.name);
        handleSelectedValueStock(objStock);
        // dispatch search company with stock name
        dispatch(entities_company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
    };
    var handlePressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var val, search, data, _data, company;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        val = e;
                        if (typeof e !== "string") {
                            val = e.target.value;
                        }
                        _ctx.next = 4;
                        return dispatch(entities_company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
                    case 4:
                        search = _ctx.sent;
                        data = search.payload.data;
                        if (data && data.length > 0) {
                            _data = (0,_sliced_to_array/* default */.Z)(data, 1), company = _data[0];
                            setValue(company.name);
                            handleSelectedValueStock(company);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePressEnter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var options = options_renderStockSuggestions(dataSearch);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* Relative */.Ig, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoCompleteStock, {
            options: options,
            width: "100%",
            value: value,
            onChange: setValue,
            onSelect: handleSelectCompany,
            onSearch: handleSearchCompany,
            mb: "8px",
            getPopupContainer: function(trigger) {
                return trigger.parentElement;
            },
            disabled: isClickAlertLog,
            dropdownClassName: "stock-search-dropdown",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Input, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Search_Iconmoon, {
                    className: "icon-avatar_search"
                }),
                placeholder: "Type stock here ..",
                height: "36px",
                width: "100%",
                onPressEnter: handlePressEnter,
                required: true
            })
        })
    });
}
/* harmony default export */ var Common_Search = (Search_Search);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ModalCreate.tsx
/* eslint-disable react/jsx-wrap-multilines */ 



var ModalCreate_Text = ui/* Common.Text */.Gn.Text, ModalCreate_Flex = ui/* Common.Flex */.Gn.Flex;
var ModalCreate_Button = ui/* Widget.Button */.$L.Button;
var ValuationModalCreate = function(param) {
    var isVisible = param.isVisible, onCancel = param.onCancel, onSubmit = param.onSubmit, isLoading = param.isLoading;
    var ref = (0,react.useState)(""), valueInput = ref[0], setValueInput = ref[1];
    var onChangeInput = function(e) {
        var inputed = e.target.value;
        setValueInput(inputed);
    };
    var handleSubmit = function(e) {
        e.preventDefault();
        var value = valueInput.trim();
        onSubmit(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate_Text, {
            size: "18px",
            align: "center",
            height: "40px",
            family: "bold",
            children: "Save New Valuation"
        }),
        visible: isVisible,
        onCancel: onCancel,
        centered: true,
        footer: null,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate_Text, {
                    mb: "8px",
                    children: "Valuation Name"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputModal, {
                    placeholder: "Valuation Name",
                    onChange: onChangeInput
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalCreate_Flex, {
                    justify: "flex-end",
                    mt: "15px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate_Button, {
                            height: "40px",
                            htmlType: "button",
                            borderLess: true,
                            onClick: onCancel,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate_Text, {
                                children: "CANCEL"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate_Button, {
                            type: "primary",
                            htmlType: "submit",
                            height: "40px",
                            width: "80px",
                            round: true,
                            loading: isLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate_Text, {
                                color: ui/* color.light */.$_.light,
                                align: "center",
                                children: !isLoading && "SAVE"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ModalCreate = (ValuationModalCreate);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ModalUpdate.tsx
/* eslint-disable react/jsx-wrap-multilines */ 


var ModalUpdate_Text = ui/* Common.Text */.Gn.Text, ModalUpdate_Flex = ui/* Common.Flex */.Gn.Flex;
var ModalUpdate_Button = ui/* Widget.Button */.$L.Button;
var ValuationModalUpdate = function(param) {
    var valuationName = param.valuationName, visible = param.visible, onCancel = param.onCancel, onSubmit = param.onSubmit, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Modal, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate_Text, {
            size: "18px",
            align: "center",
            height: "40px",
            family: "bold",
            children: "Overwrite Valuation?"
        }),
        visible: visible,
        onCancel: onCancel,
        centered: true,
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalUpdate_Text, {
                children: [
                    'Do you want to overwrite "',
                    valuationName,
                    '" valuation?'
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalUpdate_Flex, {
                justify: "flex-end",
                mt: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate_Button, {
                        height: "40px",
                        borderLess: true,
                        onClick: onCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate_Text, {
                            children: "CANCEL"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate_Button, {
                        loading: isLoading,
                        type: "primary",
                        height: "40px",
                        width: "80px",
                        round: true,
                        onClick: function() {
                            return onSubmit();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate_Text, {
                            color: ui/* color.light */.$_.light,
                            align: "center",
                            children: !isLoading && "UPDATE"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ModalUpdate = (ValuationModalUpdate);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ValuationResult.tsx





var ValuationResult_Text = ui/* Common.Text */.Gn.Text, ValuationResult_Input = ui/* Common.Input */.Gn.Input;
var ValuationResult_Button = ui/* Widget.Button */.$L.Button;
var columns = [
    {
        dataIndex: "label",
        key: "label",
        width: "60%"
    },
    {
        dataIndex: "value",
        key: "value"
    }, 
];
var ValuationResult = function(param) {
    var onClick = param.onClick, dataValuationResult = param.dataValuationResult, isUpdateMode = param.isUpdateMode, notes = param.notes, isLoading = param.isLoading;
    var ref = (0,react.useState)(""), inputedNotes = ref[0], setInputedNotes = ref[1];
    var handleOnChangeNotes = function(e) {
        setInputedNotes(e.target.value.trim());
    };
    var handleOnClickResult = function() {
        onClick(inputedNotes);
    };
    var dataSourceStockValue = [
        {
            key: 1,
            label: "Target Price ".concat(dataValuationResult.symbol),
            value: dataValuationResult.target_price
        },
        {
            key: 2,
            label: "Current Price ".concat(dataValuationResult.symbol),
            value: dataValuationResult.current_price
        },
        {
            key: 3,
            label: "Potential Gain",
            value: "".concat(dataValuationResult.margin_safety, " %")
        }, 
    ];
    var dataSourceConsensusTarget = [
        {
            key: 1,
            label: "Consensus (High)",
            value: dataValuationResult.consensus_high
        },
        {
            key: 2,
            label: "Consensus (Medium)",
            value: dataValuationResult.consensus_medium
        },
        {
            key: 3,
            label: "Consensus (Low)",
            value: dataValuationResult.consensus_low
        }, 
    ];
    if (isLoading || !dataValuationResult.target_price) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
            active: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationResult_Text, {
                family: "bold",
                mb: "15px",
                children: "Stock Value"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Table, {
                columns: columns,
                dataSource: dataSourceStockValue,
                borderless: true,
                pagination: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationResult_Text, {
                family: "bold",
                my: "15px",
                children: "Consensus Target"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Table, {
                columns: columns,
                dataSource: dataSourceConsensusTarget,
                borderless: true,
                pagination: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationResult_Text, {
                family: "bold",
                my: "15px",
                children: "Notes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationResult_Input.TextArea, {
                autoSize: {
                    minRows: 2
                },
                onChange: handleOnChangeNotes,
                defaultValue: isUpdateMode ? notes : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationResult_Button, {
                type: "defaultHoverable",
                margin: "15px 0",
                block: true,
                round: true,
                onClick: handleOnClickResult,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationResult_Text, {
                    align: "center",
                    height: "27px",
                    color: "inherit",
                    children: "Save"
                })
            })
        ]
    });
};
/* harmony default export */ var ValuationWidget_ValuationResult = (ValuationResult);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/Form/OptionsGroup.tsx






var OptionsGroup_Text = ui/* Common.Text */.Gn.Text;
var OptionsGroup = function(_param) /*#__PURE__*/ {
    var children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(SelectGroup.Option, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsGroup_Text, {
            height: "inherit",
            children: children
        })
    }));
};
/* harmony default export */ var Form_OptionsGroup = (OptionsGroup);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/Form/useValueMetrics.tsx


function useValueMetrics() {
    var getValuationMetrics = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl).getValuationMetrics;
    var dataValuationMetrics = getValuationMetrics.data;
    var getDefaultValueIndexMetrics = function(paramsMetrics) {
        if (paramsMetrics !== "multiple") {
            var findDataDefault = dataValuationMetrics.params[paramsMetrics].find(function(metrics) {
                return metrics.default;
            });
            return findDataDefault ? findDataDefault.fitem_id : "";
        }
        // special case for MULTIPLE
        return Object.keys(dataValuationMetrics.params.multiple).map(function(i) {
            var currentMultiple = dataValuationMetrics.params.multiple[i];
            if (Array.isArray(currentMultiple)) {
                var findDataDefault = currentMultiple.find(function(metrics) {
                    return metrics.default;
                });
                return findDataDefault ? findDataDefault.fitem_id : "";
            }
            return currentMultiple && currentMultiple.default ? currentMultiple.fitem_id : "";
        }).filter(function(multiple) {
            return multiple !== "";
        })[0];
    };
    return {
        metrics: dataValuationMetrics,
        getMetrics: getDefaultValueIndexMetrics
    };
}
/* harmony default export */ var Form_useValueMetrics = (useValueMetrics);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/Form/InputMetrics.tsx





var InputMetrics_Flex = ui/* Common.Flex */.Gn.Flex;
function InputMetrics(param) {
    var disabled = param.disabled, metricsKey = param.metrics, selectValue = param.selectValue, value = param.value, onChange = param.onChange, onSelect = param.onSelect;
    var ref;
    var ref1 = Form_useValueMetrics(), metrics = ref1.metrics, getMetrics = ref1.getMetrics;
    var options = (metrics === null || metrics === void 0 ? void 0 : (ref = metrics.params) === null || ref === void 0 ? void 0 : ref[metricsKey]) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputMetrics_Flex, {
        children: [
            metrics.params && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectGroup, {
                value: selectValue === 0 ? getMetrics(metricsKey) : selectValue,
                onSelect: onSelect,
                style: {
                    minWidth: "50px"
                },
                getPopupContainer: function() {
                    return document.getElementById("sw-valuation-form");
                },
                children: options.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_OptionsGroup, {
                        value: item.fitem_id,
                        children: item.fitem_name
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                onChange: onChange,
                disabled: disabled,
                value: value
            })
        ]
    });
}
/* harmony default export */ var Form_InputMetrics = (InputMetrics);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/Form/InputMetricMultiple.tsx





var InputMetricMultiple_Flex = ui/* Common.Flex */.Gn.Flex;
function InputMetricMultiple(param) {
    var disabled = param.disabled, selectValue = param.selectValue, value = param.value, onChange = param.onChange, onSelect = param.onSelect;
    var ref;
    var ref1 = Form_useValueMetrics(), metrics = ref1.metrics, getMetrics = ref1.getMetrics;
    var options = (metrics === null || metrics === void 0 ? void 0 : (ref = metrics.params) === null || ref === void 0 ? void 0 : ref.multiple) || {};
    var labelName = {
        year_one: "1 Year",
        year_three: "3 Year"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputMetricMultiple_Flex, {
        children: [
            metrics.params && /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectGroup, {
                // defaultValue={getDefaultValueIndexMetrics('MULTIPLE')}
                value: selectValue === 0 ? getMetrics("multiple") : selectValue,
                onSelect: onSelect,
                style: {
                    minWidth: "50px"
                },
                getPopupContainer: function() {
                    return document.getElementById("sw-valuation-form");
                },
                children: Object.keys(options).map(function(i) {
                    var currentMultiple = options[i];
                    if (Array.isArray(currentMultiple)) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectGroup.OptGroup, {
                            label: labelName[i],
                            children: currentMultiple.map(function(dataMultiple) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_OptionsGroup, {
                                    value: dataMultiple.fitem_id,
                                    children: dataMultiple.fitem_name
                                });
                            })
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_OptionsGroup, {
                        value: currentMultiple.fitem_id,
                        children: currentMultiple.fitem_name
                    });
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGroup, {
                onChange: onChange,
                disabled: disabled,
                value: value
            })
        ]
    });
}
/* harmony default export */ var Form_InputMetricMultiple = (InputMetricMultiple);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ValuationForm.tsx







// alert error message










// constant
var ValuationForm_Text = ui/* Common.Text */.Gn.Text;
var ValuationForm_Button = ui/* Widget.Button */.$L.Button, ValuationForm_Select = ui/* Widget.Select */.$L.Select;
var VALUATION_METRICS = {
    EPS: "eps",
    GROWTH: "growth",
    MULTIPLE: "multiple"
};
var ValuationForm = function(param) {
    var isUpdateMode = param.isUpdateMode, setUpdateMode = param.setUpdateMode, isShowResultSection = param.isShowResultSection, setShowResultSection = param.setShowResultSection;
    var dispatch = (0,es/* useDispatch */.I0)();
    var state = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl);
    var postValuationResult = state.postValuationResult, postValuationTemplateAdd = state.postValuationTemplateAdd, postValuationTemplateSave = state.postValuationTemplateSave, getValuationMetricsDefault = state.getValuationMetricsDefault, getValuationTemplateLoad = state.getValuationTemplateLoad;
    var ref = (0,react.useState)(0), updatedValuationId = ref[0], setUpdatedValuationId = ref[1];
    var ref1 = (0,react.useState)(""), updatedValuationName = ref1[0], setUpdatedValuationName = ref1[1];
    var ref2 = (0,react.useState)(null), stock = ref2[0], setStock = ref2[1];
    var ref3 = (0,react.useState)(0), valueSelectEPS = ref3[0], setValueSelectEPS = ref3[1];
    var ref4 = (0,react.useState)(""), valueEPS = ref4[0], setValueEPS = ref4[1];
    var ref5 = (0,react.useState)("CUSTOM"), valueSelectGrowth = ref5[0], setValueSelectGrowth = ref5[1];
    var ref6 = (0,react.useState)(""), valueGrowth = ref6[0], setValueGrowth = ref6[1];
    var ref7 = (0,react.useState)(0), valueSelectMultiple = ref7[0], setValueSelectMultiple = ref7[1];
    var ref8 = (0,react.useState)(""), valueMultiple = ref8[0], setValueMultiple = ref8[1];
    var ref9 = (0,react.useState)(false), isValuationModalCreate = ref9[0], setValuationModalCreate = ref9[1];
    var ref10 = (0,react.useState)(false), isValuationModalUpdate = ref10[0], setValuationModalUpdate = ref10[1];
    var ref11 = (0,react.useState)(""), inputedNotes = ref11[0], setInputedNotes = ref11[1];
    var ref12 = (0,react.useState)(true), isValuationMetricsDisabled = ref12[0], setValuationMetricsDisabled = ref12[1];
    var ref13 = (0,react.useState)({
        target_price: "",
        current_price: "",
        margin_safety: "",
        consensus_high: "",
        consensus_low: "",
        consensus_medium: "",
        symbol: ""
    }), seedDataValuationResult = ref13[0], setSeedDataValuationResult = ref13[1];
    var isLoadingPostValuationTemplateAdd = postValuationTemplateAdd.isLoading;
    var isLoadingUpdateValuation = postValuationTemplateSave.isLoading;
    var dataValuationMetricsDefault = getValuationMetricsDefault.data;
    var resetState = function() {
        if (!isUpdateMode) {
            setUpdatedValuationId(0);
            setUpdatedValuationName("");
            setInputedNotes("");
        }
        setValueSelectEPS(0);
        setValueEPS("");
        setValueSelectGrowth("CUSTOM");
        setValueGrowth("");
        setValueSelectMultiple(0);
        setValueMultiple("");
        setValuationModalCreate(false);
        setValuationModalUpdate(false);
        setValuationMetricsDisabled(true);
        setSeedDataValuationResult({
            target_price: "",
            current_price: "",
            margin_safety: "",
            consensus_high: "",
            consensus_low: "",
            consensus_medium: "",
            symbol: ""
        });
        setShowResultSection(false);
    };
    var getSeedData = function() {
        var dataResult = [
            {
                name: "target_price",
                value: seedDataValuationResult.target_price
            },
            {
                name: "current_price",
                value: seedDataValuationResult.current_price
            },
            {
                name: "margin_safety",
                value: seedDataValuationResult.margin_safety
            },
            {
                name: "consensus_high",
                value: seedDataValuationResult.consensus_high
            },
            {
                name: "consensus_medium",
                value: seedDataValuationResult.consensus_medium
            },
            {
                name: "consensus_low",
                value: seedDataValuationResult.consensus_low
            }, 
        ];
        var dataMetrics = {
            item: [
                {
                    name: "EPS",
                    itemid: String(valueSelectEPS),
                    value: valueEPS
                },
                {
                    name: "GROWTH",
                    itemid: String(valueSelectGrowth),
                    value: valueGrowth
                },
                {
                    name: "MULTIPLE",
                    itemid: String(valueSelectMultiple),
                    value: valueMultiple
                }, 
            ],
            comp_id: stock.id
        };
        return {
            metrics: dataMetrics,
            results: dataResult
        };
    };
    var handleOnClickSave = function(inputed) {
        if (isUpdateMode) {
            // show modal update
            setValuationModalUpdate(true);
        } else {
            // show modal create
            setValuationModalCreate(true);
        }
        // set inputed notes
        setInputedNotes(inputed);
    };
    var handleCancelValuationModalCreate = function() {
        // hide modal create
        setValuationModalCreate(false);
    };
    var handleCancelValuationModalUpdate = function() {
        // hide modal update
        setValuationModalUpdate(false);
    };
    var handleSubmitValuationModalCreate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(valueInput) {
            var data, requestBody, add, _payload, error, resData, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = getSeedData();
                        requestBody = {
                            company_id: stock.id,
                            name: valueInput,
                            metric: JSON.stringify(data.metrics),
                            result: JSON.stringify(data.results),
                            note: inputedNotes
                        };
                        _ctx.next = 4;
                        return dispatch(Valuation_slice/* effects.postValuationTemplateAdd */.Sz.postValuationTemplateAdd(requestBody));
                    case 4:
                        add = _ctx.sent;
                        _payload = add.payload, error = _payload.error, resData = _payload.data, message = _payload.message;
                        if (!error) {
                            // Set alert
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            // set update mode on
                            setUpdateMode(true);
                            // hide modal create
                            setValuationModalCreate(false);
                            // dispatch list valuation
                            // HIT API getValuationTemplate
                            dispatch(Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate());
                            dispatch(Valuation_slice/* effects.getValuationTemplateLoad */.Sz.getValuationTemplateLoad(resData.id));
                            // new valuation id
                            setUpdatedValuationId(resData.id);
                            // new valuation name
                            setUpdatedValuationName(resData.name);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitValuationModalCreate(valueInput) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmitValuationModalUpdate = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, requestBody, update, _payload, error, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = getSeedData();
                        requestBody = {
                            name: updatedValuationName,
                            metric: JSON.stringify(data.metrics),
                            result: JSON.stringify(data.results),
                            note: inputedNotes
                        };
                        _ctx.next = 4;
                        return dispatch(Valuation_slice/* effects.postValuationTemplateSave */.Sz.postValuationTemplateSave({
                            templateId: updatedValuationId,
                            requestBody: requestBody
                        }));
                    case 4:
                        update = _ctx.sent;
                        _payload = update.payload, error = _payload.error, message = _payload.message;
                        if (!error) {
                            // hide modal update
                            setValuationModalUpdate(false);
                            (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            // dispatch list valuation
                            // HIT API getValuationTemplate
                            dispatch(Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate());
                            dispatch(Valuation_slice/* effects.getValuationTemplateLoad */.Sz.getValuationTemplateLoad(updatedValuationId));
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitValuationModalUpdate() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function(e) {
        e.preventDefault();
        if (stock === null || stock === void 0 ? void 0 : stock.name) {
            var requestBody = {
                symbol: stock.name,
                eps_value: valueEPS,
                growth_value: valueGrowth,
                multiple_value: valueMultiple
            };
            // dispatch post postValuationResult
            dispatch(Valuation_slice/* effects.postValuationResult */.Sz.postValuationResult(requestBody));
            setShowResultSection(true);
        }
    };
    var handleSelectedValueStock = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(selectedStock) {
            var queryString, getMetric, _payload, error, data, _data, eps, growth, multiple;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setStock(selectedStock);
                        queryString = {
                            symbol: selectedStock.name
                        };
                        _ctx.next = 4;
                        return dispatch(Valuation_slice/* effects.getValuationMetricsDefault */.Sz.getValuationMetricsDefault(queryString));
                    case 4:
                        getMetric = _ctx.sent;
                        _payload = getMetric.payload, error = _payload.error, data = _payload.data;
                        // Set table upon success get company metrid
                        if (!error) {
                            _data = (0,_sliced_to_array/* default */.Z)(data, 3), eps = _data[0], growth = _data[1], multiple = _data[2];
                            // index 0: EPS
                            setValueSelectEPS(String(eps.id));
                            setValueEPS(eps.value);
                            // index 1: GROWTH
                            setValueSelectGrowth(growth.id === "" || growth.id === 0 ? "CUSTOM" : String(growth.id));
                            setValueGrowth(growth.value);
                            // index 2: MULTIPLE
                            setValueSelectMultiple(String(multiple.id));
                            setValueMultiple(multiple.value);
                            setValuationMetricsDisabled(false);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelectedValueStock(selectedStock) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var isSubmitted = postValuationResult.isSubmitted, dataValuationResult = postValuationResult.data;
        if (isSubmitted) {
            setSeedDataValuationResult({
                target_price: dataValuationResult.target_price,
                current_price: dataValuationResult.current_price,
                margin_safety: dataValuationResult.margin_safety,
                consensus_high: dataValuationResult.consensus_high,
                consensus_low: dataValuationResult.consensus_low,
                consensus_medium: dataValuationResult.consensus_medium,
                symbol: dataValuationResult.symbol
            });
        }
    }, [
        postValuationResult
    ]);
    var getResultData = function(data, key) {
        return data.find(function(item) {
            return item.name === key;
        }).value || 0;
    };
    var getMetricsData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(id) {
            var res, _data, error, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (stock === null || stock === void 0 ? void 0 : stock.name) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 2:
                        _ctx.next = 4;
                        return valuation/* default.getValuationMetricPerID */.Z.getValuationMetricPerID(stock.name, id);
                    case 4:
                        res = _ctx.sent;
                        if (res.data) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 7:
                        _data = res.data, error = _data.error, data = _data.data;
                        if (!error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", "");
                    case 10:
                        return _ctx.abrupt("return", data[0]);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getMetricsData(id) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var dataValuationDetail = getValuationTemplateLoad.data, isLoading = getValuationTemplateLoad.isLoading;
        if (Object.keys(dataValuationDetail).length > 0 && !isLoading) {
            var valuation = dataValuationDetail.valuation, metric = dataValuationDetail.metric, result = dataValuationDetail.result, note = dataValuationDetail.note;
            var company = metric.company, item = metric.item;
            var queryString = {
                symbol: company.symbol
            };
            if (isUpdateMode) {
                // dispatch default metrics
                dispatch(Valuation_slice/* effects.getValuationMetricsDefault */.Sz.getValuationMetricsDefault(queryString));
                setUpdatedValuationId(valuation.id);
                setUpdatedValuationName(valuation.name);
                var _item = (0,_sliced_to_array/* default */.Z)(item, 3), eps = _item[0], growth = _item[1], multiple = _item[2];
                // Set table valuation metric
                setValueEPS(eps.value);
                setValueSelectEPS(eps.itemid);
                setValueGrowth(growth.value);
                setValueSelectGrowth(growth.itemid);
                setValueMultiple(multiple.value);
                setValueSelectMultiple(multiple.itemid);
                setStock({
                    id: company.id,
                    name: company.symbol
                });
                setInputedNotes(note);
                setSeedDataValuationResult({
                    target_price: getResultData(result, "target_price"),
                    current_price: getResultData(result, "current_price"),
                    margin_safety: getResultData(result, "margin_safety"),
                    consensus_high: getResultData(result, "consensus_high"),
                    consensus_low: getResultData(result, "consensus_low"),
                    consensus_medium: getResultData(result, "consensus_medium"),
                    symbol: company.symbol
                });
                setShowResultSection(true);
                setValuationMetricsDisabled(false);
            } else {
                setValuationMetricsDisabled(true);
            }
        }
    }, [
        getValuationTemplateLoad,
        dispatch,
        isUpdateMode,
        setShowResultSection
    ]);
    var handleOnSelectEPS = function(value) {
        setValueSelectEPS(value);
        // if select id same with default, change value to default
        if ((dataValuationMetricsDefault === null || dataValuationMetricsDefault === void 0 ? void 0 : dataValuationMetricsDefault.length) && Number(value) === Number(dataValuationMetricsDefault[0].id)) {
            setValueEPS(dataValuationMetricsDefault[0].value);
        } else {
            setValueEPS("0");
        }
    };
    var handleOnChangeEPS = function(e) {
        var inputedEPS = e.target.value.trim();
        setValueEPS(inputedEPS);
        // if inputed same with default, change select to custom
        if ((dataValuationMetricsDefault === null || dataValuationMetricsDefault === void 0 ? void 0 : dataValuationMetricsDefault.length) && inputedEPS !== dataValuationMetricsDefault[0].value) {
            setValueSelectEPS("CUSTOM");
        }
    };
    var handleOnSelectGrowth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setValueSelectGrowth(value);
                        if (!((dataValuationMetricsDefault === null || dataValuationMetricsDefault === void 0 ? void 0 : dataValuationMetricsDefault.length) >= 2 && (value === dataValuationMetricsDefault[1].id || value === false && dataValuationMetricsDefault[1].id === ""))) {
                            _ctx.next = 4;
                            break;
                        }
                        setValueGrowth(dataValuationMetricsDefault[1].value);
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(value !== "CUSTOM")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return getMetricsData(value);
                    case 7:
                        data = _ctx.sent;
                        setValueGrowth((data === null || data === void 0 ? void 0 : data.value) || "");
                        return _ctx.abrupt("return");
                    case 10:
                        setValueGrowth("0");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnSelectGrowth(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnChangeGrowth = function(e) {
        var inputedGrowth = e.target.value.trim();
        setValueGrowth(inputedGrowth);
        // if inputed same with default, change select to custom
        if ((dataValuationMetricsDefault === null || dataValuationMetricsDefault === void 0 ? void 0 : dataValuationMetricsDefault.length) >= 2 && inputedGrowth !== dataValuationMetricsDefault[1].value) {
            setValueSelectGrowth("CUSTOM");
        }
    };
    var handleOnSelectMultiple = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setValueSelectMultiple(value);
                        if (!((dataValuationMetricsDefault === null || dataValuationMetricsDefault === void 0 ? void 0 : dataValuationMetricsDefault.length) >= 3 && value === dataValuationMetricsDefault[2].id)) {
                            _ctx.next = 4;
                            break;
                        }
                        setValueMultiple(dataValuationMetricsDefault[2].value);
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(value !== "CUSTOM")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 7;
                        return getMetricsData(value);
                    case 7:
                        data = _ctx.sent;
                        setValueMultiple((data === null || data === void 0 ? void 0 : data.value) || "");
                        return _ctx.abrupt("return");
                    case 10:
                        setValueMultiple("0");
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOnSelectMultiple(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnChangeMultiple = function(e) {
        var inputedMultiple = e.target.value.trim();
        setValueMultiple(inputedMultiple);
        // if inputed same with default, change select to custom
        if ((dataValuationMetricsDefault === null || dataValuationMetricsDefault === void 0 ? void 0 : dataValuationMetricsDefault.length) >= 3 && inputedMultiple !== dataValuationMetricsDefault[2].value) {
            setValueSelectMultiple("CUSTOM");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "sw-valuation-form",
        style: {
            height: "calc(100% - 40px)",
            overflowY: "auto",
            padding: "0 10px 10px 10px",
            zIndex: 100
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationForm_Text, {
                family: "bold",
                mb: "10px",
                mt: "10px",
                children: "Valuation Method"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationForm_Select, {
                width: "100%",
                heihgt: "30px",
                defaultValue: "PEM",
                mb: "15px",
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationForm_Select.Option, {
                    value: "PEM",
                    children: "Price to Earnings Method"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationForm_Text, {
                family: "bold",
                mb: "10px",
                children: "Valuation Metric"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Search, {
                        searchValue: (stock === null || stock === void 0 ? void 0 : stock.name) || "",
                        handleSelectedValueStock: handleSelectedValueStock,
                        isEdit: isUpdateMode,
                        isClickAlertLog: false,
                        onReset: resetState
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            borderBottom: "1px solid ".concat(ui/* color.gainsboro */.$_.gainsboro)
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_InputMetrics, {
                                metrics: VALUATION_METRICS.EPS,
                                selectValue: valueSelectEPS,
                                value: valueEPS,
                                disabled: isValuationMetricsDisabled,
                                onChange: handleOnChangeEPS,
                                onSelect: handleOnSelectEPS
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_InputMetrics, {
                                metrics: VALUATION_METRICS.GROWTH,
                                selectValue: valueSelectGrowth,
                                value: valueGrowth,
                                disabled: isValuationMetricsDisabled,
                                onChange: handleOnChangeGrowth,
                                onSelect: handleOnSelectGrowth
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_InputMetricMultiple, {
                                value: valueMultiple,
                                selectValue: valueSelectMultiple,
                                disabled: isValuationMetricsDisabled,
                                onChange: handleOnChangeMultiple,
                                onSelect: handleOnSelectMultiple
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationForm_Button, {
                        type: "defaultHoverable",
                        margin: "15px 0",
                        block: true,
                        round: true,
                        htmlType: "submit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationForm_Text, {
                            align: "center",
                            height: "27px",
                            color: "inherit",
                            children: "Value"
                        })
                    })
                ]
            }),
            isShowResultSection && /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationWidget_ValuationResult, {
                isUpdateMode: isUpdateMode,
                onClick: handleOnClickSave,
                dataValuationResult: seedDataValuationResult,
                notes: inputedNotes,
                isLoading: postValuationResult.isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalCreate, {
                isVisible: isValuationModalCreate,
                onCancel: handleCancelValuationModalCreate,
                onSubmit: handleSubmitValuationModalCreate,
                isLoading: isLoadingPostValuationTemplateAdd
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUpdate, {
                valuationName: updatedValuationName,
                visible: isValuationModalUpdate,
                onCancel: handleCancelValuationModalUpdate,
                onSubmit: handleSubmitValuationModalUpdate,
                isLoading: isLoadingUpdateValuation
            })
        ]
    });
};
/* harmony default export */ var ValuationWidget_ValuationForm = (ValuationForm);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ValuationWidget/ValuationContent.tsx







var ValuationContent = function(param) {
    var isHumbergerValuation = param.isHumbergerValuation, handleSwitchHumbergerValuation = param.handleSwitchHumbergerValuation, isUpdateMode = param.isUpdateMode, setUpdateMode = param.setUpdateMode, isShowResultSection = param.isShowResultSection, setShowResultSection = param.setShowResultSection;
    var dispatch = (0,es/* useDispatch */.I0)();
    var state = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl);
    var getValuationTemplate = state.getValuationTemplate, getValuationTemplateLoad = state.getValuationTemplateLoad;
    var isLoadingValuationDetail = getValuationTemplateLoad.isLoading;
    var dataValuationTemplate = getValuationTemplate.data;
    // didmount
    (0,react.useEffect)(function() {
        // HIT API getValuationTemplate
        dispatch(Valuation_slice/* effects.getValuationTemplate */.Sz.getValuationTemplate());
        // HIT API getValuationMetrics
        dispatch(Valuation_slice/* effects.getValuationMetrics */.Sz.getValuationMetrics());
    }, [
        dispatch
    ]);
    var handleOnClickListValuation = function(valuationId) {
        dispatch(Valuation_slice/* effects.getValuationTemplateLoad */.Sz.getValuationTemplateLoad(valuationId));
        // hide humberger
        handleSwitchHumbergerValuation();
        // change state update mode to true
        setUpdateMode(true);
    };
    // render ValuationList
    if (isHumbergerValuation) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationWidget_ValuationList, {
            handleSwitchHamberger: handleSwitchHumbergerValuation,
            dataTemplate: dataValuationTemplate,
            onClick: handleOnClickListValuation,
            setUpdateMode: setUpdateMode,
            setShowResultSection: setShowResultSection
        });
    }
    if (isLoadingValuationDetail && isUpdateMode) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
            active: true,
            paragraph: {
                rows: 6
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationWidget_ValuationForm, {
        isUpdateMode: isUpdateMode,
        setUpdateMode: setUpdateMode,
        isShowResultSection: isShowResultSection,
        setShowResultSection: setShowResultSection
    });
};
/* harmony default export */ var ValuationWidget_ValuationContent = (ValuationContent);

// EXTERNAL MODULE: ./node_modules/antd/es/pagination/index.js + 12 modules
var pagination = __webpack_require__(56673);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ScreenerWidget/styled.ts

function ScreenerWidget_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n  display: block;\n"
    ]);
    ScreenerWidget_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ScreenerWidget_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: none;\n"
    ]);
    ScreenerWidget_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ScreenerWidget_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(100% - 40px);\n  overflow-y: auto;\n\n  .ant-table-wrapper {\n    .ant-pagination {\n      display: none;\n    }\n  }\n  \n  .ant-pagination {\n    margin: 10px;\n  }\n\n  .ant-pagination-item, \n  .ant-pagination-jump-next, \n  .ant-pagination-jump-prev {\n    display: none;\n  }\n  .ant-pagination-next {\n    button {\n      ",
        "\n\n      &:before {\n        content: 'Next';\n        font-family: var(--regular-font);\n      }\n    }\n  }\n  .ant-pagination-prev {\n    margin-right: 0;\n    button {\n      border-right: none;\n      ",
        "\n\n      &:before {\n        content: 'Prev';\n        font-family: var(--regular-font);\n      }\n    }\n  }\n\n  .ant-pagination-next:not(.ant-pagination-disabled),\n  .ant-pagination-prev:not(.ant-pagination-disabled) {\n    button {\n      color: ",
        ";\n\n      &:hover {\n        border-color: ",
        ";\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    ScreenerWidget_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ScreenerWidget_styled_Text = ui/* Common.Text */.Gn.Text;
var ScreenerWidget_styled_Td = (0,styled_components_browser_esm["default"])(ScreenerWidget_styled_Text).attrs({
    height: "30px",
    padding: "0 10px",
    size: "12.5px"
}).withConfig({
    componentId: "sc-70412610-0"
})(ScreenerWidget_styled_templateObject(), ui/* color.gainsboro */.$_.gainsboro);
var ScreenerWidget_styled_Th = (0,styled_components_browser_esm["default"])(ScreenerWidget_styled_Td).attrs({
    family: "bold",
    size: "11.5px"
}).withConfig({
    componentId: "sc-70412610-1"
})(ScreenerWidget_styled_templateObject1());
var styled_button = "\n  border-radius: 0px;\n  padding: 0 10px;\n  height: 24px;\n  line-height: 24px;\n\n  .anticon {\n    display: none;\n  }\n";
var TableContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-70412610-2"
})(ScreenerWidget_styled_templateObject2(), styled_button, styled_button, ui/* color.primary */.$_.primary, ui/* color.gainsboro */.$_.gainsboro, ui/* color.primary */.$_.primary);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/SymbolLink.tsx




var SymbolLink = function(param) {
    var symbol = param.symbol, children = param.children, _isPreventDefault = param.isPreventDefault, isPreventDefault = _isPreventDefault === void 0 ? false : _isPreventDefault, onClick = param.onClick;
    var handleOnClick = (0,react.useCallback)(function(event) {
        if (isPreventDefault) {
            event.preventDefault();
        }
        !!onClick && onClick(event);
        return false;
    }, [
        isPreventDefault,
        onClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/symbol/".concat(symbol),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* SymbolLinkWrapper */.Gi, {
            onClick: handleOnClick,
            children: children
        })
    });
};
/* harmony default export */ var SideWidget_SymbolLink = (SymbolLink);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ScreenerWidget/ListTableScreener.tsx










var ListTableScreener_Text = ui/* Common.Text */.Gn.Text;
var ListTableScreener_Table = ui/* Widget.Table */.$L.Table, ListTableScreener_Select = ui/* Widget.Select */.$L.Select;
var ListTableScreener = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isInChartbitPage = router.pathname.includes("chartbit");
    var state = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl);
    var getLoadPresetScreener = state.getLoadPresetScreener, postScreenerListResult = state.postScreenerListResult, currentScreenerData = state.currentScreenerData;
    var dataLoadScreener = getLoadPresetScreener.data, isLoadingScreener = getLoadPresetScreener.isLoading;
    var isLoadingNextPageScreener = postScreenerListResult.isLoading;
    var page = currentScreenerData.page, isDataLoaded = currentScreenerData.isDataLoaded, shouldUpdate = currentScreenerData.shouldUpdate;
    var ref = (0,react.useState)(0), currentResultIndex = ref[0], setCurrentResultIndex = ref[1];
    var handleOnSelectFilter = function(columnId) {
        var findIndexSelectedColumn = dataLoadScreener.columns.findIndex(function(loadScreener) {
            return loadScreener.id === columnId;
        });
        // set selected index column
        setCurrentResultIndex(findIndexSelectedColumn);
    };
    var handleClick = (0,react.useCallback)(function(symbol) {
        var urlSuffix = isInChartbitPage ? "/chartbit" : "";
        router.push("/symbol/".concat(symbol).concat(urlSuffix), undefined, {
            shallow: isInChartbitPage
        });
    }, [
        dataLoadScreener
    ]);
    var columns = [
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_styled_Th, {
                children: "Symbol"
            }),
            dataIndex: "symbol",
            key: "symbol"
        },
        {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTableScreener_Select, {
                width: "100%",
                border: "none",
                value: dataLoadScreener.columns && dataLoadScreener.columns.length > 0 && dataLoadScreener.columns[currentResultIndex].id,
                style: {
                    height: "30px"
                },
                onSelect: handleOnSelectFilter,
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                children: dataLoadScreener.columns && dataLoadScreener.columns.length > 0 && dataLoadScreener.columns.map(function(screener) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTableScreener_Select.Option, {
                        value: screener.id,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTableScreener_Text, {
                            align: "right",
                            height: "inherit",
                            size: "11.5px",
                            family: "bold",
                            children: screener.name
                        })
                    });
                })
            }),
            dataIndex: "value",
            key: "value"
        }, 
    ];
    var dataSource = dataLoadScreener.calcs && dataLoadScreener.calcs.length > 0 && dataLoadScreener.calcs.map(function(screener) {
        return {
            key: "".concat(screener.company.id),
            symbol: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_SymbolLink, {
                symbol: screener.company.symbol,
                isPreventDefault: true,
                onClick: function() {
                    return handleClick(screener.company.symbol);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_styled_Td, {
                    family: "bold",
                    children: screener.company.symbol
                })
            }),
            value: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_styled_Td, {
                align: "right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    style: {
                        cursor: "text"
                    },
                    children: screener.results[currentResultIndex].display
                })
            })
        };
    });
    var handleTableChange = function(page) {
        var universe = dataLoadScreener.universe;
        var filters = JSON.stringify(dataLoadScreener.rules);
        var ordercol = 2; // di legacy hardcode 2
        var ordertype = dataLoadScreener.sort || "ASC";
        var screenerid = dataLoadScreener.screenerid;
        var name = dataLoadScreener.screen_name;
        var description = dataLoadScreener.screen_desc;
        var requestBody = {
            universe: universe,
            filters: filters,
            screenerid: String(screenerid),
            name: name,
            description: description,
            page: page,
            ordercol: ordercol,
            ordertype: ordertype
        };
        // export interface IScreenerSaveOrRunPayload {
        //   universe: IUniverseSaveOrRunPayload | string;
        //   filters?: IFiltersSaveOrRunPayload[] | string | null;
        //   page: number;
        //   ordercol: number;
        //   ordertype: string;
        //   sequence?: number | string | string[];
        //   save?: number;
        //   name: string;
        //   description: string;
        // }
        // TODO: Remove this lines after layout feature has been implemented
        dispatch(// @ts-ignore
        Valuation_slice/* default.actions.setCurrentScreenerData */.ZP.actions.setCurrentScreenerData({
            shouldUpdate: false
        }));
        // dispatch nextpage
        dispatch(Valuation_slice/* effects.postScreenerListResult */.Sz.postScreenerListResult(requestBody));
    };
    // TODO: Remove this lines after layout feature has been implemented
    var handlePageChange = function(currPage) {
        dispatch(// @ts-ignore
        Valuation_slice/* default.actions.setCurrentScreenerData */.ZP.actions.setCurrentScreenerData({
            page: currPage,
            shouldUpdate: true
        }));
    };
    var curpage = dataLoadScreener.curpage, perpage = dataLoadScreener.perpage, totalrows = dataLoadScreener.totalrows;
    // TODO: Remove this lines after layout feature has been implemented
    (0,react.useEffect)(function() {
        if (isDataLoaded && shouldUpdate) {
            handleTableChange(page);
        }
    }, [
        isDataLoaded,
        page,
        shouldUpdate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTableScreener_Table, {
                loading: isLoadingScreener || isLoadingNextPageScreener,
                dataSource: dataSource,
                columns: columns,
                pagination: {
                    position: [
                        "bottomLeft"
                    ],
                    pageSize: perpage
                },
                onChange: handlePageChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: totalrows > 25,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagination/* default */.Z, {
                    onChange: handlePageChange,
                    total: totalrows,
                    current: curpage,
                    pageSize: perpage,
                    hideOnSinglePage: true,
                    showQuickJumper: false,
                    showSizeChanger: false
                })
            })
        ]
    });
};
/* harmony default export */ var ScreenerWidget_ListTableScreener = (ListTableScreener);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Valuation/constants.ts
var Valuation_constants = __webpack_require__(36296);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ScreenerWidget/ListScreener.tsx





var ListScreener_Text = ui/* Common.Text */.Gn.Text;
var ListScreener_Button = ui/* Widget.Button */.$L.Button;
var ListScreener = function(param) {
    var dataScreenerCustom = param.dataScreenerCustom, handleOnClickDetailPreset = param.handleOnClickDetailPreset;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: "calc(100% - 40px)",
            overflowY: "auto",
            padding: "19px 12px 0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/screener",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    rel: "noreferrer noopener",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListScreener_Button, {
                        block: true,
                        round: true,
                        height: "35px",
                        margin: "0 0 12px",
                        type: "defaultHoverable",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListScreener_Text, {
                            color: "inherit",
                            align: "center",
                            children: "Create New Screener"
                        })
                    })
                })
            }),
            dataScreenerCustom.map(function(screener) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                    onClick: function() {
                        return handleOnClickDetailPreset(screener.id, Valuation_constants/* TYPE_CUSTOM_PRESET */.N8);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListScreener_Text, {
                        size: "14px",
                        height: "30px",
                        as: "a",
                        style: {
                            flex: 1
                        },
                        children: screener.name
                    })
                }, screener.id);
            })
        ]
    });
};
/* harmony default export */ var ScreenerWidget_ListScreener = (ListScreener);

;// CONCATENATED MODULE: ./src/utils/object.js
function findNestedObj(entireObj, keyToFind, valToFind) {
    var foundObj;
    JSON.stringify(entireObj, function(_, nestedValue) {
        if (nestedValue && nestedValue[keyToFind] === valToFind) {
            foundObj = nestedValue;
        }
        return nestedValue;
    });
    return foundObj;
}
/* harmony default export */ var object = ({
    findNestedObj: findNestedObj
});

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/Common/CloseIcon.tsx




var CloseIcon_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, CloseIcon_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var CloseIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon_IconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        size: "30px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon_Iconmoon, {
            className: "icon-widget_close",
            color: ui/* color.dimgray */.$_.dimgray,
            hoverColor: ui/* color.dimgray */.$_.dimgray,
            size: "14px",
            weight: "bold"
        })
    }));
};
/* harmony default export */ var Common_CloseIcon = (CloseIcon);

// EXTERNAL MODULE: ./src/hooks/useClickOutside.ts
var useClickOutside = __webpack_require__(1014);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ScreenerWidget/AutoSuggestion.tsx

function AutoSuggestion_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    AutoSuggestion_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AutoSuggestion_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 40px;\n  left: 0;\n  width: 100%;\n  overflow: auto;\n  border: 1px solid ",
        ";\n  box-shadow: unset;\n  background-color: ",
        ";\n  border-radius: 2px;\n\n  a {\n    display: block;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n"
    ]);
    AutoSuggestion_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var AutoSuggestion_Text = ui/* Common.Text */.Gn.Text, AutoSuggestion_Flex = ui/* Common.Flex */.Gn.Flex, AutoSuggestion_Input = ui/* Common.Input */.Gn.Input;
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b3169330-0"
})(AutoSuggestion_templateObject());
var AutoSuggestion_List = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b3169330-1"
})(AutoSuggestion_templateObject1(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro);
var AutoSuggestion = function(param) {
    var onSearch = param.onSearch, _options = param.options, options = _options === void 0 ? [] : _options, onSelect = param.onSelect, maxHeight = param.maxHeight;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,useClickOutside/* default */.Z)(function() {
        return setOpen(false);
    }).ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        ref: ref1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion_Input, {
                placeholder: "Search...",
                height: "30px",
                width: "100%",
                onChange: onSearch,
                onFocus: function() {
                    return setOpen(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: open && options.length > 0,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion_List, {
                    style: {
                        maxHeight: maxHeight
                    },
                    children: options.map(function(opt) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion_Flex, {
                            as: "a",
                            onClick: function() {
                                onSelect(opt);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoSuggestion_Text, {
                                p: "10px",
                                children: opt.name
                            })
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ScreenerWidget_AutoSuggestion = (AutoSuggestion);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ScreenerWidget/PresetScreener.tsx


function PresetScreener_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(100% - 40px);\n  overflow: auto;\n"
    ]);
    PresetScreener_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var PresetScreener_Text = ui/* Common.Text */.Gn.Text, PresetScreener_Flex = ui/* Common.Flex */.Gn.Flex;
var ListDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2ae9a597-0"
})(PresetScreener_templateObject());
var PresetScreener = function(param) {
    var handlePresetScreener = param.handlePresetScreener, dataPresetScreener = param.dataPresetScreener, handleOnClickDetailPreset = param.handleOnClickDetailPreset, maxAutocompleteHeight = param.maxAutocompleteHeight;
    var ref = (0,react.useState)([]), listData = ref[0], setListData = ref[1];
    var ref1 = (0,react.useState)([]), options = ref1[0], setOptions = ref1[1];
    var handleSelect = function(data) {
        // search value to dataPresetScreener & get array
        var childs = data.childs;
        if (childs.length === 0) {
            // dispatch to API
            handleOnClickDetailPreset(data.id);
        }
        var selectedValue = [
            (0,_object_spread/* default */.Z)({}, data)
        ];
        // set to list Data
        setListData(selectedValue);
    };
    // seed data to state listData
    (0,react.useEffect)(function() {
        setListData(dataPresetScreener);
    }, [
        dataPresetScreener
    ]);
    var handleOnClickSearch = function(searchedId) {
        // search value to dataPresetScreener & get array
        var findValueData = object.findNestedObj(listData, "id", searchedId);
        var childs = findValueData.childs;
        if (childs.length === 0) {
            // dispatch to API
            handleOnClickDetailPreset(searchedId);
        }
        // set childs to list Data
        setListData(childs);
    };
    var filterMetric = function(param) {
        var keyword = param.keyword, data_metric = param.data_metric, map_struc = param.map_struc;
        data_metric.map(function(item, i) {
            if (item.childs && item.childs.length == 0) {
                if (item.name.toLowerCase().search(keyword.toLowerCase()) > -1) {
                    map_struc.push(item);
                }
            } else {
                filterMetric({
                    keyword: keyword,
                    data_metric: item.childs,
                    map_struc: map_struc
                });
            }
        });
        return map_struc;
    };
    var onSearch = function(e) {
        var opts = filterMetric({
            keyword: e.target.value,
            data_metric: dataPresetScreener,
            map_struc: []
        });
        setOptions(opts);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PresetScreener_Flex, {
                p: " 5px 10px",
                align: "center",
                justify: "space-between",
                style: {
                    borderBottom: "1px solid ".concat(ui/* color.gainsboro */.$_.gainsboro)
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PresetScreener_Text, {
                        children: "Preset Screener"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_CloseIcon, {
                        onClick: handlePresetScreener
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PresetScreener_Flex, {
                p: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_AutoSuggestion, {
                    options: options,
                    onSelect: handleSelect,
                    onSearch: onSearch,
                    maxHeight: maxAutocompleteHeight
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: listData.map(function(preset) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                        onClick: function() {
                            return handleOnClickSearch(preset.id);
                        },
                        children: preset.name
                    }, preset.id);
                })
            })
        ]
    });
};
/* harmony default export */ var ScreenerWidget_PresetScreener = (PresetScreener);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/ScreenerWidget/ScreenerContent.tsx








var ScreenerContent = function(param) {
    var isHumbergerScreener = param.isHumbergerScreener, isPresetScreener = param.isPresetScreener, handlePresetScreener = param.handlePresetScreener, handleOffScreenerAndHamburger = param.handleOffScreenerAndHamburger, setScreenerTitle = param.setScreenerTitle, maxAutocompleteHeight = param.maxAutocompleteHeight;
    var dispatch = (0,es/* useDispatch */.I0)();
    var state = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl);
    var getScreenerCustom = state.getScreenerCustom, getScreenerMetrics = state.getScreenerMetrics, getLoadPresetScreener = state.getLoadPresetScreener, currentScreenerData = state.currentScreenerData;
    var dataScreenerCustom = getScreenerCustom.data;
    var dataPresetScreener = getScreenerMetrics.data;
    var handleOnClickDetailPreset = function(presetId) {
        var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Valuation_constants/* DEFAULT_TYPE_PRESET */.QR;
        // TODO: Remove this lines after layout feature has been implemented
        dispatch(// @ts-ignore
        Valuation_slice/* default.actions.setCurrentScreenerData */.ZP.actions.setCurrentScreenerData({
            page: Valuation_constants/* INITIAL_PAGE */.qe,
            presetId: presetId,
            type: type
        }));
        // dispatch load with presetId
        dispatch(Valuation_slice/* effects.getLoadPresetScreener */.Sz.getLoadPresetScreener({
            presetId: presetId,
            type: type
        }));
        handleOffScreenerAndHamburger();
    };
    // didmount
    (0,react.useEffect)(function() {
        var presetId = currentScreenerData.presetId;
        var type = currentScreenerData.type || Valuation_constants/* DEFAULT_TYPE_PRESET */.QR;
        // HIT API getScreenerCustom
        dispatch(Valuation_slice/* effects.getScreenerCustom */.Sz.getScreenerCustom());
        // HIT API getScreenerMetrics
        dispatch(Valuation_slice/* effects.getScreenerMetrics */.Sz.getScreenerMetrics());
        // HIT API getLoadPresetScreener
        dispatch(Valuation_slice/* effects.getLoadPresetScreener */.Sz.getLoadPresetScreener({
            presetId: presetId,
            type: type
        }));
        // TODO: Remove this lines after layout feature has been implemented
        return function() {
            dispatch(// @ts-ignore
            Valuation_slice/* default.actions.setCurrentScreenerData */.ZP.actions.setCurrentScreenerData({
                isDataLoaded: false,
                shouldUpdate: true
            }));
        };
    }, [
        dispatch
    ]);
    // to set screener title
    (0,react.useEffect)(function() {
        var isLoading = getLoadPresetScreener.isLoading, data = getLoadPresetScreener.data;
        var screenerName = data.screen_name;
        if (!isLoading) {
            setScreenerTitle(screenerName);
        }
    }, [
        getLoadPresetScreener,
        setScreenerTitle
    ]);
    // render ListScreener
    if (isHumbergerScreener) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_ListScreener, {
            dataScreenerCustom: dataScreenerCustom,
            handleOnClickDetailPreset: handleOnClickDetailPreset
        });
    }
    // render PresetScreener
    if (isPresetScreener) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_PresetScreener, {
            handlePresetScreener: handlePresetScreener,
            dataPresetScreener: dataPresetScreener,
            handleOnClickDetailPreset: handleOnClickDetailPreset,
            maxAutocompleteHeight: maxAutocompleteHeight
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_ListTableScreener, {});
};
/* harmony default export */ var ScreenerWidget_ScreenerContent = (ScreenerContent);

// EXTERNAL MODULE: ./src/assets/base64icon/index.js
var base64icon = __webpack_require__(54392);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Valuation/index.tsx













var Valuation_Flex = ui/* Common.Flex */.Gn.Flex, IconBase64 = ui/* Common.IconBase64 */.Gn.IconBase64;
function Valuation(param) {
    var isPro = param.isPro, isProScreener = param.isProScreener;
    var ref;
    var getValuationTemplateLoad = (0,es/* useSelector */.v9)(Valuation_slice/* selectors */.wl).getValuationTemplateLoad;
    var valuationData = getValuationTemplateLoad.data, isLoading = getValuationTemplateLoad.isLoading;
    var ref1 = (0,react.useState)(false), isHumbergerValuation = ref1[0], setHumbergerValuation = ref1[1];
    var ref2 = (0,react.useState)(false), isHumbergerScreener = ref2[0], setHumbergerScreener = ref2[1];
    var ref3 = (0,react.useState)(false), isPresetScreener = ref3[0], setPresetScreener = ref3[1];
    var ref4 = (0,react.useState)(false), isUpdateMode = ref4[0], setUpdateMode = ref4[1];
    var ref5 = (0,react.useState)(false), isShowResultSection = ref5[0], setShowResultSection = ref5[1];
    var ref6 = (0,react.useState)("Screener Title"), screenerTitle = ref6[0], setScreenerTitle = ref6[1];
    var ref7 = (0,react.useState)(0), resizeableHeight = ref7[0], setResizeableHeight = ref7[1];
    var ref8 = (0,react.useState)(0), windowHeight = ref8[0], setWindowHeight = ref8[1];
    // hamburger valuation
    var handleSwitchHumbergerValuation = function() {
        if (isUpdateMode) {
            setUpdateMode(false);
        }
        if (isShowResultSection) {
            setShowResultSection(false);
        }
        setHumbergerValuation(!isHumbergerValuation);
    };
    // hamburger screener
    var handleSwitchHumbergerScreener = function() {
        setPresetScreener(false);
        setHumbergerScreener(!isHumbergerScreener);
    };
    // preset screener
    var handlePresetScreener = function() {
        setHumbergerScreener(false);
        setPresetScreener(!isPresetScreener);
    };
    // off preset and hamburgrer screener
    var handleOffScreenerAndHamburger = function() {
        setHumbergerScreener(false);
        setPresetScreener(false);
    };
    // isPro 1: pro, 0: not pro
    var checkIsProUser = function() {
        return isPro;
    };
    var valuationTitle = isUpdateMode && ((ref = valuationData.valuation) === null || ref === void 0 ? void 0 : ref.name) ? valuationData.valuation.name : "Valuation Tool";
    (0,react.useEffect)(function() {
        var resizeable = document.getElementsByClassName("valuation-top");
        if (resizeable.length) {
            setResizeableHeight(resizeable[0].clientHeight);
        }
        setWindowHeight(window.innerHeight);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box, {
                className: "valuation-top",
                defaultSize: {
                    height: "50%",
                    width: "100%"
                },
                maxHeight: windowHeight - 40,
                minHeight: 50,
                onResizeStop: function(e, direction, ref, d) {
                    var h = resizeableHeight + d.height;
                    setResizeableHeight(h);
                },
                style: {
                    zIndex: 105
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Valuation_Header, {
                        title: valuationTitle,
                        isLoading: isLoading,
                        children: checkIsProUser() && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* HumbergerButton */.xw, {
                            active: isHumbergerValuation,
                            onClick: handleSwitchHumbergerValuation
                        })
                    }),
                    checkIsProUser() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ValuationWidget_ValuationContent, {
                        isHumbergerValuation: isHumbergerValuation,
                        handleSwitchHumbergerValuation: handleSwitchHumbergerValuation,
                        isUpdateMode: isUpdateMode,
                        setUpdateMode: setUpdateMode,
                        isShowResultSection: isShowResultSection,
                        setShowResultSection: setShowResultSection
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                        height: "45vh",
                        source: analytics/* SideWidgetAnalytics.VALUATION */.Lb.VALUATION
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    height: "calc(100vh - ".concat(resizeableHeight, "px)"),
                    position: "relative",
                    zIndex: 106
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Valuation_Header, {
                        title: screenerTitle,
                        children: isProScreener && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Valuation_Flex, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBase64, {
                                    icon: base64icon/* adjustIcon */.kn,
                                    iconSize: "20px",
                                    margin: "10px",
                                    onClick: handlePresetScreener
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* HumbergerButton */.xw, {
                                    active: isHumbergerScreener,
                                    onClick: handleSwitchHumbergerScreener
                                })
                            ]
                        })
                    }),
                    isProScreener ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenerWidget_ScreenerContent, {
                        isHumbergerScreener: isHumbergerScreener,
                        isPresetScreener: isPresetScreener,
                        handlePresetScreener: handlePresetScreener,
                        handleOffScreenerAndHamburger: handleOffScreenerAndHamburger,
                        setScreenerTitle: setScreenerTitle,
                        maxAutocompleteHeight: "calc(100vh - ".concat(resizeableHeight, "px - 150px)")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Widget/* default */.Z, {
                        height: "45vh",
                        source: analytics/* SideWidgetAnalytics.SCREENER */.Lb.SCREENER
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var SideWidget_Valuation = (Valuation);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/slice.ts
var Watchlist_slice = __webpack_require__(78626);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/styled.js

function Watchlist_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ";\n    "
    ]);
    Watchlist_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Watchlist_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 40px;\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n\n  & .ant-select-dropdown {\n    top: 4px !important;\n    z-index: 1;\n  }\n"
    ]);
    Watchlist_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        width: 60% !important;\n        padding: 4px 11px;\n        border: 1px solid ",
        ";\n        position: absolute;\n        right: 10px;\n        bottom: 5px;\n      "
    ]);
    Watchlist_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      position: absolute;\n      width: 0px !important;\n      padding: 0;\n      border: none;\n      right: 58px;\n      bottom: 5px;\n      background: ",
        ";\n    "
    ]);
    Watchlist_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition : 0.5s ease;\n  ",
        "\n"
    ]);
    Watchlist_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  cursor: pointer;\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    Watchlist_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 2px;\n"
    ]);
    Watchlist_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    Watchlist_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    Watchlist_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Watchlist_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    Watchlist_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-header {\n    border-bottom: none;\n  }\n\n  .ant-input-suffix {\n    color: #cbcbcb;\n  }\n"
    ]);
    styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-table {\n    table {\n      padding: 0 12px;\n      width: 100%;\n    }\n\n    .ant-table-thead {\n      > tr {\n        > th:first-child {\n          width: 25%;\n          max-width: 25%;\n        }\n\n        > th:nth-child(2) {\n          width: 30%;\n        }\n\n        > th:last-child {\n          width: 45%;\n        }\n      }\n    }\n\n    .ant-table-tbody {\n      > tr {\n        position: static;\n        cursor: pointer;\n\n        > td:first-child {\n          width: 25%;\n          max-width: 25%;\n        }\n\n        > td:nth-child(2) {\n          text-align: right;\n          width: 30%;\n        }\n\n        > td:last-child {\n          text-align: right;\n          width: 45%;\n        }\n      }\n\n      > tr.selected-row {\n        background: ",
        ";\n      }\n    }\n\n    .ant-table-cell-ellipsis {\n      overflow: unset;\n    }\n  }\n"
    ]);
    styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateX(-12px);\n    opacity: 0;\n    width: calc(",
        " + 36px);\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n    width: ",
        ";\n  }\n"
    ]);
    styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: 0.2s ease-out forwards ",
        ";\n  background: ",
        ";\n  height: 31px;\n  overflow: hidden;\n  position: absolute;\n  text-overflow: ellipsis;\n  top: -1px;\n  white-space: nowrap;\n  z-index: 1;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background: ",
        ";\n    border-color: ",
        ";\n    color: ",
        ";\n    :hover,\n    :focus,\n    :active {\n      background: ",
        ";\n      border-color: ",
        ";\n    }\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-radius: ",
        ";\n    height: ",
        ";\n    margin: ",
        ";\n    padding: ",
        ";\n    \n    ::after{\n      content: unset;\n    }\n    \n    ",
        ";\n    border : ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}



var Watchlist_styled_Flex = ui/* Common.Flex */.Gn.Flex, InputDefault = ui/* Common.Input */.Gn.Input, Watchlist_styled_Text = ui/* Common.Text */.Gn.Text;
var HumbergerButtonDefault = ui/* Widget.HumbergerButton */.$L.HumbergerButton, WidgetModal = ui/* Widget.Modal */.$L.Modal, Watchlist_styled_Table = ui/* Widget.Table */.$L.Table;
var Watchlist_styled_cellType = {
    up: ui/* color.primary */.$_.primary,
    down: ui/* color.sunsetOrange */.$_.sunsetOrange,
    neutral: ui/* color.suvaGrey */.$_.suvaGrey,
    default: ui/* color.highempahis */.$_.highempahis
};
var HamburgerButton = (0,styled_components_browser_esm["default"])(HumbergerButtonDefault).withConfig({
    componentId: "sc-d1333e62-0"
})(Watchlist_styled_templateObject1(), function(param) {
    var active = param.active;
    return active && (0,styled_components_browser_esm.css)(Watchlist_styled_templateObject(), ui/* color.light */.$_.light, ui/* color.gainsboro */.$_.gainsboro);
});
var Watchlist_styled_HeaderContainer = (0,styled_components_browser_esm["default"])(Watchlist_styled_Flex).attrs({
    align: "center",
    pl: "10px"
}).withConfig({
    componentId: "sc-d1333e62-1"
})(Watchlist_styled_templateObject2(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro);
var Watchlist_styled_Input = (0,styled_components_browser_esm["default"])(InputDefault).withConfig({
    shouldForwardProp: function(props) {
        return ![
            "active"
        ].includes(props);
    }
}).attrs(function(props) {
    return {
        active: props.active
    };
}).withConfig({
    componentId: "sc-d1333e62-2"
})(Watchlist_styled_templateObject5(), function(param) {
    var active = param.active;
    if (active) {
        return (0,styled_components_browser_esm.css)(Watchlist_styled_templateObject3(), ui/* color.gainsboro */.$_.gainsboro);
    }
    return (0,styled_components_browser_esm.css)(Watchlist_styled_templateObject4(), ui/* color.gainsboro */.$_.gainsboro);
});
var styled_ListContainer = (0,styled_components_browser_esm["default"])(Watchlist_styled_Flex).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-d1333e62-3"
})(Watchlist_styled_templateObject6(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.aliceBlue */.$_.aliceBlue);
var Watchlist_styled_Tag = (0,styled_components_browser_esm["default"])(Watchlist_styled_Text).attrs({
    color: ui/* color.light */.$_.light,
    weight: "bold",
    px: "3px"
}).withConfig({
    componentId: "sc-d1333e62-4"
})(Watchlist_styled_templateObject7(), ui/* color.dimgray */.$_.dimgray);
var Watchlist_styled_Td = (0,styled_components_browser_esm["default"])(Watchlist_styled_Text).attrs(function(props) {
    return {
        height: props.height || "30px",
        padding: props.padding || "0 10px",
        size: props.size || "12.5px",
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-d1333e62-5"
})(Watchlist_styled_templateObject9(), function(param) {
    var type = param.type;
    return (0,styled_components_browser_esm.css)(Watchlist_styled_templateObject8(), Watchlist_styled_cellType[type]);
});
var Watchlist_styled_Th = (0,styled_components_browser_esm["default"])(Watchlist_styled_Td).attrs({
    family: "bold",
    size: "11px"
}).withConfig({
    componentId: "sc-d1333e62-6"
})(Watchlist_styled_templateObject10(), ui/* color.light */.$_.light);
var Watchlist_styled_Modal = (0,styled_components_browser_esm["default"])(WidgetModal).withConfig({
    componentId: "sc-d1333e62-7"
})(styled_templateObject11());
var CompanyWatchlistTable = (0,styled_components_browser_esm["default"])(Watchlist_styled_Table).withConfig({
    componentId: "sc-d1333e62-8"
})(styled_templateObject12(), ui/* color.whisper */.$_.whisper);
var DELETE_OPTION_WIDTH = "301px";
var deleteButtonAnimation = (0,styled_components_browser_esm.keyframes)(styled_templateObject13(), DELETE_OPTION_WIDTH, DELETE_OPTION_WIDTH);
var DeleteOptionWrapper = (0,styled_components_browser_esm["default"])(Watchlist_styled_Flex).attrs(function(props) {
    return {
        margin: "0 auto",
        align: "center",
        pl: "5px",
        width: props.width || DELETE_OPTION_WIDTH,
        maxWidth: props.width || DELETE_OPTION_WIDTH
    };
}).withConfig({
    componentId: "sc-d1333e62-9"
})(_templateObject14(), deleteButtonAnimation, ui/* color.gainsboro */.$_.gainsboro);
var buttonType = {
    sunsetOrange: (0,styled_components_browser_esm.css)(_templateObject15(), ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.light */.$_.light, ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.sunsetOrange */.$_.sunsetOrange),
    highempahis: (0,styled_components_browser_esm.css)(_templateObject16(), ui/* color.highempahis */.$_.highempahis, ui/* color.highempahis */.$_.highempahis, ui/* color.light */.$_.light, ui/* color.highempahis */.$_.highempahis, ui/* color.highempahis */.$_.highempahis)
};
var ButtonWidget = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "round",
            "active",
            "borderLess"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        height: props.height || "auto",
        type: props.type || "default",
        round: props.round,
        active: props.active,
        borderLess: props.borderLess,
        margin: props.margin || "0 !important",
        padding: props.padding || "4px 15px"
    };
}).withConfig({
    componentId: "sc-d1333e62-10"
})(_templateObject17(), function(param) {
    var round = param.round;
    return round ? "2px" : "0px";
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var padding = param.padding;
    return padding;
}, function(param) {
    var type = param.type;
    return buttonType[type];
}, function(param) {
    var borderLess = param.borderLess;
    return borderLess && "none";
});


// EXTERNAL MODULE: ./node_modules/next/dist/shared/lib/styled-jsx.js
var styled_jsx = __webpack_require__(79547);
var styled_jsx_default = /*#__PURE__*/__webpack_require__.n(styled_jsx);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Iconplus.tsx



var Iconplus_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Iconplus_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var Iconplus = function(param) {
    var isActive = param.isActive, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Iconplus_IconWrapper, {
        onClick: onClick,
        padding: "12px 0",
        className: "icon-wrapper",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconplus_Iconmoon, {
                className: "icon-compose_plus",
                size: "16px",
                color: ui/* color.highempahis */.$_.highempahis,
                hoverColor: ui/* color.highempahis */.$_.highempahis
            }),
            (0,jsx_runtime.jsx)((styled_jsx_default()), {
                id: "1a2270a6bfa78c20",
                dynamic: [
                    isActive ? "flex" : "none"
                ],
                children: ".icon-wrapper.__jsx-style-dynamic-selector{display:".concat(isActive ? "flex" : "none", "}")
            })
        ]
    });
};
/* harmony default export */ var Watchlist_Iconplus = (Iconplus);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/slice.ts
var ListWatchlist_slice = __webpack_require__(31390);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Header.tsx












var Header_Flex = ui/* Common.Flex */.Gn.Flex, Watchlist_Header_Text = ui/* Common.Text */.Gn.Text;
var Header_AutoSuggestion = ui/* Widget.AutoSuggestion */.$L.AutoSuggestion;
function Watchlist_Header_Header(param) {
    var isAddSymbol = param.isAddSymbol, setAddSymbol = param.setAddSymbol;
    // @ts-ignore
    var watchlist_id = auth/* default.getUserAccess */.Z.getUserAccess().watchlist_id;
    var ref = (0,es/* useSelector */.v9)(Watchlist_slice/* selectors */.wl), showList = ref.showList, suggestions = ref.suggestions, watchlistId = ref.watchlistId;
    var ref1 = (0,es/* useSelector */.v9)(ListWatchlist_slice/* selectors */.wl), savedWatchlist = ref1.saved;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,react.useState)(false), isSearchActive = ref2[0], setSearchActive = ref2[1];
    var ref3 = (0,react.useState)(0), timeInterval = ref3[0], setTimeInterval = ref3[1];
    var inputContainerRef = (0,react.useRef)(null);
    var inputRef = (0,react.useRef)(null);
    var ref4 = (0,react.useState)(""), inputVal = ref4[0], setInputVal = ref4[1];
    var handleOutsideClick = function(e) {
        var ref;
        if (inputContainerRef.current && !((ref = inputContainerRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            setSearchActive(false);
            setAddSymbol(false);
        }
    };
    var handleSuggestionClick = function(companyid) {
        setInputVal("");
        dispatch(Watchlist_slice/* effects.saveCompanyToWatchlist */.Sz.saveCompanyToWatchlist({
            watchlistId: watchlistId,
            companyid: companyid
        }));
    };
    var handleSearchCompany = function(keyword) {
        if (keyword.length > 1) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            var timeout = window.setTimeout(function() {
                dispatch(Watchlist_slice/* effects.getCompanySuggestions */.Sz.getCompanySuggestions({
                    keyword: keyword,
                    page: 1,
                    watchlist_id: watchlist_id
                }));
            }, 500);
            setTimeInterval(timeout);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isAddSymbol && !isSearchActive) {
            setSearchActive(true);
        }
    }, [
        isSearchActive,
        isAddSymbol
    ]);
    var options = suggestions.map(function(param) {
        var id = param.id, name = param.name, desc = param.desc;
        return {
            value: id,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_styled_Tag, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_Header_Text, {
                        pl: "10px",
                        children: desc
                    })
                ]
            })
        };
    });
    var handleWatchlistSwitch = function() {
        return dispatch(Watchlist_slice/* default.actions.toggleViewType */.ZP.actions.toggleViewType({
            listType: showList === "company" ? "saved" : "company"
        }));
    };
    var onIconplusClick = function() {
        setSearchActive(true);
        inputRef.current.focus();
    };
    var getCurrentWatchlist = function() {
        if (watchlistId) {
            return savedWatchlist.find(function(item) {
                return item.watchlist_id === watchlistId;
            });
        }
        return null;
    };
    var handlePressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var val, search, _payload, error, searchData, _searchData, company;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        val = e;
                        if (typeof e !== "string") {
                            val = e.target.value;
                        }
                        if (!(val.length > 1)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 5;
                        return dispatch(Watchlist_slice/* effects.getCompanySuggestions */.Sz.getCompanySuggestions({
                            keyword: val,
                            page: 1,
                            watchlist_id: watchlist_id
                        }));
                    case 5:
                        search = _ctx.sent;
                        _payload = search.payload, error = _payload.error, searchData = _payload.data;
                        if (!error && searchData.length > 0) {
                            _searchData = (0,_sliced_to_array/* default */.Z)(searchData, 1), company = _searchData[0];
                            handleSuggestionClick(company.id);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePressEnter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var currentWatchlist = getCurrentWatchlist();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Watchlist_styled_HeaderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_Header_Text, {
                size: "16px",
                family: "bold",
                ellipsis: true,
                children: (currentWatchlist === null || currentWatchlist === void 0 ? void 0 : currentWatchlist.is_default) || !(currentWatchlist === null || currentWatchlist === void 0 ? void 0 : currentWatchlist.name) ? "All Watchlist" : currentWatchlist.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                align: "center",
                justify: "flex-end",
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                        ref: inputContainerRef,
                        align: "center",
                        pr: "10px",
                        style: {
                            display: showList === "saved" ? "none" : "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_Iconplus, {
                                isActive: !isSearchActive,
                                onClick: onIconplusClick
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_AutoSuggestion, {
                                options: options,
                                value: inputVal,
                                onChange: setInputVal,
                                style: {
                                    position: "absolute",
                                    left: 0,
                                    top: "40px"
                                },
                                onSearch: handleSearchCompany,
                                onSelect: handleSuggestionClick,
                                getPopupContainer: function(trigger) {
                                    return trigger.parentElement;
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_styled_Input, {
                                    ref: inputRef,
                                    active: isSearchActive,
                                    placeholder: "Search for symbol",
                                    height: "30px",
                                    onPressEnter: handlePressEnter
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HamburgerButton, {
                        style: {
                            display: isSearchActive ? "none" : "block"
                        },
                        active: showList === "saved",
                        onClick: handleWatchlistSwitch
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Watchlist_Header = (Watchlist_Header_Header);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/CreateModal.tsx








var CreateModal_Text = ui/* Common.Text */.Gn.Text, CreateModal_Input = ui/* Common.Input */.Gn.Input, CreateModal_Flex = ui/* Common.Flex */.Gn.Flex;
var CreateModal_Button = ui/* Widget.Button */.$L.Button;
var actions = ListWatchlist_slice/* default.actions */.ZP.actions;
var Title = /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Text, {
    size: "16px",
    align: "center",
    height: "40px",
    family: "bold",
    children: "Create New Watchlist"
});
function CreateModal() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var isCreateModalVisible = (0,es/* useSelector */.v9)(ListWatchlist_slice/* selectors */.wl).isCreateModalVisible;
    var ref = (0,react.useState)(""), watchlistName = ref[0], setWatchlistName = ref[1];
    var handleOnChange = function(e) {
        setWatchlistName(e.target.value);
    };
    var handleSubmitWatchlistName = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e === null || e === void 0 ? void 0 : e.preventDefault();
                        if (!(watchlistName.length > 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        dispatch(actions.toggleCreateModal({}));
                        _ctx.next = 5;
                        return dispatch(ListWatchlist_slice/* effects.createNewWatchlist */.Sz.createNewWatchlist({
                            name: watchlistName
                        }));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitWatchlistName(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleModalCancel = function() {
        dispatch(actions.toggleCreateModal({}));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Watchlist_styled_Modal, {
        title: Title,
        visible: isCreateModalVisible,
        onCancel: handleModalCancel,
        centered: true,
        footer: null,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmitWatchlistName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Text, {
                        as: "label",
                        htmlFor: "wl-name",
                        mb: "8px",
                        style: {
                            display: "block"
                        },
                        children: "Watchlist Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Input, {
                        id: "wl-name",
                        placeholder: "Type Watchlist Name...",
                        height: "40px",
                        width: "100%",
                        onChange: handleOnChange,
                        value: watchlistName,
                        suffix: watchlistName.length + "/25",
                        maxLength: 25
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "submit",
                        style: {
                            display: "none"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CreateModal_Flex, {
                justify: "flex-end",
                mt: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Button, {
                        height: "40px",
                        borderLess: true,
                        onClick: handleModalCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Text, {
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Button, {
                        type: "primary",
                        height: "40px",
                        width: "80px",
                        onClick: handleSubmitWatchlistName,
                        round: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateModal_Text, {
                            color: ui/* color.light */.$_.light,
                            align: "center",
                            children: "Create Watchlist"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ListWatchlist_CreateModal = (CreateModal);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/DeleteModal.tsx











var DeleteModal_Text = ui/* Common.Text */.Gn.Text, DeleteModal_Flex = ui/* Common.Flex */.Gn.Flex;
var DeleteModal_Button = ui/* Widget.Button */.$L.Button;
var DeleteModal_actions = ListWatchlist_slice/* default.actions */.ZP.actions;
function DeleteModal() {
    var ref = (0,es/* useSelector */.v9)(ListWatchlist_slice/* selectors */.wl), isDeleteModalVisible = ref.isDeleteModalVisible, watchlistTobeDeleted = ref.watchlistTobeDeleted, saved = ref.saved;
    var watchlistId = (0,es/* useSelector */.v9)(Watchlist_slice/* wlIdSelector */.ag);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var handleDeleteClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var del, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return dispatch(ListWatchlist_slice/* effects.deleteSelectedWatchlist */.Sz.deleteSelectedWatchlist({
                            watchlistid: watchlistTobeDeleted,
                            activeWatchlistId: watchlistId
                        }));
                    case 3:
                        del = _ctx.sent;
                        data = del.payload.data;
                        if (data) {
                            setLoading(false);
                            (0,AlertErrorMessage/* default */.Z)("Watchlist has been deleted", successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeleteClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var Title = /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal_Text, {
        size: "16px",
        align: "center",
        height: "40px",
        family: "bold",
        children: "Delete Watchlist"
    });
    var handleModalCancel = function() {
        return dispatch(DeleteModal_actions.toggleDeleteModal({}));
    };
    var activeWatchlist = saved.find(function(item) {
        return item.watchlist_id === watchlistTobeDeleted;
    });
    var watchlistName = (activeWatchlist === null || activeWatchlist === void 0 ? void 0 : activeWatchlist.name) || "-";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Watchlist_styled_Modal, {
        title: Title,
        visible: isDeleteModalVisible,
        centered: true,
        footer: null,
        onCancel: handleModalCancel,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteModal_Text, {
                children: [
                    "Confirm delete ",
                    watchlistName,
                    " ?"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteModal_Flex, {
                justify: "flex-end",
                mt: "15px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal_Button, {
                        height: "40px",
                        onClick: handleModalCancel,
                        borderLess: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal_Text, {
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal_Button, {
                        type: "primary",
                        height: "40px",
                        width: "80px",
                        onClick: handleDeleteClick,
                        loading: loading,
                        round: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteModal_Text, {
                            color: ui/* color.light */.$_.light,
                            children: "Delete"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var ListWatchlist_DeleteModal = (DeleteModal);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/ListCloseIcon.tsx




var ListWatchlist_ListCloseIcon_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, ListCloseIcon_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var ListCloseIcon_actions = ListWatchlist_slice/* default.actions */.ZP.actions;
var ListCloseIcon_ListCloseIcon = function(param) {
    var _id = param.id, id = _id === void 0 ? "" : _id;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleCloseClick = function() {
        dispatch(ListCloseIcon_actions.setDeleteId({
            id: id
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListCloseIcon_IconWrapper, {
        padding: "0 5px",
        onClick: handleCloseClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_ListCloseIcon_Iconmoon, {
            className: "icon-widget_close",
            color: ui/* color.sunsetOrange */.$_.sunsetOrange,
            hoverColor: ui/* color.sunsetOrange */.$_.sunsetOrange,
            size: "14px",
            weight: "bold"
        })
    });
};
/* harmony default export */ var ListWatchlist_ListCloseIcon = (ListCloseIcon_ListCloseIcon);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/WatchlistItem.tsx





var WatchlistItem_Text = ui/* Common.Text */.Gn.Text;
function WatchlistItem(param) {
    var id = param.id, index = param.index, name = param.name, hoveredRow = param.hoveredRow, onHover = param.onHover, onClick = param.onClick;
    var handleItemClick = function() {
        onClick(id);
    };
    var handleMouseEnter = function() {
        onHover(index);
    };
    var handleMouseLeave = function() {
        onHover(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_ListContainer, {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WatchlistItem_Text, {
                size: "12px",
                height: "30px",
                style: {
                    flex: 1
                },
                onClick: handleItemClick,
                children: name
            }),
            hoveredRow === index && index !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_ListCloseIcon, {
                id: id
            })
        ]
    });
}
/* harmony default export */ var ListWatchlist_WatchlistItem = (WatchlistItem);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/ListWatchlist/index.tsx









var ListWatchlist_Text = ui/* Common.Text */.Gn.Text;
var ListWatchlist_Button = ui/* Widget.Button */.$L.Button;
var ListWatchlist_actions = ListWatchlist_slice/* default.actions */.ZP.actions;
var allWatchlistActions = Watchlist_slice/* default.actions */.ZP.actions;
function ListWatchlist(param) {
    var watchlistId = param.watchlistId;
    var dispatch = (0,es/* useDispatch */.I0)();
    var saved = (0,es/* useSelector */.v9)(ListWatchlist_slice/* selectors */.wl).saved;
    var ref = (0,react.useState)(null), hoveredRow = ref[0], setHoveredRow = ref[1];
    var handleRowHover = function(hoveredRowIndex) {
        setHoveredRow(hoveredRowIndex);
    };
    var handleWatchlistClick = function(id) {
        dispatch(allWatchlistActions.setCurrentwatchlistId({
            watchlistId: id
        }));
        dispatch(allWatchlistActions.toggleViewType({
            listType: "company"
        }));
    };
    (0,react.useEffect)(function() {
        dispatch(ListWatchlist_slice/* effects.getSavedWatchlist */.Sz.getSavedWatchlist());
    }, [
        dispatch
    ]);
    var handleCreateNewClick = function() {
        return dispatch(ListWatchlist_actions.toggleCreateModal({}));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            height: "calc(100% - 40px)",
            overflowY: "auto",
            padding: "19px 12px 0",
            backgroundColor: ui/* color.light */.$_.light
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_Button, {
                block: true,
                round: true,
                height: "35px",
                margin: "0 0 12px",
                type: "defaultHoverable",
                onClick: handleCreateNewClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_Text, {
                    color: "inherit",
                    align: "center",
                    children: "Create New Watchlist"
                })
            }),
            saved.map(function(param, index) {
                var name = param.name, id = param.watchlist_id, isDefault = param.is_default;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_WatchlistItem, {
                    id: id,
                    index: index,
                    name: isDefault ? "All Watchlist" : name,
                    hoveredRow: hoveredRow,
                    onHover: handleRowHover,
                    onClick: handleWatchlistClick
                }, "watchlist-".concat(id));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_CreateModal, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWatchlist_DeleteModal, {})
        ]
    });
}
/* harmony default export */ var Watchlist_ListWatchlist = (ListWatchlist);

// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookSender.ts
var useOrderbookSender = __webpack_require__(64579);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePriceSender.ts
var useLivePriceSender = __webpack_require__(35320);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.types.ts
var orderbook_store_types = __webpack_require__(52781);
// EXTERNAL MODULE: ./src/global/Datafeed/useOrderbookIEPIEV.ts
var useOrderbookIEPIEV = __webpack_require__(28398);
// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/store.ts
var Orderbook_store = __webpack_require__(85440);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/TableSeparator.tsx
var TableSeparator = __webpack_require__(98822);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/TableBestBidOffer.tsx
var TableBestBidOffer = __webpack_require__(74438);
// EXTERNAL MODULE: ./src/global/Datafeed/useBestBidOffer.ts
var useBestBidOffer = __webpack_require__(11562);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/hooks/useBestBidData.ts
var useBestBidData = __webpack_require__(88259);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/utils.tsx + 1 modules
var utils = __webpack_require__(4680);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/styled.ts

function Orderbook_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n  display: block;\n  padding: 10px;\n\n  > span {\n    font-variant: normal;\n    -webkit-font-feature-settings: normal;\n    font-feature-settings: normal;\n    line-height: 1.15;\n  }\n"
    ]);
    Orderbook_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-left: 15px;\n      "
    ]);
    Orderbook_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-right: 15px;\n      "
    ]);
    Orderbook_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    Orderbook_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-left: 15px;\n      "
    ]);
    Orderbook_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-right: 15px;\n      "
    ]);
    Orderbook_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-top: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  font-weight: normal;\n\n  ",
        "\n"
    ]);
    Orderbook_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    Orderbook_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-top: 1px solid ",
        ";\n"
    ]);
    Orderbook_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 40px;\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n\n  & .ant-select-dropdown {\n    top: 4px !important;\n  }\n"
    ]);
    Orderbook_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          padding: 5px;\n          border: 1px solid ",
        ";\n        "
    ]);
    Orderbook_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          padding: 0;\n          border: none;\n        "
    ]);
    Orderbook_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 4px;\n  left: 0;\n  transition: 0.3s ease;\n  ",
        "\n"
    ]);
    Orderbook_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Orderbook_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 2px;\n  font-size: 12px;\n"
    ]);
    Orderbook_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  cursor: text;\n"
    ]);
    styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styled_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      color: ",
        ";\n    "
    ]);
    styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styled_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  span {\n    color: black;\n  }\n\n  ",
        "\n"
    ]);
    styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styled_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 10px;\n\n  .ant-table-thead {\n    th {\n      width: calc((100% - 20px) / 4);\n    }\n  }\n\n  .ant-table-tbody {\n    > tr:hover {\n      > td {\n        background: unset;\n      }\n    }\n\n    td {\n      width: calc((100% - 20px) / 4);\n      white-space: nowrap;\n    }\n\n    tr:first-child {\n      > td p {\n        padding-top: 10px;\n      }\n    }\n\n    tr:last-child {\n      > td p {\n        padding-bottom: 10px;\n      }\n    }\n  }\n"
    ]);
    styled_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-table-tbody {\n    > tr:hover {\n      > td {\n        background: unset;\n      }\n    }\n\n    td {\n      white-space: nowrap;\n    }\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  margin-left: 10px;\n  max-width: calc(100% - 74px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      padding-top: 25px;\n\n      ::before {\n        border-bottom: none;\n      }\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      ::after,\n      ::before {\n        display: none;\n      }\n    "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  user-select: none;\n  position: relative;\n\n  table {\n    margin: auto;\n    position: relative;\n    table-layout: fixed;\n    width: 100%;\n    z-index: 1;\n  }\n\n  tbody {\n    display: block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 255px;\n  }\n\n  thead, tbody tr, tfoot {\n    display: table;\n    width: 329px;\n    table-layout: fixed;\n  }\n\n  thead {\n    & th.title {\n      height: 26px !important;\n      line-height: 16px;\n      font-weight: normal;\n      text-align: center;\n      padding: 5px 0px !important;\n    }\n  }\n\n  tbody {\n    > tr:hover {\n      > td {\n        background: unset;\n      }\n    }\n    \n    td {\n      text-align: center;\n      padding: 5px 0px;\n      white-space: nowrap;\n    }\n\n    td:first-child, td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2), td:nth-child(5) {\n      width: 66.5px;\n    }\n\n    td:nth-child(3), td:nth-child(4) {\n      width: 50px;\n    }\n  }\n\n  tfoot {\n    background: ",
        ";\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n\n    > tr {\n      > td {\n        border-bottom: none;\n        height: 26px;\n        line-height: 16px;\n        font-weight: normal;\n        text-align: center;\n        padding: 5px 0px;\n      }\n    }\n\n    td:first-child, td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2), td:nth-child(5) {\n      width: 66.5px;\n    }\n  }\n\n  tr.blurred {\n    opacity: 0.4;\n  }\n\n  .highlited-bid::before,\n  .highlited-off::before {\n    position: absolute;\n    content: '';\n    width: 200%;\n    height: 100%;\n  }\n\n  .highlited-bid::before {\n    background: ",
        ";\n  }\n\n  td:nth-child(2):before {\n    left: -50px;\n  }\n\n  .highlited-off::before {\n    background: ",
        ";\n  }\n\n  td:nth-child(4):before {\n    right: -5px;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  position: relative;\n  z-index: 99;\n\n  table.table-live-price {\n    td:first-child {\n      padding-left: 0px;\n      text-align: left;\n      width: 30px;\n    }\n\n    td:nth-child(even) {\n      padding-right: 17px;\n\n      &.two-column {\n        padding-right: 18px;\n      }\n    }\n\n    td:nth-child(2) {\n      width: 68.5px;\n\n      &.two-column {\n        padding-left: 8px;\n        width: 126.5px;\n      }\n    }\n\n    td:nth-child(3) {\n      padding-left: 17px;\n      text-align: left;\n      width: 47px;\n\n      &.two-column {\n        padding-left: 18px;\n        padding-right: 8px;\n        width: 56px;\n      }\n    }\n\n    td:nth-child(4) {\n      width: 69px;\n    }\n\n    td:nth-child(5) {\n      padding-left: 17px;\n      text-align: left;\n      width: 47px;\n    }\n\n    td:last-child {\n      padding-right: 0px; \n      width: 51.5px;\n    }\n  }\n\n  thead th.title {\n    height: 25px !important;\n    padding: 5px 0px !important;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}


var Orderbook_styled_Text = ui/* Common.Text */.Gn.Text, Orderbook_styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_InputDefault = ui/* Common.Input */.Gn.Input;
var Orderbook_styled_Table = ui/* Widget.Table */.$L.Table;
var hexOpacity = ui/* utils.hexOpacity */.P6.hexOpacity;
var colorTextByType = {
    up: ui/* color.primary */.$_.primary,
    down: ui/* color.sunsetOrange */.$_.sunsetOrange,
    notchange: ui/* color.highball */.$_.highball,
    neutral: ui/* color.suvaGrey */.$_.suvaGrey
};
var OrderbookIndexSummary = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b7be95a5-0"
})(Orderbook_styled_templateObject(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light);
var OrderbookText = (0,styled_components_browser_esm["default"])(Orderbook_styled_Text).attrs(function(props) {
    return {
        size: "12.5px",
        align: "right",
        padding: props.padding || "4px 5px",
        height: "1.15",
        type: props.type
    };
}).withConfig({
    componentId: "sc-b7be95a5-1"
})(Orderbook_styled_templateObject3(), function(param) {
    var type = param.type;
    return colorTextByType[type];
}, function(param) {
    var _first = param.first, first = _first === void 0 ? false : _first, _last = param.last, last = _last === void 0 ? false : _last;
    if (first) {
        return (0,styled_components_browser_esm.css)(Orderbook_styled_templateObject1());
    }
    if (last) {
        return (0,styled_components_browser_esm.css)(Orderbook_styled_templateObject2());
    }
    return "";
});
var OrderbookTitle = (0,styled_components_browser_esm["default"])(OrderbookText).attrs({
    family: "bold"
}).withConfig({
    componentId: "sc-b7be95a5-2"
})(Orderbook_styled_templateObject6(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro, function(param) {
    var _first = param.first, first = _first === void 0 ? false : _first, _last = param.last, last = _last === void 0 ? false : _last;
    if (first) {
        return (0,styled_components_browser_esm.css)(Orderbook_styled_templateObject4());
    }
    if (last) {
        return (0,styled_components_browser_esm.css)(Orderbook_styled_templateObject5());
    }
    return "";
});
var OrderbookTextHover = (0,styled_components_browser_esm["default"])(OrderbookText).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "bid"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        bid: props.bid || false
    };
}).withConfig({
    componentId: "sc-b7be95a5-3"
})(Orderbook_styled_templateObject7(), function(param) {
    var _bid = param.bid, bid = _bid === void 0 ? false : _bid;
    return bid ? ui/* color.primary30% */.$_["primary30%"] : ui/* color.sunsetOrange30% */.$_["sunsetOrange30%"];
});
var SummaryCell = (0,styled_components_browser_esm["default"])(Orderbook_styled_Text).attrs({
    size: "12.5px",
    weight: "normal",
    height: "26px",
    p: "0px 10px",
    family: "bold"
}).withConfig({
    componentId: "sc-b7be95a5-4"
})(Orderbook_styled_templateObject8(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro);
// Header
var Orderbook_styled_HeaderContainer = (0,styled_components_browser_esm["default"])(Orderbook_styled_Flex).attrs({
    align: "center",
    px: "10px"
}).withConfig({
    componentId: "sc-b7be95a5-5"
})(Orderbook_styled_templateObject9(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro);
var Orderbook_styled_Input = (0,styled_components_browser_esm["default"])(styled_InputDefault).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "active"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        height: "30px",
        active: props.active
    };
}).withConfig({
    componentId: "sc-b7be95a5-6"
})(Orderbook_styled_templateObject12(), function(param) {
    var active = param.active;
    return active ? (0,styled_components_browser_esm.css)(Orderbook_styled_templateObject10(), ui/* color.gainsboro */.$_.gainsboro) : (0,styled_components_browser_esm.css)(Orderbook_styled_templateObject11());
});
var Orderbook_styled_Tag = (0,styled_components_browser_esm["default"])(Orderbook_styled_Text).attrs({
    color: ui/* color.light */.$_.light,
    weight: "bold",
    px: "3px"
}).withConfig({
    componentId: "sc-b7be95a5-7"
})(Orderbook_styled_templateObject13(), ui/* color.dimgray */.$_.dimgray);
var SymbolSearch = (0,styled_components_browser_esm["default"])(Orderbook_styled_Text).withConfig({
    // @ts-ignore
    shouldForwardProp: function(prop) {
        return ![
            "active"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        p: "5px 10px",
        mr: "10px",
        active: props.active
    };
}).withConfig({
    componentId: "sc-b7be95a5-8"
})(styled_templateObject14(), function(param) {
    var active = param.active;
    return active ? "block" : "none";
}, ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light);
var PriceChangeText = (0,styled_components_browser_esm["default"])(Orderbook_styled_Text).attrs({
    size: "18px"
}).withConfig({
    componentId: "sc-b7be95a5-9"
})(styled_templateObject16(), function(props) {
    return props.$type && (0,styled_components_browser_esm.css)(styled_templateObject15(), colorTextByType[props.$type]);
});
var TableOrderlist = (0,styled_components_browser_esm["default"])(Orderbook_styled_Table).withConfig({
    componentId: "sc-b7be95a5-10"
})(styled_templateObject17());
var TableOHLC = (0,styled_components_browser_esm["default"])(Orderbook_styled_Table).withConfig({
    componentId: "sc-b7be95a5-11"
})(_templateObject18());
var TagDesc = (0,styled_components_browser_esm["default"])(Orderbook_styled_Text).withConfig({
    componentId: "sc-b7be95a5-12"
})(_templateObject19());
var OrderbookTableWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b7be95a5-13"
})(_templateObject22(), ui/* color.aliceBlue */.$_.aliceBlue, ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro, ui/* color.primary */.$_.primary + hexOpacity(30), ui/* color.sunsetOrange */.$_.sunsetOrange + hexOpacity(30), function(props) {
    return props.$isHidden && (0,styled_components_browser_esm.css)(_templateObject20());
}, function(props) {
    return props.$isIHSG && (0,styled_components_browser_esm.css)(_templateObject21());
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b7be95a5-14"
})(_templateObject23(), ui/* color.light */.$_.light);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/Summary.tsx







var Summary_Text = ui/* Common.Text */.Gn.Text;
var Summary = function(param) {
    var symbol = param.symbol, lastprice = param.lastprice, change = param.change, percentageChange = param.percentageChange;
    var liveprice = (0,Orderbook_store/* useOrderbookStore */.av)(function(param) {
        var liveprice = param.liveprice;
        return liveprice === null || liveprice === void 0 ? void 0 : liveprice[symbol];
    });
    var getLastPrice = function() {
        return liveprice ? numeral_default()(liveprice.lastprice).format("0,0[.]00") : numeral_default()(lastprice).format("0,0[.]00");
    };
    var getChangeValue = function() {
        return liveprice ? numeral_default()(liveprice.change).format("0") : numeral_default()(change).format("0");
    };
    var getChangePercentValue = function() {
        var result = liveprice ? numeral_default()(liveprice.percentage_change).format("0.00") + "%" : numeral_default()(percentageChange).format("0.00") + "%";
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "("
                }),
                " ",
                result,
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: ")"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderbookIndexSummary, {
        className: "orderbook-title",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Summary_Text, {
                as: "span",
                size: "24px",
                family: "bold",
                mr: "5px",
                children: getLastPrice()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceChangeText, {
                as: "div",
                $type: (0,utils/* getType */.oL)(liveprice ? liveprice.change : change),
                children: [
                    Number(getChangeValue()) > 0 && "+",
                    getChangeValue(),
                    " ",
                    getChangePercentValue()
                ]
            })
        ]
    });
};
/* harmony default export */ var Orderbook_Summary = (Summary);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookSingleReceiver.ts
var useOrderbookSingleReceiver = __webpack_require__(11113);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/TableEmpty.tsx
var TableEmpty = __webpack_require__(44127);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/TableOrderbookItemSummary.tsx


var TableOrderbookItemSummary = function(param) {
    var data = param.data, renderItemOrderbook = param.renderItemOrderbook, renderOrderbookSummary = param.renderOrderbookSummary;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                children: (0,utils/* generateColumnGroup */.km)()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                children: renderItemOrderbook(data)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("tfoot", {
                children: renderOrderbookSummary(data)
            })
        ]
    });
};
/* harmony default export */ var Orderbook_TableOrderbookItemSummary = (TableOrderbookItemSummary);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/TableBidOffer.tsx











function TableBidOffer(param) {
    var orderbook = param.orderbook, symbol = param.symbol, isBlur = param.isBlur;
    var liveOrderbookData = orderbook;
    var orderbookData = (0,react.useMemo)(function() {
        return (0,utils/* getPriceDataFromOrderbookData */.ow)(liveOrderbookData);
    }, [
        liveOrderbookData
    ]);
    var ref = (0,react.useMemo)(function() {
        return (0,utils/* checkShouldTableHide */.o$)(liveOrderbookData);
    }, [
        liveOrderbookData
    ]), isHideTable = ref.isHideTable, isIHSG = ref.isIHSG;
    var previous = liveOrderbookData.previous;
    var getColor = (0,react.useCallback)(function(data, dataToCompare) {
        if (data === 0) return undefined;
        return (0,utils/* getTypeByComparison */.Ih)(data, dataToCompare);
    }, []);
    var reformatColumnData = (0,react.useCallback)(function(data) {
        if (data === 0) return "-";
        return (0,utils/* formatNumber */.uf)(data);
    }, []);
    var getClassName = (0,react.useCallback)(function(index) {
        if (index === 0) {
            return " first";
        }
        if (index === orderbookData.length - 1) {
            return " last";
        }
        return "";
    }, [
        orderbookData
    ]);
    var rowClassName = isBlur ? "blurred" : "";
    var getLotClassName = (0,react.useCallback)(function(value) {
        var isFormatted = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var formattedValue = isFormatted ? String(value) : reformatColumnData(value);
        return (0,utils/* isTensOfMillions */.K1)(formattedValue) ? " lot" : "";
    }, []);
    var renderItemOrderbook = (0,react.useCallback)(function(data) {
        return data.map(function(param, index) {
            var bidLot = param.bidLot, bidPrice = param.bidPrice, bidFrequency = param.bidFrequency, offerPrice = param.offerPrice, offerLot = param.offerLot, offerFrequency = param.offerFrequency;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                className: rowClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "orderbook-text-cell value frequency".concat(getClassName(index)),
                        children: reformatColumnData(bidFrequency)
                    }, "bid-frequency-".concat(index)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "orderbook-text-cell value".concat(getClassName(index)).concat(getLotClassName(bidLot)),
                        children: reformatColumnData(bidLot)
                    }, "bid-lot-".concat(index)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "orderbook-text-cell value".concat(getClassName(index), " ").concat(getColor(bidPrice, previous)),
                        children: reformatColumnData(bidPrice)
                    }, "bid-price-".concat(index)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "orderbook-text-cell value".concat(index === 0 ? " first" : "").concat(index === orderbookData.length - 1 ? " last" : "", " ").concat(getColor(offerPrice, previous)),
                        children: reformatColumnData(offerPrice)
                    }, "offer-price-".concat(index)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "orderbook-text-cell value".concat(getClassName(index)).concat(getLotClassName(bidLot)),
                        children: reformatColumnData(offerLot)
                    }, "offer-lot-".concat(index)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                        className: "orderbook-text-cell value frequency".concat(getClassName(index)),
                        children: reformatColumnData(offerFrequency)
                    }, "offer-frequency-".concat(index))
                ]
            }, "item-orderbook-".concat((0,v4/* default */.Z)()));
        });
    }, [
        previous,
        orderbookData,
        isBlur
    ]);
    var renderOrderbookSummary = (0,react.useCallback)(function(data) {
        var totalLots = (0,react.useMemo)(function() {
            return (0,utils/* calculateSummary */.sM)(data);
        }, [
            data
        ]);
        var totalBid = (0,react.useMemo)(function() {
            return totalLots.bid;
        }, [
            totalLots.bid
        ]);
        var totalOffer = (0,react.useMemo)(function() {
            return totalLots.offer;
        }, [
            totalLots.offer
        ]);
        var totalBidFrequency = (0,react.useMemo)(function() {
            return (0,utils/* formatNumber */.uf)(totalLots.bidFrequency);
        }, [
            totalLots.bidFrequency
        ]);
        var totalOfferFrequency = (0,react.useMemo)(function() {
            return (0,utils/* formatNumber */.uf)(totalLots.offerFrequency);
        }, [
            totalLots.offerFrequency
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            className: rowClassName,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "orderbook-text-summary",
                    children: totalBidFrequency
                }, "bid-frequency-total"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "orderbook-text-summary".concat(getLotClassName(totalBid, true)),
                    children: totalBid
                }, "bid-total"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "orderbook-text-summary center",
                    colSpan: 2,
                    children: "TOTAL"
                }, "total"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "orderbook-text-summary".concat(getLotClassName(totalOffer, true)),
                    children: totalOffer
                }, "offer-total"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                    className: "orderbook-text-summary",
                    children: totalOfferFrequency
                }, "offer-frequency-total")
            ]
        }, "summary");
    }, [
        isBlur
    ]);
    var liveOrderbookOnMessage = (0,react.useCallback)(function(message) {
        (0,Orderbook_store/* setValue */.sO)({
            key: "liveprice",
            symbol: message.stockCode,
            type: "update_orderbook_pricedata_liveprice",
            value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, message), {
                symbol: message.stockCode
            })
        });
    }, []);
    (0,useOrderbookSingleReceiver/* useOrderbookSingleReceiver */.z)(symbol, "sidebar_orderbook_bid_offer", liveOrderbookOnMessage);
    var renderTable = function() {
        if (isHideTable && isBlur) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableEmpty/* default */.Z, {});
        }
        if (isHideTable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderbookTableWrapper, {
                $isIHSG: isIHSG
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_TableOrderbookItemSummary, {
            data: orderbookData,
            renderItemOrderbook: renderItemOrderbook,
            renderOrderbookSummary: renderOrderbookSummary
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderbookTableWrapper, {
        children: renderTable()
    });
}
/* harmony default export */ var Orderbook_TableBidOffer = (TableBidOffer);

// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePriceSingleReceiver.ts
var useLivePriceSingleReceiver = __webpack_require__(75979);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/TableOHLNonStock.tsx
var TableOHLNonStock = __webpack_require__(25504);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/TableOHLStock.tsx
var TableOHLStock = __webpack_require__(57644);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/TableLivePrice.tsx











function TableLivePrice(param) {
    var orderbook = param.orderbook, symbol = param.symbol, isStock = param.isStock;
    var livePrice = (0,Orderbook_store/* useOrderbookStore */.av)(function(param) {
        var liveprice = param.liveprice;
        return liveprice === null || liveprice === void 0 ? void 0 : liveprice[symbol];
    });
    var data = livePrice || orderbook;
    var previous = (0,react.useMemo)(function() {
        return (0,utils/* formatChangePrevious */.Px)(data.previous);
    }, [
        data.previous
    ]);
    var open = (0,react.useMemo)(function() {
        return (0,utils/* formatNumberWithNA */._7)(data.open);
    }, [
        data.open
    ]);
    var lot = (0,react.useMemo)(function() {
        return data.volume ? number/* default.parseCountAbbrv3 */.ZP.parseCountAbbrv3(number/* default.parseLot */.ZP.parseLot(data.volume), 1, 4) : "NA";
    }, [
        data.volume
    ]);
    var change = (0,react.useMemo)(function() {
        return (0,utils/* formatChangePrevious */.Px)(data.change);
    }, [
        data.change
    ]);
    var newChange = (0,react.useMemo)(function() {
        return change === "NA" ? change : numeral_default()(change).value();
    }, [
        change
    ]);
    var formattedChange = (0,react.useMemo)(function() {
        return number/* default.addPlusOrMinus2 */.ZP.addPlusOrMinus2(newChange);
    }, [
        newChange
    ]);
    var high = (0,react.useMemo)(function() {
        return (0,utils/* formatNumberWithNA */._7)(data.high);
    }, [
        data.high
    ]);
    var value = (0,react.useMemo)(function() {
        return data.value ? (0,number/* parseCountAbbrv2 */.St)(data.value, 1) : "NA";
    }, [
        data.value
    ]);
    var percentageChange = (0,react.useMemo)(function() {
        return (0,utils/* formatPercentageChange */.Dl)(data.percentage_change);
    }, [
        data.percentage_change
    ]);
    var average = (0,react.useMemo)(function() {
        return (0,utils/* formatAverage */.Te)(data.average);
    }, [
        data.average
    ]);
    var low = (0,react.useMemo)(function() {
        return (0,utils/* formatNumberWithNA */._7)(data.low);
    }, [
        data.low
    ]);
    var frequency = (0,react.useMemo)(function() {
        return data.frequency ? numeral_default()(data.frequency).format("0,0") : "";
    }, [
        data.frequency
    ]);
    var fbuy = (0,react.useMemo)(function() {
        var ref;
        return data.fbuy ? (ref = numeral_default()(data.fbuy).format("0.0 a")) === null || ref === void 0 ? void 0 : ref.toUpperCase() : "";
    }, [
        data.fbuy
    ]);
    var fsell = (0,react.useMemo)(function() {
        var ref;
        return data.fsell ? (ref = numeral_default()(data.fsell).format("0.0 a")) === null || ref === void 0 ? void 0 : ref.toUpperCase() : "";
    }, [
        data.fsell
    ]);
    var ref = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!((ref = data.iepiev) === null || ref === void 0 ? void 0 : ref.iep) && !((ref1 = data.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev)) return [];
        var iep = (0,utils/* formatNumberWithNA */._7)(data.iepiev.iep.raw, "-");
        var iev = data.iepiev.iev.raw ? (0,number/* parseCountAbbrv2 */.St)(data.iepiev.iev.raw, 1, ",", true) : "-";
        var timeleft = data.iepiev.time_left_seconds;
        var showiepiev = (0,utils/* getShowIepIev */.ru)(!!(iep && iev), timeleft);
        return [
            iep,
            iev,
            showiepiev
        ];
    }, [
        data.iepiev
    ]), Iep = ref[0], Iev = ref[1], showIepIev = ref[2];
    var fourthRowExist = (0,react.useMemo)(function() {
        return showIepIev || data.is_foreignbs_exist;
    }, [
        showIepIev,
        data.is_foreignbs_exist
    ]);
    var isTwoColumn = (0,react.useMemo)(function() {
        return !data.exchange && Boolean(data.symbol);
    }, [
        data.exchange,
        data.symbol
    ]);
    var ara = (0,react.useMemo)(function() {
        if (orderbook.ara.visible) {
            var ref;
            return orderbook === null || orderbook === void 0 ? void 0 : (ref = orderbook.ara) === null || ref === void 0 ? void 0 : ref.value;
        }
        return "-";
    }, [
        orderbook.ara
    ]);
    var arb = (0,react.useMemo)(function() {
        if (orderbook.arb.visible) {
            var ref;
            return orderbook === null || orderbook === void 0 ? void 0 : (ref = orderbook.arb) === null || ref === void 0 ? void 0 : ref.value;
        }
        return "-";
    }, [
        orderbook.arb
    ]);
    var livePriceOnMessage = (0,react.useCallback)(function(message) {
        (0,Orderbook_store/* setValue */.sO)({
            key: "liveprice",
            symbol: message.stockCode,
            value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, message), {
                symbol: message.stockCode
            })
        });
    }, []);
    (0,useLivePriceSingleReceiver/* useLivePriceSingleReceiver */.J)(symbol, "sidebar_orderbook_summary", livePriceOnMessage);
    if (isStock) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLStock/* default */.Z, {
            data: {
                average: average,
                high: high,
                change: formattedChange,
                lot: lot,
                low: low,
                open: open,
                percentage: percentageChange,
                previous: previous,
                value: value,
                ara: ara,
                arb: arb,
                fbuy: fbuy,
                frequency: frequency,
                fsell: fsell,
                Iep: Iep,
                Iev: Iev
            },
            isTwoColumn: isTwoColumn,
            showForthRow: fourthRowExist,
            showIepIev: showIepIev
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLNonStock/* default */.Z, {
        data: {
            average: average,
            high: high,
            change: formattedChange,
            lot: lot,
            low: low,
            open: open,
            percentage: percentageChange,
            previous: previous,
            value: value
        },
        isTwoColumn: isTwoColumn
    });
}
/* harmony default export */ var Orderbook_TableLivePrice = (TableLivePrice);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/slice.ts
var Orderbook_slice = __webpack_require__(83231);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/Header.tsx










var Orderbook_Header_AutoSuggestion = ui/* Widget.AutoSuggestion */.$L.AutoSuggestion;
var Orderbook_Header_Text = ui/* Common.Text */.Gn.Text, Orderbook_Header_Flex = ui/* Common.Flex */.Gn.Flex;
var Header_actions = Orderbook_slice/* default.actions */.ZP.actions;
function Orderbook_Header_Header() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(Orderbook_slice/* selectors */.wl), isSearchbarActive = ref.isSearchbarActive, name = ref.name, searchResult = ref.searchResult;
    var symbol = (0,es/* useSelector */.v9)(Orderbook_slice/* symbolSelector */.Mb);
    var intervalRef = (0,react.useRef)();
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var options = searchResult.map(function(param) {
        var companyName = param.name, desc = param.desc;
        return {
            value: companyName,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Orderbook_Header_Flex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_styled_Tag, {
                        children: companyName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagDesc, {
                        children: desc
                    })
                ]
            })
        };
    });
    var inputContainerRef = (0,react.useRef)(null);
    var inputRef = (0,react.useRef)(null);
    var handleOutsideClick = (0,react.useCallback)(function(e) {
        var ref;
        e.stopPropagation();
        if (inputContainerRef.current && !((ref = inputContainerRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
            dispatch(Header_actions.setisSearchbarActive({
                isOpen: false
            }));
            setVisible(false);
        }
    }, [
        dispatch
    ]);
    var onSymbolSearchClick = function(e) {
        e.stopPropagation();
        dispatch(Header_actions.setisSearchbarActive({
            isOpen: true
        }));
        setVisible(true);
        inputRef.current.focus();
    };
    var handleSearchCompany = function(keyword) {
        if (keyword.length > 1) {
            if (intervalRef.current) {
                clearTimeout(intervalRef.current);
            }
            intervalRef.current = setTimeout(function() {
                dispatch(Orderbook_slice/* effects.fetchSymbolSuggestions */.Sz.fetchSymbolSuggestions({
                    keyword: keyword
                }));
            }, 1500);
        }
    };
    var handleSuggestionClick = function(selectedSymbol) {
        router.push("/symbol/".concat(selectedSymbol));
        dispatch(Header_actions.setSymbol({
            symbol: selectedSymbol
        }));
    };
    var handlePressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var val, search, company, _company, selected;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        val = e;
                        if (typeof e !== "string") {
                            val = e.target.value;
                        }
                        if (!(val.length > 1)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 5;
                        return dispatch(Orderbook_slice/* effects.fetchSymbolSuggestions */.Sz.fetchSymbolSuggestions({
                            keyword: val
                        }));
                    case 5:
                        search = _ctx.sent;
                        company = search.payload.company;
                        if (company && company.length > 0) {
                            _company = (0,_sliced_to_array/* default */.Z)(company, 1), selected = _company[0];
                            handleSuggestionClick(selected.name);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePressEnter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeSymbol = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        dispatch(Header_actions.setisSearchbarActive({
            isOpen: false
        }));
        setVisible(false);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, [
        handleOutsideClick
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Orderbook_styled_HeaderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: inputContainerRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_Header_AutoSuggestion, {
                        options: options,
                        style: {
                            position: "absolute",
                            bottom: "0",
                            width: "calc(100% - 20px)"
                        },
                        onSearch: handleSearchCompany,
                        onSelect: handleSuggestionClick,
                        open: visible,
                        getPopupContainer: function(trigger) {
                            return trigger.parentElement;
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_styled_Input, {
                            ref: inputRef,
                            active: isSearchbarActive,
                            placeholder: "Type stock here",
                            width: isSearchbarActive ? "100%" : "0px",
                            onPressEnter: handlePressEnter,
                            suffix: isSearchbarActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_Header_Text, {
                                size: "12px",
                                color: ui/* color.midgray */.$_.midgray,
                                style: {
                                    cursor: "pointer"
                                },
                                onClick: handleChangeSymbol,
                                children: "change symbol"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolSearch, {
                        onClick: onSymbolSearchClick,
                        active: !isSearchbarActive,
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_Header_Text, {
                style: {
                    display: isSearchbarActive ? "none" : "block"
                },
                size: "12px",
                ellipsis: true,
                children: name
            })
        ]
    });
}
/* harmony default export */ var Orderbook_Header = (Orderbook_Header_Header);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/Orderbook/index.tsx























function Orderbook() {
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,es/* useSelector */.v9)(Orderbook_slice/* selectors */.wl), symbol = ref1.symbol, lastprice = ref1.lastprice, percentageChange = ref1.percentageChange, change = ref1.change, ohlc = ref1.ohlc, orderbook = ref1.orderbook;
    var livePrice = (0,Orderbook_store/* useOrderbookStore */.av)(function(param) {
        var liveprice = param.liveprice;
        return liveprice === null || liveprice === void 0 ? void 0 : liveprice[symbol];
    });
    var orderbookData = (0,react.useMemo)(function() {
        if ((livePrice === null || livePrice === void 0 ? void 0 : livePrice.bid) && (livePrice === null || livePrice === void 0 ? void 0 : livePrice.offer)) {
            return livePrice;
        }
        if (orderbook) {
            var liveResult = (0,_object_spread/* default */.Z)({}, orderbook);
            if (livePrice === null || livePrice === void 0 ? void 0 : livePrice.bid) {
                liveResult.bid = livePrice.bid;
            }
            if (livePrice === null || livePrice === void 0 ? void 0 : livePrice.offer) {
                liveResult.offer = livePrice.offer;
            }
            return liveResult;
        }
        return null;
    }, [
        orderbook,
        livePrice
    ]);
    (0,react.useEffect)(function() {
        dispatch(Orderbook_slice/* effects.fetchOrderbook */.Sz.fetchOrderbook({
            symbol: symbol
        }));
    }, [
        symbol
    ]);
    (0,useLivePriceSender/* useLivePriceSender */.O)(liveprice_store_types/* LivePriceSymbolsKeyEnum.SIDE_WIDGET_ORDERBOOK_SUMMARY */.j.SIDE_WIDGET_ORDERBOOK_SUMMARY, [
        symbol
    ]);
    (0,useOrderbookSender/* useOrderbookSender */.J)(orderbook_store_types/* OrderbookSymbolsKeyEnum.SIDE_WIDGET_ORDERBOOK_SUMMARY */.E.SIDE_WIDGET_ORDERBOOK_SUMMARY, [
        symbol
    ]);
    // IEPIEV
    var handleMessageIepIev = function(_symbol, value) {
        (0,Orderbook_store/* setValue */.sO)({
            key: "liveprice",
            type: "update_iepiev",
            symbol: _symbol,
            value: value
        });
    };
    var onReceiveIEPIEV = (0,react.useCallback)(function(iepiev) {
        handleMessageIepIev(symbol, {
            iep: iepiev.iep,
            iev: iepiev.iev / 100
        });
    }, [
        symbol
    ]);
    (0,useOrderbookIEPIEV/* useOrderbookIEPIEV */.Jj)([
        symbol
    ], "side_widget", onReceiveIEPIEV);
    var ref2;
    var ref3 = (ref2 = orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.iepiev) !== null && ref2 !== void 0 ? ref2 : {}, iepIevTimeLeft = ref3.time_left_seconds;
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        if (iepIevTimeLeft) {
            var timeoutId = setTimeout(function() {
                handleMessageIepIev(symbol, null);
            }, iepIevTimeLeft * 1000);
            return function() {
                return clearTimeout(timeoutId);
            };
        }
    }, [
        symbol,
        iepIevTimeLeft
    ]);
    // End IEPIEV
    // BestBidOffer
    var iepiev = (orderbookData !== null && orderbookData !== void 0 ? orderbookData : {}).iepiev;
    var ref4 = (0,useBestBidData/* default */.Z)(iepiev === null || iepiev === void 0 ? void 0 : iepiev.best_bid_offer, symbol), showBestBid = ref4.showBestBid, bestBidData = ref4.bestBidData, isBlured = ref4.isBlured, setBestBidOffer = ref4.setBestBidOffer;
    var onReceiveBestBidOffer = (0,react.useCallback)(function(bestBidOffer) {
        setBestBidOffer(bestBidOffer);
    }, [
        symbol
    ]);
    (0,useBestBidOffer/* default */.ZP)([
        symbol
    ], "side_widget", onReceiveBestBidOffer);
    // End BestBidOffer
    var isHideTable = (0,react.useMemo)(function() {
        if (orderbookData) return (0,utils/* checkShouldTableHide */.o$)(orderbookData);
        return {
            isHideTable: false
        };
    }, [
        orderbookData
    ]).isHideTable;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_Summary, {
                symbol: symbol,
                lastprice: lastprice,
                change: change,
                percentageChange: percentageChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: ohlc,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_TableLivePrice, {
                    orderbook: ohlc,
                    symbol: symbol,
                    isStock: (orderbook === null || orderbook === void 0 ? void 0 : (ref = orderbook.company_type) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === trading/* STOCK_TYPE.saham */.L2.saham
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showBestBid || !isHideTable,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSeparator/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: orderbookData,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBestBidOffer/* default */.Z, {
                        visible: showBestBid,
                        previous: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.previous,
                        data: bestBidData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Orderbook_TableBidOffer, {
                        orderbook: orderbookData,
                        symbol: symbol,
                        isBlur: isBlured
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Watchlist_Orderbook = (Orderbook);

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/slice.ts
var CompanyWatchlist_slice = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/utils/tags.tsx + 2 modules
var tags = __webpack_require__(91601);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/styled.ts

function CompanyWatchlist_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  background-color: ",
        ";\n  height: 100% !important;\n"
    ]);
    CompanyWatchlist_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyWatchlist_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: auto;\n  padding-bottom: 30px;\n  height: calc(100% - 40px);\n  padding: 0px 12px 30px 12px;\n\n  table {\n    width: 100%;\n\n    th {\n      padding: 8px 4px;\n      border-bottom: 1px solid rgb(245, 246, 247);\n    }\n    th:nth-child(1),\n    td:nth-child(1) {\n      width: 25%;\n      min-width: 75.25px;\n      max-width: 75.25px;\n    }\n    th:nth-child(2),\n    td:nth-child(2) {\n      width: 30%;\n      min-width: 90.3px;\n      max-width: 90.3px;\n    }\n    th:nth-child(3),\n    td:nth-child(3) {\n      width: 45%;\n      min-width: 135.45px;\n      max-width: 135.45px;\n    }\n\n    tr {\n      position: relative;\n      cursor: pointer;\n    }\n    tr.active {\n      background: rgb(238, 238, 238);\n    }\n    tr:hover td {\n      background: rgb(245, 246, 247);\n    }\n    tr td ",
        " {\n      display: none;\n    }\n    tr:hover td ",
        " {\n      display: flex;\n    }\n\n    td {\n      line-height: 1.15;\n      font-size: 12.5px;\n      padding: 0;\n      border-bottom: 1px solid rgb(245, 246, 247);\n\n      a {\n        > div {\n          padding: 7px 4px;\n        }\n      }\n    }\n    td:not(:first-child) {\n      text-align: right;\n    }\n    td.up {\n      color: ",
        ";\n    }\n    td.down {\n      color: ",
        ";\n    }\n    td.neutral {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    CompanyWatchlist_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var styled_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var CloseIconWrapper = (0,styled_components_browser_esm["default"])(styled_IconWrapper).attrs({
    size: "30px"
}).withConfig({
    componentId: "sc-9e69af69-0"
})(CompanyWatchlist_styled_templateObject(), ui/* color.sunsetOrange */.$_.sunsetOrange);
var TableWatchlistWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9e69af69-1"
})(CompanyWatchlist_styled_templateObject1(), CloseIconWrapper, CloseIconWrapper, ui/* color.primary */.$_.primary, ui/* color.sunsetOrange */.$_.sunsetOrange, ui/* color.suvaGrey */.$_.suvaGrey);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/CloseIcon.tsx




var CompanyWatchlist_CloseIcon_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var CloseIcon_CloseIcon = function(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconWrapper, {
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWatchlist_CloseIcon_Iconmoon, {
            className: "icon-widget_close",
            color: ui/* color.light */.$_.light,
            hoverColor: ui/* color.light */.$_.light,
            size: "10px",
            weight: "bold"
        })
    });
};
CloseIcon_CloseIcon.propTypes = {
    onClick: prop_types.func
};
CloseIcon_CloseIcon.defaultProps = {
    onClick: function() {}
};
/* harmony default export */ var CompanyWatchlist_CloseIcon = (CloseIcon_CloseIcon);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/DeleteOption.tsx









var DeleteOption_Flex = ui/* Common.Flex */.Gn.Flex, DeleteOption_Text = ui/* Common.Text */.Gn.Text;
var DeleteOption = function(_param) {
    var id = _param.id, symbol = _param.symbol, onCancel = _param.onCancel, onClick = _param.onClick, watchlistId = _param.watchlistId, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "id",
        "symbol",
        "onCancel",
        "onClick",
        "watchlistId"
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleOnOk = function(e) {
        e.stopPropagation();
        // TODO: mas @hendra5, ini perlu dicek lagi terkait typingnya yap
        // @ts-ignore
        dispatch(CompanyWatchlist_slice/* effects.unfollowCompany */.Sz.unfollowCompany({
            companyId: id,
            watchlistId: watchlistId
        }));
        onCancel();
    };
    var handleCancel = function(e) {
        e.stopPropagation();
        onCancel();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteOptionWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteOption_Text, {
                as: "span",
                size: "11.5px",
                height: "31px",
                width: "50%",
                style: {
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    marginRight: "3px"
                },
                children: [
                    "Confirm delete ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeleteOption_Flex, {
                justify: "flex-end",
                width: "50%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWidget, {
                        type: "sunsetOrange",
                        height: "30px",
                        block: true,
                        onClick: handleOnOk,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOption_Text, {
                            color: ui/* color.light */.$_.light,
                            align: "center",
                            children: "Yes"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWidget, {
                        type: "highempahis",
                        height: "30px",
                        block: true,
                        onClick: handleCancel,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOption_Text, {
                            color: ui/* color.light */.$_.light,
                            align: "center",
                            children: "No"
                        })
                    })
                ]
            })
        ]
    }));
};
DeleteOption.propTypes = {
    id: prop_types.string.isRequired,
    symbol: prop_types.string.isRequired,
    onCancel: prop_types.func.isRequired
};
/* harmony default export */ var CompanyWatchlist_DeleteOption = (DeleteOption);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/RowWatchlist.tsx















var RowWatchlist_Flex = ui/* Common.Flex */.Gn.Flex;
var RowWatchlist = function(param) {
    var data = param.data, index = param.index, watchlistId = param.watchlistId, closedRow = param.closedRow, setClosedRow = param.setClosedRow;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,next_router.useRouter)(), push = ref.push, query = ref.query, pathname = ref.pathname;
    var routerSymbol = Array.isArray(query.symbol) ? query.symbol[0] : query.symbol;
    var isInChartbitPage = pathname.includes("chartbit");
    var symbol = data.symbol, last = data.last, change = data.change, percent = data.percent;
    var liveprice = (0,Orderbook_store/* useOrderbookStore */.av)(function(param) {
        var state = param.liveprice;
        return state === null || state === void 0 ? void 0 : state[symbol];
    });
    var lastPrice = (liveprice === null || liveprice === void 0 ? void 0 : liveprice.lastprice) || last;
    var lastChange = (liveprice === null || liveprice === void 0 ? void 0 : liveprice.change) || change;
    var lastPercent = (liveprice === null || liveprice === void 0 ? void 0 : liveprice.percentage_change) || percent;
    var getChangeCls = function(priceChanges) {
        if (priceChanges === 0) {
            return "neutral";
        }
        if (priceChanges < 0) {
            return "down";
        }
        return "up";
    };
    var renderChange = function(dataChanges) {
        var dataLastChange = dataChanges.change, dataLastPercent = dataChanges.percent;
        var format = "0.00";
        var percentNumeral = numeral_default()(dataLastPercent);
        if (percentNumeral.value() > 100) {
            percentNumeral = percentNumeral.divide(100);
        }
        var formattedPercent = percentNumeral.format(format);
        var formattedChange = numeral_default()(dataLastChange).format("0,0[.]0[0]");
        var formattedPercentNumber = Number(formattedPercent);
        if (formattedPercentNumber < 0) {
            format = "-".concat(format);
        } else if (formattedPercentNumber > 0) {
            format = "+".concat(format);
        }
        formattedPercent = percentNumeral.format(format);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
            style: {
                position: "relative"
            },
            className: getChangeCls(formattedPercentNumber),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_SymbolLink, {
                    symbol: symbol,
                    isPreventDefault: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "".concat(formattedChange, " (").concat(formattedPercent, "%)")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWatchlist_CloseIcon, {
                    onClick: function(e) {
                        e.stopPropagation();
                        setClosedRow(index);
                    }
                })
            ]
        });
    };
    var renderCompany = function() {
        var isHovered = closedRow === index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: isHovered ? "hidden" : "unset",
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_SymbolLink, {
                            symbol: symbol,
                            isPreventDefault: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RowWatchlist_Flex, {
                                align: "center",
                                children: [
                                    symbol,
                                    (0,tags/* renderTags */.a)(data, false)
                                ]
                            })
                        })
                    }),
                    isHovered ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWatchlist_DeleteOption, {
                        symbol: symbol,
                        id: data.id,
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        onCancel: function() {
                            return setClosedRow(undefined);
                        },
                        watchlistId: watchlistId
                    }) : null
                ]
            })
        });
    };
    var livePriceOnMessage = (0,react.useCallback)(function(message) {
        (0,Orderbook_store/* setValue */.sO)({
            key: "liveprice",
            symbol: message.stockCode,
            type: "update_general_pricedata",
            value: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, message), {
                symbol: message.stockCode
            })
        });
    }, []);
    (0,useLivePriceSingleReceiver/* useLivePriceSingleReceiver */.J)(symbol, "sidebar_watchlist", livePriceOnMessage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: routerSymbol === symbol ? "active" : null,
        onClick: function(e) {
            e.stopPropagation();
            dispatch(Orderbook_slice/* default.actions.setSymbol */.ZP.actions.setSymbol({
                symbol: symbol
            }));
            push("/symbol/".concat(symbol).concat(isInChartbitPage ? "/chartbit" : ""), undefined, {
                shallow: isInChartbitPage
            });
        },
        children: [
            renderCompany(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_SymbolLink, {
                    symbol: symbol,
                    isPreventDefault: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: numeral_default()(Number(lastPrice)).format("0,0")
                    })
                })
            }),
            renderChange({
                change: lastChange,
                percent: lastPercent
            })
        ]
    });
};
/* harmony default export */ var CompanyWatchlist_RowWatchlist = (RowWatchlist);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/EmptyWatchlist.tsx


var EmptyWatchlist_Button = ui/* Common.Button */.Gn.Button, EmptyWatchlist_Flex = ui/* Common.Flex */.Gn.Flex, EmptyWatchlist_Text = ui/* Common.Text */.Gn.Text;
var EmptyWatchlist = function(param) {
    var onAdd = param.onAdd;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyWatchlist_Flex, {
        direction: "column",
        align: "center",
        justify: "center",
        px: "30px",
        style: {
            height: "calc(100% - 40px)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyWatchlist_Text, {
                children: "Your watchlist is empty"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyWatchlist_Button, {
                block: true,
                round: true,
                type: "primary",
                margin: "10px 0",
                onClick: onAdd,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyWatchlist_Text, {
                    color: ui/* color.light */.$_.light,
                    align: "center",
                    children: "+ Add Stocks Now"
                })
            })
        ]
    });
};
/* harmony default export */ var CompanyWatchlist_EmptyWatchlist = (EmptyWatchlist);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/CompanyWatchlist/TableWatchlist.tsx










var TableWatchlist_Text = ui/* Common.Text */.Gn.Text;
var TableWatchlist = function(param) {
    var watchlistId = param.watchlistId, setAddSymbol = param.setAddSymbol;
    var dispatch = (0,es/* useDispatch */.I0)();
    var list = (0,es/* useSelector */.v9)(CompanyWatchlist_slice/* selectors */.wl).list;
    var ref = (0,react.useState)(), closedRow = ref[0], setClosedRow = ref[1];
    (0,react.useEffect)(function() {
        dispatch(CompanyWatchlist_slice/* effects.getCompanyWatchlist */.Sz.getCompanyWatchlist({
            watchlistId: watchlistId
        }));
    }, [
        dispatch,
        watchlistId
    ]);
    (0,useLivePriceSender/* useLivePriceSender */.O)(liveprice_store_types/* LivePriceSymbolsKeyEnum.SIDE_WIDGET_WATCHLIST */.j.SIDE_WIDGET_WATCHLIST, list.map(function(param) {
        var symbol = param.symbol;
        return symbol;
    }));
    if (list.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWatchlist_EmptyWatchlist, {
            onAdd: function() {
                return setAddSymbol(true);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWatchlistWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("thead", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWatchlist_Text, {
                                family: "bold",
                                size: "11px",
                                children: "Symbol"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWatchlist_Text, {
                                family: "bold",
                                size: "11px",
                                align: "right",
                                children: "Last"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWatchlist_Text, {
                                family: "bold",
                                size: "11px",
                                align: "right",
                                children: "Change (%)"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: list.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWatchlist_RowWatchlist, {
                            index: index,
                            data: item,
                            watchlistId: watchlistId,
                            closedRow: closedRow,
                            setClosedRow: setClosedRow
                        }, item.symbol);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var CompanyWatchlist_TableWatchlist = (TableWatchlist);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Watchlist/index.tsx











function Allwatchlist() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(Watchlist_slice/* selectors */.wl), watchlistId = ref.watchlistId, showList = ref.showList;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), profileData = ref1.data;
    var _country = profileData.country, country = _country === void 0 ? "ID" : _country;
    var ref2 = (0,react.useState)(false), addSymbol = ref2[0], setAddSymbol = ref2[1];
    var ref3 = (0,react.useState)(0), resizeableHeight = ref3[0], setResizeableHeight = ref3[1];
    var ref4 = (0,react.useState)(0), windowHeight = ref4[0], setWindowHeight = ref4[1];
    (0,react.useEffect)(function() {
        var resizeable = document.getElementsByClassName("sw-watchlist");
        if (resizeable.length) {
            setResizeableHeight(resizeable[0].clientHeight);
        }
        setWindowHeight(window.innerHeight);
    }, []);
    (0,react.useEffect)(function() {
        return function() {
            dispatch(Watchlist_slice/* default.actions.toggleViewType */.ZP.actions.toggleViewType({
                listType: "company"
            }));
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
                className: "sw-watchlist",
                defaultSize: {
                    height: "50%",
                    width: "100%"
                },
                maxHeight: windowHeight - 40,
                minHeight: 40,
                onResizeStop: function(e, direction, ref, d) {
                    var h = resizeableHeight + d.height;
                    setResizeableHeight(h);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_Header, {
                            isAddSymbol: addSymbol,
                            setAddSymbol: setAddSymbol
                        }),
                        showList === "company" && /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWatchlist_TableWatchlist, {
                            watchlistId: watchlistId,
                            setAddSymbol: setAddSymbol
                        }),
                        showList === "saved" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_ListWatchlist, {
                            watchlistId: watchlistId
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "ID",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: "calc(".concat(windowHeight, "px - ").concat(resizeableHeight, "px)")
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist_Orderbook, {})
                })
            })
        ]
    });
}
/* harmony default export */ var Watchlist = (Allwatchlist);

// EXTERNAL MODULE: ./src/constants/clevertap.js
var clevertap = __webpack_require__(92124);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var utils_clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/utils.ts


var generateSidewidget = function() {
    var country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ID";
    if (country === "MY") {
        return SideWidget_constants/* baseMenu */.V3;
    }
    return (0,_to_consumable_array/* default */.Z)(SideWidget_constants/* baseMenu */.V3).concat((0,_to_consumable_array/* default */.Z)(SideWidget_constants/* indonesiaMenu */.OP));
};

// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/typings/theme.ts
var theme = __webpack_require__(33270);
;// CONCATENATED MODULE: ./src/utils/array.ts

var equals = function(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    var sortedArr1 = (0,_to_consumable_array/* default */.Z)(arr1).sort();
    var sortedArr2 = (0,_to_consumable_array/* default */.Z)(arr2).sort();
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < sortedArr1.length; i++){
        if (sortedArr1[i] !== sortedArr2[i]) {
            return false;
        }
    }
    return true;
};

// EXTERNAL MODULE: ./src/global/Datafeed/useDatafeedMessageEffect.ts
var useDatafeedMessageEffect = __webpack_require__(49696);
// EXTERNAL MODULE: ./src/global/Datafeed/UseMarketMover/marketmover.store.ts
var marketmover_store = __webpack_require__(25288);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseMarketMover/useMarketMover.ts






var useMarketMover = function(key, request, onMessage) {
    var setMoverRequest = (0,marketmover_store/* useMarketMoverStore */.x)(function(s) {
        return s.setMoverRequest;
    });
    var handleReceiveMessage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var marketMoverBatch;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        marketMoverBatch = (message || {}).marketMoverBatch;
                        if (marketMoverBatch && request.moverType === marketMoverBatch.moverType && equals(request.filterStocks, marketMoverBatch.filterStocks)) {
                            onMessage(marketMoverBatch);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        request
    ]);
    (0,react.useEffect)(function() {
        setMoverRequest(key, request);
        return function() {
            setMoverRequest(key, undefined);
        };
    }, [
        key,
        request,
        setMoverRequest
    ]);
    (0,useDatafeedMessageEffect/* default */.Z)("marketMoverBatch", key, handleReceiveMessage);
};
/* harmony default export */ var UseMarketMover_useMarketMover = (useMarketMover);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/financial/order_trade/entity/v1/market_mover_pb.js
var market_mover_pb = __webpack_require__(77361);
;// CONCATENATED MODULE: ./src/features/movers/utils.ts


var _obj;
var MapMoverStr = (_obj = {}, (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.UNSPECIFIED */.pU.UNSPECIFIED, "MOVER_TYPE_UNSPECIFIED"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.TOP_VALUE */.pU.TOP_VALUE, "MOVER_TYPE_TOP_VALUE"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.TOP_VOLUME */.pU.TOP_VOLUME, "MOVER_TYPE_TOP_VOLUME"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.TOP_FREQUENCY */.pU.TOP_FREQUENCY, "MOVER_TYPE_TOP_FREQUENCY"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.TOP_GAINER */.pU.TOP_GAINER, "MOVER_TYPE_TOP_GAINER"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.TOP_LOSER */.pU.TOP_LOSER, "MOVER_TYPE_TOP_LOSER"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.NET_FOREIGN_BUY */.pU.NET_FOREIGN_BUY, "MOVER_TYPE_NET_FOREIGN_BUY"), (0,_define_property/* default */.Z)(_obj, market_mover_pb/* MoverType.NET_FOREIGN_SELL */.pU.NET_FOREIGN_SELL, "MOVER_TYPE_NET_FOREIGN_SELL"), _obj);
var MapMoverEnum = {
    MOVER_TYPE_UNSPECIFIED: market_mover_pb/* MoverType.UNSPECIFIED */.pU.UNSPECIFIED,
    MOVER_TYPE_TOP_VALUE: market_mover_pb/* MoverType.TOP_VALUE */.pU.TOP_VALUE,
    MOVER_TYPE_TOP_VOLUME: market_mover_pb/* MoverType.TOP_VOLUME */.pU.TOP_VOLUME,
    MOVER_TYPE_TOP_FREQUENCY: market_mover_pb/* MoverType.TOP_FREQUENCY */.pU.TOP_FREQUENCY,
    MOVER_TYPE_TOP_GAINER: market_mover_pb/* MoverType.TOP_GAINER */.pU.TOP_GAINER,
    MOVER_TYPE_TOP_LOSER: market_mover_pb/* MoverType.TOP_LOSER */.pU.TOP_LOSER,
    MOVER_TYPE_NET_FOREIGN_BUY: market_mover_pb/* MoverType.NET_FOREIGN_BUY */.pU.NET_FOREIGN_BUY,
    MOVER_TYPE_NET_FOREIGN_SELL: market_mover_pb/* MoverType.NET_FOREIGN_SELL */.pU.NET_FOREIGN_SELL
};
var MapMoverFilterEnum = {
    FILTER_STOCKS_TYPE_UNSPECIFIED: market_mover_pb/* FilterStocksType.UNSPECIFIED */.Y2.UNSPECIFIED,
    FILTER_STOCKS_TYPE_MAIN_BOARD: market_mover_pb/* FilterStocksType.MAIN_BOARD */.Y2.MAIN_BOARD,
    FILTER_STOCKS_TYPE_DEVELOPMENT_BOARD: market_mover_pb/* FilterStocksType.DEVELOPMENT_BOARD */.Y2.DEVELOPMENT_BOARD,
    FILTER_STOCKS_TYPE_ACCELERATION_BOARD: market_mover_pb/* FilterStocksType.ACCELERATION_BOARD */.Y2.ACCELERATION_BOARD,
    FILTER_STOCKS_TYPE_NEW_ECONOMY_BOARD: market_mover_pb/* FilterStocksType.NEW_ECONOMY_BOARD */.Y2.NEW_ECONOMY_BOARD,
    FILTER_STOCKS_TYPE_SPECIAL_MONITORING_BOARD: market_mover_pb/* FilterStocksType.SPECIAL_MONITORING_BOARD */.Y2.SPECIAL_MONITORING_BOARD,
    FILTER_STOCKS_TYPE_WARRANT_AND_RIGHT: market_mover_pb/* FilterStocksType.WARRANT_AND_RIGHT */.Y2.WARRANT_AND_RIGHT,
    FILTER_STOCKS_TYPE_SHARIA: market_mover_pb/* FilterStocksType.SHARIA */.Y2.SHARIA
};
var convertMoversFilterListToEnum = function(arr) {
    return arr.map(function(str) {
        return MapMoverFilterEnum[str];
    });
};
var convertMoverWStoAPI = function(data) {
    if (!data) return undefined;
    var result = {
        mover_type: MapMoverStr[data.moverType],
        mover_list: data.batch.map(function(old) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26;
            return {
                stock_detail: {
                    code: ((ref = old.stockDetail) === null || ref === void 0 ? void 0 : ref.code) || "",
                    name: ((ref1 = old.stockDetail) === null || ref1 === void 0 ? void 0 : ref1.name) || "",
                    icon_url: ((ref2 = old.stockDetail) === null || ref2 === void 0 ? void 0 : ref2.iconUrl) || "",
                    has_uma: ((ref3 = old.stockDetail) === null || ref3 === void 0 ? void 0 : ref3.hasUma) || false,
                    notations: ((ref4 = old.stockDetail) === null || ref4 === void 0 ? void 0 : ref4.notations) || [],
                    corpaction: {
                        active: ((ref5 = old.stockDetail) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.corpaction) === null || ref6 === void 0 ? void 0 : ref6.active) || false,
                        icon_url: ((ref7 = old.stockDetail) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.corpaction) === null || ref8 === void 0 ? void 0 : ref8.iconUrl) || "",
                        text: ((ref9 = old.stockDetail) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.corpaction) === null || ref10 === void 0 ? void 0 : ref10.text) || ""
                    }
                },
                price: old.price,
                change: {
                    percentage: ((ref11 = old.change) === null || ref11 === void 0 ? void 0 : ref11.percentage) || 0,
                    value: ((ref12 = old.change) === null || ref12 === void 0 ? void 0 : ref12.value) || 0
                },
                frequency: {
                    raw: ((ref13 = old.frequency) === null || ref13 === void 0 ? void 0 : ref13.raw) || 0,
                    formatted: ((ref14 = old.frequency) === null || ref14 === void 0 ? void 0 : ref14.formatted) || ""
                },
                value: {
                    raw: ((ref15 = old.value) === null || ref15 === void 0 ? void 0 : ref15.raw) || 0,
                    formatted: ((ref16 = old.value) === null || ref16 === void 0 ? void 0 : ref16.formatted) || ""
                },
                volume: {
                    raw: ((ref17 = old.volume) === null || ref17 === void 0 ? void 0 : ref17.raw) || 0,
                    formatted: ((ref18 = old.volume) === null || ref18 === void 0 ? void 0 : ref18.formatted) || ""
                },
                net_foreign_buy: {
                    raw: ((ref19 = old.netForeignBuy) === null || ref19 === void 0 ? void 0 : ref19.raw) || 0,
                    formatted: ((ref20 = old.netForeignSell) === null || ref20 === void 0 ? void 0 : ref20.formatted) || ""
                },
                net_foreign_sell: {
                    raw: ((ref21 = old.netForeignSell) === null || ref21 === void 0 ? void 0 : ref21.raw) || 0,
                    formatted: ((ref22 = old.netForeignSell) === null || ref22 === void 0 ? void 0 : ref22.formatted) || ""
                },
                net_buy: {
                    raw: ((ref23 = old.netBuy) === null || ref23 === void 0 ? void 0 : ref23.raw) || 0,
                    formatted: ((ref24 = old.netBuy) === null || ref24 === void 0 ? void 0 : ref24.formatted) || ""
                },
                net_sell: {
                    raw: ((ref25 = old.netSell) === null || ref25 === void 0 ? void 0 : ref25.raw) || 0,
                    formatted: ((ref26 = old.netSell) === null || ref26 === void 0 ? void 0 : ref26.formatted) || ""
                }
            };
        })
    };
    return result;
};

;// CONCATENATED MODULE: ./src/features/movers/Loader.tsx

function Loader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 19px;\n  margin: 10.5px 0;\n  background: #F7F7F7;\n  border-radius: 2px;\n  padding-left: 16px;\n  padding-right: 16px;\n"
    ]);
    Loader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Loader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 16px;\n"
    ]);
    Loader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var LoaderItem = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ea5910f6-0"
})(Loader_templateObject());
var LoaderContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-ea5910f6-1"
})(Loader_templateObject1());
var Loader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoaderContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderItem, {})
        ]
    });
};
/* harmony default export */ var movers_Loader = (Loader);

;// CONCATENATED MODULE: ./src/features/movers/index.tsx








var MoversRemote = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4622).then(__webpack_require__.t.bind(__webpack_require__, 14622, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14622)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(movers_Loader, {});
    }
});
var MoversFeature = function(param) {
    var featureKey = param.featureKey, filter = param.filter, setFilter = param.setFilter;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(undefined), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)("MOVER_TYPE_TOP_VALUE"), type = ref1[0], setType = ref1[1];
    var request = (0,react.useMemo)(function() {
        return {
            filterStocks: convertMoversFilterListToEnum(filter),
            moverType: MapMoverEnum[type]
        };
    }, [
        type,
        filter
    ]);
    var onMessageCallback = (0,react.useCallback)(function(batch) {
        setData(convertMoverWStoAPI(batch));
    }, []);
    var onClickPreview = function(symbol) {
        if (router.pathname.includes("/chartbit")) {
            router.push("/symbol/".concat(symbol, "/chartbit"));
        } else {
            router.push("/symbol/".concat(symbol));
        }
    };
    UseMarketMover_useMarketMover(featureKey, request, onMessageCallback);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MoversRemote, {
        platform: "web",
        websocketData: data,
        themeMode: theme/* ThemeMode.Light */.h.Light,
        type: type,
        filter: filter,
        portfolioList: [],
        setType: setType,
        setFilter: setFilter,
        handleClickBuy: null,
        handleClickSell: null,
        handleClickPreview: function(symbol) {
            return onClickPreview(symbol);
        },
        handleClickRow: function(symbol) {
            return onClickPreview(symbol);
        }
    });
};
/* harmony default export */ var movers = (MoversFeature);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Movers/styled.ts

function Movers_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  overflow-y: hidden;\n\n  #movers-wrapper {\n    height: 100%;\n    overflow: auto;\n\n    #movers-table-wrapper {\n      th {\n        font-weight: 400;\n      }\n    }\n\n    #movers-tab-menu-container {\n      padding-left: 8px;\n    }\n\n    #movers-burger-menu {\n      width: auto;\n      > div {\n        padding-right: 16px;\n        padding-left: 16px;\n      }\n    }\n  }\n"
    ]);
    Movers_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Movers_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: #F2F4F5;\n  height: 40px;\n  border-bottom: 1px solid #D7D7D7;\n"
    ]);
    Movers_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Movers_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    Movers_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Movers_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  overflow-y: auto;\n  border-radius: 0 0 8px 8px;\n\n  #movers-table-wrapper {\n    #movers-tab-menu-container {\n      padding-left: 20px;\n      padding-right: 20px;\n\n      #movers-tab-menu-list-container {\n        justify-content: space-between;\n        padding-right: 88px;\n      }\n\n      #movers-burger-menu {\n        right: 20px;\n      }\n    }\n\n    tr {\n      th {\n        font-weight: 400;\n      }\n\n      > td:nth-child(1) {\n        padding-left: 16px;\n      }\n\n      > td:last-child {\n        padding-right: 16px;\n      }\n    }\n  }\n"
    ]);
    Movers_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Movers_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-content {\n    border-radius: 8px;\n\n    .ant-modal-header {\n      border-radius: 8px 8px 0 0;\n    }\n\n    .ant-modal-body {\n      border-radius: 0 0 8px 8px;\n    }\n  }\n"
    ]);
    Movers_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Movers_styled_Flex = ui/* Common.Flex */.Gn.Flex, Movers_styled_Modal = ui/* Common.Modal */.Gn.Modal;
var styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e6471bbc-0"
})(Movers_styled_templateObject());
var Movers_styled_HeaderContainer = (0,styled_components_browser_esm["default"])(Movers_styled_Flex).attrs({
    align: "center",
    justify: "space-between",
    px: "10px"
}).withConfig({
    componentId: "sc-e6471bbc-1"
})(Movers_styled_templateObject1());
var ButtonExpand = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e6471bbc-2"
})(Movers_styled_templateObject2());
var ModalContentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e6471bbc-3"
})(Movers_styled_templateObject3());
var ModalMovers = (0,styled_components_browser_esm["default"])(Movers_styled_Modal).withConfig({
    componentId: "sc-e6471bbc-4"
})(Movers_styled_templateObject4());

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/Movers/index.tsx






var Movers_Text = ui/* Common.Text */.Gn.Text;
var Movers = function() {
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,react.useState)([
        "FILTER_STOCKS_TYPE_MAIN_BOARD",
        "FILTER_STOCKS_TYPE_DEVELOPMENT_BOARD",
        "FILTER_STOCKS_TYPE_ACCELERATION_BOARD",
        "FILTER_STOCKS_TYPE_NEW_ECONOMY_BOARD", 
    ]), filter = ref1[0], setFilter = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Movers_styled_HeaderContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Movers_Text, {
                        weight: "700",
                        children: "Movers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonExpand, {
                        onClick: function() {
                            return setShowModal(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/maximize.svg"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "movers-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(movers, {
                    featureKey: "sidewidget",
                    filter: filter,
                    setFilter: setFilter
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalMovers, {
                width: 940,
                bodyStyle: {
                    height: 700
                },
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Movers_Text, {
                    p: "20px 12px 12px 20px",
                    size: "18px",
                    weight: "700",
                    children: "Movers"
                }),
                centered: true,
                visible: showModal,
                onCancel: function() {
                    setShowModal(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalContentContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(movers, {
                        featureKey: "modal",
                        filter: filter,
                        setFilter: setFilter
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var SideWidget_Movers = (Movers);

;// CONCATENATED MODULE: ./src/global/MainLayout/SideWidget/index.tsx





// eslint-disable-next-line import/named



















var PRICE_ALERT_KEY = "price-alert";
var SideWidget_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var Tooltip = ui/* Widget.Tooltip */.$L.Tooltip;
function SideWidget() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), current = ref.current, isSideWidgetOpen = ref.isSideWidgetOpen, bandarDetectorActiveKey = ref.bandarDetectorActiveKey;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), country = ref1.data.country;
    var isShowSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.visible;
    });
    var alert = (0,es/* useSelector */.v9)(slice/* alertWsSelector */.m5);
    var ref2 = useWidget(current), isPro = ref2.isPro, isAddonPro = ref2.isAddonPro, addCounter = ref2.addCounter;
    var clearPriceAlert = function() {
        dispatch(slice/* default.actions.clearAlert */.ZP.actions.clearAlert());
        localStorage.removeItem(PRICE_ALERT_KEY);
    };
    (0,react.useEffect)(function() {
        if (!isSideWidgetOpen && current !== SideWidget_constants/* SIDE_MENU_KEY.ALL_WATCHLIST */.t2.ALL_WATCHLIST) {
            dispatch(Orderbook_slice/* default.actions.setSymbol */.ZP.actions.setSymbol({
                symbol: "IHSG"
            }));
        }
        if (!isSideWidgetOpen) {
            dispatch(// @ts-ignore
            Valuation_slice/* default.actions.setCurrentScreenerData */.ZP.actions.setCurrentScreenerData({
                page: Valuation_constants/* INITIAL_PAGE */.qe,
                presetId: Valuation_constants/* KENNETH_FISHER_PRICE_TO_SALES_ID */.rz,
                isDataLoaded: false,
                type: ""
            }));
        }
    }, [
        isSideWidgetOpen
    ]);
    // hide sidewidget while search company modal is showing
    if (isShowSearchCompanyModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideWidget_styled/* WidgetContainer */.Hl, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideWidget_styled/* WidgetWrapper */.wv, {
                isOpen: isSideWidgetOpen,
                children: [
                    current === SideWidget_constants/* SIDE_MENU_KEY.ALL_WATCHLIST */.t2.ALL_WATCHLIST && /*#__PURE__*/ (0,jsx_runtime.jsx)(Watchlist, {}),
                    current === SideWidget_constants/* SIDE_MENU_KEY.PRICE_ALERT */.t2.PRICE_ALERT && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_PriceAlert, {
                        isPro: isPro
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.RUNNING_TRADE */.t2.RUNNING_TRADE && /*#__PURE__*/ (0,jsx_runtime.jsx)(RunningTrade/* default */.Z, {
                        isPro: isPro
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.MOVERS */.t2.MOVERS && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_Movers, {}),
                    current === SideWidget_constants/* SIDE_MENU_KEY.VALUATION */.t2.VALUATION && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_Valuation, {
                        isPro: isPro,
                        isProScreener: isAddonPro
                    }),
                    current === SideWidget_constants/* SIDE_MENU_KEY.BANDAR_DETECTOR */.t2.BANDAR_DETECTOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_BandarDetector, {
                        isPro: isPro,
                        activeKey: bandarDetectorActiveKey
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideWidget_styled/* Container */.W2, {
                children: [
                    generateSidewidget(country).map(function(param) {
                        var key = param.key, icon = param.icon, text = param.text, eventName = param.eventName;
                        var isPriceAlert = key === SideWidget_constants/* SIDE_MENU_KEY.PRICE_ALERT */.t2.PRICE_ALERT && !!(alert === null || alert === void 0 ? void 0 : alert.msg);
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                            placement: "left",
                            title: text,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_styled/* ButtonWidget */.bW, {
                                active: current === key,
                                onClick: function() {
                                    if (eventName && current !== key) {
                                        (0,utils_clevertap/* clevertapEvent */.Lq)(clevertap/* CLEVERTAP_EVENT_NAME.SIDE_MENU */.dR.SIDE_MENU, {
                                            Action: eventName
                                        });
                                        addCounter(key);
                                    }
                                    if (isPriceAlert) {
                                        clearPriceAlert();
                                    }
                                    // @ts-ignore
                                    dispatch(MainLayout_slice/* default.actions.setActiveWidget */.ZP.actions.setActiveWidget({
                                        key: key
                                    }));
                                },
                                "data-cy": "right-menu-".concat(eventName),
                                $shouldRenderAfter: isPriceAlert,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_Iconmoon, {
                                    className: icon,
                                    color: "inherit",
                                    hoverColor: "inherit",
                                    size: "20px"
                                })
                            })
                        }, "watchlist-".concat(key));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                        placement: "left",
                        title: "Support",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideWidget_styled/* ButtonWidget */.bW, {
                            "data-cy": "right-menu-support",
                            onClick: crisp/* handleClickSupport */.lA,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "intercom-unread-count"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget_Iconmoon, {
                                    className: "icon-widget_support",
                                    color: "inherit",
                                    hoverColor: "inherit",
                                    size: "20px"
                                })
                            ]
                        })
                    }, "support")
                ]
            })
        ]
    });
}
/* harmony default export */ var MainLayout_SideWidget = (SideWidget);


/***/ }),

/***/ 73164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gi": function() { return /* binding */ SymbolLinkWrapper; },
/* harmony export */   "Hl": function() { return /* binding */ WidgetContainer; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "bW": function() { return /* binding */ ButtonWidget; },
/* harmony export */   "hb": function() { return /* binding */ ButtonTransparent; },
/* harmony export */   "wv": function() { return /* binding */ WidgetWrapper; },
/* harmony export */   "xw": function() { return /* binding */ HumbergerButton; }
/* harmony export */ });
/* unused harmony export Box */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var re_resizable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46312);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-left: 1px solid ",
        ";\n  border-collapse: collapse;\n  box-sizing: border-box;\n  height: 100%;\n  width: 35px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  display: none;\n  z-index: 999;\n  @media ",
        " {\n    height: 100vh;\n    display: flex;\n    position: fixed;\n    top: 0;\n    right: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 100%;\n    border: 1px solid ",
        ";\n    border-right: none;\n    overflow-y: hidden;\n    width: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  z-index: 99;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  background: none;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n\n  &:hover, &:focus {\n    background: none;\n    border: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      border-left: 1px solid ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n      &:after {\n        content: "";\n        display: block;\n        height: 5px;\n        width: 5px;\n        background: ',
        ";\n        position: absolute;\n        top: 21px;\n        right: 8px;\n        border-radius: 50%;\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #fff;\n  border: none;\n  border-bottom: 1px solid #dadada;\n  cursor: pointer;\n  display: block;\n  height: 60px;\n  position: relative;\n  width: 35px;\n\n  &:hover {\n    color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: inherit;\n\n  &:hover {\n    color: inherit;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Button */ .Gn.Button;
var HumbergerButtonDefault = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Widget.HumbergerButton */ .$L.HumbergerButton;
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    direction: "column"
}).withConfig({
    componentId: "sc-a9c7a1f3-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.gainsboro */ .$_.gainsboro);
var WidgetContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-a9c7a1f3-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .device.tablet */ .Uh.tablet);
var WidgetWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-a9c7a1f3-2"
})(function(param) {
    var isOpen = param.isOpen;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.gainsboro */ .$_.gainsboro, isOpen ? "330px" : 0);
});
var Box = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(re_resizable__WEBPACK_IMPORTED_MODULE_1__/* .Resizable */ .e).attrs({
    enable: {
        top: false,
        right: false,
        bottom: true,
        left: false,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false
    }
}).withConfig({
    componentId: "sc-a9c7a1f3-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light);
var ButtonTransparent = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-a9c7a1f3-4"
})(_templateObject4());
var HumbergerButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(HumbergerButtonDefault).withConfig({
    componentId: "sc-a9c7a1f3-5"
})(_templateObject6(), function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.light */ .$_.light, _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.gainsboro */ .$_.gainsboro);
});
var ButtonWidget = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].button.withConfig({
    componentId: "sc-a9c7a1f3-6"
})(_templateObject9(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.primary */ .$_.primary, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.primary */ .$_.primary);
}, function(param) {
    var $shouldRenderAfter = param.$shouldRenderAfter;
    return $shouldRenderAfter && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .color.primary */ .$_.primary);
});
var SymbolLinkWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].a.withConfig({
    componentId: "sc-a9c7a1f3-7"
})(_templateObject10());



/***/ }),

/***/ 9720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ global_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/features/onboarding/constants.ts
var ONBOARDING_MAX_STEP = 4;
var AVATAR_SIZE = {
    BIG: "BIG",
    SMALL: "SMALL",
    PORTRAIT: "PORTRAIT"
};
// DISCOVER PEOPLE
var ONBOARDING_USER_SUGGEST_LIMIT = 30;
var ONBOARDING_USER_SUGGEST_PAGE = 1;
var ONBOARDING_USER_SUGGEST_FILTER = "FILTER_ONBOARDING";
var ONBOARDING_REQUEST_FILTER = {
    limit: ONBOARDING_USER_SUGGEST_LIMIT,
    page: ONBOARDING_USER_SUGGEST_PAGE,
    filter: ONBOARDING_USER_SUGGEST_FILTER
};


;// CONCATENATED MODULE: ./src/hooks/useOnBoarding.ts




function useOnBoarding() {
    var ref = (0,react.useState)(Infinity), onboardingProgress = ref[0], setOnboardingProgress = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref1.data;
    var progress = dataProfile.onboarding, statusOnboarding = dataProfile.onboarding_done;
    (0,react.useEffect)(function() {
        // redirect only if data profile is available
        if (dataProfile.id && statusOnboarding == 0 && progress <= ONBOARDING_MAX_STEP) {
            setOnboardingProgress(progress);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        progress,
        statusOnboarding,
        dataProfile
    ]);
    return {
        onboardingProgress: onboardingProgress
    };
}
/* harmony default export */ var hooks_useOnBoarding = (useOnBoarding);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/utils/uploadImage.js
var utils_uploadImage = __webpack_require__(36684);
;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/ImageProfile/SmallAvatar.jsx




var SmallAvatar = function(param) {
    var avatarProps = param.avatar, _username = param.username, username = _username === void 0 ? null : _username, avatarOverRide = param.avatar_override, custom = param.custom, overlayClassName = param.overlayClassName, state = param.state, onAvatarError = param.onAvatarError, handleImageOnLoad = param.handleImageOnLoad, avatarURL = param.avatarURL;
    var avatarDiv = state.avatarDiv, avatarClass = state.avatarClass;
    var image;
    if (avatarProps) {
        if (avatarProps.match(/\bhttp/i)) {
            image = avatarProps;
        } else {
            image = "".concat(avatarURL, "/").concat(avatarProps);
        }
    } else {
        image = null;
    }
    var avatar = image;
    var lastslashurl = "";
    if (image) lastslashurl = utils_uploadImage/* default.lastSlashURL */.Z.lastSlashURL(avatar);
    var imageDiv;
    if (!lastslashurl || lastslashurl.includes("noimage") || lastslashurl === "0") {
        imageDiv = username ? username.charAt(0).toUpperCase() : "";
    } else {
        if (avatarOverRide) avatar = avatarProps;
        imageDiv = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: "avatar",
            className: "".concat(avatarClass, " ").concat(overlayClassName),
            src: avatar,
            onError: onAvatarError,
            onLoad: handleImageOnLoad
        });
    }
    imageDiv = avatarDiv || imageDiv;
    // Add custom props for avatar notification, tipping, trending => for removing img border
    if (custom === "tipping" || custom === "trending") return imageDiv;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
        "data-username": username,
        children: imageDiv
    });
};
SmallAvatar.propTypes = {
    avatar: (prop_types_default()).string,
    username: (prop_types_default()).string,
    avatar_override: (prop_types_default()).string,
    custom: (prop_types_default()).string,
    overlayClassName: (prop_types_default()).string,
    state: prop_types_default().shape({
        avatarDiv: (prop_types_default()).string,
        avatarClass: (prop_types_default()).string
    }),
    onAvatarError: (prop_types_default()).func,
    handleImageOnLoad: (prop_types_default()).func,
    avatarURL: (prop_types_default()).string.isRequired
};
SmallAvatar.defaultProps = {
    avatar: "",
    username: "",
    avatar_override: "",
    custom: "",
    overlayClassName: "",
    state: {
        avatarDiv: null,
        avatarClass: ""
    },
    onAvatarError: function() {},
    handleImageOnLoad: function() {}
};
/* harmony default export */ var ImageProfile_SmallAvatar = (SmallAvatar);

;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/ImageProfile/BigAvatar.jsx



var BigAvatar = function(param) {
    var avatarProps = param.avatar, tempAvatar = param.temp_avatar, avatarOverRide = param.avatar_override, hideLoader = param.hide_loader, overlayClassName = param.overlayClassName, state = param.state, onAvatarError = param.onAvatarError, handleImageOnLoad = param.handleImageOnLoad, avatarURL = param.avatarURL;
    var avatarClass = state.avatarClass;
    var image;
    if (avatarProps || avatarProps === "") {
        if (avatarProps.match(/\bhttp/i)) {
            image = avatarProps;
        } else {
            image = "".concat(avatarURL, "/").concat(avatarProps);
        }
    } else {
        image = null;
    }
    var avatar = tempAvatar || image;
    var clsLoader = "";
    if (hideLoader && avatar) clsLoader = "hide";
    if (avatarOverRide) avatar = avatarProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "PrimarySpinner ".concat(clsLoader)
            }),
            !hideLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Uploading.."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "avatar",
                    src: avatar,
                    style: {
                        opacity: 1
                    },
                    className: "".concat(avatarClass, " ").concat(overlayClassName),
                    onError: onAvatarError,
                    onLoad: handleImageOnLoad
                })
            })
        ]
    });
};
BigAvatar.propTypes = {
    avatar: (prop_types_default()).string,
    temp_avatar: (prop_types_default()).string,
    avatar_override: (prop_types_default()).string,
    hide_loader: (prop_types_default()).bool,
    overlayClassName: (prop_types_default()).string,
    state: prop_types_default().shape({
        avatarDiv: (prop_types_default()).string,
        avatarClass: (prop_types_default()).string
    }),
    onAvatarError: (prop_types_default()).func,
    handleImageOnLoad: (prop_types_default()).func,
    avatarURL: (prop_types_default()).string.isRequired
};
BigAvatar.defaultProps = {
    avatar: "",
    temp_avatar: "",
    avatar_override: "",
    hide_loader: true,
    overlayClassName: "",
    state: {
        avatarDiv: null,
        avatarClass: ""
    },
    onAvatarError: function() {},
    handleImageOnLoad: function() {}
};
/* harmony default export */ var ImageProfile_BigAvatar = (BigAvatar);

;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/ImageProfile/PortraitAvatar.jsx



var PortraitAvatar = function(param) {
    var avatarProps = param.avatar, tempAvatar = param.temp_avatar, hideLoader = param.hide_loader, avatarURL = param.avatarURL;
    var image;
    if (avatarProps) {
        if (avatarProps.match(/\bhttp/i)) {
            image = avatarProps;
        } else {
            image = "".concat(avatarURL, "/").concat(avatarProps);
        }
    } else {
        image = null;
    }
    var avatar = tempAvatar || image;
    var clsLoader = "";
    if (hideLoader && avatar) clsLoader = "hide";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "PrimarySpinner ".concat(clsLoader)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "avatar",
                    src: avatar
                })
            })
        ]
    });
};
PortraitAvatar.propTypes = {
    avatar: (prop_types_default()).string,
    temp_avatar: (prop_types_default()).string,
    hide_loader: (prop_types_default()).bool,
    avatarURL: (prop_types_default()).string.isRequired
};
PortraitAvatar.defaultProps = {
    avatar: "",
    temp_avatar: "",
    hide_loader: true
};
/* harmony default export */ var ImageProfile_PortraitAvatar = (PortraitAvatar);

// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/ImageProfile/index.jsx





// components



// contants


function ImageProfile(props) {
    var ref = (0,react.useState)(null), avatarDiv = ref[0], setAvatarDiv = ref[1];
    var ref1 = (0,react.useState)(""), avatarClass = ref1[0], setAvatarClass = ref1[1];
    var mode = props.mode;
    var handleImageOnLoad = function() {
        setAvatarClass("popavatar");
    };
    var onAvatarError = function() {
        var username = props.username;
        var initial = username ? username.charAt(0) : null;
        setAvatarDiv(initial);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            mode === AVATAR_SIZE.BIG && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProfile_BigAvatar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                state: {
                    avatarDiv: avatarDiv,
                    avatarClass: avatarClass
                },
                onAvatarError: onAvatarError,
                handleImageOnLoad: handleImageOnLoad
            })),
            mode === AVATAR_SIZE.SMALL && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProfile_SmallAvatar, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                state: {
                    avatarDiv: avatarDiv,
                    avatarClass: avatarClass
                },
                onAvatarError: onAvatarError,
                handleImageOnLoad: handleImageOnLoad
            })),
            mode === AVATAR_SIZE.PORTRAIT && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProfile_PortraitAvatar, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
}
ImageProfile.propTypes = {
    mode: prop_types_default().oneOf([
        AVATAR_SIZE.BIG,
        AVATAR_SIZE.SMALL,
        AVATAR_SIZE.PORTRAIT, 
    ]),
    avatar_override: (prop_types_default()).string,
    custom: (prop_types_default()).string,
    avatar: (prop_types_default()).string,
    temp_avatar: (prop_types_default()).string,
    hide_loader: (prop_types_default()).bool,
    overlayClassName: (prop_types_default()).string,
    username: (prop_types_default()).string,
    avatarURL: (prop_types_default()).string
};
ImageProfile.defaultProps = {
    mode: AVATAR_SIZE.SMALL,
    avatar_override: "",
    custom: "",
    avatar: "",
    temp_avatar: "",
    hide_loader: true,
    overlayClassName: "",
    username: "",
    avatarURL: api/* AVATAR_URL */.q$
};
/* harmony default export */ var UploadProfilePicture_ImageProfile = (ImageProfile);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CloseOutlined.js + 1 modules
var CloseOutlined = __webpack_require__(97937);
;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/ComposeModalCroppingImage/index.jsx






var Avatar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6761).then(__webpack_require__.t.bind(__webpack_require__, 96761, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96761)
            ];
        }
    },
    ssr: false
});
// ComposeModalCroppingImage Component
function ComposeModalCroppingImage(param) {
    var buttonSubmitTitle = param.buttonSubmitTitle, title = param.title, src = param.src, onCloseModal = param.onCloseModal, onCancelModal = param.onCancelModal, onSubmitModal = param.onSubmitModal;
    var ref = (0,react.useState)(buttonSubmitTitle), textBtnSubmit = ref[0], setTextBtnSubmit = ref[1];
    var ref1 = (0,react.useState)(""), preview = ref1[0], setPreview = ref1[1];
    (0,react.useEffect)(function() {
        setTextBtnSubmit(buttonSubmitTitle);
    }, [
        buttonSubmitTitle
    ]);
    // func onCrop to set preview image
    var onCrop = function(croppedImage) {
        setPreview(croppedImage);
    };
    // func onClose set preview image to null
    var onClose = function() {
        setPreview(null);
    };
    var onSubmitForm = function(e) {
        e.preventDefault();
        if (!preview) return false;
        onSubmitModal(preview);
        return false;
    };
    var handlerCloseModal = function(e) {
        e.preventDefault();
        if (typeof onCloseModal === "function") {
            onCloseModal();
        }
        onCancelModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "modal-cropping",
        className: " option-wrap modal-wl-edit",
        style: {
            display: "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            onSubmit: onSubmitForm,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "modal-general-in",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseOutlined/* default */.Z, {
                            role: "button",
                            "aria-label": "Close cropped image",
                            tabIndex: "0",
                            className: "modal-title-close close-option",
                            onClick: handlerCloseModal,
                            onKeyUp: handlerCloseModal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "modal-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "circle-cropping",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                        imageHeight: 280,
                                        width: 390,
                                        height: 295,
                                        src: src,
                                        onCrop: onCrop,
                                        onClose: onClose,
                                        minCropRadius: 0
                                    })
                                }),
                                preview && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    style: {
                                        width: "200px",
                                        height: "200px",
                                        display: "block",
                                        margin: "0 auto"
                                    },
                                    src: preview,
                                    alt: "Preview"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "button",
                            defaultValue: "Cancel",
                            className: "option modal-button modal-cancel",
                            onClick: handlerCloseModal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "croppingavatar",
                            type: "submit",
                            value: textBtnSubmit,
                            className: "option modal-button modal-save"
                        })
                    ]
                })
            })
        })
    });
}
ComposeModalCroppingImage.propTypes = {
    onCancelModal: (prop_types_default()).func,
    onSubmitModal: (prop_types_default()).func,
    onCloseModal: (prop_types_default()).func,
    buttonSubmitTitle: (prop_types_default()).string,
    title: (prop_types_default()).string,
    src: (prop_types_default()).string
};
ComposeModalCroppingImage.defaultProps = {
    onCancelModal: function() {},
    onSubmitModal: function() {},
    onCloseModal: function() {},
    buttonSubmitTitle: "Save",
    title: "",
    src: ""
};
/* harmony default export */ var UploadProfilePicture_ComposeModalCroppingImage = (ComposeModalCroppingImage);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
;// CONCATENATED MODULE: ./src/features/onboarding/styled.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .hide {\n    display: none !important;\n  }\n\n  .boarding-cover {\n    font-size: 16px;\n    z-index: 1000;\n    top: 0;\n    left: 0;\n    right: 0;\n    border: 1px solid #dadada;\n    width: 100%;\n    margin: auto;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.8);\n    display: table;\n    position: fixed;\n  }\n\n  .boarding-content {\n    transform-origin: bottom center;\n    animation: fade-in-pulse 0.3s forwards cubic-bezier(0.8, 0.02, 0.45, 0.91);\n\n    text-align: center;\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    background: #fff;\n\n    &.ob-discover {\n      @media only screen and (max-height: 600px) {\n        justify-content: flex-start;\n        overflow: auto;\n        padding-top: 60px;\n      }\n    }\n  }\n\n  .boarding-in {\n    width: 600px;\n\n    position: relative;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n\n    @media only screen and (max-width: 500px) {\n      width: 100%;\n    }\n  }\n\n  .boarding-title {\n    font-size: 18px;\n    font-family: var(--bold-font);\n    margin-bottom: 10px;\n\n    @media only screen and (max-width: 500px) {\n      margin-bottom: 20px;\n    }\n  }\n\n  .boarding-text {\n    line-height: 1.3;\n    font-size: 14px;\n\n    @media only screen and (max-width: 500px) {\n      padding: 0 20px;\n    }\n  }\n\n  .boarding-skip {\n    margin: 10px 0;\n    color: #b5b5b5;\n    font-size: 13px;\n    margin-top: 20px;\n    cursor: pointer;\n\n    &:hover {\n      color: #333;\n    }\n  }\n\n  .boarding-button-next {\n    display: inline-block;\n    margin: 20px 0 30px;\n    padding: 0 15px;\n    line-height: 40px;\n    height: 40px;\n    border-radius: 2px;\n    background: #b5b5b5;\n    color: #fff;\n    cursor: pointer;\n    transition: all 0.1s cubic-bezier(0.98, 0.01, 1, 1);\n  }\n\n  .boarding-button-next:hover,\n  .boarding-button-finish:hover {\n    background: #00ab6b;\n  }\n\n  .PrimarySpinner {\n    min-width: 100px;\n    min-height: 100px;\n    position: relative;\n  }\n\n  .PrimarySpinner:before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n  }\n\n  .PrimarySpinner:before {\n    content: '';\n    border-radius: 50%;\n    border-top: 2px solid #ccc;\n    border-right: 2px solid transparent;\n    animation: spinner 0.7s linear infinite;\n    -webkit-animation: spinner 0.7s linear infinite;\n  }\n\n  .boarding-button-back {\n    color: #b5b5b5;\n    position: absolute;\n    top: 2px;\n    left: 0px;\n    cursor: pointer;\n  }\n\n  @media only screen and (max-width: 500px) {\n    .boarding-button-back {\n      left: 20px !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


// copy from web legacy in build.css
var OnBoardingWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-654cb0ba-0"
})(_templateObject());
/* harmony default export */ var styled = (OnBoardingWrapper);

// EXTERNAL MODULE: ./src/global/Loading/SecondarySpinner.tsx
var SecondarySpinner = __webpack_require__(32447);
;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/styled.js

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  #compose-modal-cropping:empty {\n    z-index: -1;\n    opacity: 0;\n  }\n\n  #compose-modal-cropping {\n    overflow-y: auto;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.8);\n    z-index: 1100;\n    display: flex;\n    opacity: 1;\n    align-items: center;\n    justify-content: center;\n    padding: 50px 20%;\n  }\n\n  .modal-general-in {\n    background: #fff;\n    border-radius: 2px;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .modal-title-close {\n    width: 30px;\n    height: 43px;\n    position: absolute;\n    right: 10px;\n    top: 16px;\n    /* background: url(/icon/close.png) right center / 20px auto no-repeat; */\n    cursor: pointer;\n  }\n\n  .modal-title {\n    padding: 10px 15px;\n    font-weight: bold;\n    font-size: 18px;\n    cursor: pointer;\n    border-bottom: solid 1px #dadada;\n  }\n\n  .circle-cropping > div > div > div > div {\n    border-radius: 50%;\n  }\n\n  .modal-button {\n    width: 50%;\n    display: block;\n    float: left;\n    border: 0;\n    padding: 10px;\n    background: #fff;\n    cursor: pointer;\n  }\n\n  .modal-button:first-of-type {\n    border-radius: 0 0 0 2px;\n  }\n\n  .modal-button:last-of-type {\n    border-radius: 0 0 2px;\n    border-left: solid 1px #dadada;\n  }\n  .modal-save {\n    background: #00ab6b;\n    border-top: solid 1px #00ab6b;\n    color: #fff;\n  }\n\n  .modal-cancel {\n    border-top: solid 1px #dadada;\n  }\n\n  .boarding-avatar {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin: 0 auto 30px auto;\n    background: #ddd no-repeat center center / 51px auto\n      url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADF0lEQVRo3u1awXHiQBBsXP6jDKwMTAZWBlYGwJupOjKwHIH1mL9xBiKCkzMQGYgIDiLwfXqv5lQCW9IiTj5tFaUSsKvtmemZnoXJx8cHvsu4wTcaI5gRTA/jtusCIhIAmPnYjKrmXeZPumQzEUkB/PBo3D2AtapmvYIRkQWA1wtEyxFAqKqHPsNswetWVWMP4RoCKABMuXbaZwJwPMk88aUkGAAIe8tmJP2Ut6XHECsqhurFM7OaDfgYjidB6wRASycNLBIAuAdwVNXAFxIRiQD85O17g6mZqqYuAeTcXNuw8O0ZAHhoMO9BRMLJarWy1tg23GCpqhufaEQkaTgldlHyFxhVnQxNwtjQvL3QA0JaLCK/Zsx6B16zJlXerOf4UV5Em9Wk7BTAvObje8OFuYjsASSfhWmN0ngRkWXdvBuPQGJafW5kyRbAM4Alr88Advz8DsCriOQ0Qt2asxOS6ZXe8u+ZivWO9E56Ql8l3MiGXnoAkItIVPN9K5OWVAZPRk4lvluAyADZA4hVtfiCdIlEZA3ghSGYn6lzR2bZwoDx25wxPDbmgbPPgFRApbQ4ANzXpGW31pRgbb+T+ebMmrEPeqSxbCeRt7x9slxgxnszgJwefKszmg8wbvEuXeKCnrWthQO0oPe2fC35nr/UTK44S6VdLKKqBxHJmAnjKrHpvU+VRhfPRI70TXhyTixW6tFVTmd89TNlpb4M96ip4t1g0GDqKvo1wISe8MyMl/K+wbgH3vmwqpEuu949Q+u52pB0DLHASvxrhZmrL/O2GYhjw5p17FKzfIBx3slOSfkvKO5Ht14bSeQFDB8cm/4kb+IhqmanuHeq2ilcO2czcmdpqncuIsk5L4lIJCI55b8jfdR1L16aM1XdiMjBxP4TgDU3XJgjpJCbtpLlva3ivtgZgKpmDLGEgnFKLjyemPKlM4CrgDEd5IJNlj2dCY3+KgDkbX+D6Q1MBVTatTUYrDYbwZwD06bo/QMjsJyxKfGXiAzVMfsbNkVvA4+wI4D1n1+bWSOCgYIpVbWcjP9qGsGMYP5fML8Bx5lBVIkOEH8AAAAASUVORK5CYII=');\n    display: block;\n    margin: auto;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-bottom: 30px;\n    cursor: pointer;\n  }\n\n  .spinner-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin: 0 auto 30px auto;\n    background: #ddd;\n    margin: auto;\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    overflow: hidden;\n    margin-bottom: 30px;\n    cursor: pointer;\n  }\n\n  .boarding-avatar img {\n    width: 100%;\n  }\n\n  .boarding-avatar .PrimarySpinner {\n    min-height: 0;\n  }\n\n  .boarding-avatar\xa0.loading .generalspinner,\n  .boarding-avatar.loading .PrimarySpinner {\n    height: 120px;\n  }\n\n  .popavatar {\n    width: 100%;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n    -webkit-animation-name: popimg;\n    animation-name: popimg;\n  }\n\n  .circle-cropping > div > div {\n    display: inherit !important;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  div {\n    color: white;\n    height: 30px;\n    width: 30px;\n    border-bottom-color: white;\n    border-left-color: white;\n    border-top-color: white;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


// copy from web legacy in build.css
var UploadProfilePictureWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-43cdaa3d-0"
})(styled_templateObject());
var CustomSpinner = (0,styled_components_browser_esm["default"])(SecondarySpinner/* default */.Z).withConfig({
    componentId: "sc-43cdaa3d-1"
})(_templateObject1());


// EXTERNAL MODULE: ./src/lib/entities/onboarding.ts
var onboarding = __webpack_require__(21939);
// EXTERNAL MODULE: ./src/features/onboarding/UploadProfilePicture/slice.ts
var slice = __webpack_require__(12229);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
;// CONCATENATED MODULE: ./src/features/onboarding/UploadProfilePicture/index.jsx


















function UploadProfilePicture() {
    var ref = (0,react.useState)(false), avatarLoading = ref[0], setAvatarLoading = ref[1];
    var ref1 = (0,react.useState)(null), imagePreviewUrl = ref1[0], setImagePreviewUrl = ref1[1];
    var ref2 = (0,react.useState)(null), imageCropBuffer = ref2[0], setImageCropBuffer = ref2[1];
    var ref3 = (0,react.useState)({}), imageInput = ref3[0], setImageInput = ref3[1];
    var ref4 = (0,react.useState)(null), imageCropBufferReady = ref4[0], setImageCropBufferReady = ref4[1];
    var ref5 = (0,react.useState)(false), showModalCroppingImage = ref5[0], setShowModalCroppingImage = ref5[1];
    var ref6 = (0,react.useState)("jpg"), outputFormat = ref6[0], setOutputFormat = ref6[1];
    var ref7 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref7.data, isLoadingProfile = ref7.isLoading;
    var uploadToken = (0,es/* useSelector */.v9)(slice/* selectors */.wl).uploadToken;
    var data = uploadToken.data;
    var dispatch = (0,es/* useDispatch */.I0)();
    var username = dataProfile.username, progress = dataProfile.onboarding, avatar = dataProfile.avatar;
    (0,react.useEffect)(function() {
        setAvatarLoading(isLoadingProfile);
    }, [
        isLoadingProfile
    ]);
    /**
   * isNoImageAvatar
   * to check no image avatar from API
   * @param {string} imageURL
   * @return {boolean}
   */ var isNoImageAvatar = function(imageURL) {
        if (!imageURL) return false;
        return imageURL === "0" || imageURL === "noimage.jpg" || imageURL.indexOf("noimage.png") > -1;
    };
    /**
   * Handling intention to change avatar by linking the event to hidden image
   * input click
   */ var handleChangeAvatar = function(event) {
        event.preventDefault(); // prevent default
        event.stopPropagation();
        imageInput.click(); // Channel click event
    };
    var handleNextStep = function(event) {
        if (event.type === "click" || event.type === "keydown" && (event.key === "Enter" || event.key === " ")) {
            var nextStep = progress + 1;
            dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(parseInt(nextStep, 10)));
        }
    };
    var handleAvatarLoad = function() {
        var imagefile = document.getElementById("hide_avatar");
        var oldCrop = document.getElementById("modal-cropping"); // use element canvas id #canvas-editor Component Landing
        if (typeof oldCrop !== "undefined" && oldCrop != null) {
            // destroy canvas
            oldCrop.style.display = "none";
        }
        // Process to fix image ratio
        var canvas = document.getElementById("canvas-editor"); // use element canvas id #canvas-editor Component Landing
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        var width = imagefile.width, height = imagefile.height;
        var MAX_WIDTH = 0.6 * window.screen.availWidth; // 70 %
        var MAX_HEIGHT = 0.6 * window.screen.availHeight; // 70 %
        if (width > height) {
            // landscape
            if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width;
                width = MAX_WIDTH;
            }
        } else if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
        }
        width = Math.round(width);
        height = Math.round(height);
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(imagefile, 0, 0, width, height);
        var dataurl = canvas.toDataURL("image/png");
        // trigger component ComposeModalCroppingImage to open
        setImageCropBufferReady(dataurl);
        setShowModalCroppingImage(true);
    };
    /**
   * handleImageChange
   * Handling image input value change
   */ var handleImageChange = function(event) {
        event.preventDefault();
        var reader = new FileReader();
        var file = event.target.files[0]; // Avatar ImageFile object
        var fileOutputFormat = "jpg";
        if (!file) return false;
        if (file.length < 1) return false;
        // Only process image files type: JPEG, JPG, PNG, and GIF.
        if (!file.type.match("image.jpeg") && !file.type.match("image.jpg") && !file.type.match("image.png") && !file.type.match("image.gif")) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.UPLOAD_IMAGE_TYPE_NOT_SUPPORTED */.Z.UPLOAD_IMAGE_TYPE_NOT_SUPPORTED, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return false;
        }
        // Max size 1 MB = 1048576 bytes.
        // if (file.size > 1048576) {
        if (file.size > 2097152) {
            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.MAX_FILE_SIZE */.Z.MAX_FILE_SIZE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
            return false;
        }
        // Clean imageCropBuffer dom for other/same file upload trial
        document.querySelector("input.fileInput").value = "";
        // Closure to capture the file information.
        reader.onloadend = function() {
            if (file.type === "image/png") {
                fileOutputFormat = "png";
            }
            setImageCropBuffer(reader.result);
            setOutputFormat(fileOutputFormat);
        };
        // Read in the image file as a data URL.
        reader.readAsDataURL(file);
        return true;
    };
    /**
   * handleCancelModal
   * Hide crop image modal
   */ var handleCancelModal = function() {
        // Clean imageCropBuffer dom for other/same file upload trial
        document.querySelector("input.fileInput").value = "";
        // update state
        setShowModalCroppingImage(false);
        setImageCropBuffer(null);
        setImageCropBufferReady(null);
    };
    /**
   * handleCroppingImage
   * Handle image crop after being submited by modal
   */ var handleCroppingImage = function(image) {
        setAvatarLoading(true);
        // Clean imageCropBuffer dom for other/same file upload trial
        document.querySelector("input.fileInput").value = "";
        // update state
        setImagePreviewUrl(image);
        setShowModalCroppingImage(false);
        setImageCropBuffer(image);
    // handleSubmitAction();
    };
    var uploadAvatar = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(newFileName) {
            var uploadToken, _payload, errorUploadToken, key, file, uploadImage, _payload1, errorUploadImage, editProfile, _payload2, errorEditProfile;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.retrieveUploadToken */.Sz.retrieveUploadToken(newFileName));
                    case 2:
                        uploadToken = _ctx.sent;
                        _payload = uploadToken.payload, errorUploadToken = _payload.error;
                        if (!errorUploadToken) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 6:
                        key = uploadToken.payload.data.fields[0].value;
                        file = utils_uploadImage/* default.base64ToImage */.Z.base64ToImage(imagePreviewUrl);
                        _ctx.next = 10;
                        return dispatch(slice/* effects.uploadImageAvatar */.Sz.uploadImageAvatar({
                            file: file,
                            newFileName: newFileName
                        }));
                    case 10:
                        uploadImage = _ctx.sent;
                        _payload1 = uploadImage.payload, errorUploadImage = _payload1.error;
                        if (!errorUploadImage) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        if (!key) {
                            _ctx.next = 24;
                            break;
                        }
                        _ctx.next = 17;
                        return dispatch(profile/* effects.editUserProfile */.Sz.editUserProfile({
                            avatar: key
                        }));
                    case 17:
                        editProfile = _ctx.sent;
                        _payload2 = editProfile.payload, errorEditProfile = _payload2.error;
                        if (!errorEditProfile) {
                            _ctx.next = 23;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 23:
                        {
                            (0,AlertErrorMessage/* default */.Z)(successMessage/* default.PROFILE_UPDATED */.Z.PROFILE_UPDATED, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                            setTimeout(function() {
                                var nextStep = progress + 1;
                                dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(parseInt(nextStep, 10)));
                            }, 1500);
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function uploadAvatar(newFileName) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (imagePreviewUrl) {
            var newFileName = utils_uploadImage/* default.formatUploadImageName */.Z.formatUploadImageName("jpeg");
            var sourceImage = document.querySelector(".editavatar");
            var resultImage = document.getElementById("result_image");
            if (sourceImage && sourceImage.src === "") {
                (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.PLEASE_LOAD_IMAGE */.Z.PLEASE_LOAD_IMAGE, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                return false;
            }
            handleCancelModal();
            // compress image then HIT API
            utils_uploadImage/* default.imageCompressor */.Z.imageCompressor(sourceImage, outputFormat).then(function(dataurl) {
                resultImage.src = dataurl;
                return uploadAvatar(newFileName);
            });
        }
    }, [
        imagePreviewUrl
    ]);
    // avatarContainerClassName to dynamic className
    var avatarContainerClassName = "boarding-avatar ".concat(avatarLoading ? "loading" : "", " ").concat(isNoImageAvatar(avatar) ? "avatar-not-set" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "boarding-cover",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "boarding-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadProfilePictureWrapper, {
                    className: "boarding-in",
                    children: [
                        avatarLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "spinner-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSpinner, {})
                        }),
                        !avatarLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: avatarContainerClassName,
                            onClick: handleChangeAvatar,
                            onKeyDown: handleChangeAvatar,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadProfilePicture_ImageProfile, {
                                overlayClassName: "editavatar",
                                mode: "BIG",
                                temp_avatar: imagePreviewUrl,
                                avatar: avatar,
                                username: username,
                                hide_loader: !avatarLoading,
                                avatarURL: api/* AWS_AVATAR_BUCKET */.cU
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "boarding-title",
                            children: "Upload Profile Picture"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "boarding-text",
                            children: "Upload your profile photo so your friend know it's you."
                        }),
                        isNoImageAvatar(avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: "boarding-button",
                            onClick: handleChangeAvatar,
                            onKeyDown: handleChangeAvatar,
                            children: [
                                " ",
                                "Upload Photo",
                                " "
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: "boarding-button-next",
                            onClick: handleNextStep,
                            onKeyDown: handleNextStep,
                            children: "Next"
                        }),
                        isNoImageAvatar(avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: "boarding-skip",
                            onClick: handleNextStep,
                            onKeyDown: handleNextStep,
                            children: "Skip"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "hide_avatar",
                                    hidden: true,
                                    id: "hide_avatar",
                                    src: imageCropBuffer,
                                    className: "hide",
                                    onLoad: handleAvatarLoad
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "result_image",
                                    hidden: true,
                                    id: "result_image",
                                    className: "img_container hide"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    ref: function(fileImage) {
                                        setImageInput(fileImage);
                                    },
                                    className: "fileInput",
                                    type: "file",
                                    onChange: handleImageChange,
                                    style: {
                                        display: "none"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cropping-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "compose-modal-cropping",
                                        children: showModalCroppingImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadProfilePicture_ComposeModalCroppingImage, {
                                            elementSelector: "#compose-modal-cropping",
                                            title: "Cropping Image",
                                            src: imageCropBufferReady,
                                            onSubmitModal: handleCroppingImage,
                                            onCancelModal: handleCancelModal,
                                            buttonSubmitTitle: "Crop & Apply"
                                        }) : null
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: "canvas-editor-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("canvas", {
                                            id: "canvas-editor",
                                            className: "hide",
                                            width: "400",
                                            height: "400"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var onboarding_UploadProfilePicture = (UploadProfilePicture);

// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/Search/styled.ts

function Search_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-input-affix-wrapper {\n    &:hover {\n      border: 1px solid ",
        ";\n    }\n  }\n  input {\n    ::placeholder {\n      font-family: var(--bold-font);\n      color: #e3e3e3 !important;\n    }\n  }\n  .ant-select-dropdown {\n    width: 340px !important;\n  }\n"
    ]);
    Search_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BaseAutoComplete = ui/* Common.Autocomplete */.Gn.Autocomplete;
var Autocomplete = (0,styled_components_browser_esm["default"])(BaseAutoComplete).withConfig({
    componentId: "sc-e34685fa-0"
})(Search_styled_templateObject(), ui/* color.gainsboro */.$_.gainsboro);


// EXTERNAL MODULE: ./src/features/onboarding/OnBoardingLayout/styled.js
var OnBoardingLayout_styled = __webpack_require__(43774);
;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/Search/index.jsx




var Input = ui/* Common.Input */.Gn.Input, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function Search(param) {
    var options = param.options, onSelect = param.onSelect, onSearch = param.onSearch, onChange = param.onChange, value = param.value;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* Relative */.Ig, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete, {
            options: options,
            width: "100%",
            onSelect: onSelect,
            onSearch: onSearch,
            mb: "8px",
            getPopupContainer: function(trigger) {
                return trigger.parentElement;
            },
            value: value,
            onChange: onChange,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                    className: "icon-avatar_search"
                }),
                placeholder: "Type here to add people ...",
                height: "36px",
                width: "100%"
            })
        })
    });
}
/* harmony default export */ var DiscoverPeople_Search = (Search);

// EXTERNAL MODULE: ./src/features/onboarding/DiscoverPeople/constants.ts
var constants = __webpack_require__(86033);
;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/FollowSuggestions/SuggestionsItem/index.tsx







var SuggestionsItem_Avatar = ui/* Common.Avatar */.Gn.Avatar;
// FollowSuggestions Compoonent
// web legacy
// app\components\general\dumb\OnboardingPage\OnboardingStepThree\OnboardingStepThree.js
function SuggestionsItem(param) {
    var index = param.index, dataUserSuggestion = param.dataUserSuggestion, onFollow = param.onFollow;
    var user = dataUserSuggestion.user, reason = dataUserSuggestion.reason;
    var userId = user.id, userAvatar = user.user_avatar, username = user.username;
    var followedLabel = user.follow ? "Following" : "Follow";
    var followedClass = user.follow ? "following" : "follow";
    /**
   * onFollowUser
   * call handleActionFollowUnfollow
   * with userId, user status followed and username
   * @param {*} e event
   */ var onFollowUser = function(e) {
        e.preventDefault();
        onFollow(index, userId, user.follow, constants/* DISCOVER_PEOPLE_STATE.SUGGEST */.v.SUGGEST);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "boarding-list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "boarding-list-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        marginTop: "3px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "stream-avatar",
                        "data-username": username,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionsItem_Avatar, {
                            size: "medium",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: userAvatar,
                                src: "".concat(api/* AVATAR_URL */.q$, "/").concat(userAvatar),
                                style: {
                                    width: 40,
                                    height: 40
                                },
                                onError: function(e) {
                                    return (0,general/* handleErrorAvatar */.Tk)(e, username);
                                }
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "follow-bio",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "follow-bio-in",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "follow-bio-username",
                                children: [
                                    username,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: user === null || user === void 0 ? void 0 : user.is_verified,
                                        verifiedStatus: user === null || user === void 0 ? void 0 : user.verified_status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "follow-bio-reason",
                                children: reason
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: "button follow-".concat(followedClass),
                        onClick: onFollowUser,
                        onKeyUp: onFollowUser,
                        children: followedLabel
                    })
                })
            ]
        })
    }, "trending_user_".concat(userId));
}
/* harmony default export */ var FollowSuggestions_SuggestionsItem = (SuggestionsItem);

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/FollowSuggestions/index.tsx



// FollowSuggestions Compoonent
// web legacy
// app\components\general\dumb\OnboardingPage\OnboardingStepThree\OnboardingStepThree.js
function FollowSuggestions(param) {
    var isLoadingDataSugggestFriends = param.isLoadingDataSugggestFriends, dataGetSuggestFriends = param.dataGetSuggestFriends, onFollow = param.onFollow;
    var suggestionsResultStyle = {
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
    };
    var handleFollow = function(index, user) {
        var _user = user.user, follow = _user.follow, userid = _user.userid;
        onFollow(index, follow, userid, constants/* DISCOVER_PEOPLE_STATE.SUGGEST */.v.SUGGEST);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isLoadingDataSugggestFriends && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: suggestionsResultStyle,
                children: "Loading"
            }),
            dataGetSuggestFriends.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: suggestionsResultStyle,
                children: "There is no suggestions available."
            }),
            dataGetSuggestFriends.length > 0 && dataGetSuggestFriends.map(function(user, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowSuggestions_SuggestionsItem, {
                    index: index,
                    dataUserSuggestion: user,
                    onFollow: function() {
                        return handleFollow(index, user);
                    }
                }, user.user.userid);
            })
        ]
    });
}
/* harmony default export */ var DiscoverPeople_FollowSuggestions = (FollowSuggestions);

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/UserSearchItem/index.tsx







var Flex = ui/* Common.Flex */.Gn.Flex, UserSearchItem_Avatar = ui/* Common.Avatar */.Gn.Avatar;
// UserSearchItem Compoonent
// web legacy
// app\components\general\dumb\OnboardingPage\OnboardingStepThree\UserSearchItem.js
function UserSearchItem(param) {
    var index = param.index, dataUserSearch = param.dataUserSearch, onFollow = param.onFollow;
    var userId = dataUserSearch.id, img = dataUserSearch.img, name = dataUserSearch.name, followed = dataUserSearch.is_following, desc = dataUserSearch.desc, isVerified = dataUserSearch.is_verified;
    var followedLabel = followed ? "Following" : "Follow";
    var followedClass = followed ? "following" : "follow";
    /**
   * onFollowUser
   * call onFollow
   * with userId, user status followed and username
   * @param {*} e event
   */ var onFollowUser = function(e) {
        e.preventDefault();
        onFollow(index, followed, userId, constants/* DISCOVER_PEOPLE_STATE.SEARCH */.v.SEARCH);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "boarding-list",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "boarding-list-item",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "stream-avatar",
                    "data-username": name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserSearchItem_Avatar, {
                        size: "medium",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: img,
                            src: "".concat(api/* AVATAR_URL */.q$, "/").concat(img),
                            style: {
                                width: 40,
                                height: 40
                            },
                            onError: function(e) {
                                return (0,general/* handleErrorAvatar */.Tk)(e, name);
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "follow-bio",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "follow-bio-in",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                                align: "center",
                                direction: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: isVerified,
                                        verifiedStatus: dataUserSearch === null || dataUserSearch === void 0 ? void 0 : dataUserSearch.verified_status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: desc
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    role: "button",
                    tabIndex: 0,
                    className: "button follow-".concat(followedClass),
                    onClick: onFollowUser,
                    onKeyUp: onFollowUser,
                    children: followedLabel
                })
            ]
        })
    }, "trending_user_".concat(userId));
}
/* harmony default export */ var DiscoverPeople_UserSearchItem = (UserSearchItem);

// EXTERNAL MODULE: ./src/features/onboarding/DiscoverPeople/slice.ts
var DiscoverPeople_slice = __webpack_require__(36203);
;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/styled.ts

function DiscoverPeople_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 545px;\n\n  .stream-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 40px;\n    background: #a2a7b0;\n    color: #fff;\n    text-align: center;\n    font-size: 20px;\n    font-style: normal;\n  }\n\n  .boarding-list-wrap {\n    height: 448px;\n    overflow-y: scroll;\n    margin-right: -15px;\n    padding-right: 12px;\n  }\n\n  .boarding-in.people .boarding-list-wrap {\n    height: 480px;\n  }\n\n  @media screen and (max-height: 800px) {\n    .boarding-list-wrap {\n      height: 390px;\n    }\n    .boarding-in.people .boarding-list-wrap {\n      height: 420px;\n    }\n  }\n\n  @media only screen and (max-width: 500px) {\n    .boarding-list {\n      width: calc(100vw - 40px);\n    }\n\n    .boarding-list-wrap {\n      height: 280px;\n      overflow-y: scroll;\n    }\n    .boarding-in.people .boarding-list-wrap {\n      height: 300px;\n    }\n\n    .boarding-in.company .follow-bio {\n      width: calc(100% - 80px);\n      margin: 0;\n    }\n  }\n\n  .boarding-search-wrap {\n    position: relative;\n  }\n\n  .boarding-list {\n    font-size: 14px;\n  }\n\n  .boarding-list-item {\n    display: flex;\n    align-item: center;\n    padding: 5px 0;\n  }\n\n  .boarding-list-item > * {\n    display: inline-block;\n    vertical-align: middle;\n  }\n\n  .follow-bio {\n    width: calc(100% - 185px);\n    color: #6b6b6b;\n    margin: 0 20px;\n  }\n\n  .follow-bio.no-avatar {\n    width: calc(100% - 120px);\n    margin: 0 20px 0 0;\n  }\n\n  .follow-bio a {\n    color: #333333;\n    font-weight: bold;\n  }\n\n  .follow-bio div {\n    word-break: break-word;\n  }\n\n  .boarding-list-item .follow-bio-in {\n    text-align: left;\n    margin: 0;\n  }\n\n  .follow-bio-in .follow-bio-username {\n    font-size: 16px;\n    color: #333333;\n  }\n\n  .follow-bio-in .follow-bio-reason {\n    font-size: 13.5px;\n    color: #969696;\n  }\n\n  .boarding-list.stock-list .follow-bio {\n    width: calc(100% - 140px);\n  }\n\n  .boarding-list .follow-bio-in > * {\n    display: block;\n    vertical-align: middle;\n  }\n\n  @media screen and (max-width: 720px) {\n    .follow-bio {\n      font-size: 13px;\n      margin: 0 15px;\n    }\n\n    .follow-bio div {\n      margin-top: 2px;\n    }\n\n    .stream-avatar {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 40px;\n      margin: 0 auto;\n      border-radius: 40px;\n      background: #a2a7b0;\n      color: #fff;\n      text-align: center;\n      font-size: 20px;\n      font-style: normal;\n    }\n\n    .follow-following,\n    .follow-follow {\n      width: 80px;\n    }\n  }\n\n  .boarding-in.company .follow-bio {\n    width: calc(100% - 100px);\n    margin: 0;\n  }\n\n  .stream-avatar i {\n    font-style: normal;\n    display: block;\n    width: 50px;\n    height: 50px;\n    line-height: 50px;\n    border-radius: 50px;\n    background: #a2a7b0;\n    color: #fff;\n    text-align: center;\n    font-size: 28px;\n    overflow: hidden;\n    text-transform: uppercase;\n  }\n\n  .stream-avatar img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n\n  .boarding-list-item .stream-avatar i {\n    width: 40px;\n    height: 40px;\n    line-height: 33px;\n    border-radius: 40px;\n    font-size: 22px;\n  }\n\n  .stream-avatar i img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n  }\n\n  .follow-following {\n    border: solid 1px #dadada;\n    float: right;\n    width: 100px;\n    text-align: center;\n    height: 30px;\n    line-height: 26px;\n    font-family: var(--font-bold);\n    border-radius: 4px;\n    cursor: pointer;\n  }\n\n  .follow-follow {\n    border: solid 1px #dadada;\n    float: right;\n    width: 100px;\n    text-align: center;\n    height: 32px;\n    line-height: 30px;\n    font-family: var(--font-bold);\n    border-radius: 5px;\n    color: #dadada;\n    cursor: pointer;\n    font-weight: 700;\n  }\n\n  .follow-follow {\n    border: solid 1px ",
        ";\n    color: ",
        ";\n  }\n\n  .popavatar {\n    width: 100%;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards;\n    -webkit-animation-timing-function: ease-out;\n    animation-timing-function: ease-out;\n    -webkit-animation-name: popimg;\n    animation-name: popimg;\n  }\n\n  .search-main-close {\n    font-size: 12px;\n    cursor: pointer;\n    font-style: italic;\n  }\n\n  .search-main-close:hover {\n    color: #6b6b6b;\n  }\n\n  .option.people b {\n    max-width: calc(100% - 76px);\n    margin-right: 10px;\n  }\n\n  .or-send-to .option.people b {\n    width: auto;\n    max-width: calc(100% - 82px);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .or-send-to .option.people em[class^='icon-'] {\n    position: static;\n    font-size: 14px;\n  }\n"
    ]);
    DiscoverPeople_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 25px;\n  height: 25px;\n  line-height: 28px;\n  border-radius: 30px;\n  font-size: 12px;\n  background: #a2a7b0;\n  color: #fff;\n  padding-right: 2px;\n  text-align: center;\n  text-transform: uppercase;\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


// copy from web legacy in build.css
var DiscoverPeopleWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5815366-0"
})(DiscoverPeople_styled_templateObject(), ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary);
var IconAvatarInvalid = styled_components_browser_esm["default"].i.withConfig({
    componentId: "sc-5815366-1"
})(styled_templateObject1());
/* harmony default export */ var DiscoverPeople_styled = ({
    DiscoverPeopleWrapper: DiscoverPeopleWrapper,
    IconAvatarInvalid: IconAvatarInvalid
});

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverPeople/index.tsx




// components
// eslint-disable-next-line import/no-unresolved









// Store onboarding: discover people slice

// styled


// contants

var DiscoverPeople_DiscoverPeopleWrapper = DiscoverPeople_styled.DiscoverPeopleWrapper;
// icon
var DiscoverPeople_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text, DiscoverPeople_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, DiscoverPeople_Avatar = ui/* Common.Avatar */.Gn.Avatar;
// DiscoverPeople Compoonent
function DiscoverPeople() {
    var ref = (0,react.useState)(""), keyword = ref[0], setKeyword = ref[1];
    var ref1 = (0,react.useState)(0), timeInterval = ref1[0], setTimeInterval = ref1[1];
    // request states profile
    var ref2 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref2.data;
    // handle actions & effects
    var dispatch = (0,es/* useDispatch */.I0)();
    // data profile
    var progress = dataProfile.onboarding;
    var ref3 = (0,es/* useSelector */.v9)(DiscoverPeople_slice/* selectors */.wl), getSuggestFriends = ref3.getSuggestFriends, getSearchPeople = ref3.getSearchPeople, followUser = ref3.followUser;
    var dataGetSuggestFriends = getSuggestFriends.data, isLoadingDataSugggestFriends = getSuggestFriends.isLoading;
    var dataSearchPeople = getSearchPeople.data, isLoadingDataSearchPeople = getSearchPeople.isLoading;
    var listSearchedPeople = dataSearchPeople.people;
    //  did mount
    (0,react.useEffect)(function() {
        // web legacy:
        // app\components\general\dumb\OnboardingPage\OnboardingStepThree\OnboardingStepThree.js
        // line 28
        dispatch(DiscoverPeople_slice/* effects.getSuggestFriends */.Sz.getSuggestFriends(ONBOARDING_REQUEST_FILTER));
    }, [
        dispatch
    ]);
    /**
   * Go to any step in onboarding page and save it into database.
   * {web}../OnboardingPage/OnboardingPage.js
   * line: 127
   * @param {Object} event - Javascript Event object
   */ var handleNextStep = function(event) {
        if (event.type === "click" || event.type === "keydown" && (event.key === "Enter" || event.key === " ")) {
            // step: next onboarding step
            var nextStep = progress + 1;
            // hit API skip user/onboarding/
            dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(parseInt(nextStep, 10)));
        }
    };
    /**
   * handlePreviousStep
   * Go to back step in onboarding page
   * replace 'onboarding' in profile state.
   * @param {Object} event - Javascript Event object
   */ var handlePreviousStep = function(event) {
        if (event.type === "click" || event.type === "keydown" && (event.key === "Enter" || event.key === " ")) {
            // step: previous onboarding step
            var previousStep = String(progress - 1);
            // hit API skip user/onboarding/
            dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(parseInt(previousStep, 10)));
        }
    };
    /**
   * handleActionFollowUnfollow function
   * dispatch follow/unfollow
   * web legacy: app\modules\profile\action.js
   * line: 480
   * @param {number} userid
   * @param {boolean} userStatusFollowed
   * @param {string} username
   * @param {string} stateKey getSuggestFriends || getSearchPeople
   */ var handleFollow = function(index, followed, userid, stateKey) {
        var paramsData = {
            index: index,
            userid: userid,
            stateKey: stateKey,
            type: followed ? "UNFOLLOW" : "FOLLOW"
        };
        dispatch(DiscoverPeople_slice/* effects.toggleFollowUser */.Sz.toggleFollowUser(paramsData));
    };
    /**
   * handleOnSearchPeople
   * to search searchpeople
   * web legacy:
   * app\components\general\dumb\OnboardingPage\OnboardingStepThree\OnboardingStepThree.js
   * line: 41
   */ var handleOnSearchPeople = function(valueInput) {
        var textSearch = valueInput.trim();
        var requestBody = {
            keyword: textSearch,
            page: 1
        };
        if (textSearch.length > 1) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(window.setTimeout(function() {
                dispatch(DiscoverPeople_slice/* effects.getSearchPeople */.Sz.getSearchPeople(requestBody));
            }, 1500));
        }
    };
    /**
   * handleOnSelectPeople
   * to select searchedpeople
   */ var handleOnSelectPeople = function(valueInput) {
        var textSearch = valueInput.trim();
        var requestBody = {
            keyword: textSearch,
            page: 1
        };
        dispatch(DiscoverPeople_slice/* effects.getSearchPeople */.Sz.getSearchPeople(requestBody));
    };
    /**
   * onClearSearch
   * to clear all searched data
   */ var onClearSearch = function() {
        setKeyword("");
        dispatch(DiscoverPeople_slice/* default.actions.clearSearch */.ZP.actions.clearSearch());
    };
    var isFetchedSearchPeople = !isLoadingDataSearchPeople && listSearchedPeople.length > 0;
    var options = isFetchedSearchPeople && listSearchedPeople.map(function(dataPeople) {
        return {
            value: dataPeople.name,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscoverPeople_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverPeople_Avatar, {
                        size: "medium",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            alt: dataPeople.img,
                            src: "".concat(api/* AVATAR_URL */.q$, "/").concat(dataPeople.img),
                            style: {
                                width: 40,
                                height: 40
                            },
                            onError: function(e) {
                                return (0,general/* handleErrorAvatar */.Tk)(e, dataPeople.name);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscoverPeople_Flex, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscoverPeople_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                        pl: "10px",
                                        size: "13px",
                                        family: "bold",
                                        children: dataPeople.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: dataPeople.is_verified,
                                        verifiedStatus: dataPeople === null || dataPeople === void 0 ? void 0 : dataPeople.verified_status
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                pl: "10px",
                                size: "13px",
                                children: dataPeople.desc
                            })
                        ]
                    })
                ]
            })
        };
    });
    var renderSearchResult = function() {
        return listSearchedPeople.map(function(searchedPeople, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverPeople_UserSearchItem, {
                index: index,
                dataUserSearch: searchedPeople,
                onFollow: handleFollow
            }, searchedPeople.id);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "boarding-cover",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "boarding-content ob-discover",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DiscoverPeople_DiscoverPeopleWrapper, {
                    className: "boarding-in people",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "boarding-title",
                            style: {
                                marginBottom: "30px"
                            },
                            children: "Discover People"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "boarding-search-wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverPeople_Search, {
                                    onSearch: handleOnSearchPeople,
                                    onSelect: handleOnSelectPeople,
                                    options: options,
                                    value: keyword,
                                    onChange: setKeyword
                                }),
                                isFetchedSearchPeople ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    role: "button",
                                    tabIndex: 0,
                                    className: "search-main-close",
                                    onClick: onClearSearch,
                                    onKeyDown: onClearSearch,
                                    style: {
                                        visibility: isFetchedSearchPeople ? "visible" : "hidden"
                                    },
                                    children: "Clear Result"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "boarding-list-wrap",
                            children: [
                                isFetchedSearchPeople && renderSearchResult(),
                                listSearchedPeople.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverPeople_FollowSuggestions, {
                                    isLoadingDataSugggestFriends: isLoadingDataSugggestFriends,
                                    dataGetSuggestFriends: dataGetSuggestFriends,
                                    onFollow: handleFollow
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: "boarding-button-next",
                            "data-step": progress + 1,
                            onClick: handleNextStep,
                            onKeyDown: handleNextStep,
                            children: "Next"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: "boarding-button-back",
                            "data-step": progress - 1,
                            onClick: handlePreviousStep,
                            onKeyDown: handlePreviousStep,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverPeople_Iconmoon, {
                                size: "25px",
                                className: "icon-toolbar_prev",
                                color: ui/* color.dimGray */.$_.dimGray,
                                hoverColor: ui/* color.lowgray */.$_.lowgray
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var onboarding_DiscoverPeople = (DiscoverPeople);

;// CONCATENATED MODULE: ./src/features/onboarding/OnBoardingLayout/OnBoardingLayout.jsx



function OnBoardingLayout(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* Wrapper */.im, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* ContentWrapper */.vs, {
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* Content */.VY, {
                children: children
            })
        })
    });
}
OnBoardingLayout.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var OnBoardingLayout_OnBoardingLayout = (OnBoardingLayout);

;// CONCATENATED MODULE: ./src/features/onboarding/OnBoardingLayout/OnBoardingTitle.jsx




var OnBoardingTitle_Flex = ui/* Common.Flex */.Gn.Flex, IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, OnBoardingTitle_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function OnBoardingTitle(param) {
    var children = param.children, onClickBack = param.onClickBack;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnBoardingTitle_Flex, {
        align: "center",
        mb: "30px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                onClick: onClickBack,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingTitle_Iconmoon, {
                    className: "icon-trading_back",
                    size: "23px",
                    weight: "bold"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* Title */.Dx, {
                children: children
            })
        ]
    });
}
OnBoardingTitle.propTypes = {
    children: (prop_types_default()).node.isRequired,
    onClickBack: (prop_types_default()).func.isRequired
};
/* harmony default export */ var OnBoardingLayout_OnBoardingTitle = (OnBoardingTitle);

;// CONCATENATED MODULE: ./src/features/onboarding/OnBoardingLayout/index.jsx



// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/lib/entities/company.ts + 1 modules
var company = __webpack_require__(74645);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/styled.ts

function DiscoverStock_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: 36px;\n  border-radius: 5px;\n  background: ",
        " !important;\n  border: 1px solid\n    ",
        ";\n  color: ",
        ";\n\n  &:hover, &:focus {\n    border: 1px solid\n      ",
        ";\n  }\n"
    ]);
    DiscoverStock_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Button = ui/* Common.Button */.Gn.Button;
var StockFollowButton = (0,styled_components_browser_esm["default"])(Button).withConfig({
    componentId: "sc-cd872824-0"
})(DiscoverStock_styled_templateObject(), ui/* color.light */.$_.light, function(props) {
    return props.type === "primary" ? "".concat(ui/* color.lowgray */.$_.lowgray) : "".concat(ui/* color.primary */.$_.primary);
}, function(props) {
    return props.type === "primary" ? "".concat(ui/* color.nightRider */.$_.nightRider) : "".concat(ui/* color.primary */.$_.primary);
}, function(props) {
    return props.type === "primary" ? "".concat(ui/* color.lowgray */.$_.lowgray, " !important") : "".concat(ui/* color.primary */.$_.primary, " !important");
});


;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/ListStock/SearchedStock.jsx




var SearchedStock_Flex = ui/* Common.Flex */.Gn.Flex, SearchedStock_Text = ui/* Common.Text */.Gn.Text;
function SearchedStock(param) {
    var stock = param.stock, onFollow = param.onFollow;
    var following = stock.is_following;
    var handleFollowStock = function() {
        onFollow(stock.id, following);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchedStock_Flex, {
        align: "center",
        justify: "space-between",
        py: "10px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedStock_Text, {
                        size: "16px",
                        mb: "4px",
                        children: stock.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedStock_Text, {
                        color: ui/* color.dimgray */.$_.dimgray,
                        size: "11px",
                        children: stock.desc
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockFollowButton, {
                type: following ? "primary" : "default",
                height: "26px",
                width: "100px",
                onClick: handleFollowStock,
                round: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchedStock_Text, {
                    family: "bold",
                    color: following ? "".concat(ui/* color.nightRider */.$_.nightRider) : "".concat(ui/* color.primary */.$_.primary),
                    children: following ? "Following" : "Follow"
                })
            })
        ]
    });
}
SearchedStock.propTypes = {
    stock: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).any
    ]).isRequired,
    onFollow: (prop_types_default()).func.isRequired
};
/* harmony default export */ var ListStock_SearchedStock = (SearchedStock);

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/ListStock/SuggestedStock.jsx





var SuggestedStock_Flex = ui/* Common.Flex */.Gn.Flex, SuggestedStock_Text = ui/* Common.Text */.Gn.Text;
function SuggestedStock(param) {
    var key = param.key, stock = param.stock, onFollow = param.onFollow;
    var ref = (0,react.useState)(Boolean(stock === null || stock === void 0 ? void 0 : stock.is_following)), following = ref[0], setFollowing = ref[1];
    var handleFollowStock = function() {
        setFollowing(onFollow(stock === null || stock === void 0 ? void 0 : stock.company_id, following));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestedStock_Flex, {
        align: "center",
        justify: "space-between",
        py: "13px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedStock_Text, {
                        size: "16px",
                        mb: "4px",
                        children: (stock === null || stock === void 0 ? void 0 : stock.symbol_2) || stock.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedStock_Text, {
                        color: ui/* color.dimgray */.$_.dimgray,
                        size: "11px",
                        children: stock.name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockFollowButton, {
                type: following ? "primary" : "default",
                onClick: handleFollowStock,
                round: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedStock_Text, {
                    family: "bold",
                    color: following ? "".concat(ui/* color.nightRider */.$_.nightRider) : "".concat(ui/* color.primary */.$_.primary),
                    children: following ? "Following" : "Follow"
                })
            })
        ]
    }, key);
}
SuggestedStock.propTypes = {
    stock: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).any
    ]).isRequired,
    onFollow: (prop_types_default()).func.isRequired
};
/* harmony default export */ var ListStock_SuggestedStock = (SuggestedStock);

// EXTERNAL MODULE: ./src/features/onboarding/DiscoverStock/slice.js
var DiscoverStock_slice = __webpack_require__(9073);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/ListStock/SuggestionItemLoading.jsx



var SuggestionItemLoading_Flex = ui/* Common.Flex */.Gn.Flex;
function SuggestionItemLoading() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestionItemLoading_Flex, {
        align: "center",
        justify: "space-between",
        py: "10px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuggestionItemLoading_Flex, {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                        size: "small",
                        active: true,
                        style: {
                            width: 75,
                            height: 17
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                        size: "small",
                        active: true,
                        style: {
                            width: 125,
                            height: 14
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Button */.Z.Button, {
                size: "small",
                active: true,
                style: {
                    width: 72
                }
            })
        ]
    });
}
/* harmony default export */ var ListStock_SuggestionItemLoading = (SuggestionItemLoading);

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/ListStock/index.jsx











function ListStock() {
    var ref = (0,react.useState)(0), defaultWatchlistId = ref[0], setDefaultWatchlistId = ref[1];
    // handle actions & effects
    var dispatch = (0,es/* useDispatch */.I0)();
    // Company suggestion data
    var ref1 = (0,es/* useSelector */.v9)(DiscoverStock_slice/* selectors */.wl), _suggestions = ref1.suggestions, dataSuggestions = _suggestions.data, isLoadingSuggestions = _suggestions.isLoading;
    // Search company data
    var ref2 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _search = ref2.search, dataSearch = _search.data, isLoadingSearch = _search.isLoading;
    // Did mount
    (0,react.useEffect)(function() {
        // fetch default recommended stock
        var ref = auth/* default.getUserAccess */.Z.getUserAccess(), watchlistId = ref.watchlist_id;
        dispatch(DiscoverStock_slice/* effects.getSuggestionCompany */.Sz.getSuggestionCompany(watchlistId));
        setDefaultWatchlistId(watchlistId);
    }, []);
    var handleToggleFollowCompany = function(companyId, isFollowing) {
        // Change flag state to update to search if user is currenty searching
        var stateToUpdate = dataSearch.length > 0 ? company/* STATE_SEARCH */.yM : company/* STATE_SUGGESTION */.IN;
        var data = {
            watchlistId: defaultWatchlistId,
            companyId: companyId,
            stateToUpdate: stateToUpdate
        };
        if (isFollowing) {
            dispatch(company/* effects.postUnfollowCompany */.Sz.postUnfollowCompany(data));
            return false;
        }
        dispatch(company/* effects.postFollowCompany */.Sz.postFollowCompany(data));
        return true;
    };
    // TODO: Add ternary to validate if search > 0 use search, else use suggestions
    var isLoadingStocks = isLoadingSearch || isLoadingSuggestions;
    var stocks = dataSearch.length > 0 ? dataSearch : dataSuggestions;
    var SuggestionItem = dataSearch.length > 0 ? ListStock_SearchedStock : ListStock_SuggestedStock;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* ListWrapper */.lk, {
        children: isLoadingStocks ? (0,_to_consumable_array/* default */.Z)(Array(7)).map(function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListStock_SuggestionItemLoading, {});
        }) : stocks.map(function(stock) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(SuggestionItem, {
                stock: stock,
                onFollow: handleToggleFollowCompany
            }, stock.id || (stock === null || stock === void 0 ? void 0 : stock.company_id));
        })
    });
}
/* harmony default export */ var DiscoverStock_ListStock = (ListStock);

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/Search/options.js


var options_Flex = ui/* Common.Flex */.Gn.Flex, Tag = ui/* Common.Tag.Tag */.Gn.Tag.Tag, options_Text = ui/* Common.Text */.Gn.Text;
var renderStockSuggestions = function() {
    var stocks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return stocks.map(function(stock) {
        return {
            value: stock.name,
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(options_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                        size: "xs",
                        type: "grey",
                        children: stock.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(options_Text, {
                        pl: "10px",
                        size: "13px",
                        children: stock.desc
                    })
                ]
            })
        };
    });
};
/* harmony default export */ var options = ({});

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/Search/styled.ts

function DiscoverStock_Search_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-select-dropdown {\n    width: 340px !important;\n  }\n  .ant-input-affix-wrapper {\n    &:hover {\n      border: 1px solid ",
        ";\n    }\n  }\n  input {\n    ::placeholder {\n      font-family: var(--bold-font);\n      color: #e3e3e3 !important;\n    }\n  }\n"
    ]);
    DiscoverStock_Search_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styled_BaseAutoComplete = ui/* Common.Autocomplete */.Gn.Autocomplete;
var styled_Autocomplete = (0,styled_components_browser_esm["default"])(styled_BaseAutoComplete).withConfig({
    componentId: "sc-a44816c0-0"
})(DiscoverStock_Search_styled_templateObject(), ui/* color.gainsboro */.$_.gainsboro);


;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/Search/index.jsx







// Store company

var Search_Input = ui/* Common.Input */.Gn.Input, Search_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Search_Text = ui/* Common.Text */.Gn.Text;
function Search_Search() {
    var ref = (0,react.useState)(0), timeInterval = ref[0], setTimeInterval = ref[1];
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(company/* selectors */.wl), _search = ref2.search, dataSearch = _search.data;
    // handle actions
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleSearchCompany = function(val) {
        if (val.length > 1) {
            if (timeInterval) {
                clearTimeout(timeInterval);
            }
            setTimeInterval(setTimeout(function() {
                dispatch(company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
            }, 1500));
        }
    };
    var handleSelectCompany = function(val) {
        // dispatch search company with stock name
        dispatch(company/* effects.getSearchCompany */.Sz.getSearchCompany(val));
    };
    var handleClearSearch = function() {
        setKeyword("");
        dispatch(company/* default.actions.clearSearch */.ZP.actions.clearSearch());
    };
    var options = renderStockSuggestions(dataSearch);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnBoardingLayout_styled/* Relative */.Ig, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Autocomplete, {
                options: options,
                width: "100%",
                value: keyword,
                onChange: setKeyword,
                onSelect: handleSelectCompany,
                onSearch: handleSearchCompany,
                mb: "8px",
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Input, {
                    prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Iconmoon, {
                        className: "icon-avatar_search"
                    }),
                    placeholder: "Type here to add companies...",
                    height: "36px",
                    width: "100%"
                })
            }),
            options.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Text, {
                align: "center",
                style: {
                    fontStyle: "italic",
                    cursor: "pointer"
                },
                onClick: handleClearSearch,
                children: "Clear result"
            })
        ]
    });
}
/* harmony default export */ var DiscoverStock_Search = (Search_Search);

;// CONCATENATED MODULE: ./src/features/onboarding/DiscoverStock/index.jsx






// Store
// Store profile to get on boarding data

// Store onboarding to handle next steps


function DiscoverStock() {
    var dispatch = (0,es/* useDispatch */.I0)();
    // get current on boarding progress
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref.data;
    var progress = dataProfile.onboarding;
    var handleClickBack = function() {
        var prevStep = progress - 1;
        dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(prevStep));
    };
    var handleFinish = function() {
        if (progress < ONBOARDING_MAX_STEP) {
            var nextStep = progress + 1;
            dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(nextStep));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnBoardingLayout_OnBoardingLayout, {
        className: "ob-discover",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OnBoardingLayout_OnBoardingTitle, {
                onClickBack: handleClickBack,
                children: [
                    "Discover Company Stock",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "We recommend you to follow at least 5 stocks"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverStock_Search, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverStock_ListStock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OnBoardingLayout_styled/* ButtonNext */.P1, {
                height: "40px",
                mx: "auto",
                onClick: handleFinish,
                children: "Finish"
            })
        ]
    });
}
/* harmony default export */ var onboarding_DiscoverStock = (DiscoverStock);

;// CONCATENATED MODULE: ./src/features/onboarding/ConnectFacebook/ConnectedFacebook/index.jsx


// ConnectedFacebook Component
var ConnectedFacebook = function(param) {
    var handleNextStep = param.handleNextStep;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "boarding-title",
                style: {
                    marginTop: "40px"
                },
                children: "Your Facebook account is now connected with Stockbit!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "button",
                tabIndex: -1,
                className: "boarding-button-next",
                onClick: handleNextStep,
                onKeyDown: handleNextStep,
                children: "Next"
            })
        ]
    });
};
ConnectedFacebook.propTypes = {
    handleNextStep: (prop_types_default()).func
};
ConnectedFacebook.defaultProps = {
    handleNextStep: function() {}
};
/* harmony default export */ var ConnectFacebook_ConnectedFacebook = (ConnectedFacebook);

// EXTERNAL MODULE: ./node_modules/@greatsumini/react-facebook-login/dist/index.js
var dist = __webpack_require__(73502);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/assets/base64icon/index.js
var base64icon = __webpack_require__(54392);
;// CONCATENATED MODULE: ./src/features/onboarding/ConnectFacebook/NotConnectedFacebook/index.jsx




var fbAppId = "247631672013136";
var NotConnectedFacebook_Text = ui/* Common.Text */.Gn.Text, NotConnectedFacebook_Button = ui/* Common.Button */.Gn.Button, IconBase64 = ui/* Common.IconBase64 */.Gn.IconBase64;

// NotConnectedFacebook Component
var NotConnectedFacebook = function(param) {
    var handleNextStep = param.handleNextStep, connectFacebook = param.connectFacebook, handleFacebookResponse = param.handleFacebookResponse;
    var size = "medium";
    var renderSecondaryButton = function(onClick) {
        var buttonHeight = "".concat(size === "medium" ? 30.8 : 44, "px");
        var iconSize = "".concat(size === "medium" ? 16.8 : 24, "px");
        var fontSize = "".concat(size === "medium" ? 9.8 : 14, "px");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotConnectedFacebook_Button, {
            block: true,
            round: true,
            height: buttonHeight,
            justifyContent: "start",
            id: "facebook-register",
            onClick: function(e) {
                onClick(e);
            },
            style: {
                paddingLeft: 20,
                paddingRight: 20
            },
            className: "my-facebook-button-class hide",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBase64, {
                    icon: base64icon/* facebookIcon */.pj,
                    iconSize: iconSize,
                    padding: "unset"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotConnectedFacebook_Text, {
                    color: "light",
                    size: fontSize,
                    family: "bold",
                    width: "100%",
                    align: "center",
                    children: "Login with Facebook"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "boarding-fb"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "boarding-title",
                        style: {
                            margin: "25px 0"
                        },
                        children: "Find Facebook Friends"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "boarding-text",
                        children: [
                            "You choose which friends to follow. We'll never ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "post to Facebook without your permission."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: connectFacebook,
                        onKeyDown: connectFacebook,
                        role: "button",
                        tabIndex: -1,
                        className: "boarding-button fb",
                        children: "Connect to Facebook"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                role: "button",
                tabIndex: -1,
                className: "boarding-skip",
                onClick: handleNextStep,
                onKeyDown: handleNextStep,
                children: "Skip"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "fb-root"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 250,
                    margin: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    appId: fbAppId,
                    autoLoad: false,
                    style: {
                        fontSize: 40
                    },
                    scope: "public_profile,email,user_friends",
                    onSuccess: handleFacebookResponse,
                    render: function(param) {
                        var onClick = param.onClick;
                        return renderSecondaryButton(onClick);
                    }
                })
            })
        ]
    });
};
NotConnectedFacebook.propTypes = {
    handleNextStep: (prop_types_default()).func,
    connectFacebook: (prop_types_default()).func,
    handleFacebookResponse: (prop_types_default()).func
};
NotConnectedFacebook.defaultProps = {
    handleNextStep: function() {},
    connectFacebook: function() {},
    handleFacebookResponse: function() {}
};
/* harmony default export */ var ConnectFacebook_NotConnectedFacebook = (NotConnectedFacebook);

;// CONCATENATED MODULE: ./src/features/onboarding/ConnectFacebook/styled.js

function ConnectFacebook_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .boarding-in.facebook .boarding-button-back {\n    left: 0;\n  }\n\n  .boarding-fb {\n    display: block;\n    width: 120px;\n    height: 120px;\n    margin-bottom: 20px;\n    margin: auto;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #eee no-repeat center center / 51px auto\n      url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADhklEQVRo3uVa0W3iQBB9oPyHVICvgriDkAqgA7jvjBRSQbgOfNL8ByqIU0FMB9AB6QAq4H7eXkY+g9dk10TcShYysnf9PDNv3zzo7Pd7XMro4oLG1ak3ikgPQGq+Wqnq9pxgOk3STERGANxxXXHJB4ACwFxVi28JhiAyAP0Gc38AmLQJqluXSiKSA3g1QNYAngDcA7hR1Q6AG57/Igjw+ncRyc4eGdZEAeDWgJj6vGkRGQCYl17AIHZNdT2B/FbV1DdleF0KYMGvbgnuLGk2M0B+quq06cSqulXViQE0FJFZq2nGFHnn6YIP9KXBuhvy9IeqbtqKzMyw0TTQOhMAu9L8ccGISALgzi0aqmA5j2O1MWsyemRG/NypauiCzSrWaQVMHnohRmfJ00EbYBKnsyKldVFaJyqYfmQw/3cLICIpteHJYJJvhKcA8CoiaVMwrkDTSA/m5m1C+a7V6DUFs4rJNmbeVRs149jm1iesDXPfNnR5dDCqmpt+JLTscNJoraqtRAZGqg99WcQjKlMjk6I1a92KnXrGZgoA5l9NN97voryMIJNqqdmp3GsAxamAeF/BeXac9yxt8wTAixOeVNFZAyAzAM/m/kG5VqjS6/Y011s91bDg9qg7w0YtNyz0wZTJq9oDPtyIxd73ALJCtWUVx2rionNTwDAmxbakGspW1Bvtpu2BuecAxoGw7LxNQEZpatrfY2OBQEagiLgHvK+bz9ue5UQFu8TBAclT4Iw2bWOvmQ+ax9rFL7oFCB6ZUmo5sXhXcemSpLACULRtnl95iMOJZ9FbgEMAzyKyYzpmsfRYLRgyV4ZPV9PS8QrAhp9lak4YvZQ0fU3qHYvIkjS9aQ0MXfvHEoDs0EZZsz9NePQZtZWITGPps7/7DOsiN6kS7PcVSqPM7Pbeti831hGAtC6qls0yA2TBm4MUMCORGDU+9jXRCTr1Sc/Ofr8vi8ogZvmRN21N9PuQjNctdZXLmEBMexGlm+2SfvtmoaiDJOJA3IX0GrpGY61j0mZFDe1CO0GWANoWhxtfP6zJPrM1IZ9xt95GJICktCEHy4bOw8ND+cdYJ0FyWk8hAPTw+WcIK42CMqej5h6L8vGAeLQSBgA2VfXFYu7xSI28Kcuixp5C47a5QoKEHm8m6sFT+Zg7kxjZnx7o8Y+NtYlmKx1o55T/m5l0+oeh2qL3YGC+67iotvkPTTenKu8H9gUAAAAASUVORK5CYII=');\n  }\n\n  .boarding-button {\n    display: inline-block;\n    margin-top: 20px;\n    padding: 0 20px;\n    line-height: 40px;\n    height: 40px;\n    border-radius: 2px;\n    background: #00ab6b;\n    color: #fff;\n    cursor: pointer;\n    transition: all 0.1s cubic-bezier(0.98, 0.01, 1, 1);\n  }\n\n  .boarding-button.fb {\n    background: #3b5998;\n  }\n\n  .boarding-button:hover {\n    background: #333;\n  }\n"
    ]);
    ConnectFacebook_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

// copy from web legacy in build.css
var ConnectFacebookWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9df445a-0"
})(ConnectFacebook_styled_templateObject());
/* harmony default export */ var ConnectFacebook_styled = (ConnectFacebookWrapper);

;// CONCATENATED MODULE: ./src/features/onboarding/ConnectFacebook/index.jsx



// Components


// Store

// Store onboarding

// styled


var ConnectFacebook_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var FACEBOOK_CONNECT = "facebook";
// ConnectFacebook Compoonent
function ConnectFacebook() {
    // request states profile
    var ref = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref.data;
    // handle actions & effects
    var dispatch = (0,es/* useDispatch */.I0)();
    // data profile
    var progress = dataProfile.onboarding, isFacebookConnected = dataProfile.facebook_id;
    var checkIsFacebookConnected = function() {
        return isFacebookConnected !== null && isFacebookConnected !== "";
    };
    /**
   * Go to any step in onboarding page and save it into database.
   * {web}../OnboardingPage/OnboardingPage.js
   * line: 127
   * @param {Object} event - Javascript Event object
   */ var handleNextStep = function(event) {
        if (event.type === "click" || event.type === "keydown" && (event.key === "Enter" || event.key === " ")) {
            // step: next onboarding step
            var nextStep = progress + 1;
            // hit API skip user/onboarding/
            dispatch(onboarding/* effects.userSkipOnboarding */.Sz.userSkipOnboarding(parseInt(nextStep, 10)));
        }
    };
    /**
   * handlePreviousStep
   * Go to back step in onboarding page
   * replace 'onboarding' in profile state.
   * @param {Object} event - Javascript Event object
   */ var handlePreviousStep = function(event) {
        if (event.type === "click" || event.type === "keydown" && (event.key === "Enter" || event.key === " ")) {
            // step: previous onboarding step
            var previousStep = progress - 1;
            // Can't hit API because it will return error when set step to `0` (edit profile picture)
            dispatch(profile/* default.actions.updateOnboardingStep */.ZP.actions.updateOnboardingStep({
                step: previousStep
            }));
        }
    };
    /**
   * Links visible Facebook Connect button click to invisible FacebookLogin
   * component.
   */ var connectFacebook = function() {
        if (!checkIsFacebookConnected()) {
            document.querySelector(".my-facebook-button-class.hide").click();
        }
    };
    /**
   * handleFacebookResponse
   * to dispatch connect facebook
   */ var handleFacebookResponse = function(response) {
        var userId = response.id || response.userID;
        if (response.accessToken && userId) {
            var requestBody = {
                fb_user_id: userId,
                fb_access_token: response.accessToken
            };
            dispatch(profile/* effects.userConnectSocialMedia */.Sz.userConnectSocialMedia({
                socialMediaName: FACEBOOK_CONNECT,
                requestBody: requestBody
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "boarding-cover",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "boarding-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectFacebook_styled, {
                    className: "boarding-in facebook",
                    children: [
                        !checkIsFacebookConnected() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectFacebook_NotConnectedFacebook, {
                            handleNextStep: handleNextStep,
                            connectFacebook: connectFacebook,
                            handleFacebookResponse: handleFacebookResponse
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectFacebook_ConnectedFacebook, {
                            handleNextStep: handleNextStep
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            role: "button",
                            tabIndex: -1,
                            className: "boarding-button-back",
                            onClick: handlePreviousStep,
                            onKeyDown: handlePreviousStep,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectFacebook_Iconmoon, {
                                size: "25px",
                                className: "icon-toolbar_prev",
                                color: ui/* color.dimGray */.$_.dimGray,
                                hoverColor: ui/* color.lowgray */.$_.lowgray
                            })
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ var onboarding_ConnectFacebook = (ConnectFacebook);

;// CONCATENATED MODULE: ./src/features/onboarding/index.tsx





function OnBoarding(param) {
    var progress = param.progress;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            progress == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_UploadProfilePicture, {}),
            progress == 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_ConnectFacebook, {}),
            progress == 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_DiscoverPeople, {}),
            progress == 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(onboarding_DiscoverStock, {})
        ]
    });
}
/* harmony default export */ var features_onboarding = (OnBoarding);

// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/hooks/useProfileData.ts
var useProfileData = __webpack_require__(30995);
// EXTERNAL MODULE: ./src/hooks/useNotificationListener.ts
var useNotificationListener = __webpack_require__(91364);
// EXTERNAL MODULE: ./src/features/edit-profile/slice.ts
var edit_profile_slice = __webpack_require__(40927);
// EXTERNAL MODULE: ./src/global/TradingModal/index.tsx + 66 modules
var TradingModal = __webpack_require__(69983);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/global/Notification/index.tsx + 1 modules
var Notification = __webpack_require__(77667);
// EXTERNAL MODULE: ./src/features/chat/MainContent/useScrollChat.ts
var useScrollChat = __webpack_require__(4881);
// EXTERNAL MODULE: ./src/features/chat/store/index.ts + 7 modules
var store = __webpack_require__(77284);
// EXTERNAL MODULE: ./src/global/WebSocketV2/slice.ts + 1 modules
var WebSocketV2_slice = __webpack_require__(66250);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var chat_slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/stores/chat/index.ts + 2 modules
var chat = __webpack_require__(50490);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/utils/socketSocial.ts



var transformToNotifMessage = function(rawText, type) {
    var text = sanitize_html_default()(rawText);
    var _obj;
    var attachmentContentMapper = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PHOTO */.G0.ATTACHMENT_TYPE_PHOTO, " *IMAGE*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_GIF */.G0.ATTACHMENT_TYPE_GIF, " *GIF*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_POST */.G0.ATTACHMENT_TYPE_POST, " *POST*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_STICKER */.G0.ATTACHMENT_TYPE_STICKER, " *STICKER*"), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_PDF */.G0.ATTACHMENT_TYPE_PDF, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED, ""), (0,_define_property/* default */.Z)(_obj, constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_SHARETRADE */.G0.ATTACHMENT_TYPE_SHARETRADE, ""), _obj);
    text += attachmentContentMapper[type];
    return text;
};


;// CONCATENATED MODULE: ./src/hooks/useChatListenerWsSocialV2.ts
/* eslint-disable eqeqeq */ /* eslint-disable no-undef */ 



















var checkMessageDuplicated = function(messages, newRoomId, lastMessageId) {
    if (messages[newRoomId]) {
        var ref;
        return (ref = messages[newRoomId]) === null || ref === void 0 ? void 0 : ref.messages.some(function(chat) {
            return chat.id === lastMessageId;
        });
    }
    return false;
};
var checkMissingObjectText = function(body) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var chatMessageV1 = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.message;
    var valueText = (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref4 = chatMessageV1.body) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.conversation) === null || ref5 === void 0 ? void 0 : ref5.text) ? chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref6 = chatMessageV1.body) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.conversation) === null || ref7 === void 0 ? void 0 : ref7.text : "";
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1), {
        text: valueText,
        body: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1.body), {
            conversation: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref8 = chatMessageV1.body) === null || ref8 === void 0 ? void 0 : ref8.conversation), {
                text: valueText,
                attachmentType: (chatMessageV1 === null || chatMessageV1 === void 0 ? void 0 : (ref9 = chatMessageV1.body) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.conversation) === null || ref10 === void 0 ? void 0 : ref10.attachmentType) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED
            })
        })
    });
};
var handleRefreshGroupRoom = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatId) {
        var hasRoomDetail, ref, groupId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return store/* roomDetailStore.getState */.e.getState().refreshGroupRoomDetail(chatId);
                case 2:
                    hasRoomDetail = _ctx.sent;
                    if (!hasRoomDetail) {
                        _ctx.next = 9;
                        break;
                    }
                    ;
                    groupId = (ref = store/* roomDetailStore.getState */.e.getState().group[chatId]) === null || ref === void 0 ? void 0 : ref.id;
                    _ctx.next = 8;
                    return store/* groupMemberStore.getState */.VY.getState().fetchGroupMember(groupId, 0);
                case 8:
                    chat/* default.setState */.Z.setState((0,immer_esm/* default */.ZP)(function(state) {
                        state.conversation.isLoading = false;
                    }));
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function handleRefreshGroupRoom(chatId) {
        return _ref.apply(this, arguments);
    };
}();
function useChatListenerWsSocialV2() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var activeRoomId = (0,es/* useSelector */.v9)(chat_slice/* selectors */.wl).activeRoomId;
    var ref = (0,es/* useSelector */.v9)(edit_profile_slice/* selectors */.wl), _notifications = ref.notifications, notif = _notifications.data;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataLoggedInUser = ref1.data;
    var newIncomingChatWsSocialV2 = (0,es/* useSelector */.v9)(WebSocketV2_slice/* chatWsSocialV2Selector */.WM);
    var messages = (0,chat/* default */.Z)(function(store) {
        return store.conversation.messages;
    });
    var defaultRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var invitedRooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.invited.list;
    });
    var updateRoomListFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateRoomListFromWS;
    });
    var pushMessage = (0,chat/* default */.Z)(function(store) {
        return store.pushMessage;
    });
    var updateMessageFromWS = (0,chat/* default */.Z)(function(store) {
        return store.updateMessageFromWS;
    });
    var scrollToBottom = (0,useScrollChat/* default */.Z)().scrollToBottom;
    var actionChatRoom = function(incomingChat) {
        if (activeRoomId > 0) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
            var body = incomingChat.body;
            var newMessage = checkMissingObjectText(body);
            var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatMessage) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
            var referenceId = body === null || body === void 0 ? void 0 : (ref4 = body.event) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.chatMessage) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref7 === void 0 ? void 0 : ref7.referenceId;
            var roomStatus = body === null || body === void 0 ? void 0 : (ref8 = body.event) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.chatMessage) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref11 === void 0 ? void 0 : ref11.roomStatus;
            newMessage = (0,utils/* snakelizeKeys */.t_)(newMessage);
            newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
            var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newMessage === null || newMessage === void 0 ? void 0 : newMessage.id) : false;
            // Check if the event comes when user leave
            var isStateUnspecified = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_UNSPECIFIED */.Kn.ROOM_STATE_UNSPECIFIED;
            var isDeletedEvent = (newMessage === null || newMessage === void 0 ? void 0 : (ref12 = newMessage.body) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.conversation) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.flag) === null || ref14 === void 0 ? void 0 : ref14.is_deleted) ? newMessage === null || newMessage === void 0 ? void 0 : (ref15 = newMessage.body) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conversation) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.flag) === null || ref17 === void 0 ? void 0 : ref17.is_deleted : false;
            if (!isDuplicated && !isStateUnspecified && !isDeletedEvent) {
                var ref18, ref19, ref20, ref21, ref22;
                var chatId = newRoom.id;
                // push message to state;
                pushMessage({
                    chatId: chatId,
                    message: newMessage,
                    reference_id: referenceId,
                    room_status: roomStatus,
                    room: newRoom
                });
                // scroll to bottom if in current active chat is receive new message
                var isChatPageShowed = router_default().asPath.includes("/chat/".concat(chatId)) || router_default().asPath.includes("/group-chat/".concat(chatId)) || router_default().asPath.includes("/broadcast-chat/".concat(chatId));
                var senderUserData = newMessage === null || newMessage === void 0 ? void 0 : (ref18 = newMessage.body) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.conversation) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.sender) === null || ref20 === void 0 ? void 0 : ref20.user;
                var senderUserName = senderUserData && senderUserData.username ? senderUserData.username : "";
                var isReceiver = senderUserName !== dataLoggedInUser.username;
                if (isChatPageShowed) {
                    var container = document.getElementById("chat-content-container");
                    var currentPos = container.scrollHeight - container.clientHeight - 200;
                    var currentlyScrollingUp = container.scrollTop < currentPos;
                    // when there is incoming message on receiver side, that is currently scrolling up
                    // don't scroll to bottom
                    if (isReceiver && !currentlyScrollingUp || !isReceiver) {
                        scrollToBottom();
                    }
                }
                // Handle event type message from ws in group chat
                // will refresh the room detail and member list
                var isCurrentPage = router_default().asPath.includes("/group-chat/".concat(chatId));
                var isEventMessage = (newMessage === null || newMessage === void 0 ? void 0 : newMessage.body_type) === constant/* MESSAGE_BODY_TYPE.MESSAGE_BODY_TYPE_EVENT */.dn.MESSAGE_BODY_TYPE_EVENT;
                var isNotLeaveEvent = ((newMessage === null || newMessage === void 0 ? void 0 : (ref21 = newMessage.body) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.event) === null || ref22 === void 0 ? void 0 : ref22.text) || "").toLowerCase() !== "you left";
                if (isCurrentPage && isEventMessage && isNotLeaveEvent) {
                    handleRefreshGroupRoom(chatId);
                }
            } else {
                // update message if id has available on convo,
                updateMessageFromWS({
                    chatId: newRoom.id,
                    messageId: newMessage.id,
                    message: newMessage
                });
            }
        }
    };
    var actionRoomList = function(incomingChat) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        var body = incomingChat.body;
        var newRoom = body === null || body === void 0 ? void 0 : (ref = body.event) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.chatRoomInfo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[constant/* WS_SOCIAL_VERSION */.fO]) === null || ref3 === void 0 ? void 0 : ref3.room;
        newRoom = (0,utils/* snakelizeKeys */.t_)(newRoom);
        var messageId = newRoom === null || newRoom === void 0 ? void 0 : (ref4 = newRoom.last_message) === null || ref4 === void 0 ? void 0 : ref4.id;
        var isAccepted = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.state) === constant/* StateChatList.ROOM_STATE_ACCEPTED */.Kn.ROOM_STATE_ACCEPTED;
        var isPersonalChat = (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL;
        var isBroadcast = // TODO: remove 3
        // While waiting for proto definition encoding is done,
        // we use number 3 as broadcast type,
        // Currently, BE is sending 3 instead of ROOM_TYPE_BROADCAST
        (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) === constant/* RoomTypeFromPayload.BROADCAST */._2.BROADCAST;
        var roomList = isAccepted ? defaultRooms : invitedRooms;
        var lastMessage = (0,immer_esm/* default */.ZP)(newRoom === null || newRoom === void 0 ? void 0 : newRoom.last_message, function(draft) {
            var ref, ref1, ref2, ref3;
            draft.text = (newRoom === null || newRoom === void 0 ? void 0 : (ref = newRoom.last_message) === null || ref === void 0 ? void 0 : ref.text) ? newRoom.last_message.text : "";
            draft.sender_username = ((ref1 = newRoom.last_message) === null || ref1 === void 0 ? void 0 : ref1.sender_username) || "";
            // Replace last message if user delete their own latest chat
            if ((newRoom === null || newRoom === void 0 ? void 0 : (ref2 = newRoom.last_message) === null || ref2 === void 0 ? void 0 : ref2.text) === "This message was deleted" && ((ref3 = newRoom.last_message) === null || ref3 === void 0 ? void 0 : ref3.sender_username) === dataLoggedInUser.username) {
                draft.text = "You deleted this message";
                draft.placeholder_mask.masked_text = "You deleted this message";
            }
        });
        // ws social not send sender userId
        var senderUserName = lastMessage.sender_username;
        var isReceiver = senderUserName !== dataLoggedInUser.username;
        var isEventMessage = isPersonalChat || isBroadcast ? false : !senderUserName;
        var roomIdx = roomList.findIndex(function(item) {
            return item.id === (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id);
        });
        var isDuplicated = messages ? checkMessageDuplicated(messages, newRoom === null || newRoom === void 0 ? void 0 : newRoom.id, newRoom === null || newRoom === void 0 ? void 0 : (ref5 = newRoom.last_message) === null || ref5 === void 0 ? void 0 : ref5.id) : false;
        // existing chatroom
        if (roomIdx > -1) {
            var ref8, ref9, ref10;
            var roomInfo = isPersonalChat || isBroadcast ? roomList[roomIdx].info : (0,_object_spread/* default */.Z)({
                avatar_url: (newRoom === null || newRoom === void 0 ? void 0 : (ref8 = newRoom.info) === null || ref8 === void 0 ? void 0 : ref8.avatar_url) || ""
            }, newRoom === null || newRoom === void 0 ? void 0 : newRoom.info);
            var updateLastMessage = isDuplicated ? ((ref10 = (ref9 = messages[newRoom === null || newRoom === void 0 ? void 0 : newRoom.id]) === null || ref9 === void 0 ? void 0 : ref9.messages[0]) === null || ref10 === void 0 ? void 0 : ref10.id) === messageId : true;
            lastMessage = updateLastMessage ? lastMessage : roomList[roomIdx].last_message;
            var unreadCount = roomList[roomIdx].unread_count || 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount = roomList[roomIdx].unread_count + 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, roomList[roomIdx]), {
                last_message: lastMessage,
                info: roomInfo,
                unread_count: unreadCount,
                status: newRoom === null || newRoom === void 0 ? void 0 : newRoom.status,
                isBroadcast: isBroadcast
            });
        } else {
            var unreadCount1 = 0;
            // counter unread count chat list
            if (!isEventMessage && isReceiver && !isDuplicated) {
                unreadCount1 += 1;
            }
            newRoom = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, newRoom), {
                unread_count: unreadCount1,
                isBroadcast: isBroadcast
            });
        }
        // wont update the room list if the event is us leaving
        if ((newRoom === null || newRoom === void 0 ? void 0 : (ref6 = newRoom.lastMessage) === null || ref6 === void 0 ? void 0 : ref6.text) !== "You left") {
            updateRoomListFromWS(newRoom);
        }
        // Show Left Bottom Push Notification
        var isInvitedChat = newRoom.state === constant/* StateChatList.ROOM_STATE_INVITED */.Kn.ROOM_STATE_INVITED;
        var isMuted = newRoom.status.isMuted || false;
        var getCurrentIncomingNotifType = (ref7 = (0,utils/* getNotifType */.K5)(newRoom)) === null || ref7 === void 0 ? void 0 : ref7.notifType;
        var incomingMessageDataNotifSetting = notif.find(function(notifGroup) {
            return notifGroup.group === constant/* NOTIF_GROUP_CHAT */.wS;
        }).notifications.find(function(notifItem) {
            return notifItem.type === getCurrentIncomingNotifType;
        });
        if (isReceiver && !isMuted && incomingMessageDataNotifSetting) {
            var isDesktopNotificationTurnOn = incomingMessageDataNotifSetting.settings.find(function(setting) {
                return setting.key === constant/* NOTIF_SETTING_KEY_DN */.gK;
            }).value;
            if (isDesktopNotificationTurnOn) {
                var ref11, ref12, ref13, ref14, ref15, ref16;
                var groupChatName = (newRoom === null || newRoom === void 0 ? void 0 : (ref11 = newRoom.info) === null || ref11 === void 0 ? void 0 : ref11.name) || "Group Chat";
                var usernameAtGroup = senderUserName ? "".concat(senderUserName, " @") : "";
                var notifTitle = newRoom.type === constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL ? senderUserName : "".concat(usernameAtGroup, " ").concat(groupChatName);
                var lastMessageType = (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) || constant/* ATTACHMENT_TYPE.ATTACHMENT_TYPE_UNSPECIFIED */.G0.ATTACHMENT_TYPE_UNSPECIFIED;
                (0,Notification/* showChatNotification */.Ac)({
                    title: notifTitle,
                    description: transformToNotifMessage(lastMessage.text, lastMessageType),
                    isDeactivate: (newRoom === null || newRoom === void 0 ? void 0 : (ref12 = newRoom.attributes) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.personal) === null || ref13 === void 0 ? void 0 : ref13.is_deactivated) || false,
                    name: (newRoom === null || newRoom === void 0 ? void 0 : (ref14 = newRoom.info) === null || ref14 === void 0 ? void 0 : ref14.name) || "",
                    shortName: (newRoom === null || newRoom === void 0 ? void 0 : (ref15 = newRoom.info) === null || ref15 === void 0 ? void 0 : ref15.shortened_name) || "",
                    type: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.type) || constant/* RoomTypeFromPayload.PERSONAL */._2.PERSONAL,
                    avatar: (newRoom === null || newRoom === void 0 ? void 0 : (ref16 = newRoom.info) === null || ref16 === void 0 ? void 0 : ref16.avatar_url) || "",
                    id: (newRoom === null || newRoom === void 0 ? void 0 : newRoom.id) || 0,
                    key: "in-app-notification-".concat(newRoom === null || newRoom === void 0 ? void 0 : newRoom.id),
                    isPersonalChat: isPersonalChat,
                    isInvitedChat: isInvitedChat,
                    onClose: function() {
                        dispatch(WebSocketV2_slice/* default.actions.clearChat */.ZP.actions.clearChat());
                    }
                });
            }
        }
    };
    var _obj;
    var actionEventType = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_MESSAGE */.aw.TYPE_CHAT_MESSAGE, function(incomingChat) {
        return actionChatRoom(incomingChat);
    }), (0,_define_property/* default */.Z)(_obj, constant/* EVENT_TYPE_BROADCAST.TYPE_CHAT_ROOM_INFO */.aw.TYPE_CHAT_ROOM_INFO, function(incomingChat) {
        return actionRoomList(incomingChat);
    }), _obj);
    var actionTypeBroadCast = function(incomingChat) {
        var ref, ref1;
        var incomingBodyEventType = incomingChat === null || incomingChat === void 0 ? void 0 : (ref = incomingChat.body) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.type;
        return actionEventType[incomingBodyEventType] && actionEventType[incomingBodyEventType](incomingChat);
    };
    var chatListener = function(incomingChat) {
        if (incomingChat) {
            /* Additional information

        1. SEND MESSAGE
        When user send message to group room or personal room,
        ws will send event new messages as a sender so after
        that, we will update the slice conversations.

        2. OLD WEBSOCKET
        There is 3 version of WS, the old (M) that have been
        deprecated, the new (M2) and the latest one (M3).
        In this listener we will only use M3 as our WS event.
        To prevent doubled event sented to us, we use message.id
        as identifier to check if the message has been save in
        redux/slice or not.

        3. BODY TYPE OF EVENT
        Personal room and group room message now have same
        body payload. We dont need to transform the body.

       */ actionTypeBroadCast(incomingChat);
        }
    };
    (0,react.useEffect)(function() {
        // After check the behaviour, it more safe to use
        // synchronously process instead of asynchronous
        // when receive double events from ws
        // @ts-ignore
        chatListener(newIncomingChatWsSocialV2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newIncomingChatWsSocialV2
    ]);
    return null;
}
/* harmony default export */ var hooks_useChatListenerWsSocialV2 = (useChatListenerWsSocialV2);

// EXTERNAL MODULE: ./src/features/securities/AuthModal/index.tsx + 14 modules
var AuthModal = __webpack_require__(62450);
// EXTERNAL MODULE: ./src/utils/logger.ts
var logger = __webpack_require__(91635);
// EXTERNAL MODULE: ./src/features/community/hooks/useGetReferralInfo.ts
var useGetReferralInfo = __webpack_require__(37220);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeShareTracker.ts
var shareTradeShareTracker = __webpack_require__(56371);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeShare.ts
var useShareTradeShare = __webpack_require__(75774);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeTarget.ts
var useShareTradeTarget = __webpack_require__(972);
// EXTERNAL MODULE: ./src/features/sharetrade/utils/shareTradeOrder.ts + 1 modules
var shareTradeOrder = __webpack_require__(1473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTrade/EmptyState/styled.ts

function EmptyState_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: ",
        ";\n"
    ]);
    EmptyState_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptyState_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: auto;\n  margin-bottom: 16px;\n"
    ]);
    EmptyState_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #333333;\n  text-align: center;\n\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e0433b0-0"
})(EmptyState_styled_templateObject(), function(param) {
    var _height = param.height, height = _height === void 0 ? "auto" : _height;
    return height;
});
var ErrorIcon = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-e0433b0-1"
})(EmptyState_styled_templateObject1());
var InfoText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-e0433b0-2"
})(_templateObject2(), function(param) {
    var _color = param.color, color = _color === void 0 ? "#333333" : _color;
    return color;
});

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTrade/EmptyState/index.tsx


var EmptyState = function(param) {
    var height = param.height, textColor = param.textColor, _src = param.src, src = _src === void 0 ? "icon/empty-state-outline.svg" : _src, infoText = param.infoText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        height: height,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorIcon, {
                src: src
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoText, {
                color: textColor,
                children: infoText
            })
        ]
    });
};
/* harmony default export */ var ModalShareTrade_EmptyState = (EmptyState);

// EXTERNAL MODULE: ./src/features/sharetrade/components/ModalShareTrade/styled.ts
var ModalShareTrade_styled = __webpack_require__(15350);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTrade/index.tsx





















var ModalShareTrade = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Share Trade" : _title, _width = _param.width, width = _width === void 0 ? 430 : _width, modalVisible = _param.modalVisible, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "width",
        "modalVisible",
        "onSubmit"
    ]);
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useUIConfigStore/* default */.Z)(function(s) {
        var ref;
        return [
            (ref = s.getUIValue("shareTrade")) === null || ref === void 0 ? void 0 : ref.isTransactionBannerShown,
            s.setUIValue
        ];
    }, shallow/* default */.Z), 2), isTransactionBannerShown = ref2[0], setUIValue = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.selectedUsers,
            s.sharedUsers,
            s.setSelectedUsers
        ];
    }, shallow/* default */.Z), 3), selectedUsers = ref3[0], sharedUsers = ref3[1], setSelectedUsers = ref3[2];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeTarget/* default */.Z)(function(s) {
        return [
            s.data,
            s.error,
            s.isLoading,
            s.isEmptyList,
            s.loadShareTradeTarget,
            s.resetShareTradeTarget, 
        ];
    }, shallow/* default */.Z), 6), targetData = ref4[0], targetError = ref4[1], isTargetLoading = ref4[2], isEmptyList = ref4[3], loadShareTradeTarget = ref4[4], resetShareTradeTarget = ref4[5];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeShare/* default */.Z)(function(s) {
        return [
            s.transactionData,
            s.isLoading
        ];
    }, shallow/* default */.Z), 2), transactionData = ref5[0], isShareLoading = ref5[1];
    var isEmptySearch = (0,react.useMemo)(function() {
        var ref;
        return (targetData === null || targetData === void 0 ? void 0 : (ref = targetData.targets) === null || ref === void 0 ? void 0 : ref.length) === 0 && !!form.getFieldValue("userSearch");
    }, [
        (targetData === null || targetData === void 0 ? void 0 : (ref = targetData.targets) === null || ref === void 0 ? void 0 : ref.length) === 0,
        !!form.getFieldValue("userSearch")
    ]);
    var isShowAutoShare = (0,react.useMemo)(function() {
        return !targetError && !isEmptyList;
    }, [
        targetError,
        isEmptyList
    ]);
    var isShowUserList = (0,react.useMemo)(function() {
        return isShowAutoShare && !isEmptySearch;
    }, [
        isShowAutoShare,
        isEmptySearch
    ]);
    var isDisableSubmit = (0,react.useMemo)(function() {
        return Object.values(selectedUsers).length === 0 || isShareLoading;
    }, [
        Object.values(selectedUsers).length,
        isShareLoading
    ]);
    var userListData = (0,react.useMemo)(function() {
        // Map over sharedUsers and tag them as shared
        var taggedSharedUsers = Object.values(sharedUsers).map(function(user) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                is_shared: true
            });
        });
        // Filter targetData to exclude shared users and map over remaining ones
        var filteredTargetData = ((targetData === null || targetData === void 0 ? void 0 : targetData.targets) || []).filter(function(user) {
            return !sharedUsers[user.id];
        }).map(function(user) {
            var ref;
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
                is_share_value: ((ref = selectedUsers[user.id]) === null || ref === void 0 ? void 0 : ref.is_share_value) || user.is_share_value
            });
        });
        // Combine both arrays
        return (0,_to_consumable_array/* default */.Z)(taggedSharedUsers).concat((0,_to_consumable_array/* default */.Z)(filteredTargetData));
    }, [
        targetData === null || targetData === void 0 ? void 0 : targetData.targets,
        selectedUsers,
        sharedUsers,
        isTargetLoading
    ]);
    var previewShareTrade = (0,react.useMemo)(function() {
        return (0,shareTradeOrder/* getPreviewData */.oD)(transactionData);
    }, [
        transactionData
    ]);
    var handleBannerClose = function() {
        setUIValue("shareTrade", function(state) {
            state.isTransactionBannerShown = true;
        });
    };
    var handleResetSelectedUsers = (0,react.useCallback)(function() {
        setSelectedUsers({});
    }, [
        setSelectedUsers
    ]);
    var handleSelectedUserChange = function(isSelected, userTarget) {
        setSelectedUsers((0,immer_esm/* default */.ZP)(selectedUsers, function(state) {
            if (!isSelected && state[userTarget.id]) {
                delete state[userTarget.id];
                return;
            }
            state[userTarget.id] = userTarget;
        }));
    };
    var handleLoadUserNextPage = function() {
        var ref;
        if (targetData === null || targetData === void 0 ? void 0 : (ref = targetData.pagination) === null || ref === void 0 ? void 0 : ref.next_cursor) {
            loadShareTradeTarget({
                cursor: targetData.pagination.next_cursor,
                keyword: form.getFieldValue("userSearch")
            });
        }
    };
    var handleSearchChange = lodash_debounce_default()(function() {
        loadShareTradeTarget({
            keyword: form.getFieldValue("userSearch")
        }, true);
    }, 300);
    var handleShareClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        onSubmit(form.getFieldValue("saveAsAutoShare"));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleInitialLoad = (0,react.useCallback)(function() {
        loadShareTradeTarget({
            initialLoad: true
        });
    }, [
        loadShareTradeTarget
    ]);
    var handleResetShareTrade = (0,react.useCallback)(function() {
        handleResetSelectedUsers();
        resetShareTradeTarget();
        form.resetFields();
    }, [
        handleResetSelectedUsers,
        resetShareTradeTarget
    ]);
    (0,react.useEffect)(function() {
        if (modalVisible) {
            handleInitialLoad();
        } else {
            handleResetShareTrade();
        }
    }, [
        modalVisible,
        handleResetShareTrade
    ]);
    (0,react.useEffect)(function() {
        document.body.classList.add("disabled-popover-animation");
        return function() {
            document.body.classList.remove("disabled-popover-animation");
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShareTrade_styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        width: width
    }, props), {
        children: [
            targetError && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* ErrorState */.Te, {
                iconSrc: "/icon/error-document-retry.svg",
                description: "Unable to Load Data",
                onRetry: handleInitialLoad,
                loading: isTargetLoading
            }),
            isEmptyList && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_EmptyState, {
                textColor: "#969696",
                height: "276px",
                src: "icon/empty-state-outline.svg",
                infoText: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "You can only share trades with your groups",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        " or friends in your chat list"
                    ]
                })
            }),
            isShowAutoShare && /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShareTrade_styled/* HeaderRow */.VJ, {
                        children: [
                            !isTransactionBannerShown && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* Alert */.bZ, {
                                    message: "You can manage your Auto-Share list from Settings",
                                    afterClose: handleBannerClose
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                name: "userSearch",
                                noStyle: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* SearchInput */.Mj, {
                                    name: "userSearch",
                                    placeholder: "Search chat list",
                                    onChange: handleSearchChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* ListTitle */.AO, {
                                    children: "Send to"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                            span: 24,
                            children: [
                                isEmptySearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_EmptyState, {
                                    height: "356px",
                                    src: "icon/empty-state-outline.svg",
                                    infoText: "No result found. Chat with your friends first."
                                }),
                                isShowUserList && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* UserList */.Z7, {
                                    data: userListData,
                                    defaultCheckedKey: "is_shared",
                                    defaultSwitchKey: "is_share_value",
                                    disableSharedKey: [
                                        "is_autoshare_active",
                                        "is_shared"
                                    ],
                                    previewShareTrade: previewShareTrade,
                                    onSelectedUserChange: handleSelectedUserChange,
                                    onScrollToBottom: handleLoadUserNextPage,
                                    disableSharedUsers: true,
                                    isLoading: isTargetLoading
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* FooterCol */.zg, {
                        span: 24,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                            align: "middle",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalShareTrade_styled/* AgreementRow */.GY, {
                                        align: "middle",
                                        justify: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* AgreementText */.NL, {
                                                        children: "Add newly selected to next Auto Share’s"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* AgreementDescription */.mE, {
                                                        children: "Share Investment Amount settings can be changed via Privacy"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                                name: "saveAsAutoShare",
                                                initialValue: false,
                                                valuePropName: "checked",
                                                noStyle: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {})
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                    span: 24,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareTrade_styled/* SubmitButton */.Mm, {
                                        type: "primary",
                                        onClick: handleShareClick,
                                        loading: isShareLoading,
                                        disabled: isDisableSubmit,
                                        block: true,
                                        children: "Share"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_ModalShareTrade = (ModalShareTrade);

// EXTERNAL MODULE: ./src/features/sharetrade/components/ModalShareConfirm/index.tsx + 2 modules
var ModalShareConfirm = __webpack_require__(20242);
// EXTERNAL MODULE: ./src/global/Modal/BaseModal/index.tsx
var BaseModal = __webpack_require__(16981);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./src/global/Modal/BaseConfirmationModal/index.tsx
var BaseConfirmationModal = __webpack_require__(51595);
;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalSuccessInfo/styled.ts

function ModalSuccessInfo_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 18px 0 8px;\n  }\n\n  & .base-modal-header {\n    margin-bottom: 18px;\n  }\n\n  & .button-row {\n    padding: 20px;\n  }\n"
    ]);
    ModalSuccessInfo_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalSuccessInfo_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n"
    ]);
    ModalSuccessInfo_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 160px;\n  height: auto;\n\n  margin-bottom: 24px;\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n  margin-bottom: 16px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 20px 0;\n  gap: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 44px;\n  color: #ffffff;\n  border-radius: 4px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 44px;\n  color: #00ab6b;\n  border-radius: 4px;\n  border: none;\n  box-shadow: none;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm["default"])(BaseConfirmationModal/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-0"
})(ModalSuccessInfo_styled_templateObject());
var InfoWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bfb12a79-1"
})(ModalSuccessInfo_styled_templateObject1());
var Illustration = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-2"
})(styled_templateObject2());
var styled_InfoText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-bfb12a79-3"
})(_templateObject3());
var ButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bfb12a79-4"
})(_templateObject4());
var ConfirmButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-5"
})(_templateObject5());
var LinkButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-bfb12a79-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalSuccessInfo/index.tsx






var ModalSuccessInfo = function(_param) /*#__PURE__*/ {
    var _src = _param.src, src = _src === void 0 ? "/img/share-trade-delivered.svg" : _src, _infoText = _param.infoText, infoText = _infoText === void 0 ? "Order has been shared" : _infoText, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "infoText"
    ]);
    return (0,jsx_runtime.jsxs)(BaseModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 430
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                        src: src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_InfoText, {
                        children: infoText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                        type: "primary",
                        onClick: props.onSuccess,
                        loading: props.confirmLoading,
                        block: true,
                        children: "Done"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton, {
                        onClick: props.onBack,
                        block: true,
                        children: "Go to Chat List"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_ModalSuccessInfo = (ModalSuccessInfo);

;// CONCATENATED MODULE: ./src/features/sharetrade/components/ModalShareTradeManager/index.tsx




















var ShowModal;
(function(ShowModal) {
    ShowModal["SELECT"] = "SELECT";
    ShowModal["CONFIRM"] = "CONFIRM";
    ShowModal["SUCCESS"] = "SUCCESS";
})(ShowModal || (ShowModal = {}));
var ModalShareTradeManager = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isAutoShareOn = ref[0], setIsAutoShareOn = ref[1];
    var ref1 = (0,react.useState)(null), showModal = ref1[0], setShowModal = ref1[1];
    var symbol = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.symbol;
    });
    var resetModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.resetModal;
    });
    var usersData = (0,useShareTradeTarget/* default */.Z)(function(s) {
        return s.data;
    });
    var resetModalData = (0,tradingData/* default */.Z)(function(s) {
        return s.resetModalData;
    });
    var resetCompany = (0,tradingData/* default */.Z)(function(s) {
        return s.resetCompany;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.isVisible,
            s.setIsVisible
        ];
    }, shallow/* default */.Z), 2), isVisible = ref2[0], setIsVisible = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.selectedUsers,
            s.sharedUsers,
            s.setSelectedUsers,
            s.setSharedUsers, 
        ];
    }, shallow/* default */.Z), 4), selectedUsers = ref3[0], sharedUsers = ref3[1], setSelectedUsers = ref3[2], setSharedUsers = ref3[3];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeShare/* default */.Z)(function(s) {
        return [
            s.transactionData,
            s.isLoading,
            s.loadShareTradeShare,
            s.setTransactionData, 
        ];
    }, shallow/* default */.Z), 4), transactionData = ref4[0], isShareLoading = ref4[1], loadShareTradeShare = ref4[2], setTransactionData = ref4[3];
    var previewShareTrade = (0,react.useMemo)(function() {
        return (0,shareTradeOrder/* getPreviewData */.oD)(transactionData);
    }, [
        transactionData
    ]);
    var userSelectedList = (0,react.useMemo)(function() {
        if (!(usersData === null || usersData === void 0 ? void 0 : usersData.targets)) return [];
        return usersData.targets.filter(function(user) {
            return selectedUsers[user.id];
        }).map(function(user) {
            return (0,_object_spread/* default */.Z)({}, user, selectedUsers[user.id]);
        });
    }, [
        usersData === null || usersData === void 0 ? void 0 : usersData.targets,
        selectedUsers
    ]);
    var handleCloseModalShare = function() {
        setIsVisible(false);
        setShowModal(null);
        setSelectedUsers({});
    };
    var handleSubmitSelect = function(isAddAutoShare) {
        setIsAutoShareOn(isAddAutoShare);
        setShowModal(ShowModal.CONFIRM);
    };
    var handleCancelConfirm = function() {
        setShowModal(ShowModal.SELECT);
    };
    var handleShareConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var postData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        postData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionData), {
                            targets: Object.values(selectedUsers).map(function(param) {
                                var id = param.id, type = param.type, is_share_value = param.is_share_value;
                                return {
                                    id: id,
                                    type: type,
                                    is_share_value: is_share_value
                                };
                            }),
                            save_as_autoshare: isAutoShareOn
                        });
                        delete postData.total_investment;
                        _ctx.next = 4;
                        return loadShareTradeShare(postData);
                    case 4:
                        setSharedUsers((0,_object_spread/* default */.Z)({}, sharedUsers, selectedUsers));
                        setSelectedUsers({});
                        setShowModal(ShowModal.SUCCESS);
                        (0,shareTradeShareTracker/* trackShareSelected */.J4)(symbol, isAutoShareOn);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShareConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSwitchChange = function(checked, user) {
        setSelectedUsers((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedUsers), (0,_define_property/* default */.Z)({}, user.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, user), {
            is_share_value: checked
        }))));
    };
    var handleShareSuccess = function() {
        handleCloseModalShare();
        (0,shareTradeShareTracker/* trackDoneSelected */.tE)(symbol);
    };
    var handleBackToChatList = function() {
        // Reset all modal states
        resetCompany();
        resetModal();
        resetModalData();
        // Reset modal share
        setTransactionData(undefined);
        handleCloseModalShare();
        setSelectedUsers({});
        setSharedUsers({});
        // Redirect to chat
        router.push("/chat");
    };
    (0,react.useEffect)(function() {
        if (isVisible) setShowModal(ShowModal.SELECT);
    }, [
        isVisible
    ]);
    (0,react.useEffect)(function() {
        if (showModal === ShowModal.SELECT) (0,shareTradeShareTracker/* trackOrderViewed */.g3)();
        if (showModal === ShowModal.SUCCESS) (0,shareTradeShareTracker/* trackTradeSharedViewed */.cP)();
    }, [
        showModal
    ]);
    (0,react.useEffect)(function() {
        if (isVisible) {
            document.body.classList.add("no-scroll");
        } else {
            document.body.classList.remove("no-scroll");
        }
        return function() {
            document.body.classList.remove("no-scroll");
        };
    }, [
        isVisible
    ]);
    if (!isVisible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalShareTrade, {
                visible: showModal === ShowModal.SELECT,
                modalVisible: isVisible,
                onCancel: handleCloseModalShare,
                onSubmit: handleSubmitSelect,
                zIndex: 1003
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShareConfirm/* default */.Z, {
                visible: showModal === ShowModal.CONFIRM,
                selectedUsers: userSelectedList,
                previewShareTrade: previewShareTrade,
                isLoading: isShareLoading,
                onCancel: handleCancelConfirm,
                onConfirm: handleShareConfirm,
                onSwitchChange: handleSwitchChange,
                zIndex: 1004
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalSuccessInfo, {
                visible: showModal === ShowModal.SUCCESS,
                onCancel: handleShareSuccess,
                onSuccess: handleShareSuccess,
                onBack: handleBackToChatList
            })
        ]
    });
};
/* harmony default export */ var components_ModalShareTradeManager = (ModalShareTradeManager);

// EXTERNAL MODULE: ./src/stores/chat/useGetChatUnreadCount.ts
var useGetChatUnreadCount = __webpack_require__(9986);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
// EXTERNAL MODULE: ./src/global/GlobalModalManager/index.tsx + 14 modules
var GlobalModalManager = __webpack_require__(54037);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/global/Securities/types/api/bond.ts
var bond = __webpack_require__(73921);
// EXTERNAL MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx + 1 modules
var OrderPlacedModal = __webpack_require__(70536);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/Form.js
var Form = __webpack_require__(50963);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var TradingModal_styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./src/features/securities/withdrawal/utils.ts
var withdrawal_utils = __webpack_require__(17921);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var ModalBonds_constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useCashOnHandStore.ts
var useCashOnHandStore = __webpack_require__(78311);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore.ts
var useBondsModalStore = __webpack_require__(81557);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondTransaction.ts
var useBondTransaction = __webpack_require__(55847);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPreview.ts
var useBondPreview = __webpack_require__(42427);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/hooks/useBondPreviewForm.ts







var DEBOUNCE_DURATION = 500; // 500ms
function useBondPreviewForm(param) {
    var action = param.action, productId = param.productId, _orderId = param.orderId, orderId = _orderId === void 0 ? "" : _orderId;
    var isBuy = action === bond/* BondTransactionActionEnum.BUY */.qB.BUY;
    var isSell = action === bond/* BondTransactionActionEnum.SELL */.qB.SELL;
    var ref = (0,react.useState)(), unit = ref[0], setUnit = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var debouncedUnit = (0,useDebounce/* default */.Z)(unit, DEBOUNCE_DURATION);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return [
            s.loadBuyPreview,
            s.loadSellPreview,
            s.isLoading,
            s.buy,
            s.sell, 
        ];
    }), 5), loadBuyPreview = ref2[0], loadSellPreview = ref2[1], isLoading = ref2[2], buy = ref2[3], sell = ref2[4];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.modalType
        ];
    }), 1), modalType = ref3[0];
    var isDisabled = isLoading || !debouncedUnit || debouncedUnit <= 0;
    var handleUnitAmountChanged = function(e) {
        var value = parseInt(e.target.value, 10);
        // prevent NaN || handle negative value
        if (Number.isNaN(value)) {
            setUnit(undefined);
            return;
        }
        // handle unit more than maximum
        if (isBuy && value >= ModalBonds_constants/* MAX_UNIT_AMOUNT */.N2) {
            setUnit(ModalBonds_constants/* MAX_UNIT_AMOUNT */.N2);
            return;
        }
        if (isSell && value >= (sell === null || sell === void 0 ? void 0 : sell.available_units)) {
            setUnit(sell === null || sell === void 0 ? void 0 : sell.available_units);
            return;
        }
        setUnit(value);
    };
    var clearError = function() {
        setError("");
    };
    var loadPreview = (0,react.useCallback)(function() {
        // prevent NaN || handle negative value
        if (Number.isNaN(debouncedUnit)) {
            setError("Unit must be an integer");
            return;
        }
        if (debouncedUnit < 0) {
            setError("Unit cannot be a negative number.");
            return;
        }
        if (!productId) {
            setError("Product is required");
            return;
        }
        if (!productId) {
            setError("Product id is required");
            return;
        }
        if (isBuy) {
            loadBuyPreview(productId, unit);
            return;
        }
        if (!orderId) {
            setError("Order id is required");
            return;
        }
        if (isSell) {
            loadSellPreview(productId, orderId, unit);
        }
    }, [
        debouncedUnit,
        isBuy,
        isSell,
        productId,
        orderId
    ]);
    (0,react.useEffect)(function() {
        if (// prevent calling when loading / fetching
        isLoading || // prevent calling if the modalType is not enum
        modalType !== ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION || // prevent calling if action is unspecified
        action === bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED) {
            // do nothing
            return;
        }
        loadPreview();
    }, [
        debouncedUnit,
        productId,
        modalType,
        action
    ]);
    return {
        preview: {
            buy: buy,
            sell: sell
        },
        handleUnitAmountChanged: handleUnitAmountChanged,
        unit: unit,
        isLoadingPreview: isLoading,
        error: error,
        clearError: clearError,
        isDisabled: isDisabled
    };
};

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/styled.ts
var ModalBonds_styled = __webpack_require__(70098);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/InfoSvg.tsx
var InfoSvg = __webpack_require__(42958);
// EXTERNAL MODULE: ./src/global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled.ts
var OrderTypeFormItem_styled = __webpack_require__(82093);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondsBuy/styled.ts

function ModalBondsBuy_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f7f7f7;\n  border-radius: 2px;\n  height: 20px;\n  width: 100%;\n"
    ]);
    ModalBondsBuy_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondsBuy_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ee4a49;\n  border-radius: 4px;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n"
    ]);
    ModalBondsBuy_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondsBuy_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 20px;\n  border-radius: 4px;\n  background-color: #ebf8f3;\n  outline: none;\n  border: none;\n  color: #00ab6b;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n"
    ]);
    ModalBondsBuy_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FormItemShimmer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a9d64a61-0"
})(ModalBondsBuy_styled_templateObject());
var AlertContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-a9d64a61-1"
})(ModalBondsBuy_styled_templateObject1());
var DepositButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-a9d64a61-2"
})(ModalBondsBuy_styled_templateObject2());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/FormDisplayField.tsx










var FormDisplayField_Flex = ui/* Common.Flex */.Gn.Flex, FormDisplayField_Text = ui/* Common.Text */.Gn.Text;
function FormDisplayField(param) {
    var _label = param.label, label = _label === void 0 ? "-" : _label, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _value = param.value, value = _value === void 0 ? 0 : _value, _isBold = param.isBold, isBold = _isBold === void 0 ? false : _isBold, _type = param.type, type = _type === void 0 ? "default" : _type, _isNeedInfo = param.isNeedInfo, isNeedInfo = _isNeedInfo === void 0 ? false : _isNeedInfo, _onInfoClick = param.onInfoClick, onInfoClick = _onInfoClick === void 0 ? function() {} : _onInfoClick, _isShowSign = param.isShowSign, isShowSign = _isShowSign === void 0 ? false : _isShowSign, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, _defaultColor = param.defaultColor, defaultColor = _defaultColor === void 0 ? "#333333" : _defaultColor, _plPercentage = param.plPercentage, plPercentage = _plPercentage === void 0 ? undefined : _plPercentage;
    var color = defaultColor;
    var sign = "";
    if (type === "pl") {
        color = value >= 0 ? ui/* color.primary */.$_.primary : ui/* color.sunsetOrange */.$_.sunsetOrange;
    }
    if (isShowSign || type === "pl") {
        sign = value > 0 && value !== 0 ? "+" : "-";
    }
    var handleInfoClick = function(e) {
        e.stopPropagation();
        e.preventDefault();
        onInfoClick();
    };
    var composed = "".concat(sign, "Rp").concat((0,number/* formatNumber */.uf)(Math.abs(value), true, "0,0.00")) + " (".concat(sign).concat((0,number/* formatNumber */.uf)(Math.abs(plPercentage), true, "0,0.00", true), "%)");
    var isMultiline = composed.length >= 22;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FormItem */.xJ, {
        disabled: isDisabled,
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormDisplayField_Flex, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isNeedInfo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                type: "button",
                                onClick: handleInfoClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    component: InfoSvg/* default */.Z,
                                    style: {
                                        fontSize: 16,
                                        color: "#969696",
                                        marginLeft: 4
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: subtitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField_Text, {
                        size: "12px",
                        color: "#B5B5B5",
                        align: "right",
                        children: subtitle
                    })
                })
            ]
        }),
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemShimmer, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: type === "pl" && isMultiline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormDisplayField_Flex, {
                        direction: "column",
                        align: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField_Text, {
                                color: color,
                                family: isBold ? "bold" : "normal",
                                children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(value, "exceptZero")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: plPercentage !== undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormDisplayField_Text, {
                                    color: color,
                                    family: isBold ? "bold" : "normal",
                                    align: "end",
                                    children: [
                                        " ",
                                        "(",
                                        (0,withdrawal_utils/* formatPricePercentage */.iM)(plPercentage, "exceptZero"),
                                        ")"
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: type === "pl" && !isMultiline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormDisplayField_Text, {
                        color: color,
                        family: isBold ? "bold" : "normal",
                        children: [
                            (0,withdrawal_utils/* formatBondCurrency */.uJ)(value, "exceptZero"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: plPercentage !== undefined,
                                children: [
                                    " ",
                                    "(",
                                    (0,withdrawal_utils/* formatPricePercentage */.iM)(plPercentage, "exceptZero"),
                                    ")"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: type !== "pl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormDisplayField_Text, {
                        family: isBold ? "bold" : "normal",
                        color: color,
                        size: "14px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === "currency",
                                children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(value, isShowSign ? "exceptZero" : "never")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === "percentage",
                                children: (0,withdrawal_utils/* formatPricePercentage */.iM)(value, isShowSign ? "exceptZero" : "never")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: type === "number",
                                children: [
                                    isShowSign ? sign : "",
                                    (0,number/* formatNumber */.uf)(value, true, "0,0.00")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: type === "unit",
                                children: [
                                    value,
                                    " Unit"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === "default",
                                children: value
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx + 1 modules
var SearchCompany = __webpack_require__(77017);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductDisplay.tsx














var ModalProductDisplay_Text = ui/* Common.Text */.Gn.Text, ModalProductDisplay_Flex = ui/* Common.Flex */.Gn.Flex, ModalProductDisplay_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function ModalProductDisplay(param) {
    var _isSearchEnabled = param.isSearchEnabled, isSearchEnabled = _isSearchEnabled === void 0 ? false : _isSearchEnabled, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var stockInputRef = (0,react.useRef)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.toggleSearch,
            s.isSearchActive,
            s.closeTransactionModal, 
        ];
    }), 3), toggleSearch = ref[0], isSearchActive = ref[1], closeTransactionModal = ref[2];
    var field = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return {
            field: s.product
        };
    }).field;
    var initiateBuy = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return {
            initiateBuy: s.initiateBuyTransaction
        };
    }).initiateBuy;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,TradingModal_store/* default */.Z)(function(s) {
        return [
            s.showModal
        ];
    }), 1), showTradingModal = ref1[0];
    var handleUpdateSymbol = function(newSymbol, isBonds) {
        if (!isBonds) {
            showTradingModal({
                symbol: newSymbol,
                orderType: "BUY"
            });
        }
        if (isBonds) {
            initiateBuy(newSymbol);
        }
        if (isSearchActive) {
            toggleSearch();
        }
        closeTransactionModal();
    };
    (0,react.useEffect)(function() {
        if (isSearchActive) {
            var ref;
            (ref = stockInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        isSearchActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingModal_styled/* FormHeader */.ph, {
        style: {
            paddingTop: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay_Flex, {
                justify: "space-between",
                width: "100%",
                style: {
                    display: isSearchActive ? "none" : "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalProductDisplay_Flex, {
                    align: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: (field === null || field === void 0 ? void 0 : field.icon_url) || ModalBonds_constants/* FALLBACK_AVATAR_SRC */.sW,
                            style: {
                                width: "40px",
                                height: "40px",
                                background: "white"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalProductDisplay_Flex, {
                            direction: "column",
                            pl: "15px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay_Flex, {
                                    align: "center",
                                    width: "200px",
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* TextLoadingShimmer */.pT, {
                                        width: "80px",
                                        height: "16px"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay_Text, {
                                        family: "bold",
                                        size: "16px",
                                        children: field === null || field === void 0 ? void 0 : field.id
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalProductDisplay_Flex, {
                                    mt: "3px",
                                    children: [
                                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* TextLoadingShimmer */.pT, {
                                            width: "160px",
                                            height: "16px"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay_Text, {
                                            size: "14px",
                                            color: ui/* color.midgray */.$_.midgray,
                                            mr: "5px",
                                            children: field === null || field === void 0 ? void 0 : field.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: isSearchEnabled,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay_Iconmoon, {
                                                className: "icon-tradesmall_pencil2",
                                                size: "14px",
                                                hoverColor: ui/* color.highgray */.$_.highgray,
                                                onClick: toggleSearch
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isSearchEnabled && isSearchActive,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay_Flex, {
                    width: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                        ref: stockInputRef,
                        isInTradingModal: true,
                        updateSymbol: handleUpdateSymbol
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalTitle.tsx




var ModalTitle_Flex = ui/* Common.Flex */.Gn.Flex, ModalTitle_Text = ui/* Common.Text */.Gn.Text, ModalTitle_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function ModalTitle(param) {
    var title = param.title, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "24px" : _fontSize, _color = param.color, color = _color === void 0 ? "#333333" : _color, _isCentered = param.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, onClose = param.onClose;
    var modalType = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.modalType;
    });
    var align = modalType === ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION || modalType === ModalBonds_constants/* BondsModalTypeEnum.ORDER */._y.ORDER || modalType === ModalBonds_constants/* BondsModalTypeEnum.CONFIRMATION */._y.CONFIRMATION || isCentered ? "center" : "start";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalTitle_Flex, {
        justify: "between",
        align: "center",
        w: "100%",
        height: "50px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle_Text, {
                family: "bold",
                color: color,
                size: fontSize,
                align: align,
                mt: "0",
                width: "100%",
                "data-cy": "bonds-modal-header",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle_Iconmoon, {
                className: "icon-trading_x",
                color: "#333333",
                size: "12px",
                onClick: onClose
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/Accordion/styled.ts

function Accordion_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n\n  transition: all 0.25s ease-in-out;\n\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n\n  position: absolute;\n  right: ",
        ";\n"
    ]);
    Accordion_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Accordion_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & + & {\n    /* margin-top: -0.125rem; */\n  }\n"
    ]);
    Accordion_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Accordion_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  border-top: ",
        ";\n\n  margin-top: ",
        ";\n\n  .ant-row.ant-form-item {\n    width: 100%;\n  }\n\n  .ant-row.ant-form-item {\n    height: 32px;\n    margin-bottom: 0;\n  }\n  position: relative;\n  padding-top: ",
        ";\n  padding-top: ",
        ";\n"
    ]);
    Accordion_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 1.5;\n\n  .ant-form-item {\n  }\n\n  .ant-row.ant-form-item {\n    height: 24px;\n  }\n\n  .ant-row.ant-form-item:last-child {\n    margin-bottom: 8px;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: ",
        ";\n  max-height: ",
        ";\n  transition: max-height 0.25s ease-in-out;\n  padding-top: ",
        ";\n  overflow: hidden;\n\n  padding-top: ",
        ";\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Chevron = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5df286b1-0"
})(Accordion_styled_templateObject(), function(p) {
    return p.direction === "top" && "rotate(180deg)";
}, function(p) {
    return p.direction === "right" && "-rotate(90deg)";
}, function(p) {
    return p.direction === "bottom" && "rotate(0deg)";
}, function(p) {
    return p.direction === "left" && "rotate(90deg)";
}, function(p) {
    return p.isTight ? "0px" : "24px";
});
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5df286b1-1"
})(Accordion_styled_templateObject1());
var Title = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5df286b1-2"
})(Accordion_styled_templateObject2(), function(p) {
    return !p.isExpanded && !p.isPlain ? "1px solid gainsboro" : "none";
}, function(p) {
    return p.isExpanded ? "12px" : "0px";
}, function(p) {
    return p.isExpanded ? "0px" : "20px";
}, function(p) {
    return p.isTight && !p.isExpanded && "0px";
});
var Content = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5df286b1-3"
})(styled_templateObject3());
var ContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5df286b1-4"
})(styled_templateObject4(), function(p) {
    return p.isExpanded && !p.isPlain ? "1px solid gainsboro" : "none";
}, function(p) {
    return "".concat(p.maxHeight, "px");
}, function(p) {
    return p.isExpanded ? "20px" : "0px";
}, function(p) {
    return p.isTight ? "0px" : "20px";
});

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/Accordion/index.tsx




function Accordion(param) {
    var children = param.children, title = param.title, _isPlain = param.isPlain, isPlain = _isPlain === void 0 ? false : _isPlain, _isTight = param.isTight, isTight = _isTight === void 0 ? false : _isTight;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setExpand = ref[1];
    var contentRef = (0,react.useRef)();
    var contentHeight = isExpanded ? contentRef.current.scrollHeight + 400 : 0;
    var handleExpandToggle = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setExpand(!isExpanded);
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                maxHeight: contentHeight,
                isExpanded: isExpanded,
                isPlain: isPlain,
                isTight: isTight,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    ref: contentRef,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                onClick: handleExpandToggle,
                isExpanded: isExpanded,
                isPlain: isPlain,
                isTight: isTight,
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        direction: isExpanded ? "top" : "bottom",
                        isTight: isTight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownSvg/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondsBuy/component/DepositAlert.tsx





var DepositAlert_Text = ui/* Common.Text */.Gn.Text;
function DepositAlert() {
    var router = (0,next_router.useRouter)();
    var closeTransactionModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeTransactionModal;
    });
    var onDepositClick = function() {
        closeTransactionModal();
        router.push("/securities/deposit");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositAlert_Text, {
                        family: "bold",
                        mb: "2px",
                        children: "Deposit Sekarang"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositAlert_Text, {
                        color: ui/* color.sunsetOrange */.$_.sunsetOrange,
                        children: "Saldo kamu tidak mencukupi"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositButton, {
                onClick: onDepositClick,
                children: "Deposit"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondInfoModal.ts
var useBondInfoModal = __webpack_require__(32471);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondsBuy/index.tsx























var ModalBondsBuy_Text = ui/* Common.Text */.Gn.Text;
function ModalBondsBuy() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,Form/* useForm */.cI)(), 1), form = ref10[0];
    var productId = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return s.productId;
    });
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.transactionType,
            s.openConfirmModal,
            s.isSearchActive,
            s.toggleSearch,
            s.closeTransactionModal,
            s.sourcePage, 
        ];
    }), 6), transactionType = ref11[0], openConfirmModal = ref11[1], isSearchActive = ref11[2], toggleSearch = ref11[3], closeTransactionModal = ref11[4], sourcePage = ref11[5];
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useCashOnHandStore/* useCashOnHandStore */.I)(function(s) {
        return [
            s.cashOnHand,
            s.isLoading, 
        ];
    }), 2), cashOnHand = ref12[0], isLoadingCash = ref12[1];
    var ref13 = useBondPreviewForm({
        action: bond/* BondTransactionActionEnum.BUY */.qB.BUY,
        productId: productId
    }), handleUnitAmountChanged = ref13.handleUnitAmountChanged, preview = ref13.preview, unit = ref13.unit, isLoadingPreview = ref13.isLoadingPreview, previewDisabled = ref13.isDisabled;
    var ref14 = (0,useBondsAnalytics/* default */.Z)(), FRBondsNavigateTrackers = ref14.FRBondsNavigateTrackers, FRBondActionTrackers = ref14.FRBondActionTrackers;
    var _transactionType = ModalBonds_constants/* BOND_TRANSACTION_CONFIG */.H1[transactionType], textColor = _transactionType.textColor, title = _transactionType.title;
    var isExceedAmount = (preview === null || preview === void 0 ? void 0 : (ref = preview.buy) === null || ref === void 0 ? void 0 : ref.total_amount) > cashOnHand;
    var isDisabled = isLoadingCash || previewDisabled || isExceedAmount || isSearchActive;
    var handleSubmit = function() {
        FRBondActionTrackers.onOrderPlaced("Buy", productId);
        openConfirmModal();
    };
    (0,react.useEffect)(function() {
        if (productId) {
            FRBondsNavigateTrackers.onBondOrderPageViewed("Buy", productId, sourcePage);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
        form: form,
        onFinish: handleSubmit,
        colon: false,
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 8,
            offset: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
                modalType: ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isSearchActive,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* FreezeLayer */.VV, {
                            onClick: function() {
                                return toggleSearch(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalHeader */.xB, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                                color: textColor,
                                title: title,
                                onClose: closeTransactionModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay, {
                                isSearchEnabled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isExceedAmount,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositAlert, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Cash On Hand",
                                isLoading: isLoadingCash,
                                value: Math.round(cashOnHand),
                                type: "currency",
                                isNeedInfo: true,
                                isBold: true,
                                onInfoClick: function() {
                                    return openInfoModal(ModalBonds_constants/* BondInfoType.CASH_ON_HAND */.Im.CASH_ON_HAND);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Unit Pembelian",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* UnitInput */.OT, {
                                    value: unit,
                                    onChange: handleUnitAmountChanged,
                                    placeholder: "1 Unit = ".concat((0,withdrawal_utils/* formatCurrency */.xG)(ModalBonds_constants/* BASE_UNIT_AMOUNT.toString */.MD.toString())),
                                    type: "number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Harga Beli (%)",
                                value: preview === null || preview === void 0 ? void 0 : (ref1 = preview.buy) === null || ref1 === void 0 ? void 0 : ref1.price_rate,
                                type: "percentage",
                                onInfoClick: function() {
                                    return openInfoModal(ModalBonds_constants/* BondInfoType.BUYING_PRICE */.Im.BUYING_PRICE);
                                },
                                isNeedInfo: true,
                                isDisabled: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "Total Pembayaran",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref2 = preview.buy) === null || ref2 === void 0 ? void 0 : ref2.total_amount,
                                    isBold: true,
                                    type: "currency",
                                    defaultColor: isExceedAmount ? ui/* color.sunsetOrange */.$_.sunsetOrange : "#333333"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Nilai Pembelian",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref3 = preview.buy) === null || ref3 === void 0 ? void 0 : ref3.buy_price_amount,
                                        type: "currency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Penjual",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref4 = preview.buy) === null || ref4 === void 0 ? void 0 : ref4.accrued_interest,
                                        type: "currency",
                                        isNeedInfo: true,
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        },
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref5 = preview.buy) === null || ref5 === void 0 ? void 0 : ref5.accrued_interest) > 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Bea Meterai",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref6 = preview.buy) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fee) === null || ref7 === void 0 ? void 0 : ref7.stamp_duty,
                                        type: "currency",
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref8 = preview.buy) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fee) === null || ref9 === void 0 ? void 0 : ref9.stamp_duty) > 0
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* OrderButton */.sg, {
                    disabled: isDisabled,
                    type: "primary",
                    htmlType: "submit",
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondsBuy_Text, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondBlockers/styled.ts

function ModalBondBlockers_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: start;\n  align-items: center;\n  text-align: center;\n\n  max-width: 355px;\n  max-height: 256px;\n"
    ]);
    ModalBondBlockers_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondBlockers_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 135px;\n  width: 100%;\n"
    ]);
    ModalBondBlockers_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondBlockers_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24.3px;\n  padding: 0px 40px;\n  margin: 0px;\n"
    ]);
    ModalBondBlockers_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-718dac81-0"
})(ModalBondBlockers_styled_templateObject());
var Logo = (0,styled_components_browser_esm["default"])(Image/* default */.Z).withConfig({
    componentId: "sc-718dac81-1"
})(ModalBondBlockers_styled_templateObject1());
var Heading = styled_components_browser_esm["default"].h3.withConfig({
    componentId: "sc-718dac81-2"
})(ModalBondBlockers_styled_templateObject2());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondBlockers/constants.ts


var _obj;
var BOND_BLOCKER_CONFIG = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.UNSPECIFIED */.Ew.UNSPECIFIED, {
    title: "",
    textColor: "",
    content: [],
    iconSrc: ""
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.MAINTENANCE */.Ew.MAINTENANCE, {
    title: "Maintenance Sedang Berlangsung",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-maintenance.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.MARKET_CLOSE */.Ew.MARKET_CLOSE, {
    title: "Market Sedang Tutup",
    textColor: "#333333",
    content: [],
    iconSrc: "icon/fr/fr-blocker-market-close.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.PRICE_CHANGED */.Ew.PRICE_CHANGED, {
    title: "Terjadi Perubhan Harga",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-price-changed.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.TEMPORARY_UNAVAILABLE */.Ew.TEMPORARY_UNAVAILABLE, {
    title: "Sedang Tidak Tersedia",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-temporary-unavailable.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.UNAVAILABLE */.Ew.UNAVAILABLE, {
    title: "Sementara Tidak Dapat Dibeli",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-unavailable.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.SHARIA_VALIDATION */.Ew.SHARIA_VALIDATION, {
    title: "Bukan FR Syariah",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-sharia.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.STABLE_EARN */.Ew.STABLE_EARN, {
    title: "Produk Teridentifikasi Sebagai Stable Earn",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-stable-earn.svg"
}), (0,_define_property/* default */.Z)(_obj, ModalBonds_constants/* BondBlockerType.GENERAL_ERROR */.Ew.GENERAL_ERROR, {
    title: "Unable to Load Data",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-general-error.svg"
}), _obj);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondBlockers/index.tsx

function ModalBondBlockers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                width: 200px;\n              "
    ]);
    ModalBondBlockers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ModalBondBlockers_Flex = ui/* Common.Flex */.Gn.Flex, ModalBondBlockers_Text = ui/* Common.Text */.Gn.Text, ModalBondBlockers_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function ModalBondBlockers(param) {
    var onClose = param.onClose;
    var router = (0,next_router.useRouter)();
    var productId = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return s.productId;
    });
    var blockerType = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return {
            blockerType: s.blockerType
        };
    }).blockerType;
    var _blockerType = BOND_BLOCKER_CONFIG[blockerType], iconSrc = _blockerType.iconSrc, title = _blockerType.title;
    var handleGotoSector = function() {
        router.push("/catalog/fr-bonds/");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondBlockers_Flex, {
                    justify: "space-between",
                    align: "start",
                    w: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                            alt: "".concat(title, " illustration"),
                            src: iconSrc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers_Iconmoon, {
                            className: "icon-trading_x",
                            color: "#333333",
                            size: "12px",
                            onClick: onClose
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalBody */.fe, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.MAINTENANCE */.Ew.MAINTENANCE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Maintenance Sedang Berlangsung"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers_Text, {
                                    align: "center",
                                    children: "Transaksi Obligasi Pasar Sekunder tidak bisa dilakukan untuk sementara. Silahkan coba lagi nanti."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.PRICE_CHANGED */.Ew.PRICE_CHANGED,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Terjadi Perubahan Harga"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers_Text, {
                                    align: "center",
                                    children: "Harga telah berubah mengikuti harga pasar saat ini"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.STABLE_EARN */.Ew.STABLE_EARN,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                children: "Stable Earn Hanya Dapat Dijual Melalui Aplikasi Bibit"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.MARKET_CLOSE */.Ew.MARKET_CLOSE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Market Sedang Tutup"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondBlockers_Flex, {
                                    direction: "column",
                                    align: "center",
                                    gap: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers_Text, {
                                            children: "Market akan buka kembali dalam"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers_Text, {
                                            color: ui/* color.primary */.$_.primary,
                                            children: "15-20 menit."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.TEMPORARY_UNAVAILABLE */.Ew.TEMPORARY_UNAVAILABLE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                    children: [
                                        productId,
                                        " Sedang Tidak Tersedia"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondBlockers_Text, {
                                    align: "center",
                                    children: [
                                        "Saat ini sedang dilakukan proses pencatatan untuk pembagian kupon obligasi ",
                                        productId,
                                        ". Transaksi ",
                                        productId,
                                        " dapat dilakukan kembali dalam",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers_Text, {
                                            as: "span",
                                            color: ui/* color.primary */.$_.primary,
                                            children: "1 - 2 hari bursa"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.UNAVAILABLE */.Ew.UNAVAILABLE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Sementara Tidak Dapat Dibeli"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Silahkan coba produk Obligasi FR lainnya."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                    type: "primary",
                                    onClick: handleGotoSector,
                                    block: true,
                                    children: "Lihat Produk Obligasi FR"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === ModalBonds_constants/* BondBlockerType.SHARIA_VALIDATION */.Ew.SHARIA_VALIDATION,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Bukan FR Syariah"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Kamu tidak bisa bertransaksi FR non-syariah.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "(Fatwa No.80/DSN-MUI/III/2011)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledButton, {
                                    type: "primary",
                                    onClick: onClose,
                                    block: true,
                                    children: "Oke"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var _StyledButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-d4b5f125-0"
})(ModalBondBlockers_templateObject());

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/styled.ts
var RealTradingModal_styled = __webpack_require__(61227);
// EXTERNAL MODULE: ./src/features/trade/components/Portfolio/PnLCurrency.tsx
var PnLCurrency = __webpack_require__(32978);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/styled.ts

function ModalBondConfirm_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    ModalBondConfirm_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondConfirm_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  padding: 16px 20px;\n  margin: 16px 20px;\n  gap: 16px;\n  width: 335px;\n"
    ]);
    ModalBondConfirm_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondConfirm_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n  padding-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    ModalBondConfirm_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBondConfirm_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :disabled {\n    background: #616161 !important;\n    color: #cbcbcb;\n    border: none;\n  }\n"
    ]);
    ModalBondConfirm_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-381da8d1-0"
})(ModalBondConfirm_styled_templateObject());
var BorderedWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-381da8d1-1"
})(ModalBondConfirm_styled_templateObject1());
var Section = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-381da8d1-2"
})(ModalBondConfirm_styled_templateObject2());
var styled_ConfirmButton = (0,styled_components_browser_esm["default"])(ui/* Common.Button */.Gn.Button).withConfig({
    componentId: "sc-381da8d1-3"
})(ModalBondConfirm_styled_templateObject3());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/components/ContentBuy.tsx

function ContentBuy_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin: 0px;\n          margin-bottom: 12px;\n          border-color: #dadada;\n        "
    ]);
    ContentBuy_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ContentBuy_Flex = ui/* Common.Flex */.Gn.Flex, ContentBuy_Text = ui/* Common.Text */.Gn.Text;
function ContentBuy() {
    var ref;
    var field = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return s.buy;
    });
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: "Unit Pembelian"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: field === null || field === void 0 ? void 0 : field.unit
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: "Harga Beli (%)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: (0,number/* formatPercentage */.rl)(field === null || field === void 0 ? void 0 : field.price_rate, true, "0,0.00")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: "Nilai Pembelian"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.buy_price_amount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Flex, {
                                align: "center",
                                gap: "2px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Kupon Penjual"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: InfoSvg/* default */.Z,
                                            style: {
                                                color: "#969696"
                                            },
                                            onClick: function() {
                                                return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.accrued_interest, "exceptZero")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: "Bea Meterai"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : (ref = field.fee) === null || ref === void 0 ? void 0 : ref.stamp_duty, "exceptZero")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentBuy_Flex, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                family: "bold",
                                children: "Total Pembayaran"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy_Text, {
                                family: "bold",
                                children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.total_amount)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var _StyledDivider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-3bbc7fab-0"
})(ContentBuy_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/components/ContentSell.tsx










var ContentSell_Flex = ui/* Common.Flex */.Gn.Flex, ContentSell_Text = ui/* Common.Text */.Gn.Text;
function ContentSell() {
    var ref, ref1;
    var field = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return s.sell;
    });
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: "Unit Penjualan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: field === null || field === void 0 ? void 0 : field.units
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: "Harga Jual (%)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: (0,number/* formatPercentage */.rl)(field === null || field === void 0 ? void 0 : field.price.sell, false, "0,0.00")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: "Nilai Penjualan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.estimation_sell_amount)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: "Kupon Berjalan (Nett)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.accrued_interest_exclude_tax, "exceptZero")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: "Pajak"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)((field === null || field === void 0 ? void 0 : (ref = field.fee) === null || ref === void 0 ? void 0 : ref.total_tax) * -1, "exceptZero")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: "Bea Meterai"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)((field === null || field === void 0 ? void 0 : (ref1 = field.fee) === null || ref1 === void 0 ? void 0 : ref1.stamp_duty) * -1, "exceptZero")
                        })
                    ]
                }),
                (field === null || field === void 0 ? void 0 : field.seller_coupon) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Flex, {
                            align: "center",
                            gap: "2px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Kupon Penjual"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            color: "#969696"
                                        },
                                        onClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.seller_coupon, "exceptZero")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentSell_Flex, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            family: "bold",
                            children: "Total Nilai Penjualan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell_Text, {
                            family: "bold",
                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.amount)
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/index.tsx

function ModalBondConfirm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              padding-bottom: 0px;\n            "
    ]);
    ModalBondConfirm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondConfirm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  margin: 12px 0px;\n                "
    ]);
    ModalBondConfirm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



















var ModalBondConfirm_Button = ui/* Common.Button */.Gn.Button, ModalBondConfirm_Flex = ui/* Common.Flex */.Gn.Flex, ModalBondConfirm_Text = ui/* Common.Text */.Gn.Text;
function ModalBondConfirm() {
    var ref = (0,useBondsAnalytics/* default */.Z)(), FRBondActionTrackers = ref.FRBondActionTrackers, FRBondsNavigateTrackers = ref.FRBondsNavigateTrackers;
    var ref1 = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return {
            closeModal: s.closeModal,
            openTncModal: s.openTncModal,
            clearModal: s.clear,
            openOrderPlacedModal: s.openOrderPlacedModal,
            sourcePage: s.sourcePage
        };
    }), closeModal = ref1.closeModal, clearModal = ref1.clearModal, openTncModal = ref1.openTncModal, openOrderPlacedModal = ref1.openOrderPlacedModal, sourcePage = ref1.sourcePage;
    var ref2 = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return {
            type: s.transactionType,
            isTnCAccepted: s.isTnCAccepted,
            setTnC: s.setTnC,
            submitOrder: s.submitOrder,
            isSubmitSuccess: s.isSuccess,
            productId: s.productId
        };
    }), type = ref2.type, isTnCAccepted = ref2.isTnCAccepted, setTnC = ref2.setTnC, submitOrder = ref2.submitOrder, isSubmitSuccess = ref2.isSubmitSuccess, productId = ref2.productId;
    var ref3 = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return {
            clearPreview: s.clear,
            sell: s.sell
        };
    }), clearPreview = ref3.clearPreview, sell = ref3.sell;
    var title = type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy ".concat(productId) : "Sell ".concat(productId);
    var handleCheckboxChange = function(event) {
        if (event.target.checked) {
            FRBondActionTrackers.onTnCConfirmed();
        }
        setTnC(event.target.checked);
    };
    var handleSubmitOrder = function() {
        submitOrder();
        FRBondActionTrackers.onOrderConfirmed(type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy" : "Sell", productId, sourcePage);
    };
    (0,react.useEffect)(function() {
        // If success, then redirect to the portfolio
        if (isSubmitSuccess) {
            clearPreview(); // clear buy/sell preview data
            clearModal(); // clear modal state
            openOrderPlacedModal();
            FRBondsNavigateTrackers.onBondOrderSuccessViewed(type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy" : "Sell", productId, sourcePage);
        }
    }, [
        isSubmitSuccess
    ]);
    (0,react.useEffect)(function() {
        FRBondsNavigateTrackers.onBondPreviewOrderViewed(type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy" : "Sell", productId, sourcePage);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                            title: title,
                            color: "#333333",
                            onClose: closeModal
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(_StyledBorderedWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: type === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: type === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BorderedWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondConfirm_Flex, {
                                            align: "center",
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Text, {
                                                        family: "bold",
                                                        size: "14px",
                                                        children: "P&L (Nett)"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    amount: sell === null || sell === void 0 ? void 0 : sell.profit_loss_nett,
                                                    percentage: sell === null || sell === void 0 ? void 0 : sell.profit_loss_nett_percentage,
                                                    family: "bold"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_StyledDivider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondConfirm_Flex, {
                                            align: "center",
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Text, {
                                                            family: "bold",
                                                            size: "14px",
                                                            children: "Total Keuntungan"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Text, {
                                                            size: "12px",
                                                            color: "#B5B5B5",
                                                            children: "Selama Investasi"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    amount: sell === null || sell === void 0 ? void 0 : sell.total_realized_amount,
                                                    percentage: sell === null || sell === void 0 ? void 0 : sell.total_realized_amount_percentage,
                                                    family: "bold"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondConfirm_Flex, {
                                width: "335px",
                                mx: "20px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* Checkbox */.XZ, {
                                        checked: isTnCAccepted,
                                        onChange: handleCheckboxChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondConfirm_Text, {
                                        pl: "8px",
                                        size: "12px",
                                        as: "span",
                                        children: [
                                            "Saya, Nasabah, telah membaca, menyetujui dan memahami",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Text, {
                                                color: ui/* color.primary */.$_.primary,
                                                onClick: openTncModal,
                                                "aria-hidden": "true",
                                                size: "12px",
                                                as: "span",
                                                children: "Syarat-syarat dan Ketentuan"
                                            }),
                                            " ",
                                            "Efek Bersifat Utang dan Sukuk (EBUS) di Pasar Sekunder di atas"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondConfirm_Flex, {
                    justify: "space-between",
                    style: {
                        position: "absolute",
                        bottom: "-50px",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Button, {
                            onClick: closeModal,
                            type: "danger",
                            radius: "4px",
                            block: true,
                            height: "40px",
                            style: {
                                width: "49%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Text, {
                                align: "inherit",
                                color: "white",
                                family: "bold",
                                size: "18px",
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_ConfirmButton, {
                            onClick: handleSubmitOrder,
                            radius: "4px",
                            block: true,
                            height: "40px",
                            style: {
                                width: "49%"
                            },
                            disabled: !isTnCAccepted,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_Text, {
                                align: "inherit",
                                color: isTnCAccepted ? ui/* color.primary */.$_.primary : "#cbcbcb",
                                family: "bold",
                                size: "18px",
                                children: "Confirm"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var _StyledBorderedWrapper = (0,styled_components_browser_esm["default"])(BorderedWrapper).withConfig({
    componentId: "sc-8cb42df0-0"
})(ModalBondConfirm_templateObject());
var ModalBondConfirm_StyledDivider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-8cb42df0-1"
})(ModalBondConfirm_templateObject1());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondSell/index.tsx




















// destructures
var ModalBondSell_Text = ui/* Common.Text */.Gn.Text;
function ModalBondSell() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,Form/* useForm */.cI)(), 1), form = ref32[0];
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return [
            s.productId,
            s.acquisitionOrderId, 
        ];
    }), 2), productId = ref33[0], orderId = ref33[1];
    var ref34 = (0,useBondsAnalytics/* default */.Z)(), FRBondsNavigateTrackers = ref34.FRBondsNavigateTrackers, FRBondActionTrackers = ref34.FRBondActionTrackers;
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.transactionType,
            s.closeTransactionModal,
            s.openConfirmModal,
            s.sourcePage, 
        ];
    }), 4), transactionType = ref35[0], closeTransactionModal = ref35[1], openConfirmModal = ref35[2], sourcePage = ref35[3];
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    var ref36 = useBondPreviewForm({
        action: bond/* BondTransactionActionEnum.SELL */.qB.SELL,
        productId: productId,
        orderId: orderId
    }), handleUnitAmountChanged = ref36.handleUnitAmountChanged, isLoadingPreview = ref36.isLoadingPreview, unit = ref36.unit, preview = ref36.preview, isDisabled = ref36.isDisabled;
    var _transactionType = ModalBonds_constants/* BOND_TRANSACTION_CONFIG */.H1[transactionType], textColor = _transactionType.textColor, title = _transactionType.title;
    var onSubmit = function() {
        FRBondActionTrackers.onOrderPlaced("Sell", productId);
        openConfirmModal();
    };
    (0,react.useEffect)(function() {
        if (productId) {
            FRBondsNavigateTrackers.onBondOrderPageViewed("Sell", productId, sourcePage);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
        form: form,
        onFinish: onSubmit,
        colon: false,
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 8,
            offset: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
                modalType: ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalHeader */.xB, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                                color: textColor,
                                title: title,
                                onClose: closeTransactionModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Unit Tersedia",
                                value: preview === null || preview === void 0 ? void 0 : (ref = preview.sell) === null || ref === void 0 ? void 0 : ref.available_units,
                                type: "unit",
                                isBold: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Unit Penjualan",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* UnitInput */.OT, {
                                    value: unit,
                                    onChange: handleUnitAmountChanged,
                                    placeholder: "1 Unit = ".concat((0,withdrawal_utils/* formatCurrency */.xG)(ModalBonds_constants/* BASE_UNIT_AMOUNT.toString */.MD.toString())),
                                    type: "number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Harga Jual (%)",
                                value: preview === null || preview === void 0 ? void 0 : (ref1 = preview.sell) === null || ref1 === void 0 ? void 0 : ref1.price.sell,
                                type: "percentage",
                                onInfoClick: function() {
                                    return openInfoModal(ModalBonds_constants/* BondInfoType.SELLING_PRICE */.Im.SELLING_PRICE);
                                },
                                isNeedInfo: true,
                                isDisabled: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "Total Nilai Penjualan",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref2 = preview.sell) === null || ref2 === void 0 ? void 0 : ref2.estimation_disburse_amount,
                                    type: "currency",
                                    isBold: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Nilai Penjualan",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref3 = preview.sell) === null || ref3 === void 0 ? void 0 : ref3.estimation_sell_amount,
                                        type: "currency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Berjalan (Nett)",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref4 = preview.sell) === null || ref4 === void 0 ? void 0 : ref4.accrued_interest_exclude_tax,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref5 = preview.sell) === null || ref5 === void 0 ? void 0 : ref5.accrued_interest_exclude_tax) > 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Pajak",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref6 = preview.sell) === null || ref6 === void 0 ? void 0 : ref6.fee.total_tax) * -1,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.TAX */.Im.TAX);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref7 = preview.sell) === null || ref7 === void 0 ? void 0 : ref7.fee.total_tax) !== 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Bea Meterai",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref8 = preview.sell) === null || ref8 === void 0 ? void 0 : ref8.fee.stamp_duty) * -1,
                                        type: "currency",
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref9 = preview.sell) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fee) === null || ref10 === void 0 ? void 0 : ref10.stamp_duty) > 0
                                    }),
                                    (preview === null || preview === void 0 ? void 0 : (ref11 = preview.sell) === null || ref11 === void 0 ? void 0 : ref11.seller_coupon) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Penjual",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref12 = preview.sell) === null || ref12 === void 0 ? void 0 : ref12.seller_coupon,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref13 = preview.sell) === null || ref13 === void 0 ? void 0 : ref13.seller_coupon) > 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "P&L (Nett)",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref14 = preview.sell) === null || ref14 === void 0 ? void 0 : ref14.profit_loss_nett,
                                    type: (preview === null || preview === void 0 ? void 0 : (ref15 = preview.sell) === null || ref15 === void 0 ? void 0 : ref15.profit_loss_nett) === 0 ? "currency" : "pl",
                                    plPercentage: preview === null || preview === void 0 ? void 0 : (ref16 = preview.sell) === null || ref16 === void 0 ? void 0 : ref16.profit_loss_nett_percentage,
                                    isBold: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Berjalan",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref17 = preview.sell) === null || ref17 === void 0 ? void 0 : ref17.accrued_interest_exclude_tax,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref18 = preview.sell) === null || ref18 === void 0 ? void 0 : ref18.accrued_interest_exclude_tax) === 0 ? "currency" : "pl",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON);
                                        },
                                        isNeedInfo: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Capital Gain / Loss",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref19 = preview.sell) === null || ref19 === void 0 ? void 0 : ref19.profit_loss,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref20 = preview.sell) === null || ref20 === void 0 ? void 0 : ref20.profit_loss) === 0 ? "currency" : "pl"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Pajak",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref21 = preview.sell) === null || ref21 === void 0 ? void 0 : ref21.fee.total_tax) * -1,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.TAX */.Im.TAX);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref22 = preview.sell) === null || ref22 === void 0 ? void 0 : ref22.fee.total_tax) !== 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "Total Keuntungan (Nett)",
                                    subtitle: "Selama Investasi",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref23 = preview.sell) === null || ref23 === void 0 ? void 0 : ref23.total_realized_amount,
                                    type: (preview === null || preview === void 0 ? void 0 : (ref24 = preview.sell) === null || ref24 === void 0 ? void 0 : ref24.total_realized_amount) === 0 ? "currency" : "pl",
                                    plPercentage: preview === null || preview === void 0 ? void 0 : (ref25 = preview.sell) === null || ref25 === void 0 ? void 0 : ref25.total_realized_amount_percentage,
                                    isBold: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Total Kupon Harian",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref26 = preview.sell) === null || ref26 === void 0 ? void 0 : ref26.daily_accrued_interest,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref27 = preview.sell) === null || ref27 === void 0 ? void 0 : ref27.daily_accrued_interest) === 0 ? "currency" : "pl",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON);
                                        },
                                        isNeedInfo: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Pajak",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref28 = preview.sell) === null || ref28 === void 0 ? void 0 : ref28.fee.total_tax) * -1,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(ModalBonds_constants/* BondInfoType.TAX */.Im.TAX);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref29 = preview.sell) === null || ref29 === void 0 ? void 0 : ref29.fee.total_tax) !== 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Capital Gain / Loss",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref30 = preview.sell) === null || ref30 === void 0 ? void 0 : ref30.profit_loss,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref31 = preview.sell) === null || ref31 === void 0 ? void 0 : ref31.profit_loss) === 0 ? "currency" : "pl"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_styled/* OrderButton */.sg, {
                    disabled: isDisabled,
                    type: "secondary",
                    htmlType: "submit",
                    onClick: openConfirmModal,
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondSell_Text, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 2 modules
var BaseSecuritiesModal = __webpack_require__(93400);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTnC/styled.tsx

function ModalBondTnC_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  margin-top: 20px;\n  box-sizing: border-box;\n  min-height: 408px;\n"
    ]);
    ModalBondTnC_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    ModalBondTnC_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    ModalBondTnC_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    ModalBondTnC_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 408px;\n  overflow-y: scroll;\n  padding: 16px;\n  > ol {\n    padding-inline-start: 16px;\n    margin-bottom: 0px;\n  }\n  > h1.title {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  > div.sensor {\n    height: 1px;\n    width: 100%;\n  }\n"
    ]);
    ModalBondTnC_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var styled_ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4e13d39-0"
})(ModalBondTnC_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4e13d39-1"
})(ModalBondTnC_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-d4e13d39-2"
})(ModalBondTnC_styled_templateObject2());
var TnCFrameWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4e13d39-3"
})(ModalBondTnC_styled_templateObject3());
var TnCFrame = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d4e13d39-4"
})(ModalBondTnC_styled_templateObject4());

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTnC/TnCContent.tsx


function TnCContent(param) {
    var onReachedBottom = param.onReachedBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "title",
                children: "Syarat Dan Ketentuan Transaksi Efek Bersifat Utang dan Sukuk (EBUS) di Pasar Sekunder"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Investasi pada EBUS mengandung risiko investasi, termasuk namun tidak terbatas pada adanya risiko pasar, risiko likuiditas, dan risiko gagal bayar yang dapat berakibat pada berkurang atau hilangnya pokok investasi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Kinerja EBUS di masa lalu bukan merupakan jaminan atas kinerja dan hasil investasi di masa mendatang."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Harga yang tertera pada Aplikasi PT Stockbit Sekuritas Digital (Stockbit) merupakan harga indikasi dan dapat berubah sewaktu-waktu."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Instruksi pembelian/penjualan EBUS yang disampaikan oleh Nasabah melalui Stockbit tidak dapat dibatalkan. Transaksi yang terlaksana atas instruksi pembelian/penjualan EBUS yang diajukan oleh nasabah dan disetujui oleh Stockbit adalah transaksi yang sah, mengikat dan tidak dapat diubah dan/atau dibatalkan oleh Nasabah. Konfirmasi atas transaksi tersebut akan dikirimkan secara elektronik, bersifat akurat dan benar serta mengikat bagi Nasabah."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nasabah wajib memastikan kecukupan dana di Rekening Dana Nasabah (RDN) pada saat menyampaikan instruksi pembelian EBUS, instruksi dari Nasabah akan ditolak oleh Stockbit apabila dana di RDN Nasabah tidak mencukupi pada saat penyampaian instruksi dan/atau pada saat verifikasi instruksi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Apabila transaksi pembelian atas instruksi tersebut terlaksana, maka Stockbit berhak untuk melakukan pendebetan dana di RDN Nasabah pada tanggal settlement sejumlah nominal yang harus dibayarkan oleh Nasabah."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Apabila transaksi penjualan atas instruksi tersebut terlaksana, maka Dana hasil penjualan akan dicairkan langsung ke RDN pada tanggal settlement (T+2)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Distribusi Kupon EBUS akan dicairkan langsung ke RDN."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Transaksi EBUS pada Pasar Sekunder dikenakan pemotongan Pajak Penghasilan (PPh) final sebesar 10% atas penghasilan berupa kupon berjalan dan keuntungan (capital gain) yang diterima, serta biaya Bea Meterai yang akan dikenakan sesuai dengan ketentuan hukum dan peraturan perundang-undangan yang berlaku."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nasabah wajib membaca dan mempelajari seluruh informasi, manfaat, dan risiko terkait dengan EBUS, termasuk dan tidak terbatas pada informasi yang dimuat dalam Syarat dan Ketentuan, Produk Info, Memorandum Informasi, dan/atau dokumen lainnya yang berkaitan dengan keterbukaan informasi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nasabah membebaskan Stockbit dari segala bentuk tuntutan, ganti rugi, gugatan, dan/atau tindakan hukum lainnya dari pihak manapun yang timbul sehubungan dengan Transaksi EBUS di Pasar Sekunder yang telah diajukan dan disetujui."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                onChange: function(value) {
                    if (value) {
                        onReachedBottom();
                    }
                },
                scrollCheck: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sensor",
                    children: "\xa0"
                })
            }, "visibility-sensor")
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTnC/index.tsx













function ModalBondTnC(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref = (0,react.useState)(false), isReachedBottom = ref[0], setReachingBottom = ref[1];
    var acceptTnC = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return s.setTnC;
    });
    var closeModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeModal;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var handleTncSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isReachedBottom) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        acceptTnC(true);
                        FRBondActionTrackers.onTnCConfirmed();
                        closeModal();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTncSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReachedBottom = function() {
        setReachingBottom(true);
    };
    (0,react.useEffect)(function() {
        return function() {
            setReachingBottom(false);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Syarat & Ketentuan",
        submitText: "Saya Setuju",
        submitProps: {
            disabled: !isReachedBottom,
            loading: false
        },
        onSubmit: handleTncSubmit
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_ContentContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrameWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCContent, {
                        onReachedBottom: handleReachedBottom
                    })
                })
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/InfoTable.tsx
var InfoTable = __webpack_require__(51981);
// EXTERNAL MODULE: ./src/features/securities/styled.ts
var securities_styled = __webpack_require__(38639);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondOrder.ts
var useBondOrder = __webpack_require__(29541);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/BondProductDisplay/index.tsx




var BondProductDisplay_Flex = ui/* Common.Flex */.Gn.Flex, BondProductDisplay_Text = ui/* Common.Text */.Gn.Text;
function BondProductDisplay(param) {
    var product = param.product, cta = param.cta, isStableEarn = param.isStableEarn;
    var iconSrc = isStableEarn ? ModalBonds_constants/* STABLE_EARN_ICON_SRC */.gG : (product === null || product === void 0 ? void 0 : product.icon_url) || ModalBonds_constants/* FALLBACK_AVATAR_SRC */.sW;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondProductDisplay_Flex, {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondProductDisplay_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: iconSrc,
                        style: {
                            width: "40px",
                            height: "40px",
                            background: "white"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BondProductDisplay_Flex, {
                        direction: "column",
                        gap: "2px",
                        justify: "center",
                        ml: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay_Text, {
                                family: "bold",
                                size: "14px",
                                children: isStableEarn ? "Stable Earn" : product === null || product === void 0 ? void 0 : product.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay_Text, {
                                color: "#969696",
                                size: "12px",
                                children: product === null || product === void 0 ? void 0 : product.name
                            })
                        ]
                    })
                ]
            }),
            cta
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/styled.ts

function ModalBondOrder_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    ModalBondOrder_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    ModalBondOrder_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 8px;\n"
    ]);
    ModalBondOrder_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: start;\n  gap: 12px;\n"
    ]);
    ModalBondOrder_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  height: 44px;\n"
    ]);
    ModalBondOrder_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2px;\n  height: 12px;\n  background-color: ",
        ";\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  gap: 12px;\n\n  height: 56px;\n  width: 100%;\n  padding: 12px 16px;\n\n  background-color: #f2f1fe;\n  border-radius: 4px;\n\n  > p {\n    height: 100%;\n    margin: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: #e0ddfd;\n\n  > img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var ModalBondOrder_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-0"
})(ModalBondOrder_styled_templateObject());
var Paragraph = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-1"
})(ModalBondOrder_styled_templateObject1());
var StepperContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-2"
})(ModalBondOrder_styled_templateObject2());
var StepperItem = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-3"
})(ModalBondOrder_styled_templateObject3());
var StepperImageFrame = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-4"
})(ModalBondOrder_styled_templateObject4());
var StepperLine = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-5"
})(styled_templateObject5(), function(props) {
    return props.isActive ? "#00ab6b" : "#96969699";
});
var StepperLabel = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-6"
})(styled_templateObject6());
var PanelContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-7"
})(_templateObject7());
var PanelIconContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-aa24a7bd-8"
})(_templateObject8());
var OrderStatusLabel = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-aa24a7bd-9"
})(_templateObject9(), function(props) {
    return props.isNegative ? "#EE4A49" : "#00AB6B";
});

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/InfoPanel.tsx



function InfoPanel(param) {
    var _imageSrc = param.imageSrc, imageSrc = _imageSrc === void 0 ? "icon/fr/icon-sand-clock.svg" : _imageSrc, _text = param.text, text = _text === void 0 ? "" : _text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PanelContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelIconContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: imageSrc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/types.ts
var StepperStep;
(function(StepperStep) {
    StepperStep["SUBMITTED"] = "STEPPER_STEP_SUBMITTED";
    StepperStep["VERIFIED"] = "STEPPER_STEP_VERIFIED";
    StepperStep["SUCCESS"] = "STEPPER_STEP_SUCCESS";
    StepperStep["REJECTED"] = "STEPPER_STEP_REJECTED";
})(StepperStep || (StepperStep = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/constants.ts

var StatusIndicatorMap = {
    UNSPECIFIED: "icon/fr/icon-stepper-unspecified.svg",
    REJECTED: "icon/fr/icon-stepper-rejected.svg",
    SUCCESS: "icon/fr/icon-stepper-success.svg",
    ON_PROGRESS: "icon/fr/icon-stepper-on_progress.svg"
};
var BondOrderStatusMap = {
    BOND_ORDER_STATUS_UNSPECIFIED: "UNSPECIFIED",
    BOND_ORDER_STATUS_REJECTED: "REJECTED",
    BOND_ORDER_STATUS_SUBMITTED: "ON_PROGRESS",
    BOND_ORDER_STATUS_SUCCEEDED: "SUCCESS",
    BOND_ORDER_STATUS_VERIFIED: "SUCCESS"
};
var BondOrderStatusLabelMap = {
    BOND_ORDER_STATUS_UNSPECIFIED: "Unspecified",
    BOND_ORDER_STATUS_REJECTED: "Rejected",
    BOND_ORDER_STATUS_SUBMITTED: "Submitted",
    BOND_ORDER_STATUS_SUCCEEDED: "Success",
    BOND_ORDER_STATUS_VERIFIED: "Verified"
};
var BondOrderStatusStepMap = {
    BOND_ORDER_STATUS_UNSPECIFIED: StepperStep.REJECTED,
    BOND_ORDER_STATUS_REJECTED: StepperStep.REJECTED,
    BOND_ORDER_STATUS_SUBMITTED: StepperStep.SUBMITTED,
    BOND_ORDER_STATUS_SUCCEEDED: StepperStep.SUCCESS,
    BOND_ORDER_STATUS_VERIFIED: StepperStep.SUBMITTED
};
var stepperContentList = [
    {
        prev: undefined,
        next: StepperStep.VERIFIED,
        current: StepperStep.SUBMITTED,
        content: {
            date: undefined,
            status: "UNSPECIFIED",
            descriptions: undefined,
            label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_SUBMITTED
        }
    },
    {
        prev: StepperStep.SUBMITTED,
        next: StepperStep.SUCCESS,
        current: StepperStep.VERIFIED,
        content: {
            date: undefined,
            status: "UNSPECIFIED",
            descriptions: undefined,
            label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_VERIFIED
        }
    },
    {
        prev: StepperStep.VERIFIED,
        next: undefined,
        current: StepperStep.SUCCESS,
        content: {
            date: undefined,
            status: "UNSPECIFIED",
            descriptions: undefined,
            label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_SUCCEEDED
        }
    }, 
];

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/TimelineItem.tsx







var TimelineItem_Text = ui/* Common.Text */.Gn.Text;
function TimelineItem(param) {
    var label = param.label, date = param.date, status = param.status, index = param.index, length = param.length, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _descriptions = param.descriptions, descriptions = _descriptions === void 0 ? "" : _descriptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperImageFrame, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: StatusIndicatorMap[status]
                    }),
                    index < length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperLine, {
                        isActive: isActive
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperLabel, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem_Text, {
                                family: "bold",
                                children: label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: date,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "•"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem_Text, {
                                        color: "#858585",
                                        children: moment_default()(date).utc().format("DD MMM YYYY HH:mm")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem_Text, {
                        children: descriptions
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/Timeline.tsx






var Timeline_Text = ui/* Common.Text */.Gn.Text;
function Timeline(param) {
    var _contents = param.contents, contents = _contents === void 0 ? [] : _contents, _message = param.message, message = _message === void 0 ? "" : _message;
    // handle the rejected content first
    var rejectedContent = contents === null || contents === void 0 ? void 0 : contents.find(function(content) {
        return content.status === bond/* BondOrderStatus.REJECTED */.ro.REJECTED;
    });
    if (rejectedContent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem, {
            index: 0,
            length: 1,
            status: "REJECTED",
            date: rejectedContent.occurred_at,
            label: BondOrderStatusLabelMap[rejectedContent === null || rejectedContent === void 0 ? void 0 : rejectedContent.status],
            descriptions: message,
            isActive: false
        });
    }
    var statuses = [
        bond/* BondOrderStatus.SUBMITTED */.ro.SUBMITTED,
        bond/* BondOrderStatus.VERIFIED */.ro.VERIFIED,
        bond/* BondOrderStatus.SUCCEEDED */.ro.SUCCEEDED, 
    ];
    var reduced = statuses.reduce(function(prev, current, index) {
        var status = "UNSPECIFIED";
        var isActive = false;
        var currentContent = contents.find(function(content) {
            return content.status === current;
        });
        // Bond status is found in the array
        if (currentContent) {
            status = "SUCCESS";
            isActive = true;
        } else if (prev[index - 1] && prev[index - 1].status === "SUCCESS") {
            status = "ON_PROGRESS";
        }
        if (currentContent && index > 0 && prev[index]) {
            status = prev[index].status === "SUCCESS" ? "ON_PROGRESS" : "UNSPECIFIED";
        }
        return (0,_to_consumable_array/* default */.Z)(prev).concat([
            {
                index: index,
                status: status,
                length: statuses.length,
                date: currentContent === null || currentContent === void 0 ? void 0 : currentContent.occurred_at,
                label: BondOrderStatusLabelMap[current],
                descriptions: message,
                isActive: isActive
            }, 
        ]);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline_Text, {
                family: "bold",
                mb: "16px",
                children: "Order Status"
            }),
            reduced.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem, {
                    index: item.index,
                    length: item.length,
                    date: item.date,
                    label: item.label,
                    descriptions: item.message,
                    status: item.status,
                    isActive: item.isActive
                }, "status-history-".concat(item.index));
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/OrderContentBuy.tsx











var OrderContentBuy_Text = ui/* Common.Text */.Gn.Text;
function OrderContentBuy(param) {
    var _finalAmount = param.finalAmount, finalAmount = _finalAmount === void 0 ? 0 : _finalAmount, _tradeAmount = param.tradeAmount, tradeAmount = _tradeAmount === void 0 ? 0 : _tradeAmount, _sellerAccruedInterest = param.sellerAccruedInterest, sellerAccruedInterest = _sellerAccruedInterest === void 0 ? 0 : _sellerAccruedInterest, _stampDuty = param.stampDuty, stampDuty = _stampDuty === void 0 ? 0 : _stampDuty;
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FieldSet */.C3, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                isAccordion: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Total Pembayaran"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentBuy_Text, {
                        family: "bold",
                        children: [
                            "Rp",
                            (0,withdrawal_utils/* formatPrice */.T4)(finalAmount.toString())
                        ]
                    })
                ]
            })
        }),
        isPlain: true,
        isTight: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Nilai Pembelian"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "Rp",
                                (0,withdrawal_utils/* formatPrice */.T4)(tradeAmount.toString())
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentBuy_Text, {
                                    children: "Kupon Penjual"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                    type: "button",
                                    onClick: function() {
                                        return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            fontSize: 16,
                                            color: "#969696",
                                            marginLeft: 4
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentBuy_Text, {
                                children: [
                                    sellerAccruedInterest > 0 && "+",
                                    "Rp",
                                    (0,withdrawal_utils/* formatPrice */.T4)(sellerAccruedInterest.toString())
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentBuy_Text, {
                            children: "Bea Meterai"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentBuy_Text, {
                            children: [
                                stampDuty > 0 && "+",
                                "Rp",
                                (0,withdrawal_utils/* formatPrice */.T4)(stampDuty.toString())
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/global/Collapsible/index.tsx + 1 modules
var Collapsible = __webpack_require__(80557);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondTaxStore.ts



var initialState = {
    isVisible: false,
    accruedInterest: 0,
    pl: 0,
    amount: 0,
    totalTax: 0
};
var useBondTaxStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        openTaxModal: function openTaxModal(payload) {
            set((0,_object_spread/* default */.Z)({
                isVisible: true
            }, payload));
        },
        closeTaxModal: function closeTaxModal() {
            set(initialState);
        }
    });
});

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/OrderContentSell.tsx














var OrderContentSell_Flex = ui/* Common.Flex */.Gn.Flex, OrderContentSell_Text = ui/* Common.Text */.Gn.Text;
function OrderContentSell(param) {
    var _finalAmount = param.finalAmount, finalAmount = _finalAmount === void 0 ? 0 : _finalAmount, _tradeAmount = param.tradeAmount, tradeAmount = _tradeAmount === void 0 ? 0 : _tradeAmount, _accruedInterest = param.accruedInterest, accruedInterest = _accruedInterest === void 0 ? 0 : _accruedInterest, _totalTax = param.totalTax, totalTax = _totalTax === void 0 ? 0 : _totalTax, _stampDuty = param.stampDuty, stampDuty = _stampDuty === void 0 ? 0 : _stampDuty, _capitalGain = param.capitalGain, capitalGain = _capitalGain === void 0 ? 0 : _capitalGain, _profitLossAmount = param.profitLossAmount, profitLossAmount = _profitLossAmount === void 0 ? 0 : _profitLossAmount, _profitLossPercentage = param.profitLossPercentage, profitLossPercentage = _profitLossPercentage === void 0 ? 0 : _profitLossPercentage, _sellerCoupon = param.sellerCoupon, sellerCoupon = _sellerCoupon === void 0 ? 0 : _sellerCoupon, _accruedInterestExcludeTax = param.// for tax
    accruedInterestExcludeTax, accruedInterestExcludeTax = _accruedInterestExcludeTax === void 0 ? 0 : _accruedInterestExcludeTax, _estimationAmountExcludeTax = param.estimationAmountExcludeTax, estimationAmountExcludeTax = _estimationAmountExcludeTax === void 0 ? 0 : _estimationAmountExcludeTax, _realizedAmount = param.realizedAmount, realizedAmount = _realizedAmount === void 0 ? 0 : _realizedAmount;
    var openTaxModal = useBondTaxStore(function(s) {
        return s.openTaxModal;
    });
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FieldSet */.C3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            isAccordion: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                    children: "Nominal Diterima"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                    family: "bold",
                                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(finalAmount)
                                })
                            ]
                        })
                    }),
                    isPlain: true,
                    isTight: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Nilai Penjualan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(tradeAmount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentSell_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                                children: "Kupon Berjalan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(accruedInterest, "exceptZero")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentSell_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                                children: "Pajak Obligasi"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openTaxModal({
                                                        accruedInterest: accruedInterestExcludeTax,
                                                        amount: estimationAmountExcludeTax,
                                                        pl: realizedAmount,
                                                        totalTax: totalTax
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(totalTax * -1, "exceptZero")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Bea Meterai"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(stampDuty * -1, "exceptZero")
                                    })
                                ]
                            }),
                            sellerCoupon > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentSell_Flex, {
                                        align: "center",
                                        children: [
                                            "Kupon Penjual",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(sellerCoupon, "exceptZero")
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FieldSet */.C3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                    children: "P&L (Nett)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                    amount: profitLossAmount,
                                    percentage: profitLossPercentage,
                                    family: "bold"
                                })
                            ]
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentSell_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                                children: "Kupon Berjalan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                        amount: accruedInterest,
                                        isColorless: accruedInterest === 0,
                                        isSignless: accruedInterest <= 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Capital Gain / Loss"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                        amount: capitalGain,
                                        isColorless: capitalGain === 0,
                                        isSignless: capitalGain === 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderContentSell_Flex, {
                                        align: "center",
                                        mb: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell_Text, {
                                                children: "Pajak"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(ModalBonds_constants/* BondInfoType.TAX */.Im.TAX);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(totalTax * -1, "exceptZero")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/index.tsx



function ModalBondOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 502px;\n        "
    ]);
    ModalBondOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















var ModalBondOrder_Text = ui/* Common.Text */.Gn.Text;
var getTitle = function() {
    var productId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED;
    var _obj;
    return (_obj = {}, (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.BUY */.qB.BUY, "Buy ".concat(productId)), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.SELL */.qB.SELL, "Sell ".concat(productId)), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED, productId), _obj)[action];
};
function ModalBondOrder() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.closeModal,
            s.closeTransactionModal, 
        ];
    }), 2), closeModal = ref9[0], closeTransactionModal = ref9[1];
    var selected = (0,useBondOrder/* useBondOrder */.o)(function(s) {
        return {
            selected: s.selected,
            isLoading: s.isLoading
        };
    }).selected;
    var productId = selected === null || selected === void 0 ? void 0 : (ref = selected.product) === null || ref === void 0 ? void 0 : ref.id;
    var action = (selected === null || selected === void 0 ? void 0 : selected.action) || bond/* BondTransactionActionEnum.BUY */.qB.BUY;
    var title = getTitle(productId, action);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    title: title,
                    onClose: closeModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(_StyledModalBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(selected === null || selected === void 0 ? void 0 : selected.product.id),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                as: "a",
                                justify: "space-between",
                                align: "center",
                                onClickCapture: closeTransactionModal,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay, {
                                        product: selected === null || selected === void 0 ? void 0 : selected.product
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightSvg */.dj, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                        dataSource: [
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-status-label",
                                    children: "Status"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderStatusLabel, {
                                    isNegative: selected.status === bond/* BondOrderStatus.REJECTED */.ro.REJECTED,
                                    children: (ref1 = BondOrderStatusLabelMap[selected.status]) === null || ref1 === void 0 ? void 0 : ref1.toLocaleUpperCase()
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-order-id-label",
                                    children: "Order ID"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-order-id-content",
                                    children: selected.id
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-order-time-label",
                                    children: "Order Time"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-order-time-content",
                                    children: moment_default()(selected === null || selected === void 0 ? void 0 : selected.ordered_at).utc().format("DD MMM YY, HH:mm:ss")
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-unit-label",
                                    children: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Unit Pembelian" : "Unit Penjualan"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondOrder_Text, {
                                    "data-cy": "coupon-distribution-content",
                                    children: [
                                        selected === null || selected === void 0 ? void 0 : selected.trade_unit,
                                        " Unit"
                                    ]
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "bond-unit-label",
                                    children: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Harga Beli (%)" : "Harga Jual (%)"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_Text, {
                                    "data-cy": "coupon-distribution-content",
                                    children: (0,number/* formatPercentage */.rl)(selected === null || selected === void 0 ? void 0 : selected.price_rate.toString(), false, "0,0.00", true)
                                })
                            }, 
                        ],
                        title: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy Order" : "Sell Order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentBuy, {
                                finalAmount: selected === null || selected === void 0 ? void 0 : selected.final_amount,
                                sellerAccruedInterest: selected === null || selected === void 0 ? void 0 : selected.accrued_interest_amount,
                                stampDuty: selected === null || selected === void 0 ? void 0 : (ref2 = selected.fee) === null || ref2 === void 0 ? void 0 : ref2.stamp_duty,
                                tradeAmount: selected === null || selected === void 0 ? void 0 : selected.trade_amount
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: action === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell, {
                            finalAmount: selected === null || selected === void 0 ? void 0 : selected.final_amount,
                            tradeAmount: selected === null || selected === void 0 ? void 0 : selected.trade_amount,
                            accruedInterest: selected === null || selected === void 0 ? void 0 : (ref3 = selected.fee) === null || ref3 === void 0 ? void 0 : ref3.accrued_interest_exclude_tax,
                            totalTax: selected === null || selected === void 0 ? void 0 : (ref4 = selected.fee) === null || ref4 === void 0 ? void 0 : ref4.total_tax,
                            stampDuty: selected === null || selected === void 0 ? void 0 : (ref5 = selected.fee) === null || ref5 === void 0 ? void 0 : ref5.stamp_duty,
                            capitalGain: selected === null || selected === void 0 ? void 0 : selected.capital_gain_loss,
                            profitLossAmount: selected === null || selected === void 0 ? void 0 : selected.profit_loss_nett.amount,
                            profitLossPercentage: selected === null || selected === void 0 ? void 0 : selected.profit_loss_nett.percentage,
                            sellerCoupon: selected === null || selected === void 0 ? void 0 : selected.seller_coupon,
                            accruedInterestExcludeTax: selected === null || selected === void 0 ? void 0 : (ref6 = selected.fee) === null || ref6 === void 0 ? void 0 : ref6.accrued_interest_exclude_tax,
                            estimationAmountExcludeTax: selected === null || selected === void 0 ? void 0 : (ref7 = selected.fee) === null || ref7 === void 0 ? void 0 : ref7.estimation_amount_exclude_tax,
                            realizedAmount: selected === null || selected === void 0 ? void 0 : selected.realized_amount
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline, {
                            contents: selected === null || selected === void 0 ? void 0 : selected.status_timeline,
                            message: selected === null || selected === void 0 ? void 0 : (ref8 = selected.reject_reason) === null || ref8 === void 0 ? void 0 : ref8.message
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: (selected === null || selected === void 0 ? void 0 : selected.status) !== bond/* BondOrderStatus.REJECTED */.ro.REJECTED && (selected === null || selected === void 0 ? void 0 : selected.status) !== bond/* BondOrderStatus.SUCCEEDED */.ro.SUCCEEDED,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPanel, {
                            text: "Estimasi pembelian kamu akan selesai dalam 2 sampai 3 hari kerja."
                        })
                    })
                ]
            })
        ]
    });
};
var _StyledModalBody = (0,styled_components_browser_esm["default"])(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-1f25eaf4-0"
})(ModalBondOrder_templateObject());

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore.ts
var useBondPortfolioStore = __webpack_require__(29176);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductSelection/styled.ts

function ModalProductSelection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 20px;\n  max-height: 560px;\n  overflow-y: scroll;\n  scrollbar-width: none;\n"
    ]);
    ModalProductSelection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    ModalProductSelection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 460px;\n\n  border-radius: 4px;\n  border: 1px solid #ededed;\n\n  padding: 12px 16px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    ModalProductSelection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid #ededed;\n  padding-bottom: 12px;\n"
    ]);
    ModalProductSelection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    ModalProductSelection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ScrollableContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-83fc53d1-0"
})(ModalProductSelection_styled_templateObject());
var ProductListContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-83fc53d1-1"
})(ModalProductSelection_styled_templateObject1());
var ProductCard = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-83fc53d1-2"
})(ModalProductSelection_styled_templateObject2());
var ProductCardHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-83fc53d1-3"
})(ModalProductSelection_styled_templateObject3());
var ProductCardBody = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-83fc53d1-4"
})(ModalProductSelection_styled_templateObject4());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductSelection/components/ProductListItem.tsx

function ProductListItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                width: 100px;\n                height: 30px;\n              "
    ]);
    ProductListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function ProductListItem(param) {
    var investmentModal = param.investmentModal, orderDate = param.orderDate, orderId = param.orderId, product = param.product, totalUnits = param.totalUnits, _isStableEarn = param.isStableEarn, isStableEarn = _isStableEarn === void 0 ? false : _isStableEarn;
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var openSellModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openSellModal;
    });
    var onChooseClick = function() {
        FRBondActionTrackers.onOrderButtonClicked("Sell", product.id);
        openSellModal(product.id, orderId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay, {
                    product: product,
                    isStableEarn: isStableEarn,
                    cta: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItem_StyledButton, {
                        type: "primary",
                        onClick: onChooseClick,
                        children: "Pilih"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardBody, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Modal Investasi"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        "Rp",
                                        (0,number/* formatNumber */.uf)(investmentModal, true, "0,0.00")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Jumlah Unit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        totalUnits,
                                        " Unit"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Tanggal Pembelian"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: moment_default()(orderDate).format("DD MMM YY, HH:mm")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var ProductListItem_StyledButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-ab12df94-0"
})(ProductListItem_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductSelection/index.tsx








function ModalProductSelection() {
    var closeModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeModal;
    });
    var transactions = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.transactions;
    });
    var product = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.product;
    });
    var clearAssets = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.clearAssets;
    });
    var onClose = function() {
        clearAssets();
        closeModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    title: "Pilih Produk untuk Dijual",
                    fontSize: "18px",
                    onClose: onClose,
                    isCentered: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalBody */.fe, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListContainer, {
                        children: transactions.map(function(transaction) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductListItem, {
                                investmentModal: transaction.invested_amount,
                                orderDate: new Date(transaction.created_at),
                                orderId: transaction.order_code,
                                product: {
                                    icon_url: product === null || product === void 0 ? void 0 : product.icon_url,
                                    id: product === null || product === void 0 ? void 0 : product.identifier,
                                    min_order: "1",
                                    name: product === null || product === void 0 ? void 0 : product.label,
                                    type: bond/* BondProductTypeEnum.FR */.Sn.FR
                                },
                                totalUnits: parseInt(transaction.total_unit, 10),
                                isStableEarn: transaction === null || transaction === void 0 ? void 0 : transaction.is_stable_earn
                            }, transaction.order_code);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/__mocks__/bonds.mock.ts

var BOND_PRODUCT_MOCK = {
    icon_url: undefined,
    id: "FR0081",
    min_order: "1",
    name: "Obligasi Fixed Rate Pemerintah",
    type: bond/* BondProductTypeEnum.FR */.Sn.FR
};
var BOND_ASSET_MOCK = [
    {
        investmentModal: 4000000,
        orderId: "ABC120",
        orderDate: new Date(),
        product: BOND_PRODUCT_MOCK,
        totalUnits: 4
    },
    {
        investmentModal: 3000000,
        orderId: "ABC121",
        orderDate: new Date(),
        product: BOND_PRODUCT_MOCK,
        totalUnits: 1
    },
    {
        investmentModal: 2000000,
        orderId: "ABC122",
        orderDate: new Date(),
        product: BOND_PRODUCT_MOCK,
        totalUnits: 1
    }, 
];

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondHistory/index.tsx


function ModalBondHistory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  margin: 0;\n                "
    ]);
    ModalBondHistory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondHistory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 502px;\n        "
    ]);
    ModalBondHistory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















var ModalBondHistory_Text = ui/* Common.Text */.Gn.Text;
function ModalBondHistory() {
    var ref;
    var closeModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeModal;
    });
    var selected = (0,useBondOrder/* useBondOrder */.o)(function(s) {
        return {
            selected: s.selected,
            isLoading: s.isLoading
        };
    }).selected;
    var productId = selected === null || selected === void 0 ? void 0 : (ref = selected.product) === null || ref === void 0 ? void 0 : ref.id;
    var action = (selected === null || selected === void 0 ? void 0 : selected.action) || bond/* BondTransactionActionEnum.BUY */.qB.BUY;
    var _obj;
    var actionLabel = (_obj = {}, (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.BUY */.qB.BUY, ""), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.SELL */.qB.SELL, "Sell"), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED, "Unspecified"), _obj)[action];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    title: "".concat(actionLabel, " ").concat(productId),
                    onClose: closeModal,
                    isCentered: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondHistory_StyledModalBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* BorderedContainer */.a$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay, {
                            product: BOND_PRODUCT_MOCK
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* BorderedContainer */.a$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: moment_default()(selected === null || selected === void 0 ? void 0 : selected.ordered_at).format("DD MMM YY, HH:mm:ss")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Unit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: selected === null || selected === void 0 ? void 0 : selected.trade_unit
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                actionLabel,
                                                " Price (%)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                (0,number/* formatNumber */.uf)(selected === null || selected === void 0 ? void 0 : selected.trade_amount, true, "0,0.00"),
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                actionLabel,
                                                " Amount"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Accrued Interest"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                    condition: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Stamp Duty"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Total Payment"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_Text, {
                                                    family: "bold",
                                                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                    condition: action === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Total Fee"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_StyledDivider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_Text, {
                                                    family: "bold",
                                                    children: "Total Amount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_Text, {
                                                    family: "bold",
                                                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_Text, {
                                                    family: "bold",
                                                    children: "Realized Gain"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_Text, {
                                                    family: "bold",
                                                    children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var ModalBondHistory_StyledDivider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-67f1c0b5-0"
})(ModalBondHistory_templateObject());
var ModalBondHistory_StyledModalBody = (0,styled_components_browser_esm["default"])(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-67f1c0b5-1"
})(ModalBondHistory_templateObject1());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondInformation/styled.ts

function ModalBondInformation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 21px;\n\n  > p {\n    margin-bottom: 12px;\n  }\n\n  > p:last-of-type {\n    margin-bottom: 0px;\n  }\n\n  b {\n    font-weight: 700;\n  }\n"
    ]);
    ModalBondInformation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ModalBondInformation_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-8db2ec5a-0"
})(ModalBondInformation_styled_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondInformation/infoContent.tsx



var infoContent_obj;
var InfoContent = (infoContent_obj = {}, (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.UNSPECIFIED */.Im.UNSPECIFIED, {
    title: "Informasi Tidak tersedia",
    content: []
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST, {
    title: "Kupon Berjalan",
    content: [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Sebelum kupon pertama diterima:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Kupon yang kamu bayar pada saat pembelian + Kupon Harian yang akan kamu terima pada kupon date selanjutnya."
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Sesudah kupon pertama diterima:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Total kupon harian dari tanggal pembagian kupon terakhir hingga tanggal hari ini."
            ]
        }), 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER, {
    title: "Kupon Penjual",
    content: [
        "Kupon yang perlu dibayarkan oleh pembeli sebagai hak yang harus diterima oleh penjual.",
        "Nominal kupon ini akan kamu terima kembali pada tanggal pencairan kupon berikutnya atau ketika kamu menjual unit kamu.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.CAPITAL_GAIN_LOSS */.Im.CAPITAL_GAIN_LOSS, {
    title: "Capital Gain / Loss",
    content: [
        "Capital Gain = Nilai Sekarang - Modal Investasi",
        "Merupakan keuntungan atau kerugian dari selisih nilai sekarang dan modal investasi jika kamu menjual obligasi FR kamu pada saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.PNL_UNREALIZED */.Im.PNL_UNREALIZED, {
    title: "P&L (Unrealized)",
    content: [
        "P&L = Kupon Berjalan + Capital Gain",
        "Total keuntungan atau kerugian yang akan kamu dapatkan ketika kamu melakukan penjualan saat ini belum termasuk pajak dan bea materai.",
        "Perhitungan P&L (Unrealized) tidak termasuk total kupon yang sudah kamu terima sebelumnya", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON, {
    title: "Total Kupon Harian",
    content: [
        "Total kupon yang merupakan hak kamu yang diakumulasi setiap hari dari tanggal pembelian termasuk kupon yang telah kamu terima.",
        "Namun tidak menghitung kupon berjalan yang kamu bayarkan pada saat pembelian.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.TOTAL_INVESTMENT_PROFIT */.Im.TOTAL_INVESTMENT_PROFIT, {
    title: "Total Keuntungan Selama Investasi",
    content: [
        "Total Keuntungan = Total Kupon Harian + Capital Gain",
        "Total keuntungan (selama investasi) merupakan seluruh keuntungan/kerugian selama kamu memegang obligasi FR ini.",
        "Total keuntungan tersebut merupakan seluruh kupon yang telah/akan kamu terima dan Capital Gain / Loss pada saat penjualan saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.TOTAL_UNIT */.Im.TOTAL_UNIT, {
    title: "Total Unit Obligasi",
    content: [
        "1 Unit Obligasi senilai dengan Rp1,000,000"
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.PROJECTED_RETURN */.Im.PROJECTED_RETURN, {
    title: "Proyeksi Return",
    content: [
        "Proyeksi keuntungan dari investasi kamu pada saat jatuh tempo"
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.PNL_NETT */.Im.PNL_NETT, {
    title: "P&L (Nett)",
    content: [
        "P&L = Kupon Berjalan + Capital Gain - Pajak",
        "Total keuntungan atau kerugian yang akan kamu dapatkan ketika kamu melakukan penjualan saat ini yang sudah termasuk pajak dan bea meterai.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.TOTAL_PROFIT_NETT */.Im.TOTAL_PROFIT_NETT, {
    title: "Total Keuntungan (Nett)",
    content: [
        "Total Keuntungan = Total Kupon Harian + Capital Gain",
        "Total keuntungan (selama investasi) merupakan seluruh keuntungan/kerugian selama kamu memegang obligasi FR ini.",
        "Total keuntungan tersebut merupakan seluruh kupon yang telah/akan kamu terima dan Capital Gain / Loss pada saat penjualan saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.BUYING_PRICE */.Im.BUYING_PRICE, {
    title: "Harga Beli",
    content: [
        "Harga indikatif (dalam satuan persentase) yang mengindikasikan harga beli Obligasi di Pasar Sekunder saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.SELLING_PRICE */.Im.SELLING_PRICE, {
    title: "Harga Jual",
    content: [
        "Harga indikatif (dalam satuan persentase) yang mengindikasikan harga jual Obligasi di Pasar Sekunder saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.PROFIT */.Im.PROFIT, {
    title: "Keuntungan",
    content: [
        "Keuntungan dihitung berdasarkan pergerakan harga dari produk Obligasi FR.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.CASH_ON_HAND */.Im.CASH_ON_HAND, {
    title: "Cash on Hand",
    content: [
        "Saldo RDN yang telah mengalami Siklus Penyelesaian T+2 hari bursa.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.TAX */.Im.TAX, {
    title: "Pajak",
    content: [
        "Pajak sebesar 10% dikenakan dari nilai capital gain unit FR yang kamu jual. Penjualan kamu tidak dikenakan pajak apabila kamu sedang mengalami kerugian.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.BOND_TAX */.Im.BOND_TAX, {
    title: "Pajak Obligasi",
    content: [
        "Pajak sebesar 10% dikenakan dari nilai capital gain unit FR yang kamu jual. Penjualan kamu tidak dikenakan pajak apabila kamu sedang mengalami kerugian.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, ModalBonds_constants/* BondInfoType.USER_COUPON */.Im.USER_COUPON, {
    title: "Kupon Hak Kamu",
    content: [
        "Kupon Hak Kamu = Kupon Diterima - Kupon Penjual",
        "Total kupon diterima yang merupakan hak kamu setelah dikurangi kupon yang kamu bayarkan kepada penjual pada saat pembelian.", 
    ]
}), infoContent_obj);
/* harmony default export */ var infoContent = (InfoContent);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondInformation/index.tsx


function ModalBondInformation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 375px;\n          "
    ]);
    ModalBondInformation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var ModalBondInformation_Flex = ui/* Common.Flex */.Gn.Flex, ModalBondInformation_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, ModalBondInformation_Text = ui/* Common.Text */.Gn.Text;
function ModalBondInformation() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return [
            s.modalInfoType,
            s.closeInfoModal, 
        ];
    }), 2), modalInfoType = ref[0], closeInfoModal = ref[1];
    var portfolioProduct = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.product;
    });
    var _modalInfoType = infoContent[modalInfoType], content = _modalInfoType.content, title = _modalInfoType.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
        visible: modalInfoType !== ModalBonds_constants/* BondInfoType.UNSPECIFIED */.Im.UNSPECIFIED,
        onCancel: closeInfoModal,
        zIndex: 2000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondInformation_Flex, {
                        justify: "between",
                        align: "center",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation_Text, {
                                family: "bold",
                                size: "18px",
                                mt: "0",
                                width: "100%",
                                "data-cy": "bonds-modal-header",
                                align: "center",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation_Iconmoon, {
                                className: "icon-trading_x",
                                color: "#333333",
                                size: "12px",
                                onClick: closeInfoModal
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation_StyledModalBody, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation_styled_Container, {
                        children: content.map(function(item, i) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    item,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                        condition: modalInfoType === ModalBonds_constants/* BondInfoType.PROJECTED_RETURN */.Im.PROJECTED_RETURN,
                                        children: [
                                            " ",
                                            moment_default()(portfolioProduct === null || portfolioProduct === void 0 ? void 0 : (ref = portfolioProduct.meta) === null || ref === void 0 ? void 0 : ref.maturity_date).format("DD MMMM YYYY")
                                        ]
                                    })
                                ]
                            }, "content-item-".concat(i + 1));
                        })
                    })
                })
            ]
        })
    });
};
var ModalBondInformation_StyledModalBody = (0,styled_components_browser_esm["default"])(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-b4734043-0"
})(ModalBondInformation_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTax/styled.ts

function ModalBondTax_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    ModalBondTax_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondTax_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    ModalBondTax_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondTax_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0;\n"
    ]);
    ModalBondTax_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ModalBondTax_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-12340d50-0"
})(ModalBondTax_styled_templateObject());
var Field = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-12340d50-1"
})(ModalBondTax_styled_templateObject1());
var FieldSet = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-12340d50-2"
})(ModalBondTax_styled_templateObject2());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTax/index.tsx


function ModalBondTax_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  margin: 0px;\n                "
    ]);
    ModalBondTax_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondTax_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 375px;\n          "
    ]);
    ModalBondTax_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var ModalBondTax_Flex = ui/* Common.Flex */.Gn.Flex, ModalBondTax_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, ModalBondTax_Text = ui/* Common.Text */.Gn.Text;
function ModalBondTax() {
    var ref = (0,_sliced_to_array/* default */.Z)(useBondTaxStore(function(s) {
        return [
            s.isVisible,
            s.closeTaxModal,
            s.accruedInterest,
            s.pl,
            s.amount,
            s.totalTax, 
        ];
    }, shallow/* default */.Z), 6), isVisible = ref[0], closeTaxModal = ref[1], accruedInterest = ref[2], pl = ref[3], amount = ref[4], totalTax = ref[5];
    var isFree = totalTax <= 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
        visible: isVisible,
        onCancel: closeTaxModal,
        zIndex: 2000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondTax_Flex, {
                        justify: "between",
                        align: "center",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_Text, {
                                family: "bold",
                                size: "18px",
                                mt: "0",
                                width: "100%",
                                "data-cy": "bonds-modal-header",
                                align: "center",
                                children: "Pajak Obligasi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_Iconmoon, {
                                className: "icon-trading_x",
                                color: "#333333",
                                size: "12px",
                                onClick: closeTaxModal
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondTax_StyledModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondTax_styled_Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldSet, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "Kupon Berjalan Kena Pajak"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                        amount: accruedInterest,
                                                        isColorless: true,
                                                        isHidePositiveSign: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: pl >= 0 ? "Keuntungan" : "Kerugian"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                        amount: pl,
                                                        isHidePositiveSign: true,
                                                        isColorless: true
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_StyledDivider, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Nominal Kena Pajak"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                amount: amount,
                                                isHidePositiveSign: true,
                                                isColorless: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_styled_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Pajak Obligasi (10%)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !isFree,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_Text, {
                                            family: "bold",
                                            children: (0,withdrawal_utils/* formatBondCurrency */.uJ)(totalTax)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isFree,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_Text, {
                                            family: "bold",
                                            color: ui/* color.primary */.$_.primary,
                                            children: "Bebas Pajak"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var ModalBondTax_StyledDivider = (0,styled_components_browser_esm["default"])(divider/* default */.Z).withConfig({
    componentId: "sc-604e6892-0"
})(ModalBondTax_templateObject());
var ModalBondTax_StyledModalBody = (0,styled_components_browser_esm["default"])(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-604e6892-1"
})(ModalBondTax_templateObject1());

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondError.ts
var useBondError = __webpack_require__(10893);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/index.tsx






















var useBondErrorStore = (0,esm/* default */.ZP)(useBondError/* default */.Z);
function ModalBonds() {
    var router = (0,next_router.useRouter)();
    var ref = useBondErrorStore(function(s) {
        return {
            blockerType: s.blockerType,
            resetErrorCode: s.resetErrorCode,
            error: s.errorCode
        };
    }), blockerType = ref.blockerType, resetErrorCode = ref.resetErrorCode, error = ref.error;
    var ref1 = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return {
            modalType: s.modalType,
            closeModal: s.closeModal,
            transactionType: s.transactionType,
            openBlockerModal: s.openBlockerModal,
            closeTransactionModal: s.closeTransactionModal
        };
    }), modalType = ref1.modalType, closeModal = ref1.closeModal, transactionType = ref1.transactionType, openBlockerModal = ref1.openBlockerModal, closeTransactionModal = ref1.closeTransactionModal;
    var handleOrderPlacedClose = function() {
        closeModal();
        router.push("/securities/order/?t=".concat(Date.now()));
    };
    var handleBlockerClose = function() {
        resetErrorCode();
        closeModal();
    };
    (0,react.useEffect)(function() {
        if (!error) {
            return;
        }
        if (modalType === ModalBonds_constants/* BondsModalTypeEnum.BLOCKERS */._y.BLOCKERS) {
            return;
        }
        // if only alert, we immidately reset the error code
        if (!blockerType) {
            resetErrorCode();
            return;
        }
        openBlockerModal(blockerType);
    }, [
        blockerType,
        modalType,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.BLOCKERS */._y.BLOCKERS,
                onCancel: handleBlockerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers, {
                    onClose: handleBlockerClose
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.CONFIRMATION */._y.CONFIRMATION,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: modalType === ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: transactionType === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                            visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION && transactionType === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                            onCancel: closeTransactionModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondsBuy, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: transactionType === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                            visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION && transactionType === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                            onCancel: closeTransactionModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondSell, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTnC, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.TNC */._y.TNC,
                onCancel: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.ORDER */._y.ORDER,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.HISTORY */._y.HISTORY,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.ASSETS */._y.ASSETS,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductSelection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPlacedModal/* default */.Z, {
                visible: modalType === ModalBonds_constants/* BondsModalTypeEnum.ORDER_PLACED */._y.ORDER_PLACED,
                onSubmit: handleOrderPlacedClose,
                orderType: trading/* ORDER_TYPE.BOND */.Jm.BOND
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/features/company/FRPage/store.ts
var FRPage_store = __webpack_require__(62582);
;// CONCATENATED MODULE: ./src/features/company/FRPage/ModalUnavailable.tsx




var ModalUnavailable_Modal = ui/* Common.Modal */.Gn.Modal, ModalUnavailable_Button = ui/* Common.Button */.Gn.Button, ModalUnavailable_Flex = ui/* Common.Flex */.Gn.Flex, ModalUnavailable_Text = ui/* Common.Text */.Gn.Text;
var ModalUnavailable = function() {
    var ref = (0,FRPage_store/* modalUnavailableStore */.T)(function(s) {
        return s;
    }), visible = ref.visible, onCancel = ref.hide;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable_Modal, {
        visible: visible,
        onCancel: onCancel,
        title: null,
        centered: true,
        noBorder: true,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable_Flex, {
                align: "center",
                justify: "center",
                p: "20px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable_Button, {
                    type: "primary",
                    width: "200px",
                    py: "12.5px",
                    style: {
                        borderRadius: 4
                    },
                    onClick: onCancel,
                    children: "Oke"
                })
            }, "footer-ok"), 
        ],
        width: 500,
        height: 366,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalUnavailable_Flex, {
            direction: "column",
            align: "center",
            justify: "center",
            p: "64px 0 0 0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    width: "160",
                    height: "120",
                    src: "icon/fr/fr-blocker-unavailable.svg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable_Text, {
                    size: "16px",
                    weight: "bold",
                    align: "center",
                    mt: "16px",
                    children: "FR Bonds Tidak Tersedia"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalUnavailable_Text, {
                    mt: "12px",
                    align: "center",
                    children: "Produk FR Bonds tidak bisa ditransaksikan di virtual trading."
                })
            ]
        })
    });
};
/* harmony default export */ var FRPage_ModalUnavailable = (ModalUnavailable);

// EXTERNAL MODULE: ./src/global/MainLayout/ModalErrorMessage/ModalErrorManager.tsx + 1 modules
var ModalErrorManager = __webpack_require__(51906);
// EXTERNAL MODULE: ./src/global/MainLayout/slice.js
var MainLayout_slice = __webpack_require__(48153);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/lib/entities/notification/useNotificationData.ts
var useNotificationData = __webpack_require__(89790);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSearchCompanyModalStore.ts
var useSearchCompanyModalStore = __webpack_require__(5612);
// EXTERNAL MODULE: ./src/global/Header/Search/slice.ts + 1 modules
var Search_slice = __webpack_require__(59016);
// EXTERNAL MODULE: ./src/global/Header/Search/styled.ts
var Search_styled = __webpack_require__(33591);
// EXTERNAL MODULE: ./src/features/user/analytics/ProfileAnalytics.ts
var ProfileAnalytics = __webpack_require__(63576);
;// CONCATENATED MODULE: ./src/global/Header/Search/options.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable indent */ 












var options_Avatar = ui/* Common.Avatar */.Gn.Avatar, TagDefault = ui/* Common.Tag */.Gn.Tag, Search_options_Flex = ui/* Common.Flex */.Gn.Flex, Search_options_Text = ui/* Common.Text */.Gn.Text, options_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var options_Tag = TagDefault.Tag;
var CustomAvatar = function(param) {
    var img = param.img, name = param.name;
    var url = img.match(/http/g) ? img : "".concat(api/* AVATAR_URL */.q$, "/").concat(img);
    if (!img) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(options_Avatar, {
        size: "x-small",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            alt: name,
            src: url,
            onError: function(e) {
                (0,general/* handleErrorAvatar */.Tk)(e, name);
            }
        })
    });
};
CustomAvatar.propTypes = {
    name: (prop_types_default()).string.isRequired,
    img: (prop_types_default()).string.isRequired
};
var LabelComponent = function(param) {
    var item = param.item, searchType = param.searchType;
    var dispatch = (0,es/* useDispatch */.I0)();
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var postSearchRecent = function(keyword, target, type) {
        return dispatch(Search_slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
            keyword: keyword,
            target: target,
            type: type
        }));
    };
    if (searchType === "sector") {
        var url = item.parent_alias1 ? "".concat(item.parent_alias1, "/").concat(item.name) : item.name;
        var eventClick = item.alias1 === "fr-bonds" ? function() {
            return FRBondActionTrackers.onFRProductListClicked("Search Page");
        } : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/catalog/".concat(url),
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styled/* CatalogItem */.me, {
                onClick: eventClick,
                children: item.name
            })
        });
    }
    if (searchType === "user") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_styled/* NavLink */.OL, {
            onClick: function() {
                postSearchRecent(item.name, item.id, "people");
                ProfileAnalytics/* mainProfileEvents.onViewProfile */.j4.onViewProfile(ProfileAnalytics/* PAGE_SOURCE.search */.nP.search);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomAvatar, {
                    img: item.img,
                    name: item.name
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_options_Flex, {
                    direction: "column",
                    pl: "10px",
                    style: {
                        gap: "2px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_options_Flex, {
                            align: "center",
                            style: {
                                gap: "2px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_options_Text, {
                                    size: "14px",
                                    mt: "2px",
                                    family: "bold",
                                    children: item.keyword || item.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                    deprecatedVerifiedStatus: item.is_verified
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_options_Text, {
                            size: "12px",
                            color: ui/* color.highgray */.$_.highgray,
                            children: item.desc || item.name
                        })
                    ]
                })
            ]
        });
    }
    if (searchType === "insider") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_styled/* NavLink */.OL, {
            onClick: function() {
                return postSearchRecent(item.label, item.id, "insider");
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(options_IconWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/icon-bandar.svg"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_options_Text, {
                    pl: "10px",
                    size: "13px",
                    children: item.label
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_styled/* NavLink */.OL, {
        onClick: function() {
            return postSearchRecent(item.name, item.id, "company");
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(options_Tag, {
                size: "xs",
                type: "grey",
                style: {
                    fontFamily: "ProximaNovaBd"
                },
                children: item.keyword || item.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_options_Text, {
                pl: "10px",
                size: "13px",
                children: item.desc || item.name
            })
        ]
    });
};
var renderLabel = function(item) {
    var catalogKey = "_type";
    var type = item.type ? item.type : item[catalogKey];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelComponent, {
        item: item,
        searchType: String(type).toLowerCase()
    });
};
var recentOptions = function(suggestions) {
    if (!suggestions.list) {
        return [];
    }
    if (suggestions.list.length === 0) {
        return [];
    }
    return [
        {
            label: "Recent Searches",
            options: suggestions.list.map(function(item) {
                return {
                    value: "suggestion-".concat(item.id, "-").concat(item.keyword),
                    label: renderLabel(item)
                };
            })
        }, 
    ];
};
var options_options = function(suggestions) {
    if (!suggestions) {
        return [];
    }
    var company = suggestions.company.length > 0 ? {
        label: "Stocks",
        options: suggestions.company.map(function(item) {
            return {
                value: "stock-".concat(item.id, "-").concat(item.keyword || item.name),
                label: renderLabel(item)
            };
        })
    } : undefined;
    var people = suggestions.people.length > 0 ? {
        label: "People",
        options: suggestions.people.map(function(item) {
            return {
                value: "people-".concat(item.id, "-").concat(item.name),
                label: renderLabel(item)
            };
        })
    } : undefined;
    var insider = suggestions.insider.length > 0 ? {
        label: "Insider",
        options: suggestions.insider.map(function(item) {
            return {
                value: "insider-".concat(item.id),
                label: renderLabel(item)
            };
        })
    } : undefined;
    var catalog = suggestions.sector.length > 0 ? {
        label: "Catalog",
        options: [
            {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_options_Flex, {
                    wrap: "wrap",
                    style: {
                        gap: "10px"
                    },
                    children: suggestions.sector.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelComponent, {
                            item: item,
                            searchType: "sector"
                        });
                    })
                }),
                value: "catalog-sector",
                className: "catalog-res"
            }, 
        ]
    } : undefined;
    var list = [
        catalog,
        company,
        people,
        insider
    ];
    return list.filter(function(item) {
        return item !== undefined;
    });
};
/* harmony default export */ var Search_options = (options_options);

;// CONCATENATED MODULE: ./src/global/Header/Search/Mobile.jsx
// eslint-disable react-hooks/exhaustive-deps








var Mobile_Input = ui/* Common.Input */.Gn.Input, Mobile_Autocomplete = ui/* Common.Autocomplete */.Gn.Autocomplete, Mobile_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Mobile_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var Mobile = function() {
    var ref = (0,react.useState)(false), isSearchBarVisible = ref[0], setVisibilitySearchBar = ref[1];
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react.useState)(false), visible = ref2[0], setVisible = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,es/* useSelector */.v9)(Search_slice/* selectors */.wl), result = ref3.result, recent = ref3.recent;
    var inputRef = (0,react.useRef)(null);
    var handleOutsideClick = function(e) {
        // In antd if we only use `inputRef` as input ref, it will point to
        // the **input component** instead of the HTML component
        // thus we use `inputRef.current.input` instead of `inputRef.current`
        if (inputRef.current && !inputRef.current.input.contains(e.target)) {
            setVisible(false);
        }
    };
    var debouncedSearch = lodash_debounce_default()(function(value) {
        return dispatch(Search_slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500);
    var handleSelect = lodash_debounce_default()(function() {
        return setKeyword("");
    }, 500);
    var onFocus = function() {
        setVisible(true);
        dispatch(Search_slice/* effects.getSearchRecentResult */.Sz.getSearchRecentResult());
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_styled/* Relative */.Ig, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_IconWrapper, {
                size: "40px",
                onClick: function() {
                    return setVisibilitySearchBar(!isSearchBarVisible);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Iconmoon, {
                    size: "30px",
                    className: "icon-android_search"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Search_styled/* SearchBarWrapper */.cI, {
                isVisible: isSearchBarVisible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Autocomplete, {
                        options: keyword.length > 0 ? Search_options(result) : recentOptions(recent),
                        value: keyword,
                        onSelect: handleSelect,
                        open: visible,
                        onFocus: function() {
                            return setVisible(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Input, {
                            placeholder: "Search for brand, symbol or username...",
                            ref: inputRef,
                            height: "30px",
                            value: keyword,
                            onChange: function(e) {
                                var value = e.target.value;
                                setKeyword(value);
                                debouncedSearch(value);
                            },
                            onFocus: onFocus,
                            width: "100%",
                            "data-cy": "top-navbar-search-input-mobile"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styled/* IconClose */.bM, {
                        size: "30px",
                        onClick: function() {
                            setVisibilitySearchBar(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Iconmoon, {
                            size: "15px",
                            className: "icon-compose_close"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Search_Mobile = (Mobile);

;// CONCATENATED MODULE: ./src/global/Header/Search/Web.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ 











var Web_Input = ui/* Common.Input */.Gn.Input;
var Web = function() {
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(Search_slice/* selectors */.wl), result = ref.result, recent = ref.recent;
    var ref1 = (0,react.useState)(""), keyword = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react.useState)(false), visible = ref2[0], setVisible = ref2[1];
    var ref3 = (0,react.useState)(false), isNavigating = ref3[0], setIsNavigating = ref3[1];
    var inputRef = (0,react.useRef)(null);
    var handleOutsideClick = function(e) {
        // In antd if we only use `inputRef` as input ref, it will point to
        // the **input component** instead of the HTML component
        // thus we use `inputRef.current.input` instead of `inputRef.current`
        if (inputRef.current && !inputRef.current.input.contains(e.target)) {
            setVisible(false);
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        dispatch(Search_slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500), []);
    var onChange = function(e) {
        var value = e.target.value;
        setKeyword(value);
        debouncedSearch(value);
        setIsNavigating(false);
    };
    var onFocus = function() {
        setVisible(true);
        dispatch(Search_slice/* effects.getSearchRecentResult */.Sz.getSearchRecentResult());
    };
    var resetSearchResult = function() {
        setKeyword("");
        setVisible(false);
        inputRef.current.blur();
    };
    var handleSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(_value, option) {
            var ref, ref1, data, url, isUser, ref2, ref3, ref4, ref5, ref6, id, url1, searchType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isNavigating) {
                            _ctx.next = 18;
                            break;
                        }
                        ;
                        data = option.label.props;
                        url = (ref = option.label.props) === null || ref === void 0 ? void 0 : (ref1 = ref.item) === null || ref1 === void 0 ? void 0 : ref1.url;
                        setIsNavigating(false);
                        setVisible(false);
                        isUser = data.searchType === "user";
                        if (!isUser) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 10;
                        return dispatch(Search_slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: data.item.name,
                            target: data.item.id,
                            type: "people"
                        }));
                    case 10:
                        _ctx.next = 14;
                        break;
                    case 12:
                        _ctx.next = 14;
                        return dispatch(Search_slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: data.item.symbol || data.item.symbol_2,
                            target: data.item.id,
                            type: "company"
                        }));
                    case 14:
                        router.push("/".concat(url));
                        resetSearchResult();
                        _ctx.next = 19;
                        break;
                    case 18:
                        {
                            ;
                            id = (ref2 = option.label.props) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.item) === null || ref3 === void 0 ? void 0 : ref3.id;
                            url1 = (ref4 = option.label.props) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.item) === null || ref5 === void 0 ? void 0 : ref5.url;
                            searchType = (ref6 = option.label.props) === null || ref6 === void 0 ? void 0 : ref6.searchType;
                            if (url1) {
                                router.push("/".concat(url1));
                            }
                            // insider searchType have url === ''
                            if (searchType === "insider") {
                                router.push("/insider/".concat(id));
                            }
                            resetSearchResult();
                        }
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSelect(_value, option) {
            return _ref.apply(this, arguments);
        };
    }();
    var handlePressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            var ref, ref1, val, search, _payload, error, data, _company, company, symbol, _people, user;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        val = "";
                        if (typeof e !== "string") {
                            val = e.target.value;
                        }
                        if (!(val.length === 0)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isNavigating) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        if (!(val.length <= 3)) {
                            _ctx.next = 10;
                            break;
                        }
                        router.push("/search?q=".concat(val));
                        return _ctx.abrupt("return");
                    case 10:
                        _ctx.next = 12;
                        return dispatch(Search_slice/* effects.getSearchResult */.Sz.getSearchResult(val));
                    case 12:
                        search = _ctx.sent;
                        _payload = search.payload, error = _payload.error, data = _payload.data;
                        if (!error) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 16:
                        if (!(val.length < 10 && ((ref = data.company) === null || ref === void 0 ? void 0 : ref.length) > 0)) {
                            _ctx.next = 24;
                            break;
                        }
                        _company = (0,_sliced_to_array/* default */.Z)(data.company, 1), company = _company[0];
                        symbol = company.name || company.symbol_2;
                        _ctx.next = 21;
                        return dispatch(Search_slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: val,
                            target: company.id,
                            type: "company"
                        }));
                    case 21:
                        resetSearchResult();
                        router.push("/symbol/".concat(symbol));
                        return _ctx.abrupt("return");
                    case 24:
                        if (!(val.length > 4 && ((ref1 = data.people) === null || ref1 === void 0 ? void 0 : ref1.length) === 1)) {
                            _ctx.next = 30;
                            break;
                        }
                        _people = (0,_sliced_to_array/* default */.Z)(data.people, 1), user = _people[0];
                        _ctx.next = 28;
                        return dispatch(Search_slice/* effects.postSearchRecentResult */.Sz.postSearchRecentResult({
                            keyword: val,
                            target: user.id,
                            type: "people"
                        }));
                    case 28:
                        router.push("/".concat(user.name));
                        return _ctx.abrupt("return");
                    case 30:
                        // catch, redirect to search page
                        router.push("/search?q=".concat(val));
                    case 31:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePressEnter(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleListenArrowKey = function(e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            setIsNavigating(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        autoComplete: "off",
        onSubmit: function(e) {
            return e.preventDefault();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_styled/* Autocomplete */.F2, {
            options: keyword.length > 0 ? Search_options(result) : recentOptions(recent),
            width: "320px",
            getPopupContainer: function(trigger) {
                return trigger.parentElement;
            },
            value: keyword,
            onSelect: handleSelect,
            open: visible,
            onFocus: function() {
                return setVisible(true);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Input, {
                placeholder: "Search for brand, symbol or username...",
                height: "30px",
                ref: inputRef,
                value: keyword,
                onChange: onChange,
                onFocus: onFocus,
                onPressEnter: handlePressEnter,
                width: "100%",
                onKeyDown: handleListenArrowKey,
                "data-cy": "top-navbar-search-input-desktop"
            })
        })
    });
};
/* harmony default export */ var Search_Web = (Web);

;// CONCATENATED MODULE: ./src/global/Header/Search/index.jsx



;// CONCATENATED MODULE: ./src/utils/navbar.js

var generateNavBar = function(data) {
    var _country = data.country, country = _country === void 0 ? "ID" : _country;
    var baseMenu = [
        {
            label: "Stream",
            href: "/stream",
            logoWeb: "icon-menu_home",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/stream")) {
                    return true;
                }
                return false;
            },
            logoMobile: "icon-menu3_home",
            "data-cy": "navbar-stream"
        },
        {
            label: "Profile",
            logoWeb: "icon-menu_profile",
            href: "/".concat(data.username),
            matcher: function(router) {
                var asPath = router.asPath;
                if (data.username && asPath.includes("/".concat(data.username))) {
                    return true;
                }
                return false;
            },
            logoMobile: "icon-menu3_profile",
            "data-cy": "navbar-profile"
        },
        {
            label: "Watchlist",
            href: "/watchlist",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/watchlist")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_watchlist",
            logoMobile: "icon-menu3_watchlist",
            "data-cy": "navbar-watchlist"
        },
        {
            label: "Chat",
            href: "/chat",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/chat") || asPath.includes("/group-chat")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_chat",
            logoMobile: "icon-menu3_chat",
            "data-cy": "navbar-chat"
        },
        {
            label: "Chartbit",
            href: "/symbol/IHSG/chartbit",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/chartbit")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_chartbit",
            logoMobile: "icon-menu3_chartbit",
            "data-cy": "navbar-chartbit"
        }, 
    ];
    var mockMenu = [
        {
            label: "Orderbook",
            href: "/orderbook",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/orderbook")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_orderbook",
            logoMobile: "icon-menu3_orderbook",
            "data-cy": "navbar-orderbook"
        },
        {
            label: "e-IPO",
            href: "/e-ipo",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/e-ipo")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu3_eipo",
            logoMobile: "icon-menu3_eipo",
            "data-cy": "navbar-ipo"
        },
        {
            label: "Academy",
            href: "/academy?refresh=1",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/unboxing")) {
                    return true;
                }
                if (asPath.includes("/academy")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_academy",
            logoMobile: "icon-menu3_academy",
            "data-cy": "navbar-academy"
        },
        {
            label: "Screener",
            href: "/screener",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/screener")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_screener",
            logoMobile: "icon-menu3_screener",
            "data-cy": "navbar-screener"
        },
        {
            label: "Valuation",
            href: "/valuation",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/valuation")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_valuation",
            logoMobile: "icon-menu3_valuation",
            "data-cy": "navbar-valuation"
        },
        {
            label: "Financials",
            href: "/symbol/AALI/financials",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/financials")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_financials",
            logoMobile: "icon-menu3_financials",
            "data-cy": "navbar-financials"
        },
        {
            label: "Fundachart",
            href: "/symbol/AALI/fundachart",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/fundachart")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_fundachart",
            logoMobile: "icon-menu3_fundachart",
            "data-cy": "navbar-fundachart"
        },
        {
            label: "Seasonality",
            href: "/symbol/AALI/seasonality",
            matcher: function(router) {
                var pathname = router.pathname;
                if (pathname.includes("/symbol/[SYMBOL]/seasonality")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_seasonality",
            logoMobile: "icon-menu3_seasonality",
            "data-cy": "navbar-seasonality"
        },
        {
            label: "Sector",
            href: "/sector",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/sector")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_sector",
            logoMobile: "icon-menu3_sector",
            "data-cy": "navbar-sector"
        },
        {
            label: "Calendar",
            href: "/calendar",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/calendar")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_calendar",
            logoMobile: "icon-menu3_calendar",
            "data-cy": "navbar-calendar"
        },
        {
            label: "Earnings",
            href: "/earnings",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/earnings")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_earning",
            logoMobile: "icon-menu3_earning",
            "data-cy": "navbar-earning"
        },
        {
            label: "Glossary",
            href: "/glossary",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/glossary")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_glossary",
            logoMobile: "icon-menu3_glossary",
            "data-cy": "navbar-glossary"
        },
        {
            label: "Ebook",
            href: "/ebook",
            matcher: function(router) {
                var asPath = router.asPath;
                if (asPath.includes("/ebook")) {
                    return true;
                }
                return false;
            },
            logoWeb: "icon-menu_ebook",
            logoMobile: "icon-menu3_ebook",
            "data-cy": "navbar-ebook"
        }, 
    ];
    if (country === "MY") {
        return baseMenu;
    }
    return (0,_to_consumable_array/* default */.Z)(baseMenu).concat((0,_to_consumable_array/* default */.Z)(mockMenu));
};
/* harmony default export */ var navbar = (generateNavBar);

// EXTERNAL MODULE: ./src/global/Securities/utils/maintenance.ts + 2 modules
var maintenance = __webpack_require__(38525);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var OrderTable_store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/lib/stores/trading.ts
var stores_trading = __webpack_require__(76260);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./src/typings/auth.ts
var typings_auth = __webpack_require__(97718);
// EXTERNAL MODULE: ./src/utils/crisp.js
var crisp = __webpack_require__(65458);
;// CONCATENATED MODULE: ./src/features/securities/hooks/useSecuritiesButton.ts











function useSecuritiesButton() {
    var router = (0,next_router.useRouter)();
    var resetUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.resetUIValue;
    });
    var handleLogoutTrading = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var securitiesPathPattern, isSecuritiesPage, ref, ref1, ref2, ref3;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 3:
                        securitiesPathPattern = /securities\/.+/;
                        isSecuritiesPage = securitiesPathPattern.test(router.asPath);
                        stores_trading/* default.getState */.Z.getState().resetErrorCode();
                        TradingModal_store/* default.getState */.Z.getState().resetModal();
                        OrderTable_store/* default.getState */.Z.getState().resetOrderTableStore();
                        // reset eipo token
                        localStorage.removeItem("eipoToken");
                        localStorage.removeItem("eipoRefreshToken");
                        resetUIValue(typings_auth/* LoginType.Securities */.B.Securities);
                        if (!isSecuritiesPage) {
                            _ctx.next = 14;
                            break;
                        }
                        _ctx.next = 14;
                        return router.push("/stream");
                    case 14:
                        return _ctx.abrupt("return");
                    case 17:
                        _ctx.prev = 17;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        (0,logger/* default */.ZP)(_ctx.t0, {
                            event: "TradingMenuItem@handleNavigation",
                            errType: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.error_type,
                            errMessage: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref2 = _ctx.t0.response) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.message
                        });
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    17
                ]
            ]);
        }));
        return function handleLogoutTrading() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickSupportButton = function() {
        (0,crisp/* handleClickSupport */.lA)();
    };
    return {
        handleLogoutTrading: handleLogoutTrading,
        handleClickSupportButton: handleClickSupportButton
    };
};

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/realTadingMenu.tsx
var SECURITIES_URL = "/securities";
var realTradingMenu = [
    {
        title: "Trading",
        subMenu: [
            {
                label: "Orderbook",
                link: "/orderbook",
                iconmoonWeb: "icon-tradesmall_orderbook",
                iconmoonMobile: "icon-menu3_orderbook",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/orderbook")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Portfolio",
                link: "".concat(SECURITIES_URL, "/portfolio"),
                iconmoonWeb: "icon-tradesmall_portfolio",
                iconmoonMobile: "icon-menu3_portfolio",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/portfolio")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Order",
                link: "".concat(SECURITIES_URL, "/order"),
                iconmoonWeb: "icon-tradesmall_order",
                iconmoonMobile: "icon-menu3_order",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/order") && !asPath.includes("/orderbook")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "History",
                link: "".concat(SECURITIES_URL, "/history"),
                iconmoonWeb: "icon-tradesmall_history",
                iconmoonMobile: "icon-menu3_history",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/history")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Transfer Saham",
                link: "".concat(SECURITIES_URL, "/stocktransfer"),
                iconmoonWeb: "icon-briefcase_arrow",
                iconmoonMobile: "icon-briefcase_arrow",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/stocktransfer")) {
                        return true;
                    }
                    return false;
                }
            }, 
        ]
    },
    {
        title: "Settings",
        subMenu: [
            {
                label: "Trading Profile",
                link: "/profile/account/trading",
                iconmoonWeb: "icon-tradesmall_account",
                iconmoonMobile: "icon-menu3_account",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/profile/account/trading")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Security",
                link: "".concat(SECURITIES_URL, "/settings"),
                iconmoonWeb: "icon-tradesmall_password",
                iconmoonMobile: "icon-menu3_password",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/settings")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "E-Statement",
                link: "".concat(SECURITIES_URL, "/estatement"),
                iconmoonWeb: "icon-securities-file",
                iconmoonMobile: "icon-securities-file",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/estatement")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Deposit",
                link: "".concat(SECURITIES_URL, "/deposit"),
                iconmoonWeb: "icon-tradesmall_deposit",
                iconmoonMobile: "icon-menu3_deposit",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/deposit")) {
                        return true;
                    }
                    return false;
                }
            },
            {
                label: "Withdrawal",
                link: "".concat(SECURITIES_URL, "/withdrawal"),
                iconmoonWeb: "icon-tradesmall_withdraw",
                iconmoonMobile: "icon-menu3_withdraw",
                matcher: function(router) {
                    var asPath = router.asPath;
                    if (asPath.includes("/withdrawal")) {
                        return true;
                    }
                    return false;
                }
            }, 
        ]
    },
    {
        subMenu: [
            {
                label: "Live Support",
                link: "",
                iconmoonWeb: "icon-tradesmall_support",
                iconmoonMobile: "icon-menu3_support",
                matcher: function() {
                    return false;
                }
            },
            {
                label: "Trading Logout",
                link: "",
                iconmoonWeb: "icon-tradesmall_logout",
                iconmoonMobile: "icon-menu3_logout",
                matcher: function() {
                    return false;
                }
            }, 
        ]
    }, 
];
/* harmony default export */ var realTadingMenu = (realTradingMenu);

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/styled.ts
/* eslint-disable no-confusing-arrow */ 
function RealTrading_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  border-left: 1px solid ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  flex-direction: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n\n  ::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    top: 100%;\n    right: 0;\n    height: ",
        ";\n    background: ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    RealTrading_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RealTrading_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 15px;\n  line-height: 24px;\n  font-weight: bold;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    RealTrading_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RealTrading_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  bakcground: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n    p,\n    p::before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    RealTrading_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RealTrading_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 6px;\n  width: 250px;\n  padding: 10px 0;\n  border-bottom: 1px solid ",
        ";\n  :last-child {\n    border-bottom: none;\n  }\n"
    ]);
    RealTrading_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RealTrading_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-left: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    RealTrading_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RealTrading_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 100%;\n  right: 0;\n  display: flex;\n"
    ]);
    RealTrading_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RealTrading_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  background: ",
        ";\n"
    ]);
    RealTrading_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #ecf8fd;\n  width: 250px;\n\n  button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n\n    &.trading-menu-notification {\n      padding: 6px 0 6px 12px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      font-family: var(--bold-font);\n      text-align: left;\n      color: #333333;\n\n      p {\n        margin: 0;\n      }\n\n      img {\n        margin-right: 12px;\n      }\n    }\n\n    &.trading-menu-notification-close {\n      padding: 0 12px;\n    }\n  }\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text;
var PopoverContainer = ui/* Header.PopoverContainer */.h4.PopoverContainer;
var ButtonTrading = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-d9cc987b-0"
})(RealTrading_styled_templateObject(), ui/* color.lowgray */.$_.lowgray, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "space-between" : "space-around";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "16px 0" : "0 16px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "column" : "row";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "110px" : "145px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "60px";
}, function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? "1px" : 0;
}, ui/* color.light */.$_.light);
var TradingMenuTitle = (0,styled_components_browser_esm["default"])(styled_Text).withConfig({
    componentId: "sc-d9cc987b-1"
})(RealTrading_styled_templateObject1(), ui/* color.primary */.$_.primary);
var TradingMenuItemContainer = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-d9cc987b-2"
})(RealTrading_styled_templateObject2(), ui/* color.downgray */.$_.downgray, ui/* color.primary */.$_.primary);
var TradeAreaContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d9cc987b-3"
})(RealTrading_styled_templateObject3(), ui/* color.lowgray */.$_.lowgray);
var Grid = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d9cc987b-4"
})(RealTrading_styled_templateObject4(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
var PopoverContainerFlex = (0,styled_components_browser_esm["default"])(PopoverContainer).withConfig({
    componentId: "sc-d9cc987b-5"
})(RealTrading_styled_templateObject5());
var PopoverContainerBlock = (0,styled_components_browser_esm["default"])(PopoverContainerFlex).withConfig({
    componentId: "sc-d9cc987b-6"
})(RealTrading_styled_templateObject6(), ui/* color.light */.$_.light);
var NavigationMobile = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    direction: "column",
    py: "15px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-d9cc987b-7"
})(styled_templateObject7(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
var StockTransferNotif = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-d9cc987b-8"
})(styled_templateObject8());


;// CONCATENATED MODULE: ./src/global/Header/RealTrading/Mobile.styled.ts

function Mobile_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #00ab6b !important;\n  border: 1px solid #00ab6b !important;\n  border-radius: 4px;\n  width: 100%;\n\n  padding: 4px 15px;\n  margin: 16px 0 0;\n  height: 36px;\n  font-weight: bold;\n  color: #ffffff !important;\n"
    ]);
    Mobile_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BuyButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-5cd8f105-0"
})(Mobile_styled_templateObject());

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/Mobile.tsx











var Mobile_Flex = ui/* Common.Flex */.Gn.Flex, RealTrading_Mobile_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, RealTrading_Mobile_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, Mobile_Text = ui/* Common.Text */.Gn.Text;
var subMenuList = realTadingMenu.map(function(param) {
    var subMenu = param.subMenu;
    return subMenu;
}).flat();
var Mobile_Mobile = function() {
    var router = (0,next_router.useRouter)();
    var openSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    var ref = useSecuritiesButton(), handleLogoutTrading = ref.handleLogoutTrading, handleClickSupportButton = ref.handleClickSupportButton;
    var handleBuyClick = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            openSearchCompanyModal();
        });
    };
    var handleClickMenu = function(data) {
        if (data.label === "Trading Logout") {
            handleLogoutTrading();
        }
        if (data.label === "Live Support") {
            handleClickSupportButton();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mobile_Flex, {
                direction: "column",
                p: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mobile_Flex, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Mobile_IconWrapper, {
                                size: "40px",
                                style: {
                                    marginRight: 4
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/img/ssd.svg",
                                    alt: "logo-sekuritas",
                                    style: {
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Text, {
                                children: "Trading Area"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyButton, {
                        onClick: handleBuyClick,
                        children: "BUY"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                children: subMenuList.map(function(data) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: data.link,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavigationMobile, {
                            onClick: function() {
                                return handleClickMenu(data);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Mobile_Iconmoon, {
                                    className: data.iconmoonMobile,
                                    color: data.matcher(router) ? ui/* color.primary */.$_.primary : ui/* color.dimgray */.$_.dimgray,
                                    size: "24px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Text, {
                                    as: "a",
                                    size: "11px",
                                    align: "center",
                                    color: data.matcher(router) ? ui/* color.primary */.$_.primary : ui/* color.dimgray */.$_.dimgray,
                                    children: data.label
                                })
                            ]
                        }, data.label)
                    }, data.label);
                })
            })
        ]
    });
};
/* harmony default export */ var RealTrading_Mobile = (Mobile_Mobile);

// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var AuthModal_store = __webpack_require__(70175);
;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/virtualTradingMenu.js
var virtualTradingMenu = [
    {
        title: "Trading",
        subMenu: [
            {
                label: "Orderbook",
                link: "/orderbook",
                iconmoonWeb: "icon-tradesmall_orderbook",
                iconmoonMobile: "icon-menu3_orderbook"
            },
            {
                label: "Portfolio",
                link: "/trade/portfolio",
                iconmoonWeb: "icon-tradesmall_portfolio",
                iconmoonMobile: "icon-menu3_portfolio"
            },
            {
                label: "Order",
                link: "/trade/order",
                iconmoonWeb: "icon-tradesmall_order",
                iconmoonMobile: "icon-menu3_order"
            }, 
        ]
    }, 
];
/* harmony default export */ var VirtualTrading_virtualTradingMenu = (virtualTradingMenu);

;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/styled.js

function VirtualTrading_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  border-left: 1px solid ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  flex-direction: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n\n  ::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    top: 100%;\n    right: 0;\n    height: ",
        ";\n    background: ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    VirtualTrading_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 15px;\n  line-height: 24px;\n  font-weight: 700;\n  font-size: 14px;\n  color: ",
        ";\n"
    ]);
    VirtualTrading_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  padding: 0 15px;\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n    p,\n    p::before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    VirtualTrading_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 6px;\n  width: 250px;\n  background-color: white;\n  padding: 10px 0;\n  border-bottom: 1px solid ",
        ";\n  :last-child {\n    border-bottom: none;\n  }\n"
    ]);
    VirtualTrading_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-left: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    VirtualTrading_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 100%;\n  right: 0;\n  display: flex;\n"
    ]);
    VirtualTrading_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n"
    ]);
    VirtualTrading_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function VirtualTrading_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    VirtualTrading_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var VirtualTrading_styled_Flex = ui/* Common.Flex */.Gn.Flex, VirtualTrading_styled_Text = ui/* Common.Text */.Gn.Text;
var styled_PopoverContainer = ui/* Header.PopoverContainer */.h4.PopoverContainer;
var styled_ButtonTrading = (0,styled_components_browser_esm["default"])(VirtualTrading_styled_Flex).withConfig({
    componentId: "sc-e7788928-0"
})(VirtualTrading_styled_templateObject(), ui/* color.lowgray */.$_.lowgray, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "space-between" : "space-around";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "16px 0" : "0 16px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "column" : "row";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "110px" : "145px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "60px";
}, function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? "1px" : 0;
}, ui/* color.light */.$_.light);
var styled_TradingMenuTitle = (0,styled_components_browser_esm["default"])(VirtualTrading_styled_Text).withConfig({
    componentId: "sc-e7788928-1"
})(VirtualTrading_styled_templateObject1(), ui/* color.primary */.$_.primary);
var styled_TradingMenuItemContainer = (0,styled_components_browser_esm["default"])(VirtualTrading_styled_Flex).withConfig({
    componentId: "sc-e7788928-2"
})(VirtualTrading_styled_templateObject2(), ui/* color.downgray */.$_.downgray, ui/* color.primary */.$_.primary);
var styled_TradeAreaContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e7788928-3"
})(VirtualTrading_styled_templateObject3(), ui/* color.lowgray */.$_.lowgray);
var styled_Grid = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-e7788928-4"
})(VirtualTrading_styled_templateObject4(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
var styled_PopoverContainerFlex = (0,styled_components_browser_esm["default"])(styled_PopoverContainer).withConfig({
    componentId: "sc-e7788928-5"
})(VirtualTrading_styled_templateObject5());
var styled_PopoverContainerBlock = (0,styled_components_browser_esm["default"])(styled_PopoverContainerFlex).withConfig({
    componentId: "sc-e7788928-6"
})(VirtualTrading_styled_templateObject6());
var styled_NavigationMobile = (0,styled_components_browser_esm["default"])(VirtualTrading_styled_Flex).attrs({
    direction: "column",
    py: "15px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-e7788928-7"
})(VirtualTrading_styled_templateObject7(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);


;// CONCATENATED MODULE: ./src/global/Header/styled.js

function Header_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: scroll;\n"
    ]);
    Header_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: 16px;\n  border-bottom: 1px solid ",
        ";\n  background: ",
        ";\n  z-index: 100;\n\n  &.chat-expanded {\n    display: none;\n  }\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    Header_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  width: calc(100% - ",
        ");\n\n  &.chat-expanded {\n    display: none;\n  }\n\n  @media ",
        " {\n    position: fixed;\n    display: flex;\n    justify-content: space-between;\n    top: 0;\n    left: 0;\n    right: 0;\n    border-bottom: 1px solid ",
        ";\n    background: white;\n    z-index: 100;\n  }\n"
    ]);
    Header_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 30px;\n  padding-right: 16px;\n  height: 60px;\n  z-index: 100;\n"
    ]);
    Header_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 2px 4px;\n  text-wrap: nowrap;\n  white-space: pre;\n"
    ]);
    Header_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Header_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    background: ",
        ";\n    p {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    Header_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var styled_Button = ui/* Common.Button */.Gn.Button, Header_styled_Flex = ui/* Common.Flex */.Gn.Flex, Header_styled_Text = ui/* Common.Text */.Gn.Text;
var Fixed = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-6ab744df-0"
})(Header_styled_templateObject());
var HeaderMobile = (0,styled_components_browser_esm["default"])(Header_styled_Flex).withConfig({
    componentId: "sc-6ab744df-1"
})(Header_styled_templateObject1(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet);
var HeaderWeb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-6ab744df-2"
})(Header_styled_templateObject2(), function(props) {
    return props.isOpen ? "365px" : "35px";
}, ui/* device.tablet */.Uh.tablet, ui/* color.gainsboro */.$_.gainsboro);
var HeaderWebTop = (0,styled_components_browser_esm["default"])(Header_styled_Flex).withConfig({
    componentId: "sc-6ab744df-3"
})(Header_styled_templateObject3());
var ProUser = (0,styled_components_browser_esm["default"])(Header_styled_Text).attrs({
    as: "a"
}).withConfig({
    componentId: "sc-6ab744df-4"
})(Header_styled_templateObject4(), ui/* color.primary */.$_.primary, ui/* color.gainsboro */.$_.gainsboro);
var SwitchButton = (0,styled_components_browser_esm["default"])(styled_Button).withConfig({
    componentId: "sc-6ab744df-5"
})(Header_styled_templateObject5(), ui/* color.primary */.$_.primary, ui/* color.light */.$_.light);


;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/Mobile.tsx











var Mobile_Button = ui/* Common.Button */.Gn.Button, VirtualTrading_Mobile_Flex = ui/* Common.Flex */.Gn.Flex, VirtualTrading_Mobile_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, VirtualTrading_Mobile_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, VirtualTrading_Mobile_Text = ui/* Common.Text */.Gn.Text;
var VirtualTradeMobile = function() {
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var showSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    var handleSwitchReal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        showAuthModal();
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSwitchReal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            padding: "16px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTrading_Mobile_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile_IconWrapper, {
                        size: "40px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/favicon.ico"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile_Text, {
                        children: "Virtual Area"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_Button, {
                type: "primary",
                margin: "10px 0",
                height: "36px",
                block: true,
                onClick: showSearchCompanyModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile_Text, {
                    size: "14px",
                    color: ui/* color.light */.$_.light,
                    align: "center",
                    children: "BUY"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Grid, {
                children: VirtualTrading_virtualTradingMenu[0].subMenu.map(function(subMenu) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_NavigationMobile, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile_Iconmoon, {
                                className: subMenu.iconmoonMobile,
                                color: ui/* color.dimgray */.$_.dimgray,
                                size: "24px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile_Text, {
                                as: "a",
                                size: "11px",
                                align: "center",
                                color: ui/* color.dimgray */.$_.dimgray,
                                children: subMenu.label
                            })
                        ]
                    }, subMenu.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    padding: "0px 16px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                    height: "32px",
                    onClick: handleSwitchReal,
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile_Text, {
                        color: ui/* color.primary */.$_.primary,
                        size: "14px",
                        padding: "0 8px",
                        children: "Switch to Real Account"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var VirtualTrading_Mobile = (VirtualTradeMobile);

;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/Mobile.jsx



var InitialTrading_Mobile_Button = ui/* Common.Button */.Gn.Button, InitialTrading_Mobile_Text = ui/* Common.Text */.Gn.Text;
var InitialTradeWeb = function() {
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            padding: "16px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_Mobile_Button, {
            onClick: function() {
                return showAuthModal();
            },
            style: {
                background: ui/* color.trading */.$_.trading
            },
            margin: "10px 0",
            height: "36px",
            block: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_Mobile_Text, {
                weight: "bold",
                size: "14px",
                color: ui/* color.light */.$_.light,
                align: "center",
                children: "START TRADING"
            })
        })
    });
};
/* harmony default export */ var InitialTrading_Mobile = (InitialTradeWeb);

;// CONCATENATED MODULE: ./src/global/Header/Navbar/styled.ts

function Navbar_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: unset;\n  border: none;\n  overflow-y: auto;\n  background-color: white;\n"
    ]);
    Navbar_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-right: 1px solid ",
        ";\n\n  ::after {\n    position: absolute;\n    content: '';\n    width: 100%;\n    height: 1px;\n    top: 100%;\n    background: ",
        ";\n  }\n"
    ]);
    Navbar_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-left: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    Navbar_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n\n  & > span {\n    display: inline-block;\n    height: 1px;\n    background: ",
        ";\n  }\n"
    ]);
    Navbar_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    Navbar_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 20%;\n  background-color: white;\n\n  div:nth-child(2) {\n    :nth-child(2) {\n      background: ",
        ";\n      border-top: none;\n    }\n  }\n"
    ]);
    Navbar_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height : 40px;\n    background-color: white;\n    color : ",
        ";\n    \n    :hover,\n    a:hover{\n      color : ",
        ";\n    }\n  "
    ]);
    Navbar_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Navbar_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  display: flex;\n  align-items: center;\n"
    ]);
    Navbar_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var Navbar_styled_PopoverContainer = ui/* Header.PopoverContainer */.h4.PopoverContainer, Navbar = ui/* Header.NavbarWeb */.h4.NavbarWeb;
var styled_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, Navbar_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var PopoverNavbarContainer = (0,styled_components_browser_esm["default"])(Navbar_styled_PopoverContainer).withConfig({
    componentId: "sc-1049095d-0"
})(Navbar_styled_templateObject());
var IconClose = (0,styled_components_browser_esm["default"])(styled_IconWrapper).withConfig({
    componentId: "sc-1049095d-1"
})(Navbar_styled_templateObject1(), ui/* color.midgray */.$_.midgray, ui/* color.light */.$_.light);
var Navbar_styled_Grid = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1049095d-2"
})(Navbar_styled_templateObject2(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
var LogoExpand = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1049095d-3"
})(Navbar_styled_templateObject3(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, ui/* color.midgray */.$_.midgray);
var Navbar_styled_NavigationMobile = (0,styled_components_browser_esm["default"])(Navbar_styled_Flex).attrs({
    direction: "column",
    py: "15px",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-1049095d-4"
})(Navbar_styled_templateObject4(), ui/* color.downgray */.$_.downgray, ui/* color.downgray */.$_.downgray);
var NavbarWeb = (0,styled_components_browser_esm["default"])(Navbar).withConfig({
    componentId: "sc-1049095d-5"
})(Navbar_styled_templateObject5(), ui/* color.light */.$_.light);
var Navigation = (0,styled_components_browser_esm["default"])(Navbar_styled_Flex).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "active"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        active: props.active,
        align: "center",
        p: "8px 20px 8px 10px"
    };
}).withConfig({
    componentId: "sc-1049095d-6"
})(Navbar_styled_templateObject6(), function(param) {
    var active = param.active;
    return active ? ui/* color.primary */.$_.primary : ui/* color.dimgray */.$_.dimgray;
}, function(param) {
    var active = param.active;
    return active ? ui/* color.primary */.$_.primary : ui/* color.highempahis */.$_.highempahis;
});
var NavLink = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-1049095d-7"
})(Navbar_styled_templateObject7());


;// CONCATENATED MODULE: ./src/global/Header/Navbar/ExpandMenuOpen.jsx



var ExpandMenuOpen = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoExpand, {
        size: size,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
        ]
    });
};
ExpandMenuOpen.propTypes = {
    size: (prop_types_default()).string
};
ExpandMenuOpen.defaultProps = {
    size: "20px"
};
/* harmony default export */ var Navbar_ExpandMenuOpen = (ExpandMenuOpen);

;// CONCATENATED MODULE: ./src/global/Header/Navbar/ReloadHandler.tsx



var ReloadHandler = function(param) {
    var children = param.children, href = param.href, label = param.label, onClick = param.onClick, isMobile = param.isMobile;
    var NavWrapper = isMobile ? Navbar_styled_NavigationMobile : NavLink;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavWrapper, {
            onClick: onClick,
            children: children
        }, label)
    }, label);
};
/* harmony default export */ var Navbar_ReloadHandler = (ReloadHandler);

;// CONCATENATED MODULE: ./src/global/Header/Navbar/Mobile.jsx













var Navbar_Mobile_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Navbar_Mobile_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, Navbar_Mobile_Text = ui/* Common.Text */.Gn.Text;
var PopoverMobile = ui/* Header.PopoverCustom */.h4.PopoverCustom;
function componentTrigger(isButtonActive) {
    if (isButtonActive) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose, {
            size: "60px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Mobile_Iconmoon, {
                size: "25px",
                className: "icon-compose_close"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Mobile_IconWrapper, {
        size: "60px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_ExpandMenuOpen, {})
    });
}
var Navbar_Mobile_Mobile = function() {
    var router = (0,next_router.useRouter)();
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var ref = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading, tradingType = ref.tradingType;
    var renderTradingPopup = function() {
        if (!tradingType) return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_Mobile, {});
        if (isRealTrading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Mobile, {});
        if (isVirtualTrading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Mobile, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverMobile, {
        componentTrigger: componentTrigger,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverNavbarContainer, {
            children: [
                renderTradingPopup(),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_styled_Grid, {
                    children: navbar(data).map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar_ReloadHandler, {
                            href: item.href,
                            label: item.label,
                            isMobile: true,
                            "data-cy": item["data-cy"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Mobile_Iconmoon, {
                                    className: item.logoMobile,
                                    color: item.matcher(router) ? ui/* color.primary */.$_.primary : ui/* color.dimgray */.$_.dimgray,
                                    size: "24px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Mobile_Text, {
                                    as: "a",
                                    size: "11px",
                                    align: "center",
                                    color: item.matcher(router) ? ui/* color.primary */.$_.primary : ui/* color.dimgray */.$_.dimgray,
                                    children: item.label
                                })
                            ]
                        });
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Navbar_Mobile = (Navbar_Mobile_Mobile);

// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/constants/clevertap.js
var constants_clevertap = __webpack_require__(92124);
// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
;// CONCATENATED MODULE: ./src/global/Header/Navbar/Web.jsx
/* eslint-disable no-empty */ 















var Web_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, Web_Text = ui/* Common.Text */.Gn.Text, Web_Flex = ui/* Common.Flex */.Gn.Flex;
var NavMoreLogo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Flex, {
        width: "50px",
        height: "40px",
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/navbar-web/tripel-dot.svg",
            alt: "Tripel Dot"
        })
    });
};
var Web_Web = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var _country = data.country, country = _country === void 0 ? "ID" : _country;
    var renderExpand = function() {
        if (country === "ID") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-cy": data_cy/* default.NAVIGATION.MORE_MENU_BUTTON */.Z.NAVIGATION.MORE_MENU_BUTTON,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMoreLogo, {})
            });
        }
        return null;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarWeb, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        minimize: minimize,
        expandNavLogo: renderExpand,
        children: navbar(data).map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                active: item.matcher(router),
                "data-cy": item["data-cy"],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar_ReloadHandler, {
                    href: item.href,
                    label: item.label,
                    onClick: function() {
                        try {
                            (0,clevertap/* clevertapEvent */.Lq)(constants_clevertap/* CLEVERTAP_EVENT_NAME.HEADER_MENU */.dR.HEADER_MENU, {
                                Action: item.label.toLowerCase()
                            });
                        } catch (e) {}
                    },
                    isMobile: false,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Iconmoon, {
                            as: "a",
                            color: "inherit",
                            className: item.logoWeb
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Text, {
                            as: "a",
                            color: "inherit",
                            pl: "5px",
                            children: item.label
                        })
                    ]
                })
            }, item.label);
        })
    }));
};
Web_Web.propTypes = {
    minimize: (prop_types_default()).bool
};
Web_Web.defaultProps = {
    minimize: false
};
/* harmony default export */ var Navbar_Web = (Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/Navbar/index.jsx



// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/global/Header/Message/__tests__/constant.ts
var MOCK_USER_LOGGED_IN = {
    id: 111,
    username: "user-testing",
    country: "ID"
};
// MessageIcon
var DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT = "message-icon-inbox-chat-menu";
// MessageHeader
var DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT = "message-header-inbox-chat-menu";
var DATA_CY_NAME_MESSAGE_HEADER_REQUESTS = "message-header-inbox-chat-requests";
// MessageList
var DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST = "message-header-inbox-chat-message-list";
var DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY = "message-header-inbox-chat-message-list-empty";
// MessageItem
var DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT = "message-item-inbox-chat-menu";
// MessageItemAvatar
var DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT = "message-item-avatar-chat-menu";
// See All in Chat Button
var DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON = "message-header-inbox-chat-see-all-button";
var TEST_CASE_MESSAGE_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " should render successfully")
    };
};
var MOCK_COUNT_NOTIFICATION = {
    ZERO: 0,
    MORE_THAN_ZERO: 1,
    MORE_THAN_99: 100
};
var ROOM_LIST = {
    FILE_MOCK_NAME: {
        EMPTY: "EmptyRoomList",
        ACCEPTED: "AcceptedRoomList",
        INVITED: "InvitedRoomList"
    }
};
var MOCK_MESSAGE_ITEM = {
    id: 0,
    type: "ROOM_TYPE_GROUP",
    info: {
        name: "test lagi",
        shortened_name: "TL",
        description: "",
        avatar_url: ""
    },
    attributes: {
        group: {
            member_description: ""
        }
    },
    unread_count: 0,
    last_message: {
        text: "aaa",
        sender_username: "sender_username",
        type: "ATTACHMENT_TYPE_UNSPECIFIED",
        created_at: "2023-03-14T03:12:26Z",
        is_deleted: false,
        id: 1222222222
    },
    status: {
        is_muted: false,
        is_mentioned: false
    },
    state: "ROOM_STATE_ACCEPTED",
    unread_message: {
        total: 0,
        last_id: 12
    }
};

;// CONCATENATED MODULE: ./src/global/Header/Message/styled.js

function Message_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-popover-content {\n    border-radius: 6px !important;\n    border: 1px solid ",
        ";\n\n    .ant-popover-inner {\n      border-radius: 6px;\n    }\n  }\n\n"
    ]);
    Message_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Message_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: none;\n  overflow-y: auto;\n  background: ",
        ";\n"
    ]);
    Message_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Message_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* border-bottom: 1px solid ",
        "; */\n"
    ]);
    Message_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Message_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 65px;\n  cursor: pointer;\n  :hover {\n    background: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    Message_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Message_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 10px;\n  min-width: 19px;\n"
    ]);
    Message_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Message_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 6px;\n  height: 100%;\n"
    ]);
    Message_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Message_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 325px;\n  height: auto;\n"
    ]);
    Message_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Message_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    width: 16px;\n  }\n  & > :last-child {\n    margin-left: 5px;\n  }\n"
    ]);
    Message_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Message_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n  i {\n    font-style: normal;\n  }\n"
    ]);
    Message_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-right: 12px;\n\n  & > img {\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 52px);\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: 'space-between';\n  align-items: 'center';\n  flex-grow:1;\n  \n  p > img {\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: 7%;\n  left: 7%;\n  min-width: 18px;\n  height: 18px;\n  line-height: 18px;\n  padding: 0 2px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  font-size: 11px;\n  color: ",
        ";\n  text-align: center;\n  // TODO: Add Color to @stockbit/ui\n  border: 1px solid #8f8f8f;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  padding: 20px;\n  border-bottom-right-radius: 6px;\n  border-bottom-left-radius: 6px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Message_styled_Text = ui/* Common.Text */.Gn.Text, Message_styled_Flex = ui/* Common.Flex */.Gn.Flex, PopoverContent = ui/* Common.PopoverContent */.Gn.PopoverContent, styled_Avatar = ui/* Common.Avatar */.Gn.Avatar;
var Message_styled_PopoverContainer = ui/* Header.PopoverContainer */.h4.PopoverContainer;
var PopoverWeb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dbbc8935-0"
})(Message_styled_templateObject(), ui/* color.gainsboro */.$_.gainsboro);
var CustomPopoverContainer = (0,styled_components_browser_esm["default"])(Message_styled_PopoverContainer).withConfig({
    componentId: "sc-dbbc8935-1"
})(Message_styled_templateObject1(), ui/* color.light */.$_.light);
var PopoverContentMobile = (0,styled_components_browser_esm["default"])(PopoverContent).withConfig({
    componentId: "sc-dbbc8935-2"
})(Message_styled_templateObject2(), ui/* color.gainsboro */.$_.gainsboro);
var MessageListContainer = (0,styled_components_browser_esm["default"])(Message_styled_Flex).attrs(function(props) {
    return {
        align: "center",
        padding: "10px 20px",
        isNew: props.isNew
    };
}).withConfig({
    componentId: "sc-dbbc8935-3"
})(Message_styled_templateObject3(), ui/* color.downgray */.$_.downgray, ui/* color.black */.$_.black);
var UnreadMessage = (0,styled_components_browser_esm["default"])(Message_styled_Text).attrs({
    color: ui/* color.light */.$_.light,
    weight: "500",
    size: "11px",
    align: "center",
    padding: "3px 2px"
}).withConfig({
    componentId: "sc-dbbc8935-4"
})(Message_styled_templateObject4(), ui/* color.primary */.$_.primary);
var PopoverWrapperWeb = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dbbc8935-5"
})(Message_styled_templateObject5());
var PopoverContentWeb = (0,styled_components_browser_esm["default"])(PopoverContent).withConfig({
    componentId: "sc-dbbc8935-6"
})(Message_styled_templateObject6());
var RoomItemStatus = (0,styled_components_browser_esm["default"])(Message_styled_Flex).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-dbbc8935-7"
})(Message_styled_templateObject7());
var GroupAvatar = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-dbbc8935-8"
})(Message_styled_templateObject8());
var AvatarContainer = (0,styled_components_browser_esm["default"])(styled_Avatar).withConfig({
    componentId: "sc-dbbc8935-9"
})(styled_templateObject9(), ui/* color.component */.$_.component, ui/* color.lowgray */.$_.lowgray);
var MessageItemBody = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-dbbc8935-10"
})(_templateObject10());
var MessageItemContent = (0,styled_components_browser_esm["default"])(Message_styled_Flex).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-dbbc8935-11"
})(_templateObject11());
var MessageCount = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-dbbc8935-12"
})(_templateObject12(), ui/* color.primary */.$_.primary, ui/* color.light */.$_.light);
var PopoverFooter = (0,styled_components_browser_esm["default"])(Message_styled_Text).attrs({
    as: "a",
    color: ui/* color.primary */.$_.primary,
    align: "center",
    family: "bold"
}).withConfig({
    componentId: "sc-dbbc8935-13"
})(_templateObject13(), ui/* color.light */.$_.light);


;// CONCATENATED MODULE: ./src/global/Header/Message/MessageHeader.tsx




var MessageHeader_Text = ui/* Common.Text */.Gn.Text, MessageHeader_Flex = ui/* Common.Flex */.Gn.Flex;
function MessageHeader(param) {
    var _unreadRequest = param.unreadRequest, unreadRequest = _unreadRequest === void 0 ? 0 : _unreadRequest;
    var router = (0,next_router.useRouter)();
    var onClickRequest = function() {
        router.push("/chat?type=request");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageHeader_Flex, {
        padding: "16px 20px",
        justify: "space-between",
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageHeader_Text, {
                family: "bold",
                weight: "400",
                children: "Messages"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageHeader_Text, {
                color: ui/* color.primary */.$_.primary,
                as: "span",
                onClick: onClickRequest,
                style: {
                    cursor: "pointer"
                },
                "data-cy": DATA_CY_NAME_MESSAGE_HEADER_REQUESTS,
                children: [
                    "Requests ",
                    unreadRequest >= 1 && "(".concat(unreadRequest, ")")
                ]
            })
        ]
    });
}
/* harmony default export */ var Message_MessageHeader = (MessageHeader);

// EXTERNAL MODULE: ./src/features/chat/LeftSidebar/ChatRooms/LastMessagePreview.tsx
var LastMessagePreview = __webpack_require__(80056);
// EXTERNAL MODULE: ./src/global/Labels/LabelBroadcast.tsx
var LabelBroadcast = __webpack_require__(7162);
;// CONCATENATED MODULE: ./src/global/Header/Message/MessageItemAvatar.tsx






function RoomItemAvatar(param) {
    var type = param.type, src = param.src, name = param.name, shortName = param.shortName, isDeactive = param.isDeactive;
    if (type === "ROOM_TYPE_PERSONAL") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, {
            "data-cy": DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: isDeactive,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/avatar.png",
                        alt: "User Not Found Avatar"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: !isDeactive,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        alt: name,
                        src: src,
                        onError: function(e) {
                            return (0,general/* handleErrorAvatar */.Tk)(e, name);
                        }
                    })
                })
            ]
        });
    }
    var hasImage = src !== "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AvatarContainer, {
        "data-cy": DATA_CY_NAME_MESSAGE_ITEM_AVATAR_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: !hasImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupAvatar, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        "data-username": name,
                        children: shortName
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: hasImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: name,
                    src: src,
                    onError: function(e) {
                        return (0,general/* handleErrorAvatar */.Tk)(e, name);
                    }
                })
            })
        ]
    });
}
/* harmony default export */ var MessageItemAvatar = (RoomItemAvatar);

;// CONCATENATED MODULE: ./src/global/Header/Message/MessageItem.tsx


















var MessageItem_Text = ui/* Common.Text */.Gn.Text, MessageItem_Flex = ui/* Common.Flex */.Gn.Flex;
var MessageItem = function(param) {
    var item = param.item, onClick = param.onClick;
    var ref, ref1, ref2;
    // @ts-ignore
    var username = auth/* default.getUserAccess */.Z.getUserAccess().username;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataProfile = ref3.data;
    var id = item.id, attributes = item.attributes, _info = item.info, name = _info.name, shortName = _info.shortened_name, avatarUrl = _info.avatar_url, type = item.type, _status = item.status, isMuted = _status.is_muted, isMentioned = _status.is_mentioned, lastMessage = item.last_message, unreadCount = item.unread_count;
    var showSenderUsername = type === "ROOM_TYPE_GROUP" && username !== (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender_username) && (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.sender_username) !== "";
    var isDeactivated = attributes === null || attributes === void 0 ? void 0 : (ref = attributes.personal) === null || ref === void 0 ? void 0 : ref.is_deactivated;
    var isVerified = attributes === null || attributes === void 0 ? void 0 : (ref1 = attributes.personal) === null || ref1 === void 0 ? void 0 : ref1.is_verified;
    var verifiedStatus = attributes === null || attributes === void 0 ? void 0 : (ref2 = attributes.personal) === null || ref2 === void 0 ? void 0 : ref2.verified_status;
    var onClickChat = function() {
        onClick();
        var chatUrl = "";
        switch(type){
            case "ROOM_TYPE_BROADCAST":
                chatUrl = "broadcast-chat";
                break;
            case "ROOM_TYPE_GROUP":
                chatUrl = "group-chat";
                break;
            case "ROOM_TYPE_PERSONAL":
                chatUrl = "chat";
                break;
        }
        router.push("/".concat(chatUrl, "/").concat(id, "?source=").concat(constant/* SOURCE_CHAT_ROOM_VIEWED.findIndex */.VY.findIndex(function(x) {
            return x === "Inbox Chat";
        })));
    };
    var asteriskRemoved = (0,utils/* removeFormat */.Ir)(lastMessage);
    var isBroadcast = type === "ROOM_TYPE_BROADCAST";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageListContainer, {
        onClick: onClickChat,
        "data-cy": DATA_CY_NAME_MESSAGE_ITEM_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageItemAvatar, {
                isDeactive: isDeactivated,
                name: name,
                src: avatarUrl,
                shortName: shortName,
                type: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageItemBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageItem_Flex, {
                        align: "center",
                        justify: "space-between",
                        mb: "2px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageItem_Flex, {
                                align: "center",
                                width: "calc(100% - 100px)",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageItem_Text, {
                                        family: "bold",
                                        ellipsis: true,
                                        children: isDeactivated ? "Stockbit User" : name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: isVerified,
                                        verifiedStatus: verifiedStatus
                                    }),
                                    isBroadcast && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageItem_Flex, {
                                        ml: "4px",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelBroadcast/* default */.Z, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageItem_Text, {
                                size: "11px",
                                color: ui/* color.midgray */.$_.midgray,
                                elipsis: true,
                                children: (0,general/* convertTimeZone */.CB)(lastMessage.created_at, dataProfile.country)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageItemContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastMessagePreview/* default */.Z, {
                                message: asteriskRemoved,
                                showSenderUsername: showSenderUsername
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RoomItemStatus, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isMuted,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/muted-grey.svg",
                                            width: "16",
                                            height: "17",
                                            alt: "mentioned"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isMentioned,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/mention-green.svg",
                                            width: "16",
                                            height: "17",
                                            alt: "mentioned"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: unreadCount > 0 && !isMuted,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UnreadMessage, {
                                            children: unreadCount > 99 ? "99+" : unreadCount
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Message_MessageItem = (MessageItem);

;// CONCATENATED MODULE: ./src/global/Header/Message/MessageList.tsx








var MessageList_Text = ui/* Common.Text */.Gn.Text, MessageList_Flex = ui/* Common.Flex */.Gn.Flex;
var MessageList = function() {
    var rooms = (0,chat/* default */.Z)(function(store) {
        return store.rooms.default.list;
    });
    var fetchRooms = (0,chat/* default */.Z)(function(store) {
        return store.fetchDefaultRooms;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        fetchRooms({
            offset: 0,
            limit: 25
        });
    }, []);
    var markAsReadItem = function(id) {
        return function() {
            dispatch(chat_slice/* effects.readChat */.Sz.readChat(id));
        };
    };
    if (rooms.length > 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-cy": DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST,
            children: rooms.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageItem, {
                    item: item,
                    onClick: markAsReadItem(item.id)
                }, item.id);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageList_Flex, {
        align: "center",
        justify: "center",
        p: "15px 0",
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_MESSAGE_LIST_EMPTY,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageList_Text, {
            children: "No Recent Chat ..."
        })
    });
};
/* harmony default export */ var Message_MessageList = (MessageList);

;// CONCATENATED MODULE: ./src/global/Header/Message/MessageIcon.tsx








var MessageIcon_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, MessageIcon_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var MessageIcon = function(_param) /*#__PURE__*/ {
    var count = _param.count, props = (0,_object_without_properties/* default */.Z)(_param, [
        "count"
    ]);
    return (0,jsx_runtime.jsxs)(MessageIcon_IconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        size: "40px",
        "data-cy": DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageIcon_Iconmoon, {
                size: "30px",
                className: "icon-panel_chat"
            }),
            count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageCount, {
                children: count > 99 ? "99+" : count
            })
        ]
    }));
};
/* harmony default export */ var Message_MessageIcon = (MessageIcon);

;// CONCATENATED MODULE: ./src/global/Header/Message/Mobile.tsx











var Popover = ui/* Common.Popover */.Gn.Popover;
var Message_Mobile_Mobile = function() {
    var router = (0,next_router.useRouter)();
    var unreadCount = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return s.count;
    });
    var unreadRequest = (0,chat/* default */.Z)(function(s) {
        return s.rooms.default.unreadRequest;
    });
    // Event handlers
    var handleSeeAllClick = function() {
        router.push("".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV, "/chat"));
    };
    var Footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooter, {
        onClick: handleSeeAllClick,
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON,
        children: "See All in Chat"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover, {
        trigger: "click",
        placement: "bottom",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        overlayInnerStyle: {
            borderBottom: "unset"
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPopoverContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        borderBottom: "1px solid ".concat(ui/* color.gainsboro */.$_.gainsboro)
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageHeader, {
                            unreadRequest: unreadRequest
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentMobile, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageList, {})
                        }),
                        Footer
                    ]
                })
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageIcon, {
            count: unreadCount
        })
    });
};
/* harmony default export */ var Message_Mobile = (Message_Mobile_Mobile);

;// CONCATENATED MODULE: ./src/global/Header/Message/Web.tsx











var Web_Popover = ui/* Common.Popover */.Gn.Popover;
var Message_Web_Web = function() {
    var router = (0,next_router.useRouter)();
    var unreadCount = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return s.count;
    });
    var unreadRequest = (0,chat/* default */.Z)(function(s) {
        return s.rooms.default.unreadRequest;
    });
    // Event handlers
    var handleSeeAllClick = function() {
        router.push("".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV, "/chat"));
    };
    var Footer = /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverFooter, {
        onClick: handleSeeAllClick,
        "data-cy": DATA_CY_NAME_MESSAGE_HEADER_INBOX_CHAT_SEE_ALL_BUTTON,
        children: "See All in Chat"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Popover, {
                trigger: "click",
                placement: "bottomRight",
                overlayStyle: {
                    width: "400px",
                    border: "unset !important"
                },
                getPopupContainer: function() {
                    return document.getElementById("inbox-chat-popup");
                },
                content: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverWrapperWeb, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageHeader, {
                                unreadRequest: unreadRequest
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContentWeb, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageList, {})
                            }),
                            Footer
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_MessageIcon, {
                    count: unreadCount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverWeb, {
                id: "inbox-chat-popup"
            })
        ]
    });
};
/* harmony default export */ var Message_Web = (Message_Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/Message/index.jsx



;// CONCATENATED MODULE: ./src/global/Header/Notification/context.tsx


// @ts-ignore
var NotificationContext = /*#__PURE__*/ (0,react.createContext)();
var NotificationProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)("notification"), tab = ref[0], setTab = ref[1];
    var ref1 = (0,react.useState)(false), visible = ref1[0], setVisible = ref1[1];
    var ref2 = (0,react.useState)({
        visible: false,
        id: 0
    }), modalConvo = ref2[0], setModalConvo = ref2[1];
    var toggleNotification = function() {
        setVisible(!visible);
    };
    var closeNotification = function() {
        setVisible(false);
    };
    var changeTab = function(tabName) {
        setTab(tabName);
    };
    var showConvo = function(val) {
        setModalConvo(val);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationContext.Provider, {
        value: {
            tab: tab,
            visible: visible,
            modalConvo: modalConvo,
            changeTab: changeTab,
            toggleNotification: toggleNotification,
            closeNotification: closeNotification,
            showConvo: showConvo
        },
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/global/Header/Notification/styled.ts

function Notification_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 15px;\n  border-top: 1px solid ",
        ";\n  background: ",
        ";\n  :hover {\n    background: ",
        ";\n  }\n\n  @media ",
        " {\n    :last-child {\n      border-bottom: none;\n    }\n  }\n"
    ]);
    Notification_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 12px;\n  width: calc(100% - 20px);\n  & > p {\n    position: relative;\n    text-overflow: ellipsis;\n    word-wrap: break-word;\n    overflow: hidden;\n    line-height: 1.4em;\n    word-break: break-word;\n    width: 100%;\n  }\n"
    ]);
    Notification_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: none;\n  overflow-y: auto;\n  background: ",
        ";\n"
    ]);
    Notification_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    Notification_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 324px;\n"
    ]);
    Notification_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  margin-bottom: 13px;\n  margin-top: 15px;\n  width: 80%;\n\n  * {\n    border-collapse: collapse;\n  }\n\n  .ant-radio:hover .ant-radio-inner {\n    border-color: ",
        ";\n  }\n\n  .ant-radio-checked::after {\n    content: unset;\n  }\n\n  .ant-radio-input:focus + .ant-radio-inner {\n    box-shadow: unset;\n  }\n\n  .ant-radio-button-wrapper {\n    align-items: center;\n    border-width: 0.8px;\n    border-color: ",
        ";\n    color: ",
        ";\n    display: flex;\n    font-family: 'ProximaNovaRg', sans-serif;\n    font-size: 12px;\n    height: 28px;\n    justify-content: center;\n    width: calc(100% / 3);\n    padding: 0px 10px;\n\n    &:first-child {\n      border-top-left-radius: 2px;\n      border-bottom-left-radius: 2px;\n    }\n\n    &:last-child {\n      border-top-right-radius: 2px;\n      border-bottom-right-radius: 2px;\n    }\n  }\n\n  .ant-radio-button-wrapper + .ant-radio-button-wrapper {\n    margin-left: -1px;\n  }\n\n  .ant-radio-button-wrapper:hover {\n    color: unset;\n    background: unset;\n  }\n\n  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    color: ",
        ";\n    background: ",
        ";\n    border-color: ",
        " !important;\n    box-shadow: unset;\n  }\n\n  .ant-radio-button-wrapper:not(:first-child)::before {\n    content: unset;\n  }\n\n  span {\n    font-size: 14px;\n  }\n"
    ]);
    Notification_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  padding: 0px;\n  color: ",
        ";\n"
    ]);
    Notification_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: 7%;\n  left: 7%;\n  min-width: 18px;\n  height: 18px;\n  line-height: 18px;\n  padding: 0 2px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  font-size: 11px;\n  color: ",
        ";\n  text-align: center;\n  // TODO: Add color to @stockbit/ui\n  border: 1px solid #8f8f8f;\n"
    ]);
    Notification_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    background-color: transparent;\n    width: 18px;\n    height: 18px;\n    border: none;\n    border-radius: 0%;\n  }\n"
    ]);
    Notification_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Notification_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    left: -200px;\n    width: 30%;\n  }\n  50% {\n    width: 30%;\n  }\n  70% {\n    width: 70%;\n  }\n  80% {\n    left: 50%;\n  }\n  95% {\n    left: 120%;\n  }\n  to {\n    left: 100%;\n  }\n"
    ]);
    Notification_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  background-color: #dadada;\n  display: ",
        ";\n\n  :before {\n    display: block;\n    position: absolute;\n    content: '';\n    left: -200px;\n    width: 200px;\n    height: 1px;\n    background-color: #00ab6b;\n    animation: ",
        " 2s linear infinite;\n  }\n"
    ]);
    styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  background: #f2f1fe;\n  border-radius: 100%;\n\n  svg {\n    height: 16px;\n    width: 16px;\n    color: #8277f8;\n  }\n"
    ]);
    styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var Notification_styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_PopoverContent = ui/* Common.PopoverContent */.Gn.PopoverContent, Notification_styled_Button = ui/* Common.Button */.Gn.Button, Notification_styled_Avatar = ui/* Common.Avatar */.Gn.Avatar;
var Notification_styled_PopoverContainer = ui/* Header.PopoverContainer */.h4.PopoverContainer;
var RadioGroup = es_radio/* default.Group */.ZP.Group;
var NotifListContainer = (0,styled_components_browser_esm["default"])(Notification_styled_Flex).attrs(function(props) {
    return {
        isNew: props.isNew
    };
}).withConfig({
    componentId: "sc-b064d58-0"
})(Notification_styled_templateObject(), ui/* color.whisper */.$_.whisper, function(param) {
    var isNew = param.isNew;
    return isNew ? ui/* color.downgray */.$_.downgray : ui/* color.light */.$_.light;
}, ui/* color.downgray */.$_.downgray, ui/* device.tablet */.Uh.tablet);
var NotifListContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b064d58-1"
})(Notification_styled_templateObject1());
var styled_CustomPopoverContainer = (0,styled_components_browser_esm["default"])(Notification_styled_PopoverContainer).withConfig({
    componentId: "sc-b064d58-2"
})(Notification_styled_templateObject2(), ui/* color.light */.$_.light);
var styled_PopoverContentMobile = (0,styled_components_browser_esm["default"])(styled_PopoverContent).withConfig({
    componentId: "sc-b064d58-3"
})(Notification_styled_templateObject3(), ui/* color.gainsboro */.$_.gainsboro);
var styled_PopoverContentWeb = (0,styled_components_browser_esm["default"])(styled_PopoverContent).withConfig({
    componentId: "sc-b064d58-4"
})(Notification_styled_templateObject4());
var ButtonGroup = (0,styled_components_browser_esm["default"])(RadioGroup).attrs({
    optionType: "button"
}).withConfig({
    componentId: "sc-b064d58-5"
})(Notification_styled_templateObject5(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.lowgray */.$_.lowgray, ui/* color.midgray */.$_.midgray, ui/* color.primary */.$_.primary, ui/* color.light */.$_.light, ui/* color.primary */.$_.primary);
var CloseButton = (0,styled_components_browser_esm["default"])(Notification_styled_Button).withConfig({
    componentId: "sc-b064d58-6"
})(Notification_styled_templateObject6(), ui/* color.suvaGrey */.$_.suvaGrey);
var NotificationCount = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-b064d58-7"
})(Notification_styled_templateObject7(), ui/* color.primary */.$_.primary, ui/* color.light */.$_.light);
var IconContainer = (0,styled_components_browser_esm["default"])(Notification_styled_Avatar).withConfig({
    componentId: "sc-b064d58-8"
})(Notification_styled_templateObject8());
var LineAnimation = (0,styled_components_browser_esm.keyframes)(Notification_styled_templateObject9());
var LineLoader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b064d58-9"
})(styled_templateObject10(), function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "block" : "none";
}, LineAnimation);
var DayTradeWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b064d58-10"
})(styled_templateObject11());


;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationIcon.tsx





var NotificationIcon_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, NotificationIcon_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var NotificationIcon = function(iconProps) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationIcon_IconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
        size: "40px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationIcon_Iconmoon, {
                size: "30px",
                className: "icon-panel_notification"
            }),
            iconProps.count > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationCount, {
                children: iconProps.count > 99 ? "99+" : iconProps.count
            })
        ]
    }));
};
/* harmony default export */ var Notification_NotificationIcon = (NotificationIcon);

// EXTERNAL MODULE: ./src/utils/notification.ts
var notification = __webpack_require__(25178);
;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationTitle.tsx




var NotificationTitle_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, NotificationTitle_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, NotificationTitle_Text = ui/* Common.Text */.Gn.Text, NotificationTitle_Flex = ui/* Common.Flex */.Gn.Flex;
function NotificationTitle(param) {
    var tab = param.tab, onClickBack = param.onClickBack;
    var TAB = (0,general/* capitalizeFirstLetter */.fm)(tab);
    if (tab !== "notification") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationTitle_Flex, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitle_IconWrapper, {
                    margin: "0 0 0 -16px",
                    onClick: onClickBack,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitle_Iconmoon, {
                        size: "30px",
                        className: "icon-notification_back"
                    })
                }, "icon-notification_back"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitle_Text, {
                    family: "bold",
                    size: "16px",
                    "data-cy": "".concat(data_cy/* default.NOTIFICATION.TITLE_TEXT */.Z.NOTIFICATION.TITLE_TEXT, "-").concat(TAB),
                    children: TAB
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTitle_Text, {
        family: "bold",
        size: "16px",
        "data-cy": "".concat(data_cy/* default.NOTIFICATION.TITLE_TEXT */.Z.NOTIFICATION.TITLE_TEXT, "-Notification"),
        children: TAB
    });
}
/* harmony default export */ var Notification_NotificationTitle = (NotificationTitle);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationTab.tsx







var NotificationTab_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, NotificationTab_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
function NotificationTab(param) {
    var list = param.list, type = param.type;
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var changeTab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.changeTab;
    });
    var onClickTab = function(tabName) {
        return function() {
            changeTab(tabName);
        };
    };
    if (type === "text") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonGroup, {
            value: tab,
            children: list.map(function(param) {
                var name = param.name;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default.Button */.ZP.Button, {
                    value: name,
                    onClick: onClickTab(name),
                    checked: tab === name,
                    children: (0,general/* capitalizeFirstLetter */.fm)(name)
                }, "tab-".concat(tab));
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: list.map(function(param) {
            var className = param.className, name = param.name;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationTab_IconWrapper, {
                size: "30px",
                onClick: onClickTab(name),
                children: tab === name ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/notification/icon-".concat(name, "-active.svg")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/notification/icon-".concat(name, ".svg")
                })
            }, className);
        })
    });
}
/* harmony default export */ var Notification_NotificationTab = (NotificationTab);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationHeader.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 







var NotificationHeader_Flex = ui/* Common.Flex */.Gn.Flex, PopoverTitleWrapper = ui/* Common.PopoverTitleWrapper */.Gn.PopoverTitleWrapper, NotificationHeader_Text = ui/* Common.Text */.Gn.Text;
function NotificationHeader(param) {
    var device = param.device;
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var unread = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.unread;
    });
    var isLoading = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoading;
    });
    var closePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.closePopup;
    });
    var changeTab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.changeTab;
    });
    var markNotifAsRead = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.markNotifAsRead;
    });
    (0,react.useEffect)(function() {
        if (unread > 0) {
            markNotifAsRead(tab);
        }
    }, [
        unread
    ]);
    var isMobileDevice = device === "mobile";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineLoader, {
                isLoading: isLoading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverTitleWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationHeader_Flex, {
                        align: "center",
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationTitle, {
                                tab: tab,
                                onClickBack: function() {
                                    return changeTab("notification");
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationHeader_Text, {
                                mr: "20px",
                                style: {
                                    display: isLoading ? "block" : "none"
                                },
                                children: "Please Wait ..."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationHeader_Flex, {
                        children: [
                            !isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationTab, {
                                list: notification/* notificationTabsAttrs */.jg,
                                type: "icon"
                            }),
                            isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                                onClick: closePopup,
                                children: "Close"
                            })
                        ]
                    })
                ]
            }),
            isMobileDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationHeader_Flex, {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationTab, {
                    list: notification/* notificationTabsAttrs */.jg,
                    type: "text"
                })
            })
        ]
    });
}
/* harmony default export */ var Notification_NotificationHeader = (NotificationHeader);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationFooter.tsx



var NotificationFooter_Button = ui/* Common.Button */.Gn.Button, NotificationFooter_Text = ui/* Common.Text */.Gn.Text;
function NotificationFooter() {
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var lastId = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.contents[tab].lastId;
    });
    var total = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.contents[tab].list.length;
    });
    var isLoading = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoading;
    });
    var isLoadingPrevious = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoadingPrevious;
    });
    var getPrevNotification = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getPrevNotification;
    });
    var handlePrevClick = function() {
        getPrevNotification(tab, lastId);
    };
    if (isLoading && total === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationFooter_Button, {
        block: true,
        height: "36px",
        onClick: handlePrevClick,
        loading: isLoadingPrevious,
        children: !isLoadingPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationFooter_Text, {
            color: ui/* color.primary */.$_.primary,
            align: "center",
            children: "Load Previous"
        })
    });
}
/* harmony default export */ var Notification_NotificationFooter = (NotificationFooter);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationItemImage.tsx








var NotificationItemImage_Avatar = ui/* Common.Avatar */.Gn.Avatar, NotificationItemImage_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function NotificationItemImage(param) {
    var type = param.type, avatar = param.avatar;
    if (notification/* notificationTypesWithAvatar.includes */.UC.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomAvatar, {
            img: avatar,
            name: "avatar"
        });
    }
    if (notification/* notificationCategories.reports.includes */.In.reports.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemImage_Avatar, {
                size: "x-small",
                className: "panel-avatar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/notification/icon-report.svg"
                })
            })
        });
    }
    if (notification/* notificationCategories.tipping.includes */.In.tipping.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: avatar,
                width: "30",
                height: "30",
                alt: "tipping"
            })
        });
    }
    if (notification/* notificationCategories.tradingMatchOrder.includes */.In.tradingMatchOrder.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemImage_Avatar, {
            size: "small",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemImage_Iconmoon, {
                as: "a",
                size: "30px",
                className: "icon-avatar_order"
            })
        });
    }
    if (notification/* notificationCategories.trending.includes */.In.trending.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/notification-trending.svg",
            width: "30",
            height: "30",
            alt: "trending"
        });
    }
    if (notification/* notificationCategories.verified.includes */.In.verified.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/notification-approved.png",
            width: "30",
            height: "30",
            alt: "approved"
        });
    }
    if (notification/* notificationCategories.dayTrade.includes */.In.dayTrade.includes(type)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DayTradeWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                component: Icons/* LightningSvg */.Sf
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemImage_Avatar, {
        size: "small",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: "/icon/notification/icon-notif.svg"
        })
    });
}
/* harmony default export */ var Notification_NotificationItemImage = (NotificationItemImage);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationItemContent.tsx








var NotificationItemContent_Text = ui/* Common.Text */.Gn.Text, NotificationItemContent_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
function NotificationItemContent(param) {
    var isNew = param.isNew, type = param.type, avatar = param.avatar, mask = param.mask, message = param.message, created = param.created;
    var closePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.closePopup;
    });
    var content = (0,react.useMemo)(function() {
        var text = message;
        if (mask) {
            text = (0,notification/* parseNotificationMessage */.x8)({
                mask: mask,
                message: message,
                renderParseString: function(str) {
                    return str;
                },
                render: function(parsedText, tag) {
                    if (tag === "br") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {});
                    }
                    if (tag === "b") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: parsedText
                        });
                    }
                    if (!parsedText) {
                        return parsedText;
                    }
                    return parsedText;
                }
            });
        }
        return text;
    }, [
        message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotifListContainer, {
        isNew: isNew,
        onClick: closePopup,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemContent_IconWrapper, {
                size: "30px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItemImage, {
                    type: type,
                    avatar: avatar
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotifListContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemContent_Text, {
                        size: "13px",
                        children: content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationItemContent_Text, {
                        size: "11px",
                        color: ui/* color.midgray */.$_.midgray,
                        mt: "5px",
                        children: moment_default()(created).fromNow()
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Notification_NotificationItemContent = (NotificationItemContent);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationItem.tsx



function NotificationItem(param) {
    var item = param.item, onClickConversationNotif = param.onClickConversationNotif;
    var messageData = item.data;
    var type = item.type;
    var maskKey = "message_mask";
    var linkToKey = "link_to";
    var mask = messageData[maskKey] || [];
    var attrs = {
        href: "",
        onClick: null
    };
    var message = (messageData === null || messageData === void 0 ? void 0 : messageData.message) || "";
    switch(type){
        case "NOTIF_TYPE_MENTIONS":
        case "NOTIF_TYPE_NEW_REPORT":
        case "NOTIF_TYPE_LIKE":
        case "NOTIF_TYPE_STREAMS_UPDATE":
        case "NOTIF_TYPE_POSTALERT":
        case "NOTIF_TYPE_SAVE":
        case "NOTIF_TYPE_RETWEET":
        case "NOTIF_TYPE_NEWSFEED":
        case "NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE":
        case "NOTIF_TYPE_COMPANY_SHAREHOLDING":
        case "NOTIF_TYPE_COMPANY_DIVIDEND":
        case "NOTIF_TYPE_COMPANY_CORP_ACTION":
        case "NOTIF_TYPE_COMPANY_OTHERS":
            attrs.href = "/post/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_REPLY":
            attrs.onClick = function() {
                return onClickConversationNotif({
                    visible: true,
                    id: messageData[linkToKey].value
                });
            };
            break;
        case "NOTIF_TYPE_FOLLOWING":
            attrs.href = "/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_TIPPING_RECEIVER":
        case "NOTIF_TYPE_TIPPING_SENDER":
        case "NOTIF_TYPE_CLAIM":
            attrs.href = "/tip/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_TRADING_MATCH_ORDER":
            attrs.href = "/trade/portofolio/";
            break;
        case "NOTIF_TYPE_TRADING_COMMUNITY":
            attrs.href = "/community/?search=".concat(messageData[linkToKey].value);
            if (!mask || mask.length <= 0) {
                message = "[%username-mask%] ".concat(message);
                mask = [
                    {
                        key: "username-mask",
                        payload: {
                            actors: [],
                            id: 0,
                            tag: "PAYLOAD_MASK_TAG_BOLD",
                            text: messageData[linkToKey].value,
                            type: "PAYLOAD_MASK_TYPE_USER"
                        }
                    }, 
                ];
            }
            break;
        case "NOTIF_TYPE_NEW_TRENDING":
            attrs.href = "/symbol/".concat(messageData[linkToKey].value);
            break;
        case "NOTIF_TYPE_SECURITIES_DAY_TRADE":
        case "NOTIF_TYPE_SHARIA_STOCK_DELISTED":
            attrs.href = "/securities/portfolio";
            break;
        default:
            // NOTIF_TYPE_STOCK_ALERT => Cannot Clicked
            attrs.href = "";
            break;
    }
    if (attrs.href !== "") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: attrs === null || attrs === void 0 ? void 0 : attrs.href,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItemContent, {
                    isNew: !item.is_read,
                    avatar: messageData === null || messageData === void 0 ? void 0 : messageData.avatar,
                    created: item === null || item === void 0 ? void 0 : item.created,
                    message: message,
                    mask: mask,
                    type: item === null || item === void 0 ? void 0 : item.type
                })
            })
        });
    }
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: attrs.onClick,
        role: "menuitem",
        tabIndex: -1,
        style: {
            cursor: attrs.onClick !== null ? "pointer" : "unset"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItemContent, {
            isNew: !item.is_read,
            avatar: messageData === null || messageData === void 0 ? void 0 : messageData.avatar,
            created: item === null || item === void 0 ? void 0 : item.created,
            message: message,
            mask: mask,
            type: item === null || item === void 0 ? void 0 : item.type
        })
    }));
}
/* harmony default export */ var Notification_NotificationItem = (NotificationItem);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationList.tsx





var NotificationList_Flex = ui/* Common.Flex */.Gn.Flex, NotificationList_Text = ui/* Common.Text */.Gn.Text;
function NotificationList() {
    var isLoading = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isLoading;
    });
    var tab = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.tab;
    });
    var displayedList = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.contents[tab].list;
    });
    var closePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.closePopup;
    });
    var setConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.setConvoOpen;
    });
    var getNotification = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getNotification;
    });
    var markNotifAsRead = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.markNotifAsRead;
    });
    (0,react.useEffect)(function() {
        getNotification(tab);
        markNotifAsRead(tab);
    }, [
        tab
    ]);
    if (displayedList.length === 0 && !isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationList_Flex, {
            align: "center",
            justify: "center",
            height: "60px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationList_Text, {
                color: ui/* color.highgray */.$_.highgray,
                children: "You do not have any notification right now"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: displayedList.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationItem, {
                item: item,
                onClickConversationNotif: function(param) {
                    var id = param.id, visible = param.visible;
                    setConvoOpen(id, visible);
                    closePopup();
                }
            }, "".concat(tab, "-").concat(item.id, "-").concat(displayedList.length));
        })
    });
}
/* harmony default export */ var Notification_NotificationList = (/*#__PURE__*/react.memo(NotificationList));

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationMobile.tsx









var StreamConversation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7570), __webpack_require__.e(3828), __webpack_require__.e(3304), __webpack_require__.e(7081), __webpack_require__.e(7713), __webpack_require__.e(1767), __webpack_require__.e(7333), __webpack_require__.e(5406), __webpack_require__.e(5616), __webpack_require__.e(6041), __webpack_require__.e(1232), __webpack_require__.e(1066), __webpack_require__.e(2857), __webpack_require__.e(2826)]).then(__webpack_require__.bind(__webpack_require__, 72857));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72857)
            ];
        }
    },
    ssr: false
});
var NotificationMobile_Popover = ui/* Common.Popover */.Gn.Popover;
var NotificationMobile = function() {
    var unread = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.unread;
    });
    var isConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isConvoOpen;
    });
    var isPopupOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isPopupOpen;
    });
    var convoId = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.convoId;
    });
    var togglePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.togglePopup;
    });
    var setConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.setConvoOpen;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationMobile_Popover, {
                trigger: "click",
                visible: isPopupOpen,
                onVisibleChange: togglePopup,
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                content: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_CustomPopoverContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationHeader, {
                                device: "mobile"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_PopoverContentMobile, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationList, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationFooter, {})
                        ]
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationIcon, {
                    count: unread,
                    "data-cy": "top-navbar-icon-notification-mobile"
                })
            }),
            isConvoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamConversation, {
                postId: convoId,
                visible: isConvoOpen,
                activeCommentId: convoId,
                onCancel: function() {
                    return setConvoOpen(undefined, false);
                }
            })
        ]
    });
};
/* harmony default export */ var Notification_NotificationMobile = (NotificationMobile);

;// CONCATENATED MODULE: ./src/global/Header/Notification/Mobile.tsx



var Notification_Mobile_Mobile = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationMobile, {})
    });
};
/* harmony default export */ var Notification_Mobile = (Notification_Mobile_Mobile);

;// CONCATENATED MODULE: ./src/global/Header/Notification/NotificationWeb.tsx









var NotificationWeb_StreamConversation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7570), __webpack_require__.e(3828), __webpack_require__.e(3304), __webpack_require__.e(7081), __webpack_require__.e(7713), __webpack_require__.e(1767), __webpack_require__.e(7333), __webpack_require__.e(5406), __webpack_require__.e(5616), __webpack_require__.e(6041), __webpack_require__.e(1232), __webpack_require__.e(1066), __webpack_require__.e(2857), __webpack_require__.e(2826)]).then(__webpack_require__.bind(__webpack_require__, 72857));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72857)
            ];
        }
    },
    ssr: false
});
var NotificationWeb_Popover = ui/* Common.Popover */.Gn.Popover, PopoverContentWrapper = ui/* Common.PopoverContentWrapper */.Gn.PopoverContentWrapper;
function NotificationWeb() {
    var unread = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.unread;
    });
    var isConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isConvoOpen;
    });
    var isPopupOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.isPopupOpen;
    });
    var convoId = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.convoId;
    });
    var togglePopup = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.togglePopup;
    });
    var setConvoOpen = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.setConvoOpen;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationWeb_Popover, {
                trigger: "click",
                placement: "bottomRight",
                overlayStyle: {
                    width: "400px"
                },
                visible: isPopupOpen,
                onVisibleChange: togglePopup,
                getPopupContainer: function(trigger) {
                    return trigger.parentElement;
                },
                content: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverContentWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationHeader, {
                                device: "web"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_PopoverContentWeb, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationList, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationFooter, {})
                        ]
                    });
                },
                destroyTooltipOnHide: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationIcon, {
                    count: unread,
                    "data-cy": "top-navbar-icon-notification-desktop"
                })
            }),
            isConvoOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationWeb_StreamConversation, {
                postId: convoId,
                visible: isConvoOpen,
                activeCommentId: convoId,
                onCancel: function() {
                    return setConvoOpen(undefined, false);
                }
            })
        ]
    });
}
/* harmony default export */ var Notification_NotificationWeb = (NotificationWeb);

;// CONCATENATED MODULE: ./src/global/Header/Notification/Web.tsx



function Notification_Web_Web() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_NotificationWeb, {})
    });
}
/* harmony default export */ var Notification_Web = (Notification_Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/Notification/index.tsx



;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/IconProfile.jsx







var IconProfile_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var IconProfile = function(_param) /*#__PURE__*/ {
    var img = _param.img, name = _param.name, iconProps = (0,_object_without_properties/* default */.Z)(_param, [
        "img",
        "name"
    ]);
    return (0,jsx_runtime.jsx)(IconProfile_IconWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconProps), {
        size: "40px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomAvatar, {
            img: img,
            name: name
        })
    }));
};
IconProfile.propTypes = {
    img: (prop_types_default()).string.isRequired,
    name: (prop_types_default()).string.isRequired
};
/* harmony default export */ var ProfileMenu_IconProfile = (IconProfile);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/MenuProfileTitle.jsx



var MenuProfileTitle_Text = ui/* Common.Text */.Gn.Text, MenuProfileTitle_PopoverTitleWrapper = ui/* Common.PopoverTitleWrapper */.Gn.PopoverTitleWrapper;
var MenuProfileTitle = function(param) {
    var name = param.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuProfileTitle_PopoverTitleWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuProfileTitle_Text, {
            family: "bold",
            size: "16px",
            color: "#000000A6",
            children: name
        })
    });
};
MenuProfileTitle.propTypes = {
    name: (prop_types_default()).string
};
MenuProfileTitle.defaultProps = {
    name: ""
};
/* harmony default export */ var ProfileMenu_MenuProfileTitle = (MenuProfileTitle);

// EXTERNAL MODULE: ./node_modules/js-base64/base64.mjs
var js_base64_base64 = __webpack_require__(52300);
;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/styled.js

function ProfileMenu_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: unset;\n  border: none;\n  background-color: white;\n"
    ]);
    ProfileMenu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileMenu_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 100%;\n"
    ]);
    ProfileMenu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProfileMenu_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 34px;\n  height: 16px;\n  padding: 3px 4px 3px 4px;\n  border-radius: 4px;\n  gap: 10px;\n  border: 1px solid rgba(0, 171, 107, 1);\n  color: rgba(0, 171, 107, 1);\n  font-size: 11px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    ProfileMenu_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProfileMenu_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  padding: 0 10px;\n  cursor: pointer;\n  color: #969696;\n  & > p {\n    padding-left: 8px;\n  }\n\n  @media ",
        " {\n    & > p {\n      padding-left: 0;\n    }\n  }\n\n  :hover {\n    color: #00ab6b;\n    background: ",
        ";\n    p,\n    p::before {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    ProfileMenu_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProfileMenu_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  padding: 8px 0;\n  :last-child {\n    border-bottom: none;\n    padding-bottom: 4px;\n    padding-top: 2px;\n  }\n"
    ]);
    ProfileMenu_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProfileMenu_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 30px;\n  width: 30px;\n  align-items: center;\n  justify-content: center;\n  img {\n    height: 18px;\n    width: 18px;\n  }\n"
    ]);
    ProfileMenu_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ProfileMenu_styled_Flex = ui/* Common.Flex */.Gn.Flex, ProfileMenu_styled_PopoverContent = ui/* Common.PopoverContent */.Gn.PopoverContent;
var ProfileMenu_styled_PopoverContainer = ui/* Header.PopoverContainer */.h4.PopoverContainer;
var ProfileMenu_styled_CustomPopoverContainer = (0,styled_components_browser_esm["default"])(ProfileMenu_styled_PopoverContainer).withConfig({
    componentId: "sc-17c9f734-0"
})(ProfileMenu_styled_templateObject());
var ProfileMenu_styled_PopoverContentMobile = (0,styled_components_browser_esm["default"])(ProfileMenu_styled_PopoverContent).withConfig({
    componentId: "sc-17c9f734-1"
})(ProfileMenu_styled_templateObject1());
var NewTag = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-17c9f734-2"
})(ProfileMenu_styled_templateObject2());
var MenuList = (0,styled_components_browser_esm["default"])(ProfileMenu_styled_Flex).withConfig({
    componentId: "sc-17c9f734-3"
})(ProfileMenu_styled_templateObject3(), ui/* device.tablet */.Uh.tablet, ui/* color.downgray */.$_.downgray, ui/* color.primary */.$_.primary);
var MenuListContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-17c9f734-4"
})(ProfileMenu_styled_templateObject4(), ui/* color.lowgray */.$_.lowgray);
var ImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-17c9f734-5"
})(ProfileMenu_styled_templateObject5());


// EXTERNAL MODULE: ./src/features/community/analytics.ts
var analytics = __webpack_require__(20826);
;// CONCATENATED MODULE: ./src/utils/user.jsx









var user_Flex = ui/* Common.Flex */.Gn.Flex;
// helpers
var encodeBase64FromJS = function(object) {
    var result = object;
    if (typeof object === "object") {
        result = JSON.stringify(object);
    }
    return js_base64_base64/* Base64.encode */.DS.encode(result);
};
var decodeBase64ToJS = function(base64) {
    var decoded = js_base64_base64/* Base64.decode */.DS.decode(base64);
    var result = decoded;
    try {
        result = JSON.parse(decoded);
    } catch (e) {
        result = decoded;
    }
    return result;
};
// local storage utils
var saveObject = function(key, object) {
    window.localStorage.setItem("location", window.location.origin);
    window.localStorage.setItem(key, encodeBase64FromJS(object));
};
// Save user credentials to local storage
var setLocalUser = function(accessUser) {
    return saveObject("au", accessUser);
};
var setLocalAccess = function(accessToken) {
    return saveObject("at", accessToken);
};
var setLocalAccessExp = function(accessTokenExp) {
    return saveObject("ate", accessTokenExp);
};
var setLocalRefresh = function(refreshToken) {
    return saveObject("ar", refreshToken);
};
var setLocalRefreshExp = function(refreshTokenExp) {
    return saveObject("are", refreshTokenExp);
};
var setLocalChatToken = function(wsToken) {
    return saveObject("wst", wsToken);
};
var setLocalIntercomSettings = function(intercom) {
    return saveObject("icom", intercom);
};
var setLocalCrispSettings = function(crisp) {
    return saveObject("crisp", crisp);
};
var setLocalTempUserKey = function(tempUserKey) {
    return saveObject("tmpkey", tempUserKey);
};
var pageSourceIndex = ProfileAnalytics/* PAGE_SOURCE_INDEX.findIndex */.en.findIndex(function(sourceIndex) {
    return sourceIndex === "My Profile";
});
var getOS = function() {
    if (!(0,app/* isClient */.C5)()) {
        return "others";
    }
    var userAgent = navigator.userAgent;
    if (/Windows/.test(userAgent)) {
        return "Windows";
    }
    if (/Mac OS|Macintosh/.test(userAgent)) {
        return "macOS";
    }
    return "others";
};
// Build user profile menu
var profileMenu = function(data) {
    if (!data) {
        return [];
    }
    var proText = data.ispro ? "Extend PRO Subscription" : "Upgrade to PRO";
    // Countries that will not implement pro features
    var noProCountries = [
        "MY",
        "SG"
    ];
    // Countries that will implement some features
    var implementCountries = [
        "ID"
    ];
    var isTipJarMenuItemAvailable = implementCountries.some(function(country) {
        return data.country === country;
    });
    var isProAvailable = !noProCountries.some(function(country) {
        return data.country === country;
    });
    var tipJarMenuItem = isTipJarMenuItemAvailable ? [
        {
            label: "My Tip Jar",
            logo: "icon-setting_tipjar",
            url: "/tipjar"
        }
    ] : [];
    var communityItem = data.isCommunityAccessGranted && data.country === "ID" ? [
        {
            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(user_Flex, {
                align: "center",
                style: {
                    gap: 5
                },
                onClick: function() {
                    analytics/* affiliateActions.externalCommunitySelected */.d.externalCommunitySelected();
                },
                children: [
                    "External Community ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewTag, {
                        children: "New"
                    })
                ]
            }),
            url: "/community",
            logo: "icon-community"
        }, 
    ] : [];
    var menuItemGroup1 = [
        {
            label: "My Profile",
            logo: "icon-menu_profile",
            url: "/".concat(data.username, "?source=").concat(pageSourceIndex)
        },
        {
            label: "Settings",
            logo: "icon-menu_setting",
            url: "/profile/edit"
        }, 
    ].concat((0,_to_consumable_array/* default */.Z)(communityItem), (0,_to_consumable_array/* default */.Z)(tipJarMenuItem));
    var proItems = [
        {
            label: proText,
            logo: "icon-setting_subscribe",
            url: "/shop"
        }, 
    ];
    var menuItemGroup2 = isProAvailable ? proItems : undefined;
    var menuItemGroup3 = [
        {
            label: "Rules",
            logo: "icon-setting_rules",
            url: "/rules"
        },
        {
            label: "Help",
            logo: "icon-setting_help",
            url: "https://help.stockbit.com"
        },
        {
            label: "Live Support",
            logo: "icon-setting_support",
            url: "",
            onClick: function(e) {
                e.preventDefault();
                (0,crisp/* handleClickSupport */.lA)();
            }
        },
        {
            label: "Logout",
            logo: "icon-setting_logout",
            url: "/logout"
        }, 
    ];
    var menuDownload = [
        {
            type: "download",
            label: "Download Desktop App",
            image: "/images/download-icon.svg",
            textColor: ui/* color.primary */.$_.primary,
            url: "",
            onClick: function(e) {
                e.preventDefault();
            }
        }, 
    ];
    return [
        menuItemGroup1,
        menuItemGroup2,
        menuItemGroup3,
        menuDownload
    ].filter(function(menuItemGroup) {
        return menuItemGroup !== undefined;
    });
};
/* harmony default export */ var user = ({
    setLocalUser: setLocalUser,
    setLocalAccess: setLocalAccess,
    setLocalAccessExp: setLocalAccessExp,
    setLocalRefresh: setLocalRefresh,
    setLocalRefreshExp: setLocalRefreshExp,
    setLocalChatToken: setLocalChatToken,
    setLocalIntercomSettings: setLocalIntercomSettings,
    setLocalCrispSettings: setLocalCrispSettings,
    setLocalTempUserKey: setLocalTempUserKey,
    encodeBase64FromJS: encodeBase64FromJS,
    decodeBase64ToJS: decodeBase64ToJS,
    profileMenu: profileMenu,
    getOS: getOS
});

// EXTERNAL MODULE: ./src/hooks/useDownloadDesktopApp.ts
var useDownloadDesktopApp = __webpack_require__(85557);
// EXTERNAL MODULE: ./src/features/download/desktop-analytics.ts
var desktop_analytics = __webpack_require__(53400);
;// CONCATENATED MODULE: ./src/assets/customIcon/IconMenuProfile.tsx


function IconMenuProfile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 9.875H6.08333C4.79417 9.875 3.75 10.9192 3.75 12.2083V13.375C3.75 14.0167 4.275 14.5417 4.91667 14.5417H13.0833C13.725 14.5417 14.25 14.0167 14.25 13.375V12.2083C14.25 10.9192 13.2058 9.875 11.9167 9.875H9Z",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 8.12501C10.2887 8.12501 11.3333 7.08034 11.3333 5.79168C11.3333 4.50301 10.2887 3.45834 9 3.45834C7.71133 3.45834 6.66666 4.50301 6.66666 5.79168C6.66666 7.08034 7.71133 8.12501 9 8.12501Z",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingSubscribe.tsx


function IconSettingSubsribe() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.0749 6.24086C14.0749 7.85086 12.7682 9.15752 11.1582 9.15752C9.54823 9.15752 8.24156 7.85086 8.24156 6.24086C8.24156 4.63085 9.54823 3.32419 11.1582 3.32419C12.7682 3.32419 14.0749 4.63085 14.0749 6.24086Z",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.09323 8.30017L3.5749 13.8243",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M4.52567 12.8677L5.354 13.6961",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.76823 11.6309L6.59073 12.4534",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingRules.tsx


function IconSettingRules() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_652_327)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 14.833C12.2217 14.833 14.8333 12.2214 14.8333 8.99972C14.8333 5.77805 12.2217 3.16638 9 3.16638C5.77834 3.16638 3.16666 5.77805 3.16666 8.99972C3.16666 12.2214 5.77834 14.833 9 14.833Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.99992 7.54108V11.6244",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7.83326 11.6244H10.1666",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.4166 7.54108H8.99993",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.83743 6.08275C8.83743 6.08156 8.83779 6.07891 8.83898 6.07608C8.84001 6.07365 8.84124 6.07204 8.84231 6.07097C8.84338 6.0699 8.84499 6.06867 8.84742 6.06764C8.85025 6.06645 8.8529 6.06609 8.85409 6.06609C8.85529 6.06609 8.85794 6.06645 8.86076 6.06764C8.86319 6.06867 8.86481 6.0699 8.86588 6.07097C8.86695 6.07204 8.86818 6.07365 8.8692 6.07608C8.8704 6.07891 8.87076 6.08156 8.87076 6.08275C8.87076 6.08395 8.8704 6.0866 8.8692 6.08943C8.86818 6.09185 8.86695 6.09347 8.86588 6.09454C8.86481 6.09561 8.86319 6.09684 8.86076 6.09786C8.85794 6.09906 8.85529 6.09942 8.85409 6.09942C8.8529 6.09942 8.85025 6.09906 8.84742 6.09786C8.84499 6.09684 8.84338 6.09561 8.84231 6.09454C8.84124 6.09347 8.84001 6.09185 8.83898 6.08943C8.83779 6.0866 8.83743 6.08395 8.83743 6.08275Z",
                        fill: "currentColor",
                        stroke: "currentColor",
                        "stroke-width": "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_327",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingSupport.tsx


function IconSettingSupport() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_652_347)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.36833 7.25001C4.65417 4.94584 6.62 3.16667 9 3.16667C10.2892 3.16667 11.4558 3.69167 12.3017 4.53167C13.0133 5.24917 13.4975 6.19417 13.6317 7.25001",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.1667 13.515C11.6051 13.1464 12.7785 12.1085 13.3281 10.7522",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.75 7.25H4.91667V10.75H3.75C3.10834 10.75 2.58334 10.225 2.58334 9.58333V8.41667C2.58334 7.775 3.10834 7.25 3.75 7.25Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.25 10.75H13.0833V7.25H14.25C14.8917 7.25 15.4167 7.775 15.4167 8.41667V9.58333C15.4167 10.225 14.8917 10.75 14.25 10.75Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.125 13.3917H9.875C10.0269 13.3917 10.15 13.5148 10.15 13.6667C10.15 13.8185 10.0269 13.9417 9.875 13.9417H8.125C7.97312 13.9417 7.85 13.8185 7.85 13.6667C7.85 13.5148 7.97312 13.3917 8.125 13.3917Z",
                        fill: "#333333",
                        stroke: "currentColor",
                        "stroke-width": "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_347",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingLogout.tsx


function IconSettingLogout() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.1667 14.8336H4.91667C4.59584 14.8336 4.33334 14.5711 4.33334 14.2503V3.75028C4.33334 3.42945 4.59584 3.16695 4.91667 3.16695H10.1667",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M7.83334 9.00029H14.8333",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 6.20029L14.8333 9.00029L12.5 11.8003",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconMenuSetting.tsx


function IconMenuSetting() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_652_290)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 11.333C10.2887 11.333 11.3333 10.2884 11.3333 8.99972C11.3333 7.71105 10.2887 6.66638 9 6.66638C7.71133 6.66638 6.66666 7.71105 6.66666 8.99972C6.66666 10.2884 7.71133 11.333 9 11.333Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.5855 9.43528L14.4695 10.3193C14.666 10.5158 14.709 10.8227 14.5678 11.0622L13.5671 12.7934C13.4259 13.0329 13.1435 13.1495 12.8795 13.082L11.6762 12.7627C11.3508 12.6768 11.0132 12.8671 10.9272 13.1986L10.608 14.4019C10.5343 14.672 10.2949 14.8562 10.0125 14.8562H8.01107C7.7348 14.8562 7.48924 14.672 7.41557 14.4019L7.09633 13.1986C7.01038 12.8732 6.67272 12.6768 6.34734 12.7627L5.14405 13.082C4.87393 13.1556 4.59152 13.039 4.45646 12.7934L3.45577 11.0622C3.31456 10.8227 3.35754 10.5158 3.55399 10.3193L4.43804 9.43528C4.67747 9.19585 4.67747 8.80908 4.43804 8.56965L3.55399 7.6856C3.35754 7.48914 3.31456 7.18218 3.45577 6.94275L4.45646 5.21149C4.59766 4.97206 4.88007 4.85542 5.14405 4.92295L6.34734 5.24219C6.67272 5.32814 7.01038 5.13782 7.09633 4.8063L7.41557 3.60301C7.48924 3.33289 7.72867 3.14871 8.01107 3.14871H10.0125C10.2887 3.14871 10.5343 3.33289 10.608 3.60301L10.9272 4.8063C11.0132 5.13168 11.3508 5.32814 11.6762 5.24219L12.8795 4.92295C13.1496 4.84928 13.432 4.96592 13.5671 5.21149L14.5678 6.94275C14.709 7.18218 14.666 7.48914 14.4695 7.6856L13.5855 8.56965C13.3461 8.80908 13.3461 9.19585 13.5855 9.43528Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_290",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingTipjar.tsx


function IconSettingTipjar() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.5 14.8336H5.5C4.85834 14.8336 4.33334 14.3086 4.33334 13.6669V9.19856C4.33334 8.69106 4.49667 8.20106 4.8 7.79856L6.08334 6.0894V4.92273H5.49417C5.17334 4.92273 4.91667 4.6544 4.91667 4.33356V3.75606C4.91667 3.43523 5.17917 3.17273 5.5 3.17273H12.5C12.8208 3.17273 13.0833 3.43523 13.0833 3.75606V4.33356C13.0833 4.6544 12.8267 4.9169 12.5058 4.9169H11.9167V6.0894L13.2 7.79856C13.5033 8.20106 13.6667 8.69106 13.6667 9.19856V13.6669C13.6667 14.3086 13.1417 14.8336 12.5 14.8336Z",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.08334 4.91666H11.9167",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9 7.83334V12.5",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.4583 8.41666H8.41666C7.9325 8.41666 7.54166 8.80749 7.54166 9.29166C7.54166 9.77582 7.9325 10.1667 8.41666 10.1667H9.58333C10.0675 10.1667 10.4583 10.5575 10.4583 11.0417C10.4583 11.5258 10.0675 11.9167 9.58333 11.9167H7.54166",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconCommunity.tsx


function IconCommunity() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.66666 12.5003L4.33333 14.2503V12.5003H4.32166C3.68 12.5003 3.16666 11.9753 3.16666 11.3336V5.50028C3.16666 4.85862 3.69166 4.33362 4.33333 4.33362H13.6667C14.3083 4.33362 14.8333 4.85862 14.8333 5.50028V9.00029",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 10.5575H9.39084C8.53334 10.5575 7.83334 11.2516 7.83334 12.115V12.8908C7.83334 13.3225 8.18334 13.6666 8.60917 13.6666H14.0517C14.4833 13.6666 14.8275 13.3166 14.8275 12.8908V12.115C14.8275 11.2575 14.1333 10.5575 13.27 10.5575H11.3275H11.3333Z",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 9.39079C12.1935 9.39079 12.8908 8.69347 12.8908 7.83329C12.8908 6.9731 12.1935 6.27579 11.3333 6.27579C10.4731 6.27579 9.77583 6.9731 9.77583 7.83329C9.77583 8.69347 10.4731 9.39079 11.3333 9.39079Z",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.41666 9.00027L6.66666 7.25027",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3333 10.5581V11.9173",
                stroke: "currentColor",
                "stroke-width": "1.2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/IconSettingHelp.tsx


function IconSettingHelp() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                "clip-path": "url(#clip0_652_337)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 14.8333C12.2217 14.8333 14.8333 12.2217 14.8333 8.99999C14.8333 5.77833 12.2217 3.16666 9 3.16666C5.77834 3.16666 3.16666 5.77833 3.16666 8.99999C3.16666 12.2217 5.77834 14.8333 9 14.8333Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9 11.9167C10.6108 11.9167 11.9167 10.6108 11.9167 9.00001C11.9167 7.38918 10.6108 6.08334 9 6.08334C7.38917 6.08334 6.08334 7.38918 6.08334 9.00001C6.08334 10.6108 7.38917 11.9167 9 11.9167Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.1242 4.87564L11.065 6.93481",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.87583 4.87564L6.935 6.93481",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.87583 13.1242L6.935 11.065",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.1242 13.1242L11.065 11.065",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_652_337",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "14",
                        height: "14",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/ProfileMenuReactNode.jsx




















var ProfileMenuReactNode_Text = ui/* Common.Text */.Gn.Text, ProfileMenuReactNode_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var MenuListWithRef = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var href = param.href, onClick = param.onClick, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        onClick: onClick,
        ref: ref,
        children: children
    });
});
MenuListWithRef.propTypes = {
    href: (prop_types_default()).string,
    onClick: (prop_types_default()).func.isRequired,
    children: (prop_types_default()).node.isRequired
};
MenuListWithRef.defaultProps = {
    href: ""
};
var ProfileMenuReactNode = function(data) {
    var download = (0,useDownloadDesktopApp/* default */.Z)().download;
    var router = (0,next_router.useRouter)();
    var getStyleMenuList = function(index) {
        if (index === 3) return {
            borderBottom: "none"
        };
        return {};
    };
    var onClickItem = function(e, item) {
        if (item.type === "download") {
            e.preventDefault();
            var os = user.getOS();
            var analyticOS = os === "macOS" ? "Mac" : os;
            if (os === "macOS" || os === "Windows") {
                desktop_analytics/* DesktopAppDownloadAnalytics.onDownloadDesktopApp */.E.onDownloadDesktopApp({
                    os: analyticOS,
                    source: "Dropdown Profile"
                });
                download(os.toLowerCase());
                var el = document.getElementById("icon-profile-popover");
                el.click();
            } else {
                router.push("/desktop");
            }
        } else if (item.onClick) item.onClick(e);
    };
    var getSystemRequirementWording = function() {
        var os = user.getOS();
        if (os === "macOS") return "For MacOS 12 or above";
        if (os === "Windows") return "For Windows 10 or above";
        return "";
    };
    var renderIcon = function(logo) {
        switch(logo){
            case "icon-menu_profile":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenuProfile, {});
            case "icon-menu_setting":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenuSetting, {});
            case "icon-setting_tipjar":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingTipjar, {});
            case "icon-community":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCommunity, {});
            case "icon-setting_subscribe":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingSubsribe, {});
            case "icon-setting_rules":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingRules, {});
            case "icon-setting_help":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingHelp, {});
            case "icon-setting_support":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingSupport, {});
            case "icon-setting_logout":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconSettingLogout, {});
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenuProfile, {});
        }
    };
    return user.profileMenu(data).map(function(menu, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListContainer, {
            style: getStyleMenuList(index),
            children: menu.map(function(item) {
                var label = item.label, logo = item.logo, url = item.url, image = item.image, textColor = item.textColor;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: url,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuListWithRef, {
                        href: url,
                        onClick: function(e) {
                            onClickItem(e, item);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList, {
                            children: [
                                logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenuReactNode_IconWrapper, {
                                    size: "30px",
                                    children: renderIcon(logo)
                                }),
                                image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        alt: "",
                                        src: image
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenuReactNode_Text, {
                                            size: "14px",
                                            color: textColor || ui/* color.highempahis */.$_.highempahis,
                                            children: label
                                        }),
                                        item.type === "download" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                color: "#858585",
                                                fontSize: 11
                                            },
                                            children: getSystemRequirementWording()
                                        })
                                    ]
                                })
                            ]
                        }, label)
                    })
                }, label);
            })
        }, "menu-list-".concat(index + 1));
    });
};
/* harmony default export */ var ProfileMenu_ProfileMenuReactNode = (ProfileMenuReactNode);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/Mobile.jsx











var Mobile_PopoverMobile = ui/* Header.PopoverCustom */.h4.PopoverCustom;
var ProfileMenu_Mobile_Mobile = function() {
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var remisier = (0,useUIConfigStore/* default */.Z)(function(store) {
        return store.getUIValue("remisier");
    });
    var adjustedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        isCommunityAccessGranted: remisier === null || remisier === void 0 ? void 0 : remisier.isCommunityAccessGranted
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile_PopoverMobile, {
        componentTrigger: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_IconProfile, {
                img: data.avatar,
                name: data.username,
                "data-cy": "top-navbar-icon-profile-mobile"
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileMenu_styled_CustomPopoverContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_MenuProfileTitle, {
                    name: data.username
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_styled_PopoverContentMobile, {
                    children: ProfileMenu_ProfileMenuReactNode(adjustedData)
                })
            ]
        })
    });
};
/* harmony default export */ var ProfileMenu_Mobile = (ProfileMenu_Mobile_Mobile);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/Web.jsx










var ProfileMenu_Web_Popover = ui/* Common.Popover */.Gn.Popover, Web_PopoverContent = ui/* Common.PopoverContent */.Gn.PopoverContent, Web_PopoverContentWrapper = ui/* Common.PopoverContentWrapper */.Gn.PopoverContentWrapper;
var ProfileMenu_Web_Web = function() {
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var remisier = (0,useUIConfigStore/* default */.Z)(function(store) {
        return store.getUIValue("remisier");
    });
    var adjustedData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        isCommunityAccessGranted: remisier === null || remisier === void 0 ? void 0 : remisier.isCommunityAccessGranted
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_Web_Popover, {
        trigger: "click",
        placement: "bottomRight",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Web_PopoverContentWrapper, {
                style: {
                    maxHeight: 500
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_MenuProfileTitle, {
                        name: data.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_PopoverContent, {
                        style: {
                            maxHeight: 500
                        },
                        children: ProfileMenu_ProfileMenuReactNode(adjustedData)
                    })
                ]
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_IconProfile, {
            id: "icon-profile-popover",
            img: data.avatar,
            name: data.username,
            "data-cy": "top-navbar-icon-profile-desktop"
        })
    });
};
/* harmony default export */ var ProfileMenu_Web = (ProfileMenu_Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/ProfileMenu/index.jsx



;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/styled.js

function InitialTrading_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  align-items: center;\n  border-left: 1px solid ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  flex-direction: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  cursor: pointer;\n\n  ::after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    top: 100%;\n    right: 0;\n    height: ",
        ";\n    background: ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    InitialTrading_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InitialTrading_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: ",
        ";\n"
    ]);
    InitialTrading_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InitialTrading_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var InitialTrading_styled_ButtonTrading = (0,styled_components_browser_esm["default"])(InitialTrading_styled_Flex).withConfig({
    componentId: "sc-9dda1440-0"
})(InitialTrading_styled_templateObject(), ui/* color.lowgray */.$_.lowgray, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return minimize ? "space-between" : "space-around";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "16px 0" : "0 16px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "column" : "row";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "110px" : "145px";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "101px" : "60px";
}, function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? "1px" : 0;
}, ui/* color.light */.$_.light);
var ButtonTradingGreen = (0,styled_components_browser_esm["default"])(InitialTrading_styled_ButtonTrading).withConfig({
    componentId: "sc-9dda1440-1"
})(InitialTrading_styled_templateObject1(), function(param) {
    var _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return isActive ? ui/* color.light */.$_.light : "linear-gradient(-29deg, #46aa9e, #3fb9aa)";
}, function(param) {
    var _minimize = param.minimize, minimize = _minimize === void 0 ? false : _minimize;
    return !minimize ? "102px" : "61px";
});


;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/ButtonTradingFill.jsx







var ButtonTradingFill_Text = ui/* Common.Text */.Gn.Text, ButtonTradingFill_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, ButtonTradingFill_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var ButtonTradingFill = function(_param) /*#__PURE__*/ {
    var isActive = _param.isActive, minimize = _param.minimize, label = _param.label, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "isActive",
        "minimize",
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(ButtonTradingGreen, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: isActive,
        minimize: minimize
    }, otherProps), {
        "data-cy": "top-navbar-button-start-trading",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingFill_Text, {
                align: minimize ? "left" : "center",
                color: isActive ? ui/* color.trading */.$_.trading : ui/* color.light */.$_.light,
                family: "bold",
                size: "15px",
                children: label
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingFill_IconWrapper, {
                size: "16px",
                style: {
                    marginTop: "-10px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingFill_Iconmoon, {
                    className: "icon-toolbar_down",
                    color: isActive ? ui/* color.trading */.$_.trading : ui/* color.light */.$_.light
                })
            })
        ]
    }));
};
ButtonTradingFill.propTypes = {
    isActive: (prop_types_default()).bool,
    minimize: (prop_types_default()).bool,
    label: (prop_types_default()).string
};
ButtonTradingFill.defaultProps = {
    isActive: false,
    minimize: false,
    label: "START TRADING"
};
/* harmony default export */ var InitialTrading_ButtonTradingFill = (ButtonTradingFill);

;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/Web.jsx









var InitialTrading_Web_Popover = ui/* Header.PopoverCustom */.h4.PopoverCustom;
var Web_InitialTradeWeb = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var activeRoutes = [
        "/securities/register/information",
        "/securities/auth",
        "/securities/login", 
    ];
    var activeByDefault = activeRoutes.some(function(value) {
        return router.asPath.includes(value);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_Web_Popover, {
        componentTrigger: function(isButtonActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_ButtonTradingFill, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                isActive: isButtonActive || activeByDefault,
                label: "START TRADING",
                minimize: minimize,
                onClick: function() {
                    return showAuthModal();
                }
            }));
        }
    });
};
Web_InitialTradeWeb.propTypes = {
    minimize: (prop_types_default()).bool
};
Web_InitialTradeWeb.defaultProps = {
    minimize: true
};
/* harmony default export */ var InitialTrading_Web = (Web_InitialTradeWeb);

;// CONCATENATED MODULE: ./src/global/Header/InitialTrading/index.jsx



// EXTERNAL MODULE: ./src/lib/api/stockTransfer.ts
var stockTransfer = __webpack_require__(94177);
// EXTERNAL MODULE: ./src/global/Securities/constants/localStorage.ts
var constants_localStorage = __webpack_require__(8992);
;// CONCATENATED MODULE: ./src/global/Securities/utils/auth.ts

var getUserLoginStatus = function() {
    var tradeLoginStatus = localStorage.getItem(constants_localStorage/* securitiesStorageKey.tradeIsLogin */.O.tradeIsLogin);
    var accessToken = localStorage.getItem(constants_localStorage/* securitiesStorageKey.accessToken */.O.accessToken);
    var targetAPI = localStorage.getItem(constants_localStorage/* securitiesStorageKey.targetAPI */.O.targetAPI);
    return Boolean(tradeLoginStatus && accessToken && targetAPI);
};

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/ButtonTradingOutline.tsx




var ButtonTradingOutline_Flex = ui/* Common.Flex */.Gn.Flex, ButtonTradingOutline_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, ButtonTradingOutline_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, ButtonTradingOutline_Text = ui/* Common.Text */.Gn.Text;
var ButtonTradingOutline = function(param) {
    var isActive = param.isActive, minimize = param.minimize, label = param.label, imageSrc = param.imageSrc, onChangeVisibility = param.onChangeVisibility;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTrading, {
        "data-cy": "real-trading-btn",
        isActive: isActive,
        minimize: minimize,
        onClick: function() {
            return onChangeVisibility(!isActive);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingOutline_IconWrapper, {
                size: minimize ? "20px" : "40px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: imageSrc,
                    alt: "",
                    style: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonTradingOutline_Flex, {
                align: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingOutline_Text, {
                        size: "13px",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingOutline_IconWrapper, {
                        size: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTradingOutline_Iconmoon, {
                            className: "icon-toolbar_down"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RealTrading_ButtonTradingOutline = (ButtonTradingOutline);

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/TradingMenuItem.tsx









var TradingMenuItem_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, TradingMenuItem_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, TradingMenuItem_Text = ui/* Common.Text */.Gn.Text;
var TradingMenuItem = function(param) {
    var iconmoon = param.iconmoon, children = param.children, label = param.label, link = param.link;
    var router = (0,next_router.useRouter)();
    var ref = useSecuritiesButton(), handleLogoutTrading = ref.handleLogoutTrading, handleClickSupportButton = ref.handleClickSupportButton;
    var handleNavigation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!link) e.preventDefault();
                        if (!(label === "Trading Logout")) {
                            _ctx.next = 4;
                            break;
                        }
                        handleLogoutTrading();
                        return _ctx.abrupt("return");
                    case 4:
                        if (!(label === "Live Support")) {
                            _ctx.next = 7;
                            break;
                        }
                        handleClickSupportButton();
                        return _ctx.abrupt("return");
                    case 7:
                        router.push((0,general/* sanitizeURL */.lz)(link));
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleNavigation(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingMenuItemContainer, {
            "data-cy": "trading-menu-item",
            onClick: handleNavigation,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingMenuItem_IconWrapper, {
                    size: "14px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingMenuItem_Iconmoon, {
                        size: "12px",
                        className: iconmoon
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingMenuItem_Text, {
                    size: "14px",
                    height: "28px",
                    padding: "0 8px",
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var RealTrading_TradingMenuItem = (TradingMenuItem);

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/Web.tsx

















var Web_Button = ui/* Common.Button */.Gn.Button, RealTrading_Web_Text = ui/* Common.Text */.Gn.Text;
var RealTrading_Web_Popover = ui/* Header.PopoverCustom */.h4.PopoverCustom;
var RealTrading_Web_Web = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(null), lastId = ref1[0], setLastId = ref1[1];
    var ref2 = (0,react.useState)(""), transferNote = ref2[0], setTransferNote = ref2[1];
    var openSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    (0,react.useEffect)(function() {
        if (getUserLoginStatus()) {
            stockTransfer/* default.getNotification */.Z.getNotification().then(function(res) {
                if (res.data.data) {
                    var _data = res.data.data, latest_pending_id = _data.latest_pending_id, notes = _data.notes;
                    setLastId(latest_pending_id);
                    setTransferNote(notes);
                }
            });
        }
    }, []);
    var handleClose = function() {
        setLastId(null);
        setTransferNote("");
    };
    var handleClickNotif = function() {
        handleClose();
        router.push("/securities/stocktransfer");
    };
    var handleBuyClick = function() {
        return (0,maintenance/* withMaintenanceGuard */.L)(function() {
            openSearchCompanyModal();
            setIsVisible(false);
        });
    };
    var stockbitLogoUrl = "/img/ssd.svg";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Web_Popover, {
        componentTrigger: function(isButtonActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_ButtonTradingOutline, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                isActive: isButtonActive,
                minimize: minimize,
                label: "Trading Area",
                imageSrc: stockbitLogoUrl,
                onChangeVisibility: function(active) {
                    return setIsVisible(active);
                }
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
            condition: isVisible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PopoverContainerBlock, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: lastId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockTransferNotif, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    className: "trading-menu-notification",
                                    onClick: handleClickNotif,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            alt: "notification-illustration",
                                            src: "/images/cloud-document-blue.svg"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: transferNote
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "trading-menu-notification-close",
                                    onClick: handleClose,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        alt: "close-x",
                                        src: "/icon/x-bold-blue.svg"
                                    })
                                })
                            ]
                        })
                    }),
                    realTadingMenu.map(function(param, i) {
                        var title = param.title, subMenu = param.subMenu;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradeAreaContent, {
                            children: [
                                title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingMenuTitle, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Web_Text, {
                                        family: "bold",
                                        color: ui/* color.primary */.$_.primary,
                                        children: title
                                    })
                                }) : "",
                                i === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: "8px 16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_Button, {
                                        type: "primary",
                                        height: "32px",
                                        block: true,
                                        onClick: handleBuyClick,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Web_Text, {
                                            color: ui/* color.light */.$_.light,
                                            size: "14px",
                                            family: "bold",
                                            align: "center",
                                            children: "BUY"
                                        })
                                    })
                                }),
                                subMenu.map(function(param, index) {
                                    var iconmoonWeb = param.iconmoonWeb, label = param.label, link = param.link, flag = param.flag;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                        children: !flag && /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_TradingMenuItem, {
                                            iconmoon: iconmoonWeb,
                                            label: label,
                                            link: link,
                                            children: label
                                        })
                                    }, "trading-menu-item-".concat(index + 1));
                                })
                            ]
                        }, "trade-area-content-".concat(i + 1));
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var RealTrading_Web = (RealTrading_Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/RealTrading/index.tsx



// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/types.ts
var types = __webpack_require__(41110);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOpeningAccountStore.ts
var useOpeningAccountStore = __webpack_require__(8948);
;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/ButtonTradingOutline.jsx








var VirtualTrading_ButtonTradingOutline_Flex = ui/* Common.Flex */.Gn.Flex, VirtualTrading_ButtonTradingOutline_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, VirtualTrading_ButtonTradingOutline_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, VirtualTrading_ButtonTradingOutline_Text = ui/* Common.Text */.Gn.Text;
var virtualAreaImg = "data:image/svg+xml;base64,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";
var ButtonTradingOutline_ButtonTradingOutline = function(_param) /*#__PURE__*/ {
    var isActive = _param.isActive, minimize = _param.minimize, label = _param.label, imageSrc = _param.imageSrc, onChangeVisibility = _param.onChangeVisibility, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "isActive",
        "minimize",
        "label",
        "imageSrc",
        "onChangeVisibility"
    ]);
    return (0,jsx_runtime.jsxs)(styled_ButtonTrading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        isActive: isActive,
        minimize: minimize,
        onClick: function() {
            return onChangeVisibility(!isActive);
        }
    }, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_ButtonTradingOutline_IconWrapper, {
                size: "50px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: label === "Virtual Area" ? virtualAreaImg : imageSrc,
                    alt: "",
                    style: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTrading_ButtonTradingOutline_Flex, {
                align: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_ButtonTradingOutline_Text, {
                        size: "13px",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_ButtonTradingOutline_IconWrapper, {
                        size: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_ButtonTradingOutline_Iconmoon, {
                            className: "icon-toolbar_down"
                        })
                    })
                ]
            })
        ]
    }));
};
ButtonTradingOutline_ButtonTradingOutline.propTypes = {
    isActive: (prop_types_default()).bool.isRequired,
    minimize: (prop_types_default()).bool.isRequired,
    label: (prop_types_default()).string.isRequired,
    imageSrc: (prop_types_default()).string.isRequired,
    onChangeVisibility: (prop_types_default()).func.isRequired
};
/* harmony default export */ var VirtualTrading_ButtonTradingOutline = (ButtonTradingOutline_ButtonTradingOutline);

;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/TradingMenuItem.jsx







var VirtualTrading_TradingMenuItem_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, VirtualTrading_TradingMenuItem_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, VirtualTrading_TradingMenuItem_Text = ui/* Common.Text */.Gn.Text;
var TradingMenuItem_TradingMenuItem = function(_param) /*#__PURE__*/ {
    var iconmoon = _param.iconmoon, children = _param.children, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "iconmoon",
        "children"
    ]);
    return (0,jsx_runtime.jsxs)(styled_TradingMenuItemContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_TradingMenuItem_IconWrapper, {
                size: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_TradingMenuItem_Iconmoon, {
                    size: "12px",
                    className: iconmoon
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_TradingMenuItem_Text, {
                size: "14px",
                height: "28px",
                padding: "0 8px",
                children: children
            })
        ]
    }));
};
TradingMenuItem_TradingMenuItem.propTypes = {
    iconmoon: (prop_types_default()).string.isRequired,
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var VirtualTrading_TradingMenuItem = (TradingMenuItem_TradingMenuItem);

;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/Web.tsx























var VirtualTrading_Web_Button = ui/* Common.Button */.Gn.Button, VirtualTrading_Web_Flex = ui/* Common.Flex */.Gn.Flex, Web_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, VirtualTrading_Web_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon, VirtualTrading_Web_Text = ui/* Common.Text */.Gn.Text;
var VirtualTrading_Web_Popover = ui/* Header.PopoverCustom */.h4.PopoverCustom;
var VirtualTrading_Web_Web = function(_param) {
    var minimize = _param.minimize, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "minimize"
    ]);
    var router = (0,next_router.useRouter)();
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var showSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.showModal;
    });
    var oaStatus = (0,useOpeningAccountStore/* default */.Z)(function(s) {
        return s.status;
    });
    var isStockbitSecuritas = oaStatus === types/* AuthModalStatus.COMPLETED */.X.COMPLETED;
    var handleNavigation = function(label, link) {
        router.push((0,general/* sanitizeURL */.lz)(link));
    };
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var analyticsNavigate = function(label) {
        switch(label){
            case "Orderbook":
                virtualTrading/* virtualTradingAction.onVirtualTradingOrderbookSelected */.SP.onVirtualTradingOrderbookSelected();
                break;
            case "Portfolio":
                virtualTrading/* virtualTradingAction.onVirtualTradingPortfolioSelected */.SP.onVirtualTradingPortfolioSelected();
                break;
            case "Order":
                virtualTrading/* virtualTradingAction.onVirtualTradingOrderSelected */.SP.onVirtualTradingOrderSelected();
                break;
            default:
                break;
        }
    };
    var handleSwitchReal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                    case 2:
                        if (![
                            "/trade/portfolio/",
                            "/trade/order/"
                        ].includes(router.asPath)) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 5;
                        return router.push("/stream");
                    case 5:
                        showAuthModal();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSwitchReal() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web_Popover, {
        componentTrigger: function(isButtonActive) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_ButtonTradingOutline, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
                "data-cy": "virtual-trading-btn",
                isActive: isButtonActive,
                minimize: minimize,
                label: "Virtual Area",
                imageSrc: "".concat(api/* SITE_URL */._O, "/img/favicon.svg"),
                onChangeVisibility: function(active) {
                    return setIsVisible(active);
                }
            }));
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
            condition: isVisible,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_PopoverContainerBlock, {
                children: [
                    VirtualTrading_virtualTradingMenu.map(function(param, i) {
                        var title = param.title, subMenu = param.subMenu;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_TradeAreaContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_TradingMenuTitle, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web_Text, {
                                        family: "bold",
                                        color: ui/* color.primary */.$_.primary,
                                        children: title
                                    })
                                }),
                                i === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    style: {
                                        padding: "8px 16px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web_Button, {
                                        type: "primary",
                                        height: "32px",
                                        block: true,
                                        onClick: function() {
                                            showSearchCompanyModal();
                                            setIsVisible(false);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web_Text, {
                                            color: ui/* color.light */.$_.light,
                                            size: "14px",
                                            family: "bold",
                                            align: "center",
                                            children: "BUY"
                                        })
                                    })
                                }),
                                subMenu.map(function(param, index) {
                                    var iconmoonWeb = param.iconmoonWeb, label = param.label, link = param.link;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_TradingMenuItem, {
                                        iconmoon: iconmoonWeb,
                                        onClick: function() {
                                            handleNavigation(label, link);
                                            analyticsNavigate(label);
                                        },
                                        children: label
                                    }, "trading-menu-item-".concat(index + 1));
                                })
                            ]
                        }, "trade-area-content-".concat(i + 1));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_TradeAreaContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            "data-cy": "switch-to-real-account-btn",
                            style: {
                                padding: "0px 16px"
                            },
                            onClick: function() {
                                handleSwitchReal();
                                virtualTrading/* virtualTradingAction.onSwitchToRealTradingSelected */.SP.onSwitchToRealTradingSelected(virtualTrading/* SWITCH_TO_REAL_ACCOUNT_SOURCE.dropdownVirtualArea */.S_.dropdownVirtualArea, isStockbitSecuritas);
                            },
                            "aria-hidden": true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                                height: "32px",
                                block: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTrading_Web_Flex, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web_Text, {
                                            color: ui/* color.primary */.$_.primary,
                                            size: "14px",
                                            padding: "0 8px",
                                            children: "Switch to Real Account"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Web_IconWrapper, {
                                            size: "18px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web_Iconmoon, {
                                                className: "icon-tradesmall_switch",
                                                size: "12px",
                                                color: ui/* color.primary */.$_.primary
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var VirtualTrading_Web = (VirtualTrading_Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/VirtualTrading/index.jsx



// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var SearchCompany_slice = __webpack_require__(33908);
;// CONCATENATED MODULE: ./src/global/Header/SearchCompanyModal/styled.ts

function SearchCompanyModal_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: fixed;\n  background: ",
        ";\n  z-index: 99999;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  padding: 20px;\n"
    ]);
    SearchCompanyModal_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchCompanyModal_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 600px;\n"
    ]);
    SearchCompanyModal_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchCompanyModal_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #33bc89;\n  color: ",
        ";\n  height: 40px;\n  width: 100px;\n  border: 2px solid #33bc89;\n  border-radius: 3px;\n  transition: opacity 0s !important;\n  font-size: 16px;\n\n  &:hover {\n    background-color: #00ab6b;\n    color: ",
        ";\n  }\n"
    ]);
    SearchCompanyModal_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SearchCompanyModal_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  &:hover {\n    color: inherit;\n  }\n"
    ]);
    SearchCompanyModal_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SearchCompanyModal_styled_Flex = ui/* Common.Flex */.Gn.Flex, SearchCompanyModal_styled_Button = ui/* Common.Button */.Gn.Button, BaseIconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
var FullScreenContainer = (0,styled_components_browser_esm["default"])(SearchCompanyModal_styled_Flex).withConfig({
    componentId: "sc-67892ac1-0"
})(SearchCompanyModal_styled_templateObject(), ui/* color.light */.$_.light);
var SearchCompanyWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-67892ac1-1"
})(SearchCompanyModal_styled_templateObject1());
var SearchCompanyModal_styled_ConfirmButton = (0,styled_components_browser_esm["default"])(SearchCompanyModal_styled_Button).withConfig({
    componentId: "sc-67892ac1-2"
})(SearchCompanyModal_styled_templateObject2(), ui/* color.light */.$_.light, ui/* color.light */.$_.light);
var styled_Iconmoon = (0,styled_components_browser_esm["default"])(BaseIconmoon).withConfig({
    componentId: "sc-67892ac1-3"
})(SearchCompanyModal_styled_templateObject3());


;// CONCATENATED MODULE: ./src/global/Header/SearchCompanyModal/index.tsx













var SearchCompanyModal_Flex = ui/* Common.Flex */.Gn.Flex, SearchCompanyModal_Text = ui/* Common.Text */.Gn.Text;
function SearchCompanySymbol(param) {
    var onSymbolChange = param.onSymbolChange;
    var dispatch = (0,es/* useDispatch */.I0)();
    var result = (0,es/* useSelector */.v9)(SearchCompany_slice/* selectors */.wl).result;
    var stockInputRef = (0,react.useRef)();
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var openBondsBuy = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var closeSearchCompanyModal = (0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return s.closeModal;
    });
    var isSuggestionEmpty = !(result === null || result === void 0 ? void 0 : result.length) || (result === null || result === void 0 ? void 0 : result.length) < 1;
    var onClose = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch(SearchCompany_slice/* default.actions.resetResult */.ZP.actions.resetResult());
                        closeSearchCompanyModal();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClose() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenTransaction = function(symbol, type) {
        if (type === "fr") {
            openBondsBuy(symbol);
            FRBondActionTrackers.onOrderButtonClicked("Buy", symbol, "Search Company Page");
        } else {
            onSymbolChange(symbol);
        }
        onClose();
    };
    var handleConfirm = function() {
        if (isSuggestionEmpty) {
            return;
        }
        var _result = (0,_sliced_to_array/* default */.Z)(result, 1), selected = _result[0];
        if (!selected) {
            return;
        }
        handleOpenTransaction(selected.name, selected.type);
    };
    var onClickResult = function(symbol) {
        if (isSuggestionEmpty) {
            return;
        }
        var item = result.find(function(el) {
            return el.name === symbol;
        });
        if (!item) {
            return;
        }
        handleOpenTransaction(item.name, item.type);
    };
    (0,react.useEffect)(function() {
        var ref;
        (ref = stockInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FullScreenContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchCompanyWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchCompanyModal_Flex, {
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompanyModal_Text, {
                            size: "26px",
                            color: ui/* color.primary */.$_.primary,
                            children: "Type symbol to buy"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Iconmoon, {
                            size: "16px",
                            color: ui/* color.nightRider */.$_.nightRider,
                            className: "icon-trading_xbold",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                    ref: stockInputRef,
                    isInTradingModal: false,
                    updateSymbol: onClickResult
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchCompanyModal_Flex, {
                    align: "center",
                    justify: "flex-end",
                    padding: "10px",
                    mt: "5px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompanyModal_Text, {
                            padding: "10px",
                            color: ui/* color.nobel */.$_.nobel,
                            children: "Press Enter or"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompanyModal_styled_ConfirmButton, {
                            disabled: isSuggestionEmpty,
                            onClick: handleConfirm,
                            children: "CONFIRM"
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var SearchCompanyModal = (SearchCompanySymbol);

;// CONCATENATED MODULE: ./src/global/Header/Web.jsx















// header components












// header styled

var Header_Web_Flex = ui/* Common.Flex */.Gn.Flex, Header_Web_IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper;
var srcImage = "/img/stockbit.svg";
var lastYOffset = 0;
function Header_Web_Web(param) {
    var isSideWidgetOpen = param.isSideWidgetOpen, isHeaderMinimized = param.isHeaderMinimized;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading, tradingType = ref.tradingType;
    var ref1 = (0,react.useState)(false), isDisplayed = ref1[0], setIsDisplayed = ref1[1];
    var ref2 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), data = ref2.data, isLoading = ref2.isLoading;
    var _country = data.country, country = _country === void 0 ? "ID" : _country;
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return [
            s.visible,
            s.closeModal
        ];
    }, shallow/* default */.Z), 2), isShowSearchCompanyModal = ref3[0], closeSearchCompanyModal = ref3[1];
    var showTradingModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.showModal;
    });
    var getUnreadCount = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getUnreadCount;
    });
    (0,react.useEffect)(function() {
        var onDocumentScroll = function() {
            var currentYOffset = window.pageYOffset;
            if (currentYOffset < 300) return;
            if (currentYOffset > lastYOffset && !isHeaderMinimized) {
                // down
                dispatch(MainLayout_slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(true));
            } else if (currentYOffset < lastYOffset && isHeaderMinimized) {
                // up
                dispatch(MainLayout_slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
            }
            lastYOffset = currentYOffset;
        };
        window.addEventListener("scroll", onDocumentScroll);
        // Clean eventlistener when unmount component
        return function() {
            window.removeEventListener("scroll", onDocumentScroll);
        };
    }, [
        dispatch,
        isHeaderMinimized
    ]);
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            getUnreadCount();
        }
    }, []);
    (0,react.useEffect)(function() {
        var timer = window.setTimeout(function() {
            setIsDisplayed(true);
        }, 0);
        return function() {
            window.clearTimeout(timer);
            dispatch(MainLayout_slice/* default.actions.setHeaderMinimized */.ZP.actions.setHeaderMinimized(false));
        };
    }, []);
    var renderTradingPopup = function() {
        if (isRealTrading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTrading_Web, {
                minimize: isHeaderMinimized
            });
        }
        if (isVirtualTrading) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTrading_Web, {
                minimize: isHeaderMinimized
            });
        }
        if (!tradingType && isDisplayed) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialTrading_Web, {
                minimize: isHeaderMinimized
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    };
    var onSymbolChange = function(newSymbol) {
        closeSearchCompanyModal();
        showTradingModal({
            symbol: newSymbol,
            orderType: isRealTrading ? trading/* ORDER_TYPE.BUY */.Jm.BUY : trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY,
            modalData: {
                source: "Other"
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWeb, {
        id: "stockbit-header-web",
        isOpen: isSideWidgetOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWebTop, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Web_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/stream",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Web_IconWrapper, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    alt: "",
                                                    src: srcImage,
                                                    style: {
                                                        height: "40px",
                                                        marginRight: "30px",
                                                        width: "75px"
                                                    }
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Web, {
                                        style: {
                                            padding: "0 30px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Web_Flex, {
                                align: "center",
                                children: [
                                    !isLoading && !data.ispro ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/shop",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProUser, {
                                            children: "Berlangganan Pro"
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_Web, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_Web, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_Web, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Web, {
                        minimize: isHeaderMinimized
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: country === "ID",
                children: renderTradingPopup()
            }),
            isShowSearchCompanyModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompanyModal, {
                onSymbolChange: function(symbol) {
                    return onSymbolChange(symbol);
                }
            })
        ]
    });
}
Header_Web_Web.propTypes = {
    isSideWidgetOpen: (prop_types_default()).bool,
    isHeaderMinimized: (prop_types_default()).bool
};
Header_Web_Web.defaultProps = {
    isSideWidgetOpen: false,
    isHeaderMinimized: false
};
/* harmony default export */ var Header_Web = (Header_Web_Web);

;// CONCATENATED MODULE: ./src/global/Header/Mobile.jsx






// header components















var Header_Mobile_Flex = ui/* Common.Flex */.Gn.Flex;
var Header_Mobile_Mobile = function() {
    var data = (0,es/* useSelector */.v9)(profile/* selectors */.wl).data;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useSearchCompanyModalStore/* default */.Z)(function(s) {
        return [
            s.visible,
            s.closeModal
        ];
    }, shallow/* default */.Z), 2), isShowSearchCompanyModal = ref[0], closeSearchCompanyModal = ref[1];
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var showTradingModal = (0,TradingModal_store/* default */.Z)(function(s) {
        return s.showModal;
    });
    var getUnreadCount = (0,useNotificationData/* useNotificationData */.z)(function(store) {
        return store.getUnreadCount;
    });
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            getUnreadCount();
        }
    }, []);
    var onSymbolChange = function(newSymbol) {
        closeSearchCompanyModal();
        showTradingModal({
            symbol: newSymbol,
            orderType: isRealTrading ? trading/* ORDER_TYPE.BUY */.Jm.BUY : trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderMobile, {
        id: "stockbit-header-mobile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Mobile_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar_Mobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Search_Mobile, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Mobile_Flex, {
                align: "center",
                children: [
                    !data.ispro ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/shop",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProUser, {
                            children: "Berlangganan Pro"
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Message_Mobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Notification_Mobile, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMenu_Mobile, {})
                ]
            }),
            isShowSearchCompanyModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompanyModal, {
                onSymbolChange: function(symbol) {
                    return onSymbolChange(symbol);
                }
            })
        ]
    });
};
/* harmony default export */ var Header_Mobile = (Header_Mobile_Mobile);

;// CONCATENATED MODULE: ./src/global/Header/index.jsx


/* harmony default export */ var Header = ({
    Web: Header_Web,
    Mobile: Header_Mobile
});

// EXTERNAL MODULE: ./src/global/MainLayout/SideWidget/index.tsx + 69 modules
var SideWidget = __webpack_require__(40995);
// EXTERNAL MODULE: ./src/global/MainLayout/styled.ts
var MainLayout_styled = __webpack_require__(92589);
;// CONCATENATED MODULE: ./src/global/MainLayout/__tests__/constant.ts
var DATA_CY_MAIN_LAYOUT = "main-layout";

;// CONCATENATED MODULE: ./src/global/MainLayout/index.tsx
/* eslint-disable react/forbid-prop-types */ 











// Local Components


















// local redux slice


function MainLayout(param) {
    var children = param.children, isFlexibleWidth = param.isFlexibleWidth, maxWidth = param.maxWidth, background = param.background, width = param.width, _fullPage = param.fullPage, fullPage = _fullPage === void 0 ? false : _fullPage;
    // Library hooks
    var dispatch = (0,es/* useDispatch */.I0)();
    var breakpoints = (0,useBreakpoint/* default */.Z)();
    // Zustand store
    var fetchChatUnreadCount = (0,useGetChatUnreadCount/* useGetChatUnreadCount */.H)(function(s) {
        return s.fetchUnreadCount;
    });
    var fetchCommunityInfo = (0,useGetReferralInfo/* useGetReferralInfo */.s)(function(s) {
        return s.fetchCommunityInfo;
    });
    // Redux store
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var ref = (0,es/* useSelector */.v9)(MainLayout_slice/* selectors */.wl), isSideWidgetOpen = ref.isSideWidgetOpen, isHeaderMinimized = ref.isHeaderMinimized;
    var ref1 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), dataUserProfile = ref1.data;
    // Custom hooks
    var setFliptUserId = (0,useFliptStore/* default */.Z)(function(s) {
        return s.setUserId;
    });
    var onboardingProgress = hooks_useOnBoarding().onboardingProgress;
    (0,useProfileData/* default */.Z)();
    if (isLoggedIn) {
        (0,useNotificationListener/* default */.Z)();
        hooks_useChatListenerWsSocialV2(); // new incoming message ws social
    }
    // Reactive variable
    var userId = dataUserProfile.id;
    var isShowOnboarding = onboardingProgress < ONBOARDING_MAX_STEP;
    var props = width ? {
        style: {
            width: width
        }
    } : {};
    // feature flag initiate user id
    setFliptUserId(userId);
    // React efects
    (0,react.useEffect)(function() {
        if (!isLoggedIn) return;
        // get latest notification
        dispatch(edit_profile_slice/* effects.getNotifications */.Sz.getNotifications());
    }, []);
    (0,react.useEffect)(function() {
        if (!isLoggedIn || !userId) return;
        (0,logger/* setUserId */.Iv)(userId);
    }, [
        isLoggedIn,
        userId
    ]);
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            fetchCommunityInfo();
            fetchChatUnreadCount();
        }
    }, [
        isLoggedIn
    ]);
    // React render
    if (isShowOnboarding) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(features_onboarding, {
            progress: onboardingProgress
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "data-cy": DATA_CY_MAIN_LAYOUT,
        children: [
            breakpoints.md ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Header.Web, {
                isSideWidgetOpen: isSideWidgetOpen,
                isHeaderMinimized: isHeaderMinimized
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Header.Mobile, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_styled/* Wrapper */.im, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                background: background,
                isSideWidgetOpen: isSideWidgetOpen
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout_styled/* default */.ZP, {
                    id: "main-container",
                    isFlexibleWidth: isFlexibleWidth,
                    maxWidth: maxWidth,
                    isSideWidgetOpen: isSideWidgetOpen,
                    fullPage: fullPage,
                    children: children
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalErrorManager/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalModalManager/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ModalShareTradeManager, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FRPage_ModalUnavailable, {})
        ]
    });
}
MainLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    isFlexibleWidth: (prop_types_default()).bool,
    maxWidth: (prop_types_default()).number,
    background: (prop_types_default()).string,
    width: (prop_types_default()).any
};
MainLayout.defaultProps = {
    isFlexibleWidth: false,
    maxWidth: undefined,
    background: "transparent",
    width: undefined
};
/* harmony default export */ var global_MainLayout = (MainLayout);


/***/ }),

/***/ 92589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RU": function() { return /* binding */ SIDE_WIDGET_OPENED_WIDTH; },
/* harmony export */   "U9": function() { return /* binding */ SIDE_WIDGET_CONTENT_WIDTH; },
/* harmony export */   "Uh": function() { return /* binding */ device; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "zX": function() { return /* binding */ SIDE_WIDGET_TOOLBAR_WIDTH; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* eslint-disable space-infix-ops */ /* eslint-disable indent */ /* eslint-disable no-confusing-arrow */ 


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      @media ",
        " {\n        width: calc(100% - 60px);\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 40px auto 0 auto;\n  padding: ",
        ";\n  width: 100%;\n  max-width: ",
        ";\n\n  &.chat-expanded {\n    margin: 0 auto 0 auto !important;\n    padding: 0 !important;\n  }\n\n  ",
        "\n\n  @media ",
        " {\n    margin: 100px auto 0 auto;\n    max-width: ",
        ";\n\n    &.chat-expanded {\n      margin: 0px auto 0 auto !important;\n      padding: 20px 37px 0 0 !important;\n    }\n  }\n\n  @media ",
        " {\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        width: calc(\n          100% - (",
        " + ",
        ")\n        );\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  width: 100%;\n\n  @media ",
        " {\n    width: calc(100% - ",
        ");\n\n    ",
        "\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


// TODO: Update device dimension to DS
var laptopM = "(min-width:1081px)";
var device = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device */ .Uh), {
    laptopM: laptopM
});
var SIDE_WIDGET_CONTENT_WIDTH = "330px";
var SIDE_WIDGET_TOOLBAR_WIDTH = "35px";
var SIDE_WIDGET_OPENED_WIDTH = "365px";
// prettier-ignore
var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].main.withConfig({
    componentId: "sc-a8c680fd-0"
})(_templateObject1(), function(props) {
    return props.fullPage ? "0" : "20px 0";
}, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
}, function(props) {
    return props.isFlexibleWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject(), device.tablet);
}, device.tablet, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "660px";
}, device.laptopM, function(props) {
    return props.maxWidth ? "".concat(props.maxWidth, "px") : "990px";
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__["default"].div.withConfig({
    componentId: "sc-a8c680fd-1"
})(_templateObject3(), function(props) {
    return props.background ? props.background : "transparent";
}, device.tablet, SIDE_WIDGET_TOOLBAR_WIDTH, function(props) {
    return props.isSideWidgetOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__.css)(_templateObject2(), SIDE_WIDGET_TOOLBAR_WIDTH, SIDE_WIDGET_CONTENT_WIDTH);
});
/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 51595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65344);
/* harmony import */ var _BaseModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16981);







var BaseConfirmationModal = function(_param) /*#__PURE__*/ {
    var description = _param.description, _cancelText = _param.cancelText, cancelText = _cancelText === void 0 ? "Cancel" : _cancelText, _confirmText = _param.confirmText, confirmText = _confirmText === void 0 ? "Confirm" : _confirmText, _hideSubmitButton = _param.hideSubmitButton, hideSubmitButton = _hideSubmitButton === void 0 ? false : _hideSubmitButton, _hideCancelButton = _param.hideCancelButton, hideCancelButton = _hideCancelButton === void 0 ? false : _hideCancelButton, _onConfirm = _param.onConfirm, onConfirm = _onConfirm === void 0 ? function() {} : _onConfirm, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "description",
        "cancelText",
        "confirmText",
        "hideSubmitButton",
        "hideCancelButton",
        "onConfirm",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        children: [
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .DescriptionRow */ .uw, {
                className: "description",
                align: "middle",
                justify: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    span: 24,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .Description */ .dk, {
                        children: description
                    })
                })
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .ButtonRow */ .VR, {
                className: "button-row",
                gutter: 16,
                children: [
                    !hideCancelButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: hideSubmitButton ? 24 : 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .CancelButton */ .Lw, {
                            onClick: props.onCancel,
                            block: true,
                            children: cancelText
                        })
                    }),
                    !hideSubmitButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: hideCancelButton ? 24 : 12,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_1__/* .ConfirmButton */ .pu, {
                            type: "primary",
                            onClick: onConfirm,
                            loading: props.confirmLoading,
                            block: true,
                            children: confirmText
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseConfirmationModal);


/***/ }),

/***/ 65344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lw": function() { return /* binding */ CancelButton; },
/* harmony export */   "VR": function() { return /* binding */ ButtonRow; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "pu": function() { return /* binding */ ConfirmButton; },
/* harmony export */   "uw": function() { return /* binding */ DescriptionRow; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71577);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 12px 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n  color: #858585;\n  text-align: center;\n\n  margin: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 40px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  color: #333333;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: #333333;\n    border-color: #ededed;\n  }\n\n  &::after {\n    box-shadow: 0 0 0 0 #000000 !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 44px;\n  color: #ffffff;\n  border-radius: 4px;\n\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 19px;\n\n  padding: 12px 20px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var DescriptionRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-0"
})(_templateObject());
var Description = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p.withConfig({
    componentId: "sc-7df14943-1"
})(_templateObject1());
var ButtonRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-2"
})(_templateObject2());
var CancelButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-3"
})(_templateObject3());
var ConfirmButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-7df14943-4"
})(_templateObject4());


/***/ }),

/***/ 16981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16165);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15746);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71230);
/* harmony import */ var global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79928);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89997);








var BaseModal = function(_param) /*#__PURE__*/ {
    var prefix = _param.prefix, title = _param.title, children = _param.children, _closable = _param.closable, closable = _closable === void 0 ? true : _closable, _hideHeader = _param.hideHeader, hideHeader = _hideHeader === void 0 ? false : _hideHeader, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "prefix",
        "title",
        "children",
        "closable",
        "hideHeader"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        centered: true,
        footer: null
    }, props), {
        closable: false,
        children: [
            !hideHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .HeaderRow */ .VJ, {
                className: "base-modal-header",
                align: "middle",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: prefix
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 22,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            align: "middle",
                            justify: "center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
                                    className: "base-modal-title",
                                    children: title
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        span: 1,
                        children: closable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .CloseButton */ .PZ, {
                            onClick: props.onCancel,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                style: {
                                    fontSize: 10,
                                    color: "#969696"
                                },
                                component: global_Icons_CloseSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
                            })
                        })
                    })
                ]
            }),
            children
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseModal);


/***/ }),

/***/ 89997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "PZ": function() { return /* binding */ CloseButton; },
/* harmony export */   "VJ": function() { return /* binding */ HeaderRow; },
/* harmony export */   "u_": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33070);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71230);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n  & .ant-modal-body {\n    padding: 24px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 22px;\n  padding: 0 20px;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24px;\n\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-0"
})(_templateObject());
var HeaderRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-90095253-1"
})(_templateObject1());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].h4.withConfig({
    componentId: "sc-90095253-2"
})(_templateObject2());
var CloseButton = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].button.withConfig({
    componentId: "sc-90095253-3"
})(_templateObject3());


/***/ }),

/***/ 89698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_NotPro; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
;// CONCATENATED MODULE: ./src/global/NotPro/constants.ts
var subscribeMessage = "This feature is exclusive for PRO users";
var subscribeButton = "Subscribe";


// EXTERNAL MODULE: ./src/global/NotPro/styled.ts
var styled = __webpack_require__(92768);
;// CONCATENATED MODULE: ./src/global/NotPro/index.tsx





var Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function NotPro(param) {
    var width = param.width, height = param.height, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* WidgetAction */.uu, {
        className: className,
        style: {
            height: height || "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: subscribeMessage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LinkSubscribeWrapper */.oo, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/shop",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ButtonSubscribe */.an, {
                            type: "primary",
                            width: width,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                                    className: "icon-setting_subscribe",
                                    color: ui/* color.light */.$_.light
                                }),
                                subscribeButton
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var global_NotPro = (NotPro);


/***/ }),

/***/ 92768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ NotProWrapper; },
/* harmony export */   "an": function() { return /* binding */ ButtonSubscribe; },
/* harmony export */   "oo": function() { return /* binding */ LinkSubscribeWrapper; },
/* harmony export */   "uu": function() { return /* binding */ WidgetAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  margin-top: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  margin: 0 auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 330px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button;
var WidgetAction = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-91b4feef-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var LinkSubscribeWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-91b4feef-1"
})(_templateObject1());
var ButtonSubscribe = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Button).withConfig({
    componentId: "sc-91b4feef-2"
})(_templateObject2(), function(props) {
    return props.width || "80%";
});
var NotProWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-91b4feef-3"
})(_templateObject3());



/***/ }),

/***/ 92292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Notation_Content; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts
var styled = __webpack_require__(97038);
;// CONCATENATED MODULE: ./src/global/Notation/NotationListItem.tsx



var Flex = ui/* Common.Flex */.Gn.Flex;
function NotationListItem(param) {
    var code = param.code, desc = param.desc, _isUma = param.isUma, isUma = _isUma === void 0 ? false : _isUma;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        align: "center",
        justify: "space-between",
        mb: "10px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex, {
                justify: "flex-end",
                width: "44px",
                mr: "12px",
                pb: "10px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationTag */.GU, {
                    isUma: isUma,
                    children: code
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Description */.dk, {
                children: desc
            })
        ]
    });
}
/* harmony default export */ var Notation_NotationListItem = (NotationListItem);

;// CONCATENATED MODULE: ./src/global/Notation/Content.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable react/require-default-props */ /* eslint-disable no-confusing-arrow */ 






var Content_Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
function Content(_param) {
    var notation = _param.notation, symbol = _param.symbol, name = _param.name, notationTag = _param.notationTag, props = (0,_object_without_properties/* default */.Z)(_param, [
        "notation",
        "symbol",
        "name",
        "notationTag"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Container */.W2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        direction: "column",
        align: "center"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content_Flex, {
                justify: "center",
                align: "center",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        as: "h1",
                        size: "20px",
                        height: "24px",
                        align: "center",
                        family: "bold",
                        children: symbol
                    }),
                    notationTag
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Flex, {
                justify: "center",
                align: "center",
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    as: "p",
                    children: name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_Flex, {
                justify: "center",
                align: "center",
                py: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    as: "p",
                    align: "center",
                    children: "Perusahaan memiliki Notasi Khusus sebagai berikut:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* NotationList */.HC, {
                direction: "column",
                align: "center",
                justify: "space-evenly",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: notation.map(function(param) {
                        var notation_code = param.notation_code, notation_desc = param.notation_desc, code = param.code, desc = param.desc;
                        return code && desc || notation_code && notation_desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_NotationListItem, {
                            code: notation_code || code,
                            desc: notation_desc || desc
                        }, "notation-".concat(code)) : null;
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var Notation_Content = (Content);


/***/ }),

/***/ 15068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _Content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92292);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97038);
/* eslint-disable react/require-default-props */ 





var Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
var INDICATOR_ICON_URL = "/icon/ic_indicator.svg";
var UMA_ICON_URL = "/icon/ic_uma.svg";
var X_ICON_URL = "/icon/ic_x.svg";
var NOTATION_TYPE = {
    INDICATOR: "indicator",
    UMA: "uma",
    X: "x"
};
var INDICATOR_ALT_TEXT = "indikator notasi khusus";
function Notation(param) {
    var symbol = param.symbol, notation = param.notation, uma = param.uma, isModal = param.isModal, name = param.name, _isPopover = param.isPopover, isPopover = _isPopover === void 0 ? true : _isPopover, _type = param.type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _className = param.className, className = _className === void 0 ? "" : _className, _placement = param.placement, placement = _placement === void 0 ? "top" : _placement;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), visible = ref[0], setVisible = ref[1];
    var onCloseModal = function() {
        return setVisible(false);
    };
    var isUma = type === NOTATION_TYPE.UMA && !!uma;
    var isX = type === NOTATION_TYPE.X;
    var renderTag = function(param) {
        var _type = param.// eslint-disable-next-line no-shadow
        type, type = _type === void 0 ? NOTATION_TYPE.INDICATOR : _type, _isNotationBadges = param.// eslint-disable-next-line no-shadow
        isNotationBadges, isNotationBadges = _isNotationBadges === void 0 ? false : _isNotationBadges, _src = param.src, src = _src === void 0 ? INDICATOR_ICON_URL : _src, _alt = param.alt, alt = _alt === void 0 ? INDICATOR_ALT_TEXT : _alt;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .NotationTag */ .GU, {
            type: type,
            isSmall: true,
            isNotationBadges: isNotationBadges,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                alt: alt,
                src: src
            })
        });
    };
    var renderNotation = function() {
        if (isUma) {
            return renderTag({
                type: NOTATION_TYPE.UMA,
                src: UMA_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " uma"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        if (isX) {
            return renderTag({
                type: NOTATION_TYPE.X,
                src: X_ICON_URL,
                alt: "".concat(INDICATOR_ALT_TEXT, " x"),
                className: "",
                isNotationBadges: isNotationBadges
            });
        }
        return renderTag({
            type: type,
            isNotationBadges: isNotationBadges
        });
    };
    var renderContent = function() {
        var isFullSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Content__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            symbol: symbol,
            uma: uma,
            notation: notation,
            name: name,
            notationTag: renderTag({
                type: NOTATION_TYPE.INDICATOR,
                isNotationBadges: true
            }),
            isFullSize: isFullSize
        });
    };
    if (isModal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    onClick: function() {
                        return setVisible(true);
                    },
                    "aria-hidden": "true",
                    children: renderTag({
                        type: NOTATION_TYPE.INDICATOR,
                        isNotationBadges: true
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
                    visible: visible,
                    onCancel: onCloseModal,
                    title: null,
                    centered: true,
                    width: "500px",
                    children: renderContent(true)
                })
            ]
        });
    }
    if (!isPopover) {
        return renderNotation();
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .PopoverIndicator */ .H9, {
        className: className,
        content: renderContent(),
        placement: placement,
        children: renderNotation()
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Notation);


/***/ }),

/***/ 97038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bh": function() { return /* binding */ BadgeLabelDayTrade; },
/* harmony export */   "CC": function() { return /* binding */ IconArrow; },
/* harmony export */   "GU": function() { return /* binding */ NotationTag; },
/* harmony export */   "H9": function() { return /* binding */ PopoverIndicator; },
/* harmony export */   "HC": function() { return /* binding */ NotationList; },
/* harmony export */   "H_": function() { return /* binding */ NotationBar; },
/* harmony export */   "Nj": function() { return /* binding */ NotationBadgeContainer; },
/* harmony export */   "Qu": function() { return /* binding */ ModalIndicatorBar; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "dk": function() { return /* binding */ Description; },
/* harmony export */   "lw": function() { return /* binding */ BadgeLabelWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 36px;\n      width: 100%;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 2px;\n  margin: auto;\n  padding: 20px 28px;\n  width: 350px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n  font-size: 14px;\n  line-height: 15px;\n  padding-bottom: 10px;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: scroll;\n  max-height: 300px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: rgba(235, 160, 49, 0.03);\n  cursor: pointer;\n  height: 38px;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: unset;\n    justify-content: center;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    text-align: center;\n    width: unset;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: 20px;\n    width: 20px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n    width: 22.8px;\n    cursor: unset;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: unset;\n    border: unset;\n    border-radius: unset;\n    width: 12px;\n    height: 12px;\n    margin-left: 4px;\n    margin-right: 0;\n    padding: 0;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          margin-right: 0;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n          margin-bottom: 2px;\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: #fef4e8;\n  border: 1px solid #f5931b;\n  color: #f5931b;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  font-family: ProximaNovaBd;\n\n  ",
        "\n\n  ",
        "\n  > .notation-label__icon {\n    height: 12px;\n    width: 12px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #8277f8;\n  font-size: 12px;\n  font-weight: 700;\n  color: #8277f8;\n  background-color: #f5f0ff;\n  padding: 2px 4.5px 2px 2px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ], [
        "\n  color: ",
        ";\n  font-size: 12px;\n\n  &:before {\n    content: '\\\\e968';\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-close {\n    color: rgba(0, 0, 0, 0.43);\n\n    .ant-modal-close-x {\n      font-size: 14px;\n      height: 48px;\n      line-height: 48px;\n      width: 48px;\n\n      .ant-modal-close-icon {\n        color: rgba(0, 0, 0, 0.43);\n        height: 14px;\n        width: 14px;\n\n        > svg {\n          fill: inherit;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: unset !important;\n  min-width: 12px;\n  height: 12px;\n  gap: 2px;\n  border: 1px solid #f5931b;\n  border-radius: 2px;\n  background-color: #fef4e8;\n  padding: 0 2.5px;\n  color: #f5931b;\n  font-size: 9px;\n  line-height: normal;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}


var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon, Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal, Popover = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Popover */ .Gn.Popover;
var percentToHex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .utils.hexOpacity */ .P6.hexOpacity;
var Tag = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Notation.Tag */ .gO.Tag;
var Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-3f7ff3d7-0"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light, function(param) {
    var isFullsize = param.isFullsize;
    return isFullsize && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
});
var Description = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-3f7ff3d7-1"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.component */ .$_.component);
var NotationList = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-3f7ff3d7-2"
})(_templateObject3());
var NotationBar = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-3f7ff3d7-3"
})(_templateObject4());
var notationTagVariant = {
    indicator: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject5()),
    notation: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject6()),
    uma: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject7()),
    x: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject8())
};
var NotationTag = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Tag).withConfig({
    componentId: "sc-3f7ff3d7-4"
})(_templateObject11(), function(param) {
    var type = param.type;
    return notationTagVariant[type];
}, function(param) {
    var isNotationBadges = param.isNotationBadges;
    return isNotationBadges ? (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject9()) : (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject10());
});
var BadgeLabelWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    justify: "center",
    px: "5px",
    py: "2px",
    ml: "5px"
}).withConfig({
    componentId: "sc-3f7ff3d7-5"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var BadgeLabelDayTrade = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(BadgeLabelWrapper).withConfig({
    componentId: "sc-3f7ff3d7-6"
})(_templateObject13());
var IconArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Iconmoon).withConfig({
    componentId: "sc-3f7ff3d7-7"
})(_templateObject14(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.yellowSea */ .$_.yellowSea, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.yellowSea */ .$_.yellowSea);
var ModalIndicatorBar = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Modal).attrs({
    maskStyle: {
        backgroundColor: "rgba(0,0,0,0.8)"
    }
}).withConfig({
    componentId: "sc-3f7ff3d7-8"
})(_templateObject15());
var PopoverIndicator = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Popover).attrs({
    overlayInnerStyle: {
        border: "1px solid ".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro)
    }
}).withConfig({
    componentId: "sc-3f7ff3d7-9"
})(_templateObject16());
var NotationBadgeContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Tag).withConfig({
    componentId: "sc-3f7ff3d7-10"
})(_templateObject17());



/***/ }),

/***/ 59359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ exodusApiInstance; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusApiInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    disabledErrorAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};


/***/ }),

/***/ 24949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ getOrderDetail; },
/* harmony export */   "k": function() { return /* binding */ bulkCancelByOrderId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4621);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96563);





var bulkCancelByOrderId = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderIds) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.bulkCancelByOrderId */ .Li.bulkCancelByOrderId, {
                        ui_ref: (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateUiRef */ .TW)(),
                        order_id: orderIds
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function bulkCancelByOrderId(orderIds) {
        return _ref.apply(this, arguments);
    };
}();
var getOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_3__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_2__/* .orderEndpoint.orderDetail */ .Li.orderDetail, {
                        params: {
                            order_id: orderId
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 19254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 3px;\n\n  & > .ant-checkbox {\n    top: 0;\n\n    & > .ant-checkbox-inner {\n      width: 18px;\n      height: 18px;\n      border-radius: 4px;\n    }\n  }\n\n  & > .ant-checkbox-checked::after {\n    border-radius: 4px;\n  }\n\n  & > span:nth-child(2) {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47b14e33-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 17348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  border: 1px solid #ededed;\n  color: #333333;\n\n  padding: 2px 12px;\n  border-radius: 16px;\n  width: fit-content;\n\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Chips = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    componentId: "sc-46a8463a-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Chips);


/***/ }),

/***/ 82093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  background: none;\n  border: none;\n  padding: 4px 0;\n  margin: 0;\n\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InfoButton = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].button.withConfig({
    componentId: "sc-3a702b20-0"
})(_templateObject());


/***/ }),

/***/ 68861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronDownSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M4 6l4 4 4-4"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronDownSvg);


/***/ }),

/***/ 42958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var InfoSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2",
            d: "M6.5 11.167a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334zM6.5 8.367V6.5M6.5 4.633h.004"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoSvg);


/***/ }),

/***/ 97077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_InputStepper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/InputStepper/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: hidden;\n  border-radius: 2px;\n  border: 1px solid #dadada;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f5f6f7;\n  width: 30px;\n  height: 32px;\n  border: none;\n  flex-shrink: 0;\n  transition: 0.3s opacity ease-out;\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.75;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  border: solid #dadada;\n  border-width: 0 1px;\n  text-align: center;\n\n  outline: none;\n\n  &::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  & .ant-input-number-handler-wrap {\n    display: none;\n  }\n\n  & .ant-input-number-input-wrap {\n    display: flex;\n    align-items: center;\n\n    & input {\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var InputStepContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5b57c1c-0"
})(_templateObject());
var StepButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-5b57c1c-1"
})(_templateObject1());
var StepInput = styled_components_browser_esm["default"].input.withConfig({
    componentId: "sc-5b57c1c-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/global/Securities/components/InputStepper/index.tsx
// TODO: Split InputStepper to InputNumber component







var InputStepper = function(_param) {
    var containerStyle = _param.containerStyle, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _step = _param.step, step = _step === void 0 ? 1 : _step, _disableDecimal = _param.disableDecimal, disableDecimal = _disableDecimal === void 0 ? false : _disableDecimal, props = (0,_object_without_properties/* default */.Z)(_param, [
        "containerStyle",
        "onChange",
        "step",
        "disableDecimal"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useState)(((ref = props.value) === null || ref === void 0 ? void 0 : ref.toString()) || ((ref1 = props.defaultValue) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "0"), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react.useMemo)(function() {
        var min = props.min, max = props.max;
        return {
            minValue: min === undefined ? -Infinity : Number(min),
            maxValue: max === undefined ? Infinity : Number(max)
        };
    }, [
        props.min,
        props.max
    ]), minValue = ref3.minValue, maxValue = ref3.maxValue;
    var formatter = function(value) {
        return Intl.NumberFormat("en-US").format(value);
    };
    var parser = function(value) {
        // Purposefully hardcoded number only to get separator symbol
        var thousandSeparator = Intl.NumberFormat("en-US").format(1111).replace(/[0-9]+/g, "");
        var decimalSeparator = Intl.NumberFormat("en-US").format(1.1).replace(/[0-9]+/g, "");
        var ref = (0,_sliced_to_array/* default */.Z)(value.replaceAll(thousandSeparator, "").split(decimalSeparator), 2), wholeValue = ref[0], tmp = ref[1], decimalValue = tmp === void 0 ? 0 : tmp;
        return Number("".concat(wholeValue).concat(decimalSeparator).concat(decimalValue));
    };
    var parsedInputValue = (0,react.useMemo)(function() {
        return parser(inputValue);
    }, [
        inputValue
    ]);
    var setTextCursor = function(target, position) {
        window.requestAnimationFrame(function() {
            target.focus();
            target.setSelectionRange(position, position);
        });
    };
    var getStep = function(key) {
        return step[key] || step;
    };
    // Clamp value optionally, set to Infinity to handle unclamped value
    var getClampedValue = function(value) {
        return Math.min(Math.max(value, minValue), maxValue);
    };
    var getProcessedValue = function(value) {
        var parsedValue = getClampedValue(parser(value));
        return {
            rawValue: parsedValue,
            formattedValue: formatter(parsedValue)
        };
    };
    var handleChange = function(e) {
        var value = e.target.value;
        var isReplaceZero = parsedInputValue === 0;
        var ref = getProcessedValue(isReplaceZero ? value.replace("0", "") : value), rawValue = ref.rawValue, formattedValue = ref.formattedValue;
        var selectionPos = e.target.selectionStart;
        // Handle on value not convertible to number
        if (Number.isNaN(rawValue)) return;
        // Handle when inputing decimal
        if (value[value.length - 1] === "." && !inputValue.includes(".") && !disableDecimal) {
            setInputValue("".concat(formattedValue, "."));
            return;
        }
        // Handle on removing comma
        if (formattedValue === inputValue) {
            // Check if the last character removed was '0'
            if (inputValue === "0" && selectionPos === 0) {
                // Set the cursor to the right of '0'
                setTextCursor(e.target, selectionPos + 1);
                return;
            }
            setTextCursor(e.target, selectionPos);
            return;
        }
        setInputValue(formattedValue);
        onChange(rawValue);
        // Prevent cursor jumping when adding and removing text
        var shiftPos = inputValue.length - value.length;
        var newCursor = selectionPos + (formattedValue.length - inputValue.length + shiftPos);
        setTextCursor(e.target, newCursor);
    };
    var handleStepDown = function() {
        var stepValue = getStep("down");
        var rawValue = getClampedValue(parsedInputValue - stepValue);
        setInputValue(formatter(rawValue));
        onChange(rawValue);
    };
    var handleStepUp = function() {
        var stepValue = getStep("up");
        var rawValue = getClampedValue(parsedInputValue + stepValue);
        setInputValue(formatter(rawValue));
        onChange(rawValue);
    };
    var handlePropValueChange = (0,react.useCallback)(function() {
        if (props.value === undefined) return;
        var newValue = formatter(getClampedValue(props.value || 0));
        setInputValue(newValue);
    }, [
        props.value
    ]);
    (0,react.useEffect)(function() {
        handlePropValueChange();
    }, [
        handlePropValueChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputStepContainer, {
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepButton, {
                type: "button",
                "data-cy": "btn-step-down",
                onClick: handleStepDown,
                disabled: parsedInputValue <= minValue || props.disabled,
                children: "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "data-cy": "input-step"
            }, props), {
                onChange: handleChange,
                value: inputValue
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepButton, {
                type: "button",
                "data-cy": "btn-step-up",
                onClick: handleStepUp,
                disabled: parsedInputValue >= maxValue || props.disabled,
                children: "+"
            })
        ]
    });
};
/* harmony default export */ var components_InputStepper = (InputStepper);


/***/ }),

/***/ 93400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_BaseSecuritiesModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 19 modules
var modal = __webpack_require__(33070);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/Icons/CloseIconSvg.tsx

var CloseIconSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 12 13",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M11 1.5l-10 10M1 1.5l10 10"
        })
    });
};
/* harmony default export */ var Icons_CloseIconSvg = (CloseIconSvg);

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-body {\n    padding: 24px 0 0;\n  }\n\n  & .ant-modal-close-x {\n    width: 50px;\n    margin-top: 6px;\n\n    :hover .anticon {\n      color: #b5b5b5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #c1c1c1;\n  font-size: 10px;\n  transition: 0.3s color linear;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  line-height: normal;\n  color: #333333;\n  margin: 0 0 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  transform: translate(0, 100%);\n  width: 100%;\n  height: unset;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm["default"])(modal/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-0"
})(_templateObject());
var CloseIcon = (0,styled_components_browser_esm["default"])(Icon/* default */.Z).attrs({
    component: Icons_CloseIconSvg
}).withConfig({
    componentId: "sc-d885cbc0-1"
})(_templateObject1());
var Title = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-d885cbc0-2"
})(_templateObject2());
var FloatingButton = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx





var BaseSecuritiesModal = function(_param) /*#__PURE__*/ {
    var title = _param.title, submitText = _param.submitText, onSubmit = _param.onSubmit, submitProps = _param.submitProps, hideSubmit = _param.hideSubmit, children = _param.children, _modalWidth = _param.modalWidth, modalWidth = _modalWidth === void 0 ? 500 : _modalWidth, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "submitText",
        "onSubmit",
        "submitProps",
        "hideSubmit",
        "children",
        "modalWidth"
    ]);
    return (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: modalWidth,
        footer: null,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
        centered: true
    }, props), {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            children,
            !hideSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "primary",
                onClick: onSubmit
            }, submitProps), {
                children: submitText
            }))
        ]
    }));
};
/* harmony default export */ var Modal_BaseSecuritiesModal = (BaseSecuritiesModal);


/***/ }),

/***/ 27607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var SkeletonWrapper = function(param) {
    var _loading = param.loading, loading = _loading === void 0 ? false : _loading, skeleton = param.skeleton, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? skeleton : children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SkeletonWrapper);


/***/ }),

/***/ 8992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ securitiesStorageKey; }
/* harmony export */ });
var securitiesStorageKey = {
    tradeIsLogin: "tradeIsLogin",
    accessToken: "securitiesAccessToken",
    refreshToken: "securitiesRefreshtoken",
    targetAPI: "securitiesTarget",
    stockbitFormula: "formulaStockbit"
};


/***/ }),

/***/ 94386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hz": function() { return /* binding */ orderMaxQuantity; },
/* harmony export */   "eg": function() { return /* binding */ orderMaxLot; },
/* harmony export */   "qc": function() { return /* binding */ SPLIT_ORDER_COPY; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);


var orderMaxLot = 50000;
var orderMaxQuantity = 50;
var _obj;
var SPLIT_ORDER_COPY = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SplitOrderMethodEnum.UNSPECIFIED */ .PH.UNSPECIFIED, "Unspecified"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SplitOrderMethodEnum.EQUAL */ .PH.EQUAL, "Equal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SplitOrderMethodEnum.RANDOM */ .PH.RANDOM, "Random"), _obj);


/***/ }),

/***/ 76870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var global_Datafeed_UseLivePrice_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);
/* harmony import */ var global_Datafeed_UseLivePrice_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65131);
/* harmony import */ var hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64999);
/* harmony import */ var global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27934);





var StateKey = {
    trade_page: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.TRADE_PAGE */ .j.TRADE_PAGE,
    portfolio_detail: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.PORTFOLIO_DETAIL */ .j.PORTFOLIO_DETAIL,
    orderlist_detail: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.ORDERLIST_DETAIL */ .j.ORDERLIST_DETAIL
};
var useLivePriceUpdater = function(config, updateFunction) {
    var isRealTrading = (0,hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isRealTrading;
    var symbol = config.symbol, page = config.page;
    var symbols = Array.isArray(symbol) ? symbol : [
        symbol
    ];
    (0,global_Datafeed_UseLivePrice_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(StateKey[page], symbols);
    var livePriceOnMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (!isRealTrading) return;
        var isSymbolMatch = Array.isArray(symbol) ? symbol.includes(message.stockCode) : message.stockCode === symbol;
        if (!isSymbolMatch) return;
        updateFunction(message);
    }, [
        symbol,
        isRealTrading,
        updateFunction
    ]);
    (0,global_Datafeed_UseLivePrice_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_2__/* .useLivePriceReceiver */ .V)(symbols, page, livePriceOnMessage);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLivePriceUpdater);


/***/ }),

/***/ 11806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _api_balance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6474);






var initialState = {
    tradingBalance: null,
    tradingLimit: null,
    dayTrade: null,
    dayTradeLeverage: null,
    dayTradeTradingBalance: null,
    isLoading: false,
    error: null
};
var useCashInfoStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        loadCashInfo: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol, orderId) {
                var axiosResponse, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                tradingBalance: 0,
                                tradingLimit: 0,
                                dayTrade: 0,
                                isLoading: true,
                                error: null
                            });
                            _ctx.next = 4;
                            return (0,_api_balance__WEBPACK_IMPORTED_MODULE_1__/* .getCashInfo */ .h)(symbol, orderId);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set({
                                tradingBalance: Number(data.trade_balance),
                                tradingLimit: Number(data.trade_limit),
                                dayTrade: Number(data.day_trade_buying_power),
                                dayTradeLeverage: Number(data.day_trade_leverage),
                                dayTradeTradingBalance: Number(data.day_trade_trading_balance)
                            });
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                error: _ctx.t0
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(symbol, orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetCashInfo: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        set(initialState);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useCashInfoStore);


/***/ }),

/***/ 97454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useEmittenInfoStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/emitten.ts




var getEmittenInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", exodus/* exodusApiInstance.disabledErrorAlert.get */.l.disabledErrorAlert.get(apiEndpoint/* emittenEndpoint.emittenInfo */.CI.emittenInfo(symbol)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getEmittenInfo(symbol) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/stores/useEmittenInfoStore.ts






var initialState = {
    data: {},
    isLoading: false
};
var useEmittenInfoStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadEmittenInfo: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getEmittenInfo(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetEmittenInfo: function() {
            set(initialState);
        },
        updateEmittenInfo: function(newData) {
            set(function(state) {
                return {
                    data: (0,_object_spread/* default */.Z)({}, state.data, newData)
                };
            });
        }
    });
});
/* harmony default export */ var stores_useEmittenInfoStore = (useEmittenInfoStore);


/***/ }),

/***/ 8948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var lib_api_securities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65906);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91635);







var initialState = {
    status: null
};
var useOpeningAccountStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        resetStore: function() {
            return set({
                status: null
            });
        },
        loadAccountStatus: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res, ref, ref1, data, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_securities__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getOAStatus */ .Z.getOAStatus();
                    case 3:
                        res = _ctx.sent;
                        ;
                        ref1 = (ref = res === null || res === void 0 ? void 0 : res.data) !== null && ref !== void 0 ? ref : {}, data = ref1.data, _$error = ref1.error;
                        if (!(!data || _$error)) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to get oa status failed");
                    case 8:
                        set({
                            status: data.status
                        });
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,utils_logger__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_ctx.t0, {
                            event: "useOpeningAccountStore@loadAccountStatus",
                            errCause: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.cause
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }))
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOpeningAccountStore);


/***/ }),

/***/ 87127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12902);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75413);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24949);








var initialState = {
    data: undefined,
    isLoading: false
};
var useOrderDetailStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadOrderDetail: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
                var axiosResponse, _data, responseData, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_2__/* .getOrderDetail */ .d)(orderId);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            data = utils_securities_transformData__WEBPACK_IMPORTED_MODULE_1__/* ["default"].orderDetail */ .Z.orderDetail(responseData);
                            set({
                                data: data,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(orderId) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOrderDetail: function() {
            set(initialState);
        },
        updateOrderDetail: function(newData) {
            var ref;
            if (typeof newData !== "object") return;
            var currentOrderId = (ref = get().data) === null || ref === void 0 ? void 0 : ref.orderid;
            if (currentOrderId !== newData.orderid) return;
            set((0,immer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
                state.data = newData;
            }));
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useOrderDetailStore);


/***/ }),

/***/ 98976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_usePortfolioDetailStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/portfolio.ts





var getPortfolio = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var targetAPI;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    targetAPI = (0,utils/* getTargetAPI */.Ai)();
                    return _ctx.abrupt("return", trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolio */.Db.portfolio[targetAPI]));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPortfolio() {
        return _ref.apply(this, arguments);
    };
}();
var getPortfolioDetail = function(symbol) {
    var targetAPI = (0,utils/* getTargetAPI */.Ai)();
    return trading/* tradingApiInstance */.i[targetAPI].get(apiEndpoint/* portfolioEndpoint.portfolioDetail */.Db.portfolioDetail[targetAPI](symbol));
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts








var initialState = {
    data: {},
    dayTrade: {},
    isLoading: false
};
var usePortfolioDetailStore = (0,esm/* default */.ZP)(function(set, get) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        setCurrentSymbol: function(symbol) {
            set({
                data: {
                    symbol: symbol
                }
            });
        },
        loadPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, _data, responseData, result, day_trade, data, dataDaytrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getPortfolioDetail(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            _data = axiosResponse.data, responseData = _data.data;
                            result = responseData.result, day_trade = responseData.day_trade;
                            data = transformData/* default.portfolioItem */.Z.portfolioItem(result);
                            dataDaytrade = transformData/* default.portfolioItem */.Z.portfolioItem(day_trade);
                            set({
                                data: data,
                                dayTrade: dataDaytrade,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetPortfolioDetail: function() {
            set(initialState);
        },
        updatePortfolioDetail: function(newData) {
            var checkSymbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref;
            if (typeof newData !== "object") return;
            var currentSymbol = (ref = get().data) === null || ref === void 0 ? void 0 : ref.symbol;
            if (currentSymbol !== newData.symbol && checkSymbol) return;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (isDayTrade) {
                    state.dayTrade = (0,_object_spread/* default */.Z)({}, state.dayTrade, newData);
                } else {
                    state.data = (0,_object_spread/* default */.Z)({}, state.data, newData);
                }
            }));
        }
    });
});
/* harmony default export */ var stores_usePortfolioDetailStore = (usePortfolioDetailStore);


/***/ }),

/***/ 5612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);

var useSearchCompanyModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return {
        visible: false,
        showModal: function() {
            set({
                visible: true
            });
        },
        closeModal: function() {
            set({
                visible: false
            });
        }
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (useSearchCompanyModalStore);


/***/ }),

/***/ 49365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ stores_useTermsAndConditionStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/termsAndConditions.ts



var getTnCByFeature = function(featureId) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).get(apiEndpoint/* termsAndConditionsEndpoint.getTnCByFeature */.Lr.getTnCByFeature(featureId));
};
var postTnCAcceptance = function(featureId, version, isAccepted) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).post(apiEndpoint/* termsAndConditionsEndpoint.postTnCAcceptance */.Lr.postTnCAcceptance(), {
        acceptance_letters: [
            {
                feature_id: featureId,
                is_accepted: isAccepted,
                version: version
            }, 
        ]
    });
};
// terms and condition v2
var getTnCByFeatures = function(featureIds) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).get(apiEndpoint/* termsAndConditionsAPI.getTnCByFeature */.b4.getTnCByFeature(featureIds));
};
var postTnCAcceptances = function(acceptancePayload) {
    return exodus/* exodusApiInstance.withLanguageInstance */.l.withLanguageInstance(termsAndCondition/* AcceptanceLanguageEnum.BAHASA */.$6.BAHASA).post(apiEndpoint/* termsAndConditionsAPI.postTnCAcceptance */.b4.postTnCAcceptance(), {
        acceptance_letters: acceptancePayload
    });
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts











var initialState = {
    contents: undefined,
    isSubmitting: false,
    termsData: undefined,
    accountStatus: ""
};
var useTermsAndConditionStore = (0,esm/* default */.ZP)((0,immer/* immer */.n)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadTnC: function loadTnC(featureId, onAgreementPending, onAgreementAccepted) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data, isAccepted;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getTnCByFeature(featureId);
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            isAccepted = data.acceptance_letters.length === 0;
                            set(function(draft) {
                                draft.contents = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.contents), (0,_define_property/* default */.Z)({}, featureId, {
                                    isAccepted: isAccepted,
                                    acceptanceLetters: data.acceptance_letters
                                }));
                            });
                            if (isAccepted) {
                                _ctx.next = 10;
                                break;
                            }
                            onAgreementPending();
                            return _ctx.abrupt("return");
                        case 10:
                            onAgreementAccepted();
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        },
        postAcceptance: function postAcceptance(featureId, version) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isSubmitting = true;
                            });
                            _ctx.next = 4;
                            return postTnCAcceptance(featureId, version, true);
                        case 4:
                            set(function(draft) {
                                draft.contents[featureId].isAccepted = true;
                                draft.isSubmitting = false;
                            });
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.contents[featureId].isAccepted = false;
                                draft.isSubmitting = false;
                            });
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        loadTnCAcceptance: // terms and condition v2
        function loadTnCAcceptance(featureIds) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data, acceptanceLetters, isDayTradeAccepted;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getTnCByFeatures(featureIds);
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            acceptanceLetters = data.acceptance_letters;
                            acceptanceLetters.forEach(function(letter) {
                                set(function(draft) {
                                    draft.termsData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, draft.termsData), (0,_define_property/* default */.Z)({}, letter.feature_id, {
                                        isAccepted: letter.is_accepted,
                                        url: letter.url,
                                        version: letter.version
                                    }));
                                });
                                var storeKey = termsAndCondition/* TnCFeaturePersistMap */.rO[letter.feature_id];
                                useUIConfigStore/* default.getState */.Z.getState().setUIValue(storeKey, letter.is_accepted);
                            });
                            isDayTradeAccepted = useUIConfigStore/* default.getState */.Z.getState().getUIValue("dayTradeTnc");
                            return _ctx.abrupt("return", isDayTradeAccepted);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }))();
        },
        postAcceptances: function postAcceptances(acceptances) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set(function(draft) {
                                draft.isSubmitting = true;
                            });
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return postTnCAcceptances(acceptances);
                        case 4:
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            return _ctx.abrupt("return", true);
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 13:
                            _ctx.prev = 13;
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            return _ctx.finish(13);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8,
                        13,
                        16
                    ]
                ]);
            }))();
        },
        loadSubAccountStatus: function loadSubAccountStatus(type) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, _data, tmp, sub_account, status, isActive, storeKey;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return trade/* default.checkSubAccountDayTrade */.Z.checkSubAccountDayTrade(type);
                        case 3:
                            response = _ctx.sent;
                            _data = response.data, tmp = _data.data, sub_account = (tmp === void 0 ? {} : tmp).sub_account;
                            status = (sub_account || {}).status;
                            set(function(draft) {
                                draft.accountStatus = status;
                            });
                            isActive = status === termsAndCondition/* SubAccountStatus.ACTIVE */.go.ACTIVE;
                            storeKey = "dayTradeSubAccountActive";
                            useUIConfigStore/* default.getState */.Z.getState().setUIValue(storeKey, isActive);
                            return _ctx.abrupt("return", isActive);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", true);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    });
}));
/* harmony default export */ var stores_useTermsAndConditionStore = (useTermsAndConditionStore);


/***/ }),

/***/ 21734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ useTradingInfoStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware/immer.js
var immer = __webpack_require__(42435);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/trading.ts
var instance_trading = __webpack_require__(96563);
;// CONCATENATED MODULE: ./src/global/Securities/api/trading.ts




var getTradingInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(features) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,instance_trading/* getTradingApiInstance */.j)().get(apiEndpoint/* tradingEndpoints.getTradingInfo */.bU.getTradingInfo, {
                        params: {
                            features: features.join(",")
                        }
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getTradingInfo(features) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts








var initialState = {
    dayTrade: undefined,
    splitOrder: undefined,
    isLoading: false
};
var useTradingInfoStore = (0,esm/* default */.ZP)((0,immer/* immer */.n)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadTradingInfo: function loadTradingInfo() {
            var features = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [
                trading/* TradingFeatureEnum.UNSPECIFIED */.n.UNSPECIFIED
            ];
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            _ctx.next = 4;
                            return getTradingInfo(features);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            set(function(draft) {
                                draft.isLoading = false;
                                var _day_trade;
                                draft.dayTrade = (_day_trade = data.day_trade) !== null && _day_trade !== void 0 ? _day_trade : draft.dayTrade;
                                var _split_order;
                                draft.splitOrder = (_split_order = data.split_order) !== null && _split_order !== void 0 ? _split_order : draft.splitOrder;
                            });
                            return _ctx.abrupt("return", data);
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.isLoading = false;
                            });
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", {
                                day_trade: undefined,
                                split_order: undefined
                            });
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        }
    });
}));


/***/ }),

/***/ 52870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var typings_transactionForm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93134);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38597);





var initialState = {
    formType: typings_transactionForm__WEBPACK_IMPORTED_MODULE_0__/* .TransactionFormType.Classic */ .b.Classic
};
var useTransactionFormStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_2__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        setFormType: function(formType) {
            set({
                formType: formType
            });
        }
    });
}, {
    name: "@fast-trade/shell-transaction-form"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useTransactionFormStore);


/***/ }),

/***/ 48453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AutoOrderProduct; }
/* harmony export */ });
/* unused harmony export AutoSellType */
var AutoOrderProduct;
(function(AutoOrderProduct) {
    AutoOrderProduct["AutoBuy"] = "AB";
    AutoOrderProduct["AutoSell"] = "AS";
})(AutoOrderProduct || (AutoOrderProduct = {}));
var AutoSellType;
(function(AutoSellType) {
    AutoSellType["TakeProfit"] = "TP";
    AutoSellType["StopLoss"] = "SL";
})(AutoSellType || (AutoSellType = {}));


/***/ }),

/***/ 56644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StockType; }
/* harmony export */ });
var StockType;
(function(StockType) {
    StockType["Saham"] = "saham";
    StockType["Right"] = "right";
    StockType["Waran"] = "waran";
    StockType["Index"] = "index";
    StockType["IndexAsing"] = "index_asing";
    StockType["Reksadana"] = "reksadana";
    StockType["Commodities"] = "commodities";
    StockType["Crypto"] = "crypto";
    StockType["Fx"] = "fx";
    StockType["Etf"] = "etf";
    StockType["Bond"] = "bond";
})(StockType || (StockType = {}));


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ AcceptanceLanguageEnum; },
/* harmony export */   "RD": function() { return /* binding */ SubAccountType; },
/* harmony export */   "el": function() { return /* binding */ TnCFeaturesIDEnum; },
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; },
/* harmony export */   "hO": function() { return /* binding */ TnCFeatureIDEnum; },
/* harmony export */   "rO": function() { return /* binding */ TnCFeaturePersistMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var AcceptanceLanguageEnum;
(function(AcceptanceLanguageEnum) {
    AcceptanceLanguageEnum["BAHASA"] = "ID";
    AcceptanceLanguageEnum["ENGLISH"] = "EN";
})(AcceptanceLanguageEnum || (AcceptanceLanguageEnum = {}));
var TnCFeatureIDEnum;
(function(TnCFeatureIDEnum) {
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_UNSPECIFIED"] = 0] = "FEATURE_UNSPECIFIED";
    TnCFeatureIDEnum[TnCFeatureIDEnum["FEATURE_TRADING_LIMIT"] = 1] = "FEATURE_TRADING_LIMIT";
})(TnCFeatureIDEnum || (TnCFeatureIDEnum = {}));
var SubAccountType;
(function(SubAccountType) {
    SubAccountType["DAY_TRADE"] = "SUB_ACCOUNT_TYPE_DAY_TRADE";
})(SubAccountType || (SubAccountType = {}));
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["ACTIVE"] = "SUB_ACCOUNT_STATUS_ACTIVE";
})(SubAccountStatus || (SubAccountStatus = {}));
var TnCFeaturesIDEnum;
(function(TnCFeaturesIDEnum) {
    TnCFeaturesIDEnum["TRADING_LIMIT"] = "FEATURE_ID_TRADING_LIMIT";
    TnCFeaturesIDEnum["AUTO_ORDER"] = "FEATURE_ID_AUTO_ORDER";
    TnCFeaturesIDEnum["DAY_TRADE"] = "FEATURE_ID_DAY_TRADE";
})(TnCFeaturesIDEnum || (TnCFeaturesIDEnum = {}));
var _obj;
var TnCFeaturePersistMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.TRADING_LIMIT, "tradingLimitTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.AUTO_ORDER, "autoOrderTnc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, TnCFeaturesIDEnum.DAY_TRADE, "dayTradeTnc"), _obj);


/***/ }),

/***/ 6421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ EventTypeEnum; },
/* harmony export */   "n": function() { return /* binding */ TradingFeatureEnum; }
/* harmony export */ });
var TradingFeatureEnum;
(function(TradingFeatureEnum) {
    TradingFeatureEnum["UNSPECIFIED"] = "FEATURE_UNSPECIFIED";
    TradingFeatureEnum["DAY_TRADE"] = "FEATURE_DAY_TRADE";
    TradingFeatureEnum["SPLIT_ORDER"] = "FEATURE_SPLIT_ORDER";
})(TradingFeatureEnum || (TradingFeatureEnum = {}));
var EventTypeEnum;
(function(EventTypeEnum) {
    EventTypeEnum["UNSPECIFIED"] = "EVENT_TYPE_UNSPECIFIED";
    EventTypeEnum["OUTSIDE_MARKET_HOURS"] = "EVENT_TYPE_DISABLE_OUTSIDE_MARKET_HOURS";
    EventTypeEnum["EXCEED_DEBT_RATIO"] = "EVENT_TYPE_DISABLE_EXCEED_DEBT_RATIO";
})(EventTypeEnum || (EventTypeEnum = {}));


/***/ }),

/***/ 2941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getFormattedCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99534);

var getFormattedCurrency = function(value) {
    var intlOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _currencyPrefix = intlOptions.currencyPrefix, currencyPrefix = _currencyPrefix === void 0 ? "Rp" : _currencyPrefix, options = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(intlOptions, [
        "currencyPrefix"
    ]);
    return "".concat(currencyPrefix).concat(value.toLocaleString(undefined, options));
};


/***/ }),

/***/ 98202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ getSellAmountInvestedFee; },
/* harmony export */   "J0": function() { return /* binding */ getLimitLot; },
/* harmony export */   "Oz": function() { return /* binding */ generateUpdatedPortfolioHeader; },
/* harmony export */   "Sd": function() { return /* binding */ getSellGain; },
/* harmony export */   "fY": function() { return /* binding */ getProfitLoss; },
/* harmony export */   "jm": function() { return /* binding */ generateUpdatedPortfolioItem; },
/* harmony export */   "yq": function() { return /* binding */ getBuyAmountInvested; }
/* harmony export */ });
/* unused harmony exports getConfigFormula, getBuyAmountInvestedFee */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var _constants_localStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8992);
/* eslint-disable no-new-func */ 

var getConfigFormula = function() {
    var ref;
    return ((ref = JSON.parse(localStorage.getItem(_constants_localStorage__WEBPACK_IMPORTED_MODULE_0__/* .securitiesStorageKey.stockbitFormula */ .O.stockbitFormula))) === null || ref === void 0 ? void 0 : ref.formula) || {};
};
var getSellAmountInvestedFee = function(lot, price, isCorporateAction) {
    var isDayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref = getConfigFormula(), sellAmountInvestedFee = ref.sell_amount_invested_fee, caSellAmountInvestedFee = ref.ca_sell_amount_invested_fee, feeSell = ref.fee_sell, feeBuy = ref.fee_buy, feeBuyDayTrade = ref.fee_buy_day_trade, feeSellDayTrade = ref.fee_sell_day_trade;
    var FEE_BUY = isDayTrade ? feeBuyDayTrade : feeBuy;
    var FEE_SELL = isDayTrade ? feeSellDayTrade : feeSell;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price, ",").concat(isCorporateAction ? "FEE_BUY=".concat(FEE_BUY) : "FEE_SELL=".concat(FEE_SELL)), "return ".concat(isCorporateAction ? caSellAmountInvestedFee : sellAmountInvestedFee))();
};
var getBuyAmountInvested = function(lot, price) {
    var ref = getConfigFormula(), buyAmountInvested = ref.buy_amount_invested;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(buyAmountInvested))();
};
var getBuyAmountInvestedFee = function(lot, price) {
    var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref = getConfigFormula(), buyAmountInvestedFee = ref.buy_amount_invested_fee, feeBuy = ref.fee_buy, feeBuyDayTrade = ref.fee_buy_day_trade;
    var FEE_BUY = isDayTrade ? feeBuyDayTrade : feeBuy;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price, ",FEE_BUY=").concat(FEE_BUY), "return ".concat(buyAmountInvestedFee))();
};
var getProfitLoss = function(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee) {
    var ref = getConfigFormula(), sellProfitLoss = ref.sell_profit_loss;
    return new Function("SELL_AMOUNT_INVESTED_FEE=".concat(sellAmountInvestedFee, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(buyAmountInvestedAveragePriceFee), "return ".concat(sellProfitLoss))();
};
var getSellGain = function(sellProfitLoss, buyAmountInvestedAveragePriceFee) {
    var ref = getConfigFormula(), sellGain = ref.sell_gain;
    return new Function("SELL_PROFITLOSS=".concat(sellProfitLoss, ",BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE=").concat(buyAmountInvestedAveragePriceFee), "return ".concat(sellGain))() * 100;
};
var getLimitLot = function(balance, price) {
    var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var priceWithFee = getBuyAmountInvestedFee(1, price, isDayTrade);
    var limitLot = Math.floor(balance / priceWithFee);
    return limitLot < 0 ? 0 : limitLot;
};
var generateUpdatedPortfolioItem = function(configFormula, lastPrice, balanceLot, amountInvested) {
    var formula = configFormula.formula;
    var LOT = balanceLot;
    var CURRENT_PRICE = lastPrice;
    var AMOUNT_INVESTED = amountInvested;
    var unrealised_market_value = new Function("LOT", "CURRENT_PRICE", "return ".concat(formula.unrealised_market_value, ";"))(LOT, CURRENT_PRICE);
    var UNREALISED_MARKET_VALUE = unrealised_market_value;
    var unrealised_profit_loss = new Function("UNREALISED_MARKET_VALUE", "AMOUNT_INVESTED", "return ".concat(formula.unrealised_profit_loss, ";"))(UNREALISED_MARKET_VALUE, AMOUNT_INVESTED);
    var UNREALISED_PROFIT_LOSS = unrealised_profit_loss;
    var unrealised_gain = new Function("UNREALISED_PROFIT_LOSS", "AMOUNT_INVESTED", "return ".concat(formula.unrealised_gain, ";"))(UNREALISED_PROFIT_LOSS, AMOUNT_INVESTED);
    return {
        unrealised_marketvalue: unrealised_market_value,
        unrealised_profitloss: unrealised_profit_loss,
        unrealised_gain: unrealised_gain
    };
};
var generateUpdatedPortfolioHeader = function(configFormula) {
    var result = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], tradingBalance = arguments.length > 3 ? arguments[3] : void 0, amountInvested = arguments.length > 4 ? arguments[4] : void 0, amountAllocated = arguments.length > 5 ? arguments[5] : void 0, totalDebt = arguments.length > 6 ? arguments[6] : void 0;
    var formula = configFormula.formula;
    var combinedResult = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(result).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dayTrade));
    var unrealised_profitloss = combinedResult.reduce(function(sum, item) {
        return item.unrealised_profitloss !== undefined ? sum + item.unrealised_profitloss : sum;
    }, 0);
    var SUMMARY_NET_PROFIT_LOSS = unrealised_profitloss;
    var TRADING_BALANCE = tradingBalance;
    var SUMMARY_OPEN = amountAllocated;
    var SUMMARY_INVESTED = amountInvested;
    var gain = new Function("SUMMARY_NET_PROFIT_LOSS", "TRADING_BALANCE", "SUMMARY_OPEN", "SUMMARY_INVESTED", "return ".concat(formula.summary_net_profit_loss_percentage, ";"))(SUMMARY_NET_PROFIT_LOSS, TRADING_BALANCE, SUMMARY_OPEN, SUMMARY_INVESTED);
    var equity = new Function("SUMMARY_NET_PROFIT_LOSS", "TRADING_BALANCE", "SUMMARY_OPEN", "SUMMARY_INVESTED", "return ".concat(formula.summary_equity, ";"))(SUMMARY_NET_PROFIT_LOSS, TRADING_BALANCE, SUMMARY_OPEN, SUMMARY_INVESTED);
    var unrealised_market_value_day_trade = dayTrade.reduce(function(sum, item) {
        return item.unrealised_marketvalue !== undefined ? sum + item.unrealised_marketvalue : sum;
    }, 0);
    var TOTAL_DEBT = totalDebt;
    var DAY_TRADE_MARKET_VALUE = unrealised_market_value_day_trade;
    var ratio = new Function("TOTAL_DEBT", "DAY_TRADE_MARKET_VALUE", "return ".concat(formula.day_trade_debt_ratio, ";"))(TOTAL_DEBT, DAY_TRADE_MARKET_VALUE);
    return {
        unrealised_profitloss: unrealised_profitloss,
        gain: gain,
        equity: equity,
        ratio: ratio * 100,
        market_value: DAY_TRADE_MARKET_VALUE
    };
};


/***/ }),

/***/ 98306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getStepFractionByValue; },
/* harmony export */   "n": function() { return /* binding */ getFraction; }
/* harmony export */ });
var fractionList = [
    {
        maxThreshold: 200,
        step: 1
    },
    {
        maxThreshold: 500,
        step: 2
    },
    {
        maxThreshold: 2000,
        step: 5
    },
    {
        maxThreshold: 5000,
        step: 10
    },
    // For handling largest value directly from loop
    {
        maxThreshold: Infinity,
        step: 25
    }, 
];
var getFraction = function(price) {
    var fraction = {
        up: null,
        down: null
    };
    // Loop fraction list to set up and down fraction step, if both exist loops break
    for(var i = 0; i < fractionList.length; i += 1){
        var _i = fractionList[i], maxThreshold = _i.maxThreshold, step = _i.step;
        if (!fraction.up && price < maxThreshold) fraction.up = step;
        if (!fraction.down && price <= maxThreshold) fraction.down = step;
        if (fraction.up && fraction.down) break;
    }
    return fraction;
};
var getStepFractionByValue = function(price) {
    var fraction = getFraction(price);
    // Loop fraction list to set up and down fraction step, if both exist loops break
    for(var i = 0; i < fractionList.length; i += 1){
        var _i = fractionList[i], maxThreshold = _i.maxThreshold, step = _i.step;
        if (!fraction.up && price < maxThreshold) fraction.up = step;
        if (!fraction.down && price <= maxThreshold) fraction.down = step;
        if (fraction.up && fraction.down) break;
    }
    // Calculate difference between fraction and price to round to fraction set
    var diffFractUp = price % fraction.up;
    var diffFractDown = price % fraction.down;
    return {
        up: diffFractUp === 0 ? fraction.up : fraction.up - diffFractUp,
        down: diffFractUp === 0 ? fraction.down : diffFractDown
    };
};


/***/ }),

/***/ 77596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ usePortfolio; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Securities/websocket/store/securities.store.types.ts
var securities_store_types = __webpack_require__(17985);
// EXTERNAL MODULE: ./src/global/Securities/websocket/SecuritiesContext.tsx
var SecuritiesContext = __webpack_require__(46895);
// EXTERNAL MODULE: ./src/global/Securities/websocket/utils.ts
var utils = __webpack_require__(46238);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/usePortfolioSender.ts




function usePortfolioSender() {
    var ref = (0,SecuritiesContext/* useSecuritiesContext */.S)(), setChannel = ref.setChannel, socket = ref.socket, token = ref.token, isAuthorized = ref.isAuthorized;
    var handleAction = (0,react.useCallback)(function(actionType) {
        var accountNumber = (0,utils/* getAccountNumber */.cH)();
        var isSubscribe = actionType === securities_store_types/* PayloadCase.SUBSCRIBE */.e7.SUBSCRIBE;
        var channelPayload = isSubscribe ? utils/* default.createSubscribePayload */.ZP.createSubscribePayload(accountNumber) : utils/* default.createUnsubscribePayload */.ZP.createUnsubscribePayload(accountNumber);
        if (socket && accountNumber) {
            setChannel(securities_store_types/* SecuritiesChannel.SECURITIES */.Jd.SECURITIES, channelPayload);
        }
    }, [
        setChannel,
        socket,
        token
    ]);
    (0,react.useEffect)(function() {
        if (isAuthorized) {
            handleAction(securities_store_types/* PayloadCase.SUBSCRIBE */.e7.SUBSCRIBE);
        }
        return function() {
            handleAction(securities_store_types/* PayloadCase.UNSUBSCRIBE */.e7.UNSUBSCRIBE);
        };
    }, [
        isAuthorized,
        handleAction
    ]);
};

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/Securities/stores/usePortfolioDetailStore.ts + 1 modules
var usePortfolioDetailStore = __webpack_require__(98976);
// EXTERNAL MODULE: ./src/global/Securities/stores/useOrderDetailStore.ts
var useOrderDetailStore = __webpack_require__(87127);
// EXTERNAL MODULE: ./src/utils/securities/formatter.ts
var formatter = __webpack_require__(89237);
// EXTERNAL MODULE: ./src/global/Securities/types/store/order.ts
var order = __webpack_require__(91037);
;// CONCATENATED MODULE: ./src/utils/securities/transformWebsocketData.ts


var convertSideToAction = function(side) {
    return side === order/* iOrderSide.BUY */.vT.BUY ? order/* OrderAction.Buy */.iX.Buy : order/* OrderAction.Sell */.iX.Sell;
};
var portfolioSummary = function(portfolio) {
    var ref = portfolio !== null && portfolio !== void 0 ? portfolio : {}, trading = ref.trading, amount = ref.amount, profitLoss = ref.profitLoss, gain = ref.gain, equity = ref.equity, debt = ref.debt;
    return {
        tradingbalance: trading === null || trading === void 0 ? void 0 : trading.balance,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_allocated: amount === null || amount === void 0 ? void 0 : amount.allocated,
        amount_creditlimit: amount === null || amount === void 0 ? void 0 : amount.creditLimit,
        unrealised_profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.unrealised,
        realised_profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.realised,
        profitloss: profitLoss === null || profitLoss === void 0 ? void 0 : profitLoss.net,
        gain: gain,
        equity: equity,
        debt_ratio: debt === null || debt === void 0 ? void 0 : debt.ratio,
        debt_total: debt === null || debt === void 0 ? void 0 : debt.total,
        debt_market_value: debt === null || debt === void 0 ? void 0 : debt.marketValue
    };
};
var portfolioItem = function(data) {
    var ref = data !== null && data !== void 0 ? data : {}, asset = ref.asset, company = ref.company, exercise = ref.exercise, flags = ref.flags, price = ref.price, qty = ref.qty, symbol = ref.symbol, isSharia = ref.isSharia;
    return {
        allow_order: (0,formatter/* convertBooleanToNumber */.y0)(flags === null || flags === void 0 ? void 0 : flags.allowOrder),
        amount_invested: asset === null || asset === void 0 ? void 0 : asset.amountInvested,
        available_lot: qty === null || qty === void 0 ? void 0 : qty.available.lot,
        available_share: qty === null || qty === void 0 ? void 0 : qty.available.share,
        balance_lot: qty === null || qty === void 0 ? void 0 : qty.balance.lot,
        balance_share: qty === null || qty === void 0 ? void 0 : qty.balance.share,
        company_name: company === null || company === void 0 ? void 0 : company.name,
        exercise_data: (0,formatter/* getExercisedData */.a$)(exercise),
        exercise_type: exercise === null || exercise === void 0 ? void 0 : exercise.type,
        have_smartorder: flags === null || flags === void 0 ? void 0 : flags.haveSmartOrder,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_latest: price === null || price === void 0 ? void 0 : price.latest,
        stock_on_hand: qty === null || qty === void 0 ? void 0 : qty.stockOnHand,
        symbol: symbol,
        total: asset === null || asset === void 0 ? void 0 : asset.amountInvested,
        unrealised_gain: asset === null || asset === void 0 ? void 0 : asset.unrealised.gain,
        unrealised_marketvalue: asset === null || asset === void 0 ? void 0 : asset.unrealised.marketValue,
        unrealised_profitloss: asset === null || asset === void 0 ? void 0 : asset.unrealised.profitLoss,
        can_buy: flags === null || flags === void 0 ? void 0 : flags.canBuy,
        can_sell: flags === null || flags === void 0 ? void 0 : flags.canSell,
        is_sharia: isSharia
    };
};
var portfolioList = function(portfolio) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = portfolio !== null && portfolio !== void 0 ? portfolio : {}, summary = ref10.summary, smartOrderInfo = ref10.smartOrderInfo, results = ref10.results, dayTrade = ref10.dayTrade;
    return {
        tradingbalance: summary === null || summary === void 0 ? void 0 : (ref = summary.trading) === null || ref === void 0 ? void 0 : ref.balance,
        amount_invested: summary === null || summary === void 0 ? void 0 : (ref1 = summary.amount) === null || ref1 === void 0 ? void 0 : ref1.invested,
        amount_allocated: summary === null || summary === void 0 ? void 0 : (ref2 = summary.amount) === null || ref2 === void 0 ? void 0 : ref2.allocated,
        amount_creditlimit: summary === null || summary === void 0 ? void 0 : (ref3 = summary.amount) === null || ref3 === void 0 ? void 0 : ref3.creditLimit,
        unrealised_profitloss: summary === null || summary === void 0 ? void 0 : (ref4 = summary.profitLoss) === null || ref4 === void 0 ? void 0 : ref4.unrealised,
        realised_profitloss: summary === null || summary === void 0 ? void 0 : (ref5 = summary.profitLoss) === null || ref5 === void 0 ? void 0 : ref5.realised,
        profitloss: summary === null || summary === void 0 ? void 0 : (ref6 = summary.profitLoss) === null || ref6 === void 0 ? void 0 : ref6.net,
        gain: summary === null || summary === void 0 ? void 0 : summary.gain,
        equity: summary === null || summary === void 0 ? void 0 : summary.equity,
        show_create_smartorder: smartOrderInfo === null || smartOrderInfo === void 0 ? void 0 : smartOrderInfo.canCreate,
        auto_order_info: smartOrderInfo === null || smartOrderInfo === void 0 ? void 0 : smartOrderInfo.info,
        result: results === null || results === void 0 ? void 0 : results.map(function(result) {
            return portfolioItem(result);
        }),
        day_trade: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.map(function(result) {
            return portfolioItem(result);
        }),
        debt_ratio: summary === null || summary === void 0 ? void 0 : (ref7 = summary.debt) === null || ref7 === void 0 ? void 0 : ref7.ratio,
        debt_total: summary === null || summary === void 0 ? void 0 : (ref8 = summary.debt) === null || ref8 === void 0 ? void 0 : ref8.total,
        debt_market_value: summary === null || summary === void 0 ? void 0 : (ref9 = summary.debt) === null || ref9 === void 0 ? void 0 : ref9.marketValue
    };
};
var orderDetail = function(order) {
    var ref, ref1;
    var ref2 = order !== null && order !== void 0 ? order : {}, action = ref2.action, amount = ref2.amount, dayTrade = ref2.dayTrade, gtc = ref2.gtc, marketOrderId = ref2.marketOrderId, message = ref2.message, orderId = ref2.orderId, price = ref2.price, qty = ref2.qty, side = ref2.side, smartOrder = ref2.smartOrder, statusText = ref2.statusText, symbol = ref2.symbol, time = ref2.time, isSharia = ref2.isSharia, securitiesKind = ref2.securitiesKind;
    var securities_kind = (0,formatter/* convertSecuritiesKind */.KH)(securitiesKind);
    var isBond = securities_kind === "SECURITIES_KIND_BOND";
    return {
        action: convertSideToAction(side),
        amend_action: action.canAmend,
        amount: amount === null || amount === void 0 ? void 0 : amount.amount,
        amount_fee: amount === null || amount === void 0 ? void 0 : amount.fee.amount,
        amount_invested: amount === null || amount === void 0 ? void 0 : amount.invested,
        amount_invested_fee: amount === null || amount === void 0 ? void 0 : amount.fee.invested,
        amount_matched: isBond ? amount === null || amount === void 0 ? void 0 : (ref = amount.fee) === null || ref === void 0 ? void 0 : ref.invested : amount === null || amount === void 0 ? void 0 : amount.matched,
        amount_matched_broker_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.broker,
        amount_matched_exchange_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.exchange,
        amount_matched_fee: amount === null || amount === void 0 ? void 0 : amount.fee.matched.amount,
        amount_matched_total: amount === null || amount === void 0 ? void 0 : amount.matchedTotal,
        amount_open: amount === null || amount === void 0 ? void 0 : amount.open,
        amount_open_fee: amount === null || amount === void 0 ? void 0 : amount.fee.open,
        cancel_action: action.canCancel,
        config_type: (0,formatter/* convertSmartOrderConfigType */.Hc)(smartOrder === null || smartOrder === void 0 ? void 0 : (ref1 = smartOrder.configType) === null || ref1 === void 0 ? void 0 : ref1.toString()),
        gtc: (0,formatter/* convertBooleanToNumber */.y0)(gtc === null || gtc === void 0 ? void 0 : gtc.isGtc),
        label: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.label,
        market_orderid: marketOrderId,
        message: message,
        order_done: qty === null || qty === void 0 ? void 0 : qty.lotDone,
        order_open: qty === null || qty === void 0 ? void 0 : qty.lotOpen,
        order_total: qty === null || qty === void 0 ? void 0 : qty.lotTotal,
        orderid: orderId,
        price: price === null || price === void 0 ? void 0 : price.order,
        price_average: price === null || price === void 0 ? void 0 : price.average.price,
        price_average_fee: price === null || price === void 0 ? void 0 : price.average.fee,
        price_order: price === null || price === void 0 ? void 0 : price.order,
        smart_orderid: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.orderId,
        status: statusText,
        symbol: symbol,
        securities_kind: securities_kind,
        time: (0,formatter/* getHourFromTimestamp */.aF)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.open)),
        time_match: (0,formatter/* convertTimestampToDate */.gg)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.match)),
        time_open: (0,formatter/* convertTimestampToDate */.gg)((0,formatter/* getTime */.hK)(time === null || time === void 0 ? void 0 : time.open)),
        trigger_price: smartOrder === null || smartOrder === void 0 ? void 0 : smartOrder.triggerPrice,
        day_trade_is_day_trade: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.isDayTrade,
        day_trade_force_sell_event: (0,formatter/* convertForceSellEvent */.zn)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.forceSellEvent),
        day_trade_message: dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.message,
        is_sharia: isSharia
    };
};
var orderList = function(response) {
    var orders = (response !== null && response !== void 0 ? response : {}).orders;
    return orders === null || orders === void 0 ? void 0 : orders.map(function(order) {
        return orderDetail(order);
    });
};
/* harmony default export */ var transformWebsocketData = ({
    portfolioSummary: portfolioSummary,
    portfolioItem: portfolioItem,
    portfolioList: portfolioList,
    orderDetail: orderDetail,
    orderList: orderList
});

;// CONCATENATED MODULE: ./src/global/Securities/websocket/hooks/useSecuritiesMessage.ts


var useSecuritiesMessage = function(channel, action) {
    var ref = (0,react.useContext)(SecuritiesContext/* SecuritiesContext */.i), setAction = ref.setAction, removeAction = ref.removeAction;
    (0,react.useEffect)(function() {
        if (action) {
            setAction(channel, action);
            return function() {
                removeAction(channel);
            };
        }
        return undefined;
    }, [
        channel,
        action,
        setAction,
        removeAction
    ]);
};
/* harmony default export */ var hooks_useSecuritiesMessage = (useSecuritiesMessage);

// EXTERNAL MODULE: ./src/global/Securities/websocket/constants.ts
var constants = __webpack_require__(93313);
;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/usePortfolioReceiver.ts








function usePortfolioReceiver() {
    var ref = (0,tradingData/* default */.Z)(function(s) {
        return {
            updatePortfolioSummary: s.updatePortfolioSummary,
            updatePortfolioList: s.updatePortfolioList,
            updatePortfolioItem: s.updatePortfolioItem,
            deletePortfolioListItem: s.deletePortfolioItem,
            updateOrderList: s.updateOrderList,
            updateOrderListItem: s.updateOrderListItem,
            deleteOrderListItem: s.deleteOrderListItem
        };
    }, shallow/* default */.Z), updatePortfolioSummary = ref.updatePortfolioSummary, updatePortfolioList = ref.updatePortfolioList, updatePortfolioItem = ref.updatePortfolioItem, deletePortfolioListItem = ref.deletePortfolioListItem, updateOrderList = ref.updateOrderList, updateOrderListItem = ref.updateOrderListItem, deleteOrderListItem = ref.deleteOrderListItem;
    var updatePortfolioDetail = (0,usePortfolioDetailStore/* default */.Z)(function(s) {
        return {
            updatePortfolioDetail: s.updatePortfolioDetail
        };
    }, shallow/* default */.Z).updatePortfolioDetail;
    var updateOrderDetail = (0,useOrderDetailStore/* default */.Z)(function(s) {
        return {
            updateOrderDetail: s.updateOrderDetail
        };
    }, shallow/* default */.Z).updateOrderDetail;
    var handleReceiveMessage = (0,react.useCallback)(function(param) {
        var messageAction = param.action, message = param.message;
        if (!message) return;
        switch(message.case){
            case constants/* SecuritiesMessageCase.SUMMARY */.FJ.SUMMARY:
                {
                    var transformedData = transformWebsocketData.portfolioSummary(message.value);
                    updatePortfolioSummary(transformedData);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_LIST */.FJ.PORTFOLIO_LIST:
                {
                    var transformedData1 = transformWebsocketData.portfolioList(message.value);
                    updatePortfolioList(transformedData1);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_DETAIL */.FJ.PORTFOLIO_DETAIL:
                {
                    var transformedData2 = transformWebsocketData.portfolioItem(message.value);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deletePortfolioListItem(transformedData2.symbol);
                        break;
                    }
                    updatePortfolioDetail(transformedData2);
                    updatePortfolioItem(transformedData2.symbol, transformedData2);
                    break;
                }
            case constants/* SecuritiesMessageCase.PORTFOLIO_DETAIL_DAY_TRADE */.FJ.PORTFOLIO_DETAIL_DAY_TRADE:
                {
                    var transformedData3 = transformWebsocketData.portfolioItem(message.value);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deletePortfolioListItem(transformedData3.symbol, true);
                        break;
                    }
                    updatePortfolioDetail(transformedData3, true, true);
                    updatePortfolioItem(transformedData3.symbol, transformedData3, true);
                    break;
                }
            case constants/* SecuritiesMessageCase.ORDER_LIST */.FJ.ORDER_LIST:
                {
                    var transformedData4 = transformWebsocketData.orderList(message.value);
                    updateOrderList(transformedData4);
                    break;
                }
            case constants/* SecuritiesMessageCase.ORDER_DETAIL */.FJ.ORDER_DETAIL:
                {
                    var transformedData5 = transformWebsocketData.orderDetail(message.value);
                    updateOrderListItem(transformedData5.orderid, transformedData5);
                    updateOrderDetail(transformedData5);
                    if (messageAction === constants/* DATA_ACTION.DELETE */.S0.DELETE) {
                        deleteOrderListItem(transformedData5.orderid);
                    }
                    break;
                }
            default:
                break;
        }
    }, []);
    hooks_useSecuritiesMessage("securities", handleReceiveMessage);
};

;// CONCATENATED MODULE: ./src/global/Securities/websocket/usePortfolio/index.ts


var useGenPortfolio = function() {
    usePortfolioSender();
    usePortfolioReceiver();
};
/* harmony default export */ var usePortfolio = (useGenPortfolio);


/***/ }),

/***/ 70536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TradingModal_OrderPlacedModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
;// CONCATENATED MODULE: ./src/global/Icons/ShareSvg.tsx

var ShareSvg = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_7968_43563)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.25 10V14.6666C5.25 14.976 5.37292 15.2728 5.59171 15.4916C5.8105 15.7104 6.10724 15.8333 6.41666 15.8333H13.4166C13.726 15.8333 14.0228 15.7104 14.2415 15.4916C14.4603 15.2728 14.5833 14.976 14.5833 14.6666V10",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.2501 6.49982L9.91681 4.1665L7.5835 6.49982",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.91663 4.1665V11.7498",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_7968_43563",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(0.25)"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Icons_ShareSvg = (ShareSvg);

// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/features/sharetrade/analytics/shareTradeShareTracker.ts
var shareTradeShareTracker = __webpack_require__(56371);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
;// CONCATENATED MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx
















var Button = ui/* Common.Button */.Gn.Button, Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text, Modal = ui/* Common.Modal */.Gn.Modal;
function OrderPlacedModal(param) {
    var visible = param.visible, onSubmit = param.onSubmit, orderType = param.orderType;
    var isAmend = (0,react.useMemo)(function() {
        return orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    }, [
        orderType
    ]);
    var symbol = (0,store/* default */.Z)(function(s) {
        return s.symbol;
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.orderType,
            s.resetShareTradeModal
        ];
    }, shallow/* default */.Z), 2), shareOrderType = ref[0], resetShareTradeModal = ref[1];
    var isShowShareButton = (0,react.useMemo)(function() {
        return !isAmend && [
            transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder,
            transaction/* SellOrderType.LimitOrder */.qK.LimitOrder
        ].includes(shareOrderType);
    }, [
        isAmend,
        shareOrderType
    ]);
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.isVisible,
            s.setIsVisible,
            s.setSharedUsers
        ];
    }, shallow/* default */.Z), 3), isShareTradeVisible = ref1[0], setIsShareTradeVisible = ref1[1], setSharedUsers = ref1[2];
    var isOrderModalVisible = (0,react.useMemo)(function() {
        return visible && !isShareTradeVisible;
    }, [
        visible,
        isShareTradeVisible
    ]);
    var handleSubmit = function() {
        resetShareTradeModal();
        setSharedUsers({});
        onSubmit();
    };
    var handleShareTradeClick = function() {
        setIsShareTradeVisible(true);
        (0,shareTradeShareTracker/* trackOrderShareSelected */.M1)(orderType, symbol);
    };
    (0,react.useEffect)(function() {
        // don't track if the modal is visible and it is a bond transaction
        if (!visible || orderType === trading/* ORDER_TYPE.BOND */.Jm.BOND) {
            return;
        }
        if (orderType) {
            (0,securities/* clevertapOrderReceived */.dQ)({
                orderType: orderType
            });
            (0,autoOrder/* trackAutoBuyOrderReceivedView */.Bi)();
        }
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        visible: isOrderModalVisible,
        closable: false,
        width: "420px",
        centered: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
                direction: "column",
                align: "center",
                padding: "50px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/icon/previewOrder-success.svg",
                        alt: "order-placed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        family: "bold",
                        padding: "5px",
                        children: "Order is Now Placed"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* OrderPlacedConfirmWrapper */.Yc, {
                justify: "space-between",
                width: "100%",
                children: [
                    isShowShareButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ShareTradeButton */.Ae, {
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: Icons_ShareSvg
                        }),
                        type: "default",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        onClick: handleShareTradeClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            align: "inherit",
                            color: "inherit",
                            family: "bold",
                            size: "14px",
                            children: "Share Trade"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: handleSubmit,
                        type: "primary",
                        radius: "4px",
                        block: true,
                        height: "44px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                            align: "inherit",
                            color: "inherit",
                            family: "bold",
                            size: "14px",
                            children: "Done"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var TradingModal_OrderPlacedModal = (OrderPlacedModal);


/***/ }),

/***/ 89279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25935);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(29658);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83153);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36902);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70362);








var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
function AnnouncementModal(param) {
    var visible = param.visible, orderType = param.orderType, closeModal = param.closeModal, onSubmit = param.onSubmit, showTransactionModal = param.showTransactionModal;
    var isExerciseType = orderType === constants_trading__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE;
    var ref = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), _rightTradeable = ref.rightTradeable, rightData = _rightTradeable.data, _exercise = ref.exercise, exerciseData = _exercise.data;
    var showModal = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().showModal;
    var is_tradeable = rightData === null || rightData === void 0 ? void 0 : rightData.is_tradeable;
    var not_tradeable_type;
    var not_tradeable_reason = rightData === null || rightData === void 0 ? void 0 : rightData.message;
    var end_date_exercise;
    var is_exerciseable = true;
    var not_exerciseable_type;
    var not_exerciseable_reason;
    var differentTradeable = (rightData === null || rightData === void 0 ? void 0 : rightData.is_tradeable) && exerciseData && !exerciseData.is_tradeable;
    if (!rightData || differentTradeable) {
        is_tradeable = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.is_tradeable;
        not_tradeable_type = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_tradeable_type;
        not_tradeable_reason = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_tradeable_reason;
    }
    if (exerciseData) {
        is_exerciseable = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.is_exerciseable;
        not_exerciseable_reason = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_exerciseable_reason;
        end_date_exercise = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.end_date_exercise;
        not_exerciseable_type = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_exerciseable_type;
        if (!is_tradeable && !not_tradeable_type) {
            not_tradeable_type = exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.not_tradeable_type;
        }
    }
    var showDates = [
        "MAX_EXERCISE_AT",
        "SELL_RECOMMEND"
    ];
    var announcementType = isExerciseType ? not_exerciseable_type : not_tradeable_type;
    var isOutOfSession = announcementType === "OUT_OF_SESSION";
    var messageReasonToRender = isExerciseType ? not_exerciseable_reason : not_tradeable_reason;
    var handleClick = function() {
        if (announcementType === "SELL_RECOMMEND") {
            showModal({
                orderType: constants_trading__WEBPACK_IMPORTED_MODULE_4__/* .ORDER_TYPE.SELL */ .Jm.SELL
            });
            showTransactionModal();
            return;
        }
        var isExercisable = isExerciseType && is_exerciseable;
        var notExerciseTradeable = !isExerciseType && is_tradeable;
        var notExerciseRightTradable = !isExerciseType && (rightData === null || rightData === void 0 ? void 0 : rightData.is_tradeable) && !isOutOfSession;
        if (isExercisable || notExerciseTradeable || notExerciseRightTradable) {
            showTransactionModal();
            return;
        }
        if (onSubmit) onSubmit();
        else closeModal();
    };
    var broadcast = "/images/broadcast.svg";
    var not_found = "/images/data_not_found.svg";
    var icon = {
        DEFAULT: broadcast,
        OUT_OF_SESSION: not_found
    };
    var titles = {
        OUT_OF_SESSION: "Transaksi Tidak Dapat Dilakukan",
        DEFAULT: "Perhatian"
    };
    var buttons = {
        EXPIRED: "Lanjut",
        MAX_EXERCISE_AT: isExerciseType ? "Oke, Mengerti" : "Lanjut",
        SELL_RECOMMEND: "Sell",
        DEFAULT: "Oke, Mengerti"
    };
    var buttonTypes = {
        SELL_RECOMMEND: "danger",
        DEFAULT: "primary"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
        visible: visible,
        closable: false,
        centered: true,
        width: "375px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                direction: "column",
                align: "center",
                padding: "30px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        src: icon[announcementType] || icon.DEFAULT,
                        alt: "Announcement"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        align: "center",
                        family: "bold",
                        size: "16px",
                        my: "16px",
                        children: titles[announcementType] || titles.DEFAULT
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        align: "center",
                        color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray,
                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(messageReasonToRender || "-")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        condition: showDates.includes(announcementType) && end_date_exercise,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            color: "#f5931b",
                            family: "bold",
                            pt: "15px",
                            children: end_date_exercise
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Flex, {
                justify: "space-between",
                style: {
                    position: "absolute",
                    bottom: "-50px",
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                    type: buttonTypes[announcementType] || buttonTypes.DEFAULT,
                    radius: "4px",
                    block: true,
                    height: "40px",
                    onClick: handleClick,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        align: "inherit",
                        color: "white",
                        family: "bold",
                        size: "16px",
                        children: buttons[announcementType] || buttons.DEFAULT
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AnnouncementModal);


/***/ }),

/***/ 32471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useBondInfoModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38875);




var initialState = {
    modalInfoType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondInfoType.UNSPECIFIED */ .Im.UNSPECIFIED
};
var useBondInfoModal = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
        openInfoModal: function openInfoModal(infoType) {
            set({
                modalInfoType: infoType
            });
        },
        closeInfoModal: function closeInfoModal() {
            set({
                modalInfoType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondInfoType.UNSPECIFIED */ .Im.UNSPECIFIED
            });
        }
    });
});


/***/ }),

/***/ 70098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ FieldSet; },
/* harmony export */   "CQ": function() { return /* binding */ CouponHistoryContainer; },
/* harmony export */   "F0": function() { return /* binding */ ModalContainer; },
/* harmony export */   "OT": function() { return /* binding */ UnitInput; },
/* harmony export */   "Y0": function() { return /* binding */ ModalRoot; },
/* harmony export */   "a$": function() { return /* binding */ BorderedContainer; },
/* harmony export */   "fe": function() { return /* binding */ ModalBody; },
/* harmony export */   "gN": function() { return /* binding */ Field; },
/* harmony export */   "mz": function() { return /* binding */ ModalFooter; },
/* harmony export */   "pT": function() { return /* binding */ TextLoadingShimmer; },
/* harmony export */   "w2": function() { return /* binding */ HistoryGroupContainer; },
/* harmony export */   "xB": function() { return /* binding */ ModalHeader; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; }
/* harmony export */ });
/* unused harmony export InputSectionWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 264px;\n  min-width: 415px;\n\n  padding: 20px;\n\n  max-width: 100%;\n\n  .ant-modal-close {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      min-width: 503px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  min-height: 126px;\n\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 24px;\n  margin-bottom: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-form-item {\n    margin-bottom: 20px;\n  }\n  .ant-slider-rail {\n    background-color: #dadada;\n    display: block;\n  }\n  .ant-row.ant-form-item {\n    height: 24px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #dadada;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  background-color: #ededed;\n  border-radius: 4px;\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-form-item-control-input {\n    background-color: ",
        ";\n    border: ",
        ";\n    padding-left: ",
        ";\n    color: ",
        ";\n    border-radius: 2px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Firefox */\n  -moz-appearance: textfield !important;\n\n  :focus::placeholder {\n    color: transparent;\n  }\n  ::placeholder {\n    letter-spacing: -1px;\n  }\n\n  /* Chrome, Safari, Edge, Opera */\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n\n    margin: 0;\n  }\n\n  caret-color: #1db87a;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  width: 100%;\n  padding: 8px 0px;\n  border-bottom: 1px solid #f1f1f1;\n\n  :last-of-type {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 2px;\n\n  min-height: 360px;\n  max-height: 400px;\n\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
var ModalRoot = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Modal).attrs({
    width: "auto",
    type: "transparent",
    centered: true
}).withConfig({
    componentId: "sc-b9b1e5b0-0"
})(_templateObject());
var ModalContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-1"
})(_templateObject2(), function(p) {
    return p.modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1());
});
var ModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-2"
})(_templateObject3());
var ModalBody = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-3"
})(_templateObject4());
var ModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-4"
})(_templateObject5());
var InputSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-5"
})(_templateObject6());
var Field = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-6"
})(_templateObject7(), function(p) {
    return p.isAccordion ? "16px" : 0;
});
var FieldSet = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-7"
})(_templateObject8());
var BorderedContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-8"
})(_templateObject9());
var TextLoadingShimmer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-9"
})(_templateObject10(), function(p) {
    return p.height || "16px";
}, function(p) {
    return p.width || "100%";
});
var FormItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-b9b1e5b0-10"
})(_templateObject11(), function(props) {
    return props.disabled ? "#f7f7f7" : "transparent";
}, function(props) {
    return props.disabled ? "1px solid #dadada" : "none";
}, function(props) {
    return props.disabled ? "8px" : "unset";
}, function(props) {
    return props.disabled ? "#858585" : "unset";
});
var UnitInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b9b1e5b0-11"
})(_templateObject12());
var HistoryGroupContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-12"
})(_templateObject13());
var CouponHistoryContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-b9b1e5b0-13"
})(_templateObject14());


/***/ }),

/***/ 29735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondsAnalytics; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);



var EVENTS_NAMES = {
    bondsPageViewed: "FR Bonds Page Viewed",
    bondProductPageViewed: "FR Bonds Product Page Viewed",
    bondOrderPageViewed: "FR Bonds Order Page Viewed",
    bondPreviewOrderViewed: "FR Bonds Preview Order Viewed",
    bondOrderSuccessViewed: "FR Bonds Order Success Viewed",
    bondsAction: "FR Bonds Action"
};
var PAGE_NAMES = {
    "/stream": "Stream Page",
    "/symbol": "Product Page",
    "/securities": "Portofolio List",
    "/watchlist": "Watchlist Page",
    "/screener": "Screener Page",
    "/valuation": "Valuation Page",
    "/sector": "Sector Page",
    "/community": "Community Page"
};
function useBondsAnalytics() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // fill the search related page
    var defaultPageSource = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var pageNames = Object.keys(PAGE_NAMES);
        var pageIndex = pageNames.find(function(path) {
            return router.pathname.startsWith(path) ? path : undefined;
        });
        if (pageIndex) {
            return PAGE_NAMES[pageIndex];
        }
        return "Search Page";
    }, [
        router.pathname
    ]);
    var FRBondsNavigateTrackers = {
        // When user landing on FR Bonds page
        onBondPageViewed: function onBondPageViewed(section) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsPageViewed, {
                Section: section
            });
        },
        // When user landing on FR Bonds Product page
        onBondProductPageViewed: function onBondProductPageViewed(symbol, yieldValue) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondProductPageViewed, {
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order page
        onBondOrderPageViewed: function onBondOrderPageViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderPageViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Preview Order page
        onBondPreviewOrderViewed: function onBondPreviewOrderViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondPreviewOrderViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order Success page
        onBondOrderSuccessViewed: function onBondOrderSuccessViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderSuccessViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    var FRBondActionTrackers = {
        // When user click FR Bonds introduction banner
        onIntroductionBannerClicked: function onIntroductionBannerClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "Introduction Banner Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click “Saya Setuju” on FR Bonds TnC
        onTnCConfirmed: function onTnCConfirmed() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "TnC Confirmed"
            });
        },
        // When user click FR Bonds Section/Catalog to be redirected to FR Bonds list
        onFRProductListClicked: function onFRProductListClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Product List Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click buy/sell button on FR product to initiate order
        onOrderButtonClicked: function onOrderButtonClicked(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Button Clicked",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page to finalize order
        onOrderPlaced: function onOrderPlaced(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Placed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page, confirming the order
        onOrderConfirmed: function onOrderConfirmed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Confirmed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    return {
        FRBondsNavigateTrackers: FRBondsNavigateTrackers,
        FRBondActionTrackers: FRBondActionTrackers
    };
};


/***/ }),

/***/ 3415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var lib_analytics_securities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91154);
/* harmony import */ var global_TradingModal_RealTradingModal_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53616);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76805);







var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, IconWrapper = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconWrapper */ .Gn.IconWrapper, Iconmoon = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Iconmoon */ .Gn.Iconmoon;
function ExchangeFeeModal(param) {
    var visible = param.visible, closeModal = param.closeModal, orderType = param.orderType;
    var securitiesPreviewFeeData = localStorage.getItem("securitiesPreviewFeeData");
    var securitiesPreviewFeeDataDayTrade = localStorage.getItem("securitiesPreviewFeeDataDayTrade");
    var dayTradeActive = (0,global_TradingModal_RealTradingModal_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().dayTradeActive;
    var previewFeeData = dayTradeActive ? securitiesPreviewFeeDataDayTrade : securitiesPreviewFeeData;
    var ref = JSON.parse(previewFeeData) || {
        exchange: {}
    }, _exchange = ref.exchange, title = _exchange.title, desc = _exchange.desc, subtitle = _exchange.subtitle, compositions = _exchange.compositions, exchange_fee_total_title = _exchange.exchange_fee_total_title, exchange_fee_total_buy = _exchange.exchange_fee_total_buy, exchange_fee_total_sell = _exchange.exchange_fee_total_sell;
    var isSell = orderType === constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL || orderType === constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .ORDER_TYPE.SELL */ .Jm.SELL;
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (visible) (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_3__/* .clevertapExchangeFee */ .Sv)(orderType);
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        closable: false,
        width: "420px",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconWrapper, {
                style: {
                    position: "absolute",
                    left: "30px",
                    top: "20px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Iconmoon, {
                    size: "25px",
                    className: "icon-notification_back",
                    onClick: closeModal
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                size: "16px",
                align: "center",
                family: "bold",
                padding: "20px",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                direction: "column",
                padding: "10px 35px 30px 35px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        children: desc
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        mt: "10px",
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                        direction: "column",
                        padding: "15px",
                        mt: "10px",
                        width: "100%",
                        style: {
                            border: "1px solid #dadada",
                            borderRadius: "5px"
                        },
                        children: [
                            compositions.map(function(param) {
                                var name = param.name, value = param.value, type = param.type;
                                if (type === 3 || isSell) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .FeeItem */ .A5, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                                                children: [
                                                    value,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }, value);
                                }
                                return null;
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_6__/* .FeeItem */ .A5, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                        family: "bold",
                                        py: "8px",
                                        children: exchange_fee_total_title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                                        family: "bold",
                                        children: [
                                            (isSell ? exchange_fee_total_sell : exchange_fee_total_buy) * 100,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ExchangeFeeModal);


/***/ }),

/***/ 73510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RealTradingModal_PreviewOrderModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts + 1 modules
var useTradingInfoStore = __webpack_require__(21734);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/utils/securities/analytics.ts
var analytics = __webpack_require__(67600);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./src/global/Securities/constants/transactionForm.ts
var transactionForm = __webpack_require__(9657);
// EXTERNAL MODULE: ./src/stores/sharetrade/useShareTradeShare.ts
var useShareTradeShare = __webpack_require__(75774);
// EXTERNAL MODULE: ./src/typings/api/shareTradeShare.ts
var shareTradeShare = __webpack_require__(10529);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/features/sharetrade/stores/useShareTradeModal.ts
var useShareTradeModal = __webpack_require__(77064);
// EXTERNAL MODULE: ./src/features/day-trade/utils/formater.ts
var formater = __webpack_require__(22733);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/Table/SplitLotRow/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 12px;\n  width: 100%;\n  flex-direction: column;\n\n  & > div {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 4px;\n\n    &:last-child {\n      margin: 0;\n    }\n\n    & > p {\n      color: #969696;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Flex = ui/* Common.Flex */.Gn.Flex;
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-90545a0b-0"
})(_templateObject(), function(param) {
    var isSplitOrder = param.isSplitOrder;
    return isSplitOrder ? "#f2f1fe" : "";
});
var TotalLotWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-90545a0b-1"
})(_templateObject1());
var ListWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-90545a0b-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/global/Securities/components/Table/SplitLotRow/index.tsx







var Text = ui/* Common.Text */.Gn.Text;
var SplitLotRow = function(param) {
    var _lot = param.lot, lot = _lot === void 0 ? 0 : _lot, disabled = param.disabled;
    var splittedLot = (0,react.useMemo)(function() {
        if (lot <= trading/* SPLIT_ORDER_LOT */.pr) return [];
        var splitLength = Math.floor(lot / trading/* SPLIT_ORDER_LOT */.pr);
        var leftOver = lot - trading/* SPLIT_ORDER_LOT */.pr * splitLength;
        var leftOverArray = leftOver > 0 ? [
            {
                start: splitLength + 1,
                end: null,
                lot: leftOver
            }
        ] : [];
        return [
            {
                start: 1,
                end: splitLength > 1 ? splitLength : null,
                lot: trading/* SPLIT_ORDER_LOT */.pr
            }, 
        ].concat((0,_to_consumable_array/* default */.Z)(leftOverArray));
    }, [
        lot
    ]);
    var isSplitOrder = (0,react.useMemo)(function() {
        return splittedLot.length > 0 && !disabled;
    }, [
        splittedLot
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        "data-cy": "split-order-container",
        isSplitOrder: isSplitOrder,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TotalLotWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        "data-cy": "lot-label",
                        children: "Lot"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        "data-cy": "lot-value",
                        children: (0,number/* formatNumber */.uf)(lot)
                    })
                ]
            }),
            isSplitOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                children: splittedLot.map(function(param, i) {
                    var start = param.start, end = param.end, lotItemValue = param.lot;
                    return(// eslint-disable-next-line react/no-array-index-key -- no unique id key
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                "data-cy": "list-lot-label-".concat(i),
                                children: [
                                    "Order ",
                                    start,
                                    end ? " - ".concat(end) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                "data-cy": "list-lot-value-".concat(i),
                                children: [
                                    end ? "@" : "",
                                    (0,number/* formatNumber */.uf)(lotItemValue)
                                ]
                            })
                        ]
                    }, "split-lot-row-".concat(i)));
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Table_SplitLotRow = (SplitLotRow);

// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/global/Securities/constants/transaction.ts
var constants_transaction = __webpack_require__(94386);
// EXTERNAL MODULE: ./src/global/TradingModal/utils/generateFeeData.ts
var generateFeeData = __webpack_require__(54202);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/store.ts
var RealTradingModal_store = __webpack_require__(53616);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/SellPreview.tsx


















var SellPreview_Flex = ui/* Common.Flex */.Gn.Flex, SellPreview_Text = ui/* Common.Text */.Gn.Text;
function SellPreview(param) {
    var showExchangeFee = param.showExchangeFee;
    var ref = (0,tradingData/* default */.Z)(), company = ref.company, portfolioDetail = ref.portfolioDetail, _configFormula = ref.configFormula, configFormula = _configFormula.data;
    var ref1 = (0,RealTradingModal_store/* default */.Z)(), price = ref1.price, shares = ref1.shares, expiry = ref1.expiry, isSplitOrderActive = ref1.isSplitOrderActive, splitQuantity = ref1.splitQuantity, splitRangeMin = ref1.splitRangeMin, splitRangeMax = ref1.splitRangeMax, dayTradeActive = ref1.dayTradeActive, splitMethod = ref1.splitMethod;
    var _data = company.data, symbol = _data.symbol, productType = _data.type_company;
    var price_average_fee = portfolioDetail.data.price_average_fee;
    var lot = shares / constant/* lotSize */.CQ;
    var isCorporateAction = (0,react.useMemo)(function() {
        return trading/* CorporateActionStockType.includes */.dB.includes(productType.toLowerCase());
    }, [
        productType
    ]);
    var generatedSellData = (0,generateFeeData/* generateSellData */.z)(configFormula, lot, price, price_average_fee, dayTradeActive);
    var brokerFee = generatedSellData.STOCKBIT_FEE, exchangeFee = generatedSellData.TOTAL_EXCHANGE_FEE;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewContainer */.VA, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: "Stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        family: "bold",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: "Expiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: transactionForm/* expiryOptions */.Me[expiry]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SplitLotRow, {
                lot: lot,
                disabled: isSplitOrderActive || !(0,utils/* isRedirectToNewCore */.JI)()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: "Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: (0,number/* formatNumber */.uf)(price, false, "0,00", true)
                    })
                ]
            }),
            isSplitOrderActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                children: "Split Quantity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                children: (0,number/* formatNumber */.uf)(splitQuantity, false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                        justify: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                children: "Split Method"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                children: constants_transaction/* SPLIT_ORDER_COPY */.qc[splitMethod]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                            justify: "space-between",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                    children: "Split Range Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                    children: "".concat((0,number/* formatNumber */.uf)(splitRangeMin, false), " - ").concat((0,number/* formatNumber */.uf)(splitRangeMax, false))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: "Proceed Amount"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Text, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(price * lot * constant/* lotSize */.CQ, false, "0,00", true)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: "Broker Fee"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        children: brokerFee === 0 ? "Free" : "Rp ".concat((0,number/* formatNumber */.uf)(brokerFee, false, "0,00", true))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Flex, {
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                                    children: "Exchange Fee"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/information.svg",
                                    alt: "fee-info",
                                    onClick: showExchangeFee,
                                    style: {
                                        marginLeft: "5px",
                                        width: "12px",
                                        cursor: "pointer"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Text, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(exchangeFee, false, "0,00", true)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SellPreview_Text, {
                        family: "bold",
                        children: "Proceeds (Net Fee)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SellPreview_Text, {
                        family: "bold",
                        children: [
                            "Rp",
                            " ",
                            (0,number/* formatNumber */.uf)((0,formula/* getSellAmountInvestedFee */.B1)(lot, price, isCorporateAction, dayTradeActive), false)
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var PreviewOrderModal_SellPreview = (SellPreview);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/global/Securities/stores/useCashInfoStore.ts
var useCashInfoStore = __webpack_require__(11806);
// EXTERNAL MODULE: ./src/global/Securities/components/Chips/index.tsx
var Chips = __webpack_require__(17348);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
;// CONCATENATED MODULE: ./src/global/TradingModal/utils/generateInvestmentBalance.ts
/* eslint-disable no-new-func */ var generateInvestmentBalance = function(configFormula, price, lot) {
    var multiplier = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dayTradeLeverage = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    var formula = configFormula.formula, day_trade = configFormula.day_trade;
    var LOT = lot;
    var PRICE = price;
    var DAY_TRADE_LEVERAGE = dayTradeLeverage;
    var totalInvestment = new Function("LOT", "PRICE", "return ".concat(formula.buy_amount_invested, ";"))(LOT, PRICE);
    var PORTION_DEDUCT_TO_TB = day_trade.portion_deduct_to_tb;
    var STOCK_MULTIPLIER = multiplier;
    var dayTradeUnrealized = new Function("LOT", "PRICE", "PORTION_DEDUCT_TO_TB", "STOCK_MULTIPLIER", "return ".concat(formula.day_trade_debt_unrealized, ";"))(LOT, PRICE, PORTION_DEDUCT_TO_TB, STOCK_MULTIPLIER);
    var ORDER_UNREALIZED_DAY_TRADE_DEBT = dayTradeUnrealized;
    var investmentDayTrade = new Function("ORDER_UNREALIZED_DAY_TRADE_DEBT", "DAY_TRADE_LEVERAGE", "const min = Math.min;\n    return ".concat(formula.day_trade_investment_day_trade, ";"))(ORDER_UNREALIZED_DAY_TRADE_DEBT, DAY_TRADE_LEVERAGE);
    var INVESTMENT_DAY_TRADE = investmentDayTrade;
    var investmentTradingBalance = new Function("LOT", "PRICE", "INVESTMENT_DAY_TRADE", "return ".concat(formula.day_trade_investment_portion_tb, ";"))(LOT, PRICE, INVESTMENT_DAY_TRADE);
    return {
        totalInvestment: totalInvestment,
        investmentDayTrade: investmentDayTrade,
        investmentTradingBalance: investmentTradingBalance
    };
};
/* harmony default export */ var utils_generateInvestmentBalance = (generateInvestmentBalance);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/BuyPreview.tsx























var BuyPreview_Flex = ui/* Common.Flex */.Gn.Flex, BuyPreview_Text = ui/* Common.Text */.Gn.Text;
function BuyPreview(param) {
    var showExchangeFee = param.showExchangeFee;
    var ref = (0,react.useState)(false), openInvestment = ref[0], setOpenInvestment = ref[1];
    var ref1 = (0,store/* default */.Z)(function(s) {
        return {
            isAutoBuy: s.isAutoBuy,
            symbol: s.symbol
        };
    }), isAutoBuy = ref1.isAutoBuy, symbol = ref1.symbol;
    var ref2 = (0,tradingData/* default */.Z)(), _configFormula = ref2.configFormula, configFormula = _configFormula.data;
    var ref3 = (0,RealTradingModal_store/* default */.Z)(), price = ref3.price, expiry = ref3.expiry, shares = ref3.shares, buyOrderType = ref3.type, triggerPrice = ref3.triggerPrice, isSplitOrderActive = ref3.isSplitOrderActive, splitQuantity = ref3.splitQuantity, splitRangeMin = ref3.splitRangeMin, splitRangeMax = ref3.splitRangeMax, dayTradeActive = ref3.dayTradeActive, dayTradeMultiplier = ref3.dayTradeMultiplier, splitMethod = ref3.splitMethod;
    var dayTradeLeverage = (0,useCashInfoStore/* default */.Z)(function(s) {
        return s.dayTradeLeverage;
    }, shallow/* default */.Z);
    var lot = shares / constant/* lotSize */.CQ;
    var ref4 = (0,generateFeeData/* generateBuyFeeData */.V)(configFormula, lot, price, dayTradeActive), investmentPlusFee = ref4.investmentPlusFee, brokerFee = ref4.brokerFee, exchangeFee = ref4.exchangeFee;
    var ref5 = utils_generateInvestmentBalance(configFormula, price, lot, dayTradeMultiplier, dayTradeLeverage), totalInvestment = ref5.totalInvestment, investmentDayTrade = ref5.investmentDayTrade, investmentTradingBalance = ref5.investmentTradingBalance;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewContainer */.VA, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: "Stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        family: "bold",
                        children: symbol
                    })
                ]
            }),
            isAutoBuy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: "Order Type"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: transactionForm/* orderTypeOptions.Buy */.Ud.Buy[buyOrderType]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: "Expiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: transactionForm/* expiryOptions */.Me[expiry]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: dayTradeActive,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                            children: "Leverage"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItemRow */.ww, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: Icons/* LightningSvg */.Sf
                                        }),
                                        "".concat(dayTradeMultiplier, "x")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                    children: "Day Trade"
                                })
                            ]
                        })
                    ]
                })
            }),
            isAutoBuy && /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: "Trigger Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: triggerPrice
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                        children: [
                            isAutoBuy && "Buy ",
                            " Price"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: (0,number/* formatNumber */.uf)(price, false)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Table_SplitLotRow, {
                lot: lot,
                disabled: isSplitOrderActive || !(0,utils/* isRedirectToNewCore */.JI)()
            }),
            isSplitOrderActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                children: "Split Quantity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                children: (0,number/* formatNumber */.uf)(splitQuantity, false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                children: "Split Method"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                children: constants_transaction/* SPLIT_ORDER_COPY */.qc[splitMethod]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                        condition: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                    children: "Split Range Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                    children: "".concat((0,number/* formatNumber */.uf)(splitRangeMin, false), " - ").concat((0,number/* formatNumber */.uf)(splitRangeMax, false))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Flex, {
                        align: "center",
                        onClick: function() {
                            if (!dayTradeActive) return;
                            setOpenInvestment(!openInvestment);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                children: "Investment"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                                condition: dayTradeActive,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/chevron-".concat(!openInvestment ? "down" : "up", ".svg"),
                                    alt: "dropdown",
                                    style: {
                                        marginLeft: "5px",
                                        width: "16px",
                                        cursor: "pointer"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(totalInvestment, false)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                condition: dayTradeActive && openInvestment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InvestmentWrapper */.Qi, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* InvestmentDetail */.yH, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                        children: "Trading Balance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                                        children: [
                                            "Rp ",
                                            (0,number/* formatNumber */.uf)(investmentTradingBalance, false)
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                        children: "Day Trade"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                                        children: [
                                            "Rp ",
                                            (0,number/* formatNumber */.uf)(investmentDayTrade, false)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        children: "Broker Fee"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(brokerFee)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Flex, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                                children: "Exchange Fee"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/information.svg",
                                alt: "fee-info",
                                onClick: showExchangeFee,
                                style: {
                                    marginLeft: "5px",
                                    width: "12px",
                                    cursor: "pointer"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(exchangeFee, false)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewItem */.s8, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyPreview_Text, {
                        family: "bold",
                        children: "Investment (Plus Fee)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BuyPreview_Text, {
                        family: "bold",
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(investmentPlusFee)
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var PreviewOrderModal_BuyPreview = (BuyPreview);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/ExercisePreview.tsx







var ExercisePreview_Flex = ui/* Common.Flex */.Gn.Flex, ExercisePreview_Text = ui/* Common.Text */.Gn.Text;
function ExercisePreview() {
    var ref = (0,tradingData/* default */.Z)(), company = ref.company, portfolioDetail = ref.portfolioDetail;
    var ref1 = (0,RealTradingModal_store/* default */.Z)(), shares = ref1.shares, expiry = ref1.expiry;
    var symbol = company.data.symbol;
    var exercise_data = portfolioDetail.data.exercise_data;
    var price = exercise_data.price;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewContainer */.VA, {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExercisePreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: "Stock"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        family: "bold",
                        children: symbol
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExercisePreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: "Expiry"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: transactionForm/* expiryOptions */.Me[expiry]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExercisePreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: "Exercise Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: (0,number/* formatNumber */.uf)(price, false)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExercisePreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: "Shares"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        children: shares
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExercisePreview_Flex, {
                justify: "space-between",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExercisePreview_Text, {
                        family: "bold",
                        children: "Exercise Amount"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ExercisePreview_Text, {
                        family: "bold",
                        children: [
                            "Rp ",
                            (0,number/* formatNumber */.uf)(shares * price, false)
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var PreviewOrderModal_ExercisePreview = (ExercisePreview);

// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/ProfitLoss.tsx







var ProfitLoss_Flex = ui/* Common.Flex */.Gn.Flex, ProfitLoss_Text = ui/* Common.Text */.Gn.Text;
function ProfitLoss(param) {
    var priceAverageFee = param.priceAverageFee, isCorporateAction = param.isCorporateAction;
    var ref = (0,RealTradingModal_store/* default */.Z)(), price = ref.price, shares = ref.shares;
    var lot = shares / constant/* lotSize */.CQ;
    var sellAmountInvestedFee = (0,formula/* getSellAmountInvestedFee */.B1)(lot, price, isCorporateAction);
    var buyAmountInvestedAveragePriceFee = (0,formula/* getBuyAmountInvested */.yq)(lot, priceAverageFee);
    var sellProfitLoss = (0,formula/* getProfitLoss */.fY)(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee);
    var sellGain = (0,formula/* getSellGain */.Sd)(sellProfitLoss, buyAmountInvestedAveragePriceFee);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfitLoss_Flex, {
        align: "center",
        justify: "center",
        px: "20px",
        py: "16px",
        style: {
            border: "1px solid #dadada",
            borderRadius: "5px",
            minWidth: "320px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfitLoss_Flex, {
            justify: "space-between",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfitLoss_Text, {
                    children: "Profit/Loss"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfitLoss_Text, {
                    color: (0,general/* getColorBasedOnNumber */.pV)(sellProfitLoss),
                    children: [
                        (0,number/* formatNumber */.uf)(sellProfitLoss, false),
                        " (",
                        sellProfitLoss > 0 && "+",
                        sellGain === Infinity ? "0.0%" : (0,number/* formatPercentage */.rl)(sellGain, false),
                        ")"
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var PreviewOrderModal_ProfitLoss = (ProfitLoss);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/utils.ts
var RealTradingModal_utils = __webpack_require__(16153);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/styled.ts
var RealTradingModal_styled = __webpack_require__(61227);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/index.tsx
/* eslint-disable no-console */ 





































var Button = ui/* Common.Button */.Gn.Button, PreviewOrderModal_Flex = ui/* Common.Flex */.Gn.Flex, PreviewOrderModal_Text = ui/* Common.Text */.Gn.Text;
function PreviewOrderModal(param) {
    var visible = param.visible, showExchangeFee = param.showExchangeFee, onCancel = param.onCancel, onSubmit = param.onSubmit, portfolioData = param.portfolioData;
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,store/* default */.Z)(function(s) {
        return {
            orderType: s.orderType,
            orderid: s.orderid,
            symbol: s.symbol,
            isDayTrade: s.isDayTrade,
            modalData: s.modalData,
            setModalState: s.setModalState
        };
    }, shallow/* default */.Z), orderType = ref1.orderType, orderid = ref1.orderid, symbol = ref1.symbol, isDayTrade = ref1.isDayTrade, modalData = ref1.modalData, setModalState = ref1.setModalState;
    var ref2 = (0,tradingData/* default */.Z)(function(s) {
        var ref, ref1;
        return {
            exerciseData: (ref = s.exercise) === null || ref === void 0 ? void 0 : ref.data,
            getExercise: s.getExercise,
            productType: (ref1 = s.company.data) === null || ref1 === void 0 ? void 0 : ref1.type_company
        };
    }, shallow/* default */.Z), exerciseData = ref2.exerciseData, getExercise = ref2.getExercise, productType = ref2.productType;
    var ref3 = (0,tradingOperation/* default */.Z)(), postTradeBuy = ref3.postTradeBuy, postDayTradeBuy = ref3.postDayTradeBuy, postSmartOrder = ref3.postSmartOrder, postTradeAmend = ref3.postTradeAmend, postDayTradeAmend = ref3.postDayTradeAmend, postTradeSell = ref3.postTradeSell, postRequestExercise = ref3.postRequestExercise, editSmartOrder = ref3.editSmartOrder, postDayTradeSell = ref3.postDayTradeSell;
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var ref4 = (0,RealTradingModal_store/* default */.Z)(), configType = ref4.configType, expiry = ref4.expiry, price = ref4.price, shares = ref4.shares, stockCode = ref4.stockCode, triggerPrice = ref4.triggerPrice, type = ref4.type, resetOrderData = ref4.resetOrderData, isSplitOrderActive = ref4.isSplitOrderActive, splitQuantity = ref4.splitQuantity, splitRangeMin = ref4.splitRangeMin, splitRangeMax = ref4.splitRangeMax, dayTradeActive = ref4.dayTradeActive, dayTradeMultiplier = ref4.dayTradeMultiplier, splitMethod = ref4.splitMethod;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useShareTradeModal/* default */.Z)(function(s) {
        return [
            s.setOrderType,
            s.setExpiry,
            s.setIsDayTrade
        ];
    }, shallow/* default */.Z), 3), setShareOrderType = ref5[0], setShareExpiry = ref5[1], setIsDayTrade = ref5[2];
    var setShareTransactionData = (0,useShareTradeShare/* default */.Z)(function(s) {
        return s.setTransactionData;
    });
    var dayTrade = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return {
            dayTrade: s.dayTrade
        };
    }).dayTrade;
    var isCorporateAction = (0,react.useMemo)(function() {
        return trading/* CorporateActionStockType.includes */.dB.includes(productType === null || productType === void 0 ? void 0 : productType.toLowerCase());
    }, [
        productType
    ]);
    var lot = shares / constant/* lotSize */.CQ;
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY || orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isExercise = orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE;
    var onClose = function() {
        (0,autoOrder/* trackAutoBuyConfirmOrderCanceled */._3)(stockCode, trading/* BUY_ORDER_TYPE_TEXT */.x4[type], transactionForm/* expiryOptions */.Me[expiry], triggerPrice, price, shares);
        onCancel();
    };
    var handleSetTransactionData = function(orderId, isBuyOrder) {
        var shareOrderType = isBuyOrder ? shareTradeShare/* ShareOrderType.Buy */.y.Buy : shareTradeShare/* ShareOrderType.Sell */.y.Sell;
        setShareTransactionData({
            order_id: orderId,
            price: price,
            status: shareTradeShare/* ShareOrderStatus.Open */.F.Open,
            symbol: symbol,
            type: shareOrderType,
            order_time: new Date().toISOString(),
            qty: shares,
            total_investment: price * shares
        });
    };
    var submitOrderBuy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, dayTradeData, result, result1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Set default payment method to Trading Balance
                        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
                        if (!dayTradeActive) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        dayTradeData = {
                            symbol: symbol,
                            price: price,
                            shares: (lot * constant/* lotSize */.CQ).toString(),
                            multiplier: dayTradeMultiplier
                        };
                        _ctx.next = 7;
                        return postDayTradeBuy(dayTradeData);
                    case 7:
                        result = _ctx.sent;
                        handleSetTransactionData((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.order_id, true);
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 10:
                        _ctx.next = 12;
                        return postTradeBuy((0,_object_spread/* default */.Z)({
                            accountType: "stockbit",
                            orderkey: "W-BUY-".concat(Date.now()),
                            symbol: symbol,
                            price: price,
                            shares: lot * 100,
                            boardtype: "RG",
                            gtc: expiry
                        }, (0,RealTradingModal_utils/* getSplitOrderPayload */.xb)({
                            splitOrderActive: isSplitOrderActive,
                            splitQuantity: splitQuantity,
                            splitRangeMin: splitRangeMin,
                            splitRangeMax: splitRangeMax,
                            splitMethod: splitMethod
                        })));
                    case 12:
                        result1 = _ctx.sent;
                        handleSetTransactionData(result1 === null || result1 === void 0 ? void 0 : (ref = result1.data) === null || ref === void 0 ? void 0 : ref.order_id, true);
                        return _ctx.abrupt("return", Boolean(result1 && !result1.error));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitOrderBuy() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitSmartOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return postSmartOrder({
                            config_type: configType === null || configType === void 0 ? void 0 : configType.toString(),
                            shares: shares === null || shares === void 0 ? void 0 : shares.toString(),
                            gtc: "".concat(transactionForm/* expiryId */.IY[expiry]),
                            trigger_price: triggerPrice,
                            stock_code: stockCode,
                            price: price,
                            type: transaction/* SmartOrderCode */.H1[type]
                        });
                    case 2:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitSmartOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitAmend = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, result, data1, result1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isDayTrade) {
                            _ctx.next = 6;
                            break;
                        }
                        data = {
                            orderid: orderid,
                            price: price,
                            shares: (lot * constant/* lotSize */.CQ).toString(),
                            multiplier: dayTradeMultiplier
                        };
                        _ctx.next = 4;
                        return postDayTradeAmend(data);
                    case 4:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 6:
                        data1 = {
                            price: price,
                            shares: lot * constant/* lotSize */.CQ,
                            order_id: orderid
                        };
                        _ctx.next = 9;
                        return postTradeAmend([
                            data1
                        ]);
                    case 9:
                        result1 = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result1 && !result1.error));
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitAmend() {
            return _ref.apply(this, arguments);
        };
    }();
    var editAutoBuy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return editSmartOrder({
                            id: orderid,
                            trigger_price: triggerPrice,
                            shares: (ref = lot * constant/* lotSize */.CQ) === null || ref === void 0 ? void 0 : ref.toString(),
                            config_type: configType === null || configType === void 0 ? void 0 : configType.toString(),
                            price: price
                        });
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function editAutoBuy() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitOrderSell = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, ref1, result, data, result1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!dayTradeActive) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        _ctx.next = 5;
                        return postDayTradeSell({
                            symbol: symbol,
                            price: price,
                            shares: (lot * constant/* lotSize */.CQ).toString()
                        });
                    case 5:
                        result = _ctx.sent;
                        handleSetTransactionData((ref1 = result.data) === null || ref1 === void 0 ? void 0 : ref1.order_id, false);
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 8:
                        data = (0,_object_spread/* default */.Z)({
                            accountType: "stockbit",
                            orderkey: "W-SELL-".concat(Date.now()),
                            symbol: symbol,
                            price: price,
                            shares: lot * 100,
                            boardtype: "RG",
                            gtc: expiry
                        }, (0,RealTradingModal_utils/* getSplitOrderPayload */.xb)({
                            splitOrderActive: isSplitOrderActive,
                            splitQuantity: splitQuantity,
                            splitRangeMin: splitRangeMin,
                            splitRangeMax: splitRangeMax,
                            splitMethod: splitMethod
                        }));
                        _ctx.next = 11;
                        return postTradeSell(data);
                    case 11:
                        result1 = _ctx.sent;
                        handleSetTransactionData((ref = result1.data) === null || ref === void 0 ? void 0 : ref.order_id, false);
                        return _ctx.abrupt("return", Boolean(result1 && !result1.error));
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitOrderSell() {
            return _ref.apply(this, arguments);
        };
    }();
    var submitRequestExercise = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = {
                            orderKey: "W-EXERCISE-".concat(Date.now()),
                            stockCode: symbol,
                            shares: shares
                        };
                        _ctx.next = 3;
                        return postRequestExercise(data);
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(result && !result.error));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitRequestExercise() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAPIResponse = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(apiCall) {
            var result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setIsLoading(true);
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return apiCall();
                    case 4:
                        result = _ctx.sent;
                        if (result) {
                            onSubmit();
                            resetOrderData();
                        } else onCancel();
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        console.error(_ctx.t0);
                    case 11:
                        _ctx.prev = 11;
                        setIsLoading(false);
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8,
                    11,
                    14
                ]
            ]);
        }));
        return function handleAPIResponse(apiCall) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBuyOrderRequest = function() {
        var _obj;
        var buyOrderRequest = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder, submitOrderBuy), (0,_define_property/* default */.Z)(_obj, transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy, submitSmartOrder), _obj);
        setShareExpiry(expiry);
        setShareOrderType(type);
        setIsDayTrade(dayTradeActive);
        handleAPIResponse(buyOrderRequest[type] || submitOrderBuy);
    };
    var handleSellOrderRequest = function() {
        var _obj;
        var sellOrderRequest = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.LimitOrder */.qK.LimitOrder, submitOrderSell), (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.StopLoss */.qK.StopLoss, submitSmartOrder), (0,_define_property/* default */.Z)(_obj, transaction/* SellOrderType.TakeProfit */.qK.TakeProfit, submitSmartOrder), _obj);
        setShareExpiry(expiry);
        setShareOrderType(type);
        setIsDayTrade(dayTradeActive);
        handleAPIResponse(sellOrderRequest[type] || submitOrderSell);
    };
    var onConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isAmend;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isLoading) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        (0,autoOrder/* trackAutoBuyOrderConfirmed */.FY)(stockCode, trading/* BUY_ORDER_TYPE_TEXT */.x4[type], transactionForm/* expiryOptions */.Me[expiry], triggerPrice, price, shares);
                        isAmend = orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
                        if (isAmend && type === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) {
                            handleAPIResponse(editAutoBuy);
                        } else if (isAmend) {
                            handleAPIResponse(submitAmend);
                        }
                        if (orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY) {
                            handleBuyOrderRequest();
                        }
                        if (orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL) {
                            handleSellOrderRequest();
                        }
                        if (orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE) {
                            handleAPIResponse(submitRequestExercise);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirm = function() {
        if (isRealTrading) {
            (0,securities/* clevertapOrderConfirmed */.y8)({
                symbol: symbol,
                price: price,
                shares: shares,
                orderType: orderType,
                type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                expiry: transactionForm/* expiryOptions */.Me[expiry],
                orderTypeStatus: (0,analytics/* generateOrderTypeLabel */.JH)(type),
                splitOrder: isSplitOrderActive,
                dayTrade: isDayTrade || dayTradeActive
            });
        }
        onConfirm();
        if (modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget) {
            setModalState({
                modalData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalData), {
                    openFromWidget: false
                })
            });
        }
    };
    var loadExercisableData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getExercise(symbol);
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        _ctx.prev = 5;
                        _ctx.t0 = _ctx["catch"](0);
                        onClose();
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    5
                ]
            ]);
        }));
        return function loadExercisableData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (visible) {
            (0,securities/* clevertapOrderPreviewed */.J2)({
                symbol: symbol,
                orderType: orderType
            });
            (0,autoOrder/* trackAutoBuyPreviewOrderView */.jU)();
            if (orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE) loadExercisableData();
        }
    }, [
        symbol,
        visible
    ]);
    var isNeedToRenderInfo = false;
    if (exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.time_server) {
        var timeServer = new Date(exerciseData === null || exerciseData === void 0 ? void 0 : exerciseData.time_server);
        var secondsInDay = timeServer.getSeconds() + timeServer.getMinutes() * 60 + timeServer.getHours() * 3600;
        var limitCutOff = 10 * 3600; // 10:00 AM
        isNeedToRenderInfo = secondsInDay > limitCutOff;
    }
    var closeHour = (0,formater/* formatHourMinutes */.d7)(dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_open, dayTrade === null || dayTrade === void 0 ? void 0 : dayTrade.trading_close).close;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PreviewModalContainer */.__, {
        visible: visible,
        closable: false,
        centered: true,
        width: "fit-content",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewOrderModal_Flex, {
                direction: "column",
                align: "center",
                padding: "40px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_Text, {
                        family: "bold",
                        size: "16px",
                        mb: "10px",
                        children: "Preview Order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_Flex, {
                        mb: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/previeworder-icon.svg",
                            alt: "order-preview"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewOrderModal_Flex, {
                        align: "center",
                        justify: "center",
                        style: {
                            border: "1px solid #dadada",
                            borderRadius: "5px",
                            minWidth: "320px"
                        },
                        children: [
                            isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_BuyPreview, {
                                showExchangeFee: showExchangeFee
                            }),
                            isSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_SellPreview, {
                                showExchangeFee: showExchangeFee
                            }),
                            isExercise && /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_ExercisePreview, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isBuy && dayTradeActive,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* DayTradeInfoBanner */.hv, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewOrderModal_Text, {
                                children: [
                                    "Saham yang dibeli dengan Day Trade akan terjual otomatis hari ini pukul ",
                                    closeHour,
                                    " WIB."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isExercise && isNeedToRenderInfo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_Text, {
                            color: ui/* color.highgray */.$_.highgray,
                            align: "center",
                            mt: "15px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "exercise-information",
                                children: [
                                    "Penebusan ini akan diproses ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " di hari bursa berikutnya karena sudah melewati cut-off kami pukul 10:00 WIB."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isSell,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_Flex, {
                            mt: "16px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_ProfitLoss, {
                                priceAverageFee: portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.price_average_fee,
                                isCorporateAction: isCorporateAction
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PreviewOrderModal_Flex, {
                justify: "space-between",
                style: {
                    position: "absolute",
                    bottom: "-50px",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: function() {
                            setIsLoading(false);
                            if (isRealTrading) {
                                (0,securities/* clevertapOrderCanceled */.bQ)({
                                    symbol: symbol,
                                    price: price,
                                    shares: shares,
                                    orderType: orderType,
                                    type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading
                                });
                            }
                            onClose();
                        },
                        type: "secondary",
                        radius: "4px",
                        block: true,
                        height: "40px",
                        style: {
                            width: "49%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_Text, {
                            align: "inherit",
                            color: "inherit",
                            family: "bold",
                            size: "18px",
                            children: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: handleConfirm,
                        loading: isLoading,
                        radius: "4px",
                        block: true,
                        height: "40px",
                        style: {
                            width: "49%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal_Text, {
                            align: "inherit",
                            color: ui/* color.primary */.$_.primary,
                            family: "bold",
                            size: "18px",
                            children: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var RealTradingModal_PreviewOrderModal = (PreviewOrderModal);


/***/ }),

/***/ 27477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(579);



var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal;
function ShariaUnavailableModal(param) {
    var visible = param.visible, onClose = param.onClose;
    var handleClick = function() {
        if (onClose) onClose();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
        visible: visible,
        centered: true,
        width: "500px",
        onCancel: handleClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
            direction: "column",
            align: "center",
            padding: "50px 30px 20px",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    src: "/images/syariah/unavailable.svg",
                    alt: "Unavailable"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    align: "center",
                    family: "bold",
                    size: "16px",
                    my: "16px",
                    children: "Bukan Saham Syariah"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    align: "center",
                    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.dimgray */ .$_.dimgray,
                    children: "Kamu tidak bisa bertransaksi saham non-syariah."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    align: "center",
                    family: "bold",
                    children: "(Fatwa No.80/DSN-MUI/III/2011)"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Flex, {
                    justify: "center",
                    style: {
                        width: "100%"
                    },
                    mt: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                        type: "primary",
                        radius: "4px",
                        block: true,
                        height: "40px",
                        width: "200px",
                        onClick: handleClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            align: "inherit",
                            color: "white",
                            family: "bold",
                            size: "16px",
                            children: "Oke"
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ShariaUnavailableModal);


/***/ }),

/***/ 65205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2497);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76825);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70362);
/* harmony import */ var global_TradingModal_RealTradingModal_TransactionModal_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55039);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(333);
/* harmony import */ var lib_api_smartOrder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59140);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53616);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61227);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2078);













var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_4__/* .Common.Flex */ .Gn.Flex, Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_4__/* .Common.Modal */ .Gn.Modal, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_4__/* .Common.Text */ .Gn.Text;
var title = "Dengan menggunakan fitur Auto Order, saya menyatakan dan memahami bahwa:";
var checkboxDescription = "Saya menyetujui Syarat & Ketentuan Penggunaan Auto Order di atas.";
var tnc = [
    "Saya mengerti risiko penggunaan fitur Auto Order.",
    "Fitur Auto Order hanya membantu proses otomatisasi dalam bertransaksi. Pemesanan melalui Auto Order adalah sepenuhnya tanggung jawab pengguna, PT. Stockbit Sekuritas Digital tidak bertanggung jawab atas segala kerugian yang mungkin bisa terjadi.",
    "Sistem akan mulai melakukan pengecekan harga pada pukul 09:00:00 WIB.",
    "Proses pembentukan harga pada saat sesi pembukaan dapat mempengaruhi order saya.",
    "Eksekusi Auto Order bergantung pada antrian di bursa dimana ada kemungkinan terjadinya jeda waktu.",
    "Pemesanan melalui Auto Order tidak menjamin akan sesuai dengan harga dan jumlah yang saya harapkan.",
    "Stockbit berhak melakukan penghentian sementara fasilitas automated trading jika terdapat resiko perdagangan yang mungkin timbul untuk menghindari kerugian yang tidak diinginkan", 
];
function AutoOrderTncModal(param) {
    var autoOrderType = param.autoOrderType, visible = param.visible, closeModal = param.closeModal;
    var setOrderType = (0,_store__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(s) {
        return s.setOrderType;
    });
    var setAutoBuy = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(state) {
        return state.setAutoBuy;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isTncAgree = ref[0], setTncAgree = ref[1];
    var ref1 = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_7__/* .selectors */ .wl), username = ref1.data.username;
    var saveLogTnc = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, logTnc, response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        ;
                        logTnc = JSON.parse(localStorage.getItem("logTnc")) || [];
                        _ctx.next = 5;
                        return (0,lib_api_smartOrder__WEBPACK_IMPORTED_MODULE_8__/* .postSmartOrderTnC */ .xB)({
                            product: autoOrderType
                        });
                    case 5:
                        response = _ctx.sent;
                        if (!((response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message) !== "success")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if (!(0,global_TradingModal_RealTradingModal_TransactionModal_utils__WEBPACK_IMPORTED_MODULE_6__/* .checkIsAutoOrderTncAgreed */ .KK)(username, autoOrderType)) {
                            logTnc.push({
                                username: username,
                                product: autoOrderType
                            });
                            localStorage.setItem("logTnc", JSON.stringify(logTnc));
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function saveLogTnc() {
            return _ref.apply(this, arguments);
        };
    }();
    var onTncAgreed = function() {
        saveLogTnc();
        setOrderType(global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_11__/* .BuyOrderType.AutoBuy */ .dY.AutoBuy);
        setAutoBuy(true);
        closeModal();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                size: "20px",
                align: "center",
                family: "bold",
                padding: "15px",
                children: "Syarat & Ketentuan"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                direction: "column",
                padding: "20px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Flex, {
                        direction: "column",
                        padding: "20px",
                        style: {
                            border: "1px solid rgb(237, 237, 237)",
                            borderRadius: "5px"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                family: "bold",
                                mb: "10px",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                style: {
                                    marginLeft: "-20px"
                                },
                                children: tnc.map(function(item) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                                            padding: "5px",
                                            children: item
                                        })
                                    }, item);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_10__/* .Checkbox */ .XZ, {
                        onChange: function() {
                            return setTncAgree(!isTncAgree);
                        },
                        style: {
                            marginTop: "15px"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                            children: checkboxDescription
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_10__/* .AutoBuySubmitButton */ .yJ, {
                disabled: !isTncAgree,
                onClick: onTncAgreed,
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Text, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "16px",
                    children: "Submit"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AutoOrderTncModal);


/***/ }),

/***/ 52595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76825);
/* harmony import */ var hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47002);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(29658);
/* harmony import */ var lib_analytics_securities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91154);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62974);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36902);
/* harmony import */ var global_TradingModal_components_NumberInput__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93951);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29097);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45605);
/* harmony import */ var global_Securities_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2941);
/* harmony import */ var _components_FormItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27892);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51520);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53616);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(61227);
















var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Button */ .Gn.Button, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_2__/* .Common.Text */ .Gn.Text;
function FormExercise(param) {
    var onSubmit = param.onSubmit;
    var ref = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), getCashOnHand = ref.getCashOnHand, cashOnHand = ref.cashOnHand, company = ref.company, _configFormula = ref.configFormula, formula = _configFormula.data.formula;
    var symbol = company.data.symbol;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getCashOnHand();
    }, []);
    var getPortfolioDetail = (0,hooks_useGetPortfolioData__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(symbol);
    var exercise_data = getPortfolioDetail.exercise_data, stock_on_hand = getPortfolioDetail.stock_on_hand;
    var price = exercise_data.price;
    var available_cash_on_hand = cashOnHand.data.available_cash_on_hand;
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(), shares = ref.shares, setShares = ref.setShares;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used by eval
    var PRICE = price;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used by eval
    var LOT = shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_8__/* .lotSize */ .CQ;
    // eslint-disable-next-line no-eval -- formula passed from the server
    var exerciseAmount = eval(formula.buy_amount_invested);
    var exceedCashOnHand = exerciseAmount > available_cash_on_hand;
    var disableSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return shares < 1 || exceedCashOnHand;
    }, [
        shares,
        exceedCashOnHand
    ]);
    var exerciseWarningText = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "Order Exercise yang sudah disubmit tidak dapat dibatalkan. Setelah exercise berhasil dilakukan, kamu hanya bisa menjual di pasar reguler dalam satuan lot ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                children: "(1 lot = 100 lembar)."
            })
        ]
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (exceedCashOnHand) {
            (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_4__/* .clevertapExerciseError */ .sW)();
        }
    }, [
        exceedCashOnHand
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setShares(stock_on_hand);
    }, [
        stock_on_hand
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_4__/* .clevertapExerciseViewed */ .LF)({
            symbol: symbol,
            share: stock_on_hand
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Flex, {
                style: {
                    background: "#fcf6ff",
                    borderRadius: 4
                },
                p: "8px 12px",
                mb: "16px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    children: exerciseWarningText
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_10__/* .FormExerciseFieldWrapper */ .hn, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        label: "Cash on Hand",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                            family: "bold",
                            children: (0,global_Securities_utils_currencyFormatter__WEBPACK_IMPORTED_MODULE_13__/* .getFormattedCurrency */ .c)(available_cash_on_hand, {
                                currencyPrefix: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        label: "",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_12__/* .Slider */ .iR, {
                                    min: 0,
                                    max: stock_on_hand,
                                    value: shares,
                                    tipFormatter: null,
                                    onChange: function(s) {
                                        return setShares(s);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                                    ml: "5px",
                                    width: "80px",
                                    children: (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatPercentage */ .rl)(shares / stock_on_hand * 100, false)
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        label: "Exercised Amount",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                            family: "bold",
                            children: [
                                "Rp ",
                                (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(exerciseAmount, false)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        label: "Exercised Price",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Text, {
                            family: "bold",
                            children: [
                                "Rp ",
                                (0,utils_number__WEBPACK_IMPORTED_MODULE_5__/* .formatNumber */ .uf)(price, false)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_FormItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        label: "Shares Exercised",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_TradingModal_components_NumberInput__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            defaultValue: stock_on_hand,
                            value: shares,
                            min: 0,
                            max: stock_on_hand,
                            step: 1,
                            onChange: function(s) {
                                return setShares(s);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                condition: exceedCashOnHand,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_10__/* .ErrorBox */ .Tv, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                            style: {
                                color: "#ee4a49",
                                marginRight: 7
                            }
                        }),
                        "Nilai exercise kamu melebihi cash on hand yang kamu miliki."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, {
                disabled: disableSubmit,
                onClick: function() {
                    (0,lib_analytics_securities__WEBPACK_IMPORTED_MODULE_4__/* .clevertapExerciseSelected */ .Uj)({
                        symbol: symbol,
                        share: shares,
                        stockOnHandPercentage: shares / stock_on_hand * 100
                    });
                    onSubmit();
                },
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                py: "12px",
                px: "24px",
                style: {
                    position: "absolute",
                    left: 0,
                    bottom: -36,
                    width: "100%"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "18px",
                    children: "Exercise"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormExercise);


/***/ }),

/***/ 51520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ck": function() { return /* binding */ SpecialMonitoringModalContainer; },
/* harmony export */   "Jn": function() { return /* binding */ SpecialMonitoringButton; },
/* harmony export */   "RP": function() { return /* binding */ BalanceButton; },
/* harmony export */   "Tv": function() { return /* binding */ ErrorBox; },
/* harmony export */   "V$": function() { return /* binding */ FieldsWrapper; },
/* harmony export */   "fx": function() { return /* binding */ SliderPercentText; },
/* harmony export */   "hn": function() { return /* binding */ FormExerciseFieldWrapper; },
/* harmony export */   "p7": function() { return /* binding */ SelectForm; },
/* harmony export */   "vQ": function() { return /* binding */ TransactionForm; }
/* harmony export */ });
/* unused harmony export HeaderWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92961);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71230);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #f7aead;\n  background-color: #fef6f6;\n  align-items: center;\n  margin-top: 32px;\n  color: #333333;\n\n  .icon {\n    position: relative;\n    display: inline-block;\n    color: #ee4a49;\n    background: #fff;\n    border: 1px solid #ee4a49;\n    border-radius: 50%;\n    width: 14px;\n    height: 14px;\n    margin-right: 5px;\n    margin-bottom: 2px;\n\n    &::before {\n      position: absolute;\n      content: 'i';\n      left: 42%;\n      font-size: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-close {\n    margin-top: 24px;\n    margin-right: 14px;\n  }\n\n  .special-monitoring__content {\n    height: 560px;\n    overflow-y: scroll;\n    position: relative;\n    padding: 0 30px 30px;\n\n    &::-webkit-scrollbar {\n      width: 0;\n    }\n\n    & .special-monitoring__card {\n      border: 1px solid ",
        ";\n      border-radius: 4px;\n      margin-top: 20px;\n\n      &:first-child {\n        margin-top: 0;\n      }\n\n      & .special-monitoring__header {\n        padding: 16px 20px;\n        border-bottom: 1px solid ",
        ";\n      }\n\n      & .special-monitoring__body {\n        padding: 16px 20px;\n\n        & ul {\n          padding-inline-start: 24px;\n\n          & li {\n            margin-bottom: 20px;\n\n            &::marker {\n              color: ",
        ";\n            }\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n          }\n        }\n\n        & .special-monitoring__session-container {\n          margin-top: 20px;\n\n          & p {\n            margin-bottom: 8px;\n          }\n\n          & .special-monitoring__session-item {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -55px;\n  width: 100%;\n\n  :disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #bcbcbc;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-left: 5px;\n  width: 40px;\n  white-space: nowrap;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div {\n    padding: 16px 0;\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  padding: 0;\n\n  & > span {\n    margin-left: 6px;\n  }\n\n  &:disabled {\n    cursor: unset;\n  }\n\n  .multiplier-chip {\n    font-size: 14px;\n    line-height: 19px;\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 8px;\n    margin-left: 4px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 40px;\n\n  & div.ant-form-item-explain {\n    width: calc(100% + 40px);\n  }\n\n  & div.ant-form-item-control {\n    max-width: 160px;\n  }\n\n  & .slider-form-item div.ant-form-item-control {\n    max-width: unset;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & > div.ant-form-item {\n    margin-bottom: 20px;\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n  width: 100%;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n\n  padding-right: 36px;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text;
// eslint-disable-next-line import/prefer-default-export
var ErrorBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e890764c-0"
})(_templateObject());
var SpecialMonitoringModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Modal).withConfig({
    componentId: "sc-e890764c-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis);
var SpecialMonitoringButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Button).withConfig({
    componentId: "sc-e890764c-2"
})(_templateObject2());
var SliderPercentText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-e890764c-3"
})(_templateObject3());
var FormExerciseFieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e890764c-4"
})(_templateObject4());
var BalanceButton = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].button.withConfig({
    componentId: "sc-e890764c-5"
})(_templateObject5());
var TransactionForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e890764c-6"
})(_templateObject6());
var FieldsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-e890764c-7"
})(_templateObject7());
var SelectForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e890764c-8"
})(_templateObject8());
var HeaderWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e890764c-9"
})(_templateObject9());


/***/ }),

/***/ 55039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jg": function() { return /* binding */ generateTradingVariable; },
/* harmony export */   "KK": function() { return /* binding */ checkIsAutoOrderTncAgreed; },
/* harmony export */   "xl": function() { return /* binding */ calculateLotAmendTransaction; }
/* harmony export */ });
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86123);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83153);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29097);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-unused-vars */ /* eslint-disable no-eval */ 


var calculateLotAmendTransaction = function(previous_buy_price, previous_lot, price, lot) {
    // Prevent user increase lot with previous trade price
    // updating to use calculation procedure based on legacy
    // https://gitlab.com/stockbitgroup/stockbit/web/web/-/blob/staging/app/routes/securities/component/trade/ModalBuy.js#L351
    if (price === previous_buy_price && lot > previous_lot) {
        return previous_lot;
    }
    return lot;
};
var calculateInitialTradingBalance = function(stock_type, order_type, cash_on_hand, trading_balance, cash_onhand_amended, trading_balance_amended) {
    var isDayTrade = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
    if (stock_type.toLowerCase() === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_TYPE.right */ .L2.right) {
        return order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY ? cash_onhand_amended : cash_on_hand;
    }
    if (order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY && isDayTrade) {
        return trading_balance;
    }
    return order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY ? trading_balance_amended : trading_balance;
};
// eslint-disable-next-line import/prefer-default-export
var generateTradingVariable = function(param) {
    var configFormula = param.configFormula, cash_on_hand = param.cash_on_hand, trading_balance = param.trading_balance, price = param.price, lot = param.lot, trigger_price = param.trigger_price, config_type = param.config_type, order_type = param.order_type, previous_buy_price = param.previous_buy_price, previous_lot = param.previous_lot, stock_type = param.stock_type, trading_balance_amended = param.trading_balance_amended, cash_onhand_amended = param.cash_onhand_amended, _isDayTrade = param.isDayTrade, isDayTrade = _isDayTrade === void 0 ? false : _isDayTrade;
    if ((0,constants_app__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5)()) {
        var _formula = configFormula.formula, fee_buy = _formula.fee_buy, fee_buy_day_trade = _formula.fee_buy_day_trade, buy_amount_invested = _formula.buy_amount_invested, buy_amount_invested_fee = _formula.buy_amount_invested_fee, buy_amount_fee = _formula.buy_amount_fee, buy_amount_broker_fee = _formula.buy_amount_broker_fee, buy_amount_exchange_fee = _formula.buy_amount_exchange_fee, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
        var ref = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee, broker_fee = ref.broker_fee, exchange = ref.exchange;
        var PRICE = Number(price);
        var LOT = Math.round(Number(lot));
        var TRIGGER_PRICE = Number(trigger_price);
        var CONFIG_TYPE = Number(config_type);
        if (order_type === constants_trading__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY) {
            LOT = calculateLotAmendTransaction(previous_buy_price, previous_lot, PRICE, LOT);
        }
        var FEE_BUY = isDayTrade ? Number(fee_buy_day_trade) : Number(fee_buy);
        var BROKER_FEE = Number(broker_fee);
        var EXCHANGE_FEE_TOTAL_BUY = Number(exchange.exchange_fee_total_buy);
        // if the source of eval script comes from controlled env (e.g. backend),
        // its relatively safe to use eval (https://stackoverflow.com/a/23175542)
        // so I add nosemgrep, to surprass nosemgrep
        var BUY_AMOUNT = eval(buy_amount_invested); // nosemgrep
        var BUY_AMOUNT_FEE = eval(buy_amount_invested_fee); // nosemgrep
        var BUY_FEE = eval(buy_amount_fee); // nosemgrep
        var STOCKBIT_FEE = eval(buy_amount_broker_fee); // nosemgrep
        var EXCHANGE_FEE = eval(buy_amount_exchange_fee); // nosemgrep
        var TRADING_BALANCE = calculateInitialTradingBalance(stock_type, order_type, cash_on_hand, trading_balance, cash_onhand_amended, trading_balance_amended, isDayTrade);
        var BUY_PRICE_WITH_FEE = (PRICE * FEE_BUY + PRICE) * global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_2__/* .lotSize */ .CQ;
        var LIMIT_LOT = Math.floor(TRADING_BALANCE / BUY_PRICE_WITH_FEE);
        return {
            TRADING_BALANCE: TRADING_BALANCE,
            BUY_AMOUNT_FEE: BUY_AMOUNT_FEE,
            BUY_AMOUNT: BUY_AMOUNT,
            PRICE: PRICE,
            BUY_FEE: BUY_FEE,
            STOCKBIT_FEE: STOCKBIT_FEE,
            EXCHANGE_FEE: EXCHANGE_FEE,
            LOT: LOT,
            LIMIT_LOT: LIMIT_LOT,
            TRIGGER_PRICE: TRIGGER_PRICE,
            CONFIG_TYPE: CONFIG_TYPE
        };
    }
    return null;
};
var checkIsAutoOrderTncAgreed = function(userName, autoOrderType) {
    var logTnc = JSON.parse(localStorage.getItem("logTnc"));
    if (!logTnc) return false;
    var usernameFound = logTnc.find(function(item) {
        return item.username === userName && item.product === autoOrderType;
    });
    if (usernameFound) return true;
    return false;
};


/***/ }),

/***/ 53616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29097);





var initialState = {
    configType: 2,
    expiry: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .Expiry.GoodForDay */ .ZM.GoodForDay,
    price: 0,
    shares: 0,
    stockCode: "",
    triggerPrice: 0,
    availableLot: 0,
    type: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.LimitOrder */ .dY.LimitOrder,
    typeDescription: "Limit Order",
    isSplitOrderActive: false,
    splitQuantity: null,
    splitRangeMin: null,
    splitRangeMax: null,
    splitMethod: global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .SplitOrderMethodEnum.RANDOM */ .PH.RANDOM,
    sellLeverage: null,
    dayTradeActive: false,
    dayTradeMultiplier: 0
};
var realTradingStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        setConfigType: function(payload) {
            var index = _constant__WEBPACK_IMPORTED_MODULE_1__/* .triggerPriceOption.indexOf */ .mr.indexOf(payload);
            set({
                configType: index + 1
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setOrderType: function(type) {
            set({
                type: type
            });
        },
        setPrice: function(payload) {
            var value = Number(payload);
            set({
                price: value
            });
        },
        setAvailableLot: function(payload) {
            var value = Number(payload);
            set({
                availableLot: value
            });
        },
        setShares: function(payload) {
            var value = Number(payload);
            set({
                shares: value
            });
        },
        setStockCode: function(payload) {
            set({
                stockCode: payload
            });
        },
        setTriggerPrice: function(payload) {
            var value = Number(payload);
            set({
                triggerPrice: value
            });
        },
        resetOrderData: function() {
            set(initialState);
        },
        setTradingData: function(payload) {
            set((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, payload));
        },
        setSplitOrderActive: function(isSplitOrderActive) {
            set({
                isSplitOrderActive: isSplitOrderActive
            });
        },
        setSplitQuantity: function(splitQuantity) {
            set({
                splitQuantity: splitQuantity
            });
        },
        setSplitRange: function(splitRangeMin, splitRangeMax) {
            set({
                splitRangeMin: splitRangeMin,
                splitRangeMax: splitRangeMax
            });
        },
        setSellLeverage: function(sellLeverage) {
            set({
                sellLeverage: sellLeverage
            });
        },
        setDayTradeActive: function(active) {
            set({
                dayTradeActive: active
            });
        },
        setDayTadeMultiplier: function(multiplier) {
            set({
                dayTradeMultiplier: multiplier
            });
        },
        setSplitMethod: function setSplitMethod(splitMethod) {
            set({
                splitMethod: splitMethod
            });
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (realTradingStore);


/***/ }),

/***/ 61227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ CustomSelect; },
/* harmony export */   "Jm": function() { return /* binding */ TabPane; },
/* harmony export */   "UE": function() { return /* binding */ TabWrapper; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "d2": function() { return /* binding */ TriggerPriceSelect; },
/* harmony export */   "hv": function() { return /* binding */ DayTradeInfoBanner; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "yJ": function() { return /* binding */ AutoBuySubmitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76750);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-nav-list {\n    width: 100%;\n  }\n  .ant-tabs-nav-list {\n    .ant-tabs-tab {\n      width: 50%;\n      text-align: center;\n      font-family: var(--bold-font);\n\n      &.ant-tabs-tab-active {\n        color: ",
        ";\n        .ant-tabs-tab-btn {\n          color: ",
        ";\n        }\n      }\n\n      .ant-tabs-tab-btn {\n        width: 100%;\n        color: ",
        ";\n\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: solid 1px ",
        ";\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 2px;\n\n  /* Add style when disabled*/\n  &:disabled {\n    color: #b5b5b5;\n    background: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 36px;\n  width: 36px;\n  margin-right: 0px;\n  text-indent: 0;\n  padding-left: 5px;\n  padding-right: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -55px;\n  width: 100%;\n\n  :disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #bcbcbc;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: ",
        " !important;\n  }\n\n  .ant-tabs-tab-active {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-step {\n    background-color: ",
        " !important;\n    height: 4px;\n    top: 4px;\n    z-index: 0;\n    border-radius: 2px;\n  }\n\n  .ant-slider-track {\n    border-radius: 2px;\n    height: 4px;\n    z-index: 1;\n  }\n\n  .ant-slider-handle {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-checked .ant-checkbox-inner,\n  .ant-checkbox-indeterminate .ant-checkbox-inner {\n    background-color: #0bba7a;\n    border-color: #0bba7a;\n  }\n\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 318px;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f2f1fe;\n  border-radius: 4px;\n  margin-top: 16px;\n  color: #333333;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var BaseTabPane = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"].TabPane */ .Z.TabPane;
var Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, BaseCheckbox = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Checkbox */ .Gn.Checkbox;
var BaseSlider = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Trading.Slider */ .BN.Slider;
var TabWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-461d54e1-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.mountainMeadow */ .$_.mountainMeadow, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.mountainMeadow */ .$_.mountainMeadow, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray);
var CustomSelect = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].select.withConfig({
    componentId: "sc-461d54e1-1"
})(_templateObject1(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var TriggerPriceSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(CustomSelect).withConfig({
    componentId: "sc-461d54e1-2"
})(_templateObject2());
var AutoBuySubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-461d54e1-3"
})(_templateObject3());
var TabPane = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseTabPane).withConfig({
    componentId: "sc-461d54e1-4"
})(_templateObject4());
var Tabs = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-461d54e1-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseSlider).withConfig({
    componentId: "sc-461d54e1-6"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseCheckbox).withConfig({
    componentId: "sc-461d54e1-7"
})(_templateObject7());
var DayTradeInfoBanner = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-461d54e1-8"
})(_templateObject8());



/***/ }),

/***/ 16153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PS": function() { return /* binding */ getLotOrderLimit; },
/* harmony export */   "Tx": function() { return /* binding */ getInitialPrice; },
/* harmony export */   "xb": function() { return /* binding */ getSplitOrderPayload; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4621);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2078);
/* eslint-disable import/prefer-default-export */ 




var getInitialPrice = function(companyData, orderType, amendPreviousPrice) {
    var price = companyData.price, orderbook = companyData.orderbook;
    var ref = orderbook || {}, bid = ref.bid, offer = ref.offer;
    var defaultPrice = Number(price) || 0;
    var isAmend = [
        constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY,
        constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL
    ].includes(orderType);
    if (isAmend) return amendPreviousPrice || defaultPrice;
    var bidPrice = Number(bid === null || bid === void 0 ? void 0 : bid.price);
    var offerPrice = Number(offer === null || offer === void 0 ? void 0 : offer.price);
    var isARB = Number.isNaN(bidPrice);
    var isARA = Number.isNaN(offerPrice);
    // Return orderbook price when autoreject or fallback to price field
    if (isARB) return offerPrice || defaultPrice;
    if (isARA) return bidPrice || defaultPrice;
    if (orderType === constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY && offerPrice) return offerPrice;
    if (orderType === constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL && bidPrice) return bidPrice;
    return defaultPrice;
};
var getLotOrderLimit = function() {
    return constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .LOT_ORDER_LIMIT */ .Ik[(0,features_securities_utils__WEBPACK_IMPORTED_MODULE_1__/* .getTargetAPI */ .Ai)()];
};
var getSplitOrderPayload = function(param) {
    var splitOrderActive = param.splitOrderActive, splitQuantity = param.splitQuantity, splitRangeMin = param.splitRangeMin, splitRangeMax = param.splitRangeMax, splitMethod = param.splitMethod;
    if (!splitOrderActive) return {};
    var isRandom = splitMethod === global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_2__/* .SplitOrderMethodEnum.RANDOM */ .PH.RANDOM;
    var splitOrder = {
        qty: splitQuantity,
        method: splitMethod
    };
    if (isRandom) {
        splitOrder = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, splitOrder), {
            min_lot: splitRangeMin,
            max_lot: splitRangeMax
        });
    }
    return {
        split_order: splitOrder
    };
};


/***/ }),

/***/ 27892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76805);



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex;
function FormItem(param) {
    var className = param.className, label = param.label, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Flex, {
        className: className,
        py: "10px",
        align: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lX, {
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    width: 210
                },
                children: children
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormItem);


/***/ }),

/***/ 93951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_TradingModal_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76805);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62974);





function NumberInput(_param) {
    var value = _param.value, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "value"
    ]);
    var min = props.min, max = props.max;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_TradingModal_styled__WEBPACK_IMPORTED_MODULE_1__/* .InputNumber */ .Rn, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        value: value,
        onKeyUp: function(e) {
            var newVal = e.target.value || min;
            newVal = Number(e.target.value.replace(/\D/g, ""));
            if (min && newVal < min) newVal = min;
            if (max && newVal > max) newVal = max;
            e.target.value = (0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(newVal, false);
        }
    }, props));
}
/* harmony default export */ __webpack_exports__["Z"] = (NumberInput);


/***/ }),

/***/ 77017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SearchCompany; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: fit-content;\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 16px;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  border-left: none;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 99999 !important;\n  .rc-virtual-list-holder-inner > :first-child {\n    display: none !important;\n  }\n\n  .ant-select-dropdown {\n    width: 60% !important;\n    top: -55px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:focus {\n    border-right-width: 0px !important;\n  }\n  &:hover {\n    border-right-width: 0px !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  right: 60px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var BaseAutocomplete = ui/* Common.Autocomplete */.Gn.Autocomplete, Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text, IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, Input = ui/* Common.Input */.Gn.Input;
var Relative = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fb1be289-0"
})(_templateObject(), ui/* color.light */.$_.light);
var CatalogItem = (0,styled_components_browser_esm["default"])(Text).attrs({
    size: "13px",
    p: "3px 5px"
}).withConfig({
    componentId: "sc-fb1be289-1"
})(_templateObject1(), ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary, ui/* color.primary */.$_.primary, ui/* color.light */.$_.light);
var SearchBarWrapper = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-fb1be289-2"
})(_templateObject2(), function(param) {
    var _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible;
    return isVisible ? "flex" : "none";
}, ui/* color.light */.$_.light);
var IconClose = (0,styled_components_browser_esm["default"])(IconWrapper).withConfig({
    componentId: "sc-fb1be289-3"
})(_templateObject3(), ui/* color.lowgray */.$_.lowgray, ui/* color.light */.$_.light);
var Autocomplete = (0,styled_components_browser_esm["default"])(BaseAutocomplete).withConfig({
    componentId: "sc-fb1be289-4"
})(_templateObject4());
var CustomInput = (0,styled_components_browser_esm["default"])(Input).withConfig({
    componentId: "sc-fb1be289-5"
})(_templateObject5());
var IconmoonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-fb1be289-6"
})(_templateObject6());


;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 










var SearchCompany_Input = ui/* Common.Input */.Gn.Input, TagDefault = ui/* Common.Tag */.Gn.Tag, SearchCompany_Flex = ui/* Common.Flex */.Gn.Flex, SearchCompany_Text = ui/* Common.Text */.Gn.Text;
var Tag = TagDefault.Tag;
var checkIsBonds = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.indexOf("FR") >= 0;
};
var SearchCompany = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var updateSymbol = param.updateSymbol, isInTradingModal = param.isInTradingModal, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds;
    var dispatch = (0,es/* useDispatch */.I0)();
    var _$ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), searchResult = _$ref.result;
    var result = isBonds ? searchResult === null || searchResult === void 0 ? void 0 : searchResult.filter(function(item) {
        return checkIsBonds(item === null || item === void 0 ? void 0 : item.desc);
    }) : searchResult;
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500), []);
    var onChange = function(e) {
        var value = e.target.value;
        debouncedSearch(value);
    };
    var onSelect = function(name, isSelectedBonds) {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
        updateSymbol(name, isSelectedBonds);
    };
    var onPressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _result, item;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (result) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _result = (0,_sliced_to_array/* default */.Z)(result, 1), item = _result[0];
                        if (item) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isBonds) {
                            _ctx.next = 8;
                            break;
                        }
                        updateSymbol(item.name, isBonds);
                        return _ctx.abrupt("return");
                    case 8:
                        updateSymbol(item.name, checkIsBonds(item.desc));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPressEnter() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderLabel = function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return onSelect(item.name, checkIsBonds(item.desc));
            },
            "aria-hidden": true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchCompany_Flex, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                        size: "xs",
                        type: "grey",
                        children: item.keyword || item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany_Text, {
                        pl: "10px",
                        size: "13px",
                        children: item.desc || item.name
                    })
                ]
            })
        });
    };
    var options = function(suggestions) {
        if (!suggestions) {
            return [];
        }
        var company = suggestions.length > 0 ? {
            options: suggestions.map(function(item) {
                return {
                    value: item.keyword || item.name,
                    label: renderLabel(item)
                };
            })
        } : undefined;
        var list = [
            company
        ];
        return list.filter(function(item) {
            return item !== undefined;
        });
    };
    (0,react.useEffect)(function() {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Autocomplete, {
        options: options(result),
        width: "100%",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        children: [
            isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany_Input, {
                ref: ref,
                placeholder: "Type company symbol here",
                height: "40px",
                onChange: onChange,
                width: "100%",
                loading: true,
                onPressEnter: onPressEnter,
                style: {
                    maxWidth: "460px"
                },
                "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_SEARCH_COMPANY */.eG.HEADER_SEARCH_COMPANY
            }),
            !isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                ref: ref,
                placeholder: "",
                height: "60px",
                onChange: onChange,
                width: "100%",
                onPressEnter: onPressEnter,
                style: {
                    outline: 0,
                    fontSize: "26px",
                    padding: "0px",
                    borderWidth: "0 0 2px"
                }
            })
        ]
    });
});
/* harmony default export */ var components_SearchCompany = (SearchCompany);


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony exports stockType, expiryOption */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = (/* unused pure expression or super */ null && ([
    "Good For Day",
    "Good Till Cancelled"
]));
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 66940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useIsUserSyariah; }
});

// EXTERNAL MODULE: ./src/utils/securitiesLocalStorage.ts + 1 modules
var securitiesLocalStorage = __webpack_require__(11763);
;// CONCATENATED MODULE: ./src/global/Securities/types/api/auth.ts
var AccountTypeEnum;
(function(AccountTypeEnum) {
    AccountTypeEnum["EQUITY"] = "ACCOUNT_TYPE_EQUITY";
    AccountTypeEnum["SYARIAH"] = "ACCOUNT_TYPE_SYARIAH";
    AccountTypeEnum["BOND"] = "ACCOUNT_TYPE_BOND";
    AccountTypeEnum["DAY_TRADING"] = "ACCOUNT_TYPE_DAY_TRADING";
})(AccountTypeEnum || (AccountTypeEnum = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts


var useIsSyariahUser = function() {
    var accountType = securitiesLocalStorage/* default.getSecuritiesAccountInfo */.Z.getSecuritiesAccountInfo().accountType;
    return accountType === AccountTypeEnum.SYARIAH;
};
/* harmony default export */ var useIsUserSyariah = (useIsSyariahUser);


/***/ }),

/***/ 47060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70362);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36902);
/* harmony import */ var global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66940);





var useSyariah = function() {
    var setModalState = (0,global_TradingModal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.setModalState;
    });
    var checkStockTradable = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(s) {
        return s.checkStockTradable;
    });
    var isUserSyariah = (0,global_TradingModal_hooks_useIsUserSyariah__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var checkSyariahTradeableStatus = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
            var data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return checkStockTradable(symbol);
                    case 3:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.is_sharia_tradable);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", true);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function checkSyariahTradeableStatus(symbol) {
            return _ref.apply(this, arguments);
        };
    }();
    var showSyariahRestrictionModal = function() {
        setModalState({
            visible: true,
            modalData: {
                showShariaRestrictionBuy: true
            }
        });
    };
    var hideSyariahRestrictionModal = function() {
        setModalState({
            modalData: {
                showShariaRestrictionBuy: false
            }
        });
    };
    return {
        showSyariahRestrictionModal: showSyariahRestrictionModal,
        hideSyariahRestrictionModal: hideSyariahRestrictionModal,
        checkSyariahTradeableStatus: checkSyariahTradeableStatus,
        isUserSyariah: isUserSyariah
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useSyariah);


/***/ }),

/***/ 69983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_TradingModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/hooks/useGetPortfolioData.ts
var useGetPortfolioData = __webpack_require__(47002);
// EXTERNAL MODULE: ./src/lib/analytics/virtualTrading.ts
var virtualTrading = __webpack_require__(29351);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./src/lib/stores/tradingData.ts + 1 modules
var tradingData = __webpack_require__(36902);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/portfolio.ts + 1 modules
var portfolio = __webpack_require__(80943);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/stores/usePortfolioStore.ts






var initialState = {
    portfolio: {
        available_lot: 0,
        balance_lot: 0,
        price: {
            order: 0,
            average: 0,
            market: 0
        }
    },
    portfolioList: {
        trading_balance: 0,
        amount: {
            invested: 0,
            allocated: 0,
            credit_limit: 0
        },
        result: [],
        profit_loss: {
            unrealized: 0,
            realized: 0,
            total: 0
        },
        equity: 0,
        gain: 0
    }
};
var usePortfolioStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        loadPortfolioDetail: function loadPortfolioDetail(symbol) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, axiosData, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,portfolio/* getPortfolioDetail */.P)(symbol);
                        case 3:
                            ref = _ctx.sent;
                            axiosData = ref.data;
                            data = axiosData.data;
                            set({
                                portfolio: data
                            });
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        },
        loadPortfolioList: function loadPortfolioList() {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, axiosData, data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,portfolio/* getPortfolioList */.g)();
                        case 3:
                            ref = _ctx.sent;
                            axiosData = ref.data;
                            data = axiosData.data;
                            set({
                                portfolioList: data
                            });
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }))();
        }
    });
});
/* harmony default export */ var stores_usePortfolioStore = (usePortfolioStore);

// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/lib/stores/tradingOperation.ts + 1 modules
var tradingOperation = __webpack_require__(31532);
// EXTERNAL MODULE: ./src/global/VirtualTrading/stores/useVirtualOrderStore.ts
var useVirtualOrderStore = __webpack_require__(72965);
// EXTERNAL MODULE: ./src/global/VirtualTrading/utils/formula.ts
var formula = __webpack_require__(41150);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/Slider/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 10px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  margin: 0;\n  border-radius: 4px;\n\n  &:hover .ant-slider-handle {\n    border-color: #00ab6b !important;\n  }\n\n  & > .ant-slider-handle {\n    transition: left 0.1s linear;\n    will-change: left;\n\n    z-index: 3;\n    border-color: #00ab6b;\n    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);\n\n    &:hover {\n      border-color: #00ab6b !important;\n    }\n\n    :focus {\n      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);\n    }\n\n    :active {\n      box-shadow: 0 0 0 5px rgb(0, 171, 107, 0.12);\n    }\n  }\n\n  & > .ant-slider-rail {\n    display: block;\n    z-index: 1;\n    background-color: #f1f1f1;\n    border-radius: 4px;\n  }\n\n  & > .ant-slider-track {\n    display: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 2;\n  cursor: pointer;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  pointer-events: none;\n  padding: 4px 0;\n  display: flex;\n\n  transition: clip-path 0.1s linear;\n  will-change: clip-path;\n\n  & > div {\n    border-radius: 0;\n    clip-path: polygon(\n      calc(0% + ",
        "px) 0%,\n      100% 0%,\n      calc(100% - ",
        "px) 100%,\n      0% 100%\n    );\n\n    :last-child {\n      border-radius: 0 4px 4px 0;\n      clip-path: polygon(\n        calc(0% + ",
        "px) 0%,\n        100% 0%,\n        100% 100%,\n        0% 100%\n      );\n    }\n\n    :first-child {\n      border-radius: 4px 0 0 4px;\n      clip-path: polygon(\n        0% 0%,\n        100% 0%,\n        calc(100% - ",
        "px) 100%,\n        0% 100%\n      );\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        "%;\n  background-color: ",
        ";\n  height: 4px;\n  transition: 0.15s background-color ease-out;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var BaseSlider = ui/* Trading.Slider */.BN.Slider;
var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96ff7898-0"
})(_templateObject());
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96ff7898-1"
})(_templateObject1());
var SliderTrack = (0,styled_components_browser_esm["default"])(BaseSlider).withConfig({
    componentId: "sc-96ff7898-2"
})(_templateObject2());
var TrackWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96ff7898-3"
})(_templateObject3(), function(param) {
    var cutSize = param.cutSize;
    return cutSize;
}, function(param) {
    var cutSize = param.cutSize;
    return cutSize;
}, function(param) {
    var cutSize = param.cutSize;
    return cutSize;
}, function(param) {
    var cutSize = param.cutSize;
    return cutSize;
});
var Track = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-96ff7898-4"
})(_templateObject4(), function(param) {
    var _width = param.width, width = _width === void 0 ? 100 : _width;
    return width;
}, function(param) {
    var backgroundColor = param.backgroundColor;
    return backgroundColor;
});

;// CONCATENATED MODULE: ./src/global/Securities/components/Slider/index.tsx





var Slider = function(_param) {
    var _tracksWidth = _param.tracksWidth, tracksWidth = _tracksWidth === void 0 ? [] : _tracksWidth, _tracksColor = _param.tracksColor, tracksColor = _tracksColor === void 0 ? [
        "#00AB6B",
        "#8277F8"
    ] : _tracksColor, defaultValue = _param.defaultValue, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "tracksWidth",
        "tracksColor",
        "defaultValue",
        "onChange"
    ]);
    var ref = (0,react.useState)(defaultValue), clipValue = ref[0], setClipValue = ref[1];
    var isControlled = typeof props.value !== "undefined";
    var sliderValue = isControlled ? props.value : clipValue;
    var getLimitNumber = function(value) {
        var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
        return Math.min(Math.max(value, min), max);
    };
    var clipWidth = (0,react.useMemo)(function() {
        var maxSliderValue = props.max || 100;
        var clipPercentage = sliderValue / maxSliderValue * 100;
        // Based on 100% css clip-path width - clipPercentage
        var width = 100 - getLimitNumber(clipPercentage);
        return width || 0;
    }, [
        sliderValue,
        props.max
    ]);
    var handleValueChange = function(value) {
        setClipValue(value);
        onChange(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderTrack, (0,_object_spread/* default */.Z)({
                    onChange: handleValueChange,
                    tooltipVisible: false,
                    defaultValue: defaultValue
                }, props)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackWrapper, {
                    style: {
                        clipPath: "polygon(0% 0%, calc(100% - ".concat(clipWidth, "%) 0%, calc(100% - ").concat(clipWidth, "%) 100%, 0% 100%)")
                    },
                    cutSize: 2,
                    children: tracksWidth.length > 0 ? tracksWidth.map(function(width, idx) {
                        return width > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                            width: width,
                            backgroundColor: tracksColor[idx] || "#00AB6B"
                        }, idx.toString());
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Track, {
                        backgroundColor: "#00AB6B"
                    }, "tracks")
                })
            ]
        })
    });
};
/* harmony default export */ var components_Slider = (Slider);

// EXTERNAL MODULE: ./src/global/TradingModal/components/FormItem.tsx
var FormItem = __webpack_require__(27892);
// EXTERNAL MODULE: ./src/global/TradingModal/utils/generateStepPrice.ts
var generateStepPrice = __webpack_require__(97103);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/store.ts



var store_initialState = {
    price: 0,
    shares: 0,
    stockCode: "",
    latestPortfolio: {
        isLoading: false,
        message: "",
        data: {
            available_lot: 0,
            price_average: 0
        },
        error: ""
    }
};
var virtualTradingStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, store_initialState), {
        setPrice: function(payload) {
            set({
                price: payload
            });
        },
        setShares: function(payload) {
            set({
                shares: payload
            });
        },
        setStockCode: function(payload) {
            set({
                stockCode: payload
            });
        },
        resetOrderData: function() {
            set(store_initialState);
        }
    });
});
/* harmony default export */ var store = (virtualTradingStore);

// EXTERNAL MODULE: ./src/global/TradingModal/components/NumberInput.tsx
var NumberInput = __webpack_require__(93951);
;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/FormSell.tsx






















var Text = ui/* Common.Text */.Gn.Text;
function FormSell(param) {
    var orderType = param.orderType, _orderid = param.orderid, orderid = _orderid === void 0 ? undefined : _orderid, orderedLot = param.orderedLot, orderedPrice = param.orderedPrice, closeModal = param.closeModal;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isButtonLoading = ref1[0], setIsButtonLoading = ref1[1];
    var ref2 = stores_usePortfolioStore(), _portfolio = ref2.portfolio, _price = _portfolio.price, priceAverage = _price.average, available_lot = _portfolio.available_lot;
    var ref3 = store(), price = ref3.price, shares = ref3.shares, setPrice = ref3.setPrice, setShares = ref3.setShares;
    var ref4 = (0,tradingData/* default */.Z)(), company = ref4.company, getOrderHistory = ref4.getOrderHistory, getPortfolio = ref4.getPortfolio;
    var postTradeSellData = (0,tradingOperation/* default */.Z)().postTradeSellData;
    var createVirtualOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualOrder;
    });
    var createVirtualAmendOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualAmendOrder;
    });
    var ref5 = (0,react.useMemo)(function() {
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL && Number(orderedPrice) === Number(price)) {
            return {
                avalilableLot: available_lot + orderedLot,
                maxLot: orderedLot
            };
        }
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL && Number(orderedPrice) !== Number(price)) {
            return {
                avalilableLot: available_lot + orderedLot,
                maxLot: available_lot + orderedLot
            };
        }
        return {
            avalilableLot: available_lot,
            maxLot: available_lot
        };
    }, [
        available_lot,
        orderedLot,
        orderType,
        price,
        orderedPrice
    ]), avalilableLot = ref5.avalilableLot, maxLot = ref5.maxLot;
    if (!company) return null;
    var isLoading = postTradeSellData.isLoading;
    var symbol = (company === null || company === void 0 ? void 0 : (ref = company.data) === null || ref === void 0 ? void 0 : ref.symbol) ? company.data.symbol : "";
    var lot = shares / 100 > maxLot ? maxLot : shares / 100;
    var buyAmount = (0,formula/* getBuyLot */.V$)(lot, priceAverage);
    var sellLot = (0,formula/* getSellLot */.K1)(lot, price);
    var sellProfitLoss = (0,formula/* getSellProfitLoss */.FZ)(lot, price, buyAmount);
    var sellGain = (0,formula/* getSellGain */.Sd)(sellProfitLoss, buyAmount);
    var onSubmitOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!isLoading) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsButtonLoading(true);
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL)) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 7;
                        return createVirtualAmendOrder({
                            gtc: false,
                            order_id: orderid,
                            price: Number(price),
                            shares: Number(shares),
                            symbol: symbol
                        });
                    case 7:
                        getOrderHistory(false);
                        getPortfolio(false);
                        virtualTrading/* virtualTradingAction.onAmendOrderPlaced */.SP.onAmendOrderPlaced({
                            Symbol: symbol,
                            Price: price,
                            Type: virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading
                        });
                        closeModal();
                        setIsButtonLoading(false);
                    case 12:
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 15;
                        return createVirtualOrder("sell", symbol, {
                            gtc: false,
                            price: Number(price),
                            shares: Number(shares),
                            tradeshare: false
                        });
                    case 15:
                        virtualTrading/* virtualTradingAction.onSellOrderPlaced */.SP.onSellOrderPlaced({
                            Symbol: symbol,
                            Price: price,
                            gainLossPercentage: (0,number/* formatNumber */.uf)(sellGain * constant/* lotSize */.CQ, false, "0.00"),
                            Type: virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading
                        });
                        closeModal();
                        setIsButtonLoading(false);
                        router.push("/trade/order");
                    case 19:
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](0);
                        Promise.reject(_ctx.t0);
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    21
                ]
            ]);
        }));
        return function onSubmitOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var onLotChange = function(lotValue) {
        setShares(lotValue * 100);
    };
    var onPriceChange = function(newPrice, lotValue) {
        setPrice(newPrice);
        onLotChange(lotValue); // On Amend, changing price can also changing lot value
    };
    var initValue = function() {
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL) {
            var ref;
            onPriceChange((ref = company.data) === null || ref === void 0 ? void 0 : ref.price, avalilableLot);
        }
        if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL) {
            onPriceChange(orderedPrice, orderedLot);
        }
    };
    (0,react.useEffect)(function() {
        initValue();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Available Lot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    align: "right",
                    children: avalilableLot
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Sell Order Lot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Slider, {
                    min: 0,
                    max: maxLot,
                    value: lot,
                    onChange: onLotChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    value: lot,
                    min: 0,
                    max: maxLot,
                    step: 1,
                    onChange: onLotChange
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Price",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    value: price,
                    min: 1,
                    step: (0,generateStepPrice/* default */.Z)(price),
                    onChange: function(v) {
                        return onPriceChange(v, lot);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Proceed Amount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                    align: "right",
                    children: (0,number/* formatNumber */.uf)(sellLot, false)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Profit/Loss",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                    align: "right",
                    color: (0,general/* getColorBasedOnNumber */.pV)(sellProfitLoss),
                    children: [
                        sellProfitLoss > 0 && "+",
                        (0,number/* formatNumber */.uf)(sellProfitLoss, false),
                        " (",
                        sellGain > 0 && "+",
                        (0,number/* formatNumber */.uf)(sellGain * 100, false, "0.00"),
                        "%)"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWrapper */.W4, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                    disabled: shares < 100,
                    onClick: function() {
                        onSubmitOrder();
                    },
                    loading: isButtonLoading,
                    type: "secondary",
                    height: "40px",
                    radius: "4px",
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var VirtualTradingModal_FormSell = (FormSell);

// EXTERNAL MODULE: ./src/hooks/useTradingAccount.ts
var useTradingAccount = __webpack_require__(64999);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/store.ts
var AuthModal_store = __webpack_require__(70175);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/OverLimitText.tsx


var Flex = ui/* Common.Flex */.Gn.Flex, OverLimitText_Text = ui/* Common.Text */.Gn.Text, Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function OverLimitText(param) {
    var isRight = param.isRight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        ml: "180px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon, {
                size: "20px",
                className: "icon-toolbar_error"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(OverLimitText_Text, {
                size: "13px",
                color: "red",
                ml: "3px",
                mb: "10px",
                children: [
                    "Nilai pembelian kamu tidak dapat diproses karena melebihi",
                    " ",
                    isRight ? "cash on hand" : "trading limit"
                ]
            })
        ]
    });
}
/* harmony default export */ var components_OverLimitText = (OverLimitText);

;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/FormBuy.tsx





















var FormBuy_Text = ui/* Common.Text */.Gn.Text, IconWrapper = ui/* Common.IconWrapper */.Gn.IconWrapper, FormBuy_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function FormBuy(param) {
    var orderType = param.orderType, orderid = param.orderid, closeModal = param.closeModal;
    var router = (0,next_router.useRouter)();
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var ref = (0,tradingData/* default */.Z)(), portfolio = ref.portfolio, getOrderHistory = ref.getOrderHistory, getPortfolio = ref.getPortfolio;
    var showAuthModal = (0,AuthModal_store/* default */.Z)(function(state) {
        return state.showModal;
    });
    var isLoading = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.isLoading;
    });
    var createVirtualOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualOrder;
    });
    var createVirtualAmendOrder = (0,useVirtualOrderStore/* useVirtualOrderStore */.R)(function(s) {
        return s.createVirtualAmendOrder;
    });
    var tradingbalance = portfolio.data.tradingbalance;
    var ref1 = store(), price = ref1.price, shares = ref1.shares, stockCode = ref1.stockCode, setPrice = ref1.setPrice, setShares = ref1.setShares;
    var amount = (0,formula/* getBuyLot */.V$)(shares / constant/* lotSize */.CQ, Number(price));
    var onSubmitOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 4;
                        return createVirtualAmendOrder({
                            gtc: false,
                            order_id: orderid,
                            price: Number(price),
                            shares: Number(shares),
                            symbol: stockCode
                        });
                    case 4:
                        if (!(orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY)) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return createVirtualOrder("buy", stockCode, {
                            gtc: false,
                            price: Number(price),
                            shares: Number(shares),
                            tradeshare: false
                        });
                    case 7:
                        getOrderHistory(false);
                        getPortfolio(false);
                        closeModal();
                        if (orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY) {
                            router.push("/trade/order");
                        }
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        Promise.reject(_ctx.t0);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function onSubmitOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClickSwitchVirtual = function() {
        var isVirtualBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY;
        closeModal();
        if (isVirtualBuy) {
            showAuthModal({
                symbol: stockCode,
                orderType: constants/* AUTH_ORDER_TYPE.BUY */.q.BUY
            });
        }
    };
    var isOverlimit = price * shares > tradingbalance;
    var disableBuy = shares < 100 || isOverlimit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Trading Balance",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBuy_Text, {
                    family: "bold",
                    children: (0,number/* formatNumber */.uf)(tradingbalance, isRealTrading, isOverlimit ? "0.00" : "0,0")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Amount",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBuy_Text, {
                    children: (0,number/* formatNumber */.uf)(amount, false)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Price",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    value: price,
                    min: 0,
                    step: (0,generateStepPrice/* default */.Z)(price),
                    onChange: function(newPrice) {
                        return setPrice(newPrice);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItem/* default */.Z, {
                label: "Buy Order Lot",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumberInput/* default */.Z, {
                    defaultValue: 0,
                    min: 0,
                    value: shares / constant/* lotSize */.CQ,
                    step: 1,
                    onChange: function(lot) {
                        setShares(lot * constant/* lotSize */.CQ);
                    }
                })
            }),
            isOverlimit && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OverLimitText, {
                isRight: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* SwitchWrapper */.iV, {
                onClick: onClickSwitchVirtual,
                isOverlimit: isOverlimit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBuy_Text, {
                        align: "center",
                        color: "#00ab6b",
                        mr: "5px",
                        children: "Switch to Real Account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                        size: "18px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBuy_Iconmoon, {
                            className: "icon-tradesmall_switch",
                            size: "12px",
                            color: ui/* color.primary */.$_.primary
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWrapper */.W4, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                    disabled: disableBuy,
                    onClick: function() {
                        onSubmitOrder();
                        virtualTrading/* virtualTradingAction.onBuyOrderPlaced */.SP.onBuyOrderPlaced({
                            Symbol: stockCode,
                            Price: price,
                            Lot: shares / constant/* lotSize */.CQ,
                            Type: virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading
                        });
                    },
                    loading: isLoading,
                    type: "primary",
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBuy_Text, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var VirtualTradingModal_FormBuy = (FormBuy);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx + 1 modules
var SearchCompany = __webpack_require__(77017);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 49 modules
var es_select = __webpack_require__(92961);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 30px;\n  max-width: 75px;\n\n  @media ",
        " {\n    max-width: 150px;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  display: flex;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-right: 1px solid ",
        ";\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 110px;\n  left: -5%;\n  z-index: 9999;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n\n  @media ",
        " {\n    top: 95px;\n    left: -15%;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: rgba(255, 199, 116, 0.1);\n  border: 1px solid #eba031;\n  border-radius: 4px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #3a645c;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 120px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



var styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text, BaseTooltip = ui/* Common.Tooltip */.Gn.Tooltip;
var PriceWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    wrap: "wrap",
    align: "center",
    justify: "flex-end",
    width: "100%"
}).withConfig({
    componentId: "sc-b59766d3-0"
})(styled_templateObject(), ui/* device.table */.Uh.table);
var BidOfferWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-b59766d3-1"
})(styled_templateObject1(), ui/* device.tablet */.Uh.tablet);
var BidOffer = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    width: "70px",
    height: "30px"
}).withConfig({
    componentId: "sc-b59766d3-2"
})(styled_templateObject2(), ui/* color.gainsboro */.$_.gainsboro);
var LeftBox = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    width: "40%",
    height: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-b59766d3-3"
})(styled_templateObject3(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.gainsboro */.$_.gainsboro);
var RightBox = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    width: "60%",
    height: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-b59766d3-4"
})(styled_templateObject4());
var SyariahLabelWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    align: "center",
    justify: "center",
    px: "5px",
    py: "2px",
    ml: "5px"
}).withConfig({
    componentId: "sc-b59766d3-5"
})(_templateObject5(), ui/* color.primary */.$_.primary);
var NotationPopoverWrapper = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    direction: "column",
    align: "center",
    justify: "center",
    padding: "20px",
    width: "350px"
}).withConfig({
    componentId: "sc-b59766d3-6"
})(_templateObject6(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.light */.$_.light, ui/* device.tablet */.Uh.tablet);
var NotationCodeBox = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    width: "30px",
    align: "center",
    justify: "center",
    mr: "10px"
}).withConfig({
    componentId: "sc-b59766d3-7"
})(_templateObject7());
var NotationDesc = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    margin: "0 0 10px 10px",
    py: "5px"
}).withConfig({
    componentId: "sc-b59766d3-8"
})(_templateObject8(), ui/* color.downgray */.$_.downgray);
var SymbolAvatar = (0,styled_components_browser_esm["default"])(styled_Flex).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-b59766d3-9"
})(_templateObject9());
var CustomTooltip = (0,styled_components_browser_esm["default"])(BaseTooltip).withConfig({
    componentId: "sc-b59766d3-10"
})(_templateObject10());
var TooltipContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b59766d3-11"
})(_templateObject11(), ui/* color.light */.$_.light);
var TransactionFormSelect = (0,styled_components_browser_esm["default"])(es_select/* default */.Z).withConfig({
    componentId: "sc-b59766d3-12"
})(_templateObject12());


;// CONCATENATED MODULE: ./src/global/TradingModal/components/NotationPopover.tsx





var NotationPopover_Text = ui/* Common.Text */.Gn.Text, NotationPopover_Flex = ui/* Common.Flex */.Gn.Flex;
function NotationPopover(param) {
    var data = param.data;
    var ref = (0,react.useState)(false), isShown = ref[0], setIsShown = ref[1];
    var notation = data.notation, symbol = data.symbol, name = data.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationPopover_Flex, {
        onMouseEnter: function() {
            return setIsShown(true);
        },
        onMouseLeave: function() {
            return setIsShown(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/ic_indicator.svg",
                alt: "warning",
                width: "12px"
            }),
            isShown && /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationPopoverWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationPopover_Flex, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationPopover_Text, {
                                size: "24px",
                                family: "bold",
                                align: "center",
                                mr: "5px",
                                children: symbol
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/ic_indicator.svg",
                                alt: "warning",
                                width: "12px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationPopover_Text, {
                        align: "center",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationPopover_Text, {
                        align: "center",
                        padding: "15px",
                        children: "Perusahaan memiliki notasi khusus sebagai berikut:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationPopover_Flex, {
                        direction: "column",
                        children: notation.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotationPopover_Flex, {
                                align: "center",
                                justify: "center",
                                padding: "5px 10px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationCodeBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationPopover_Text, {
                                            color: "#eba031",
                                            children: item.notation_code
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NotationDesc, {
                                        children: item.notation_desc
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_NotationPopover = (NotationPopover);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/CompanyLabel.tsx





var CompanyLabel_Text = ui/* Common.Text */.Gn.Text, CompanyLabel_Flex = ui/* Common.Flex */.Gn.Flex;
function CompanyLabel(param) {
    var data = param.data;
    var notation = data.notation, corp_action = data.corp_action, catalogs = data.catalogs;
    var checkIsSyariah = function() {
        var syariahCatalog = catalogs.find(function(param) {
            var company_symbol = param.company_symbol;
            return company_symbol === "Syariah";
        });
        return syariahCatalog !== undefined;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyLabel_Flex, {
        align: "center",
        justify: "center",
        ml: "10px",
        children: [
            notation.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NotationPopover, {
                data: data
            }),
            corp_action.active && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/corp_action_event_icon.svg",
                alt: "corp_action",
                style: {
                    marginLeft: "5px"
                }
            }),
            checkIsSyariah() && /*#__PURE__*/ (0,jsx_runtime.jsx)(SyariahLabelWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLabel_Text, {
                    size: "12px",
                    color: ui/* color.primary */.$_.primary,
                    children: "Syariah"
                })
            })
        ]
    });
}
/* harmony default export */ var components_CompanyLabel = (CompanyLabel);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/BidOfferBox.tsx




var BidOfferBox_Text = ui/* Common.Text */.Gn.Text;
function BidOfferBox(param) {
    var orderbook = param.orderbook;
    var bid = orderbook.bid, offer = orderbook.offer;
    var bidPrice = bid.price ? (0,number/* formatNumber */.uf)(bid.price, false) : "-";
    var offerPrice = offer.price ? (0,number/* formatNumber */.uf)(offer.price, false) : "-";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BidOfferWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BidOffer, {
                mr: "10px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BidOfferBox_Text, {
                            children: "B"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BidOfferBox_Text, {
                            children: bidPrice
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BidOffer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BidOfferBox_Text, {
                            children: "O"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BidOfferBox_Text, {
                            children: offerPrice
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_BidOfferBox = (BidOfferBox);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/HeaderVirtual.tsx















var HeaderVirtual_Text = ui/* Common.Text */.Gn.Text, HeaderVirtual_Flex = ui/* Common.Flex */.Gn.Flex, HeaderVirtual_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function TransactionHeader(param) {
    var orderType = param.orderType, onUpdateSymbol = param.onUpdateSymbol, isSearchActive = param.isSearchActive, _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle, setIsSearchActive = param.setIsSearchActive;
    var data = (0,tradingData/* default */.Z)(function(s) {
        return s.company;
    }).data;
    var ref = (0,react.useState)(false), showSearch = ref[0], setShowSearch = ref[1];
    if (!data) return null;
    var icon_url = data.icon_url, change = data.change, name = data.name, percentage = data.percentage, price = data.price, symbol = data.symbol, orderbook = data.orderbook;
    var isBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY;
    var isAmendBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY;
    var _obj;
    var modalTitles = (_obj = {}, (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY, "Buy"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL, "Sell"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY, "Amend Buy"), (0,_define_property/* default */.Z)(_obj, trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL, "Amend Sell"), _obj);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showTitle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Text, {
                    family: "bold",
                    color: isBuy || isAmendBuy ? ui/* color.primary */.$_.primary : ui/* color.sunsetOrange */.$_.sunsetOrange,
                    size: "24px",
                    align: "center",
                    children: modalTitles[orderType]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormHeader */.ph, {
                mt: "30px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Flex, {
                        justify: "space-between",
                        width: "100%",
                        style: {
                            display: isSearchActive ? "none" : "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Flex, {
                                align: "flex-start",
                                children: [
                                    !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolAvatar, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Text, {
                                            color: "white",
                                            family: "bold",
                                            size: "16px",
                                            children: symbol[0]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: icon_url,
                                        style: {
                                            width: "40px",
                                            height: "40px",
                                            background: "white"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Flex, {
                                        direction: "column",
                                        pl: "15px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Flex, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Text, {
                                                        family: "bold",
                                                        size: "16px",
                                                        children: symbol
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyLabel, {
                                                        data: data
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Flex, {
                                                mt: "3px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Text, {
                                                        size: "14px",
                                                        color: ui/* color.midgray */.$_.midgray,
                                                        mr: "5px",
                                                        children: name
                                                    }),
                                                    (isBuy || isAmendBuy) && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Iconmoon, {
                                                        className: "icon-tradesmall_pencil2",
                                                        size: "14px",
                                                        hoverColor: ui/* color.highgray */.$_.highgray,
                                                        onClick: function() {
                                                            setIsSearchActive();
                                                            setShowSearch(!showSearch);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Text, {
                                                family: "bold",
                                                children: (0,number/* formatNumber */.uf)(price, false)
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Text, {
                                                color: (0,general/* getColorBasedOnNumber */.pV)(change),
                                                children: change && change.slice(1)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderVirtual_Text, {
                                                color: function() {
                                                    if (change === 0) return ui/* color.nightRider */.$_.nightRider;
                                                    if (change > 0) return ui/* color.primary */.$_.primary;
                                                    return ui/* color.sunsetOrange */.$_.sunsetOrange;
                                                },
                                                children: [
                                                    "(",
                                                    percentage > 0 && "+",
                                                    (0,number/* formatNumber */.uf)(percentage, false, "0.00%"),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BidOfferBox, {
                                        orderbook: orderbook
                                    })
                                ]
                            })
                        ]
                    }),
                    isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual_Flex, {
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                            isInTradingModal: true,
                            updateSymbol: function(newSymbol) {
                                return onUpdateSymbol(newSymbol);
                            }
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var HeaderVirtual = (TransactionHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/global/Securities/components/SkeletonWrapper/index.tsx
var SkeletonWrapper = __webpack_require__(27607);
// EXTERNAL MODULE: ./src/features/company/Stream/TableOrderbook/hooks/useBestBidData.ts
var useBestBidData = __webpack_require__(88259);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLC.styled.ts

function TableOHLC_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: auto;\n"
    ]);
    TableOHLC_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  background: #ffffff;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  table-layout: fixed;\n  width: 321px;\n\n  tbody {\n    display: block;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: 320px;\n  }\n\n  thead, tbody tr, tfoot {\n    display: table;\n    width: 320px;\n    table-layout: fixed;\n  }\n\n  tbody, tfoot {\n    .blurred {\n      opacity: 0.4;\n    }\n  }\n\n  tbody > tr.best-bid-offer {\n    border-width: 5px 3px;\n    border-style: solid; \n    border-color: #EDEDED;\n\n    td > p {\n      line-height: 14px;\n      font-weight: normal;\n      text-align: center;\n      padding: 4px 0px;\n    }\n  }\n\n  thead {\n    th:first-child, th:last-child {\n      width: 40px;\n    }\n\n    th:nth-child(2), th:nth-child(5) {\n      width: 66.5px;\n    }\n\n    th:nth-child(3), th:nth-child(4) {\n      width: 50px;\n    }\n  }\n\n  tbody {\n    td:first-child, td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2), td:nth-child(5) {\n      width: 66.5px;\n    }\n\n    td:nth-child(3), td:nth-child(4) {\n      width: 50px;\n    }\n  }\n\n  tfoot {\n    td:nth-child(3) {\n      width: 100px;\n    }\n\n    td:first-child, td:last-child {\n      width: 40px;\n    }\n\n    td:nth-child(2), td:nth-child(4) {\n      width: 66.5px;\n    }\n  }\n"
    ]);
    TableOHLC_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid #dadada;\n"
    ]);
    TableOHLC_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f7f7f7;\n  padding: 8px 0;\n  color: #333333;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n"
    ]);
    TableOHLC_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n"
    ]);
    TableOHLC_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  min-width: ",
        ";\n  max-width: ",
        ";\n  margin: 0;\n  padding: 8px 0;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  white-space: nowrap;\n\n  &:empty::before {\n    content: '';\n    display: inline-block;\n  }\n"
    ]);
    TableOHLC_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid #dadada;\n  background: #f7f7f7;\n"
    ]);
    TableOHLC_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #333333;\n  margin: 0;\n  padding: 8px 0;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n"
    ]);
    TableOHLC_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function TableOHLC_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  & > .ant-skeleton-button {\n    vertical-align: middle;\n    width: 80%;\n    height: 16px;\n  }\n"
    ]);
    TableOHLC_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var OHLCContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-d26fb0e-0"
})(TableOHLC_styled_templateObject());
var OHLCTable = styled_components_browser_esm["default"].table.withConfig({
    componentId: "sc-d26fb0e-1"
})(TableOHLC_styled_templateObject1());
var OHLCTableHead = styled_components_browser_esm["default"].thead.withConfig({
    componentId: "sc-d26fb0e-2"
})(TableOHLC_styled_templateObject2());
var OHLCTableHeadData = styled_components_browser_esm["default"].th.withConfig({
    componentId: "sc-d26fb0e-3"
})(TableOHLC_styled_templateObject3());
var OHLCTableBodyData = styled_components_browser_esm["default"].td.withConfig({
    componentId: "sc-d26fb0e-4"
})(TableOHLC_styled_templateObject4());
var OHLCCellText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-d26fb0e-5"
})(TableOHLC_styled_templateObject5(), function(param) {
    var color = param.color;
    return color || "#333333";
}, function(param) {
    var minWidth = param.minWidth;
    return minWidth ? "".concat(minWidth, "px") : "unset";
}, function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth ? "".concat(maxWidth, "px") : "unset";
});
var OHLCTableFoot = styled_components_browser_esm["default"].tfoot.withConfig({
    componentId: "sc-d26fb0e-6"
})(TableOHLC_styled_templateObject6());
var OHLCTableFootData = styled_components_browser_esm["default"].td.withConfig({
    componentId: "sc-d26fb0e-7"
})(TableOHLC_styled_templateObject7());
var TableOHLCTextSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-d26fb0e-8"
})(TableOHLC_styled_templateObject8());

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLCSkeleton.tsx


var TableOHLCSkeleton = function(param) {
    var _rows = param.rows, rows = _rows === void 0 ? 10 : _rows, _columns = param.columns, columns = _columns === void 0 ? 6 : _columns;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OHLCTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHead, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: new Array(columns).fill("").map(function(_, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCTextSkeleton, {
                                    active: true
                                })
                            }, idx.toString());
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    style: {
                        padding: "11px 0"
                    },
                    children: new Array(rows).fill("").map(function(_, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: new Array(6).fill("").map(function(__, subIdx) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCTextSkeleton, {
                                            active: true
                                        })
                                    })
                                }, subIdx.toString());
                            })
                        }, idx.toString());
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFoot, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: new Array(columns).fill("").map(function(_, idx) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCTextSkeleton, {
                                    active: true
                                })
                            }, idx.toString());
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TableOrderbook_TableOHLCSkeleton = (TableOHLCSkeleton);

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/types.ts
var StockPriceMovement;
(function(StockPriceMovement) {
    StockPriceMovement["Up"] = "Up";
    StockPriceMovement["Down"] = "Down";
    StockPriceMovement["Flat"] = "Flat";
})(StockPriceMovement || (StockPriceMovement = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/constants.ts



var _obj;
var stockPriceMovementColor = (_obj = {}, (0,_define_property/* default */.Z)(_obj, StockPriceMovement.Flat, "#94B041"), (0,_define_property/* default */.Z)(_obj, StockPriceMovement.Down, ui/* color.sunsetOrange */.$_.sunsetOrange), (0,_define_property/* default */.Z)(_obj, StockPriceMovement.Up, ui/* color.primary */.$_.primary), _obj);
var orderbookDataKey = {
    price: "price",
    frequency: "que_num",
    volume: "volume"
};
var bidOfferRowQuantity = 10;

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/utils.tsx




var getLengthOrderbook = function() {
    var bid = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, offer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var newBid = bid || {};
    var newOffer = offer || {};
    var bidLength = (ref = Object.keys(newBid).filter(function(key) {
        return key.includes("price");
    })) === null || ref === void 0 ? void 0 : ref.length;
    var offerLength = Object.keys(newOffer).filter(function(key) {
        return key.includes("price");
    }).length;
    var dataLength = Math.max(bidLength, offerLength);
    var dataShowedLength = dataLength <= 10 ? 10 : dataLength;
    return dataShowedLength;
};
var getStockPriceMovement = function(currentPrice, previousPrice) {
    if (currentPrice === previousPrice) return StockPriceMovement.Flat;
    return currentPrice < previousPrice ? StockPriceMovement.Down : StockPriceMovement.Up;
};
var getBidOfferList = function(item, length) {
    var itemList = {
        frequency: [],
        volume: [],
        price: []
    };
    if (!item) return itemList;
    for(var i = 1; i <= length; i += 1){
        itemList.frequency = (0,_to_consumable_array/* default */.Z)(itemList.frequency).concat([
            Number(item === null || item === void 0 ? void 0 : item["".concat(orderbookDataKey.frequency).concat(i)]) || 0, 
        ]);
        itemList.price = (0,_to_consumable_array/* default */.Z)(itemList.price).concat([
            Number(item === null || item === void 0 ? void 0 : item["".concat(orderbookDataKey.price).concat(i)]) || 0, 
        ]);
        itemList.volume = (0,_to_consumable_array/* default */.Z)(itemList.volume).concat([
            (Number(item === null || item === void 0 ? void 0 : item["".concat(orderbookDataKey.volume).concat(i)]) || 0) / constant/* lotSize */.CQ, 
        ]);
    }
    return itemList;
};
var getTotalFrequencyVolume = function(bid, offer, lengthRow) {
    var frequencyVolume = {
        bid: {
            frequency: 0,
            volume: 0
        },
        offer: {
            frequency: 0,
            volume: 0
        }
    };
    var newBid = frequencyVolume.bid, newOffer = frequencyVolume.offer;
    for(var i = 0; i < lengthRow; i += 1){
        if (bid.frequency[i]) newBid.frequency += bid.frequency[i];
        if (bid.volume[i]) newBid.volume += bid.volume[i];
        if (offer.frequency[i]) newOffer.frequency += offer.frequency[i];
        if (offer.volume[i]) newOffer.volume += offer.volume[i];
    }
    return frequencyVolume;
};
var getTextColor = function(currentPrice, previousPrice) {
    return stockPriceMovementColor[getStockPriceMovement(currentPrice, previousPrice)];
};
var formatNumber = function(value) {
    return value.toLocaleString(undefined, {
        maximumFractionDigits: 0
    });
};
var formatCellValue = function(value) {
    return !value ? "-" : formatNumber(value);
};

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLCBestBidOffer.tsx



var OHLCBestBidOffer = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var data = props.data, previous = props.previous;
    if (!data) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        className: "best-bid-offer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 40,
                    maxWidth: 55,
                    children: "-"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 50,
                    children: formatCellValue((ref = data.bid) === null || ref === void 0 ? void 0 : (ref1 = ref.quantity) === null || ref1 === void 0 ? void 0 : ref1.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    "data-cy": "bid-price",
                    minWidth: 50,
                    maxWidth: 55,
                    color: getTextColor((ref2 = data.bid) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.raw, previous),
                    children: formatCellValue((ref4 = data.bid) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.price) === null || ref5 === void 0 ? void 0 : ref5.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    "data-cy": "offer-price",
                    minWidth: 50,
                    maxWidth: 55,
                    color: getTextColor((ref6 = data.offer) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.price) === null || ref7 === void 0 ? void 0 : ref7.raw, previous),
                    children: formatCellValue((ref8 = data.offer) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.price) === null || ref9 === void 0 ? void 0 : ref9.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 50,
                    children: formatCellValue((ref10 = data.offer) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.quantity) === null || ref11 === void 0 ? void 0 : ref11.raw)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                    minWidth: 40,
                    maxWidth: 55,
                    children: "-"
                })
            })
        ]
    });
};
/* harmony default export */ var TableOHLCBestBidOffer = (OHLCBestBidOffer);

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableOHLC.tsx










var TableOHLC = function(param) {
    var bid = param.bid, offer = param.offer, previous = param.previous, loading = param.loading, _isEmpty = param.isEmpty, isEmpty = _isEmpty === void 0 ? false : _isEmpty, bestBidOffer = param.bestBidOffer, _marketStatus = param.marketStatus, marketStatus = _marketStatus === void 0 ? "close" : _marketStatus;
    var lengthOrderbook = (0,react.useMemo)(function() {
        if (bid && offer) {
            return getLengthOrderbook(bid, offer);
        }
        return bidOfferRowQuantity;
    }, [
        bid,
        offer
    ]);
    var bidList = (0,react.useMemo)(function() {
        return getBidOfferList(bid, lengthOrderbook);
    }, [
        bid,
        lengthOrderbook
    ]);
    var offerList = (0,react.useMemo)(function() {
        return getBidOfferList(offer, lengthOrderbook);
    }, [
        offer,
        lengthOrderbook
    ]);
    var ref = (0,react.useMemo)(function() {
        return getTotalFrequencyVolume({
            frequency: bidList.frequency,
            volume: bidList.volume
        }, {
            frequency: offerList.frequency,
            volume: offerList.volume
        }, lengthOrderbook);
    }, [
        bidList.frequency.join(),
        bidList.volume.join(),
        offerList.frequency.join(),
        offerList.volume.join(),
        lengthOrderbook, 
    ]), bidTotal = ref.bid, offerTotal = ref.offer;
    var initialBestBidOffer = (0,react.useMemo)(function() {
        return bestBidOffer;
    }, []);
    var ref1 = (0,useBestBidData/* default */.Z)(initialBestBidOffer, null, marketStatus), isBlured = ref1.isBlured, showBestBid = ref1.showBestBid;
    var getRowClassName = (0,react.useCallback)(function() {
        if (isBlured) {
            return "blurred";
        }
        return "";
    }, [
        isBlured
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableOHLCSkeleton, {}),
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCContainer, {
            "data-cy": "ohlc-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OHLCTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isEmpty || showBestBid,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHead, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Freq"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Lot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Bid"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Offer"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Lot"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableHeadData, {
                                        children: "Freq"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: showBestBid,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOHLCBestBidOffer, {
                                    data: bestBidOffer,
                                    previous: previous
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isEmpty,
                                children: new Array(lengthOrderbook).fill("").map(function(_, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                        "data-cy": "ohlc-row-".concat(i),
                                        className: getRowClassName(),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    color: "#8277F8",
                                                    minWidth: 40,
                                                    maxWidth: 55,
                                                    children: formatCellValue(bidList.frequency[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 50,
                                                    children: formatCellValue(bidList.volume[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    "data-cy": "bid-price",
                                                    minWidth: 50,
                                                    maxWidth: 55,
                                                    color: getTextColor(bidList.price[i], previous),
                                                    children: formatCellValue(bidList.price[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    "data-cy": "offer-price",
                                                    minWidth: 50,
                                                    maxWidth: 55,
                                                    color: getTextColor(offerList.price[i], previous),
                                                    children: formatCellValue(offerList.price[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 50,
                                                    children: formatCellValue(offerList.volume[i])
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 40,
                                                    maxWidth: 55,
                                                    color: "#8277F8",
                                                    children: formatCellValue(offerList.frequency[i])
                                                })
                                            })
                                        ]
                                    }, "rows-".concat(i.toString()));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isEmpty && showBestBid,
                                children: Array.from({
                                    length: 10
                                }).map(function(_, idx) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                        children: Array.from({
                                            length: 6
                                        }).map(function(__, idy) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableBodyData, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCCellText, {
                                                    minWidth: 40,
                                                    maxWidth: 55,
                                                    children: "-"
                                                })
                                            }, "empty-".concat(idy.toString()));
                                        })
                                    }, "empty-row-".concat(idx.toString()));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: !isEmpty,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFoot, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                className: getRowClassName(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-bid-frequency",
                                        children: formatNumber(bidTotal.frequency)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-bid-volume",
                                        children: formatNumber(bidTotal.volume)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        colSpan: 2,
                                        children: "TOTAL"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-offer-volume",
                                        children: formatNumber(offerTotal.volume)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        "data-cy": "total-offer-frequency",
                                        children: formatNumber(offerTotal.frequency)
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isEmpty && showBestBid,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFoot, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        colSpan: 2,
                                        children: "TOTAL"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OHLCTableFootData, {
                                        children: "-"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TableOrderbook_TableOHLC = (TableOHLC);

// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableSecure.styled.ts

function TableSecure_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px;\n"
    ]);
    TableSecure_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-spacing: 0 8px;\n  border-collapse: separate;\n  margin: -8px 0;\n\n  & tr {\n    & > td:nth-child(odd) {\n      padding-left: 36px;\n    }\n    & > td:nth-child(even) {\n      padding-left: 2px;\n    }\n    & > td:first-child {\n      padding-left: 0;\n    }\n  }\n"
    ]);
    TableSecure_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    TableSecure_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: ",
        ";\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16px;\n  padding: 0;\n"
    ]);
    TableSecure_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & tr > td {\n    width: 40px;\n    height: 16px;\n\n    &:nth-child(odd) {\n      padding: 0;\n    }\n\n    & > div {\n      padding: 0 2px;\n      display: flex;\n      width: 100%;\n      & > span.ant-skeleton-button {\n        width: 100%;\n      }\n    }\n  }\n"
    ]);
    TableSecure_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TableSecure_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > .ant-skeleton-button {\n    height: 16px;\n    vertical-align: middle;\n  }\n"
    ]);
    TableSecure_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var SecureTableContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bda7231e-0"
})(TableSecure_styled_templateObject());
var SecureTable = styled_components_browser_esm["default"].table.withConfig({
    componentId: "sc-bda7231e-1"
})(TableSecure_styled_templateObject1());
var SecureTableRow = styled_components_browser_esm["default"].tr.withConfig({
    componentId: "sc-bda7231e-2"
})(TableSecure_styled_templateObject2(), function(param) {
    var _minWidth = param.minWidth, minWidth = _minWidth === void 0 ? [] : _minWidth;
    return minWidth.map(function(width, idx) {
        return "\n        & > td:nth-child(".concat(idx + 1, ") {\n          min-width: ").concat(width, "px;\n        }");
    });
});
var SecureTableData = styled_components_browser_esm["default"].td.withConfig({
    componentId: "sc-bda7231e-3"
})(TableSecure_styled_templateObject3(), function(param) {
    var color = param.color;
    return "".concat(color || "#333333");
}, function(param) {
    var align = param.align;
    return align;
});
var SecureTableTbodySkeleton = styled_components_browser_esm["default"].tbody.withConfig({
    componentId: "sc-bda7231e-4"
})(TableSecure_styled_templateObject4());
var TableSecureColumnSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default.Button */.Z.Button).withConfig({
    componentId: "sc-bda7231e-5"
})(TableSecure_styled_templateObject5());

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableSecureSkeleton.tsx


var TableSecureSkeleton = function(param) {
    var _row = param.row, row = _row === void 0 ? 3 : _row, _column = param.column, column = _column === void 0 ? 6 : _column;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTable, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableTbodySkeleton, {
                children: new Array(row).fill("").map(function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                        children: new Array(column).fill("").map(function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableSecureColumnSkeleton, {
                                    active: true
                                })
                            });
                        })
                    });
                })
            })
        })
    }, "skeleton-comp");
};
/* harmony default export */ var TableOrderbook_TableSecureSkeleton = (TableSecureSkeleton);

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableSecure.tsx










var defaultColumnsWidth = [
    24,
    53.3,
    30,
    47.33,
    21,
    56.3
];
var TableSecure = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data, _columnsWidth = param.columnsWidth, columnsWidth = _columnsWidth === void 0 ? defaultColumnsWidth : _columnsWidth, loading = param.loading, _isStock = param.isStock, isStock = _isStock === void 0 ? false : _isStock;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var formatNumber = function(value) {
        var format = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "0,0";
        return numeral_default()(value).format(format);
    };
    var getTextColor = function(currentPrice) {
        var previousPrice = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : data.previous;
        return stockPriceMovementColor[getStockPriceMovement(currentPrice, previousPrice)];
    };
    var ref8 = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!((ref = data.iepiev) === null || ref === void 0 ? void 0 : ref.iep) && !((ref1 = data.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev)) return [];
        var iepRaw = data.iepiev.iep.raw;
        var ievRaw = data.iepiev.iev.raw;
        var iep = formatNumber(iepRaw);
        var iev = data.iepiev.iev.raw ? (0,number/* parseCountAbbrv2 */.St)(ievRaw, 1, ",", true) : 0;
        var timeleft = data.iepiev.time_left_seconds;
        var showiepiev = iep && iev && (timeleft !== undefined ? timeleft > 0 : true);
        return [
            iep,
            iev,
            showiepiev
        ];
    }, [
        data.iepiev
    ]), Iep = ref8[0], Iev = ref8[1], showIepIev = ref8[2];
    var fourthRowExist = (0,react.useMemo)(function() {
        return showIepIev || data.is_foreignbs_exist;
    }, [
        showIepIev,
        data.is_foreignbs_exist
    ]);
    var lot = (0,react.useMemo)(function() {
        return data.volume ? number/* default.parseCountAbbrv3 */.ZP.parseCountAbbrv3(number/* default.parseLot */.ZP.parseLot(data.volume), 1, 4) : "NA";
    }, [
        data.volume
    ]);
    if (!loading && !data) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableSecureSkeleton, {}),
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTable, {
                children: isStock ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Open"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.open),
                                    "data-cy": "open-content",
                                    children: formatNumber(data.open)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Prev"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.previous),
                                    "data-cy": "previous-content",
                                    children: formatNumber(data.previous)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.change, 0),
                                    "data-cy": "volume-content",
                                    children: lot
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "High"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.high),
                                    "data-cy": "high-content",
                                    children: formatNumber(data.high)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "ARA"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "ara-content",
                                    children: (data === null || data === void 0 ? void 0 : (ref = data.ara) === null || ref === void 0 ? void 0 : ref.visible) ? data === null || data === void 0 ? void 0 : (ref1 = data.ara) === null || ref1 === void 0 ? void 0 : ref1.value : "-"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Val"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.change, 0),
                                    "data-cy": "value-content",
                                    children: number/* default.numberFormatter */.ZP.numberFormatter({
                                        num: data.value,
                                        fixed: 1
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Low"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.low),
                                    "data-cy": "low-content",
                                    children: formatNumber(data.low)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "ARB"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "arb-content",
                                    children: (data === null || data === void 0 ? void 0 : (ref2 = data.arb) === null || ref2 === void 0 ? void 0 : ref2.visible) ? data === null || data === void 0 ? void 0 : (ref3 = data.arb) === null || ref3 === void 0 ? void 0 : ref3.value : "-"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Avg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.average),
                                    "data-cy": "average-content",
                                    children: formatNumber(data.average)
                                })
                            ]
                        }),
                        fourthRowExist && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                showIepIev ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "IEP"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "iep-content",
                                            color: getTextColor((ref4 = data.iepiev) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.iep) === null || ref5 === void 0 ? void 0 : ref5.raw),
                                            children: Iep
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "IEV"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "iev-content",
                                            children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(Iev, 0, true)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "F Buy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "fbuy-content",
                                            color: ui/* color.primary */.$_.primary,
                                            children: number/* default.numberFormatter */.ZP.numberFormatter({
                                                num: data.fbuy,
                                                fixed: 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "F Sell"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "fsell-content",
                                            color: ui/* color.sunsetOrange */.$_.sunsetOrange,
                                            children: number/* default.numberFormatter */.ZP.numberFormatter({
                                                num: data.fsell,
                                                fixed: 1
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Freq"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "frequency-content",
                                    children: formatNumber(data.frequency)
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Prev"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.previous),
                                    "data-cy": "previous-content",
                                    children: formatNumber(data.previous)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Open"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.open),
                                    "data-cy": "open-content",
                                    children: formatNumber(data.open)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Lot"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.change, 0),
                                    "data-cy": "volume-content",
                                    children: lot
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Chg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.change, 0),
                                    "data-cy": "change-content",
                                    children: [
                                        data.change > 0 && "+",
                                        formatNumber(data.change)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "High"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.high),
                                    "data-cy": "high-content",
                                    children: formatNumber(data.high)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Val"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.change, 0),
                                    "data-cy": "value-content",
                                    children: number/* default.numberFormatter */.ZP.numberFormatter({
                                        num: data.value,
                                        fixed: 1
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableRow, {
                            minWidth: columnsWidth,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "%"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.percentage_change, 0),
                                    "data-cy": "percentage_change-content",
                                    children: [
                                        formatNumber(data.percentage_change, "0.00"),
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Low"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.low),
                                    "data-cy": "low-content",
                                    children: formatNumber(data.low)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Avg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    color: getTextColor(data.average),
                                    "data-cy": "average-content",
                                    children: formatNumber(data.average)
                                })
                            ]
                        }),
                        fourthRowExist && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    children: "Freq"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                    align: "right",
                                    "data-cy": "frequency-content",
                                    children: formatNumber(data.frequency)
                                }),
                                showIepIev ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "IEP"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "iep-content",
                                            color: getTextColor((ref6 = data.iepiev) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.iep) === null || ref7 === void 0 ? void 0 : ref7.raw),
                                            children: Iep
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "IEV"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "iev-content",
                                            children: number/* default.kNumberFormatter */.ZP.kNumberFormatter(Iev, 0, true)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "F Buy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "fbuy-content",
                                            color: ui/* color.primary */.$_.primary,
                                            children: number/* default.numberFormatter */.ZP.numberFormatter({
                                                num: data.fbuy,
                                                fixed: 1
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            children: "F Sell"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SecureTableData, {
                                            align: "right",
                                            "data-cy": "fsell-content",
                                            color: ui/* color.sunsetOrange */.$_.sunsetOrange,
                                            children: number/* default.numberFormatter */.ZP.numberFormatter({
                                                num: data.fsell,
                                                fixed: 1
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var TableOrderbook_TableSecure = (TableSecure);

;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/styled.ts

function TableOrderbook_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border-bottom: 1px solid ",
        ";\n  padding: 20px 16px;\n"
    ]);
    TableOrderbook_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TableOrderbook_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  background-color: ",
        ";\n  border: solid 1px ",
        ";\n  border-radius: 4px;\n  margin-bottom: 20px;\n  margin-right: 30px;\n  position: relative;\n  min-width: 320px;\n\n  @media ",
        " {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    TableOrderbook_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TableOrderbook_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 15px;\n\n  & .ant-skeleton-content {\n    & > .ant-skeleton-title {\n      margin: 0 0 7.5px;\n    }\n\n    & > .ant-skeleton-paragraph {\n      margin: 0;\n    }\n  }\n"
    ]);
    TableOrderbook_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TableOrderbook_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 225px;\n"
    ]);
    TableOrderbook_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var TableOrderbook_styled_Flex = ui/* Common.Flex */.Gn.Flex, IconMoreOptions = ui/* Common.IconMoreOptions */.Gn.IconMoreOptions, TableOrderbook_styled_Text = ui/* Common.Text */.Gn.Text;
var CardHeader = (0,styled_components_browser_esm["default"])(TableOrderbook_styled_Flex).attrs({
    padding: "9px 12px",
    align: "center"
}).withConfig({
    componentId: "sc-71864dce-0"
})(TableOrderbook_styled_templateObject(), ui/* color.downgray */.$_.downgray);
var styled_Wrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-71864dce-1"
})(TableOrderbook_styled_templateObject1(), ui/* color.light */.$_.light, ui/* color.downgray */.$_.downgray, ui/* device.tablet */.Uh.tablet);
var TableHeaderTextSkeleton = (0,styled_components_browser_esm["default"])(skeleton/* default */.Z).withConfig({
    componentId: "sc-71864dce-2"
})(TableOrderbook_styled_templateObject2());
var SubCompanyText = (0,styled_components_browser_esm["default"])(TableOrderbook_styled_Text).withConfig({
    componentId: "sc-71864dce-3"
})(TableOrderbook_styled_templateObject3());


;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/TableHeader.tsx







var TableHeader_Flex = ui/* Common.Flex */.Gn.Flex, TableHeader_Text = ui/* Common.Text */.Gn.Text;
var TableHeaderSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHeader, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Avatar */.Z.Avatar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderTextSkeleton, {
                    paragraph: {
                        rows: 1
                    }
                })
            ]
        })
    });
};
function TableHeader(param) {
    var data = param.data, _loading = param.loading, loading = _loading === void 0 ? false : _loading;
    if (!data) return null;
    var _icon_url = data.icon_url, icon_url = _icon_url === void 0 ? "" : _icon_url, _symbol = data.symbol, symbol = _symbol === void 0 ? "" : _symbol, _name = data.name, name = _name === void 0 ? "" : _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper/* default */.Z, {
        skeleton: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeaderSkeleton, {}),
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableHeader_Flex, {
                align: "flex-start",
                children: [
                    !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolAvatar, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader_Text, {
                            color: "white",
                            family: "bold",
                            size: "16px",
                            children: symbol[0]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: icon_url,
                        style: {
                            width: "40px",
                            height: "40px",
                            background: "white"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableHeader_Flex, {
                        direction: "column",
                        pl: "15px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader_Flex, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader_Text, {
                                    family: "bold",
                                    size: "16px",
                                    children: symbol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHeader_Flex, {
                                mt: "3px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCompanyText, {
                                    size: "14px",
                                    color: ui/* color.midgray */.$_.midgray,
                                    mr: "5px",
                                    children: name
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var TableOrderbook_TableHeader = (TableHeader);

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.types.ts
var liveprice_store_types = __webpack_require__(27934);
// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/useLivePrice.ts
var useLivePrice = __webpack_require__(39767);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.types.ts
var orderbook_store_types = __webpack_require__(52781);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookReceiver.ts
var useOrderbookReceiver = __webpack_require__(49816);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbookSender.ts
var useOrderbookSender = __webpack_require__(64579);
;// CONCATENATED MODULE: ./src/global/Datafeed/UseOrderbook/useOrderbook.ts


var useOrderbook = function(symbols, stateKey, actionKey, onMessage) {
    (0,useOrderbookSender/* useOrderbookSender */.J)(stateKey, symbols);
    (0,useOrderbookReceiver/* useOrderbookReceiver */.q)(symbols, actionKey, onMessage);
};

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/features/orderbook/utils.ts
var utils = __webpack_require__(51346);
// EXTERNAL MODULE: ./src/global/Securities/constants/apiEndpoint.ts
var apiEndpoint = __webpack_require__(53850);
// EXTERNAL MODULE: ./src/global/Securities/api/instance/exodus.ts
var exodus = __webpack_require__(59359);
;// CONCATENATED MODULE: ./src/global/Securities/api/orderbook.ts


var getOrderbookCompanies = function(symbol) {
    return exodus/* exodusApiInstance.defaultInstance.get */.l.defaultInstance.get(apiEndpoint/* orderbookEndpoint.orderbookCompanies */.I6.orderbookCompanies(symbol));
};

;// CONCATENATED MODULE: ./src/global/Securities/stores/useOrderbookCompanies.ts








var useOrderbookCompanies_initialState = {
    data: {},
    isLoading: false
};
var useOrderbookCompanies = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useOrderbookCompanies_initialState), {
        loadOrderbookCompanies: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var axiosResponse, data, transformedData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return getOrderbookCompanies(symbol);
                        case 4:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            transformedData = (0,utils/* transformNewOrderbookListToExisting */.M6)(data);
                            set({
                                data: transformedData,
                                isLoading: false
                            });
                            return _ctx.abrupt("return", transformedData);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetOrderbookCompanies: function() {
            set({
                data: {}
            });
        },
        setBidOffer: function(param) {
            var bid = param.bid, offer = param.offer;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (bid) {
                    var ref;
                    state.data.bid = (0,_object_spread/* default */.Z)({}, (ref = state.data) === null || ref === void 0 ? void 0 : ref.bid, bid);
                }
                if (offer) {
                    var ref1;
                    state.data.offer = (0,_object_spread/* default */.Z)({}, (ref1 = state.data) === null || ref1 === void 0 ? void 0 : ref1.offer, offer);
                }
            }));
        },
        setHeader: function(livePrice) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                state.data = (0,_object_spread/* default */.Z)({}, state.data, livePrice);
            }));
        },
        setIepIev: function(payload) {
            set((0,immer_esm/* default */.ZP)(function(state) {
                var ref, ref1, ref2, ref3, ref4;
                state.data.iepiev = payload ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = state.data) === null || ref === void 0 ? void 0 : ref.iepiev), {
                    iep: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref1 = state.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iepiev) === null || ref2 === void 0 ? void 0 : ref2.iep), {
                        raw: payload.iep
                    }),
                    iev: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref3 = state.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.iepiev) === null || ref4 === void 0 ? void 0 : ref4.iev), {
                        raw: payload.iev / 100
                    })
                }) : null;
            }));
        },
        setBestBidOffer: function(payload) {
            var bestBid = payload.bestBid, bestOffer = payload.bestOffer;
            set((0,immer_esm/* default */.ZP)(function(state) {
                if (bestBid) {
                    var ref, ref1, ref2;
                    state.data.iepiev = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref = state.data) === null || ref === void 0 ? void 0 : ref.iepiev), {
                        best_bid_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref1 = state.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.iepiev) === null || ref2 === void 0 ? void 0 : ref2.best_bid_offer), {
                            bid: bestBid
                        })
                    });
                }
                if (bestOffer) {
                    var ref3, ref4, ref5;
                    state.data.iepiev = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref3 = state.data) === null || ref3 === void 0 ? void 0 : ref3.iepiev), {
                        best_bid_offer: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (ref4 = state.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.iepiev) === null || ref5 === void 0 ? void 0 : ref5.best_bid_offer), {
                            offer: bestOffer
                        })
                    });
                }
            }));
        }
    });
});
/* harmony default export */ var stores_useOrderbookCompanies = (useOrderbookCompanies);

// EXTERNAL MODULE: ./src/global/Datafeed/useOrderbookIEPIEV.ts
var useOrderbookIEPIEV = __webpack_require__(28398);
// EXTERNAL MODULE: ./src/global/Datafeed/useBestBidOffer.ts
var useBestBidOffer = __webpack_require__(11562);
;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useSecuritiesOrderbook.ts










var useSecuritiesOrderbook = function(symbol) {
    var disableOrderbook = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var ref = (0,_sliced_to_array/* default */.Z)(stores_useOrderbookCompanies(function(s) {
        return [
            s.data,
            s.isLoading,
            s.loadOrderbookCompanies,
            s.resetOrderbookCompanies,
            s.setBidOffer,
            s.setHeader,
            s.setIepIev,
            s.setBestBidOffer, 
        ];
    }, shallow/* default */.Z), 8), orderbookData = ref[0], isLoading = ref[1], loadOrderbookCompanies = ref[2], resetOrderbookCompanies = ref[3], setBidOffer = ref[4], setHeader = ref[5], setIepIev = ref[6], setBestBidOffer = ref[7];
    (0,useLivePrice/* useLivePrice */.L)([
        symbol
    ], liveprice_store_types/* LivePriceSymbolsKeyEnum.SECURITIES_TRANSACTION */.j.SECURITIES_TRANSACTION, "securities_transaction", setHeader);
    useOrderbook(!disableOrderbook ? [
        symbol
    ] : [], orderbook_store_types/* OrderbookSymbolsKeyEnum.SECURITIES_TRANSACTION */.E.SECURITIES_TRANSACTION, "securities_transaction", setBidOffer);
    (0,useOrderbookIEPIEV/* useOrderbookIEPIEV */.Jj)([
        symbol
    ], "securities_transaction", setIepIev);
    (0,useBestBidOffer/* default */.ZP)([
        symbol
    ], "securities_transaction", setBestBidOffer);
    var ref1;
    var ref2 = (ref1 = orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.iepiev) !== null && ref1 !== void 0 ? ref1 : {}, iepIevTimeLeft = ref2.time_left_seconds;
    (0,react.useEffect)(function() {
        if (iepIevTimeLeft) {
            var timeoutId = setTimeout(function() {
                setIepIev(null);
            }, iepIevTimeLeft * 1000);
            return function() {
                return clearTimeout(timeoutId);
            };
        }
    }, [
        symbol,
        iepIevTimeLeft
    ]);
    (0,react.useEffect)(function() {
        if (symbol) loadOrderbookCompanies(symbol);
        else resetOrderbookCompanies();
        return function() {
            resetOrderbookCompanies();
        };
    }, [
        symbol
    ]);
    return [
        orderbookData,
        isLoading
    ];
};
/* harmony default export */ var hooks_useSecuritiesOrderbook = (useSecuritiesOrderbook);

// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var TradingModal_store = __webpack_require__(70362);
;// CONCATENATED MODULE: ./src/global/TradingModal/TableOrderbook/index.tsx











var TableOrderbook = function() {
    var ref = (0,TradingModal_store/* default */.Z)(), showOrderbook = ref.showOrderbook, symbol = ref.symbol;
    var ref1 = (0,_sliced_to_array/* default */.Z)(hooks_useSecuritiesOrderbook(symbol, !showOrderbook), 2), orderbookData = ref1[0], loading = ref1[1];
    var companyData = (0,tradingData/* default */.Z)(function(s) {
        return s.company.data;
    });
    var isBidOfferEmpty = (0,react.useMemo)(function() {
        return !loading && !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.bid) && !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.offer);
    }, [
        loading,
        !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.bid),
        !(orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.offer)
    ]);
    // check if not loading and orderbookData is not empty before render orderbook table
    if (!loading && Object.keys(orderbookData).length > 0) {
        var ref2, ref3, ref4;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableHeader, {
                    data: companyData
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableSecure, {
                    data: orderbookData,
                    loading: loading,
                    isStock: (companyData === null || companyData === void 0 ? void 0 : (ref2 = companyData.type_company) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === trading/* STOCK_TYPE.saham */.L2.saham
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOrderbook_TableOHLC, {
                    bid: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.bid,
                    offer: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.offer,
                    previous: orderbookData === null || orderbookData === void 0 ? void 0 : orderbookData.previous,
                    loading: loading,
                    isEmpty: isBidOfferEmpty,
                    bestBidOffer: orderbookData === null || orderbookData === void 0 ? void 0 : (ref3 = orderbookData.iepiev) === null || ref3 === void 0 ? void 0 : ref3.best_bid_offer,
                    marketStatus: companyData === null || companyData === void 0 ? void 0 : (ref4 = companyData.market_hour) === null || ref4 === void 0 ? void 0 : ref4.status
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TradingModal_TableOrderbook = (TableOrderbook);

;// CONCATENATED MODULE: ./src/global/TradingModal/VirtualTradingModal/index.tsx





















var VirtualTradingModal_Flex = ui/* Common.Flex */.Gn.Flex;
function BuySellModal(param) {
    var closeModal = param.closeModal, onSwitchTab = param.onSwitchTab;
    var ref = (0,TradingModal_store/* default */.Z)(), symbol = ref.symbol, orderType = ref.orderType, priceProps = ref.price, showOrderbook = ref.showOrderbook, showTabs = ref.showTabs, orderedLot = ref.orderedLot, orderid = ref.orderid, orderedPrice = ref.orderedPrice, showTradingModal = ref.showModal;
    var ref1 = store(), resetOrderData = ref1.resetOrderData, setPrice = ref1.setPrice, setStockCode = ref1.setStockCode, setShares = ref1.setShares;
    var loadPortfolioDetail = stores_usePortfolioStore().loadPortfolioDetail;
    var ref2 = (0,react.useState)(false), isSearchActive = ref2[0], setIsSearchActive = ref2[1];
    var ref3 = (0,tradingData/* default */.Z)(function(s) {
        return {
            company: s.company,
            getPortfolio: s.getPortfolio,
            getCompany: s.getCompany,
            resetCompany: s.resetCompany
        };
    }, shallow/* default */.Z), company = ref3.company, getPortfolio = ref3.getPortfolio, getCompany = ref3.getCompany, resetCompany = ref3.resetCompany;
    var isLoading = company.isLoading, data = company.data;
    var portfolioData = (0,useGetPortfolioData/* default */.Z)(symbol);
    var available_lot = (portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.available_lot) || 0;
    var handleNotTradeable = function() {
        (0,AlertErrorMessage/* default */.Z)("The symbol is not tradeable", errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
        closeModal();
    };
    // TODO: MOVE LOGIC INIT DATA TO BUYFORM AND SELLFORM
    var setupInitialData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var getData, error, result, tradeable, price, symbolCompany, isTradeable;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    setIsSearchActive(false);
                    resetOrderData();
                    _ctx.next = 4;
                    return getPortfolio(false);
                case 4:
                    _ctx.next = 6;
                    return getCompany(symbol);
                case 6:
                    getData = _ctx.sent;
                    error = getData.error, result = getData.data;
                    if (!error) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 10:
                    tradeable = result.tradeable, price = result.price, symbolCompany = result.symbol;
                    isTradeable = Number(tradeable) === 1;
                    if (isTradeable) {
                        _ctx.next = 15;
                        break;
                    }
                    handleNotTradeable();
                    return _ctx.abrupt("return");
                case 15:
                    // Set new refference due to bugs
                    // refferencing to toher zustand state symbol
                    setStockCode(symbolCompany);
                    if (orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY) {
                        setShares(orderedLot * 100);
                        setPrice(orderedPrice);
                    } else if (orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY) {
                        setShares(0);
                        setPrice(priceProps || price);
                    }
                case 17:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var onCloseModal = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return resetOrderData();
                    case 2:
                        resetCompany();
                        closeModal();
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onCloseModal() {
            return _ref.apply(this, arguments);
        };
    }();
    var isBuy = orderType === trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY || orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_BUY */.Jm.VIRTUAL_AMEND_BUY;
    var isSell = orderType === trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL || orderType === trading/* ORDER_TYPE.VIRTUAL_AMEND_SELL */.Jm.VIRTUAL_AMEND_SELL;
    (0,react.useEffect)(function() {
        if (symbol) {
            setupInitialData();
            loadPortfolioDetail(symbol);
        }
    }, [
        symbol
    ]);
    (0,react.useEffect)(function() {
        if (isSell) {
            virtualTrading/* virtualTradingNavigate.onSellOrderViewed */.f9.onSellOrderViewed(symbol, virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading);
        }
    }, [
        isSell
    ]);
    (0,react.useEffect)(function() {
        var currentUrl = window.location.pathname.toLowerCase();
        var source;
        if (currentUrl.includes("symbol")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.companyPage */.CS.companyPage;
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.predictionPost */.CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.portfolio */.CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = virtualTrading/* VIRTUAL_TRADING_SOURCE.watchlist */.CS.watchlist;
        }
        if (isBuy) {
            virtualTrading/* virtualTradingNavigate.onBuyOrderViewes */.f9.onBuyOrderViewes(symbol, source, virtualTrading/* VIRTUAL_TRADING_TYPES.virtualTrading */.gT.virtualTrading);
        }
    }, [
        isBuy
    ]);
    if (isLoading || !(data === null || data === void 0 ? void 0 : data.price)) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TransactionModalContainer */.md, {
        "data-cy": "transaction-modal-virtual",
        visible: true,
        onCancel: onCloseModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTradingModal_Flex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: showOrderbook,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_TableOrderbook, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalFormWrapper */.W_, {
                    children: [
                        isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FreezeLayer */.VV, {
                            onClick: function() {
                                return setIsSearchActive(false);
                            }
                        }),
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FreezeLayer */.VV, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormWrapper */.n5, {
                            style: showTabs ? {
                                paddingTop: 0
                            } : {},
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                    condition: showTabs && onSwitchTab,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VirtualTradingModal_Flex, {
                                        style: {
                                            margin: "-15px -20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTab */.a7, {
                                                isActive: isBuy,
                                                onClick: function() {
                                                    return onSwitchTab(trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTabText */.QX, {
                                                    color: ui/* color.primary */.$_.primary,
                                                    children: "Buy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTab */.a7, {
                                                isActive: isSell,
                                                onClick: function() {
                                                    if (available_lot > 0) onSwitchTab(trading/* ORDER_TYPE.VIRTUAL_SELL */.Jm.VIRTUAL_SELL);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ModalTabText */.QX, {
                                                    color: ui/* color.sunsetOrange */.$_.sunsetOrange,
                                                    children: "Sell"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderVirtual, {
                                    orderType: orderType,
                                    showTitle: !showTabs,
                                    onUpdateSymbol: function(newSymbol) {
                                        showTradingModal({
                                            symbol: newSymbol,
                                            // Chnaging symbol always open buy modal by default
                                            orderType: trading/* ORDER_TYPE.VIRTUAL_BUY */.Jm.VIRTUAL_BUY
                                        });
                                    },
                                    isSearchActive: isSearchActive,
                                    setIsSearchActive: function() {
                                        return setIsSearchActive(!isSearchActive);
                                    }
                                }),
                                isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingModal_FormBuy, {
                                    orderType: orderType,
                                    orderid: orderid,
                                    closeModal: onCloseModal
                                }),
                                isSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingModal_FormSell, {
                                    orderType: orderType,
                                    orderid: orderid,
                                    orderedLot: orderedLot,
                                    orderedPrice: orderedPrice,
                                    closeModal: onCloseModal
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var VirtualTradingModal = (BuySellModal);

// EXTERNAL MODULE: ./src/lib/analytics/securities.ts
var securities = __webpack_require__(91154);
// EXTERNAL MODULE: ./src/lib/analytics/autoOrder.ts
var autoOrder = __webpack_require__(66959);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var OrderTable_store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/Securities/types/autoOrder.ts
var types_autoOrder = __webpack_require__(48453);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts + 1 modules
var useTermsAndConditionStore = __webpack_require__(49365);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
// EXTERNAL MODULE: ./src/global/Securities/types/transaction.ts
var transaction = __webpack_require__(2078);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 2 modules
var BaseSecuritiesModal = __webpack_require__(93400);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/TradingLimitTncModal/styled.ts

function TradingLimitTncModal_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  margin-top: 20px;\n  box-sizing: border-box;\n  min-height: 408px;\n"
    ]);
    TradingLimitTncModal_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TradingLimitTncModal_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    TradingLimitTncModal_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TradingLimitTncModal_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    TradingLimitTncModal_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TradingLimitTncModal_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    TradingLimitTncModal_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TradingLimitTncModal_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 408px;\n"
    ]);
    TradingLimitTncModal_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ContentContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b9f83084-0"
})(TradingLimitTncModal_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b9f83084-1"
})(TradingLimitTncModal_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-b9f83084-2"
})(TradingLimitTncModal_styled_templateObject2());
var TnCFrameWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b9f83084-3"
})(TradingLimitTncModal_styled_templateObject3());
var TnCFrame = styled_components_browser_esm["default"].iframe.withConfig({
    componentId: "sc-b9f83084-4"
})(TradingLimitTncModal_styled_templateObject4());

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/TradingLimitTncModal/index.tsx















var TradingLimitTncModal = function(_param) {
    var _title = _param.title, title = _title === void 0 ? "Syarat & Ketentuan" : _title, _checkboxText = _param.checkboxText, checkboxText = _checkboxText === void 0 ? "Saya menyetujui Syarat & Ketentuan Penggunaan Trading Limit di atas." : _checkboxText, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "checkboxText",
        "onSubmit"
    ]);
    var FEATURE_ID = termsAndCondition/* TnCFeatureIDEnum.FEATURE_TRADING_LIMIT */.hO.FEATURE_TRADING_LIMIT;
    var ref = (0,react.useState)(false), tncAgreed = ref[0], setTncAgreed = ref[1];
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var isSubmitting = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.isSubmitting;
    });
    var contents = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.contents;
    });
    var postAcceptance = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.postAcceptance;
    });
    var handleCheckboxChange = function(event) {
        setTncAgreed(event.target.checked);
    };
    var handleTncSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tradingLimitContents, _acceptanceLetters, content;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (tncAgreed) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        tradingLimitContents = contents[FEATURE_ID];
                        _acceptanceLetters = (0,_sliced_to_array/* default */.Z)(tradingLimitContents.acceptanceLetters, 1), content = _acceptanceLetters[0];
                        _ctx.next = 6;
                        return postAcceptance(FEATURE_ID, content.version);
                    case 6:
                        setUIValue("tradingLimitTnc", true);
                        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit);
                        onSubmit();
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTncSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var iframeSrc = "";
    if (contents && contents[FEATURE_ID]) {
        var tradingLimitContents = contents[FEATURE_ID];
        var _acceptanceLetters = (0,_sliced_to_array/* default */.Z)(tradingLimitContents.acceptanceLetters, 1), content = _acceptanceLetters[0];
        iframeSrc = "".concat(content.url);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        submitText: "Lanjut",
        submitProps: {
            disabled: !tncAgreed,
            loading: isSubmitting
        },
        onSubmit: handleTncSubmit
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrameWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                        title: "trading-limit-tnc",
                        src: iframeSrc
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        onChange: handleCheckboxChange,
                        children: checkboxText
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var Modal_TradingLimitTncModal = (TradingLimitTncModal);

// EXTERNAL MODULE: ./src/features/day-trade/components/Modals/index.ts + 17 modules
var Modals = __webpack_require__(12104);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/SplitOrderInfoModal/styled.ts

function SplitOrderInfoModal_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-body {\n    padding: 40px;\n\n    & > div,\n    & > p {\n      margin-bottom: 16px;\n\n      :last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  & .ant-modal-close-x {\n    margin-top: 22px;\n    margin-right: 20px;\n  }\n"
    ]);
    SplitOrderInfoModal_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SplitOrderInfoModal_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > p {\n    margin: 0 0 4px;\n\n    :last-child {\n      margin: 0;\n    }\n  }\n"
    ]);
    SplitOrderInfoModal_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SplitOrderInfoModal_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 14px;\n  font-weight: ",
        ";\n  line-height: 19px;\n"
    ]);
    SplitOrderInfoModal_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Modal = (0,styled_components_browser_esm["default"])(BaseSecuritiesModal/* default */.Z).withConfig({
    componentId: "sc-c603f783-0"
})(SplitOrderInfoModal_styled_templateObject());
var InfoWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-c603f783-1"
})(SplitOrderInfoModal_styled_templateObject1());
var SplitOrderInfoModal_styled_Text = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-c603f783-2"
})(SplitOrderInfoModal_styled_templateObject2(), function(param) {
    var _weight = param.weight, weight = _weight === void 0 ? "normal" : _weight;
    return weight;
});

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/SplitOrderInfoModal/constants.ts
var SPLIT_ORDER_MODAL_CONTENT = {
    DEFAULT: [
        {
            title: "Split Quantity",
            description: "The number of divided (smaller) orders your order will be split into."
        },
        {
            title: "Split Range Lot",
            description: "Sets the min and max lot size for each split order."
        }, 
    ],
    SPLIT_METHOD: [
        {
            title: "Random",
            description: "Sets the min and max lot size for each split order. Should not exceed original lot size."
        },
        {
            title: "Equal",
            description: "The number of divided (smaller) orders your order will be split into. Should not exceed original lot size."
        }, 
    ]
};

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/SplitOrderInfoModal/index.tsx






var SplitOrderInfoModal = function(_param) /*#__PURE__*/ {
    var _title = _param.title, title = _title === void 0 ? "Split Order" : _title, _description = _param.description, description = _description === void 0 ? "Split your order into multiple smaller orders for better trading strategy management." : _description, _info = _param.info, info = _info === void 0 ? SPLIT_ORDER_MODAL_CONTENT.DEFAULT : _info, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "info"
    ]);
    return (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: title,
        hideSubmit: true
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitOrderInfoModal_styled_Text, {
                children: description
            }),
            info.map(function(infoItem, idx) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitOrderInfoModal_styled_Text, {
                            weight: "700",
                            children: infoItem.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SplitOrderInfoModal_styled_Text, {
                            children: infoItem.description
                        })
                    ]
                }, idx.toString());
            })
        ]
    }));
};
/* harmony default export */ var Modal_SplitOrderInfoModal = (SplitOrderInfoModal);

// EXTERNAL MODULE: ./src/global/Securities/stores/useTradingInfoStore.ts + 1 modules
var useTradingInfoStore = __webpack_require__(21734);
// EXTERNAL MODULE: ./src/global/Securities/types/trading.ts
var types_trading = __webpack_require__(6421);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTransactionFormStore.ts
var useTransactionFormStore = __webpack_require__(52870);
// EXTERNAL MODULE: ./src/typings/transactionForm.ts
var transactionForm = __webpack_require__(93134);
// EXTERNAL MODULE: ./src/global/GlobalModalManager/stores/useGlobalModalStore.ts
var useGlobalModalStore = __webpack_require__(14467);
// EXTERNAL MODULE: ./src/global/GlobalModalManager/types/index.ts
var types = __webpack_require__(30682);
// EXTERNAL MODULE: ./src/features/fast-order/stores/useFastOrderStore.ts
var useFastOrderStore = __webpack_require__(5562);
// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useSyariah.ts
var useSyariah = __webpack_require__(47060);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/styled.ts
var RealTradingModal_styled = __webpack_require__(61227);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/OrderTypeModal.tsx





var OrderTypeModal_Flex = ui/* Common.Flex */.Gn.Flex, OrderTypeModal_Modal = ui/* Common.Modal */.Gn.Modal, OrderTypeModal_Text = ui/* Common.Text */.Gn.Text;
var limitOrderDesc = "adalah perintah untuk membeli saham pada harga tertentu sesuai harga yang telah kamu tentukan.";
var autoBuyDesc = "adalah perintah untuk membeli saham dengan kondisi <i>(Trigger Price)</i> yang sudah kamu tentukan. Jika kondisi harga saham terpenuhi, maka order beli akan dikirim secara otomatis";
function OrderTypeModal(param) {
    var visible = param.visible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderTypeModal_Modal, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeModal_Text, {
                size: "20px",
                align: "center",
                family: "bold",
                padding: "15px",
                children: "Order Type"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* TabWrapper */.UE, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RealTradingModal_styled/* Tabs */.mQ, {
                    defaultActiveKey: "1",
                    centered: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* TabPane */.Jm, {
                            tab: "Limit Order",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderTypeModal_Flex, {
                                direction: "column",
                                padding: "15px",
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/img/limit-order.svg",
                                        alt: "limit-order"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderTypeModal_Text, {
                                        family: "bold",
                                        my: "15px",
                                        children: [
                                            "Limit Order",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeModal_Text, {
                                                style: {
                                                    display: "inline"
                                                },
                                                children: limitOrderDesc
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "1"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* TabPane */.Jm, {
                            tab: "Auto Buy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderTypeModal_Flex, {
                                direction: "column",
                                padding: "20px",
                                align: "center",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/img/auto-buy.svg",
                                        alt: "limit-order"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderTypeModal_Text, {
                                        family: "bold",
                                        my: "15px",
                                        children: [
                                            "Auto Buy",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeModal_Text, {
                                                style: {
                                                    display: "inline"
                                                },
                                                children: (0,html_react_parser/* default */.ZP)(autoBuyDesc)
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, "2")
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var TransactionModal_OrderTypeModal = (OrderTypeModal);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/index.tsx + 7 modules
var PreviewOrderModal = __webpack_require__(73510);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/PreviewOrderModal/ExchangeFeeModal.tsx
var ExchangeFeeModal = __webpack_require__(3415);
// EXTERNAL MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx + 1 modules
var OrderPlacedModal = __webpack_require__(70536);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/AnnouncementModal/index.tsx
var AnnouncementModal = __webpack_require__(89279);
// EXTERNAL MODULE: ./src/global/Securities/stores/useCashInfoStore.ts
var useCashInfoStore = __webpack_require__(11806);
// EXTERNAL MODULE: ./src/lib/flipt/hooks/index.ts + 1 modules
var hooks = __webpack_require__(62514);
// EXTERNAL MODULE: ./src/lib/flipt/constants/flagKeys.ts
var flagKeys = __webpack_require__(34540);
// EXTERNAL MODULE: ./src/global/Securities/types/stockType.ts
var stockType = __webpack_require__(56644);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./src/global/Notation/styled.ts
var Notation_styled = __webpack_require__(97038);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/TradingCompanyTags.tsx







var TradingCompanyTags_Flex = ui/* Common.Flex */.Gn.Flex, TradingCompanyTags_Text = ui/* Common.Text */.Gn.Text;
var TradingCompanyTags = function(param) {
    var company = param.company;
    var symbol = company.symbol, name = company.name, uma = company.uma, corp_action = company.corp_action, indexes = company.indexes, notation = company.notation, market_hour = company.market_hour, dayTradeInfo = company.day_trade_info;
    var isXNotationEnabled = market_hour.suspend_info;
    var isDBX = indexes.indexOf("DBX") > -1;
    var isSyariah = indexes.indexOf("JII") > -1 || indexes.indexOf("ISSI") > -1;
    var isDayTrade = dayTradeInfo === null || dayTradeInfo === void 0 ? void 0 : dayTradeInfo.is_show_multiplier;
    var hasNotation = notation.length > 0;
    var hasXNotation = notation.find(function(value) {
        return value.notation_code === "X";
    });
    var onlyHasXNotation = notation.length === 1 && notation[0].notation_code === "X";
    var checkIndicator = hasNotation && !onlyHasXNotation;
    var showIndicator = isXNotationEnabled ? checkIndicator : hasNotation;
    var showXIcon = isXNotationEnabled && hasXNotation;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingCompanyTags_Flex, {
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showIndicator,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                    symbol: symbol,
                    name: name,
                    notation: notation,
                    uma: uma,
                    type: "indicator",
                    placement: "bottom",
                    isNotationBadges: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showXIcon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                    symbol: symbol,
                    name: name,
                    notation: notation,
                    uma: uma,
                    type: "x",
                    placement: "bottom",
                    isNotationBadges: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: corp_action.active,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionTag/* default */.Z, {
                    corpAction: corp_action,
                    isCorpActionBadges: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: uma,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                    symbol: symbol,
                    name: name,
                    notation: notation,
                    uma: uma,
                    type: "uma",
                    placement: "bottom",
                    isNotationBadges: true,
                    isPopover: false
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDayTrade,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Notation_styled/* BadgeLabelDayTrade */.Bh, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/day-trade/lightning-filled-company.svg",
                            alt: "",
                            height: "14",
                            width: "14"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradingCompanyTags_Text, {
                            size: "12px",
                            color: "#8277f8",
                            family: "bold",
                            children: [
                                dayTradeInfo.multiplier,
                                "x"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isDBX,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_styled/* BadgeLabelWrapper */.lw, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingCompanyTags_Text, {
                        size: "12px",
                        color: ui/* color.primary */.$_.primary,
                        children: "DBX"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isSyariah,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation_styled/* BadgeLabelWrapper */.lw, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingCompanyTags_Text, {
                        size: "12px",
                        color: ui/* color.primary */.$_.primary,
                        children: "Syariah"
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var components_TradingCompanyTags = (TradingCompanyTags);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/styled.ts
var TransactionModal_styled = __webpack_require__(51520);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormTypeSelect.tsx










var FormTypeSelect = function(param) {
    var onChange = param.onChange;
    var ref = (0,_sliced_to_array/* default */.Z)((0,TradingModal_store/* default */.Z)(function(s) {
        return [
            s.symbol,
            s.orderType,
            s.showTabs,
            s.showOrderbook
        ];
    }), 4), classicSymbol = ref[0], orderType = ref[1], showTabs = ref[2], showOrderbook = ref[3];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTransactionFormStore/* default */.Z)(function(s) {
        return [
            s.formType,
            s.setFormType, 
        ];
    }), 2), formType = ref1[0], setFormType = ref1[1];
    var setSymbol = (0,useFastOrderStore/* default */.Z)(function(s) {
        return s.setSymbol;
    });
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useGlobalModalStore/* default */.Z)(function(s) {
        return [
            s.setActiveModal
        ];
    }), 1), setActiveModal = ref2[0];
    var handleSelectChange = function(value) {
        setSymbol(classicSymbol); // Update symbol used by classic form to fast order form
        setFormType(value);
        setActiveModal(types/* GlobalModalType.FastOrder */.C.FastOrder, {
            switchFormConfig: {
                orderType: orderType,
                showTabs: showTabs,
                showOrderbook: showOrderbook
            }
        });
        onChange(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_styled/* SelectForm */.p7, {
        value: formType,
        onChange: handleSelectChange,
        children: [
            {
                label: "Classic",
                value: transactionForm/* TransactionFormType.Classic */.b.Classic
            },
            {
                label: "Fast Order",
                value: transactionForm/* TransactionFormType.FastOrder */.b.FastOrder
            }, 
        ].map(function(param) {
            var label = param.label, selectValue = param.value;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default.Option */.Z.Option, {
                value: selectValue,
                children: label
            }, selectValue);
        })
    });
};
/* harmony default export */ var TransactionModal_FormTypeSelect = (FormTypeSelect);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/TransactionTypeSwitch/styled.tsx

function TransactionTypeSwitch_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  border: 1px solid #ededed;\n  background-color: #f6f6f6;\n  height: 32px;\n  border-radius: 2px;\n  width: 100%;\n  overflow: hidden;\n"
    ]);
    TransactionTypeSwitch_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TransactionTypeSwitch_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: #ffffff;\n  height: 100%;\n  transition: 0.3s left ease-out, 0.3s width ease-out;\n"
    ]);
    TransactionTypeSwitch_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TransactionTypeSwitch_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n"
    ]);
    TransactionTypeSwitch_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TransactionTypeSwitch_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 0;\n\n  font-weight: bold;\n  font-size: 18px;\n  line-height: 24px;\n\n  &.buy {\n    color: #00ab6b;\n  }\n\n  &.sell {\n    color: #ee4a49;\n  }\n"
    ]);
    TransactionTypeSwitch_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b16cbc9c-0"
})(TransactionTypeSwitch_styled_templateObject());
var BackgroundHighlight = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b16cbc9c-1"
})(TransactionTypeSwitch_styled_templateObject1());
var SwitchWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-b16cbc9c-2"
})(TransactionTypeSwitch_styled_templateObject2());
var SwitchButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-b16cbc9c-3"
})(TransactionTypeSwitch_styled_templateObject3());

;// CONCATENATED MODULE: ./src/global/TradingModal/components/TransactionTypeSwitch/index.tsx







var TransactionTypeSwitch = function(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _defaultValue, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    var _obj;
    var switchRefs = (0,react.useRef)((_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* TransactionType.Buy */.iU.Buy, /*#__PURE__*/ (0,react.createRef)()), (0,_define_property/* default */.Z)(_obj, transaction/* TransactionType.Sell */.iU.Sell, /*#__PURE__*/ (0,react.createRef)()), _obj));
    var ref = (0,react.useState)(defaultValue), activeTransactionType = ref[0], setActiveTransactionType = ref[1];
    var ref1 = (0,react.useState)({
        width: 0,
        left: 0
    }), highlightConfig = ref1[0], setHighlightConfig = ref1[1];
    var handleSetHighlightConfig = function(transactionType) {
        setHighlightConfig((0,immer_esm/* default */.ZP)(highlightConfig, function(draft) {
            var ref, ref1;
            draft.width = ((ref = switchRefs.current[transactionType].current) === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0;
            draft.left = ((ref1 = switchRefs.current[transactionType].current) === null || ref1 === void 0 ? void 0 : ref1.offsetLeft) || 0;
        }));
    };
    var handleSwitchTransactionType = function(transactionType) {
        return function() {
            setActiveTransactionType(transactionType);
            onChange(transactionType);
        };
    };
    (0,react.useEffect)(function() {
        handleSetHighlightConfig(activeTransactionType);
    }, [
        activeTransactionType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundHighlight, {
                style: (0,_object_spread/* default */.Z)({}, highlightConfig)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwitchWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                        ref: switchRefs.current[transaction/* TransactionType.Buy */.iU.Buy],
                        className: "buy",
                        onClick: handleSwitchTransactionType(transaction/* TransactionType.Buy */.iU.Buy),
                        disabled: disabled,
                        children: "Buy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                        ref: switchRefs.current[transaction/* TransactionType.Sell */.iU.Sell],
                        className: "sell",
                        onClick: handleSwitchTransactionType(transaction/* TransactionType.Sell */.iU.Sell),
                        disabled: disabled,
                        children: "Sell"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_TransactionTypeSwitch = (TransactionTypeSwitch);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/Header.tsx
/* eslint-disable arrow-body-style */ 























var Header_Text = ui/* Common.Text */.Gn.Text, Header_Flex = ui/* Common.Flex */.Gn.Flex, Header_Iconmoon = ui/* Common.Iconmoon */.Gn.Iconmoon;
function Header_TransactionHeader(param) {
    var orderType = param.orderType, _defaultTabsValue = param.defaultTabsValue, defaultTabsValue = _defaultTabsValue === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _defaultTabsValue, isSearchActive = param.isSearchActive, _disableTabs = param.disableTabs, disableTabs = _disableTabs === void 0 ? false : _disableTabs, _showTabs = param.showTabs, showTabs = _showTabs === void 0 ? false : _showTabs, _formTypeSelectVisible = param.formTypeSelectVisible, formTypeSelectVisible = _formTypeSelectVisible === void 0 ? false : _formTypeSelectVisible, _setIsSearchActive = param.setIsSearchActive, setIsSearchActive = _setIsSearchActive === void 0 ? function() {} : _setIsSearchActive, _onUpdateSymbol = param.onUpdateSymbol, onUpdateSymbol = _onUpdateSymbol === void 0 ? function() {} : _onUpdateSymbol, _onFormTypeChange = param.onFormTypeChange, onFormTypeChange = _onFormTypeChange === void 0 ? function() {} : _onFormTypeChange, _onTabsChange = param.onTabsChange, onTabsChange = _onTabsChange === void 0 ? function() {} : _onTabsChange;
    var stockInputRef = (0,react.useRef)();
    var data = (0,tradingData/* default */.Z)(function(s) {
        return s.company;
    }).data;
    var ref = (0,_sliced_to_array/* default */.Z)(stores_useOrderbookCompanies(function(s) {
        return [
            s.data.lastprice,
            s.data.change,
            s.data.percentage_change
        ];
    }, shallow/* default */.Z), 3), priceOrderbook = ref[0], changeOrderbook = ref[1], percentageOrderbook = ref[2];
    var ref1 = (0,react.useState)(false), showSearch = ref1[0], setShowSearch = ref1[1];
    var icon_url = data.icon_url, name = data.name, symbol = data.symbol, orderbook = data.orderbook, priceCompany = data.price, changeCompany = data.change, percentageCompany = data.percentage;
    var price = priceOrderbook || priceCompany;
    var change = changeOrderbook || changeCompany;
    var percentage = percentageOrderbook || percentageCompany;
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    (0,react.useEffect)(function() {
        var ref;
        if (isSearchActive) (ref = stockInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        isSearchActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                style: {
                    position: "relative",
                    width: "100%",
                    height: 32,
                    paddingRight: 24,
                    marginBottom: 20,
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Flex, {
                        align: "center",
                        justify: "center",
                        width: "100%",
                        height: "32px",
                        style: {
                            position: "absolute"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: !showTabs,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Text, {
                                family: "bold",
                                color: isSell ? ui/* color.sunsetOrange */.$_.sunsetOrange : ui/* color.primary */.$_.primary,
                                size: "24px",
                                align: "center",
                                m: "0",
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_TITLE */.eG.HEADER_TITLE,
                                children: [
                                    orderType.split("_").map(function(s) {
                                        return (0,general/* capitalizeFirstLetter */.fm)(s);
                                    }).join(" "),
                                    orderType === "EXERCISE" && " ".concat(symbol)
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: 7,
                        children: formTypeSelectVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormTypeSelect, {
                            onChange: onFormTypeChange
                        })
                    }),
                    showTabs && /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                        span: 16,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TransactionTypeSwitch, {
                            defaultValue: defaultTabsValue,
                            disabled: disableTabs,
                            onChange: onTabsChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormHeader */.ph, {
                style: {
                    paddingTop: showTabs ? 15 : 0
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                        justify: "space-between",
                        width: "100%",
                        style: {
                            display: isSearchActive ? "none" : "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                align: "flex-start",
                                children: [
                                    !icon_url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SymbolAvatar, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
                                            color: "white",
                                            family: "bold",
                                            size: "16px",
                                            children: symbol[0]
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: icon_url,
                                        style: {
                                            width: "40px",
                                            height: "40px",
                                            background: "white"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                        direction: "column",
                                        pl: "15px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
                                                        family: "bold",
                                                        size: "16px",
                                                        children: symbol
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TradingCompanyTags, {
                                                        company: data
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                                mt: "3px",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
                                                        size: "14px",
                                                        color: ui/* color.midgray */.$_.midgray,
                                                        mr: "5px",
                                                        children: name
                                                    }),
                                                    isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Iconmoon, {
                                                        className: "icon-tradesmall_pencil2",
                                                        size: "14px",
                                                        hoverColor: ui/* color.highgray */.$_.highgray,
                                                        onClick: function() {
                                                            setIsSearchActive();
                                                            setShowSearch(!showSearch);
                                                        },
                                                        "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_CHANGE_EMITEN_BUTTON_PENCIL */.eG.HEADER_CHANGE_EMITEN_BUTTON_PENCIL
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Flex, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Text, {
                                                family: "bold",
                                                as: "span",
                                                children: (0,number/* formatNumber */.uf)(price, false)
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Text, {
                                                color: (0,general/* getColorBasedOnNumber */.pV)(Number(change)),
                                                as: "span",
                                                children: [
                                                    Number(change),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_Text, {
                                                color: (0,general/* getColorBasedOnNumber */.pV)(Number(change)),
                                                ml: "3px",
                                                children: [
                                                    "(",
                                                    percentage > 0 && " +",
                                                    numeral_default()(percentage).format("0.00"),
                                                    "%)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BidOfferBox, {
                                        orderbook: orderbook
                                    })
                                ]
                            })
                        ]
                    }),
                    isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Flex, {
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                            ref: stockInputRef,
                            isInTradingModal: true,
                            updateSymbol: function(newSymbol, isBond) {
                                (0,securities/* clevertapChangeStock */.EQ)();
                                onUpdateSymbol(newSymbol, isBond);
                            }
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Header = (Header_TransactionHeader);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/features/day-trade/components/BuyLeverage/leverage.styled.ts

function leverage_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n"
    ]);
    leverage_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 15px;\n  font-size: 12px;\n  fonwt-weight: 400;\n  line-height: 16px;\n  padding: 6px 12px;\n  text-align: center;\n  color: #858585;\n  background: #ffffff;\n  border: 1px solid #ededed;\n  cursor: pointer;\n\n"
    ]);
    leverage_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover,\n  &:focus,\n  &:active {\n    color: #858585;\n    border: 1px solid #ededed;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    leverage_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function leverage_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: min-content;\n  display: flex;\n  gap: 5px;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 16px 6px 14px;\n\n  span {\n    margin: 0 !important;\n  }\n"
    ]);
    leverage_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LeverageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-7adabab9-0"
})(leverage_styled_templateObject());
var Chip = (0,styled_components_browser_esm["default"])(es_button/* default */.Z).withConfig({
    componentId: "sc-7adabab9-1"
})(leverage_styled_templateObject1());
var NoneButton = (0,styled_components_browser_esm["default"])(Chip).withConfig({
    componentId: "sc-7adabab9-2"
})(leverage_styled_templateObject2(), function(param) {
    var isActive = param.isActive;
    return isActive && "\n    color: #0ba16b;\n    font-weight: 700;\n    border-color: #0ba16b;\n\n    &:hover, &:focus, &:active {\n      color: #0ba16b;\n      border-color: #0ba16b;\n    }\n  ";
}, function(param) {
    var isDisabled = param.isDisabled;
    return isDisabled && "\n    color: #858585;\n    font-weight: 400;\n    border-color: #EDEDED;\n    cursor: not-allowed;\n\n    &:hover, &:focus, &:active {\n      color: #858585;\n      border-color: #EDEDED;\n    }\n  ";
});
var ActionButton = (0,styled_components_browser_esm["default"])(NoneButton).withConfig({
    componentId: "sc-7adabab9-3"
})(leverage_styled_templateObject3());

;// CONCATENATED MODULE: ./src/features/day-trade/components/BuyLeverage/leverage.tsx







function LeverageButton(param) {
    var paymentMethod = param.paymentMethod, multiplier = param.multiplier, _enableDayTrade = param.enableDayTrade, enableDayTrade = _enableDayTrade === void 0 ? false : _enableDayTrade, _isAmend = param.isAmend, isAmend = _isAmend === void 0 ? false : _isAmend, _onMethodChange = param.onMethodChange, onMethodChange = _onMethodChange === void 0 ? function() {} : _onMethodChange, onOpenModalLeverage = param.onOpenModalLeverage;
    var isTradingBalance = paymentMethod === transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance;
    var isTradingLimit = paymentMethod === transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit;
    var isDayTrade = paymentMethod === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
    var isShowBadge = isTradingBalance || isDayTrade;
    var handleNoneButtonClick = function() {
        if (isAmend) return;
        onMethodChange(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        (0,securities/* clevertapDayTradeLeverageSelected */.Am)("None");
    };
    var handleOpenModalLeverage = function() {
        if (isAmend) return;
        onOpenModalLeverage();
        (0,securities/* clevertapDayTradeLeverageSelected */.Am)("Leverage");
    };
    var getDropdownText = function() {
        if (isTradingLimit || !enableDayTrade) {
            return "Trading Limit";
        }
        if (isDayTrade || isAmend) {
            return "".concat(multiplier, "x Day Trade");
        }
        return "Up to ".concat(multiplier, "x");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoneButton, {
                isActive: isTradingBalance,
                isDisabled: isAmend,
                onClick: handleNoneButtonClick,
                children: "None"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionButton, {
                isActive: !isTradingBalance || isAmend,
                onClick: handleOpenModalLeverage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isShowBadge && enableDayTrade,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: Icons/* LightningSvg */.Sf
                        })
                    }),
                    getDropdownText(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: enableDayTrade && !isAmend,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            component: Icons/* DropDownSvg */.V3
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
// EXTERNAL MODULE: ./src/global/Securities/components/Chips/index.tsx
var Chips = __webpack_require__(17348);
// EXTERNAL MODULE: ./src/global/Securities/components/InputStepper/index.tsx + 1 modules
var InputStepper = __webpack_require__(97077);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/InfoSvg.tsx
var InfoSvg = __webpack_require__(42958);
// EXTERNAL MODULE: ./src/global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled.ts
var OrderTypeFormItem_styled = __webpack_require__(82093);
;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/OrderTypeFormItem/index.tsx











var OrderTypeFormItem_obj, _obj1;
var orderTypeOptions = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, transaction/* TransactionType.Buy */.iU.Buy, (OrderTypeFormItem_obj = {}, (0,_define_property/* default */.Z)(OrderTypeFormItem_obj, transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder, "Limit Order"), (0,_define_property/* default */.Z)(OrderTypeFormItem_obj, transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy, "Auto Buy"), OrderTypeFormItem_obj)), (0,_define_property/* default */.Z)(_obj1, transaction/* TransactionType.Sell */.iU.Sell, (0,_define_property/* default */.Z)({}, transaction/* SellOrderType.LimitOrder */.qK.LimitOrder, "Limit Order")), _obj1);
var OrderTypeFormItem = function(param) {
    var form = param.form, _transactionType = param.transactionType, transactionType = _transactionType === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _transactionType, _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder : _defaultValue, _hideInfoIcon = param.hideInfoIcon, hideInfoIcon = _hideInfoIcon === void 0 ? false : _hideInfoIcon, _onInfoIconClick = param.onInfoIconClick, onInfoIconClick = _onInfoIconClick === void 0 ? function() {} : _onInfoIconClick, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange;
    var activeOptions = (0,react.useMemo)(function() {
        return Object.entries(orderTypeOptions[transactionType]);
    }, [
        transactionType
    ]);
    var handleChange = function(value, option) {
        onChange(value, option);
        form.validateFields();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Order type",
                        !hideInfoIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                            type: "button",
                            onClick: onInfoIconClick,
                            "data-cy": constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_BUTTON_INFO */.eG.ORDER_TYPE_BUTTON_INFO,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    fontSize: 16,
                                    color: "#969696",
                                    marginLeft: 4
                                }
                            })
                        })
                    ]
                }),
                name: "orderType",
                initialValue: defaultValue,
                hidden: activeOptions.length <= 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                    onChange: handleChange,
                    onDropdownVisibleChange: function(visible) {
                        if (visible) {
                            (0,securities/* clevertapAutoOrderOptionsViewed */.r8)();
                        }
                    },
                    "data-cy": constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT */.eG.ORDER_TYPE_SELECT,
                    getPopupContainer: function() {
                        return document.getElementById(constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT_DROPDOWN */.eG.ORDER_TYPE_SELECT_DROPDOWN);
                    },
                    children: activeOptions.map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], text = _param[1];
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default.Option */.Z.Option, {
                            value: key,
                            children: text
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT_DROPDOWN */.eG.ORDER_TYPE_SELECT_DROPDOWN,
                "data-cy": constant/* DATA_CY_MODAL_TRADING.ORDER_TYPE_SELECT_DROPDOWN */.eG.ORDER_TYPE_SELECT_DROPDOWN
            })
        ]
    });
};
/* harmony default export */ var TransactionForm_OrderTypeFormItem = (OrderTypeFormItem);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/SpecialMonitoringBanner/styled.ts

function SpecialMonitoringBanner_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 5px 0 10px;\n  padding: 12px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fef4e8;\n  border: 0.5px solid #f5931b;\n  border-radius: 4px;\n  cursor: pointer;\n\n  p {\n    margin-bottom: 0;\n  }\n\n  i {\n    color: #f5931b;\n    font-weight: 700;\n  }\n"
    ]);
    SpecialMonitoringBanner_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SpecialMonitoringBanner_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n\n  .special-monitoring-banner__title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 4px !important;\n\n    & > span {\n      font-size: 12px;\n      line-height: 16px;\n      color: ",
        ";\n    }\n  }\n\n  .special-monitoring-banner__desc {\n    font-size: 12px;\n    line-height: 16px;\n    color: ",
        ";\n  }\n"
    ]);
    SpecialMonitoringBanner_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SpecialMonitoringBannerContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bfb9fe90-0"
})(SpecialMonitoringBanner_styled_templateObject());
var SpecialMonitoringBannerContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-bfb9fe90-1"
})(SpecialMonitoringBanner_styled_templateObject1(), ui/* color.highgray */.$_.highgray, ui/* color.highempahis */.$_.highempahis);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/SpecialMonitoringBanner/index.tsx


var SpecialMonitoringBanner = function(param) {
    var onClick = param.onClick, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBannerContainer, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SpecialMonitoringBannerContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "special-monitoring-banner__title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Full Call Auction"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "special-monitoring-banner__desc",
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML: {
                            __html: title
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "icon-trading_back reverse"
            })
        ]
    });
};
/* harmony default export */ var components_SpecialMonitoringBanner = (SpecialMonitoringBanner);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SwapRightOutlined.js + 1 modules
var SwapRightOutlined = __webpack_require__(32198);
;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumber/styled.ts

function InputNumber_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    border-color: #00ab6b;\n  }\n\n  &:focus {\n    border-color: #00ab6b;\n    border-right-width: 1px !important;\n    outline: 0;\n\n    box-shadow: 0 0 0 2px rgba(0, 171, 107, 0.2);\n  }\n"
    ]);
    InputNumber_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputNumber_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border: 1px solid #dadada;\n  padding: 6px 12px;\n  box-sizing: border-box;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 18px;\n  color: #333333;\n\n  border-radius: 2px;\n\n  transition: 0.15s linear;\n  transition-property: border-color, box-shadow;\n  outline: 0;\n\n  ",
        "\n"
    ]);
    InputNumber_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var InputHightlightCss = (0,styled_components_browser_esm.css)(InputNumber_styled_templateObject());
var Input = styled_components_browser_esm["default"].input.withConfig({
    componentId: "sc-f42c2e44-0"
})(InputNumber_styled_templateObject1(), function(param) {
    var disableHighlight = param.disableHighlight;
    return !disableHighlight && InputHightlightCss;
});

;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumber/index.tsx






var InputNumber = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var className = _param.className, _onBlur = _param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, propValue = _param.value, _formatter = _param.formatter, formatter = _formatter === void 0 ? "0.[0000]" : _formatter, allowEmptyField = _param.allowEmptyField, disableDecimal = _param.disableDecimal, defaultValue = _param.defaultValue, zeroReplacer = _param.zeroReplacer, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "onBlur",
        "onChange",
        "value",
        "formatter",
        "allowEmptyField",
        "disableDecimal",
        "defaultValue",
        "zeroReplacer"
    ]);
    var _$ref = (0,react.useState)(defaultValue ? numeral_default()(defaultValue).format(formatter) : ""), inputValue = _$ref[0], setInputValue = _$ref[1];
    var numeralInputValue = (0,react.useMemo)(function() {
        return numeral_default()(inputValue);
    }, [
        inputValue
    ]);
    var setTextCursor = function(target, position) {
        window.requestAnimationFrame(function() {
            target.focus();
            target.setSelectionRange(position, position);
        });
    };
    var _min, _max;
    var getClampedValue = function(value) {
        return Math.min(Math.max(value, (_min = props.min) !== null && _min !== void 0 ? _min : -Infinity), (_max = props.max) !== null && _max !== void 0 ? _max : Infinity);
    };
    var handleBlur = function(e) {
        onBlur(e);
        if (inputValue === "" && allowEmptyField) return;
        setInputValue(numeral_default()(inputValue).format(formatter));
    };
    var handleChange = function(e) {
        var _target = e.target, eventValue = _target.value, selectionStart = _target.selectionStart;
        if (zeroReplacer !== undefined && (eventValue === "" || eventValue === "0")) {
            setInputValue(zeroReplacer);
            onChange(0, e);
            return;
        }
        // Handle allow empty field when clear all
        if (eventValue === "" && allowEmptyField) {
            setInputValue(eventValue);
            onChange(undefined, e);
            return;
        }
        // Handle initial input when current value is 0, for replacing initial 0
        var currentValue = numeralInputValue.value() || 0;
        var numeralInstance = numeral_default()(currentValue === 0 && (Number(eventValue) < 9 || selectionStart < 2) ? eventValue.replace("0", "") : eventValue);
        // Handle for characters input resulting NaN
        if (Number.isNaN(numeralInstance.value())) return;
        // Handle initial decimal input
        if (eventValue[eventValue.length - 1] === "." && !inputValue.includes(".") && !disableDecimal) {
            setInputValue("".concat(numeralInstance.format(formatter), "."));
            return;
        }
        // Prevent adding value more than maximum or minimum value
        numeralInstance.set(getClampedValue(numeralInstance.value()));
        var value = numeralInstance.value();
        if (eventValue === inputValue) {
            setTextCursor(e.target, selectionStart);
            return;
        }
        // Set final value
        setInputValue(numeralInstance.format(formatter));
        onChange(value, e);
        // Calculate shifting cursor with decimal and thousand separator
        var shiftPos = (currentValue === null || currentValue === void 0 ? void 0 : currentValue.toString().length) - (value === null || value === void 0 ? void 0 : value.toString().length) || 0;
        var newCursor = selectionStart + (numeralInstance.format(formatter).length - numeralInputValue.format(formatter).length + shiftPos);
        setTextCursor(e.target, newCursor <= 0 ? 1 : newCursor);
    };
    var handlePropValueChange = (0,react.useCallback)(function() {
        var isPropValueEmpty = propValue === undefined || propValue === null;
        if (isPropValueEmpty && allowEmptyField) return;
        var isReplaceZero = zeroReplacer !== undefined && propValue === 0;
        setInputValue(isReplaceZero ? zeroReplacer : numeral_default()(getClampedValue(propValue)).format(formatter));
    }, [
        propValue
    ]);
    (0,react.useEffect)(function() {
        handlePropValueChange();
    }, [
        handlePropValueChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: "ant-input ".concat(className),
        onChange: handleChange,
        onBlur: handleBlur,
        value: inputValue
    }, props));
});
/* harmony default export */ var Input_InputNumber = (InputNumber);

;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumberAddon/styled.ts

function InputNumberAddon_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border-radius: 2px;\n  border: 1px solid #dadada;\n  padding: 4px 12px;\n"
    ]);
    InputNumberAddon_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputNumberAddon_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & {\n    border: 0;\n    padding: 0;\n    width: 100%;\n    text-align: right;\n    box-shadow: none !important;\n  }\n"
    ]);
    InputNumberAddon_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var InputNumberAddon_styled_Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-2f65c52c-0"
})(InputNumberAddon_styled_templateObject());
var styled_InputNumber = (0,styled_components_browser_esm["default"])(Input_InputNumber).withConfig({
    componentId: "sc-2f65c52c-1"
})(InputNumberAddon_styled_templateObject1());

;// CONCATENATED MODULE: ./src/global/Securities/components/Input/InputNumberAddon/index.tsx




var InputNumberAddon = function(_param) /*#__PURE__*/ {
    var addonBefore = _param.addonBefore, addonAfter = _param.addonAfter, props = (0,_object_without_properties/* default */.Z)(_param, [
        "addonBefore",
        "addonAfter"
    ]);
    return (0,jsx_runtime.jsxs)(InputNumberAddon_styled_Container, {
        className: "ant-input",
        children: [
            addonBefore && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginRight: 4
                },
                children: addonBefore
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_InputNumber, (0,_object_spread/* default */.Z)({}, props)),
            addonAfter && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    marginLeft: 4
                },
                children: addonAfter
            })
        ]
    });
};
/* harmony default export */ var Input_InputNumberAddon = (InputNumberAddon);

// EXTERNAL MODULE: ./node_modules/antd/es/switch/index.js + 1 modules
var es_switch = __webpack_require__(94594);
;// CONCATENATED MODULE: ./src/global/Securities/components/Switch/index.tsx

function Switch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 34px;\n  height: 20px;\n\n  & > .ant-switch-handle {\n    width: 18px;\n    height: 18px;\n    top: 1px;\n    left: 1px;\n  }\n\n  &.ant-switch-checked .ant-switch-handle {\n    left: calc(100% - 18px - 1px);\n  }\n"
    ]);
    Switch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Switch = (0,styled_components_browser_esm["default"])(es_switch/* default */.Z).withConfig({
    componentId: "sc-fe336cf-0"
})(Switch_templateObject());
/* harmony default export */ var components_Switch = (Switch);

// EXTERNAL MODULE: ./src/global/Securities/constants/transaction.ts
var constants_transaction = __webpack_require__(94386);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/store.ts
var RealTradingModal_store = __webpack_require__(53616);
;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/SplitOrderFormItem/useSplitOrderValidation.ts
var getErrorListValidation = function(errorList) {
    for(var i = 0; i < errorList.length; i += 1){
        var errorCondition = errorList[i].errorCondition;
        if (errorCondition) return errorList[i];
    }
    return null;
};
var useSplitOrderValidation = function(transactionType) {
    var getValidateQuantityField = function(quantity, min, max, orderLot) {
        return getErrorListValidation([
            {
                errorCondition: quantity <= 1,
                message: "Split Quantity must be higher than 1"
            },
            {
                errorCondition: quantity > orderLot,
                message: "Split Quantity must be lower or equal to ".concat(transactionType, " Order Lot")
            },
            {
                errorCondition: quantity * min > orderLot && min <= max,
                message: ""
            },
            {
                errorCondition: quantity * max < orderLot && min <= max,
                message: ""
            }, 
        ]);
    };
    var getValidateMinRangeField = function(quantity, min, max, buyOrderLot) {
        return getErrorListValidation([
            {
                errorCondition: min > max,
                message: "Min Range must be lower than Max Range"
            },
            {
                errorCondition: min > buyOrderLot,
                message: "Min Range must be lower than ".concat(transactionType, " Order Lot")
            },
            {
                errorCondition: quantity * min > buyOrderLot,
                message: "Total of Split Quantity and Min Range must not exceed ".concat(transactionType, " Order Lot")
            }, 
        ]);
    };
    var getValidateMaxRangeField = function(quantity, min, max, buyOrderLot) {
        return getErrorListValidation([
            {
                errorCondition: min > max,
                message: "Min Range must be lower than Max Range"
            },
            {
                errorCondition: quantity * max < buyOrderLot,
                message: "Total of Split Quantity and Max Range must be higher or equal to ".concat(transactionType, " Order Lot")
            }, 
        ]);
    };
    return {
        getValidateQuantityField: getValidateQuantityField,
        getValidateMinRangeField: getValidateMinRangeField,
        getValidateMaxRangeField: getValidateMaxRangeField
    };
};
/* harmony default export */ var SplitOrderFormItem_useSplitOrderValidation = (useSplitOrderValidation);

// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 8 modules
var input = __webpack_require__(7648);
;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/SplitOrderFormItem/styled.ts

function SplitOrderFormItem_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-input:hover,\n  .ant-input:focus,\n  .ant-input-focused {\n    border-color: #dadada;\n    outline: 0;\n    box-shadow: none;\n  }\n\n  &.ant-form-item-has-error {\n    .ant-input:hover,\n    .ant-input:focus,\n    .ant-input-focused {\n      border-color: #ff7875;\n      border-right-width: 1px !important;\n      outline: 0;\n      box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);\n    }\n  }\n\n  & .ant-form-item-explain,\n  .ant-form-item-extra {\n    min-height: unset;\n  }\n"
    ]);
    SplitOrderFormItem_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-form-item-explain {\n    color: #ff4d4f;\n  }\n"
    ]);
    SplitOrderFormItem_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0;\n"
    ]);
    SplitOrderFormItem_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-input-group > .ant-input:first-child,\n  .ant-input-group-addon:first-child {\n    padding-right: 50px;\n    border-radius: 4px;\n    text-align: right;\n  }\n\n  & span.ant-input-group-addon {\n    background: transparent;\n    position: absolute;\n    top: 0;\n    right: 0;\n\n    width: fit-content;\n    height: 100%;\n\n    display: flex;\n    align-items: center;\n\n    border: none;\n    color: #858585;\n    z-index: 1;\n  }\n"
    ]);
    SplitOrderFormItem_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SplitOrderFormItem_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #858585;\n"
    ]);
    SplitOrderFormItem_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n\n  & > div,\n  span {\n    margin-right: 8px;\n\n    :last-child {\n      margin-right: 0;\n    }\n  }\n"
    ]);
    styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 4px;\n  text-align: center;\n"
    ]);
    styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-flex;\n  background: none;\n  border: none;\n  padding: 4px 0;\n  margin: 0;\n\n  cursor: pointer;\n"
    ]);
    styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 10px;\n\n  input[type='radio']:checked + span {\n    color: #00ab6b;\n    border: 1px solid #00ab6b;\n  }\n"
    ]);
    styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 15px;\n  cursor: pointer;\n\n  > input {\n    display: none;\n  }\n\n  > span {\n    font-size: 12px;\n    line-height: 16px;\n    padding: 6px 12px;\n    color: #858585;\n    border: 1px solid #858585;\n    border-radius: 15px;\n  }\n"
    ]);
    styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var styled_FormItem = (0,styled_components_browser_esm["default"])(es_form/* default.Item */.Z.Item).withConfig({
    componentId: "sc-f9bbead9-0"
})(SplitOrderFormItem_styled_templateObject());
var FormItemError = (0,styled_components_browser_esm["default"])(styled_FormItem).withConfig({
    componentId: "sc-f9bbead9-1"
})(SplitOrderFormItem_styled_templateObject1());
var FormItemRange = (0,styled_components_browser_esm["default"])(styled_FormItem).withConfig({
    componentId: "sc-f9bbead9-2"
})(SplitOrderFormItem_styled_templateObject2());
var QuantityInput = (0,styled_components_browser_esm["default"])(input/* default */.Z).withConfig({
    componentId: "sc-f9bbead9-3"
})(SplitOrderFormItem_styled_templateObject3());
var QuantityAddon = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-f9bbead9-4"
})(SplitOrderFormItem_styled_templateObject4());
var RangeWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9bbead9-5"
})(styled_templateObject5());
var RangeInput = (0,styled_components_browser_esm["default"])(Input_InputNumber).attrs({
    disableHighlight: true
}).withConfig({
    componentId: "sc-f9bbead9-6"
})(styled_templateObject6());
var InfoButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-f9bbead9-7"
})(styled_templateObject7());
var RadioButtonContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-f9bbead9-8"
})(styled_templateObject8());
var RadioButton = styled_components_browser_esm["default"].label.withConfig({
    componentId: "sc-f9bbead9-9"
})(styled_templateObject9());

;// CONCATENATED MODULE: ./src/global/Securities/components/Form/TransactionForm/SplitOrderFormItem/index.tsx















var SplitOrderFormItem = function(param) {
    var form = param.form, _orderLot = param.orderLot, orderLot = _orderLot === void 0 ? 10 : _orderLot, _minQuantity = param.minQuantity, minQuantity = _minQuantity === void 0 ? 0 : _minQuantity, _maxQuantity = param.maxQuantity, maxQuantity = _maxQuantity === void 0 ? constants_transaction/* orderMaxQuantity */.Hz : _maxQuantity, _minRange = param.minRange, minRange = _minRange === void 0 ? 0 : _minRange, _maxRange = param.maxRange, maxRange = _maxRange === void 0 ? constants_transaction/* orderMaxLot */.eg : _maxRange, _checkedInitialValue = param.checkedInitialValue, checkedInitialValue = _checkedInitialValue === void 0 ? false : _checkedInitialValue, _quantityInitialValue = param.quantityInitialValue, quantityInitialValue = _quantityInitialValue === void 0 ? 0 : _quantityInitialValue, minRangeInitialValue = param.minRangeInitialValue, maxRangeInitialValue = param.maxRangeInitialValue, _transactionType = param.transactionType, transactionType = _transactionType === void 0 ? transaction/* TransactionType.Buy */.iU.Buy : _transactionType, _disabledToggle = param.disabledToggle, disabledToggle = _disabledToggle === void 0 ? false : _disabledToggle, _onInfoIconClick = param.onInfoIconClick, onInfoIconClick = _onInfoIconClick === void 0 ? function() {} : _onInfoIconClick, _onSwitchChange = param.onSwitchChange, onSwitchChange = _onSwitchChange === void 0 ? function() {} : _onSwitchChange, _onSplitMethodInfoClick = param.onSplitMethodInfoClick, onSplitMethodInfoClick = _onSplitMethodInfoClick === void 0 ? function() {} : _onSplitMethodInfoClick;
    var ref = (0,RealTradingModal_store/* default */.Z)(), splitMethod = ref.splitMethod, setSplitMethod = ref.setSplitMethod, setSplitRange = ref.setSplitRange;
    var ref1 = (0,react.useState)(checkedInitialValue), isSplitOrderActive = ref1[0], setSplitOrderActive = ref1[1];
    var ref2 = SplitOrderFormItem_useSplitOrderValidation(transactionType), getValidateQuantityField = ref2.getValidateQuantityField, getValidateMinRangeField = ref2.getValidateMinRangeField, getValidateMaxRangeField = ref2.getValidateMaxRangeField;
    var ref3 = (0,react.useState)(0), quantityValue = ref3[0], setQuantityValue = ref3[1];
    var handleValidateAllFields = function() {
        form.validateFields();
    };
    var handleSwitchChange = function(value) {
        form.resetFields([
            "splitQuantity",
            "splitRangeMin",
            "splitRangeMax"
        ]);
        setSplitOrderActive(value);
        handleValidateAllFields();
        onSwitchChange(value);
    };
    var handleQuantityChange = function(value) {
        setQuantityValue(value);
        handleValidateAllFields();
    };
    var handleInfoIconClick = function(event) {
        event.stopPropagation();
        onInfoIconClick(event);
    };
    var handleValidateQuantity = function(param) {
        var getFieldsValue = param.getFieldsValue, setFields = param.setFields;
        return {
            validator: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, splitQuantity, splitRangeMin, splitRangeMax, isFieldsEmpty, isBuyOrderLotEmpty, errorItem;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = getFieldsValue([
                                "splitQuantity",
                                "splitRangeMin",
                                "splitRangeMax", 
                            ]), splitQuantity = ref.splitQuantity, splitRangeMin = ref.splitRangeMin, splitRangeMax = ref.splitRangeMax;
                            isFieldsEmpty = !(splitQuantity !== undefined && splitRangeMin && splitRangeMax);
                            isBuyOrderLotEmpty = orderLot === 0;
                            setFields([
                                "splitRangeMin",
                                "splitRangeMax"
                            ].map(function(name) {
                                return {
                                    name: name,
                                    errors: undefined
                                };
                            }));
                            if (!(isFieldsEmpty || isBuyOrderLotEmpty)) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.resolve());
                        case 6:
                            errorItem = getValidateQuantityField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            if (!(errorItem === null || errorItem === void 0 ? void 0 : errorItem.errorCondition)) {
                                _ctx.next = 10;
                                break;
                            }
                            if (errorItem.message.includes("lower")) {
                                form.setFieldsValue({
                                    splitRangeMin: 1,
                                    splitRangeMax: 1
                                });
                            }
                            return _ctx.abrupt("return", Promise.reject(errorItem.message ? new Error(errorItem.message) : undefined));
                        case 10:
                            return _ctx.abrupt("return", Promise.resolve());
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))
        };
    };
    var handleValidateRange = function(param) {
        var setFields = param.setFields, getFieldsValue = param.getFieldsValue;
        return {
            validator: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var ref, splitQuantity, splitRangeMin, splitRangeMax, isFieldsEmpty, isOrderLotEmpty, quantityFieldError, minRangeFieldError, maxRangeFieldError;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ref = getFieldsValue([
                                "splitQuantity",
                                "splitRangeMin",
                                "splitRangeMax", 
                            ]), splitQuantity = ref.splitQuantity, splitRangeMin = ref.splitRangeMin, splitRangeMax = ref.splitRangeMax;
                            isFieldsEmpty = !(splitQuantity !== undefined && splitRangeMin && splitRangeMax);
                            isOrderLotEmpty = orderLot === 0;
                            setFields([
                                "splitRangeMin",
                                "splitRangeMax"
                            ].map(function(name) {
                                return {
                                    name: name,
                                    errors: undefined
                                };
                            }));
                            if (!(isFieldsEmpty || isOrderLotEmpty)) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.resolve());
                        case 6:
                            quantityFieldError = getValidateQuantityField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            if (!(quantityFieldError === null || quantityFieldError === void 0 ? void 0 : quantityFieldError.message)) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", Promise.resolve());
                        case 9:
                            minRangeFieldError = getValidateMinRangeField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            maxRangeFieldError = getValidateMaxRangeField(splitQuantity, splitRangeMin, splitRangeMax, orderLot);
                            if (!(minRangeFieldError || maxRangeFieldError)) {
                                _ctx.next = 15;
                                break;
                            }
                            if (minRangeFieldError) {
                                setFields([
                                    {
                                        name: "splitRangeMin",
                                        errors: [
                                            ""
                                        ]
                                    }
                                ]);
                            }
                            if (maxRangeFieldError) {
                                setFields([
                                    {
                                        name: "splitRangeMax",
                                        errors: [
                                            ""
                                        ]
                                    }
                                ]);
                            }
                            return _ctx.abrupt("return", Promise.reject(minRangeFieldError || maxRangeFieldError));
                        case 15:
                            return _ctx.abrupt("return", Promise.resolve());
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))
        };
    };
    var handleResetRange = function() {
        form.setFieldsValue({
            splitRangeMin: 0,
            splitRangeMax: 0
        });
        setSplitRange(0, 0);
    };
    var handleSplitMethodSelected = function(e) {
        setSplitMethod(e.target.value);
        if (e.target.value === transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL) {
            handleResetRange();
        }
        setTimeout(function() {
            handleValidateAllFields();
        }, 0);
    };
    // set value setMinRange and setMaxRange if orderLot or splitQuantity change
    var handleSetMinMaxRange = function() {
        var splitQuantity = form.getFieldsValue([
            "splitQuantity",
            "splitRangeMin",
            "splitRangeMax", 
        ]).splitQuantity;
        if (splitMethod === transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL) {
            handleResetRange();
            return;
        }
        if (!splitQuantity || !orderLot) {
            form.setFieldsValue({
                splitRangeMin: 0,
                splitRangeMax: 0
            });
            setSplitRange(0, 0);
            return;
        }
        var orderPerQuantity = orderLot / splitQuantity;
        var formattedOrderPerQuantity = orderPerQuantity > 1 ? orderPerQuantity : 1;
        // Minimum Lot Size as 50% of the average lot size, rounding down any decimal result.
        // Maximum Lot Size as 150% of the average lot size, rounding up any decimal result.
        var calculadteMin = Math.floor(formattedOrderPerQuantity * 0.5);
        var calculadteMax = Math.ceil(formattedOrderPerQuantity * 1.5);
        var formattedMin = calculadteMin > 0 ? calculadteMin : 1;
        var rangeMin = formattedMin > constants_transaction/* orderMaxLot */.eg ? constants_transaction/* orderMaxLot */.eg : formattedMin;
        var rangeMax = calculadteMax > constants_transaction/* orderMaxLot */.eg ? constants_transaction/* orderMaxLot */.eg : calculadteMax;
        form.setFieldsValue({
            splitRangeMin: rangeMin,
            splitRangeMax: rangeMax
        });
        setSplitRange(rangeMin, rangeMax);
    };
    (0,react.useEffect)(function() {
        handleSetMinMaxRange();
        if (!isSplitOrderActive) {
            setQuantityValue(0);
        }
    }, [
        orderLot,
        quantityValue,
        isSplitOrderActive,
        splitMethod
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Split Order",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton, {
                            type: "button",
                            onClick: handleInfoIconClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: InfoSvg/* default */.Z,
                                style: {
                                    fontSize: 16,
                                    color: "#969696",
                                    marginLeft: 4
                                }
                            })
                        })
                    ]
                }),
                name: "isSplitOrderActive",
                initialValue: checkedInitialValue,
                valuePropName: "checked",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Switch, {
                    onChange: handleSwitchChange,
                    disabled: disabledToggle
                })
            }),
            isSplitOrderActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_FormItem, {
                        label: "Split Quantity",
                        name: "splitQuantity",
                        validateTrigger: "onChange",
                        rules: [
                            handleValidateQuantity
                        ],
                        initialValue: quantityInitialValue,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_InputNumberAddon, {
                            addonAfter: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuantityAddon, {
                                children: [
                                    "order",
                                    quantityValue > 1 && "s"
                                ]
                            }),
                            min: minQuantity,
                            max: maxQuantity,
                            formatter: "0,0",
                            autoComplete: "off",
                            onChange: handleQuantityChange,
                            disableHighlight: true,
                            disableDecimal: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_FormItem, {
                        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Split Method"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoButton, {
                                    type: "button",
                                    onClick: onSplitMethodInfoClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            fontSize: 16,
                                            color: "#969696",
                                            marginLeft: 4
                                        }
                                    })
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioButtonContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioButton, {
                                    htmlFor: "radio-random",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            id: "radio-random",
                                            name: "splitMethod",
                                            value: transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                                            checked: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                                            onChange: handleSplitMethodSelected,
                                            defaultChecked: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Random"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioButton, {
                                    htmlFor: "radio-equal",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "radio",
                                            id: "radio-equal",
                                            name: "splitMethod",
                                            value: transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL,
                                            checked: splitMethod === transaction/* SplitOrderMethodEnum.EQUAL */.PH.EQUAL,
                                            onChange: handleSplitMethodSelected
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Equal"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemError, {
                            validateStatus: "",
                            label: "Split Range Lot",
                            name: "rangeInput",
                            validateTrigger: "onChange",
                            rules: [
                                handleValidateRange
                            ],
                            initialValue: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(RangeWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemRange, {
                                        name: "splitRangeMin",
                                        initialValue: minRangeInitialValue,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeInput, {
                                            min: minRange,
                                            max: maxRange,
                                            placeholder: "Min",
                                            formatter: "0,0",
                                            autoComplete: "off",
                                            zeroReplacer: "",
                                            onChange: handleValidateAllFields,
                                            allowEmptyField: true,
                                            disableDecimal: true,
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapRightOutlined/* default */.Z, {
                                        style: {
                                            color: "#96969699"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemRange, {
                                        name: "splitRangeMax",
                                        initialValue: maxRangeInitialValue,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RangeInput, {
                                            min: minRange,
                                            max: maxRange,
                                            placeholder: "Max",
                                            formatter: "0,0",
                                            autoComplete: "off",
                                            zeroReplacer: "",
                                            onChange: handleValidateAllFields,
                                            allowEmptyField: true,
                                            disableDecimal: true,
                                            required: true
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionForm_SplitOrderFormItem = (SplitOrderFormItem);

// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
;// CONCATENATED MODULE: ./src/global/Securities/components/Tooltip/index.ts

function Tooltip_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    Tooltip_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Tooltip = (0,styled_components_browser_esm["default"])(tooltip/* default */.Z).attrs({
    overlayStyle: {
        maxWidth: "unset"
    },
    overlayClassName: "tooltip-overlay-green",
    overlayInnerStyle: {
        background: "#00ab6b",
        padding: "12px",
        maxWidth: "unset",
        lineHeight: "16px",
        fontSize: "12px",
        fontWeight: 700
    }
}).withConfig({
    componentId: "sc-6aa290c9-0"
})(Tooltip_templateObject());
/* harmony default export */ var components_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ./src/global/TradingModal/components/TriggerPriceTooltip.tsx







var TriggerPriceTooltip_Flex = ui/* Common.Flex */.Gn.Flex, TriggerPriceTooltip_Text = ui/* Common.Text */.Gn.Text;
function TriggerPriceTooltip() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TriggerPriceTooltip_Flex, {
        align: "center",
        justify: "flex-end",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TriggerPriceTooltip_Text, {
                align: "right",
                children: "Trigger Price"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomTooltip, {
                overlayStyle: {
                    maxWidth: "281px"
                },
                overlayInnerStyle: {
                    padding: "12px",
                    borderRadius: "4px"
                },
                color: ui/* color.highempahis */.$_.highempahis,
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TriggerPriceTooltip_Text, {
                            size: "12px",
                            family: "bold",
                            color: "inherit",
                            children: "Trigger Price"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                height: "8px"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TriggerPriceTooltip_Text, {
                            size: "12px",
                            color: "inherit",
                            children: "Trigger Price adalah kondisi harga yang harus terpenuhi agar order beli dapat dikirim."
                        })
                    ]
                }),
                placement: "bottom",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/info.svg",
                    alt: "type-info",
                    style: {
                        marginLeft: "5px",
                        width: "12px",
                        cursor: "pointer"
                    },
                    onMouseEnter: autoOrder/* trackAutoBuyTriggerPriceInfoSelected */.gT,
                    "data-cy": constant/* DATA_CY_MODAL_TRADING.TRIGGER_PRICE_BUTTON_INFO */.eG.TRIGGER_PRICE_BUTTON_INFO
                })
            })
        ]
    });
}
/* harmony default export */ var components_TriggerPriceTooltip = (TriggerPriceTooltip);

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useEnableSplitOrder.ts








function useEnableSplitOrder(formType) {
    var ref = (0,RealTradingModal_store/* default */.Z)(), expiry = ref.expiry, orderType = ref.type;
    var ref1 = (0,TradingModal_store/* default */.Z)(), modalOrderType = ref1.orderType;
    var splitOrderInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.splitOrder;
    });
    var isSplitOrderFeatureEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.SPLIT_ORDER */.O.SPLIT_ORDER);
    var isShowSplitOrder = (0,react.useMemo)(function() {
        // set to true in case we have failed to get splitorder info
        var isMarketOpen = true;
        if (splitOrderInfo && typeof splitOrderInfo.remaining_trading_close === "number") {
            isMarketOpen = splitOrderInfo.remaining_trading_close !== 0;
        }
        if (formType === "buy") {
            return orderType === transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder && // Order type is not amend BUY
            modalOrderType !== trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY && // feature flag enabled
            isSplitOrderFeatureEnabled && // disable split order on GTC
            expiry !== transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled && // only show when market opens
            isMarketOpen;
        }
        // order is limit order BUY / SELL
        return orderType === transaction/* SellOrderType.LimitOrder */.qK.LimitOrder && // Order type is not amend SELL
        modalOrderType !== trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL && // feature flag enabled
        isSplitOrderFeatureEnabled && // disable split order on GTC
        expiry !== transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled && // only show when market opens
        isMarketOpen;
    }, [
        orderType,
        isSplitOrderFeatureEnabled,
        expiry,
        splitOrderInfo
    ]);
    return isShowSplitOrder;
};

;// CONCATENATED MODULE: ./src/global/TradingModal/hooks/useTransactionBalance.ts






var useTransactionBalance = function() {
    var paymentMethod = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance;
    var portfolioTradingBalance = (0,tradingData/* default */.Z)(function(s) {
        var ref;
        return (ref = s.portfolio.data) === null || ref === void 0 ? void 0 : ref.tradingbalance;
    });
    var balanceList = (0,useCashInfoStore/* default */.Z)(function(s) {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance, s.tradingBalance || portfolioTradingBalance), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, s.tradingLimit), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, s.dayTrade), _obj;
    }, shallow/* default */.Z);
    return [
        balanceList[paymentMethod]
    ].concat((0,_to_consumable_array/* default */.Z)(Object.values(balanceList)));
};
/* harmony default export */ var hooks_useTransactionBalance = (useTransactionBalance);

// EXTERNAL MODULE: ./src/global/TradingModal/hooks/useIsUserSyariah.ts + 1 modules
var useIsUserSyariah = __webpack_require__(66940);
// EXTERNAL MODULE: ./src/lib/entities/profile.js + 2 modules
var profile = __webpack_require__(333);
;// CONCATENATED MODULE: ./src/global/Securities/utils/transactionBalance.ts


var getCashTracks = function(paymentMethod, tradingBalance, tradingLimit) {
    var minThreshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [
        0.04,
        0.08
    ];
    // If payment method is not Trading Limit, return 100% TB and 0% TL
    if (paymentMethod !== transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit) {
        return [
            100,
            0
        ];
    }
    var _minThreshold = (0,_sliced_to_array/* default */.Z)(minThreshold, 2), leftMinThreshold = _minThreshold[0], rightMinThreshold = _minThreshold[1];
    var clampToZero = function(value) {
        return value < 0 ? 0 : value;
    };
    var tradingBalanceRatio = clampToZero(tradingBalance) / clampToZero(tradingLimit);
    var isTradingBalanceFinite = Number.isFinite(tradingBalanceRatio);
    // Will return max TB if TL actually 0 / ratio is infinity
    if (!isTradingBalanceFinite) return [
        100,
        0
    ];
    var tradingLimitRatio = 1 - tradingBalanceRatio;
    if (tradingBalanceRatio !== 0 && tradingBalanceRatio < leftMinThreshold) {
        return [
            leftMinThreshold * 100,
            (1 - leftMinThreshold) * 100
        ];
    }
    if (tradingLimitRatio !== 0 && tradingLimitRatio < rightMinThreshold) {
        return [
            (1 - rightMinThreshold) * 100,
            rightMinThreshold * 100
        ];
    }
    return [
        tradingBalanceRatio * 100,
        tradingLimitRatio * 100
    ];
};

// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var utils_formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/utils.ts
var RealTradingModal_utils = __webpack_require__(16153);
// EXTERNAL MODULE: ./src/global/Securities/utils/transactionPrice.ts
var transactionPrice = __webpack_require__(98306);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/utils.ts
var TransactionModal_utils = __webpack_require__(55039);
// EXTERNAL MODULE: ./src/utils/securities/analytics.ts
var analytics = __webpack_require__(67600);
// EXTERNAL MODULE: ./src/global/Securities/constants/transactionForm.ts
var constants_transactionForm = __webpack_require__(9657);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormBuy.tsx













// components














// hooks




// lib





// stores




// utils







// constants



// types



// styles



var FormBuy_Flex = ui/* Common.Flex */.Gn.Flex, TransactionModal_FormBuy_Text = ui/* Common.Text */.Gn.Text;
var FormBuy_FormBuy = function(param) {
    var showOrderTypeModal = param.showOrderTypeModal, showAutoBuyTncModal = param.showAutoBuyTncModal, showSpecialMonitoringModal = param.showSpecialMonitoringModal, _onShowTradingLimitTnc = param.onShowTradingLimitTnc, onShowTradingLimitTnc = _onShowTradingLimitTnc === void 0 ? function() {} : _onShowTradingLimitTnc, _onShowSplitOrderInfo = param.onShowSplitOrderInfo, onShowSplitOrderInfo = _onShowSplitOrderInfo === void 0 ? function() {} : _onShowSplitOrderInfo, _onShowSplitOrderMethodInfo = param.onShowSplitOrderMethodInfo, onShowSplitOrderMethodInfo = _onShowSplitOrderMethodInfo === void 0 ? function() {} : _onShowSplitOrderMethodInfo, onSubmit = param.onSubmit, _onShowDayTradeOnboarding = param.onShowDayTradeOnboarding, onShowDayTradeOnboarding = _onShowDayTradeOnboarding === void 0 ? function() {} : _onShowDayTradeOnboarding, _onShowDayTradeUnavailable = param.onShowDayTradeUnavailable, onShowDayTradeUnavailable = _onShowDayTradeUnavailable === void 0 ? function() {} : _onShowDayTradeUnavailable;
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useUIConfigStore/* default */.Z)(function(s) {
        return [
            s.setUIValue,
            s.getUIValue("tradingLimitTooltip"),
            s.getUIValue("transactionPaymentMethod"),
            s.getUIValue("dayTradeSubAccountActive"), 
        ];
    }, shallow/* default */.Z), 4), setUIValue = ref1[0], isTradingLimitTooltipOpened = ref1[1], defaultPaymentMethod = ref1[2], isDayTradeSubAccountActive = ref1[3];
    var ref2 = (0,react.useState)(false), cashInfoLoaded = ref2[0], setCashInfoLoaded = ref2[1];
    var ref3 = (0,react.useState)(false), hasFormError = ref3[0], setHasFormError = ref3[1];
    var ref4 = (0,react.useState)(false), isPaymentMethodVisible = ref4[0], setPaymentMethodVisible = ref4[1];
    var ref5 = (0,react.useState)(defaultPaymentMethod || transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance), paymentMethod = ref5[0], setPaymentMethod = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(hooks_useTransactionBalance(paymentMethod), 4), activeTradingBalance = ref6[0], tradingBalance = ref6[1], tradingLimit = ref6[2], dayTradeBuyingPower = ref6[3];
    var loadTradingInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.loadTradingInfo;
    });
    var splitOrder = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.splitOrder;
    });
    var ref7 = splitOrder || {}, maxOrder = ref7.max_order;
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useCashInfoStore/* default */.Z)(function(s) {
        return [
            s.error,
            s.isLoading,
            s.loadCashInfo
        ];
    }, shallow/* default */.Z), 3), cashInfoError = ref8[0], isCashInfoLoading = ref8[1], loadCashInfo = ref8[2];
    var ref9 = (0,TradingModal_store/* default */.Z)(), symbol = ref9.symbol, orderType = ref9.orderType, isAutoBuy = ref9.isAutoBuy, orderedPrice = ref9.orderedPrice, orderedLot = ref9.orderedLot, modalData = ref9.modalData, isDayTrade = ref9.isDayTrade, orderId = ref9.orderid, setAutoBuy = ref9.setAutoBuy, setModalState = ref9.setModalState;
    var ref10 = modalData || {}, trigger_price = ref10.trigger_price, config_type = ref10.config_type, amount_open_fee = ref10.amount_open_fee, amount_matched_total = ref10.amount_matched_total;
    var ref11 = (0,tradingData/* default */.Z)(), _portfolio = ref11.portfolio, _data = _portfolio.data, showCreateSmartOrder = _data.show_create_smartorder, _company = ref11.company, _data1 = _company.data, tradeable = _data1.tradeable, productType = _data1.type_company, marketHour = _data1.market_hour, dayTradeInfo = _data1.day_trade_info, cashOnHand = ref11.cashOnHand, getCashOnHand = ref11.getCashOnHand, _configFormula = ref11.configFormula, configFormula = _configFormula.data;
    var multiplier = (dayTradeInfo || {}).multiplier;
    var ref12 = (0,RealTradingModal_store/* default */.Z)(), configType = ref12.configType, price = ref12.price, expiry = ref12.expiry, triggerPrice = ref12.triggerPrice, shares = ref12.shares, buyOrderType = ref12.type, isSplitOrderActive = ref12.isSplitOrderActive, splitQuantity = ref12.splitQuantity, splitRangeMin = ref12.splitRangeMin, splitRangeMax = ref12.splitRangeMax, splitMethod = ref12.splitMethod, setTriggerPrice = ref12.setTriggerPrice, setPrice = ref12.setPrice, setExpiry = ref12.setExpiry, setConfigType = ref12.setConfigType, setOrderType = ref12.setOrderType, setShares = ref12.setShares, setSplitOrderActive = ref12.setSplitOrderActive, setSplitQuantity = ref12.setSplitQuantity, setSplitRange = ref12.setSplitRange, setSplitMethod = ref12.setSplitMethod, setDayTradeActive = ref12.setDayTradeActive, setDayTadeMultiplier = ref12.setDayTadeMultiplier;
    var isShowSplitOrder = useEnableSplitOrder("buy");
    var isUserSyariah = (0,useIsUserSyariah/* default */.Z)();
    var isSaham = productType.toLowerCase() === trading/* STOCK_TYPE.saham */.L2.saham;
    var isRight = productType.toLowerCase() === trading/* STOCK_TYPE.right */.L2.right;
    var isAmend = orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY;
    var isShowOrderType = buyOrderType && isSaham && showCreateSmartOrder && !isAmend;
    var originalLot = shares / constant/* lotSize */.CQ;
    var isTradeable = tradeable === 1;
    // trigger price must be > 0, if order type is Auto Buy
    var triggerAutoBuy = buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy && Number(triggerPrice) === 0;
    var hideExpiry = !isSaham || isAmend;
    var dayTradeMultiplier = parseInt(multiplier, 10);
    var isPaymentDayTradeActive = paymentMethod === transaction/* PaymentMethod.DayTrade */.XL.DayTrade;
    var isPaymentTradingLimitActive = paymentMethod === transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit;
    // Disable day trade if multiplier is below 1
    var isPaymentDayTradeDisabled = (0,react.useMemo)(function() {
        return dayTradeMultiplier <= 1;
    }, [
        dayTradeMultiplier
    ]);
    // Hide or show payment leverage (Trading Limit / Day Trade) - Buy Order
    var isPaymentMethodDisabled = (0,react.useMemo)(function() {
        var isOrderTypeAutoBuy = buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
        var isExpiryGtc = expiry === transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled;
        return [
            isOrderTypeAutoBuy,
            isExpiryGtc,
            isAmend,
            !isSaham,
            isUserSyariah, 
        ].includes(true);
    }, [
        buyOrderType,
        expiry,
        dayTradeMultiplier,
        isAmend,
        isSaham,
        isUserSyariah, 
    ]);
    // Hide or show payment leverage (Trading Limit / Day Trade) - Amend Order
    var isShowAmendLeverage = (0,react.useMemo)(function() {
        return isDayTrade && isAmend;
    }, [
        isDayTrade,
        isAmend
    ]);
    var isTradingLimitTooltipActive = (0,react.useMemo)(function() {
        return [
            !isPaymentMethodDisabled,
            !isTradingLimitTooltipOpened,
            isShowOrderType,
            false
        ].every(function(value) {
            return value;
        });
    }, [
        isPaymentMethodDisabled,
        isTradingLimitTooltipOpened,
        isShowOrderType
    ]);
    // Balance for payment method (leverage) modal
    var leverageBalanceList = (0,react.useMemo)(function() {
        var _obj;
        var balance = (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, tradingLimit), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, dayTradeBuyingPower), _obj);
        // Remove day trade balance if multiplier is below 1
        if (dayTradeMultiplier <= 1) {
            delete balance[transaction/* PaymentMethod.DayTrade */.XL.DayTrade];
        }
        return balance;
    }, [
        tradingLimit,
        dayTradeBuyingPower,
        dayTradeMultiplier
    ]);
    var tracksWidth = (0,react.useMemo)(function() {
        return getCashTracks(paymentMethod, tradingBalance, tradingLimit);
    }, [
        paymentMethod,
        tradingBalance,
        tradingLimit
    ]);
    var ref13 = (0,es/* useSelector */.v9)(profile/* selectors */.wl), username = ref13.data.username;
    var available_cash_on_hand = cashOnHand.data.available_cash_on_hand;
    var limitLot = (0,react.useMemo)(function() {
        var buyOrderDayTrade = isPaymentDayTradeActive;
        // New limit lot calculation for amend order
        // If user is day trade and day trade is active, use active trading balance (from buying power)
        // No need to add fee and matched total because it's already included in the buying power
        // Otherwise, use original trading balance plus fee and matched total
        if (isAmend) {
            var amendTradingBalance = isDayTrade ? activeTradingBalance : activeTradingBalance + (amount_open_fee || 0) + (amount_matched_total || 0);
            return (0,utils_formula/* getLimitLot */.J0)(amendTradingBalance, price, buyOrderDayTrade) || 1;
        }
        // Set limit to 1 when limit lot equal zero to enable slider to 100%
        return (0,utils_formula/* getLimitLot */.J0)(activeTradingBalance, price, buyOrderDayTrade) || 1;
    }, [
        activeTradingBalance,
        price,
        isPaymentDayTradeActive,
        isAmend
    ]);
    var ref14 = (0,TransactionModal_utils/* generateTradingVariable */.Jg)({
        configFormula: configFormula,
        cash_on_hand: available_cash_on_hand,
        trading_balance: activeTradingBalance,
        price: price,
        lot: originalLot,
        trigger_price: triggerPrice || 0,
        config_type: configType || 0,
        order_type: orderType,
        previous_buy_price: orderedPrice,
        previous_lot: orderedLot,
        stock_type: productType,
        trading_balance_amended: activeTradingBalance + (amount_open_fee || 0) + (amount_matched_total || 0),
        cash_onhand_amended: available_cash_on_hand + (amount_open_fee || 0) + (amount_matched_total || 0),
        isDayTrade: isPaymentDayTradeActive
    }), tradingbalance = ref14.TRADING_BALANCE, investmentPlusFee = ref14.BUY_AMOUNT_FEE, lot = ref14.LOT;
    var isOverlimit = investmentPlusFee > tradingbalance;
    var isDisabledBuySplitOrder = (0,react.useMemo)(function() {
        if (!isSplitOrderActive) {
            return false;
        }
        if (splitQuantity === null || splitQuantity < 1) {
            return true;
        }
        if (splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM && (!splitRangeMin || !splitRangeMax)) {
            return true;
        }
        return false;
    }, [
        isSplitOrderActive,
        splitQuantity,
        splitMethod,
        splitRangeMin,
        splitRangeMax, 
    ]);
    var disableBuy = (0,react.useMemo)(function() {
        return price === 0 || lot < 1 || !isTradeable || isOverlimit || triggerAutoBuy || hasFormError || isDisabledBuySplitOrder;
    }, [
        hasFormError,
        isTradeable,
        isOverlimit,
        price,
        lot,
        triggerAutoBuy,
        isDisabledBuySplitOrder, 
    ]);
    var showSplitOrderForm = (0,react.useMemo)(function() {
        return isShowSplitOrder && paymentMethod === transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance;
    }, [
        isShowSplitOrder,
        paymentMethod
    ]);
    // Get balance label based on payment method (leverage)
    var getBalanceLabel = (0,react.useCallback)(function() {
        if (isRight) return constants_transactionForm/* balanceLabel.cashOnHand */.Hg.cashOnHand;
        var dayTradeEnable = isPaymentDayTradeActive && dayTradeMultiplier > 1;
        if (dayTradeEnable) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    constants_transactionForm/* balanceLabel.dayTrade */.Hg.dayTrade,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Chips/* default */.Z, {
                        className: "multiplier-chip",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                component: Icons/* LightningSvg */.Sf
                            }),
                            "".concat(multiplier, "x")
                        ]
                    })
                ]
            });
        }
        return isPaymentTradingLimitActive ? constants_transactionForm/* balanceLabel.tradingLimit */.Hg.tradingLimit : constants_transactionForm/* balanceLabel.tradingBalance */.Hg.tradingBalance;
    }, [
        isRight,
        isPaymentDayTradeActive,
        dayTradeMultiplier,
        paymentMethod
    ]);
    var getMaxLot = function() {
        if (orderedPrice && price === orderedPrice) return orderedLot;
        return (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
    };
    var getSliderMaxLot = function() {
        var lotOrderLimit = (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
        return limitLot > lotOrderLimit ? lotOrderLimit : limitLot;
    };
    var getPercentage = function() {
        var percentage = Math.round(100 * lot / limitLot);
        if (Number.isNaN(percentage) || percentage === Infinity) {
            return "0";
        }
        return percentage;
    };
    var handleValidateAllFields = function() {
        form.validateFields();
    };
    var handleSetPaymentMethod = function(method) {
        setPaymentMethod(method);
        setUIValue("transactionPaymentMethod", method);
        if (method !== transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance) {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
        if (method !== paymentMethod && !isAmend) {
            setShares(0);
        }
    };
    var handleLoadCashInfo = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var cashOrderId;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    if (!cashInfoLoaded) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    cashOrderId = isAmend && isDayTrade ? orderId : undefined;
                    _ctx.next = 6;
                    return loadCashInfo(symbol, cashOrderId);
                case 6:
                    setCashInfoLoaded(true);
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.prev = 9;
                    _ctx.t0 = _ctx["catch"](0);
                    handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    })), [
        cashInfoLoaded,
        setCashInfoLoaded
    ]);
    var handleSaveFields = function() {
        var values = form.getFieldsValue();
        if (isShowSplitOrder && !isPaymentDayTradeActive) {
            setSplitOrderActive(!!values.isSplitOrderActive);
            setSplitQuantity(values.splitQuantity);
            setSplitRange(values.splitRangeMin, values.splitRangeMax);
        } else {
            setSplitOrderActive(false);
            setSplitQuantity(null);
            setSplitRange(null, null);
        }
        var DayTradeOrder = isDayTrade || isPaymentDayTradeActive;
        setDayTradeActive(DayTradeOrder);
        setDayTadeMultiplier(DayTradeOrder ? dayTradeMultiplier : 0);
    };
    var handleFieldsChange = function(_, allFields) {
        var hasEmpty = allFields.some(function(param) {
            var value = param.value;
            return value === undefined;
        });
        var hasError = allFields.some(function(param) {
            var errors = param.errors;
            return errors.length > 0;
        });
        setHasFormError(hasEmpty || hasError);
    };
    var handleOrderTypeChange = function(selectedOrderType) {
        var isSelectedAutoBuy = selectedOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy;
        if (isSelectedAutoBuy) {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
        if (isSelectedAutoBuy && !(0,TransactionModal_utils/* checkIsAutoOrderTncAgreed */.KK)(username, types_autoOrder/* AutoOrderProduct.AutoBuy */.V.AutoBuy)) {
            showAutoBuyTncModal();
            return;
        }
        setOrderType(selectedOrderType);
        setAutoBuy(isSelectedAutoBuy);
        if (isSelectedAutoBuy) handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        (0,autoOrder/* trackAutoBuyOrderTypeSelected */.dM)(selectedOrderType, symbol);
        (0,securities/* clevertapDayTradeOrderTypeSelected */.$v)(symbol, (0,analytics/* generateOrderTypeLabel */.JH)(selectedOrderType));
    };
    var handleBalanceLabelClick = function() {
        setPaymentMethodVisible(true);
        handleLoadCashInfo();
    };
    var handleTradingLimitTooltipChange = function(value) {
        if (!value) setUIValue("tradingLimitTooltip", !value);
    };
    var handlePriceChange = function(value) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        setPrice(value);
        handleValidateAllFields();
        if (isAmend) {
            var PRICE = Number(value);
            var LOT = Math.round(Number(originalLot));
            var lotAmend = (0,TransactionModal_utils/* calculateLotAmendTransaction */.xl)(orderedPrice, orderedLot, PRICE, LOT);
            setShares(lotAmend * constant/* lotSize */.CQ);
        }
    };
    var handleMethodChange = function(method) {
        // Handle when use click both tooltip and balance button
        if (isTradingLimitTooltipActive) setUIValue("tradingLimitTooltip", true);
        if (method === transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit) {
            onShowTradingLimitTnc();
        }
        setPaymentMethodVisible(false);
        handleSetPaymentMethod(method);
    };
    var handleMethodClose = function() {
        setPaymentMethodVisible(false);
    };
    var handleOrderTypeInfoClick = function() {
        showOrderTypeModal();
        (0,autoOrder/* trackAutoBuyOrderTypeInfoSelected */._E)(trading/* BUY_ORDER_TYPE_TEXT */.x4[orderType], symbol);
    };
    var handleLotChange = function(value) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        var roundLot = Math.floor(value);
        setShares(roundLot * constant/* lotSize */.CQ);
        handleValidateAllFields();
    };
    var handleExpiryChange = function(e) {
        var selectedExpiry = e.target.value;
        setExpiry(selectedExpiry);
        if (selectedExpiry === transaction/* Expiry.GoodTillCancelled */.ZM.GoodTillCancelled) {
            handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        } else {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
        handleValidateAllFields();
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var day_trade, isTimeLimit, isUnavailable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleSaveFields();
                        if (!isPaymentDayTradeActive) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 4;
                        return loadTradingInfo([
                            types_trading/* TradingFeatureEnum.DAY_TRADE */.n.DAY_TRADE, 
                        ]);
                    case 4:
                        day_trade = _ctx.sent.day_trade;
                        if (!day_trade) {
                            _ctx.next = 11;
                            break;
                        }
                        isTimeLimit = day_trade.remaining_trading_close <= 0;
                        isUnavailable = [
                            types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.b.EXCEED_DEBT_RATIO,
                            types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.b.OUTSIDE_MARKET_HOURS, 
                        ].includes(day_trade === null || day_trade === void 0 ? void 0 : day_trade.event_type);
                        if (!(isUnavailable || isTimeLimit)) {
                            _ctx.next = 11;
                            break;
                        }
                        onShowDayTradeUnavailable();
                        return _ctx.abrupt("return");
                    case 11:
                        onSubmit();
                        (0,securities/* clevertapOrderPlaced */.As)({
                            orderType: orderType,
                            symbol: symbol,
                            price: price,
                            lot: lot,
                            tradingBalancePercentage: getPercentage(),
                            status: disableBuy ? "failed" : "success",
                            expiry: constants_transactionForm/* expiryOptions */.Me[expiry],
                            type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                            orderTypeStatus: (0,analytics/* generateOrderTypeLabel */.JH)(buyOrderType),
                            splitOrder: isSplitOrderActive,
                            dayTrade: isPaymentDayTradeActive
                        });
                        if (buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) (0,autoOrder/* trackAutoBuyOrderPlaced */.pR)();
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeSwitchSplitOrder = function(checked) {
        setSplitOrderActive(checked);
        if (!checked) {
            setSplitMethod(transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM);
        }
        if (isPaymentDayTradeActive && checked) {
            setPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        }
        (0,securities/* clevertapDayTradeSplitOrderSelected */.F9)(checked);
    };
    (0,react.useEffect)(function() {
        if (isRight) getCashOnHand();
        (0,autoOrder/* trackAutoBuyOrderView */.PH)();
    }, [
        isRight
    ]);
    (0,react.useEffect)(function() {
        if (isAmend) {
            if (orderedPrice) setPrice(orderedPrice);
            if (trigger_price) setTriggerPrice(trigger_price);
            if (orderedLot) setShares(orderedLot * constant/* lotSize */.CQ);
            if (constant/* triggerPriceOption */.mr) {
                setConfigType(constant/* triggerPriceOption */.mr[config_type - 1]);
            }
        }
        if (isAutoBuy) {
            setOrderType(transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy);
            handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        } else {
            setOrderType(transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder);
        }
        if (!isSaham) {
            setExpiry(transaction/* Expiry.GoodForDay */.ZM.GoodForDay);
            setAutoBuy(false);
            setOrderType(transaction/* BuyOrderType.LimitOrder */.dY.LimitOrder);
        }
    }, [
        orderType,
        isAutoBuy
    ]);
    (0,react.useEffect)(function() {
        if (isOverlimit) (0,securities/* clevertapBuyError */.xC)();
    }, [
        isOverlimit
    ]);
    (0,react.useEffect)(function() {
        if (paymentMethod || isAmend) {
            handleLoadCashInfo();
        }
    }, [
        handleLoadCashInfo,
        paymentMethod,
        isAmend
    ]);
    (0,react.useEffect)(function() {
        if (isPaymentMethodDisabled || isPaymentDayTradeDisabled && defaultPaymentMethod === transaction/* PaymentMethod.DayTrade */.XL.DayTrade) {
            setPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
        }
        if (isAmend && isDayTrade) {
            setPaymentMethod(transaction/* PaymentMethod.DayTrade */.XL.DayTrade);
        }
    }, [
        isPaymentMethodDisabled,
        isPaymentDayTradeDisabled,
        isAmend,
        isDayTrade
    ]);
    (0,react.useEffect)(function() {
        form.validateFields();
        (0,securities/* clevertapBuyOrderViewed */.A2)(symbol, modalData === null || modalData === void 0 ? void 0 : modalData.source);
        // Reset payment method if symbol changed from search
        if (modalData === null || modalData === void 0 ? void 0 : modalData.openFromSearch) {
            handleSetPaymentMethod(transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
            setModalState({
                modalData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, modalData), {
                    openFromSearch: false
                })
            });
        }
    }, []);
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeLeverage */.g0, {
                zIndex: 1001,
                balance: leverageBalanceList,
                tradingBalance: tradingbalance,
                error: (_obj = {}, (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit, !!cashInfoError), (0,_define_property/* default */.Z)(_obj, transaction/* PaymentMethod.DayTrade */.XL.DayTrade, !!cashInfoError), _obj),
                methodValue: paymentMethod,
                visible: isPaymentMethodVisible,
                loading: isCashInfoLoading,
                onMethodChange: handleMethodChange,
                onCancel: handleMethodClose,
                onReloadClick: function() {
                    return loadCashInfo(symbol);
                },
                destroyOnClose: true,
                symbol: symbol,
                splitOrderActive: isSplitOrderActive,
                dayTradeAvailable: isDayTradeSubAccountActive,
                dayTradeMultiplier: dayTradeMultiplier,
                onShowDayTradeOnboarding: onShowDayTradeOnboarding
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: marketHour.suspend_info,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpecialMonitoringBanner, {
                    onClick: showSpecialMonitoringModal,
                    title: marketHour.suspend_info
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* TransactionForm */.vQ, {
                form: form,
                colon: false,
                labelCol: {
                    span: 12
                },
                onFinish: handleSubmit,
                onFieldsChange: handleFieldsChange,
                onBlur: handleSaveFields,
                onValuesChange: handleSaveFields,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* FieldsWrapper */.V$, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isShowOrderType,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_OrderTypeFormItem, {
                                    form: form,
                                    transactionType: transaction/* TransactionType.Buy */.iU.Buy,
                                    defaultValue: buyOrderType,
                                    onChange: handleOrderTypeChange,
                                    onInfoIconClick: handleOrderTypeInfoClick
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isPaymentMethodDisabled || isShowAmendLeverage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Leverage",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageButton, {
                                        paymentMethod: paymentMethod,
                                        multiplier: dayTradeMultiplier,
                                        enableDayTrade: dayTradeMultiplier > 1,
                                        isAmend: isAmend,
                                        onMethodChange: handleMethodChange,
                                        onOpenModalLeverage: handleBalanceLabelClick
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* BalanceButton */.RP, {
                                    type: "button",
                                    onClick: handleBalanceLabelClick,
                                    disabled: true,
                                    children: [
                                        getBalanceLabel(),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: !isPaymentMethodDisabled,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tooltip, {
                                                placement: "bottom",
                                                title: "Tingkatkan buying power kamu dengan Trading Limit",
                                                visible: isTradingLimitTooltipActive,
                                                onVisibleChange: handleTradingLimitTooltipChange,
                                                trigger: "click",
                                                arrowPointAtCenter: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                    condition: isTradingLimitTooltipActive,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                        component: ChevronDownSvg/* default */.Z,
                                                        style: {
                                                            color: "#969696"
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormBuy_Text, {
                                    family: "bold",
                                    children: (0,number/* formatNumber */.uf)(tradingbalance, true, isOverlimit ? "0,0.00" : "0,0")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !isAmend || isAmend && (isAutoBuy || isSaham),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    className: "slider-form-item",
                                    label: "",
                                    wrapperCol: {
                                        xs: {
                                            offset: 0
                                        },
                                        sm: {
                                            span: 12,
                                            offset: 12
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormBuy_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Slider, {
                                                min: 0,
                                                max: getSliderMaxLot(),
                                                value: lot,
                                                tracksWidth: tracksWidth,
                                                tipFormatter: null,
                                                onChange: function(newLot) {
                                                    // If newLot is more than max Lot, don't update the value
                                                    if (isAmend && newLot > getMaxLot()) {
                                                        // if ordered price is same as price, set shares to ordered lot (max lot)
                                                        if (orderedPrice === price) {
                                                            setShares(orderedLot * constant/* lotSize */.CQ);
                                                        }
                                                        return;
                                                    }
                                                    (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
                                                        symbol: symbol,
                                                        orderType: orderType,
                                                        adjustedType: "slider"
                                                    });
                                                    setShares(Math.ceil(newLot) * constant/* lotSize */.CQ);
                                                    handleValidateAllFields();
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* SliderPercentText */.fx, {
                                                children: [
                                                    getPercentage(),
                                                    "%"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Investment (Plus Fee)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_FormBuy_Text, {
                                    family: "bold",
                                    children: [
                                        "Rp",
                                        " ",
                                        (0,number/* formatNumber */.uf)(investmentPlusFee, true, isOverlimit ? "0,0.00" : "0,0")
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isAutoBuy,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TriggerPriceTooltip, {}),
                                    "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_TRIGGER_PRICE */.eG.FORM_TRIGGER_PRICE,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormBuy_Flex, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* TriggerPriceSelect */.d2, {
                                                value: constant/* triggerPriceOption */.mr[configType - 1],
                                                onChange: function(e) {
                                                    setConfigType(e.target.value);
                                                    (0,autoOrder/* trackAutoBuyTriggerConditionSelected */.ZY)({
                                                        1: "≥",
                                                        2: '"≤"'
                                                    }[e.target.value]);
                                                    handleValidateAllFields();
                                                },
                                                "data-cy": constant/* DATA_CY_MODAL_TRADING.TRIGGER_PRICE_SELECT */.eG.TRIGGER_PRICE_SELECT,
                                                children: constant/* triggerPriceOption.map */.mr.map(function(opt) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                        children: opt
                                                    }, opt);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                                containerStyle: {
                                                    marginLeft: 4,
                                                    height: 32
                                                },
                                                defaultValue: triggerPrice,
                                                value: triggerPrice,
                                                min: 0,
                                                step: 1,
                                                onChange: function(trigger) {
                                                    setTriggerPrice(trigger);
                                                    handleValidateAllFields();
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: isAutoBuy ? "Buy Price" : "Price",
                                "data-cy": isAutoBuy ? constant/* DATA_CY_MODAL_TRADING.FORM_BUY_PRICE */.eG.FORM_BUY_PRICE : constant/* DATA_CY_MODAL_TRADING.FORM_PRICE */.eG.FORM_PRICE,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    value: price,
                                    min: 0,
                                    step: (0,transactionPrice/* getStepFractionByValue */.Z)(price),
                                    onChange: handlePriceChange,
                                    disableDecimal: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Buy Order Lot",
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_LOT */.eG.FORM_LOT,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    defaultValue: 0,
                                    min: 0,
                                    value: lot,
                                    max: getMaxLot(),
                                    onChange: handleLotChange
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isOverlimit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OverLimitText, {
                                    isRight: isRight
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !hideExpiry,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Expiry",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* CustomSelect */.AP, {
                                        value: expiry,
                                        onChange: handleExpiryChange,
                                        style: {
                                            width: "160px"
                                        },
                                        disabled: isPaymentDayTradeActive,
                                        "daya-cy": constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT */.eG.EXPIRY_SELECT,
                                        children: Object.entries(constants_transactionForm/* expiryOptions */.Me).map(function(param) {
                                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: key,
                                                children: value
                                            }, key);
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: showSplitOrderForm,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_SplitOrderFormItem, {
                                    form: form,
                                    orderLot: lot,
                                    checkedInitialValue: isSplitOrderActive,
                                    quantityInitialValue: splitQuantity,
                                    minRangeInitialValue: splitRangeMin,
                                    maxRangeInitialValue: splitRangeMax,
                                    maxQuantity: maxOrder,
                                    transactionType: transaction/* TransactionType.Buy */.iU.Buy,
                                    onInfoIconClick: onShowSplitOrderInfo,
                                    onSwitchChange: handleChangeSwitchSplitOrder,
                                    onSplitMethodInfoClick: onShowSplitOrderMethodInfo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWrapper */.W4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                            disabled: disableBuy,
                            type: "primary",
                            htmlType: "submit",
                            radius: "4px",
                            block: true,
                            height: "40px",
                            "data-cy": constant/* DATA_CY_MODAL_TRADING.BUTTON_PLACE_ORDER */.eG.BUTTON_PLACE_ORDER,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormBuy_Text, {
                                children: "Place Order"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_FormBuy = (/*#__PURE__*/(0,react.memo)(FormBuy_FormBuy));

// EXTERNAL MODULE: ./src/global/Common/If.tsx
var Common_If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/types.ts
var RealTradingModal_types = __webpack_require__(20620);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
;// CONCATENATED MODULE: ./src/features/day-trade/components/SellLeverage/sell-levarage.styled.ts

function sell_levarage_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n"
    ]);
    sell_levarage_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & span.ant-radio {\n    top: 0;\n  }\n\n  & span.ant-radio-inner {\n    width: 16px;\n    height: 16px;\n  }\n\n  & span.ant-radio-inner::after {\n    top: 50%;\n    left: 50%;\n    width: 11px;\n    height: 11px;\n    transform: translate(-50%, -50%);\n  }\n"
    ]);
    sell_levarage_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    sell_levarage_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  gap: 8px;\n"
    ]);
    sell_levarage_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  border: none;\n  min-height: 30px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    sell_levarage_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: row;\n"
    ]);
    sell_levarage_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  font-size: 14px;\n  color: #333333;\n\n  p {\n    margin: 0;\n    text-wrap: nowrap;\n  }\n\n  svg {\n    color: #969696;\n  }\n"
    ]);
    sell_levarage_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function sell_levarage_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding-top: 2px;\n\n  p {\n    margin: 0;\n    font-size: 12px;\n    text-wrap: nowrap;\n    color: #858585;\n    margin-top: 1px;\n  }\n"
    ]);
    sell_levarage_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var AntGroup = es_radio/* default.Group */.ZP.Group;
var RadioGroup = (0,styled_components_browser_esm["default"])(AntGroup).withConfig({
    componentId: "sc-cbd8ca-0"
})(sell_levarage_styled_templateObject());
var Radio = (0,styled_components_browser_esm["default"])(es_radio/* default */.ZP).withConfig({
    componentId: "sc-cbd8ca-1"
})(sell_levarage_styled_templateObject1());
var sell_levarage_styled_LeverageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cbd8ca-2"
})(sell_levarage_styled_templateObject2());
var LeverageGroup = (0,styled_components_browser_esm["default"])(RadioGroup).withConfig({
    componentId: "sc-cbd8ca-3"
})(sell_levarage_styled_templateObject3());
var LeverageItem = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cbd8ca-4"
})(sell_levarage_styled_templateObject4(), function(param) {
    var isSelected = param.isSelected;
    return isSelected && "padding: 4px 8px; border: 1px solid #EDEDED;";
});
var LeverageTextContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cbd8ca-5"
})(sell_levarage_styled_templateObject5());
var LabelWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cbd8ca-6"
})(sell_levarage_styled_templateObject6());
var LabelLot = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-cbd8ca-7"
})(sell_levarage_styled_templateObject7());


;// CONCATENATED MODULE: ./src/features/day-trade/components/SellLeverage/sell-leverage.tsx






function SellLeverage(param) {
    var _dayTradeLot = param.dayTradeLot, dayTradeLot = _dayTradeLot === void 0 ? 0 : _dayTradeLot, _regularLot = param.regularLot, regularLot = _regularLot === void 0 ? 0 : _regularLot, isAmend = param.isAmend, leverage = param.leverage, handleChangeLeverage = param.handleChangeLeverage;
    var REGULAR = RealTradingModal_types/* LEVERAGE.REGULAR */.h$.REGULAR, DAY_TRADE = RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE;
    var isHidden = regularLot <= 0 || isAmend;
    var isRegularEmpty = function(value) {
        return value === REGULAR && isHidden;
    };
    var isDayTradeHidden = function(value) {
        return value === DAY_TRADE && isHidden;
    };
    var SellLeverageOptions = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                component: Icons/* LightningSvg */.Sf
            }),
            value: DAY_TRADE,
            label: "Day Trade",
            lot: dayTradeLot
        },
        {
            icon: null,
            value: REGULAR,
            label: "Regular",
            lot: regularLot
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sell_levarage_styled_LeverageWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeverageGroup, {
            value: leverage,
            children: SellLeverageOptions.map(function(param) {
                var icon = param.icon, value = param.value, label = param.label, lot = param.lot;
                if (isRegularEmpty(value)) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageItem, {
                    onClick: function() {
                        return handleChangeLeverage(value);
                    },
                    isSelected: isDayTradeHidden(value),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_If/* default */.Z, {
                            condition: !isDayTradeHidden(value),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio, {
                                value: value
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeverageTextContent, {
                            onClick: function(e) {
                                return e.stopPropagation();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LabelWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: label
                                        }),
                                        icon
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelLot, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            lot,
                                            " Lot"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }, value);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormSell.tsx







// components







// hooks


// libs



// stores



// utils








// types




// styles

var Select = ui/* Common.Select */.Gn.Select, FormSell_Text = ui/* Common.Text */.Gn.Text, FormSell_Flex = ui/* Common.Flex */.Gn.Flex;
var calculateSliderPercentage = function(lotTransaction, maxLot) {
    // Odd lot need to round down
    var lotAvailabletoSell = Math.floor(maxLot);
    var sliderValue = lotTransaction / lotAvailabletoSell;
    var percentage = !Number.isNaN(sliderValue) ? Math.round(sliderValue * 100) : 0;
    if (percentage === Infinity) return 0;
    if (percentage > 100) return 100;
    return percentage;
};
var calculateMaxLotInput = function(price, previous_sell_price, available_lot) {
    var original_available_lot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, isAmend = arguments.length > 4 ? arguments[4] : void 0;
    var isUserDoAmend = isAmend && previous_sell_price !== price;
    var maxLotToAmend = Math.floor(available_lot + original_available_lot);
    var maxLotToSell = Math.floor(original_available_lot);
    return isUserDoAmend ? maxLotToAmend : maxLotToSell;
};
var FormSell_FormSell = function(param) {
    var showSpecialMonitoringModal = param.showSpecialMonitoringModal, _onShowSplitOrderInfo = param.onShowSplitOrderInfo, onShowSplitOrderInfo = _onShowSplitOrderInfo === void 0 ? function() {} : _onShowSplitOrderInfo, _onShowSplitOrderMethodInfo = param.onShowSplitOrderMethodInfo, onShowSplitOrderMethodInfo = _onShowSplitOrderMethodInfo === void 0 ? function() {} : _onShowSplitOrderMethodInfo, onSubmit = param.onSubmit, _onShowDayTradeUnavailable = param.onShowDayTradeUnavailable, onShowDayTradeUnavailable = _onShowDayTradeUnavailable === void 0 ? function() {} : _onShowDayTradeUnavailable;
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(false), hasFormError = ref1[0], setHasFormError = ref1[1];
    var isShowSplitOrder = useEnableSplitOrder("sell");
    var ref2 = (0,tradingData/* default */.Z)(), _company = ref2.company, _data = _company.data, marketHour = _data.market_hour, productType = _data.type_company, dayTradeInfo = _data.day_trade_info, _portfolioDetailDayTrade = ref2.portfolioDetailDayTrade, detailDayTrade = _portfolioDetailDayTrade.data, getCashOnHand = ref2.getCashOnHand;
    var loadTradingInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.loadTradingInfo;
    });
    var splitOrder = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.splitOrder;
    });
    var ref3 = splitOrder || {}, maxOrder = ref3.max_order;
    var multiplier = (dayTradeInfo || {}).multiplier;
    var ref4 = (0,TradingModal_store/* default */.Z)(), orderType = ref4.orderType, orderedPrice = ref4.orderedPrice, orderedLot = ref4.orderedLot, symbol = ref4.symbol, isDayTrade = ref4.isDayTrade;
    var ref5 = (0,RealTradingModal_store/* default */.Z)(), price = ref5.price, shares = ref5.shares, expiry = ref5.expiry, sellOrderType = ref5.type, isSplitOrderActive = ref5.isSplitOrderActive, splitQuantity = ref5.splitQuantity, splitRangeMin = ref5.splitRangeMin, splitRangeMax = ref5.splitRangeMax, splitMethod = ref5.splitMethod, leverage = ref5.sellLeverage, setPrice = ref5.setPrice, setShares = ref5.setShares, setExpiry = ref5.setExpiry, setOrderType = ref5.setOrderType, setSplitOrderActive = ref5.setSplitOrderActive, setSplitQuantity = ref5.setSplitQuantity, setSplitRange = ref5.setSplitRange, setSplitMethod = ref5.setSplitMethod, setLeverage = ref5.setSellLeverage, setDayTradeActive = ref5.setDayTradeActive, setDayTadeMultiplier = ref5.setDayTadeMultiplier;
    var getPortfolioDetail = (0,useGetPortfolioData/* default */.Z)(symbol);
    var isDayTradeActive = leverage === RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE;
    var isAmend = orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isSaham = productType.toLowerCase() === trading/* STOCK_TYPE.saham */.L2.saham;
    var isRight = productType.toLowerCase() === trading/* STOCK_TYPE.right */.L2.right;
    var isCorporateAction = (0,react.useMemo)(function() {
        return trading/* CorporateActionStockType.includes */.dB.includes(productType.toLowerCase());
    }, [
        productType
    ]);
    var hideExpiry = (0,react.useMemo)(function() {
        return !isSaham || isAmend || sellOrderType !== transaction/* SellOrderType.LimitOrder */.qK.LimitOrder;
    }, [
        isSaham,
        isAmend,
        sellOrderType
    ]);
    var showOrderType = (0,react.useMemo)(function() {
        return isSaham && sellOrderType;
    }, [
        isSaham,
        sellOrderType
    ]);
    var tmp = getPortfolioDetail.available_lot, availableLot = tmp === void 0 ? 0 : tmp, tmp1 = getPortfolioDetail.price_average_fee, priceAverageFee = tmp1 === void 0 ? 0 : tmp1;
    var tmp2 = detailDayTrade.available_lot, availableLotDayTrade = tmp2 === void 0 ? 0 : tmp2, tmp3 = detailDayTrade.price_average_fee, priceAverageFeeDayTrade = tmp3 === void 0 ? 0 : tmp3;
    // Get available lot and price average fee based on user day trade or user regular
    var ref6 = (0,react.useMemo)(function() {
        var RegularSell = [
            availableLot,
            priceAverageFee
        ];
        var DayTradeSell = [
            availableLotDayTrade,
            priceAverageFeeDayTrade
        ];
        // If order is amend, return based on order type, if not return based on user day trade
        // isDayTrade is true if user click amend button from order which is day trade
        if (isAmend) {
            return isDayTrade ? DayTradeSell : RegularSell;
        }
        // If order is not amend, return based on user day trade
        var regularLotAvailable = availableLot > 0;
        var dayTradeLotAvailable = availableLotDayTrade > 0;
        // If user have both regular and day trade lot, leverage will not selected
        if (!leverage) {
            // user have both regular and day trade lot, return 0 so user have to select leverage
            if (regularLotAvailable && dayTradeLotAvailable) {
                return [
                    0,
                    0
                ];
            }
        }
        // If user have day trade lot and leverage is selected, return day trade sell
        // Else return regular sell
        return isDayTradeActive && dayTradeLotAvailable ? DayTradeSell : RegularSell;
    }, [
        availableLot,
        priceAverageFee,
        availableLotDayTrade,
        priceAverageFeeDayTrade,
        isAmend,
        isDayTrade,
        leverage,
        isDayTradeActive, 
    ]), available_lot = ref6[0], price_average_fee = ref6[1];
    // originalAvailableLot is used to calculate max lot input
    // If user is day trade and not amend, available lot is based on day trade
    var originalAvailableLot = (0,react.useMemo)(function() {
        if (!isAmend) {
            return available_lot;
        }
        return orderedLot || available_lot;
    }, [
        isAmend,
        available_lot,
        orderedLot
    ]);
    // availableLotToSell is used to show available lot to sell
    var availableLotToSell = (0,react.useMemo)(function() {
        // Check if user is day trade and not amend, return day trade available lot if available
        if (!isAmend && !leverage && availableLotDayTrade > 0) {
            return availableLot <= 0 ? availableLotDayTrade : "-";
        }
        return isAmend ? available_lot + orderedLot : available_lot;
    }, [
        availableLot,
        availableLotDayTrade,
        isAmend,
        leverage,
        available_lot,
        orderedLot, 
    ]);
    // isDayTradeSell is used to check if user is day trade and sell order is active
    // isDayTrade is true if user click amend button from order which is day trade (amend)
    // isDayTradeActive is true if user have day trade lot and leverage is selected (new order)
    var isDayTradeSell = (0,react.useMemo)(function() {
        return isAmend ? isDayTrade : isDayTradeActive;
    }, [
        isAmend,
        isDayTrade,
        isDayTradeActive
    ]);
    // isLeverageEnabled is used to show sell leverage component
    var isLeverageEnabled = (0,react.useMemo)(function() {
        // If amend regular order, return false
        if (isAmend && !isDayTrade) {
            return false;
        }
        // If order is amend and day trade, return true
        if (isAmend && isDayTrade) {
            return true;
        }
        // If user have day trade lot and leverage is not selected, return true
        return availableLotDayTrade > 0;
    }, [
        isAmend,
        isDayTrade,
        availableLotDayTrade
    ]);
    // isDisabledInput is used to disable input if have day trade lot and leverage is not selected
    var isDisabledInput = (0,react.useMemo)(function() {
        return !isAmend && !leverage && availableLotDayTrade > 0;
    }, [
        isAmend,
        leverage,
        availableLotDayTrade,
        availableLot
    ]);
    var lot = (0,react.useMemo)(function() {
        var lotOrderLimit = (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
        var userLot = typeof shares === "number" ? Math.floor(shares / constant/* lotSize */.CQ) : available_lot;
        return Math.floor(userLot > lotOrderLimit ? lotOrderLimit : userLot);
    }, [
        shares,
        constant/* lotSize */.CQ,
        available_lot
    ]);
    var isDisabledSellSplitOrder = (0,react.useMemo)(function() {
        if (!isSplitOrderActive) {
            return false;
        }
        if (splitQuantity === null || splitQuantity < 1) {
            return true;
        }
        if (splitMethod === transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM && (!splitRangeMin || !splitRangeMax)) {
            return true;
        }
        return false;
    }, [
        isSplitOrderActive,
        splitQuantity,
        splitMethod,
        splitRangeMin,
        splitRangeMax, 
    ]);
    var isSubmitDisabled = (0,react.useMemo)(function() {
        return lot < 1 || price === 0 || hasFormError || isDisabledSellSplitOrder;
    }, [
        lot,
        price,
        hasFormError,
        isSplitOrderActive,
        isDisabledSellSplitOrder
    ]);
    var showSplitOrderForm = (0,react.useMemo)(function() {
        return isShowSplitOrder && !isDayTradeActive;
    }, [
        isShowSplitOrder,
        isDayTradeActive
    ]);
    var maxLot = calculateMaxLotInput(price, orderedPrice, available_lot, originalAvailableLot, isAmend);
    var lotPercentage = calculateSliderPercentage(lot, maxLot);
    var sellAmountInvestedFee = (0,utils_formula/* getSellAmountInvestedFee */.B1)(lot, price, isCorporateAction, isDayTradeSell);
    var buyAmountInvestedAveragePriceFee = (0,utils_formula/* getBuyAmountInvested */.yq)(lot, price_average_fee);
    var sellProfitLoss = (0,utils_formula/* getProfitLoss */.fY)(sellAmountInvestedFee, buyAmountInvestedAveragePriceFee);
    var sellGain = (0,utils_formula/* getSellGain */.Sd)(sellProfitLoss, buyAmountInvestedAveragePriceFee);
    var getMaxLot = function() {
        var lotOrderLimit = (0,RealTradingModal_utils/* getLotOrderLimit */.PS)();
        return maxLot > lotOrderLimit ? lotOrderLimit : maxLot;
    };
    var handleValidateAllFields = function() {
        form.validateFields();
    };
    var handleGtcChange = function(selectedExpiry) {
        setExpiry(selectedExpiry);
        if (selectedExpiry === transaction/* Expiry.GoodForDay */.ZM.GoodForDay) {
            setSplitOrderActive(false);
            form.setFieldsValue({
                isSplitOrderActive: false
            });
        }
    };
    var handlePriceChange = function(newPrice) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        setPrice(newPrice);
        handleValidateAllFields();
    };
    var handleLotChange = function(newLot) {
        (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
            symbol: symbol,
            orderType: orderType,
            adjustedType: "add/substract"
        });
        var roundLot = Math.floor(newLot);
        setShares(roundLot * constant/* lotSize */.CQ);
        handleValidateAllFields();
    };
    var handleOrderTypeChange = function(type) {
        setOrderType(type);
    };
    var handleFieldsChange = function(_, allFields) {
        var hasEmpty = allFields.some(function(param) {
            var value = param.value;
            return value === undefined;
        });
        var hasError = allFields.some(function(param) {
            var errors = param.errors;
            return errors.length > 0;
        });
        setHasFormError(hasEmpty || hasError);
    };
    var handleSaveFields = function() {
        var values = form.getFieldsValue();
        if (isShowSplitOrder && !isDayTradeActive) {
            setSplitOrderActive(!!values.isSplitOrderActive);
            setSplitQuantity(values.splitQuantity);
            setSplitRange(values.splitRangeMin, values.splitRangeMax);
        } else {
            setSplitOrderActive(false);
            setSplitQuantity(null);
            setSplitRange(null, null);
        }
        setDayTradeActive(isDayTradeSell);
        setDayTadeMultiplier(isAmend && isDayTrade ? parseInt(multiplier, 10) : 0);
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var day_trade, isTimeLimit, isUnavailable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleSaveFields();
                        if (!isDayTradeSell) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 4;
                        return loadTradingInfo([
                            types_trading/* TradingFeatureEnum.DAY_TRADE */.n.DAY_TRADE, 
                        ]);
                    case 4:
                        day_trade = _ctx.sent.day_trade;
                        if (!day_trade) {
                            _ctx.next = 11;
                            break;
                        }
                        isTimeLimit = day_trade.remaining_trading_close <= 0;
                        isUnavailable = [
                            types_trading/* EventTypeEnum.EXCEED_DEBT_RATIO */.b.EXCEED_DEBT_RATIO,
                            types_trading/* EventTypeEnum.OUTSIDE_MARKET_HOURS */.b.OUTSIDE_MARKET_HOURS, 
                        ].includes(day_trade === null || day_trade === void 0 ? void 0 : day_trade.event_type);
                        if (!(isUnavailable || isTimeLimit)) {
                            _ctx.next = 11;
                            break;
                        }
                        onShowDayTradeUnavailable();
                        return _ctx.abrupt("return");
                    case 11:
                        onSubmit();
                        (0,securities/* clevertapOrderPlaced */.As)({
                            orderType: orderType,
                            symbol: symbol,
                            price: price,
                            lot: lot,
                            gainLoss: "".concat(sellGain, "%"),
                            totalLot: "".concat(lotPercentage, "%"),
                            status: isSubmitDisabled ? "failed" : "success",
                            expiry: constants_transactionForm/* expiryOptions */.Me[expiry],
                            type: virtualTrading/* VIRTUAL_TRADING_TYPES.realTrading */.gT.realTrading,
                            dayTrade: isDayTradeSell
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangeSwitchSplitOrder = function(checked) {
        if (!checked) {
            setSplitMethod(transaction/* SplitOrderMethodEnum.RANDOM */.PH.RANDOM);
        }
    };
    (0,react.useEffect)(function() {
        if (isRight) getCashOnHand();
        (0,securities/* clevertapSellOrderViewed */.B0)(symbol);
    }, [
        isRight
    ]);
    (0,react.useEffect)(function() {
        if (isAmend) {
            setShares(orderedLot * constant/* lotSize */.CQ);
        } else {
            setShares(Math.floor(available_lot) * constant/* lotSize */.CQ);
        }
    }, [
        isAmend,
        orderedLot,
        available_lot
    ]);
    (0,react.useEffect)(function() {
        if (!sellOrderType) setOrderType(transaction/* SellOrderType.LimitOrder */.qK.LimitOrder);
    }, [
        sellOrderType,
        setOrderType
    ]);
    (0,react.useEffect)(function() {
        if (isDayTradeActive) {
            setExpiry(transaction/* Expiry.GoodForDay */.ZM.GoodForDay);
            setSplitOrderActive(false);
            setSplitQuantity(null);
            setSplitRange(null, null);
        }
        if (!leverage) {
            if (detailDayTrade.available_lot > 0 && availableLot <= 0) {
                setLeverage(RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE);
                setDayTradeActive(true);
            }
            if (detailDayTrade.available_lot <= 0 && availableLot > 0) {
                setLeverage(RealTradingModal_types/* LEVERAGE.REGULAR */.h$.REGULAR);
                setDayTradeActive(false);
            }
        }
    }, [
        leverage
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: marketHour.suspend_info,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SpecialMonitoringBanner, {
                    onClick: showSpecialMonitoringModal,
                    title: marketHour.suspend_info
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* TransactionForm */.vQ, {
                form: form,
                colon: false,
                labelCol: {
                    span: 12
                },
                onFinish: handleSubmit,
                onFieldsChange: handleFieldsChange,
                onBlur: handleSaveFields,
                onValuesChange: handleSaveFields,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showOrderType,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_OrderTypeFormItem, {
                            form: form,
                            transactionType: transaction/* TransactionType.Sell */.iU.Sell,
                            defaultValue: sellOrderType,
                            onChange: handleOrderTypeChange,
                            hideInfoIcon: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* FieldsWrapper */.V$, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isLeverageEnabled,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                    label: "Leverage",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SellLeverage, {
                                        dayTradeLot: isAmend ? availableLotToSell : detailDayTrade.available_lot,
                                        regularLot: getPortfolioDetail.available_lot,
                                        isAmend: isAmend,
                                        leverage: leverage,
                                        handleChangeLeverage: function(value) {
                                            setLeverage(value);
                                            setDayTradeActive(value === RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE);
                                            if (value === RealTradingModal_types/* LEVERAGE.DAY_TRADE */.h$.DAY_TRADE && isSplitOrderActive) {
                                                setSplitOrderActive(false);
                                                form.setFieldsValue({
                                                    isSplitOrderActive: false
                                                });
                                            }
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Available Lot",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSell_Text, {
                                    align: "right",
                                    "data-cy": constant/* DATA_CY_MODAL_TRADING.AVAILABLE_LOT_VALUE */.eG.AVAILABLE_LOT_VALUE,
                                    children: availableLotToSell
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                className: "slider-form-item",
                                label: "Sell Order Lot",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormSell_Flex, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Slider, {
                                            min: 0,
                                            max: getMaxLot(),
                                            value: lot,
                                            tipFormatter: null,
                                            disabled: isDisabledInput,
                                            onChange: function(newLot) {
                                                (0,securities/* clevertapOrderQuantityAdjusted */.CH)({
                                                    symbol: symbol,
                                                    orderType: orderType,
                                                    adjustedType: "slider"
                                                });
                                                setShares(Math.floor(newLot) * constant/* lotSize */.CQ);
                                                handleValidateAllFields();
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* SliderPercentText */.fx, {
                                            children: [
                                                lotPercentage,
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "",
                                wrapperCol: {
                                    xs: {
                                        offset: 0
                                    },
                                    sm: {
                                        span: 12,
                                        offset: 12
                                    }
                                },
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_SELL_ORDER_LOT */.eG.FORM_SELL_ORDER_LOT,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    containerStyle: {
                                        width: 160
                                    },
                                    defaultValue: lot,
                                    value: lot,
                                    min: 0,
                                    max: getMaxLot(),
                                    step: 1,
                                    onChange: handleLotChange,
                                    disabled: isDisabledInput
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Price",
                                "data-cy": constant/* DATA_CY_MODAL_TRADING.FORM_PRICE */.eG.FORM_PRICE,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                    containerStyle: {
                                        width: 160
                                    },
                                    value: price,
                                    min: 0,
                                    step: (0,transactionPrice/* getStepFractionByValue */.Z)(price),
                                    onChange: handlePriceChange,
                                    disableDecimal: true,
                                    disabled: isDisabledInput
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Proceeds (Net Fee)",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormSell_Text, {
                                    family: "bold",
                                    align: "right",
                                    children: [
                                        "Rp",
                                        (0,number/* formatNumber */.uf)(sellAmountInvestedFee, false)
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Profit/Loss",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormSell_Text, {
                                    align: "right",
                                    color: (0,general/* getColorBasedOnNumber */.pV)(sellProfitLoss),
                                    "data-cy": constant/* DATA_CY_MODAL_TRADING.PROFIT_LOSS_VALUE */.eG.PROFIT_LOSS_VALUE,
                                    children: [
                                        (0,number/* formatNumber */.uf)(sellProfitLoss, false),
                                        " (",
                                        sellProfitLoss > 0 && "+",
                                        sellGain === Infinity || sellGain === 0 ? "0.00%" : (0,number/* formatPercentage */.rl)(sellGain, false),
                                        ")"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: !hideExpiry,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                        label: "Expiry",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select, {
                                            value: expiry,
                                            width: "100%",
                                            onChange: handleGtcChange,
                                            disabled: isDisabledInput || isDayTradeActive,
                                            "data-cy": constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT */.eG.EXPIRY_SELECT,
                                            getPopupContainer: function() {
                                                return document.getElementById(constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT_DROPDOWN */.eG.EXPIRY_SELECT_DROPDOWN);
                                            },
                                            children: Object.entries(constants_transactionForm/* expiryOptions */.Me).map(function(param) {
                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Select.Option, {
                                                    value: key,
                                                    children: value
                                                }, key);
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        id: constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT_DROPDOWN */.eG.EXPIRY_SELECT_DROPDOWN,
                                        "data-cy": constant/* DATA_CY_MODAL_TRADING.EXPIRY_SELECT_DROPDOWN */.eG.EXPIRY_SELECT_DROPDOWN
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: showSplitOrderForm,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionForm_SplitOrderFormItem, {
                                    form: form,
                                    orderLot: lot,
                                    checkedInitialValue: isSplitOrderActive,
                                    quantityInitialValue: splitQuantity,
                                    minRangeInitialValue: splitRangeMin,
                                    maxRangeInitialValue: splitRangeMax,
                                    maxQuantity: maxOrder,
                                    transactionType: transaction/* TransactionType.Sell */.iU.Sell,
                                    onInfoIconClick: onShowSplitOrderInfo,
                                    disabledToggle: isDisabledInput,
                                    onSwitchChange: handleChangeSwitchSplitOrder,
                                    onSplitMethodInfoClick: onShowSplitOrderMethodInfo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonWrapper */.W4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                            htmlType: "submit",
                            disabled: isSubmitDisabled,
                            type: "secondary",
                            radius: "4px",
                            block: true,
                            height: "40px",
                            "data-cy": constant/* DATA_CY_MODAL_TRADING.BUTTON_PLACE_ORDER */.eG.BUTTON_PLACE_ORDER,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSell_Text, {
                                children: "Place Order"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_FormSell = (/*#__PURE__*/(0,react.memo)(FormSell_FormSell));

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/FormExercise.tsx
var FormExercise = __webpack_require__(52595);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore.ts
var useBondsModalStore = __webpack_require__(81557);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/index.tsx

























var TransactionModal_Flex = ui/* Common.Flex */.Gn.Flex;
var TransactionModal_obj;
var transactionToOrderType = (TransactionModal_obj = {}, (0,_define_property/* default */.Z)(TransactionModal_obj, transaction/* TransactionType.Buy */.iU.Buy, trading/* ORDER_TYPE.BUY */.Jm.BUY), (0,_define_property/* default */.Z)(TransactionModal_obj, transaction/* TransactionType.Sell */.iU.Sell, trading/* ORDER_TYPE.SELL */.Jm.SELL), TransactionModal_obj);
function TransactionModal(param) {
    var visible = param.visible, showAutoBuyTncModal = param.showAutoBuyTncModal, showOrderTypeModal = param.showOrderTypeModal, showSpecialMonitoringModal = param.showSpecialMonitoringModal, onUpdateSymbol = param.onUpdateSymbol, _onShowTradingLimitTnc = param.onShowTradingLimitTnc, onShowTradingLimitTnc = _onShowTradingLimitTnc === void 0 ? function() {} : _onShowTradingLimitTnc, _onShowSplitOrderInfo = param.onShowSplitOrderInfo, onShowSplitOrderInfo = _onShowSplitOrderInfo === void 0 ? function() {} : _onShowSplitOrderInfo, _onShowSplitOrderMethodInfo = param.onShowSplitOrderMethodInfo, onShowSplitOrderMethodInfo = _onShowSplitOrderMethodInfo === void 0 ? function() {} : _onShowSplitOrderMethodInfo, onSubmit = param.onSubmit, closeModal = param.closeModal, _onSwitchTab = param.onSwitchTab, onSwitchTab = _onSwitchTab === void 0 ? function() {} : _onSwitchTab, portfolioData = param.portfolioData, _onShowDayTradeOnboarding = param.onShowDayTradeOnboarding, onShowDayTradeOnboarding = _onShowDayTradeOnboarding === void 0 ? function() {} : _onShowDayTradeOnboarding, _onShowDayTradeUnavailable = param.onShowDayTradeUnavailable, onShowDayTradeUnavailable = _onShowDayTradeUnavailable === void 0 ? function() {} : _onShowDayTradeUnavailable;
    var isFastOrderEnabled = (0,hooks/* useFliptBoolean */.v)(flagKeys/* FeatureFlagKeys.FAST_ORDER */.O.FAST_ORDER);
    var ref = (0,react.useState)(false), isSearchActive = ref[0], setIsSearchActive = ref[1];
    var resetCashInfo = (0,useCashInfoStore/* default */.Z)(function(s) {
        return s.resetCashInfo;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var ref1 = (0,TradingModal_store/* default */.Z)(), orderType = ref1.orderType, showOrderbook = ref1.showOrderbook, showTabs = ref1.showTabs;
    var resetOrderData = (0,RealTradingModal_store/* default */.Z)(function(s) {
        return s.resetOrderData;
    });
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var openBondsBuyModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var company = (0,tradingData/* default */.Z)(function(s) {
        return s.company.data;
    });
    var available_lot = (portfolioData === null || portfolioData === void 0 ? void 0 : portfolioData.available_lot) || 0;
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY || orderType === trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL || orderType === trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL;
    var isExercise = orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE;
    var isAmend = (0,react.useMemo)(function() {
        return [
            trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
        ].includes(orderType);
    }, [
        orderType
    ]);
    var isFormTypeSelectVisible = (0,react.useMemo)(function() {
        return isFastOrderEnabled && [
            trading/* ORDER_TYPE.BUY */.Jm.BUY,
            trading/* ORDER_TYPE.SELL */.Jm.SELL
        ].includes(orderType) && [
            stockType/* StockType.Saham */.Z.Saham,
            stockType/* StockType.Waran */.Z.Waran,
            stockType/* StockType.Right */.Z.Right,
            stockType/* StockType.Etf */.Z.Etf, 
        ].includes(company === null || company === void 0 ? void 0 : company.type_company.toLowerCase());
    }, [
        isFastOrderEnabled,
        isAmend
    ]);
    var defaultTabValue = (0,react.useMemo)(function() {
        if (available_lot <= 0 || [
            (trading/* ORDER_TYPE.BUY */.Jm.BUY, trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY)
        ].includes(orderType)) {
            return transaction/* TransactionType.Buy */.iU.Buy;
        }
        if ([
            trading/* ORDER_TYPE.SELL */.Jm.SELL,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL
        ].includes(orderType)) {
            return transaction/* TransactionType.Sell */.iU.Sell;
        }
        return transaction/* TransactionType.Buy */.iU.Buy;
    }, [
        orderType
    ]);
    var handleUpdateSymbol = function(selected, isBonds) {
        if (isBonds) {
            openBondsBuyModal(selected);
            FRBondActionTrackers.onOrderButtonClicked("Buy", selected, "Search Company Page");
            closeModal();
            return;
        }
        onUpdateSymbol(selected);
        setIsSearchActive(false);
    };
    var handleClose = function() {
        resetCashInfo();
        closeModal();
        resetOrderData();
        (0,autoOrder/* trackAutoBuyOrderCanceled */.fY)();
        setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
    };
    var handleFormTypeChange = function(value) {
        if (value === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder) handleClose();
    };
    var handleSwitchTab = function(value) {
        onSwitchTab(transactionToOrderType[value]);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TransactionModalContainer */.md, {
            width: "auto",
            "data-cy": "transaction-modal-real",
            visible: visible,
            onCancel: handleClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_Flex, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showOrderbook && !isExercise,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_TableOrderbook, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* ModalFormWrapper */.W_, {
                        children: [
                            isSearchActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FreezeLayer */.VV, {
                                onClick: function() {
                                    return setIsSearchActive(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormWrapper */.n5, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                                        orderType: orderType,
                                        defaultTabsValue: defaultTabValue,
                                        showTabs: showTabs,
                                        isSearchActive: isSearchActive,
                                        disableTabs: available_lot <= 0,
                                        setIsSearchActive: function() {
                                            return setIsSearchActive(!isSearchActive);
                                        },
                                        formTypeSelectVisible: isFormTypeSelectVisible,
                                        onUpdateSymbol: handleUpdateSymbol,
                                        onFormTypeChange: handleFormTypeChange,
                                        onTabsChange: handleSwitchTab
                                    }),
                                    isBuy && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormBuy, {
                                        showOrderTypeModal: showOrderTypeModal,
                                        showAutoBuyTncModal: showAutoBuyTncModal,
                                        showSpecialMonitoringModal: showSpecialMonitoringModal,
                                        onShowTradingLimitTnc: onShowTradingLimitTnc,
                                        onShowSplitOrderInfo: onShowSplitOrderInfo,
                                        onShowSplitOrderMethodInfo: onShowSplitOrderMethodInfo,
                                        onSubmit: onSubmit,
                                        onShowDayTradeOnboarding: onShowDayTradeOnboarding,
                                        onShowDayTradeUnavailable: onShowDayTradeUnavailable
                                    }),
                                    isSell && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_FormSell, {
                                        showSpecialMonitoringModal: showSpecialMonitoringModal,
                                        onShowSplitOrderInfo: onShowSplitOrderInfo,
                                        onShowSplitOrderMethodInfo: onShowSplitOrderMethodInfo,
                                        onSubmit: onSubmit,
                                        onShowDayTradeUnavailable: onShowDayTradeUnavailable
                                    }),
                                    isExercise && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormExercise/* default */.Z, {
                                        onSubmit: onSubmit
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var RealTradingModal_TransactionModal = (/*#__PURE__*/(0,react.memo)(TransactionModal));

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/AutoOrderTncModal.tsx
var AutoOrderTncModal = __webpack_require__(65205);
// EXTERNAL MODULE: ./src/features/securities/static/information/specialMonitoring/index.tsx + 4 modules
var specialMonitoring = __webpack_require__(13799);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/TransactionModal/SpecialMonitoringModal.tsx




var SpecialMonitoringModal_Text = ui/* Common.Text */.Gn.Text;
var SpecialMonitoringModal = function(param) {
    var visible = param.visible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransactionModal_styled/* SpecialMonitoringModalContainer */.Ck, {
        visible: visible,
        centered: true,
        onCancel: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringModal_Text, {
                size: "18px",
                align: "center",
                family: "bold",
                padding: "40px 30px 16px",
                children: "Informasi Pemantauan Khusus"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "special-monitoring__content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(specialMonitoring/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_styled/* SpecialMonitoringButton */.Jn, {
                onClick: closeModal,
                type: "primary",
                radius: "4px",
                block: true,
                height: "40px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialMonitoringModal_Text, {
                    align: "inherit",
                    color: "inherit",
                    family: "bold",
                    size: "16px",
                    children: "Oke"
                })
            })
        ]
    });
};
/* harmony default export */ var TransactionModal_SpecialMonitoringModal = (SpecialMonitoringModal);

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ShariaUnavailableModal/index.tsx
var ShariaUnavailableModal = __webpack_require__(27477);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/index.tsx















































function RealTradingModal(param) {
    var onSwitchTab = param.onSwitchTab, closeModal = param.closeModal;
    var router = (0,next_router.useRouter)();
    var isRealTrading = (0,useTradingAccount/* default */.Z)().isRealTrading;
    var ref = (0,react.useState)(null), modal = ref[0], setModal = ref[1];
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var getUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue;
    });
    var loadTradingInfo = (0,useTradingInfoStore/* useTradingInfoStore */.r)(function(s) {
        return s.loadTradingInfo;
    });
    var openBuyBonds = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openBuyModal;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTransactionFormStore/* default */.Z)(function(s) {
        return [
            s.formType,
            s.setFormType, 
        ];
    }), 2), formType = ref1[0], setFormType = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useGlobalModalStore/* default */.Z)(function(s) {
        return [
            s.activeModal,
            s.setActiveModal, 
        ];
    }), 2), activeModal = ref2[0], setActiveModal = ref2[1];
    var setFastOrderSymbol = (0,useFastOrderStore/* default */.Z)(function(s) {
        return s.setSymbol;
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,TradingModal_store/* default */.Z)(function(s) {
        return [
            s.symbol,
            s.orderType,
            s.price,
            s.orderedPrice,
            s.modalData,
            s.onClose,
            s.showModal,
            s.showTabs,
            s.showOrderbook,
            s.setModalState, 
        ];
    }, shallow/* default */.Z), 10), symbol = ref3[0], orderType = ref3[1], priceProps = ref3[2], orderedPrice = ref3[3], modalData = ref3[4], onClose = ref3[5], showTradingModal = ref3[6], showTabs = ref3[7], showOrderbook = ref3[8], setModalState = ref3[9];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,tradingData/* default */.Z)(function(s) {
        return [
            s.checkRightTradeable,
            s.getExercise,
            s.getCompany,
            s.getOrderHistory,
            s.getPortfolio,
            s.getConfigFormula,
            s.resetModalData,
            s.resetCompany, 
        ];
    }, shallow/* default */.Z), 8), checkRightTradeable = ref4[0], getExercise = ref4[1], getCompany = ref4[2], getOrderHistory = ref4[3], getPortfolio = ref4[4], getConfigFormula = ref4[5], resetModalData = ref4[6], resetCompany = ref4[7];
    var isBuy = orderType === trading/* ORDER_TYPE.BUY */.Jm.BUY;
    var isSell = orderType === trading/* ORDER_TYPE.SELL */.Jm.SELL;
    var setOrderTab = (0,OrderTable_store/* default */.Z)(function(s) {
        return s.setOrderTab;
    });
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,RealTradingModal_store/* default */.Z)(function(s) {
        return [
            s.setPrice,
            s.setStockCode,
            s.type,
            s.dayTradeActive
        ];
    }, shallow/* default */.Z), 4), setPrice = ref5[0], setStockCode = ref5[1], buyOrderType = ref5[2], dayTradeActive = ref5[3];
    var portfolioData = (0,useGetPortfolioData/* default */.Z)(symbol, true, false, dayTradeActive);
    var loadTnC = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnC;
    });
    var termsData = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.termsData;
    });
    var loadTnCAcceptance = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnCAcceptance;
    });
    var loadSubAccountStatus = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadSubAccountStatus;
    });
    var ref6 = (0,useSyariah/* default */.Z)(), isUserSyariah = ref6.isUserSyariah, checkSyariahTradeableStatus = ref6.checkSyariahTradeableStatus, hideSyariahRestrictionModal = ref6.hideSyariahRestrictionModal;
    var loadCompanyData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getCompany(symbol);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCompanyData() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadRightTradeableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return checkRightTradeable();
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data === null || data === void 0 ? void 0 : data.is_tradeable);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadRightTradeableStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadExercisableData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getExercise(symbol);
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", {
                            isExercisable: data === null || data === void 0 ? void 0 : data.is_exerciseable,
                            isExerciseTradeable: data === null || data === void 0 ? void 0 : data.is_tradeable
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadExercisableData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getTradeableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(emittenInfo) {
            var type, isRight, isWarrant, isRightTradeable, isRightTradeable1, isExerciseTradeable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        type = emittenInfo.type_company;
                        isRight = type.toLowerCase() === trading/* STOCK_TYPE.right */.L2.right;
                        isWarrant = type.toLowerCase() === trading/* STOCK_TYPE.waran */.L2.waran;
                        if (!(isRight && isSell)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 6;
                        return loadRightTradeableStatus();
                    case 6:
                        isRightTradeable = _ctx.sent;
                        return _ctx.abrupt("return", isRightTradeable);
                    case 8:
                        if (!(![
                            isRight,
                            isWarrant
                        ].includes(true) || !isBuy)) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 10:
                        if (!isRight) {
                            _ctx.next = 16;
                            break;
                        }
                        _ctx.next = 13;
                        return loadRightTradeableStatus();
                    case 13:
                        isRightTradeable1 = _ctx.sent;
                        if (isRightTradeable1) {
                            _ctx.next = 16;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 16:
                        _ctx.next = 18;
                        return loadExercisableData();
                    case 18:
                        isExerciseTradeable = _ctx.sent.isExerciseTradeable;
                        return _ctx.abrupt("return", isExerciseTradeable);
                    case 20:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTradeableStatus(emittenInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    var getTransactionStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(emittenInfo) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE)) {
                            _ctx.next = 4;
                            break;
                        }
                        _ctx.next = 3;
                        return loadExercisableData();
                    case 3:
                        return _ctx.abrupt("return", _ctx.sent.isExercisable);
                    case 4:
                        return _ctx.abrupt("return", getTradeableStatus(emittenInfo));
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTransactionStatus(emittenInfo) {
            return _ref.apply(this, arguments);
        };
    }();
    var setInitialPrice = function(emittenInfo) {
        var tradeable = emittenInfo.tradeable;
        if (tradeable) {
            setPrice(priceProps || (0,RealTradingModal_utils/* getInitialPrice */.Tx)(emittenInfo, orderType, orderedPrice));
            setStockCode(symbol);
        }
    };
    var handleResetData = function() {
        var isPreventCloseModal = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        resetCompany();
        resetModalData();
        setModal(null);
        if (!isPreventCloseModal) closeModal();
    };
    var handleSubmitOrderPlaced = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                        (0,securities/* clevertapOrderDone */.v8)({
                            orderType: orderType
                        });
                        if (buyOrderType === transaction/* BuyOrderType.AutoBuy */.dY.AutoBuy) (0,autoOrder/* trackAutoBuyOrderDone */.Rj)();
                        handleResetData();
                        if (orderType === trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE) setOrderTab("exercise");
                        if ([
                            "/securities/order/",
                            "/securities/order"
                        ].includes(router === null || router === void 0 ? void 0 : router.asPath)) {
                            getPortfolio(isRealTrading);
                            getOrderHistory(true);
                        } else router.push("/securities/order");
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitOrderPlaced() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowSplitOrderInfo = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_INFO */.fG.SPLIT_ORDER_INFO);
    };
    var handleShowSplitMethodInfo = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_METHOD_INFO */.fG.SPLIT_ORDER_METHOD_INFO);
    };
    var handleShowTradingLimitTnc = function() {
        loadTnC(termsAndCondition/* TnCFeatureIDEnum.FEATURE_TRADING_LIMIT */.hO.FEATURE_TRADING_LIMIT, /**
       * If user is not yet accepted the TnC,
       * then show the modal using the callback
       */ function() {
            setUIValue("tradingLimitTnc", false);
            setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingBalance */.XL.TradingBalance);
            setModal(RealTradingModal_types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC);
        }, /**
       * If user was accepted the TnC before,
       * then show continue their action to use the Trading limit as payment
       */ function() {
            setUIValue("tradingLimitTnc", true);
            setUIValue("transactionPaymentMethod", transaction/* PaymentMethod.TradingLimit */.XL.TradingLimit);
            setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
        });
    };
    var handleTradingLimitTncSubmit = function() {
        setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
    };
    var loadDayTradeTncStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", loadTnCAcceptance([
                            termsAndCondition/* TnCFeaturesIDEnum.TRADING_LIMIT */.el.TRADING_LIMIT,
                            termsAndCondition/* TnCFeaturesIDEnum.DAY_TRADE */.el.DAY_TRADE, 
                        ]));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadDayTradeTncStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var loadDayTradeSubAccountStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var subAccountActive;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        subAccountActive = getUIValue("dayTradeSubAccountActive");
                        if (!subAccountActive) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", subAccountActive);
                    case 3:
                        return _ctx.abrupt("return", loadSubAccountStatus(termsAndCondition/* SubAccountType.DAY_TRADE */.RD.DAY_TRADE));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadDayTradeSubAccountStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var getDayTradeTncStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var checkShown, isActive, dayTradeTncShown, dayTradeTnc, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        checkShown = _args.length > 0 && _args[0] !== void 0 ? _args[0] : true;
                        if (!isUserSyariah) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 3:
                        if (termsData) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return loadDayTradeTncStatus();
                    case 6:
                        _ctx.next = 8;
                        return loadDayTradeSubAccountStatus();
                    case 8:
                        isActive = _ctx.sent;
                        if (!isActive) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 11:
                        dayTradeTncShown = getUIValue("dayTradeTncShown");
                        if (!(dayTradeTncShown !== undefined && checkShown)) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return", dayTradeTncShown);
                    case 14:
                        dayTradeTnc = getUIValue("dayTradeTnc");
                        if (!(dayTradeTnc !== undefined)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", dayTradeTnc);
                    case 17:
                        return _ctx.abrupt("return", loadDayTradeTncStatus());
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getDayTradeTncStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOpenModalDayTrade = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isDayTradeAccepted;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getDayTradeTncStatus(false);
                    case 2:
                        isDayTradeAccepted = _ctx.sent;
                        if (!isDayTradeAccepted) {
                            setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleOpenModalDayTrade() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseModalDayTrade = function() {
        var showDayTradeOnboarding = (modalData || {}).showDayTradeOnboarding;
        if (showDayTradeOnboarding && !symbol && !orderType) {
            setModal(null);
            setModalState({
                modalData: {
                    showDayTradeOnboarding: false
                }
            });
        } else {
            setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
        }
        setUIValue("dayTradeTncShown", true);
    };
    var getShariaTradableStatus = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var isShariaTradable;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!isUserSyariah || !isBuy)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", true);
                    case 2:
                        _ctx.next = 4;
                        return checkSyariahTradeableStatus(symbol);
                    case 4:
                        isShariaTradable = _ctx.sent;
                        if (isShariaTradable) {
                            _ctx.next = 8;
                            break;
                        }
                        setModal(RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE);
                        return _ctx.abrupt("return", false);
                    case 8:
                        return _ctx.abrupt("return", true);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getShariaTradableStatus() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseModalSharia = function() {
        setModal(null);
        hideSyariahRestrictionModal();
        handleResetData();
    };
    var handlePlaceOrder = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return getShariaTradableStatus();
                    case 2:
                        if (_ctx.sent) {
                            _ctx.next = 4;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 4:
                        setModal(RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePlaceOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoadInitialData = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var isSwitchToClassic, companyData, isTransactionable;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return getShariaTradableStatus();
                case 3:
                    if (_ctx.sent) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 5:
                    if (!(!symbol || (modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget))) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 7:
                    isSwitchToClassic = [
                        trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
                        trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL,
                        trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE, 
                    ].includes(orderType);
                    if (!(formType === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder)) {
                        _ctx.next = 12;
                        break;
                    }
                    if (isSwitchToClassic) {
                        _ctx.next = 11;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 11:
                    setFormType(transactionForm/* TransactionFormType.Classic */.b.Classic);
                case 12:
                    _ctx.next = 14;
                    return getConfigFormula();
                case 14:
                    _ctx.next = 16;
                    return loadCompanyData();
                case 16:
                    companyData = _ctx.sent;
                    _ctx.next = 19;
                    return getTransactionStatus(companyData);
                case 19:
                    isTransactionable = _ctx.sent;
                    if (isTransactionable) {
                        _ctx.next = 23;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.ANNOUNCEMENT */.fG.ANNOUNCEMENT);
                    return _ctx.abrupt("return");
                case 23:
                    _ctx.next = 25;
                    return loadTradingInfo([
                        types_trading/* TradingFeatureEnum.SPLIT_ORDER */.n.SPLIT_ORDER
                    ]);
                case 25:
                    if (router.asPath.includes("portfolio")) {
                        _ctx.next = 28;
                        break;
                    }
                    _ctx.next = 28;
                    return getPortfolio(true);
                case 28:
                    setInitialPrice(companyData);
                    _ctx.next = 31;
                    return getDayTradeTncStatus();
                case 31:
                    if (_ctx.sent) {
                        _ctx.next = 34;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING);
                    return _ctx.abrupt("return");
                case 34:
                    setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    _ctx.next = 40;
                    break;
                case 37:
                    _ctx.prev = 37;
                    _ctx.t0 = _ctx["catch"](0);
                    handleResetData();
                case 40:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                37
            ]
        ]);
    })), [
        symbol
    ]);
    // Handle show modal from outside transaction
    var handleLoadRestriction = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var showShariaRestrictionBuy, showDayTradeOnboarding;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!modalData || (modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget))) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    showShariaRestrictionBuy = (modalData || {}).showShariaRestrictionBuy;
                    if (!isUserSyariah) {
                        _ctx.next = 8;
                        break;
                    }
                    if (!showShariaRestrictionBuy) {
                        _ctx.next = 7;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE);
                    return _ctx.abrupt("return");
                case 7:
                    setModalState({
                        modalData: {
                            showShariaRestrictionBuy: false
                        }
                    });
                case 8:
                    showDayTradeOnboarding = (modalData || {}).showDayTradeOnboarding;
                    if (!showDayTradeOnboarding) {
                        _ctx.next = 16;
                        break;
                    }
                    _ctx.next = 12;
                    return getDayTradeTncStatus();
                case 12:
                    if (_ctx.sent) {
                        _ctx.next = 15;
                        break;
                    }
                    setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING);
                    return _ctx.abrupt("return");
                case 15:
                    setModalState({
                        modalData: {
                            showDayTradeOnboarding: false
                        }
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        isUserSyariah,
        modalData === null || modalData === void 0 ? void 0 : modalData.showDayTradeOnboarding,
        modalData === null || modalData === void 0 ? void 0 : modalData.showShariaRestrictionBuy,
        modalData === null || modalData === void 0 ? void 0 : modalData.openFromWidget, 
    ]);
    (0,react.useEffect)(function() {
        handleLoadInitialData();
        return function() {
            handleResetData(true);
        };
    }, [
        handleLoadInitialData
    ]);
    (0,react.useEffect)(function() {
        handleLoadRestriction();
    }, [
        handleLoadRestriction
    ]);
    // Redirect to Fast Order modal and closing classic modal
    // This due to too many tradingModalStore.showModal reference to be refactored
    (0,react.useEffect)(function() {
        var isSwitchToClassic = [
            trading/* ORDER_TYPE.AMEND_BUY */.Jm.AMEND_BUY,
            trading/* ORDER_TYPE.AMEND_SELL */.Jm.AMEND_SELL,
            trading/* ORDER_TYPE.EXERCISE */.Jm.EXERCISE, 
        ].includes(orderType);
        var isFastOrder = formType === transactionForm/* TransactionFormType.FastOrder */.b.FastOrder && activeModal !== types/* GlobalModalType.FastOrder */.C.FastOrder;
        var isShouldOpenFastOrder = symbol && isFastOrder && !isSwitchToClassic;
        if (isShouldOpenFastOrder) {
            setFastOrderSymbol(symbol);
            setActiveModal(types/* GlobalModalType.FastOrder */.C.FastOrder, {
                switchFormConfig: {
                    orderType: orderType,
                    showTabs: showTabs,
                    showOrderbook: showOrderbook
                }
            });
            handleResetData();
            return;
        }
        // Switch back to classic form if condition to open fast order not met
        setFormType(transactionForm/* TransactionFormType.Classic */.b.Classic);
    }, [
        symbol,
        formType,
        orderType,
        showTabs
    ]);
    var getTransactionModalVisible = (0,react.useCallback)(function(value) {
        return modal === RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION && formType === value;
    }, [
        formType,
        modal
    ]);
    var isClassicFormVisible = (0,react.useMemo)(function() {
        return getTransactionModalVisible(transactionForm/* TransactionFormType.Classic */.b.Classic);
    }, [
        getTransactionModalVisible
    ]);
    if (!modal) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.ANNOUNCEMENT */.fG.ANNOUNCEMENT,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementModal/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.ANNOUNCEMENT */.fG.ANNOUNCEMENT,
                    orderType: orderType,
                    closeModal: handleResetData,
                    onSubmit: onClose,
                    showTransactionModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isClassicFormVisible,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_TransactionModal, {
                    visible: isClassicFormVisible,
                    showAutoBuyTncModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC);
                    },
                    showOrderTypeModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.ORDER_TYPE */.fG.ORDER_TYPE);
                    },
                    showSpecialMonitoringModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING);
                    },
                    onUpdateSymbol: function(newSymbol, isBonds) {
                        if (isBonds) {
                            openBuyBonds(newSymbol);
                            FRBondActionTrackers.onOrderButtonClicked("Buy", newSymbol, "Search Company Page");
                            onClose();
                            return;
                        }
                        showTradingModal({
                            symbol: newSymbol,
                            orderType: orderType,
                            modalData: {
                                openFromSearch: true
                            }
                        });
                    },
                    onShowTradingLimitTnc: handleShowTradingLimitTnc,
                    onShowSplitOrderInfo: handleShowSplitOrderInfo,
                    onShowSplitOrderMethodInfo: handleShowSplitMethodInfo,
                    onSubmit: handlePlaceOrder,
                    closeModal: handleResetData,
                    onSwitchTab: onSwitchTab,
                    portfolioData: portfolioData,
                    onShowDayTradeOnboarding: handleOpenModalDayTrade,
                    onShowDayTradeUnavailable: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_TYPE */.fG.ORDER_TYPE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_OrderTypeModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_TYPE */.fG.ORDER_TYPE,
                    closeModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionModal_SpecialMonitoringModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SPECIAL_MONITORING */.fG.SPECIAL_MONITORING,
                    closeModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewOrderModal/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW,
                    showExchangeFee: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.EXCHANGE_FEE */.fG.EXCHANGE_FEE);
                    },
                    onCancel: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    },
                    onSubmit: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED);
                    },
                    portfolioData: portfolioData
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.EXCHANGE_FEE */.fG.EXCHANGE_FEE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExchangeFeeModal/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.EXCHANGE_FEE */.fG.EXCHANGE_FEE,
                    closeModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.PREVIEW */.fG.PREVIEW);
                    },
                    orderType: orderType
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPlacedModal/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.ORDER_PLACED */.fG.ORDER_PLACED,
                    onSubmit: handleSubmitOrderPlaced,
                    orderType: orderType
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoOrderTncModal/* default */.Z, {
                    autoOrderType: types_autoOrder/* AutoOrderProduct.AutoBuy */.V.AutoBuy,
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.AUTOBUY_TNC */.fG.AUTOBUY_TNC,
                    closeModal: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_TradingLimitTncModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.TRADING_LIMIT_TNC */.fG.TRADING_LIMIT_TNC,
                    onCancel: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    },
                    onSubmit: handleTradingLimitTncSubmit
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_INFO */.fG.SPLIT_ORDER_INFO,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_SplitOrderInfoModal, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_INFO */.fG.SPLIT_ORDER_INFO,
                    onCancel: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeOnboarding */.B7, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_ONBOARDING */.fG.DAY_TRADE_ONBOARDING,
                    maskClosable: false,
                    onCancel: handleCloseModalDayTrade,
                    onSubmit: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeTnc */.md, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_TNC */.fG.DAY_TRADE_TNC,
                    maskClosable: false,
                    onCancel: handleCloseModalDayTrade,
                    onSubmit: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_CONFIRMATION */.fG.DAY_TRADE_CONFIRMATION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_CONFIRMATION */.fG.DAY_TRADE_CONFIRMATION,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeConfirmation */.S$, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_CONFIRMATION */.fG.DAY_TRADE_CONFIRMATION,
                    maskClosable: false,
                    onCancel: handleCloseModalDayTrade,
                    onSubmit: handleCloseModalDayTrade
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* DayTradeUnavailable */.TI, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.DAY_TRADE_UNAVAILABLE */.fG.DAY_TRADE_UNAVAILABLE,
                    onCancel: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    },
                    onSubmit: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_METHOD_INFO */.fG.SPLIT_ORDER_METHOD_INFO,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_SplitOrderInfoModal, {
                    title: "Split Method",
                    description: "",
                    info: SPLIT_ORDER_MODAL_CONTENT.SPLIT_METHOD,
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SPLIT_ORDER_METHOD_INFO */.fG.SPLIT_ORDER_METHOD_INFO,
                    onCancel: function() {
                        return setModal(RealTradingModal_types/* MODAL_TYPE.TRANSACTION */.fG.TRANSACTION);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: modal === RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShariaUnavailableModal/* default */.Z, {
                    visible: modal === RealTradingModal_types/* MODAL_TYPE.SHARIA_UNAVAILABLE */.fG.SHARIA_UNAVAILABLE,
                    onClose: handleCloseModalSharia
                })
            })
        ]
    });
}
/* harmony default export */ var TradingModal_RealTradingModal = (RealTradingModal);

;// CONCATENATED MODULE: ./src/global/TradingModal/index.tsx







var TradingModal = function() {
    var ref = (0,useTradingAccount/* default */.Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading, tradingType = ref.tradingType;
    var ref1 = (0,TradingModal_store/* default */.Z)(), visible = ref1.visible, resetModal = ref1.resetModal, setOrderType = ref1.setOrderType;
    var resetModalData = (0,tradingData/* default */.Z)(function(s) {
        return s.resetModalData;
    });
    var closeModal = function() {
        resetModal();
        resetModalData();
    };
    var onSwitchTab = function(type) {
        setOrderType(type);
    };
    if (!tradingType) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
        condition: visible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isVirtualTrading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualTradingModal, {
                    closeModal: closeModal,
                    onSwitchTab: onSwitchTab
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isRealTrading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingModal_RealTradingModal, {
                    closeModal: closeModal,
                    onSwitchTab: onSwitchTab
                })
            })
        ]
    });
};
/* harmony default export */ var global_TradingModal = (TradingModal);


/***/ }),

/***/ 76805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ FeeItem; },
/* harmony export */   "Ae": function() { return /* binding */ ShareTradeButton; },
/* harmony export */   "QX": function() { return /* binding */ ModalTabText; },
/* harmony export */   "Qi": function() { return /* binding */ InvestmentWrapper; },
/* harmony export */   "Rn": function() { return /* binding */ InputNumber; },
/* harmony export */   "VA": function() { return /* binding */ PreviewContainer; },
/* harmony export */   "VV": function() { return /* binding */ FreezeLayer; },
/* harmony export */   "W4": function() { return /* binding */ ButtonWrapper; },
/* harmony export */   "W_": function() { return /* binding */ ModalFormWrapper; },
/* harmony export */   "Yc": function() { return /* binding */ OrderPlacedConfirmWrapper; },
/* harmony export */   "__": function() { return /* binding */ PreviewModalContainer; },
/* harmony export */   "a7": function() { return /* binding */ ModalTab; },
/* harmony export */   "iV": function() { return /* binding */ SwitchWrapper; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; },
/* harmony export */   "md": function() { return /* binding */ TransactionModalContainer; },
/* harmony export */   "n5": function() { return /* binding */ FormWrapper; },
/* harmony export */   "ph": function() { return /* binding */ FormHeader; },
/* harmony export */   "s8": function() { return /* binding */ PreviewItem; },
/* harmony export */   "sg": function() { return /* binding */ OrderButton; },
/* harmony export */   "ww": function() { return /* binding */ PreviewItemRow; },
/* harmony export */   "yH": function() { return /* binding */ InvestmentDetail; }
/* harmony export */ });
/* unused harmony exports FormItemWrapper, Tag, Slider */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62974);
/* eslint-disable indent */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 500px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  .ant-modal-close {\n    top: 8px;\n  }\n\n  .ant-modal-close-icon {\n    svg {\n      width: 14px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-self: stretch;\n  align-items: center;\n  border-radius: 2px;\n  background: ",
        ";\n  color: ",
        ";\n  padding: 0 8px;\n  font-weight: bold;\n  min-height: 25px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 20px;\n  background: ",
        ";\n  border-radius: 4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n\n  .ant-input-number-input {\n    padding: 0px !important;\n  }\n\n  .ant-input-number-handler-wrap {\n    width: 0px !important;\n  }\n\n  .ant-input-number-handler-up {\n    border-left: 1px solid ",
        ";\n    left: ",
        ";\n  }\n\n  .ant-input-number-handler-down {\n    border-right: 1px solid ",
        ";\n    left: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px 0;\n\n  & > div {\n    padding: 6px 20px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  transition: all 0.3s ease;\n  &:hover {\n    cursor: pointer;\n    background: #f5f6f7;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div {\n    border-color: #f2f1fe;\n    background-color: #f2f1fe;\n    color: #8277f8;\n    padding: 2px 6px;\n    margin-right: 2px;\n    display: flex;\n    gap: 2px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 6px 12px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  gap: 4px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #f5f6f7;\n  &:hover {\n    cursor: pointer;\n    background: #f5f6f7;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 40%;\n  text-align: right;\n  padding-right: 30px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-track {\n    background-color: ",
        " !important;\n    height: 3px;\n    top: 5px;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 100%;\n  background: ",
        "80;\n  height: 92%;\n  z-index: 100;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  width: 100%;\n  transform: translateY(100%);\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n  cursor: pointer;\n  margin: ",
        " -20px -10px;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 4px;\n  height: 44px;\n\n  background: ",
        ";\n  color: ",
        ";\n  border-color: ",
        ";\n\n  &.ant-btn-secondary {\n    background-color: ",
        ";\n    border-color: ",
        ";\n  }\n\n  & p {\n    font-size: 14px;\n    font-weight: bold;\n    line-height: 19px;\n    color: inherit;\n    text-align: inherit;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  height: 51px;\n  width: 50%;\n  border-radius: 3px 3px 0 0;\n  background: ",
        ";\n  border-bottom: ",
        ";\n\n  :first-child {\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #00ab6b;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: #00ab6b;\n  }\n\n  & .anticon {\n    width: 20px;\n    height: 20px;\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -16px;\n  transform: translateY(100%);\n\n  & > button {\n    margin 0 8px;\n\n    :first-child { \n      margin-left: 0;\n    }\n\n    :last-child { \n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}



var Modal = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Modal */ .Gn.Modal, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button;
var BaseSlider = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Trading.Slider */ .BN.Slider, BaseInputNumber = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Trading.InputNumber */ .BN.InputNumber;
var ModalFormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-91a7a2dc-0"
})(_templateObject());
var PreviewModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Modal).withConfig({
    componentId: "sc-91a7a2dc-1"
})(_templateObject1());
var TransactionModalContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Modal).attrs({
    width: "auto",
    type: "transparent",
    centered: true
}).withConfig({
    componentId: "sc-91a7a2dc-2"
})(_templateObject2());
var FormHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-91a7a2dc-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var FormItemWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-91a7a2dc-4"
})(_templateObject4());
var Tag = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-91a7a2dc-5"
})(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.nightRider */ .$_.nightRider, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var FormWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-91a7a2dc-6"
})(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseInputNumber).attrs({
    formatter: function(value) {
        return (0,utils_number__WEBPACK_IMPORTED_MODULE_2__/* .formatNumber */ .uf)(value.replace(/\D/g, ""), false);
    },
    parser: function(value) {
        return value.replace(/[, ]+/g, "").trim();
    }
}).withConfig({
    componentId: "sc-91a7a2dc-7"
})(_templateObject7(), function(props) {
    if (props.isForTriggerPrice) return "63px !important";
    return "100px !important";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var isForTriggerPrice = param.isForTriggerPrice;
    if (isForTriggerPrice) return "-1px !important";
    return "0px !important";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(param) {
    var isForTriggerPrice = param.isForTriggerPrice;
    if (isForTriggerPrice) return "-91px !important";
    return "-130px !important";
});
var PreviewContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-91a7a2dc-8"
})(_templateObject8());
var PreviewItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    width: "100%",
    justify: "space-between",
    align: "center",
    py: "3px"
}).withConfig({
    componentId: "sc-91a7a2dc-9"
})(_templateObject9());
var PreviewItemRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    justify: "center",
    align: "center",
    gap: "4px"
}).withConfig({
    componentId: "sc-91a7a2dc-10"
})(_templateObject10());
var InvestmentWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    width: "100%",
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-91a7a2dc-11"
})(_templateObject11());
var InvestmentDetail = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    direction: "column",
    width: "100%"
}).withConfig({
    componentId: "sc-91a7a2dc-12"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var FeeItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    width: "100%",
    align: "center",
    justify: "space-between",
    py: "2px"
}).withConfig({
    componentId: "sc-91a7a2dc-13"
})(_templateObject13());
var FormLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.attrs({
    align: "right",
    pr: "30px"
}).withConfig({
    componentId: "sc-91a7a2dc-14"
})(_templateObject14());
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(BaseSlider).withConfig({
    componentId: "sc-91a7a2dc-15"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetorange */ .$_.sunsetorange);
var FreezeLayer = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-91a7a2dc-16"
})(_templateObject16(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var ButtonWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.withConfig({
    componentId: "sc-91a7a2dc-17"
})(_templateObject17());
var SwitchWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).attrs({
    align: "center",
    justify: "center",
    height: "40px"
}).withConfig({
    componentId: "sc-91a7a2dc-18"
})(_templateObject18(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, function(props) {
    return props.isOverlimit ? "50px" : "25px";
});
var OrderButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-91a7a2dc-19"
})(_templateObject19(), function(param) {
    var disabled = param.disabled;
    if (disabled) return "#616161 !important";
    return _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary;
}, function(param) {
    var disabled = param.disabled;
    if (disabled) return "".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lowgray */ .$_.lowgray, "!important");
    return _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light;
}, function(param) {
    var disabled = param.disabled;
    if (disabled) return "#616161 !important";
    return _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary;
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange);
var ModalTab = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].div.attrs(function(props) {
    return {
        isActive: props.isActive
    };
}).withConfig({
    componentId: "sc-91a7a2dc-20"
})(_templateObject20(), function(param) {
    var isActive = param.isActive;
    return isActive ? _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light : _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.component */ .$_.component;
}, function(param) {
    var isActive = param.isActive;
    return !isActive && "1px solid ".concat(_stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ModalTabText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Text).attrs({
    family: "bold",
    size: "24px",
    height: "50px",
    align: "center"
}).withConfig({
    componentId: "sc-91a7a2dc-21"
})(_templateObject21());
var ShareTradeButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Button).withConfig({
    componentId: "sc-91a7a2dc-22"
})(_templateObject22());
var OrderPlacedConfirmWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__["default"])(Flex).withConfig({
    componentId: "sc-91a7a2dc-23"
})(_templateObject23());



/***/ }),

/***/ 54202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ generateBuyFeeData; },
/* harmony export */   "z": function() { return /* binding */ generateSellData; }
/* harmony export */ });
/* harmony import */ var _constant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29097);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-eval */ 
var generateBuyFeeData = function(configFormula, lot, price) {
    var isDayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var formula = configFormula.formula, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
    var previewFee = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee;
    // don't delete these variables! needed for eval below.
    var LOT = lot;
    var PRICE = price;
    var FEE_BUY = isDayTrade ? formula.fee_buy_day_trade : formula.fee_buy;
    var BROKER_FEE = previewFee.broker_fee;
    var EXCHANGE_FEE_TOTAL_BUY = previewFee.exchange.exchange_fee_total_buy;
    var investment = eval(formula.buy_amount_invested); // nosemgrep
    var investmentPlusFee = eval(formula.buy_amount_invested_fee); // nosemgrep
    var brokerFee = eval(formula.buy_amount_broker_fee); // nosemgrep
    var exchangeFee = eval(formula.buy_amount_exchange_fee); // nosemgrep
    return {
        investment: investment,
        investmentPlusFee: investmentPlusFee,
        brokerFee: brokerFee,
        exchangeFee: exchangeFee
    };
};
var generateSellData = function(configFormula, lot, price, averagePrice) {
    var isDayTrade = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var formula = configFormula.formula, preview_fee = configFormula.preview_fee, day_trade = configFormula.day_trade;
    var previewFee = isDayTrade ? day_trade === null || day_trade === void 0 ? void 0 : day_trade.preview_fee : preview_fee;
    var LOT = lot;
    var PRICE = price;
    var FEE_BUY = isDayTrade ? formula.fee_buy_day_trade : formula.fee_buy;
    var FEE_SELL = isDayTrade ? formula.fee_sell_day_trade : formula.fee_sell;
    var exchangeFee = previewFee.exchange.compositions.reduce(function(total, param) {
        var value = param.value;
        return total + value;
    }, 0);
    var TOTAL_EXCHANGE_FEE = LOT * PRICE * exchangeFee;
    var SELL_AMOUNT_INVESTED_FEE = eval(formula.sell_amount_invested_fee);
    var BUY_AMOUNT_INVESTED_AVERAGE_PRICE_FEE = averagePrice * lot * _constant__WEBPACK_IMPORTED_MODULE_0__/* .lotSize */ .CQ;
    var BROKER_FEE = previewFee.broker_fee;
    var EXCHANGE_FEE_TOTAL_BUY = previewFee.exchange.exchange_fee_total_buy;
    var EXCHANGE_FEE_TOTAL_SELL = previewFee.exchange.exchange_fee_total_sell;
    var SELL_FEE = eval(formula.ca_sell_amount_fee);
    var SELL_AMOUNT = eval(formula.ca_sell_amount_invested);
    var STOCKBIT_FEE = eval(formula.ca_sell_amount_broker_fee);
    var EXCHANGE_FEE = eval(formula.ca_sell_amount_exchange_fee);
    var CA_SELL_AMOUNT_INVESTED_FEE = eval(formula.ca_sell_amount_invested_fee);
    var SELL_PROFITLOSS = eval(formula.sell_profit_loss);
    var SELL_GAIN = eval(formula.sell_gain) * _constant__WEBPACK_IMPORTED_MODULE_0__/* .lotSize */ .CQ;
    return {
        SELL_FEE: SELL_FEE,
        SELL_AMOUNT: SELL_AMOUNT,
        STOCKBIT_FEE: STOCKBIT_FEE,
        TOTAL_EXCHANGE_FEE: TOTAL_EXCHANGE_FEE,
        CA_SELL_AMOUNT_INVESTED_FEE: CA_SELL_AMOUNT_INVESTED_FEE,
        SELL_PROFITLOSS: SELL_PROFITLOSS,
        SELL_GAIN: SELL_GAIN
    };
};


/***/ }),

/***/ 97103:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var generateStepPrice = function(price) {
    var newStep = 1;
    if (price > 200 && price <= 500) {
        newStep = 2;
    } else if (price > 500 && price <= 2000) {
        newStep = 5;
    } else if (price > 2000 && price <= 5000) {
        newStep = 10;
    } else if (price > 5000) {
        newStep = 25;
    }
    return newStep;
};
/* harmony default export */ __webpack_exports__["Z"] = (generateStepPrice);


/***/ }),

/***/ 86408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ getFormula; },
  "u": function() { return /* binding */ postCancel; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/config.ts
var configEndpoint = {
    formula: "/virtualtrading/config/formula",
    cancel: "/virtualtrading/cancel"
};
/* harmony default export */ var config = (configEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/config.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getFormula = function() {
    return defaultInstance.get(config.formula);
};
var postCancel = function(requestBody) {
    return defaultInstance.post(config.cancel, requestBody);
};


/***/ }),

/***/ 79397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cf": function() { return /* binding */ getVirtualOrderList; },
  "__": function() { return /* binding */ postVirtualAmendOrder; },
  "$C": function() { return /* binding */ postVirtualOrder; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/order.ts
var orderEndpoints = {
    list: function() {
        return "/virtualtrading/order";
    },
    create: function(type, symbol) {
        return "/virtualtrading/".concat(type, "/").concat(symbol);
    },
    amend: function() {
        return "/virtualtrading/amend";
    }
};
/* harmony default export */ var order = (orderEndpoints);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/order.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getVirtualOrderList = function() {
    return defaultInstance.get(order.list());
};
var postVirtualOrder = function(orderType, symbol, payload) {
    return defaultInstance.post(order.create(orderType, symbol), payload);
};
var postVirtualAmendOrder = function(payload) {
    return defaultInstance.post(order.amend(), payload);
};


/***/ }),

/***/ 80943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ getPortfolioDetail; },
  "g": function() { return /* binding */ getPortfolioList; }
});

// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/constants/apiEndpoints/portfolio.ts
var portfolioEndpoint = {
    detail: function(symbol) {
        return "/virtualtrading/portfolio/".concat(symbol);
    },
    list: function() {
        return "/virtualtrading/portfolio";
    }
};
/* harmony default export */ var portfolio = (portfolioEndpoint);

;// CONCATENATED MODULE: ./src/global/VirtualTrading/api/portfolio.ts


var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var getPortfolioDetail = function(symbol) {
    return defaultInstance.get(portfolio.detail(symbol));
};
var getPortfolioList = function() {
    return defaultInstance.get(portfolio.list());
};


/***/ }),

/***/ 62544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export useFormulaStore */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _api_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86408);







var initialState = {
    formula: {}
};
var useFormulaStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadFormula: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, axiosData, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,_api_config__WEBPACK_IMPORTED_MODULE_1__/* .getFormula */ .p)();
                    case 3:
                        ref = _ctx.sent;
                        axiosData = ref.data;
                        data = axiosData.data;
                        set({
                            formula: data
                        });
                        return _ctx.abrupt("return", data);
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }))
    });
}, {
    name: "virtualFormula"
}));
/* harmony default export */ __webpack_exports__["Z"] = (useFormulaStore);


/***/ }),

/***/ 72965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useVirtualOrderStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var _api_order__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79397);




var useVirtualOrderStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return {
        isLoading: false,
        message: "",
        data: [],
        error: "",
        createVirtualOrder: function createVirtualOrder(orderType, symbol, form) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isLoading, response, data, orderIds;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isLoading = get().isLoading;
                            if (!isLoading) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_1__/* .postVirtualOrder */ .$C)(orderType, symbol, form);
                        case 7:
                            response = _ctx.sent;
                            data = response.data.data;
                            orderIds = "order_id" in data ? [
                                data.order_id
                            ] : data.order_ids;
                            set({
                                isLoading: false,
                                data: orderIds
                            });
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        },
        createVirtualAmendOrder: function createVirtualAmendOrder(form) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var isLoading, response, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            isLoading = get().isLoading;
                            if (!isLoading) {
                                _ctx.next = 4;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 4:
                            set({
                                isLoading: true
                            });
                            _ctx.next = 7;
                            return (0,_api_order__WEBPACK_IMPORTED_MODULE_1__/* .postVirtualAmendOrder */ .__)(form);
                        case 7:
                            response = _ctx.sent;
                            data = response.data.data;
                            set({
                                isLoading: false,
                                data: [
                                    data.order_id
                                ]
                            });
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }))();
        }
    };
});


/***/ }),

/***/ 41150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FZ": function() { return /* binding */ getSellProfitLoss; },
/* harmony export */   "K1": function() { return /* binding */ getSellLot; },
/* harmony export */   "Sd": function() { return /* binding */ getSellGain; },
/* harmony export */   "V$": function() { return /* binding */ getBuyLot; }
/* harmony export */ });
/* unused harmony export getFormula */
/* harmony import */ var _stores_useFormulaStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62544);
/* eslint-disable no-new-func */ 
var getFormula = function() {
    return _stores_useFormulaStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().formula;
};
var getBuyLot = function(lot, price) {
    var buy = getFormula().buy;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(buy === null || buy === void 0 ? void 0 : buy.lot))();
};
var getSellLot = function(lot, price) {
    var sell = getFormula().sell;
    return new Function("LOT=".concat(lot, ",PRICE=").concat(price), "return ".concat(sell === null || sell === void 0 ? void 0 : sell.lot))();
};
var getSellProfitLoss = function(lot, price, buyAmount) {
    var sell = getFormula().sell;
    return Function("LOT=".concat(lot, ",PRICE=").concat(price, ",BUYAMOUNT=").concat(buyAmount), "return ".concat(sell === null || sell === void 0 ? void 0 : sell.profit_loss))();
};
var getSellGain = function(sellProfitLoss, buyAmount) {
    var sell = getFormula().sell;
    return Function("SELL_PROFITLOSS=".concat(sellProfitLoss, ",BUYAMOUNT=").concat(buyAmount), "return ".concat(sell === null || sell === void 0 ? void 0 : sell.gain))();
};


/***/ }),

/***/ 64030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAsync; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useAsyncFn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86110);



function useAsync(fn) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_useAsyncFn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn, deps, {
        loading: true
    }), 2), state = ref[0], callback = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        callback();
    }, [
        callback
    ]);
    return state;
};


/***/ }),

/***/ 86110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAsyncFn; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useMountedState.ts

function useMountedState() {
    var mountedRef = (0,react.useRef)(false);
    var get = (0,react.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0,react.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
};

;// CONCATENATED MODULE: ./src/hooks/useAsyncFn.ts





function useAsyncFn(fn) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], initialState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        loading: false
    }, throwErr = arguments.length > 3 ? arguments[3] : void 0;
    var lastCallId = (0,react.useRef)(0);
    var isMounted = useMountedState();
    var ref = (0,react.useState)(initialState), state = ref[0], set = ref[1];
    var callback = (0,react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var callId = lastCallId.current + 1;
        lastCallId.current = callId;
        if (!state.loading) {
            set(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    loading: true
                });
            });
        }
        return fn.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)).then(function(value) {
            if (isMounted() && callId === lastCallId.current) {
                set({
                    value: value,
                    loading: false
                });
            }
            return value;
        }, function(error) {
            if (isMounted() && callId === lastCallId.current) {
                set({
                    error: error,
                    loading: false
                });
            }
            if (throwErr) {
                throw error;
            } else {
                return error;
            }
        });
    }, deps);
    return [
        state,
        callback
    ];
};


/***/ }),

/***/ 1014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useClickOutside; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useClickOutside(callback) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleClickOutside = function(event) {
            var ref1;
            if (ref.current && !((ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.contains(event.target)) && callback) {
                callback();
            }
        };
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        callback
    ]);
    return {
        ref: ref
    };
};


/***/ }),

/***/ 85557:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var useDownloadDesktopApp = function() {
    var getUrl = function(os) {
        var path = os === "macos" ? "macos/Stockbit.dmg" : "windows/Stockbit.zip";
        var url = "".concat("https://sda-release.stockbit.com", "/release/").concat(path);
        return url;
    };
    var download = function(os) {
        return window.open(getUrl(os), "_blank");
    };
    return {
        download: download,
        getUrl: getUrl
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDownloadDesktopApp);


/***/ }),

/***/ 47002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36902);
/* harmony import */ var _useTradingAccount__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64999);



var useGetPortfolioData = function(symbol) {
    var refetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, fromAll = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, dayTrade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var ref = (0,_useTradingAccount__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(), isRealTrading = ref.isRealTrading, isVirtualTrading = ref.isVirtualTrading;
    var ref1 = (0,lib_stores_tradingData__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), _portfolio = ref1.portfolio, _data = _portfolio.data, realList = _data.result, _portfolioDetail = ref1.portfolioDetail, detail = _portfolioDetail.data, _portfolioDetailDayTrade = ref1.portfolioDetailDayTrade, detailDayTrade = _portfolioDetailDayTrade.data, getPortfolio = ref1.getPortfolio, getPortfolioDetail = ref1.getPortfolioDetail;
    var data = null;
    if (symbol) {
        if (isRealTrading && symbol) {
            if (fromAll) {
                data = realList.find(function(l) {
                    return l.symbol === symbol;
                });
            } else {
                data = dayTrade ? detailDayTrade : detail;
            }
        } else if (isVirtualTrading) {
            data = realList.find(function(l) {
                return l.symbol === symbol;
            });
        }
    } else {
        data = realList;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (refetch) {
            if (isRealTrading && !symbol) getPortfolio(true);
            else if (isRealTrading && symbol) {
                getPortfolioDetail(symbol);
            }
            if (isVirtualTrading) getPortfolio(false);
        }
    }, [
        symbol,
        refetch
    ]);
    return data || {};
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetPortfolioData);


/***/ }),

/***/ 91364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2497);
/* harmony import */ var global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23985);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77667);
/* harmony import */ var lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89790);





var PRICE_ALERT_KEY = "price-alert";
function useNotificationListener() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var unread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.unread;
    });
    var setUnread = (0,lib_entities_notification_useNotificationData__WEBPACK_IMPORTED_MODULE_4__/* .useNotificationData */ .z)(function(store) {
        return store.setUnread;
    });
    var notification = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* .notifWsSelector */ .i9);
    var notificationListener = function() {
        var notif = notification[notification.length - 1];
        // Update unread notification
        setUnread(unread + 1);
        var onClose = function() {
            return dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.resetNotification */ .ZP.actions.resetNotification());
        };
        // Show notification on left bottom side
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        (0,global_Notification__WEBPACK_IMPORTED_MODULE_3__/* .showGeneralNotification */ .uw)(notif, onClose);
    };
    var getPriceAlertFromLocalStorage = function() {
        var alertRaw = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(PRICE_ALERT_KEY);
        if (alertRaw) {
            try {
                return JSON.parse(alertRaw);
            } catch (e) {
                return false;
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (notification.length > 0) {
            notificationListener();
        }
    }, [
        notification
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var alert = getPriceAlertFromLocalStorage();
        if (alert) {
            dispatch(global_WebSocket_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setAlert */ .ZP.actions.setAlert(alert));
        }
    }, []);
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (useNotificationListener);


/***/ }),

/***/ 30995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14229);




function useProfileData() {
    // get data from reducer
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    // get data from profile
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .selectors */ .wl), dataProfile = ref.data;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // check if profile data is available
        var parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getToken */ .Z.getToken();
        if (parsedCookie) {
            var token = parsedCookie.accessToken.token;
            // check if there's token but empty data profile
            if (token && !dataProfile.id) {
                var userAccess = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess();
                // @ts-ignore
                var username = userAccess.username;
                // get user data profile
                // @ts-ignore
                dispatch(lib_entities_profile__WEBPACK_IMPORTED_MODULE_2__/* .effects.getUserProfile */ .Sz.getUserProfile(username));
            }
        }
    }, [
        dispatch,
        dataProfile
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useProfileData);


/***/ }),

/***/ 66959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ trackAutoBuyOrderReceivedView; },
/* harmony export */   "FY": function() { return /* binding */ trackAutoBuyOrderConfirmed; },
/* harmony export */   "Fs": function() { return /* binding */ trackAutoBuyDetailView; },
/* harmony export */   "GK": function() { return /* binding */ trackAutoSellAlterOrderView; },
/* harmony export */   "HJ": function() { return /* binding */ trackAutoSellAlterOrderSelected; },
/* harmony export */   "Jl": function() { return /* binding */ trackAutoSellOrderTypeSelected; },
/* harmony export */   "K": function() { return /* binding */ trackAutoSellOrderCanceled; },
/* harmony export */   "PH": function() { return /* binding */ trackAutoBuyOrderView; },
/* harmony export */   "Pz": function() { return /* binding */ trackAutoSellOrderDeleted; },
/* harmony export */   "RI": function() { return /* binding */ trackAutoSellOrderConfirmed; },
/* harmony export */   "Rj": function() { return /* binding */ trackAutoBuyOrderDone; },
/* harmony export */   "V0": function() { return /* binding */ trackAutoSellInfoSelected; },
/* harmony export */   "Vf": function() { return /* binding */ trackAutoSellDeleteCanceled; },
/* harmony export */   "ZY": function() { return /* binding */ trackAutoBuyTriggerConditionSelected; },
/* harmony export */   "_3": function() { return /* binding */ trackAutoBuyConfirmOrderCanceled; },
/* harmony export */   "_E": function() { return /* binding */ trackAutoBuyOrderTypeInfoSelected; },
/* harmony export */   "bG": function() { return /* binding */ trackAutoSellOrderQuantityAdjusted; },
/* harmony export */   "bm": function() { return /* binding */ trackAutoSellOrderSelected; },
/* harmony export */   "dM": function() { return /* binding */ trackAutoBuyOrderTypeSelected; },
/* harmony export */   "fY": function() { return /* binding */ trackAutoBuyOrderCanceled; },
/* harmony export */   "fh": function() { return /* binding */ trackAutoSellOrderInfoClosed; },
/* harmony export */   "fn": function() { return /* binding */ trackAutoSellDetailOrderView; },
/* harmony export */   "gT": function() { return /* binding */ trackAutoBuyTriggerPriceInfoSelected; },
/* harmony export */   "gl": function() { return /* binding */ trackAutoSellOrderDetailClosed; },
/* harmony export */   "i7": function() { return /* binding */ trackAutoSellFormView; },
/* harmony export */   "iY": function() { return /* binding */ trackAutoOrderCanceled; },
/* harmony export */   "jU": function() { return /* binding */ trackAutoBuyPreviewOrderView; },
/* harmony export */   "pR": function() { return /* binding */ trackAutoBuyOrderPlaced; },
/* harmony export */   "ur": function() { return /* binding */ trackAutoSellAutoOrderView; },
/* harmony export */   "vD": function() { return /* binding */ trackAutoSellInfoView; }
/* harmony export */ });
/* unused harmony exports trackAutoBuyAction, trackAutoBuyTncSelected, trackAutoBuyCancelOrderSelected, trackAutoBuyAmendSelected, trackAutoSellOrderTncSelected */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var trackAutoBuyOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Viewed");
};
var trackAutoBuyPreviewOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Previewed");
};
var trackAutoBuyOrderReceivedView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Received Viewed");
};
var trackAutoBuyDetailView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Order Detail Viewed");
};
var trackAutoBuyAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Action", eventObject);
};
var trackAutoBuyOrderTypeSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Set Order Type Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTriggerPriceInfoSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Price Info Selected"
    });
};
/**
 *
 * @param {('≥' | '≤')} condition
 * @returns
 */ var trackAutoBuyTriggerConditionSelected = function(condition) {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Condition Selected",
        Condition: condition
    });
};
var trackAutoBuyOrderTypeInfoSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Order Type Info Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTncSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Smart Order Terms & Conditions Selected"
    });
};
var trackAutoBuyOrderCanceled = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Order Buy Canceled"
    });
};
var trackAutoBuyOrderPlaced = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Placed"
    });
};
var trackAutoBuyConfirmOrderCanceled = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Canceled",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderConfirmed = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Confirmed",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderDone = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Done"
    });
};
var trackAutoBuyCancelOrderSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Cancel Order Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyAmendSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Amend Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
// #endregion Auto Buy
// #region Auto Sell
var trackAutoSellAutoOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Auto Order Viewed");
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellFormView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Viewed"));
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellInfoView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Information Viewed"));
};
var trackAutoSellDetailOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Detail Auto Order Viewed");
};
/**
 *
 * @param {("Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Auto Order Viewed"));
};
var trackAutoSellAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Action", eventObject);
};
/**
 *
 * @param {string} stock
 */ var trackAutoSellOrderSelected = function(stock) {
    trackAutoSellAction({
        Action: "Auto Sell Set Auto Order Selected",
        Stock: stock
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 */ var trackAutoSellOrderTypeSelected = function(type, stock) {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Type Selected",
        "Auto Sell Type": type,
        Stock: stock
    });
};
var trackAutoOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Canceled"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 */ var trackAutoSellInfoSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Information Selected")
    });
};
var trackAutoSellOrderQuantityAdjusted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Quantity Adjusted"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 * @param {number} lot
 * @param {number} price
 * @param {string} tpPercentage
 * @param {string} slPercentage
 */ var trackAutoSellOrderConfirmed = function(type, stock, lot, price, gainPercentage) {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Confirmed",
        "Auto Sell Type": type,
        Stock: stock,
        Lot: lot,
        Price: price,
        "Take Profit Percentage": type === "Take Profit" ? gainPercentage : 0,
        "Stop Loss Percentage": type === "Stop Loss" ? gainPercentage : 0
    });
};
var trackAutoSellOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Canceled"
    });
};
var trackAutoSellOrderInfoClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Information Closed"
    });
};
var trackAutoSellOrderDetailClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Detail Closed"
    });
};
/**
 *
 * @param {("Add"|"Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Auto Order Selected")
    });
};
var trackAutoSellDeleteCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Delete Canceled"
    });
};
var trackAutoSellOrderDeleted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Deleted"
    });
};
var trackAutoSellOrderTncSelected = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Terms & Conditions Selected"
    });
}; // #endregion Auto Sell


/***/ }),

/***/ 91154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ clevertapDayTradeSortSelected; },
/* harmony export */   "$f": function() { return /* binding */ clevertapExerciseClicked; },
/* harmony export */   "$v": function() { return /* binding */ clevertapDayTradeOrderTypeSelected; },
/* harmony export */   "A2": function() { return /* binding */ clevertapBuyOrderViewed; },
/* harmony export */   "Am": function() { return /* binding */ clevertapDayTradeLeverageSelected; },
/* harmony export */   "As": function() { return /* binding */ clevertapOrderPlaced; },
/* harmony export */   "B0": function() { return /* binding */ clevertapSellOrderViewed; },
/* harmony export */   "C4": function() { return /* binding */ clevertapSetPriceAlertSelected; },
/* harmony export */   "C5": function() { return /* binding */ clevertapDayTradeTNCViewed; },
/* harmony export */   "CH": function() { return /* binding */ clevertapOrderQuantityAdjusted; },
/* harmony export */   "EQ": function() { return /* binding */ clevertapChangeStock; },
/* harmony export */   "F9": function() { return /* binding */ clevertapDayTradeSplitOrderSelected; },
/* harmony export */   "FH": function() { return /* binding */ clevertapSecuritiesTradingPinSubmitted; },
/* harmony export */   "HR": function() { return /* binding */ clevertapDayTradeActivationDismissed; },
/* harmony export */   "J2": function() { return /* binding */ clevertapOrderPreviewed; },
/* harmony export */   "L": function() { return /* binding */ clevertapDayTradeDebtRatioViewed; },
/* harmony export */   "LA": function() { return /* binding */ clevertapViewChartSelected; },
/* harmony export */   "LF": function() { return /* binding */ clevertapExerciseViewed; },
/* harmony export */   "Lx": function() { return /* binding */ clevertapPortfolioDetailExercise; },
/* harmony export */   "Nf": function() { return /* binding */ clevertapDayTradeLeverageOptionViewed; },
/* harmony export */   "Rs": function() { return /* binding */ clevertapOrderTabSelected; },
/* harmony export */   "SW": function() { return /* binding */ clevertapDayTradeDebtRatioSubmitted; },
/* harmony export */   "Sv": function() { return /* binding */ clevertapExchangeFee; },
/* harmony export */   "TD": function() { return /* binding */ clevertapDayTradeDebtRatioChipSelected; },
/* harmony export */   "Uj": function() { return /* binding */ clevertapExerciseSelected; },
/* harmony export */   "V8": function() { return /* binding */ clevertapDayTradeActivationViewed; },
/* harmony export */   "_3": function() { return /* binding */ clevertapOrderDetailAmendViewed; },
/* harmony export */   "_O": function() { return /* binding */ clevertapPortfolioCompanySell; },
/* harmony export */   "_h": function() { return /* binding */ clevertapDayTradeOrderDetailSelected; },
/* harmony export */   "bQ": function() { return /* binding */ clevertapOrderCanceled; },
/* harmony export */   "dQ": function() { return /* binding */ clevertapOrderReceived; },
/* harmony export */   "f0": function() { return /* binding */ clevertapPortfolioBuyMore; },
/* harmony export */   "fn": function() { return /* binding */ clevertapSecuritiesTradingPinViewed; },
/* harmony export */   "hA": function() { return /* binding */ clevertapOrderDetailCancelConfirmed; },
/* harmony export */   "in": function() { return /* binding */ clevertapOrderViewed; },
/* harmony export */   "jS": function() { return /* binding */ clevertapDayTradeAfterMarketViewed; },
/* harmony export */   "kt": function() { return /* binding */ clevertapOrderDetailViewed; },
/* harmony export */   "lH": function() { return /* binding */ clevertapDayTradeActivationSelected; },
/* harmony export */   "mD": function() { return /* binding */ clevertapPortfolioSell; },
/* harmony export */   "mf": function() { return /* binding */ clevertapOrderDetailCancel; },
/* harmony export */   "ng": function() { return /* binding */ clevertapSetVisibleBalance; },
/* harmony export */   "oZ": function() { return /* binding */ clevertapDayTradeLeverageActivationSelected; },
/* harmony export */   "p": function() { return /* binding */ clevertapDayTradeActivationSuccessSelected; },
/* harmony export */   "pl": function() { return /* binding */ clevertapDayTradeActivationSubmitted; },
/* harmony export */   "qj": function() { return /* binding */ clevertapPortfolioDetailViewed; },
/* harmony export */   "r8": function() { return /* binding */ clevertapAutoOrderOptionsViewed; },
/* harmony export */   "rP": function() { return /* binding */ clevertapDayTradeStockListViewed; },
/* harmony export */   "sW": function() { return /* binding */ clevertapExerciseError; },
/* harmony export */   "t3": function() { return /* binding */ clevertapDayTradeDebtRatioModalViewed; },
/* harmony export */   "tG": function() { return /* binding */ clevertapPortfolioOrderViewed; },
/* harmony export */   "v8": function() { return /* binding */ clevertapOrderDone; },
/* harmony export */   "vM": function() { return /* binding */ clevertapStockSelected; },
/* harmony export */   "xA": function() { return /* binding */ clevertapOrderDetailAmend; },
/* harmony export */   "xC": function() { return /* binding */ clevertapBuyError; },
/* harmony export */   "xs": function() { return /* binding */ clevertapDayTradeActivationSuccessViewed; },
/* harmony export */   "y8": function() { return /* binding */ clevertapOrderConfirmed; },
/* harmony export */   "yr": function() { return /* binding */ clevertapPortfolioViewed; }
/* harmony export */ });
/* unused harmony exports generateSymbolType, clevertapTransactionOrderFailed, clevertapTransactionOrderFailedConfirmed, clevertapTransactionOrderAlert, clevertapBuyStockContinue */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42227);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29097);
/* harmony import */ var _virtualTrading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29351);
// List of clevertap event for stockbit securities
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
// Clevertap event is wrapped with high order function
// to separate concern with existing code.








// Symbol type for clevertap is different from
// exisitng API response
function generateSymbolType(symbol) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(symbol.split("-"), 2), symbolType = ref[1];
    if (!symbolType) {
        return "Normal";
    }
    if (symbolType.toUpperCase()[0] === "R") {
        return "Right";
    }
    if (symbolType.toUpperCase()[0] === "W") {
        return "Warrant";
    }
    return "";
}
function clevertapOrderDetailCancel() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, symbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", orderType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Buy";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_SELECTED */ .Le, {
        Type: type,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_VIEWED */ .Tf);
}
function clevertapOrderDetailCancelConfirmed(param) {
    var symbol = param.symbol, orderType = param.orderType, expiry = param.expiry, leverage = param.leverage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_CONFIRMED */ .fR, {
        symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Expiry: expiry,
        "Leverage Type": leverage
    });
}
function clevertapOrderDetailAmend(param) {
    var _type = param.type, type = _type === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _type, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_AMEND_SELECTED */ .fg, {
        Type: type,
        symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapOrderDetailAmendViewed(param) {
    var symbol = param.symbol, orderType = param.orderType, type = param.type;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_VIEWED */ .z8, {
        Symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Type: type
    });
}
function clevertapOrderQuantityAdjusted(param) {
    var symbol = param.symbol, orderType = param.orderType, adjustedType = param.adjustedType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_QUANTITY_ADJUSTED */ .gW,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_QUANTITY_ADJUSTED */ .sR,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPlaced(param) {
    var orderType = param.orderType, symbol = param.symbol, price = param.price, lot = param.lot, gainLoss = param.gainLoss, totalLot = param.totalLot, tradingBalancePercentage = param.tradingBalancePercentage, status = param.status, expiry = param.expiry, type = param.type, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PLACED */ .gg,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "% Trading Balance": tradingBalancePercentage,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PLACED */ .vc,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "Gain/Loss %": gainLoss,
            "% Total Lot": totalLot,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPreviewed(param) {
    var symbol = param.symbol, orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PREVIEWED */ .L9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PREVIEWED */ .q7,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_PREVIEWED */ .jG,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderCanceled(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CANCELED */ .lE,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CANCELED */ .dT,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CANCELED */ .a,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmed(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED */ .ee,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED */ .ZF,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type,
            Expiry: expiry,
            "Balance Lot": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CONFIRMED */ .Dn,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderReceived(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_RECEIVED */ .Hm,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_RECEIVED */ .n2,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderDone(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_DONE */ .g1,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_DONE */ .xc,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapExchangeFee(orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_SELECTED */ .tI);
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_VIEWED */ ._e, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
}
function clevertapChangeStock() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_STOCK_VIEWED */ .jr);
}
function clevertapBuyError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ERROR_PAGE */ .IU, {
        Reason: "Insufficient Trading Limit"
    });
}
function clevertapPortfolioSell(param) {
    var _tradingType = param.tradingType, tradingType = _tradingType === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _tradingType, source = param.source, gainLoss = param.gainLoss, symbol = param.symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SELL_STOCK_SELECTED */ .vf, {
        Type: tradingType,
        Source: source,
        "Gain/Loss %": gainLoss,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioCompanySell(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_COMPANY_SELL_STOCK_SELECTED */ .JW, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioBuyMore(symbol, gainLoss) {
    var tradingType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_BUY_MORE_SELECTED */ ._O, {
        Symbol: symbol,
        "Gain / Loss %": gainLoss,
        Type: tradingType
    });
}
function clevertapViewChartSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEW_CHART_SELECTED */ .J1, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapSetPriceAlertSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SET_PRICE_ALERT_SELECTED */ .ef, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapPortfolioViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, portfolioType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .PORTFOLIOS_TYPE.regular */ .ub.regular;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEWED */ .tA, {
        Type: tradingType,
        "Portfolio List": portfolioType
    });
}
function clevertapPortfolioOrderViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Order";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_ORDER_VIEWED */ .zF, {
        Type: tradingType,
        Filter: (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(filter)
    });
}
function clevertapOrderViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_VIEWED */ .dz);
}
function clevertapOrderDetailViewed(param) {
    var orderType = param.orderType, status = param.status, rejectReason = param.rejectReason, expiry = param.expiry, symbol = param.symbol, type = param.type, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _dayTradeForceSell = param.dayTradeForceSell, dayTradeForceSell = _dayTradeForceSell === void 0 ? false : _dayTradeForceSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_VIEWED */ .v9, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        Status: status,
        "Reject Reason": rejectReason,
        Expiry: expiry,
        Symbol: symbol,
        Type: type,
        "Symbol Type": generateSymbolType(symbol),
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": dayTradeForceSell ? "Force Sell" : "Regular"
    });
}
function clevertapStockSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_SELECTED */ .B);
}
function clevertapExerciseClicked(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_EXERCISE_CLICKED */ ._g, {
        Symbol: symbol
    });
}
function clevertapExerciseViewed(param) {
    var symbol = param.symbol, share = param.share;
    return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_VIEWED */ .dW, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share
    });
}
function clevertapExerciseSelected(param) {
    var symbol = param.symbol, share = param.share, stockOnHandPercentage = param.stockOnHandPercentage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_SELECTED */ .Nq, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share,
        "% Stock on Hand": stockOnHandPercentage
    });
}
function clevertapExerciseError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ERROR_PAGE */ .Vm, {
        Reason: "Melebihi Cash on Hand"
    });
}
function clevertapTransactionOrderFailed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED);
}
function clevertapTransactionOrderFailedConfirmed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED_CONFIRMED);
}
function clevertapTransactionOrderAlert() {
    clevertapEvent(TRANSACTION_ORDER_ALERT);
}
function clevertapBuyStockContinue() {
    clevertapEvent(BUY_STOCK_CONTINUE);
}
function clevertapPortfolioDetailViewed(param) {
    var symbol = param.symbol, gainLoss = param.gainLoss, exerciseable = param.exerciseable, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_STOCK_DETAIL_VIEWED */ .kC, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Gain/Loss %": gainLoss,
        Exercisable: exerciseable,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular"
    });
}
function clevertapPortfolioDetailExercise(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_DETAIL_EXERCISE_SELECTED */ .le, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapDayTradeActivationViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_VIEWED */ .jY);
}
function clevertapDayTradeTNCViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_TNC_VIEWED */ .hG);
}
function clevertapDayTradeActivationSuccessViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_VIEWED */ .DQ);
}
function clevertapDayTradeActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SELECTED */ .Av
    });
}
function clevertapDayTradeActivationDismissed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_DISMISSED */ .wK
    });
}
function clevertapDayTradeActivationSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUBMITTED */ .mX
    });
}
function clevertapDayTradeActivationSuccessSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_SELECTED */ .Go
    });
}
function clevertapDayTradeLeverageOptionViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_OPTION_VIEWED */ .zW);
}
function clevertapDayTradeLeverageActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED */ .TC
    });
}
function clevertapDayTradeAfterMarketViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_AFTER_MARKET_VIEWED */ .D1);
}
function clevertapDayTradeDebtRatioViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_VIEWED */ .nc);
}
function clevertapDayTradeDebtRatioSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED */ .Yu
    });
}
function clevertapDayTradeDebtRatioChipSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_CHIP_SELECTED */ .zt
    });
}
function clevertapDayTradeDebtRatioModalViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_MODAL_VIEWED */ .bK);
}
function clevertapDayTradeStockListViewed(param) {
    var _sourcePage = param.sourcePage, sourcePage = _sourcePage === void 0 ? "Company Page" : _sourcePage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_LIST_VIEWED */ .GK, {
        "Source Page": sourcePage
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_SORT_VIEWED */ .YM);
}
function clevertapDayTradeLeverageSelected(leverage) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7,
        Leverage: leverage
    });
}
function clevertapDayTradeSortSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_SELECTED */ .cc
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_APPLIED */ .Zy
    });
}
function clevertapDayTradeOrderTypeSelected(stock, orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_TYPE_SELECTED */ .YB,
        Stock: stock,
        "Buy Order Type": orderType
    });
}
function clevertapDayTradeSplitOrderSelected(toggle) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SPLIT_ORDER_SELECTED */ .CV,
        Toggle: toggle ? "On" : "Off"
    });
}
function clevertapDayTradeOrderDetailSelected(param) {
    var symbol = param.symbol, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _forcedSell = param.forcedSell, forcedSell = _forcedSell === void 0 ? false : _forcedSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_DETAIL_SELECTED */ .BY, {
        Symbol: symbol,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": forcedSell ? "Force Sell" : "Regular"
    });
}
function clevertapSecuritiesTradingPinViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_VIEWED */ .Hd);
}
function clevertapSecuritiesTradingPinSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_SUBMITTED */ .II, {
        Method: "PIN Input"
    });
}
function clevertapBuyOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_VIEWED */ .HA, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapSellOrderViewed(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_VIEWED */ .gE, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapAutoOrderOptionsViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_AUTO_ORDER_OPTIONS_VIEWED */ .YS);
}
function clevertapSetVisibleBalance() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SET_VISIBLE_BALANCE */ .G2);
}
function clevertapOrderTabSelected(tab) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Order Detail Action", {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_ORDER_TAB_SELECTED */ .Oc,
        "Transaction Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(tab)
    });
}


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 89561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "By": function() { return /* binding */ deleteReferral; },
/* harmony export */   "ER": function() { return /* binding */ getReferralStatus; },
/* harmony export */   "H5": function() { return /* binding */ postApplyReferral; },
/* harmony export */   "KT": function() { return /* binding */ getReferralByCode; },
/* harmony export */   "Qu": function() { return /* binding */ getReferralInfo; },
/* harmony export */   "ve": function() { return /* binding */ getReferralMembers; }
/* harmony export */ });
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestWithoutAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var getReferralInfo = function() {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/info"));
};
var getReferralStatus = function() {
    return requestWithoutAlert.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/status"));
};
var getReferralByCode = function(code) {
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/").concat(code));
};
var getReferralMembers = function(param) {
    var keyword = param.keyword, status = param.status, startDate = param.startDate, endDate = param.endDate, cursor = param.cursor;
    return request.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/affiliate/members"), {
        params: {
            search: keyword !== "" ? keyword : undefined,
            status: status !== "MEMBER_STATUS_UNSPECIFIED" ? status : undefined,
            start_date: startDate,
            end_date: endDate,
            cursor: cursor
        }
    });
};
var postApplyReferral = function(code) {
    return request.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral/apply"), {
        code: code
    });
};
var deleteReferral = function() {
    return request.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg, "/remisier/referral"));
};
var communityAPI = {
    getReferralInfo: getReferralInfo,
    getReferralStatus: getReferralStatus,
    getReferralByCode: getReferralByCode,
    getReferralMembers: getReferralMembers,
    postApplyReferral: postApplyReferral,
    deleteReferral: deleteReferral
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (communityAPI)));


/***/ }),

/***/ 14732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aX": function() { return /* binding */ getShareTradeSetting; },
  "JG": function() { return /* binding */ getShareTradeTarget; },
  "cm": function() { return /* binding */ postShareTradeShare; },
  "E8": function() { return /* binding */ putShareTradeSetting; },
  "wm": function() { return /* binding */ putShareTradeTarget; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/lib/api/instances/exodus.ts
var exodus = __webpack_require__(78372);
;// CONCATENATED MODULE: ./src/lib/api/shareTrade/endpoints.ts
var shareTradeEndpoints = {
    setting: "/sharetrade/setting",
    settingAutoShare: "/sharetrade/setting/autoshare",
    target: "/sharetrade/target",
    share: "/sharetrade/share"
};
/* harmony default export */ var endpoints = (shareTradeEndpoints);

;// CONCATENATED MODULE: ./src/lib/api/shareTrade/index.ts




var defaultInstance = exodus/* default.defaultInstance */.Z.defaultInstance;
var setting = endpoints.setting, settingAutoShare = endpoints.settingAutoShare, target = endpoints.target, share = endpoints.share;
var getShareTradeSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.get(setting));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getShareTradeSetting() {
        return _ref.apply(this, arguments);
    };
}();
var putShareTradeSetting = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.put(settingAutoShare, requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function putShareTradeSetting(requestBody) {
        return _ref.apply(this, arguments);
    };
}();
var getShareTradeTarget = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(params) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.get(target, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getShareTradeTarget(params) {
        return _ref.apply(this, arguments);
    };
}();
var putShareTradeTarget = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.put(target, requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function putShareTradeTarget(requestBody) {
        return _ref.apply(this, arguments);
    };
}();
var postShareTradeShare = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(requestBody) {
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", defaultInstance.post(share, requestBody));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postShareTradeShare(requestBody) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 59140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ editSmartOrder; },
/* harmony export */   "Xz": function() { return /* binding */ getStockData; },
/* harmony export */   "sU": function() { return /* binding */ postSmartOrder; },
/* harmony export */   "xB": function() { return /* binding */ postSmartOrderTnC; },
/* harmony export */   "zW": function() { return /* binding */ smartOrderDelete; }
/* harmony export */ });
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16311);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var requestTrading = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, true, false);
var postSmartOrder = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        data: [
            payload
        ]
    });
};
var editSmartOrder = function(payload) {
    return requestTrading.put("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), payload);
};
var smartOrderDelete = function(payload) {
    return requestTrading.delete("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        data: payload
    });
};
var getStockData = function(payload) {
    return requestTrading.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/smart-order"), {
        params: payload
    });
};
var postSmartOrderTnC = function(payload) {
    return requestTrading.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, "/smart-order/tnc"), payload);
};


/***/ }),

/***/ 94177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16311);
/* eslint-disable no-undef */ /* eslint-disable camelcase */ /* eslint-disable import/named */ 

var request = (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
var STOCK_TRANSFER_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_SECURITIES_GENERAL_URL */ .kg, "/stock-transfer");
/**
 * Get securities login token
 * @return {APIResponse}
 */ var getStockTransferExist = function() {
    return request.get("".concat(STOCK_TRANSFER_URL, "/is-exist"));
};
var getTransactionList = function(type) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/transactions"), {
        params: {
            type: type
        }
    });
};
var getTransactionDetail = function(stockTransferId) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/v2/transactions/").concat(stockTransferId));
};
// 1: All; 2: Default; 3: Others
var getSecuritiesList = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
    return request.get("".concat(STOCK_TRANSFER_URL, "/securities"), {
        params: {
            query_type: type
        }
    });
};
var getForm = function(securityCode, transferId) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/v2/form"), {
        params: {
            security_code: securityCode,
            stock_transfer_id: transferId
        }
    });
};
var postTransaction = function(data) {
    return request.post("".concat(STOCK_TRANSFER_URL, "/v2/transactions"), {
        stock_transfer_data: data
    });
};
var cancelTransaction = function(stockTransferId) {
    return request.post("".concat(STOCK_TRANSFER_URL, "/transactions/cancel"), {
        stock_transfer_id: stockTransferId
    });
};
var getUploadToken = function(securityCode) {
    return request.get("".concat(STOCK_TRANSFER_URL, "/upload/token"), {
        params: {
            security_code: securityCode
        }
    });
};
var uploadImage = function(url, body) {
    return fetch(url, {
        method: "POST",
        body: body
    });
};
var getNotification = function() {
    return request.get("".concat(STOCK_TRANSFER_URL, "/notifications"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getStockTransferExist: getStockTransferExist,
    getTransactionList: getTransactionList,
    getTransactionDetail: getTransactionDetail,
    getSecuritiesList: getSecuritiesList,
    getForm: getForm,
    postTransaction: postTransaction,
    cancelTransaction: cancelTransaction,
    getUploadToken: getUploadToken,
    uploadImage: uploadImage,
    getNotification: getNotification
});


/***/ }),

/***/ 89790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useNotificationData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42435);
/* harmony import */ var lib_api_notification__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99368);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);









var useNotificationData = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_4__/* .immer */ .n)(function(set) {
    return {
        tab: "notification",
        isPopupOpen: false,
        isConvoOpen: false,
        isReading: false,
        isLoading: false,
        isLoadingPrevious: false,
        contents: {
            notification: {
                list: [],
                lastId: null
            },
            mention: {
                list: [],
                lastId: null
            },
            report: {
                list: [],
                lastId: null
            },
            tipping: {
                list: [],
                lastId: null
            }
        },
        unread: 0,
        // UI Reducers
        changeTab: function changeTab(tab) {
            set(function(draft) {
                draft.tab = tab;
            });
        },
        togglePopup: function togglePopup() {
            set(function(draft) {
                draft.isPopupOpen = !draft.isPopupOpen;
            });
        },
        closePopup: function closePopup() {
            set(function(draft) {
                draft.isPopupOpen = false;
            });
        },
        setConvoOpen: function setConvoOpen(id) {
            var isOpen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            set(function(draft) {
                draft.isConvoOpen = isOpen;
                draft.convoId = id;
            });
        },
        closeConvo: function closeConvo() {
            set(function(draft) {
                draft.isConvoOpen = false;
                draft.convoId = undefined;
            });
        },
        setUnread: function setUnread(count) {
            set(function(draft) {
                draft.unread = count;
            });
        },
        getNotification: // Asynchronous actions
        function getNotification1(tab) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isLoading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = result;
                                draft.isLoading = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                            _ctx.next = 17;
                            break;
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isLoading = false;
                            });
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        14
                    ]
                ]);
            }))();
        },
        getPrevNotification: function getPrevNotification(tab, lastId) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, _data, result, unread;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // if previous
                            set(function(draft) {
                                draft.isLoadingPrevious = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getNotification */ .v6)(typeParams.typeCodes, 25, lastId);
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            _data = data.data, result = _data.result, unread = _data.unread;
                            set(function(draft) {
                                draft.unread = unread;
                                draft.contents[tab].list = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(draft.contents[tab].list).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(result));
                                draft.isLoadingPrevious = false;
                                if (result.length - 1 >= 0) {
                                    draft.contents[tab].lastId = result[result.length - 1].id;
                                }
                            });
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        },
        getUnreadCount: function getUnreadCount() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                            });
                            _ctx.next = 4;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .getUnreadNotificationNumber */ .O7)();
                        case 4:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 9:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 14;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = result.unread;
                                });
                            }
                            _ctx.next = 15;
                            break;
                        case 14:
                            throw new Error("failed to read notification");
                        case 15:
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        markNotifAsRead: function markNotifAsRead() {
            var tab = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "notification";
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var typeParams, ref, data, status, result;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.errorMessage = undefined;
                                draft.isReading = true;
                            });
                            typeParams = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTabsAttrs.find */ .jg.find(function(item) {
                                return item.name === tab;
                            });
                            _ctx.next = 5;
                            return (0,lib_api_notification__WEBPACK_IMPORTED_MODULE_1__/* .markAsRead */ .zJ)(typeParams.typeCodes);
                        case 5:
                            ref = _ctx.sent;
                            data = ref.data;
                            status = ref.status;
                            if (!(status !== 200)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error(data.error || data.error_type);
                        case 10:
                            result = data.data;
                            if (!result) {
                                _ctx.next = 15;
                                break;
                            }
                            {
                                set(function(draft) {
                                    draft.unread = 0;
                                    draft.isReading = false;
                                    draft.contents[tab].list = draft.contents[tab].list.map(function(item) {
                                        return !item.is_read ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, item), {
                                            is_read: true
                                        }) : item;
                                    });
                                });
                            }
                            _ctx.next = 16;
                            break;
                        case 15:
                            throw new Error("failed to read notification");
                        case 16:
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.errorMessage = _ctx.t0.message;
                                draft.isReading = false;
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }))();
        }
    };
}));


/***/ }),

/***/ 34737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A3": function() { return /* binding */ FLIPT_URL_HOST; },
/* harmony export */   "HZ": function() { return /* binding */ FLIPT_TOKEN; },
/* harmony export */   "Ii": function() { return /* binding */ FLIPT_CHARTBIT_NAMESPACE; },
/* harmony export */   "Vr": function() { return /* binding */ FLIPT_CHARTBIT_TOKEN; },
/* harmony export */   "ad": function() { return /* binding */ FLIPT_NAMESPACE; }
/* harmony export */ });
// Environment variables
var _NEXT_PUBLIC_FLIPT_URL_HOST;
var FLIPT_URL_HOST = (_NEXT_PUBLIC_FLIPT_URL_HOST = "https://flipt.stockbit.com") !== null && _NEXT_PUBLIC_FLIPT_URL_HOST !== void 0 ? _NEXT_PUBLIC_FLIPT_URL_HOST : "";
var _NEXT_PUBLIC_FLIPT_NAMESPACE;
var FLIPT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_NAMESPACE = "transaction") !== null && _NEXT_PUBLIC_FLIPT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_TOKEN;
var FLIPT_TOKEN = (_NEXT_PUBLIC_FLIPT_TOKEN = "3m1ehM_SYRRg0NDWbzixtn4O5ZcVWaaQW7ytx7NAm0A=") !== null && _NEXT_PUBLIC_FLIPT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_TOKEN : undefined;
var _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE;
var FLIPT_CHARTBIT_NAMESPACE = (_NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE = "chartbit") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_NAMESPACE : "";
var _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN;
var FLIPT_CHARTBIT_TOKEN = (_NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN = "N58pKzjn1zMJNwH5pGTOwy3-ufiL1Xdb0VQmRCl5kek=") !== null && _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN !== void 0 ? _NEXT_PUBLIC_FLIPT_CHARTBIT_TOKEN : undefined;


/***/ }),

/***/ 34540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FeatureFlagKeys; }
/* harmony export */ });
/**
 * Flag conventions
 * [platform]-[flag-type]-[feature-name]
 *
 * Platform:
 *   - all: all platform
 *   - android: android only
 *   - ios: ios only
 *   - web: web only
 * Flag Type:
 *   - b: boolean
 *   - v: variant
 * Feature name:
 *   - name of the feature with dash as separator
 *
 * Example:
 *   - web-b-split-order
 *   - all-v-language
 */ var FeatureFlagKeys;
(function(FeatureFlagKeys) {
    FeatureFlagKeys["SPLIT_ORDER"] = "all-b-split-order-eligibility";
    FeatureFlagKeys["FAST_ORDER"] = "web-b-fast-trade-eligibility";
    FeatureFlagKeys["FAST_ORDER_DUPLICATE_BIDOFFER"] = "web-b-fast-trade-duplicate-bidoffer";
    FeatureFlagKeys["CHARTBIT_MAINTENANCE"] = "chartbit_maintenance";
    FeatureFlagKeys["CHARTBIT_DEBUG"] = "chartbit_debug";
    FeatureFlagKeys["CHARTBIT_DISABLE_AUTOSAVE"] = "chartbit_disable_autosave";
    FeatureFlagKeys["CHARTBIT_IFRAME_LOGGING"] = "chartbit_iframe_logging";
})(FeatureFlagKeys || (FeatureFlagKeys = {}));


/***/ }),

/***/ 62514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* reexport */ useFliptBoolean; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./src/lib/flipt/store/useFliptStore.ts + 4 modules
var useFliptStore = __webpack_require__(90060);
;// CONCATENATED MODULE: ./src/lib/flipt/hooks/useFliptBoolean.ts



function useFliptBoolean(flagKey, alwaysLoad, namespaceKey) {
    var featureFlags = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.getUIValue("featureFlags");
    });
    var loadBooleanEvaluation = (0,useFliptStore/* default */.Z)(function(s) {
        return s.loadBooleanEvaluation;
    });
    var namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : undefined;
    var flag = featureFlags ? featureFlags[flagKey] : undefined;
    (0,react.useEffect)(function() {
        if (flag && !alwaysLoad) {
            return;
        }
        loadBooleanEvaluation(flagKey, namespace);
    }, [
        flagKey,
        flag,
        alwaysLoad
    ]);
    return flag ? flag.isEnabled : false;
};

;// CONCATENATED MODULE: ./src/lib/flipt/hooks/index.ts



/***/ }),

/***/ 90060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store_useFliptStore; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
;// CONCATENATED MODULE: ./src/lib/flipt/constants/endpoints.ts
// endpoints
var endpoints = {
    evaluate: {
        boolean: "evaluate/v1/boolean",
        variant: "evaluate/v1/variant",
        batch: "evaluate/v1/batch"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/flipt/constants/env.ts
var env = __webpack_require__(34737);
;// CONCATENATED MODULE: ./src/lib/flipt/instance.ts




var fliptApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_TOKEN */.HZ) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_TOKEN */.HZ)
        });
    }
    return config;
});
var fliptChartbitApi = axios_default().create({
    baseURL: env/* FLIPT_URL_HOST */.A3,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
    }
});
fliptChartbitApi.interceptors.request.use(function(config) {
    if (env/* FLIPT_CHARTBIT_TOKEN */.Vr) {
        // eslint-disable-next-line no-param-reassign
        config.headers = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config.headers), {
            Authorization: "Bearer ".concat(env/* FLIPT_CHARTBIT_TOKEN */.Vr)
        });
    }
    return config;
});

;// CONCATENATED MODULE: ./src/lib/flipt/helpers.ts

var createEntityID = function(userId) {
    return "web-".concat(userId);
};
var createEvaluationPayload = function(userId, flagKey, namespaceKey) {
    return {
        context: {
            user_id: userId
        },
        entityId: createEntityID(userId),
        flagKey: flagKey,
        namespaceKey: namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad
    };
};

;// CONCATENATED MODULE: ./src/lib/flipt/endpoints.ts




var getService = function(service) {
    if (service === "chartbit") {
        return fliptChartbitApi;
    }
    return fliptApi;
};
// endpoints handlers
var evaluateBoolean = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.boolean, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};
var evaluateVariant = function(userId, flagKey, namespaceKey) {
    var api = namespaceKey ? getService(namespaceKey) : fliptApi;
    return api.post(endpoints.evaluate.variant, createEvaluationPayload(userId, flagKey, namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : env/* FLIPT_NAMESPACE */.ad));
};

;// CONCATENATED MODULE: ./src/lib/flipt/store/useFliptStore.ts





var useFliptStore = (0,esm/* default */.ZP)(function(set, get) {
    return {
        setUserId: function setUserId(userId) {
            set({
                userId: String(userId)
            });
        },
        loadBooleanEvaluation: function loadBooleanEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, featureFlags, namespace, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            featureFlags = getUIValue("featureFlags");
                            if (!(featureFlags && featureFlags[flagKey])) {
                                _ctx.next = 9;
                                break;
                            }
                            return _ctx.abrupt("return", featureFlags[flagKey].isEnabled);
                        case 9:
                            namespace = namespaceKey !== null && namespaceKey !== void 0 ? namespaceKey : "transaction";
                            _ctx.next = 12;
                            return evaluateBoolean(userId, flagKey, namespace);
                        case 12:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    isEnabled: response.data.enabled
                                };
                            });
                            return _ctx.abrupt("return", response.data.enabled);
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        17
                    ]
                ]);
            }))();
        },
        loadVariantEvaluation: function loadVariantEvaluation(flagKey, namespaceKey) {
            return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var userId, ref, getUIValue, setUIValue, response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            userId = get().userId;
                            if (userId) {
                                _ctx.next = 5;
                                break;
                            }
                            // Return a rejected promise if user id is not found
                            // to prevent the function from continuing
                            Promise.reject(new Error("user id is not found"));
                            return _ctx.abrupt("return", false);
                        case 5:
                            ref = useUIConfigStore/* default.getState */.Z.getState(), getUIValue = ref.getUIValue, setUIValue = ref.setUIValue;
                            _ctx.next = 8;
                            return evaluateVariant(userId, flagKey, namespaceKey);
                        case 8:
                            response = _ctx.sent;
                            setUIValue("featureFlags", function(draft) {
                                draft[flagKey] = {
                                    variance: response.data
                                };
                            });
                            return _ctx.abrupt("return", response.data);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    };
});
/* harmony default export */ var store_useFliptStore = (useFliptStore);


/***/ }),

/***/ 36902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradingData; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(38597);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/orderbook.ts
var orderbook = __webpack_require__(83384);
// EXTERNAL MODULE: ./src/lib/api/securities.ts
var securities = __webpack_require__(65906);
// EXTERNAL MODULE: ./src/features/trade/components/OrderTable/store.ts
var store = __webpack_require__(83100);
// EXTERNAL MODULE: ./src/global/Securities/utils/formula.ts
var formula = __webpack_require__(98202);
// EXTERNAL MODULE: ./src/utils/securities/transformData.ts
var transformData = __webpack_require__(75413);
;// CONCATENATED MODULE: ./src/utils/securities/transformVirtualTradingData.ts


var vtOrderList = function(data) {
    return data.map(function(item) {
        return {
            action: item.action,
            amount_fee: item.amount.fee,
            amount_invested: item.amount.invested,
            amount_matched: item.amount.matched,
            currency: item.currency,
            gtc: item.gtc.enable ? 1 : 0,
            gtc_expired: item.gtc.expired,
            gtc_status: item.gtc.status,
            order_done: item.done,
            order_open: item.open,
            order_total: item.total,
            orderid: item.id,
            market_orderid: item.market_order_id,
            price: item.price,
            price_average: item.price_average,
            status: item.status,
            symbol: item.symbol,
            time: item.time.created,
            time_open: item.time.open,
            time_match: item.time.match,
            total: item.total
        };
    });
};
var vtPortfolioList = function(data) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
        // transform to the legacy schema
        tradingbalance: data.trading_balance,
        amount_invested: data.amount.invested,
        amount_allocated: data.amount.allocated,
        amount_creditlimit: data.amount.credit_limit,
        unrealised_profitloss: data.profit_loss.unrealized,
        realised_profitloss: data.profit_loss.realized,
        profitloss: data.profit_loss.total,
        equity: data.equity,
        gain: data.gain,
        // transform to the legacy schema
        result: data.result.map(function(item) {
            return {
                available_lot: item.available_lot,
                balance_lot: item.balance_lot,
                symbol: item.symbol,
                sell_open: item.sell_open.total,
                sell_open_today: item.sell_open.today,
                total: item.total,
                price: item.price.order,
                price_average: item.price.average,
                price_latest: item.price.market,
                unrealised_marketvalue: item.unrealized.market_value,
                unrealised_profitloss: item.unrealized.profit_loss,
                unrealised_gain: item.unrealized.gain,
                name: item.name
            };
        })
    });
};
/* harmony default export */ var transformVirtualTradingData = ({
    vtOrderList: vtOrderList,
    vtPortfolioList: vtPortfolioList
});

// EXTERNAL MODULE: ./src/global/VirtualTrading/api/order.ts + 1 modules
var order = __webpack_require__(79397);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/portfolio.ts + 1 modules
var portfolio = __webpack_require__(80943);
;// CONCATENATED MODULE: ./src/lib/stores/tradingData.ts
/* eslint-disable import/no-named-as-default-member */ 
















var defaultData = {
    isLoading: false,
    message: "",
    data: null,
    error: ""
};
var historyDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        data: [],
        page: "1",
        isNeedToFetchMore: false,
        totalRealizedAmount: 0,
        tooltipHeader: "",
        tooltips: []
    },
    showSkeleton: true
});
var transactionHistoryDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        history: []
    },
    showSkeleton: false
});
var portfolioDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        tradingbalance: 0,
        amount_invested: 0,
        amount_allocated: 0,
        unrealised_profitloss: 0,
        gain: 0,
        equity: 0,
        result: [],
        auto_order_info: "",
        // Day Trade
        day_trade: [],
        debt_ratio: 0,
        debt_total: 0,
        debt_market_value: 0
    }
});
var portfolioDetailDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        available_lot: 0,
        available_share: 0,
        exercise_data: {
            price: 0
        }
    }
});
var cashOnHandDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: {
        available_cash_on_hand: 0
    }
});
var orderHistoryDefault = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
    data: []
});
var setIsLoading = function(key, set) {
    var custom = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        isLoading: true
    })), false, "setIsLoading/".concat(key));
};
var setError = function(error, key, set) {
    var custom = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        error: error
    })), false, "setError/".concat(key));
};
var setData = function(data, message, key, set) {
    var custom = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : defaultData;
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, custom), {
        data: data,
        message: message
    })), false, "setData/".concat(key));
};
var tradingDataStore = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)((0,middleware/* persist */.tJ)(function(set, get) {
    return {
        portfolio: portfolioDefault,
        orderHistory: orderHistoryDefault,
        configFormula: defaultData,
        exerciseList: defaultData,
        history: historyDefault,
        transactionHistory: transactionHistoryDefault,
        company: defaultData,
        corpActions: defaultData,
        exercise: defaultData,
        cashOnHand: cashOnHandDefault,
        portfolioDetail: portfolioDetailDefault,
        portfolioDetailDayTrade: portfolioDetailDefault,
        rightTradeable: defaultData,
        stockTradable: defaultData,
        resetModalData: function() {
            set({
                rightTradeable: defaultData,
                exercise: defaultData,
                cashOnHand: cashOnHandDefault
            });
        },
        resetCompany: function() {
            set({
                company: defaultData
            });
        },
        setSkeleton: function(key, showSkeleton) {
            set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, get()[key]), {
                showSkeleton: showSkeleton
            })));
        },
        getPortfolio: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isRealTrading) {
                var resetData, key, api, response, _$error, _data, responseData, message, data, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            key = "portfolio";
                            if (resetData) setIsLoading(key, set, portfolioDefault);
                            _ctx.prev = 3;
                            api = !isRealTrading ? portfolio/* getPortfolioList */.g : trade/* default.getPortfolio */.Z.getPortfolio;
                            _ctx.next = 7;
                            return api();
                        case 7:
                            response = _ctx.sent;
                            if (!(response.data.error || !response.data)) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to get portfolio failed";
                            setError(_$error, key, set, portfolioDefault);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, responseData = _data.data, message = _data.message;
                            data = isRealTrading ? transformData/* default.portfolioList */.Z.portfolioList(responseData) : transformVirtualTradingData.vtPortfolioList(responseData);
                            setData(data, message, key, set, portfolioDefault);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, portfolioDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(isRealTrading) {
                return _ref.apply(this, arguments);
            };
        }(),
        getConfigFormula: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, persistedFormula, response, _$error, _data, responseData, message, data, formulaStockbit;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "configFormula";
                        persistedFormula = get().configFormula;
                        setIsLoading(key, set, persistedFormula);
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return trade/* default.getConfigFormula */.Z.getConfigFormula();
                    case 6:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _$error = "Attempt to retrieve config formula failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 11:
                        _data = response.data, responseData = _data.data, message = _data.message;
                        data = transformData/* default.formulaData */.Z.formulaData(responseData);
                        formulaStockbit = {
                            formula: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data.formula), {
                                fee_buy: data.fee.buy,
                                fee_sell: data.fee.sell,
                                fee_buy_day_trade: data.day_trade.fee.buy,
                                fee_sell_day_trade: data.day_trade.fee.sell
                            })
                        };
                        localStorage.setItem("formulaStockbit", JSON.stringify(formulaStockbit));
                        localStorage.setItem("securitiesPreviewFeeData", JSON.stringify(data.preview_fee));
                        localStorage.setItem("securitiesPreviewFeeDataDayTrade", JSON.stringify(data.day_trade.preview_fee));
                        setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formulaStockbit), {
                            preview_fee: data.preview_fee,
                            day_trade: data.day_trade
                        }), message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](3);
                        setError(_ctx.t0, key, set, persistedFormula);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    21
                ]
            ]);
        })),
        getOrderHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(isRealTrading) {
                var resetData, key, api, response, _$error, _data, data, message, result, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resetData = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            key = "orderHistory";
                            if (resetData) setIsLoading(key, set, orderHistoryDefault);
                            _ctx.prev = 3;
                            api = !isRealTrading ? order/* getVirtualOrderList */.cf : trade/* default.getOrderList */.Z.getOrderList;
                            _ctx.next = 7;
                            return api(0);
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to retrieve order history failed";
                            setError(_$error, key, set, orderHistoryDefault);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            result = isRealTrading ? transformData/* default.orderList */.Z.orderList(data) : transformVirtualTradingData.vtOrderList(data);
                            setData(result, message, key, set);
                            store/* default.getState */.Z.getState().searchAndFilter(result);
                            return _ctx.abrupt("return", {
                                data: result,
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, orderHistoryDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(isRealTrading) {
                return _ref.apply(this, arguments);
            };
        }(),
        getExerciseList: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "exerciseList";
                        setIsLoading(key, set);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.getExerciseList */.Z.getExerciseList();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to retrieve exercise list failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        getHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var filters, appendData, key, oldData, response, _$error, _data, data, message, _$error1, ref, page, updatedData, oldData1, transformedHistoryData, isGroupDateExistOnPrevPage, newData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            filters = param.filters, appendData = param.appendData;
                            key = "history";
                            if (Number(filters.page) > 1) {
                                oldData = get().history;
                                set({
                                    history: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, oldData), {
                                        isLoading: true
                                    })
                                });
                            } else {
                                setIsLoading(key, set, historyDefault);
                            }
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.getHistory */.Z.getHistory(filters);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to retrieve history list failed";
                            setError(_$error, key, set, historyDefault);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message, _$error1 = _data.error;
                            if (!_$error1) {
                                _ctx.next = 15;
                                break;
                            }
                            setError(_$error1, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            throw new Error(_$error1);
                        case 15:
                            if (data) {
                                ;
                                page = (filters === null || filters === void 0 ? void 0 : filters.page) || 1;
                                updatedData = [];
                                oldData1 = (ref = get().history.data) === null || ref === void 0 ? void 0 : ref.data;
                                if (data === null || data === void 0 ? void 0 : data.history) {
                                    transformedHistoryData = data.history.reduce(function(prev, curr) {
                                        var _prev;
                                        var isMonthlyRealizedAvailable = typeof curr === "object" && "monthly_gain" in curr;
                                        (_prev = prev).push.apply(_prev, [
                                            (0,_object_spread/* default */.Z)({
                                                groupDate: curr.date
                                            }, isMonthlyRealizedAvailable ? {
                                                groupRealizedGain: curr.monthly_gain
                                            } : {
                                                groupRealizedGain: null
                                            }), 
                                        ].concat((0,_to_consumable_array/* default */.Z)(curr.history_list)));
                                        return prev;
                                    }, []);
                                    if (appendData && oldData1.length && transformedHistoryData.length) {
                                        isGroupDateExistOnPrevPage = (oldData1 === null || oldData1 === void 0 ? void 0 : oldData1.find(function(item) {
                                            var ref;
                                            return item.groupDate === ((ref = transformedHistoryData[0]) === null || ref === void 0 ? void 0 : ref.groupDate);
                                        })) || null;
                                        if (isGroupDateExistOnPrevPage) {
                                            transformedHistoryData.shift();
                                        }
                                        updatedData = (0,_to_consumable_array/* default */.Z)(oldData1).concat((0,_to_consumable_array/* default */.Z)(transformedHistoryData));
                                    } else {
                                        updatedData = transformedHistoryData;
                                    }
                                } else if (appendData && oldData1) {
                                    updatedData = oldData1;
                                }
                                newData = {
                                    data: updatedData,
                                    page: page,
                                    isNeedToFetchMore: page < data.meta.max_page,
                                    totalRealizedAmount: data.meta.total_realized_amount,
                                    tooltipHeader: data.meta.tooltip_header,
                                    tooltips: data.meta.tooltips
                                };
                                setData(newData, message, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                    // @ts-ignore
                                    showSkeleton: false
                                }));
                            }
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, historyDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        /**
         *
         * TODO | SBPD-9819
         * Migrate to use the getHistory API
         * - [ ] Adjust the @params to match /history API
         * - [ ] Adjust the response of the /history
         * - [ ] Transform the response to the legacy UI
         * - [ ] Test
         */ getTransactionHistory: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(urlParams) {
                var key, response, _$error, _data, data, message, _$error1;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "transactionHistory";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.getHistory */.Z.getHistory(urlParams);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to retrieve history list failed";
                            setError(_$error, key, set, historyDefault);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message, _$error1 = _data.error;
                            if (_$error1) {
                                setError(_$error1, key, set, {
                                    // @ts-ignore -- TODO:  Fix the type of the store interface
                                    // current implementation has too many instances
                                    // where the types are casted using 'any'
                                    // makes it difficult to achieve static typing
                                    showSkeleton: false
                                });
                            }
                            setData(data, message, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionHistoryDefault), {
                                // @ts-ignore -- Same as above
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", response.data);
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, transactionHistoryDefault), {
                                // @ts-ignore
                                showSkeleton: false
                            }));
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        16
                    ]
                ]);
            }));
            return function(urlParams) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCompany: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbol) {
                var key, companyResponse, _data, data, _$error, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "company";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return orderbook/* default.getCompanyInfo */.Z.getCompanyInfo(symbol);
                        case 5:
                            companyResponse = _ctx.sent;
                            _data = companyResponse.data, data = _data.data, _$error = _data.error, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 10;
                                break;
                            }
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCorpActions: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(symbols) {
                var key, companyResponse, _data, data, _$error, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "corpActions";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return securities/* default.getAllCorpAction */.Z.getAllCorpAction(symbols);
                        case 5:
                            companyResponse = _ctx.sent;
                            _data = companyResponse.data, data = _data.data, _$error = _data.error, message = _data.message;
                            if (!_$error) {
                                _ctx.next = 10;
                                break;
                            }
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(symbols) {
                return _ref.apply(this, arguments);
            };
        }(),
        getExercise: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "exercise";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.getExercise */.Z.getExercise(stockCode);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }(),
        checkRightTradeable: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "rightTradeable";
                        setIsLoading(key, set);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.checkRightTradeable */.Z.checkRightTradeable();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to post trade buy failed";
                        setError(_$error, key, set);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set);
                        return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        getPortfolioDetail: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, keyDetail, response, _$error, _data, data, message, result, dayTrade;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "portfolioDetail";
                            keyDetail = "portfolioDetailDayTrade";
                            setIsLoading(key, set, portfolioDetailDefault);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.getPortfolioDetail */.Z.getPortfolioDetail(stockCode);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to get portfolio detail failed";
                            setError(_$error, key, set, portfolioDetailDefault);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            result = transformData/* default.portfolioItem */.Z.portfolioItem(data.result);
                            dayTrade = transformData/* default.portfolioItem */.Z.portfolioItem(data.day_trade);
                            setData(result, message, key, set, portfolioDetailDefault);
                            setData(dayTrade, message, keyDetail, set, portfolioDetailDefault);
                            return _ctx.abrupt("return", {
                                data: {
                                    result: result,
                                    day_trade: dayTrade
                                },
                                message: message
                            });
                        case 19:
                            _ctx.prev = 19;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set, portfolioDetailDefault);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        19
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }(),
        getCashOnHand: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var key, response, _$error, _data, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        key = "cashOnHand";
                        setIsLoading(key, set, cashOnHandDefault);
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return trade/* default.getCashOnHand */.Z.getCashOnHand();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _$error = "Attempt to get cash on hand failed";
                        setError(_$error, key, set, cashOnHandDefault);
                        throw new Error(_$error);
                    case 10:
                        _data = response.data, data = _data.data, message = _data.message;
                        setData(data, message, key, set, cashOnHandDefault);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(_ctx.t0, key, set, cashOnHandDefault);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    15
                ]
            ]);
        })),
        // Live Portfolio - LivePrice
        updatePortfolioListItem: function(stockCode, newData) {
            var ref, ref1, ref2;
            if (!stockCode || !newData) return;
            var key = "portfolio";
            var price_latest = newData.price_latest;
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var persistedFormula = get().configFormula;
            if (!persistedFormula) return;
            // Update portfolio list item (Table) - Regular
            var resultList = (ref1 = portfolioData.result) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                if (item.symbol === stockCode) {
                    var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(persistedFormula.data, price_latest, item.balance_lot, item.amount_invested);
                    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        price_latest: price_latest
                    }), updatedData);
                }
                return item;
            });
            var dayTradeList = (ref2 = portfolioData.day_trade) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                if (item.symbol === stockCode) {
                    var updatedData = (0,formula/* generateUpdatedPortfolioItem */.jm)(persistedFormula.data, price_latest, item.balance_lot, item.amount_invested);
                    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                        price_latest: price_latest
                    }), updatedData);
                }
                return item;
            });
            // Update portfolio summary (Header) - Live Price
            // Update portfolio summary (Header)
            var ref3 = (0,formula/* generateUpdatedPortfolioHeader */.Oz)(persistedFormula.data, resultList, dayTradeList, portfolioData.tradingbalance, portfolioData.amount_invested, portfolioData.amount_allocated, portfolioData.debt_total), unrealised_profitloss = ref3.unrealised_profitloss, gain = ref3.gain, equity = ref3.equity, ratio = ref3.ratio, market_value = ref3.market_value;
            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, portfolioData), {
                result: resultList,
                day_trade: dayTradeList,
                unrealised_profitloss: unrealised_profitloss,
                gain: gain,
                equity: equity,
                debt_ratio: ratio,
                debt_market_value: market_value
            }), "update-portfolio-liveprice", key, set, portfolioDefault);
        },
        // End Live Portfolio - LivePrice
        // Live Portfolio - New WS
        updatePortfolioSummary: function(newData) {
            var ref;
            if (!newData) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            setData((0,_object_spread/* default */.Z)({}, portfolioData, newData), "update-portfolio-data-ws", key, set, portfolioDefault);
        },
        updatePortfolioList: function(newData) {
            var ref, ref1, ref2;
            if (!newData) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var resultList = (ref1 = portfolioData.result) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                var ref;
                var result = (ref = newData.result) === null || ref === void 0 ? void 0 : ref.find(function(res) {
                    return res.symbol === item.symbol;
                });
                if (!result) return item;
                return (0,_object_spread/* default */.Z)({}, item, result);
            });
            var dayTradeList = (ref2 = portfolioData.day_trade) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                var ref;
                var result = (ref = newData.day_trade) === null || ref === void 0 ? void 0 : ref.find(function(res) {
                    return res.symbol === item.symbol;
                });
                if (!result) return item;
                return (0,_object_spread/* default */.Z)({}, item, result);
            });
            setData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, portfolioData, newData), {
                result: resultList,
                day_trade: dayTradeList
            }), "update-portfolio-data-ws", key, set, portfolioDefault);
        },
        updatePortfolioItem: function(stockCode, newData) {
            var isDayTrade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ref, ref1, ref2;
            if (!stockCode || !newData) return;
            var key = "portfolio";
            var portfolioDetailData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioDetailData || !newData) return;
            var portfolioList = isDayTrade ? portfolioDetailData.day_trade : portfolioDetailData.result;
            if (!portfolioList) return;
            // Update portfolio detail if exist
            var resultList = portfolioList.map(function(item) {
                if (item.symbol === stockCode) {
                    return (0,_object_spread/* default */.Z)({}, item, newData);
                }
                return item;
            });
            // Add new portfolio detail if not exist
            var isPortfolioExist = portfolioList.find(function(item) {
                return item.symbol === stockCode;
            });
            if (!isPortfolioExist && resultList) {
                resultList.push(newData);
                resultList.sort(function(a, b) {
                    var symbolA = a.symbol.toUpperCase();
                    var symbolB = b.symbol.toUpperCase();
                    if (symbolA < symbolB) {
                        return -1;
                    }
                    if (symbolA > symbolB) {
                        return 1;
                    }
                    return 0;
                });
            }
            var updatedData = (0,_object_spread/* default */.Z)({}, portfolioDetailData, isDayTrade ? {
                day_trade: resultList
            } : {
                result: resultList
            });
            setData(updatedData, "update-portfolio-item-ws", key, set);
            // update portfolioDetail if exist
            var portfolioDetail = isDayTrade ? (ref1 = get().portfolioDetailDayTrade) === null || ref1 === void 0 ? void 0 : ref1.data : (ref2 = get().portfolioDetail) === null || ref2 === void 0 ? void 0 : ref2.data;
            if (!portfolioDetail) return;
            if (portfolioDetail.symbol === stockCode) {
                var keyDetail = isDayTrade ? "portfolioDetailDayTrade" : "portfolioDetail";
                setData((0,_object_spread/* default */.Z)({}, portfolioDetail, newData), "update-portfolio-detail-ws", keyDetail, set);
            }
        },
        deletePortfolioItem: function(stockCode) {
            var isDayTrade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var ref, ref1, ref2, ref3, ref4;
            if (!stockCode) return;
            var key = "portfolio";
            var portfolioData = (ref = get().portfolio) === null || ref === void 0 ? void 0 : ref.data;
            if (!portfolioData) return;
            var portfolioList = isDayTrade ? (ref1 = get().portfolio) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.day_trade : (ref3 = get().portfolio) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.result;
            if (!portfolioList) return;
            var resultList = portfolioList.filter(function(item) {
                return item.symbol !== stockCode;
            });
            var updatedData = (0,_object_spread/* default */.Z)({}, portfolioData, isDayTrade ? {
                day_trade: resultList
            } : {
                result: resultList
            });
            setData(updatedData, "update-portfolio-item-ws", key, set);
        },
        updateOrderList: function(newData) {
            var ref;
            if (!newData) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            if (!orderHistoryData) return;
            var orderList = orderHistoryData.map(function(item) {
                var result = newData.find(function(res) {
                    return res.orderid === item.orderid;
                });
                if (!result) return item;
                return (0,_object_spread/* default */.Z)({}, item, result);
            });
            if ((orderList === null || orderList === void 0 ? void 0 : orderList.length) === 0) return;
            setData(orderList, "update-order-list-ws", key, set);
            store/* default.getState */.Z.getState().searchAndFilter(orderList);
        },
        updateOrderListItem: function(orderId, newData) {
            var ref, ref1;
            if (!orderId || !newData) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            var orderHistoryLoading = (ref1 = get().orderHistory) === null || ref1 === void 0 ? void 0 : ref1.isLoading;
            if (!orderHistoryData) return;
            // Update order detail if exist
            var resultList = orderHistoryData.map(function(item) {
                if (item.orderid === orderId) {
                    return (0,_object_spread/* default */.Z)({}, item, newData);
                }
                return item;
            });
            // Add new order detail if not exist
            var isOrderExist = orderHistoryData.find(function(item) {
                return item.orderid === orderId;
            });
            // only update order list if order list is not empty and not loading
            if ((orderHistoryData === null || orderHistoryData === void 0 ? void 0 : orderHistoryData.length) === 0 && orderHistoryLoading) return;
            if (!isOrderExist) {
                resultList.unshift(newData);
            }
            setData(resultList, "update-order-item-ws", key, set, orderHistoryDefault);
            store/* default.getState */.Z.getState().searchAndFilter(resultList);
        },
        deleteOrderListItem: function(orderId) {
            var ref;
            if (!orderId) return;
            var key = "orderHistory";
            var orderHistoryData = (ref = get().orderHistory) === null || ref === void 0 ? void 0 : ref.data;
            if (!orderHistoryData) return;
            var resultList = orderHistoryData.filter(function(item) {
                return item.orderid !== orderId;
            });
            setData(resultList, "delete-order-item-ws", key, set);
            store/* default.getState */.Z.getState().searchAndFilter(resultList);
        },
        // End Live Portfolio - New WS
        checkStockTradable: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(stockCode) {
                var key, response, _$error, _data, data, message, tradableData;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "stockTradable";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.checkStockTradable */.Z.checkStockTradable(stockCode);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to check stock tradable failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            tradableData = data[0];
                            setData(tradableData, message, key, set);
                            return _ctx.abrupt("return", {
                                data: tradableData,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", Promise.reject(new Error(_ctx.t0)));
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        16
                    ]
                ]);
            }));
            return function(stockCode) {
                return _ref.apply(this, arguments);
            };
        }()
    };
}, {
    name: "zustandStockbitFormula",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            configFormula: state.configFormula
        };
    }
})));
/* harmony default export */ var tradingData = (tradingDataStore);


/***/ }),

/***/ 31532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tradingOperation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/trade.ts
var trade = __webpack_require__(65141);
// EXTERNAL MODULE: ./src/lib/api/alert.ts
var api_alert = __webpack_require__(56703);
// EXTERNAL MODULE: ./src/lib/api/smartOrder.ts
var smartOrder = __webpack_require__(59140);
// EXTERNAL MODULE: ./src/global/VirtualTrading/api/config.ts + 1 modules
var config = __webpack_require__(86408);
;// CONCATENATED MODULE: ./src/global/VirtualTrading/types/transactions.ts
var VirtualExpiryId;
(function(VirtualExpiryId) {
    VirtualExpiryId[VirtualExpiryId["GoodForDay"] = 0] = "GoodForDay";
    VirtualExpiryId[VirtualExpiryId["GoodTillCanceled"] = 1] = "GoodTillCanceled";
})(VirtualExpiryId || (VirtualExpiryId = {}));

;// CONCATENATED MODULE: ./src/lib/stores/tradingOperation.ts
/* eslint-disable import/no-named-as-default-member */ 










var defaultData = {
    isLoading: false,
    message: "",
    data: null,
    error: ""
};
var setIsLoading = function(key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        isLoading: true
    })));
};
var setError = function(error, key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        error: error
    })));
};
var setData = function(data, message, key, set) {
    set((0,_define_property/* default */.Z)({}, key, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
        data: data,
        message: message
    })));
};
var tradingOperationStore = (0,esm/* default */.ZP)(function(set) {
    return {
        postTradeCancelData: defaultData,
        smartOrderDeleteData: defaultData,
        addPriceAlertData: defaultData,
        postTradeBuyData: defaultData,
        postSmartOrderBuyData: defaultData,
        postTradeSellData: defaultData,
        postTradeAmendData: defaultData,
        postRequestExerciseData: defaultData,
        postDayTradeBuyData: defaultData,
        postDayTradeSellData: defaultData,
        postDayTradeAmendData: defaultData,
        postDayTradeCancelData: defaultData,
        postTradeCancel: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderid, orderkey, symbol, gtc, isRealTrading, key, apiData, apiFunction, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderid = param.orderid, orderkey = param.orderkey, symbol = param.symbol, gtc = param.gtc, isRealTrading = param.isRealTrading;
                            key = "postTradeCancelData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            apiData = isRealTrading ? {
                                orderid: orderid,
                                orderkey: orderkey,
                                symbol: symbol,
                                gtc: gtc
                            } : {
                                order_id: orderid,
                                gtc: gtc === VirtualExpiryId.GoodTillCanceled
                            };
                            apiFunction = !isRealTrading ? config/* postCancel */.u : trade/* default.tradeCancel */.Z.tradeCancel;
                            _ctx.next = 8;
                            return apiFunction(apiData);
                        case 8:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            setError("Attempt to cancel trade failed", key, set);
                            throw new Error("Attempt to cancel trade failed");
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            set({
                                postTradeCancelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                                    data: data,
                                    message: message
                                })
                            });
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        18
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        smartOrderDelete: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "smartOrderDeleteData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,smartOrder/* smartOrderDelete */.zW)(payload);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 9;
                                break;
                            }
                            setError("Attempt to cancel trade failed", key, set);
                            throw new Error("Attempt to cancel trade failed");
                        case 9:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 14:
                            _ctx.prev = 14;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        14
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        addPriceAlert: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var name, command, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            name = param.name, command = param.command;
                            key = "addPriceAlertData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return api_alert/* default.addPriceAlert */.Z.addPriceAlert(name, command);
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to retrieve exercise list failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeBuy: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderkey, symbol, price, shares, boardtype, gtc, split_order, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, boardtype = param.boardtype, gtc = param.gtc, split_order = param.split_order;
                            key = "postTradeBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.tradeBuy */.Z.tradeBuy({
                                orderkey: orderkey,
                                symbol: symbol,
                                price: price,
                                shares: shares,
                                boardtype: boardtype,
                                gtc: gtc,
                                split_order: split_order
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postSmartOrderBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return (0,smartOrder/* postSmartOrder */.sU)(payload);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post smart order failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeSell: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderkey, symbol, price, shares, boardtype, gtc, split_order, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderkey = param.orderkey, symbol = param.symbol, price = param.price, shares = param.shares, boardtype = param.boardtype, gtc = param.gtc, split_order = param.split_order;
                            key = "postTradeSellData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.tradeSell */.Z.tradeSell({
                                orderkey: orderkey,
                                symbol: symbol,
                                price: price,
                                shares: shares,
                                boardtype: boardtype,
                                // @ts-ignore
                                gtc: gtc,
                                split_order: split_order
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post trade sell failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postTradeAmend: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orders) {
                var key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postTradeAmendData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.bulkTradeAmend */.Z.bulkTradeAmend(orders);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 10;
                                break;
                            }
                            _$error = "Attempt to post trade ammend failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 10:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(orders) {
                return _ref.apply(this, arguments);
            };
        }(),
        postRequestExercise: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderKey, shares, stockCode, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderKey = param.orderKey, shares = param.shares, stockCode = param.stockCode;
                            key = "postRequestExerciseData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.postRequestExercise */.Z.postRequestExercise({
                                stockCode: stockCode,
                                shares: shares,
                                orderKey: orderKey
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post request exercise data failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        editSmartOrder: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(payload) {
                var response, _data, data, _$error, errorType, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,smartOrder/* editSmartOrder */.GP)(payload);
                        case 3:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error("Error while fetching data");
                        case 6:
                            _data = response.data, data = _data.data, _$error = _data.error, errorType = _data.error_type, message = _data.message;
                            if (!(_$error || errorType)) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(message);
                        case 9:
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function(payload) {
                return _ref.apply(this, arguments);
            };
        }(),
        // Day Trade
        postDayTradeBuy: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var symbol, price, shares, multiplier, key, API, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            symbol = param.symbol, price = param.price, shares = param.shares, multiplier = param.multiplier;
                            key = "postDayTradeBuyData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            API = trade/* default */.Z;
                            _ctx.next = 7;
                            return API.dayTradeBuy({
                                symbol: symbol,
                                price: price,
                                shares: shares,
                                multiplier: multiplier
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to post day trade buy failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeSell: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var symbol, price, shares, key, API, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            symbol = param.symbol, price = param.price, shares = param.shares;
                            key = "postDayTradeSellData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            API = trade/* default */.Z;
                            _ctx.next = 7;
                            return API.dayTradeSell({
                                symbol: symbol,
                                price: price,
                                shares: shares
                            });
                        case 7:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 12;
                                break;
                            }
                            _$error = "Attempt to post day trade sell failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 12:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        17
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeAmend: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
                var orderid, price, shares, multiplier, key, response, _$error, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            orderid = param.orderid, price = param.price, shares = param.shares, multiplier = param.multiplier;
                            key = "postDayTradeAmendData";
                            setIsLoading(key, set);
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return trade/* default.dayTradeAmend */.Z.dayTradeAmend({
                                orderid: orderid,
                                price: price,
                                shares: shares,
                                multiplier: multiplier
                            });
                        case 6:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 11;
                                break;
                            }
                            _$error = "Attempt to post day trade ammend failed";
                            setError(_$error, key, set);
                            throw new Error(_$error);
                        case 11:
                            _data = response.data, data = _data.data, message = _data.message;
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](3);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", {
                                error: _ctx.t0
                            });
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        16
                    ]
                ]);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        postDayTradeCancel: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(orderKey) {
                var key, response, _data, data, message;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            key = "postDayTradeCancelData";
                            setIsLoading(key, set);
                            _ctx.prev = 2;
                            _ctx.next = 5;
                            return trade/* default.dayTradeCancel */.Z.dayTradeCancel(orderKey);
                        case 5:
                            response = _ctx.sent;
                            if (response.data) {
                                _ctx.next = 9;
                                break;
                            }
                            setError("Attempt to cancel day trade failed", key, set);
                            throw new Error("Attempt to cancel day trade failed");
                        case 9:
                            _data = response.data, data = _data.data, message = _data.message;
                            set({
                                postDayTradeCancelData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultData), {
                                    data: data,
                                    message: message
                                })
                            });
                            setData(data, message, key, set);
                            return _ctx.abrupt("return", {
                                data: data,
                                message: message
                            });
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](2);
                            setError(_ctx.t0, key, set);
                            return _ctx.abrupt("return", _ctx.t0);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        15
                    ]
                ]);
            }));
            return function(orderKey) {
                return _ref.apply(this, arguments);
            };
        }()
    };
});
/* harmony default export */ var tradingOperation = (tradingOperationStore);


/***/ }),

/***/ 25610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_orderbook__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83384);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12902);








var initialState = {
    data: {},
    isLoading: {}
};
var useGetCompanyInfo = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, initialState), {
        getCompanyInfo: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(symbol) {
                var response;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!get().isLoading[symbol]) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, draft.isLoading), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, symbol, true));
                                });
                            });
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanyInfo */ .Z.getCompanyInfo(symbol);
                        case 6:
                            response = _ctx.sent;
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(state, function(draft) {
                                    if (draft.data[symbol]) {
                                        draft.data[symbol] = response.data.data;
                                    } else {
                                        draft.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state.data), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, symbol, response.data.data));
                                    }
                                    draft.isLoading[symbol] = false;
                                });
                            });
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](3);
                            set(function(state) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(state, function(draft) {
                                    draft.isLoading[symbol] = false;
                                });
                            });
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        10
                    ]
                ]);
            }));
            return function(symbol) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useGetCompanyInfo);


/***/ }),

/***/ 75774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6430);
/* harmony import */ var lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14732);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);







var initialState = {
    isLoading: false,
    error: undefined,
    transactionData: undefined
};
var useShareTradeShare = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        setTransactionData: function(transactionData) {
            set({
                transactionData: transactionData
            });
        },
        loadShareTradeShare: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_2__/* .postShareTradeShare */ .cm)(requestBody);
                        case 4:
                            set({
                                isLoading: false,
                                error: undefined
                            });
                            return _ctx.abrupt("return", Promise.resolve());
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false,
                                error: _ctx.t0
                            });
                            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                                alertType: "plain-default",
                                messageType: "error",
                                content: "Unable to share trade at this moment"
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        8
                    ]
                ]);
            }));
            return function(requestBody) {
                return _ref.apply(this, arguments);
            };
        }()
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeShare);


/***/ }),

/***/ 972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12902);
/* harmony import */ var lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14732);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6430);










var initialState = {
    data: undefined,
    isEmptyList: false,
    isLoading: false,
    isUpdateLoading: false,
    error: undefined,
    updateError: undefined
};
var useShareTradeTarget = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadShareTradeTarget: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
                var disableLoading, initialLoad, restParams, axiosResponse, data, _args = arguments;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            disableLoading = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                            initialLoad = params.initialLoad, restParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(params, [
                                "initialLoad"
                            ]);
                            _ctx.prev = 2;
                            set({
                                isLoading: !disableLoading
                            });
                            _ctx.next = 6;
                            return (0,lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_1__/* .getShareTradeTarget */ .JG)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                                limit: 20
                            }, restParams));
                        case 6:
                            axiosResponse = _ctx.sent;
                            data = axiosResponse.data.data;
                            set(function(currstate) {
                                return (0,immer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(currstate, function(state) {
                                    if (params === null || params === void 0 ? void 0 : params.cursor) {
                                        state.data = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                                            targets: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(state.data.targets).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data.targets))
                                        });
                                    } else state.data = data;
                                    if (data.targets.length === 0 && !(params === null || params === void 0 ? void 0 : params.keyword) && initialLoad) {
                                        state.isEmptyList = true;
                                    }
                                    state.isLoading = false;
                                    state.error = undefined;
                                });
                            });
                            return _ctx.abrupt("return", data);
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](2);
                            set({
                                isLoading: false,
                                error: _ctx.t0
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        12
                    ]
                ]);
            }));
            return function(params) {
                return _ref.apply(this, arguments);
            };
        }(),
        loadUpdateTarget: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
                var withLoading, _args = arguments;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            withLoading = _args.length > 1 && _args[1] !== void 0 ? _args[1] : true;
                            _ctx.prev = 1;
                            if (withLoading) set({
                                isUpdateLoading: true
                            });
                            _ctx.next = 5;
                            return (0,lib_api_shareTrade__WEBPACK_IMPORTED_MODULE_1__/* .putShareTradeTarget */ .wm)(requestBody);
                        case 5:
                            set({
                                isUpdateLoading: false,
                                updateError: undefined
                            });
                            return _ctx.abrupt("return", null);
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](1);
                            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                alertType: "plain-default",
                                messageType: "error",
                                content: "Unable to save auto-share"
                            });
                            set({
                                isUpdateLoading: false
                            });
                            return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        9
                    ]
                ]);
            }));
            return function(requestBody) {
                return _ref.apply(this, arguments);
            };
        }(),
        resetShareTradeTarget: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeTarget);


/***/ }),

/***/ 10529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ ShareOrderStatus; },
/* harmony export */   "y": function() { return /* binding */ ShareOrderType; }
/* harmony export */ });
var ShareOrderType;
(function(ShareOrderType) {
    ShareOrderType["Unspecified"] = "ORDER_TYPE_UNSPECIFIED";
    ShareOrderType["Buy"] = "ORDER_TYPE_BUY";
    ShareOrderType["Sell"] = "ORDER_TYPE_SELL";
})(ShareOrderType || (ShareOrderType = {}));
var ShareOrderStatus;
(function(ShareOrderStatus) {
    ShareOrderStatus["Unspecified"] = "ORDER_STATUS_UNSPECIFIED";
    ShareOrderStatus["Open"] = "ORDER_STATUS_OPEN";
    ShareOrderStatus["Amend"] = "ORDER_STATUS_AMEND";
    ShareOrderStatus["Cancel"] = "ORDER_STATUS_CANCEL";
    ShareOrderStatus["Match"] = "ORDER_STATUS_MATCH";
    ShareOrderStatus["PartialMatch"] = "ORDER_STATUS_PARTIAL_MATCH";
})(ShareOrderStatus || (ShareOrderStatus = {}));


/***/ }),

/***/ 32070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ TargetType; }
/* harmony export */ });
/* unused harmony export PaginationNextType */
var PaginationNextType;
(function(PaginationNextType) {
    PaginationNextType["Personal"] = "PERSONAL";
    PaginationNextType["Group"] = "Group";
})(PaginationNextType || (PaginationNextType = {}));
var TargetType;
(function(TargetType) {
    TargetType["Unspecified"] = "TARGET_TYPE_UNSPECIFIED";
    TargetType["ChatRoom"] = "TARGET_TYPE_CHATROOM";
    TargetType["User"] = "TARGET_TYPE_USER";
})(TargetType || (TargetType = {}));


/***/ }),

/***/ 33270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ ThemeMode; }
/* harmony export */ });
var ThemeMode;
(function(ThemeMode) {
    ThemeMode["Dark"] = "dark";
    ThemeMode["Light"] = "light";
})(ThemeMode || (ThemeMode = {}));


/***/ }),

/***/ 93134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ TransactionFormType; }
/* harmony export */ });
var TransactionFormType;
(function(TransactionFormType) {
    TransactionFormType["Classic"] = "Classic";
    TransactionFormType["FastOrder"] = "FastOrder";
})(TransactionFormType || (TransactionFormType = {}));


/***/ }),

/***/ 46870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ getTimeFromDate; },
/* harmony export */   "k": function() { return /* binding */ convertToDate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);

var getTimeFromDate = function(date) {
    var addLeadingZero = function(value) {
        return value < 10 ? "0".concat(value) : value;
    };
    return "".concat(addLeadingZero(date.getHours()), ":").concat(addLeadingZero(date.getMinutes()), ":").concat(addLeadingZero(date.getSeconds()));
};
var convertToDate = function(dateStr) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(dateStr.split(" "), 2), date = ref[0], tmp = ref[1], time = tmp === void 0 ? "00:00:00" : tmp;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date.split("-").map(function(item) {
        return Number(item);
    }), 3), year = ref1[0], month = ref1[1], day = ref1[2];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(time.split(":").map(function(item) {
        return Number(item);
    }), 3), hour = ref2[0], mins = ref2[1], sec = ref2[2];
    return new Date(year, month - 1, day, hour, mins, sec);
};


/***/ }),

/***/ 67600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JH": function() { return /* binding */ generateOrderTypeLabel; },
/* harmony export */   "d8": function() { return /* binding */ generateOrderExpiryLabel; }
/* harmony export */ });
/* unused harmony export generateOrderLeverageLabel */
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2078);

function generateOrderLeverageLabel(method) {
    var leverageLabel = "";
    switch(method){
        case PaymentMethod.DayTrade:
            leverageLabel = "Day Trade";
            break;
        case PaymentMethod.TradingLimit:
            leverageLabel = "Trading Limit";
            break;
        default:
            leverageLabel = "Trading Balance";
    }
    return leverageLabel;
}
function generateOrderTypeLabel(orderType) {
    var orderTypeLabel = "";
    switch(orderType){
        case global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.AutoBuy */ .dY.AutoBuy:
            orderTypeLabel = "Auto Buy";
            break;
        case global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrderType.LimitOrder */ .dY.LimitOrder:
        default:
            orderTypeLabel = "Limit Order";
            break;
    }
    return orderTypeLabel;
}
function generateOrderExpiryLabel(expiry) {
    var expiryLabel = "";
    switch(expiry){
        case 0:
            expiryLabel = "Good for day";
            break;
        case 1:
            expiryLabel = "Good till canceled";
            break;
        default:
            expiryLabel = "";
    }
    return expiryLabel;
}


/***/ }),

/***/ 91601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ renderTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/Notation/index.tsx
var Notation = __webpack_require__(15068);
// EXTERNAL MODULE: ./src/global/CorpAction/CorpActionTag.tsx
var CorpActionTag = __webpack_require__(66988);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Badges/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border: 0.8px solid #f14747;\n  border-radius: 2px;\n  color: ",
        ";\n  display: inline-block;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: normal;\n  padding: 0px 5px;\n  position: relative;\n  vertical-align: middle;\n\n  > span {\n    font-style: normal;\n    font-family: var(--bold-font);\n    line-height: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Badge = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3fb9e69c-0"
})(_templateObject(), ui/* color.light */.$_.light, ui/* color.sunsetOrange */.$_.sunsetOrange);

;// CONCATENATED MODULE: ./src/global/Badges/index.tsx


var STATUS_LIST = {
    SUSPENDED: [
        1,
        "STATUS_SUSPENDED"
    ],
    DELISTED: [
        2,
        "STATUS_DELISTED"
    ]
};
function Badges_Badge(param) {
    var status = param.status;
    var isDelisted = STATUS_LIST.DELISTED.includes(status);
    var isSuspended = STATUS_LIST.SUSPENDED.includes(status);
    var renderBadge = function(companyStatus) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: companyStatus
            })
        });
    };
    if (isDelisted) {
        return renderBadge("Delisted");
    }
    if (isSuspended) {
        return renderBadge("Suspended");
    }
    return null;
}
/* harmony default export */ var Badges = (Badges_Badge);

;// CONCATENATED MODULE: ./src/utils/tags.tsx
/* eslint-disable no-undef */ 




var Flex = ui/* Common.Flex */.Gn.Flex;
var compareValue = function(value, otherValue) {
    return !!value || !!otherValue;
};
/**
 * Render tags notation and corp action
 */ var renderTags = function(company) {
    var showPopover = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, placement = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "top", customContainerStyle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        marginLeft: 4,
        gap: 4
    };
    var symbol = company.symbol, symbol_2 = company.symbol_2, _notation = company.notation, notation = _notation === void 0 ? [] : _notation, _corp_action = company.corp_action, corp_action = _corp_action === void 0 ? {} : _corp_action, uma = company.uma, companyName = company.name, _withNotation = company.withNotation, withNotation = _withNotation === void 0 ? 0 : _withNotation, _withUMA = company.withUMA, withUMA = _withUMA === void 0 ? 0 : _withUMA, _withCorpAction = company.withCorpAction, withCorpAction = _withCorpAction === void 0 ? 0 : _withCorpAction, _status = company.status, status = _status === void 0 ? 0 : _status;
    var companySymbol = symbol || symbol_2;
    var showNotation = compareValue((notation === null || notation === void 0 ? void 0 : notation.length) > 0, withNotation);
    var showCorpAction = compareValue(corp_action === null || corp_action === void 0 ? void 0 : corp_action.active, withCorpAction);
    var showUma = compareValue(uma, withUMA);
    var showBadge = status !== 0;
    if (!showBadge && !showCorpAction && !showNotation && !showUma) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex, {
        align: "center",
        style: customContainerStyle,
        children: [
            showNotation && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: companySymbol,
                name: companyName,
                notation: notation,
                uma: false,
                isPopover: showPopover,
                isNotationBadges: true,
                placement: placement
            }),
            showCorpAction && /*#__PURE__*/ (0,jsx_runtime.jsx)(CorpActionTag/* default */.Z, {
                corpAction: company.corp_action,
                isCorpActionBadges: true
            }),
            showBadge && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badges, {
                status: status
            }),
            showUma && /*#__PURE__*/ (0,jsx_runtime.jsx)(Notation/* default */.Z, {
                symbol: companySymbol,
                name: companyName,
                notation: notation,
                uma: showUma,
                isNotationBadges: true,
                type: "uma",
                placement: placement,
                isPopover: false
            })
        ]
    });
};
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 36684:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51679);
/* harmony import */ var _uploadFile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78603);






var domToImage = __webpack_require__(29306);
function formatUploadImageName(formattype) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "stockbit";
    var randomId = (0,_uploadFile__WEBPACK_IMPORTED_MODULE_4__/* .generateId */ .Ox)();
    // old code: moment().format()
    var tzOffset = new Date().getTimezoneOffset() * 60000;
    var localISOTime = new Date(Date.now() - tzOffset).toISOString().slice(0, -1);
    var now = localISOTime;
    now = now.replace(/-/g, "");
    now = now.replace(/:/g, "");
    now = now.substr(0, 15);
    return "".concat(prefix + randomId + now, "web.").concat(formattype);
}
function dataURItoBlob(dataURI) {
    var binary = atob(dataURI.split(",")[1]);
    var array = [];
    for(var i = 0; i < binary.length; i += 1){
        array.push(binary.charCodeAt(i));
    }
    return new Blob([
        new Uint8Array(array)
    ], {
        type: "image/jpeg"
    });
}
function base64ToImage(base64) {
    var rawBase64 = base64.split(",");
    //   original code: rawBase64 = rawBase64[1];
    var _rawBase64 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(rawBase64, 2), base64ORawData = _rawBase64[1];
    rawBase64 = base64ORawData;
    var fileName = "".concat(Date.now(), ".jpeg");
    var blob = dataURItoBlob(base64);
    var file = new File([
        blob
    ], fileName);
    return file;
}
function capitalizeFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
}
// originally from web legacy, there's params quality
// but never in used
function imageCompressor(sourceImage, outputFormat) {
    var methodName = "to".concat(capitalizeFirstLetter(outputFormat));
    if (typeof domToImage[methodName] !== "function") {
        methodName = "toJpeg";
    }
    return domToImage[methodName](sourceImage, {
        quality: 0.6
    }).catch(function() {
    /** TODO: Handle error correctly */ });
}
function lastSlashURL(url) {
    return url.substr(url.lastIndexOf("/") + 1);
}
function uploadPromise(file, token) {
    var newfilename;
    // If attachment is url return the url immediately
    if (typeof file === "string" && file.indexOf("http") !== -1) {
        return Promise.resolve({
            data: {
                url: file
            }
        });
    }
    if (file) {
        var filetype = file.type.split("/")[1];
        newfilename = formatUploadImageName(filetype, "stream");
    }
    var fd = new FormData();
    var formerFile = null;
    // eslint-disable-next-line no-underscore-dangle
    if (file._file) formerFile = file._file;
    // fd.append('key', file['name'])
    fd.append("key", newfilename);
    fd.append("AWSAccessKeyId", token.AWSAccessKeyId);
    fd.append("acl", "public-read");
    fd.append("success_action_redirect", token.success_action_redirect);
    fd.append("policy", token.policy);
    fd.append("signature", token.signature);
    fd.append("Content-Type", "");
    if (!formerFile) {
        fd.append("file", file);
    } else {
        fd.append("file", formerFile);
    }
    return fetch(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_IMAGES_BUCKET */ .Me, {
        method: "POST",
        cache: "default",
        body: fd,
        mode: "cors"
    }).then(function(response) {
        return response.json();
    }).catch(function(error) {
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE, constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
        return error;
    });
}
/**
 * Upload files stacked into Amazon S3
 * @param {any} file
 * @returns {Object}
 */ function uploadImage(file) {
    var bucket = "stockbit";
    return lib_api_stream__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUploadToken */ .Z.getUploadToken(bucket).then(function(res) {
        var _data = res.data, token = _data.data;
        return uploadPromise(file, token);
    });
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    formatUploadImageName: formatUploadImageName,
    imageCompressor: imageCompressor,
    base64ToImage: base64ToImage,
    lastSlashURL: lastSlashURL,
    uploadImage: uploadImage
});


/***/ })

}]);